import * as Wr from "react";
import { i as Ur, b as It, E as jr, x as Do, r as Kr, c as Qr } from "../createReactComponent-58f9bea8.mjs";
import { n as Je } from "../property-9daa16cd.mjs";
import { r as Yr } from "../state-7560d4dc.mjs";
import { r as qr } from "../query-async-a940115b.mjs";
import { e as $r } from "../class-map-2994e95e.mjs";
import { r as Jr } from "../icon-c572aa57.mjs";
import "../base-e16d29d8.mjs";
var ht = class {
  constructor() {
    this.allSyncListeners = /* @__PURE__ */ new Map(), this.allAsyncListeners = /* @__PURE__ */ new Map(), this.globalSyncListeners = /* @__PURE__ */ new Set(), this.globalAsyncListeners = /* @__PURE__ */ new Set(), this.asyncFunctionsQueue = [], this.scheduled = !1, this.firedEvents = {};
  }
  setFrameworkOverrides(e) {
    this.frameworkOverrides = e;
  }
  getListeners(e, t, i) {
    const o = t ? this.allAsyncListeners : this.allSyncListeners;
    let s = o.get(e);
    return !s && i && (s = /* @__PURE__ */ new Set(), o.set(e, s)), s;
  }
  noRegisteredListenersExist() {
    return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
  }
  addEventListener(e, t, i = !1) {
    this.getListeners(e, i, !0).add(t);
  }
  removeEventListener(e, t, i = !1) {
    const o = this.getListeners(e, i, !1);
    o && (o.delete(t), o.size === 0) && (i ? this.allAsyncListeners : this.allSyncListeners).delete(e);
  }
  addGlobalListener(e, t = !1) {
    (t ? this.globalAsyncListeners : this.globalSyncListeners).add(e);
  }
  removeGlobalListener(e, t = !1) {
    (t ? this.globalAsyncListeners : this.globalSyncListeners).delete(e);
  }
  dispatchEvent(e) {
    const t = e;
    this.dispatchToListeners(t, !0), this.dispatchToListeners(t, !1), this.firedEvents[t.type] = !0;
  }
  dispatchEventOnce(e) {
    this.firedEvents[e.type] || this.dispatchEvent(e);
  }
  dispatchToListeners(e, t) {
    const i = e.type;
    if (t && "event" in e) {
      const r = e.event;
      r instanceof Event && (e.eventPath = r.composedPath());
    }
    const o = this.getListeners(i, t, !1) ?? /* @__PURE__ */ new Set(), s = new Set(o);
    s.size > 0 && ((r, n) => {
      r.forEach((a) => {
        if (!n.has(a))
          return;
        const l = this.frameworkOverrides ? () => this.frameworkOverrides.wrapIncoming(() => a(e)) : () => a(e);
        t ? this.dispatchAsync(l) : l();
      });
    })(s, o), new Set(t ? this.globalAsyncListeners : this.globalSyncListeners).forEach((r) => {
      const n = this.frameworkOverrides ? () => this.frameworkOverrides.wrapIncoming(() => r(i, e)) : () => r(i, e);
      t ? this.dispatchAsync(n) : n();
    });
  }
  dispatchAsync(e) {
    if (this.asyncFunctionsQueue.push(e), !this.scheduled) {
      const t = () => {
        window.setTimeout(this.flushAsyncQueue.bind(this), 0);
      };
      this.frameworkOverrides ? this.frameworkOverrides.wrapIncoming(t) : t(), this.scheduled = !0;
    }
  }
  flushAsyncQueue() {
    this.scheduled = !1;
    const e = this.asyncFunctionsQueue.slice();
    this.asyncFunctionsQueue = [], e.forEach((t) => t());
  }
};
function T(e) {
  if (e && e.length)
    return e[e.length - 1];
}
function Ke(e, t, i) {
  return e == null && t == null || e != null && t != null && e.length === t.length && e.every((o, s) => i ? i(o, t[s]) : t[s] === o);
}
function ls(e, t) {
  const i = e.indexOf(t);
  i >= 0 && (e[i] = e[e.length - 1], e.pop());
}
function Y(e, t) {
  const i = e.indexOf(t);
  i >= 0 && e.splice(i, 1);
}
function Jt(e, t, i) {
  e.splice(i, 0, t);
}
function ds(e, t, i) {
  (function(o, s) {
    for (let r = 0; r < s.length; r++)
      Y(o, s[r]);
  })(e, t), t.slice().reverse().forEach((o) => Jt(e, o, i));
}
function He(e, t) {
  return e.indexOf(t) > -1;
}
function Mo(e, t) {
  t != null && e != null && t.forEach((i) => e.push(i));
}
var cs = "__ag_Grid_Stop_Propagation", Xr = ["touchstart", "touchend", "touchmove", "touchcancel", "scroll"], hi = {};
function at(e) {
  e[cs] = !0;
}
function Ae(e) {
  return e[cs] === !0;
}
var hs = (() => {
  const e = { select: "input", change: "input", submit: "form", reset: "form", error: "img", load: "img", abort: "img" };
  return (t) => {
    if (typeof hi[t] == "boolean")
      return hi[t];
    const i = document.createElement(e[t] || "div");
    return hi[t = "on" + t] = t in i;
  };
})();
function Di(e, t, i) {
  let o = t;
  for (; o; ) {
    const s = e.getDomData(o, i);
    if (s)
      return s;
    o = o.parentElement;
  }
  return null;
}
function Zr(e, t) {
  return !(!t || !e) && function(i) {
    const o = i;
    return o.path ? o.path : o.composedPath ? o.composedPath() : function(s) {
      const r = [];
      let n = s.target;
      for (; n; )
        r.push(n), n = n.parentElement;
      return r;
    }(o);
  }(t).indexOf(e) >= 0;
}
var f = class {
  constructor() {
    this.destroyFunctions = [], this.destroyed = !1, this.__v_skip = !0, this.propertyListenerId = 0, this.lastChangeSetIdLookup = {}, this.isAlive = () => !this.destroyed;
  }
  preWireBeans(e) {
    this.gridId = e.context.getGridId(), this.frameworkOverrides = e.frameworkOverrides, this.stubContext = e.context, this.eventService = e.eventService, this.gos = e.gos, this.localeService = e.localeService;
  }
  getFrameworkOverrides() {
    return this.frameworkOverrides;
  }
  destroy() {
    for (let e = 0; e < this.destroyFunctions.length; e++)
      this.destroyFunctions[e]();
    this.destroyFunctions.length = 0, this.destroyed = !0, this.dispatchLocalEvent({ type: "destroyed" });
  }
  addEventListener(e, t) {
    this.localEventService || (this.localEventService = new ht()), this.localEventService.addEventListener(e, t);
  }
  removeEventListener(e, t) {
    this.localEventService && this.localEventService.removeEventListener(e, t);
  }
  dispatchLocalEvent(e) {
    this.localEventService && this.localEventService.dispatchEvent(e);
  }
  addManagedElementListeners(e, t) {
    return this._setupListeners(e, t);
  }
  addManagedEventListeners(e) {
    return this._setupListeners(this.eventService, e);
  }
  addManagedListeners(e, t) {
    return this._setupListeners(e, t);
  }
  _setupListeners(e, t) {
    const i = [];
    for (const o in t) {
      const s = t[o];
      s && i.push(this._setupListener(e, o, s));
    }
    return i;
  }
  _setupListener(e, t, i) {
    if (this.destroyed)
      return () => null;
    e instanceof HTMLElement ? function(s, r, n, a) {
      const l = He(Xr, n) ? { passive: !0 } : void 0;
      s && s.addEventListener && s.addEventListener(r, n, a, l);
    }(this.getFrameworkOverrides(), e, t, i) : e.addEventListener(t, i);
    const o = () => (e.removeEventListener(t, i), null);
    return this.destroyFunctions.push(o), () => (o(), this.destroyFunctions = this.destroyFunctions.filter((s) => s !== o), null);
  }
  setupGridOptionListener(e, t) {
    this.gos.addPropertyEventListener(e, t);
    const i = () => (this.gos.removePropertyEventListener(e, t), null);
    return this.destroyFunctions.push(i), () => (i(), this.destroyFunctions = this.destroyFunctions.filter((o) => o !== i), null);
  }
  addManagedPropertyListener(e, t) {
    return this.destroyed ? () => null : this.setupGridOptionListener(e, t);
  }
  addManagedPropertyListeners(e, t) {
    if (this.destroyed)
      return;
    const i = e.join("-") + this.propertyListenerId++, o = (s) => {
      if (s.changeSet) {
        if (s.changeSet && s.changeSet.id === this.lastChangeSetIdLookup[i])
          return;
        this.lastChangeSetIdLookup[i] = s.changeSet.id;
      }
      const r = { type: "gridPropertyChanged", changeSet: s.changeSet, source: s.source };
      t(r);
    };
    e.forEach((s) => this.setupGridOptionListener(s, o));
  }
  addDestroyFunc(e) {
    this.isAlive() ? this.destroyFunctions.push(e) : e();
  }
  createManagedBean(e, t) {
    const i = this.createBean(e, t);
    return this.addDestroyFunc(this.destroyBean.bind(this, e, t)), i;
  }
  createBean(e, t, i) {
    return (t || this.stubContext).createBean(e, i);
  }
  destroyBean(e, t) {
    return (t || this.stubContext).destroyBean(e);
  }
  destroyBeans(e, t) {
    return (t || this.stubContext).destroyBeans(e);
  }
}, qi = class {
  constructor(e) {
    this.frameworkOverrides = e, this.wrappedListeners = /* @__PURE__ */ new Map(), this.wrappedGlobalListeners = /* @__PURE__ */ new Map();
  }
  wrap(e) {
    let t = e;
    return this.frameworkOverrides.shouldWrapOutgoing && (t = (i) => {
      this.frameworkOverrides.wrapOutgoing(() => e(i));
    }, this.wrappedListeners.set(e, t)), t;
  }
  wrapGlobal(e) {
    let t = e;
    return this.frameworkOverrides.shouldWrapOutgoing && (t = (i, o) => {
      this.frameworkOverrides.wrapOutgoing(() => e(i, o));
    }, this.wrappedGlobalListeners.set(e, t)), t;
  }
  unwrap(e) {
    return this.wrappedListeners.get(e) ?? e;
  }
  unwrapGlobal(e) {
    return this.wrappedGlobalListeners.get(e) ?? e;
  }
};
function Ve(e) {
  return e == null || e === "" ? null : e;
}
function S(e, t = !1) {
  return e != null && (e !== "" || t);
}
function A(e) {
  return !S(e);
}
function W(e) {
  return e == null || e.length === 0;
}
function Mi(e) {
  return e != null && typeof e.toString == "function" ? e.toString() : null;
}
function We(e) {
  if (e === void 0)
    return;
  if (e === null || e === "")
    return null;
  if (typeof e == "number")
    return isNaN(e) ? void 0 : e;
  const t = parseInt(e, 10);
  return isNaN(t) ? void 0 : t;
}
function Ei(e) {
  if (e !== void 0)
    return e !== null && e !== "" && Pi(e);
}
function Pi(e) {
  return typeof e == "boolean" ? e : typeof e == "string" && (e.toUpperCase() === "TRUE" || e == "");
}
function Xt(e, t) {
  return (e ? JSON.stringify(e) : null) === (t ? JSON.stringify(t) : null);
}
function _r(e, t, i = !1) {
  const o = e == null, s = t == null;
  if (e && e.toNumber && (e = e.toNumber()), t && t.toNumber && (t = t.toNumber()), o && s)
    return 0;
  if (o)
    return -1;
  if (s)
    return 1;
  function r(n, a) {
    return n > a ? 1 : n < a ? -1 : 0;
  }
  if (typeof e != "string" || !i)
    return r(e, t);
  try {
    return e.localeCompare(t);
  } catch {
    return r(e, t);
  }
}
function jt(e) {
  if (e instanceof Set || e instanceof Map) {
    const t = [];
    return e.forEach((i) => t.push(i)), t;
  }
  return Object.values(e);
}
var $i = /* @__PURE__ */ new Set(["__proto__", "constructor", "prototype"]);
function le(e, t) {
  if (e != null)
    if (Array.isArray(e))
      for (let i = 0; i < e.length; i++)
        t(i.toString(), e[i]);
    else
      for (const [i, o] of Object.entries(e))
        t(i, o);
}
function gs(e) {
  const t = {}, i = Object.keys(e);
  for (let o = 0; o < i.length; o++) {
    if ($i.has(i[o]))
      continue;
    const s = i[o], r = e[s];
    t[s] = r;
  }
  return t;
}
function ki(e, t) {
  if (!e)
    return;
  const i = e, o = {};
  return Object.keys(i).forEach((s) => {
    if (t && t.indexOf(s) >= 0 || $i.has(s))
      return;
    const r = i[s], n = Ai(r) && r.constructor === Object;
    o[s] = n ? ki(r) : r;
  }), o;
}
function Ie(e) {
  if (!e)
    return [];
  const t = Object;
  if (typeof t.values == "function")
    return t.values(e);
  const i = [];
  for (const o in e)
    e.hasOwnProperty(o) && e.propertyIsEnumerable(o) && i.push(e[o]);
  return i;
}
function oe(e, t, i = !0, o = !1) {
  S(t) && le(t, (s, r) => {
    if ($i.has(s))
      return;
    let n = e[s];
    n !== r && (o && n == null && r != null && typeof r == "object" && r.constructor === Object && (n = {}, e[s] = n), Ai(r) && Ai(n) && !Array.isArray(n) ? oe(n, r, i, o) : (i || r !== void 0) && (e[s] = r));
  });
}
function bt(e, t, i) {
  if (!t || !e)
    return;
  if (!i)
    return e[t];
  const o = t.split(".");
  let s = e;
  for (let r = 0; r < o.length; r++) {
    if (s == null)
      return;
    s = s[o[r]];
  }
  return s;
}
function Ai(e) {
  return typeof e == "object" && e !== null;
}
var en = { resizable: !0, sortable: !0 }, tn = 0;
function us() {
  return tn++;
}
function Le(e) {
  return e instanceof ps;
}
var ps = class extends f {
  constructor(e, t, i, o) {
    super(), this.isColumn = !0, this.instanceId = us(), this.autoHeaderHeight = null, this.moving = !1, this.menuVisible = !1, this.lastLeftPinned = !1, this.firstRightPinned = !1, this.filterActive = !1, this.columnEventService = new ht(), this.tooltipEnabled = !1, this.rowGroupActive = !1, this.pivotActive = !1, this.aggregationActive = !1, this.colDef = e, this.userProvidedColDef = t, this.colId = i, this.primary = o, this.setState(e);
  }
  wireBeans(e) {
    this.columnHoverService = e.columnHoverService;
  }
  getInstanceId() {
    return this.instanceId;
  }
  setState(e) {
    e.sort !== void 0 ? e.sort !== "asc" && e.sort !== "desc" || (this.sort = e.sort) : e.initialSort !== "asc" && e.initialSort !== "desc" || (this.sort = e.initialSort);
    const t = e.sortIndex, i = e.initialSortIndex;
    t !== void 0 ? t !== null && (this.sortIndex = t) : i !== null && (this.sortIndex = i);
    const o = e.hide, s = e.initialHide;
    this.visible = o !== void 0 ? !o : !s, e.pinned !== void 0 ? this.setPinned(e.pinned) : this.setPinned(e.initialPinned);
    const r = e.flex, n = e.initialFlex;
    r !== void 0 ? this.flex = r : n !== void 0 && (this.flex = n);
  }
  setColDef(e, t, i) {
    this.colDef = e, this.userProvidedColDef = t, this.initMinAndMaxWidths(), this.initDotNotation(), this.initTooltip(), this.columnEventService.dispatchEvent(this.createColumnEvent("colDefChanged", i));
  }
  getUserProvidedColDef() {
    return this.userProvidedColDef;
  }
  setParent(e) {
    this.parent = e;
  }
  getParent() {
    return this.parent;
  }
  setOriginalParent(e) {
    this.originalParent = e;
  }
  getOriginalParent() {
    return this.originalParent;
  }
  postConstruct() {
    this.initMinAndMaxWidths(), this.resetActualWidth("gridInitializing"), this.initDotNotation(), this.initTooltip();
  }
  initDotNotation() {
    const e = this.gos.get("suppressFieldDotNotation");
    this.fieldContainsDots = S(this.colDef.field) && this.colDef.field.indexOf(".") >= 0 && !e, this.tooltipFieldContainsDots = S(this.colDef.tooltipField) && this.colDef.tooltipField.indexOf(".") >= 0 && !e;
  }
  initMinAndMaxWidths() {
    const e = this.colDef;
    this.minWidth = e.minWidth ?? 20, this.maxWidth = e.maxWidth ?? Number.MAX_SAFE_INTEGER;
  }
  initTooltip() {
    this.tooltipEnabled = S(this.colDef.tooltipField) || S(this.colDef.tooltipValueGetter) || S(this.colDef.tooltipComponent);
  }
  resetActualWidth(e) {
    const t = this.calculateColInitialWidth(this.colDef);
    this.setActualWidth(t, e, !0);
  }
  calculateColInitialWidth(e) {
    let t;
    const i = We(e.width), o = We(e.initialWidth);
    return t = i ?? o ?? 200, Math.max(Math.min(t, this.maxWidth), this.minWidth);
  }
  isEmptyGroup() {
    return !1;
  }
  isRowGroupDisplayed(e) {
    if (A(this.colDef) || A(this.colDef.showRowGroup))
      return !1;
    const t = this.colDef.showRowGroup === !0, i = this.colDef.showRowGroup === e;
    return t || i;
  }
  isPrimary() {
    return this.primary;
  }
  isFilterAllowed() {
    return !!this.colDef.filter;
  }
  isFieldContainsDots() {
    return this.fieldContainsDots;
  }
  isTooltipEnabled() {
    return this.tooltipEnabled;
  }
  isTooltipFieldContainsDots() {
    return this.tooltipFieldContainsDots;
  }
  addEventListener(e, t) {
    var o;
    this.frameworkOverrides.shouldWrapOutgoing && !this.frameworkEventListenerService && (this.columnEventService.setFrameworkOverrides(this.frameworkOverrides), this.frameworkEventListenerService = new qi(this.frameworkOverrides));
    const i = ((o = this.frameworkEventListenerService) == null ? void 0 : o.wrap(t)) ?? t;
    this.columnEventService.addEventListener(e, i);
  }
  removeEventListener(e, t) {
    var o;
    const i = ((o = this.frameworkEventListenerService) == null ? void 0 : o.unwrap(t)) ?? t;
    this.columnEventService.removeEventListener(e, i);
  }
  createColumnFunctionCallbackParams(e) {
    return this.gos.addGridCommonParams({ node: e, data: e.data, column: this, colDef: this.colDef });
  }
  isSuppressNavigable(e) {
    if (typeof this.colDef.suppressNavigable == "boolean")
      return this.colDef.suppressNavigable;
    if (typeof this.colDef.suppressNavigable == "function") {
      const t = this.createColumnFunctionCallbackParams(e);
      return (0, this.colDef.suppressNavigable)(t);
    }
    return !1;
  }
  isCellEditable(e) {
    return !(e.group && !this.gos.get("enableGroupEdit")) && this.isColumnFunc(e, this.colDef.editable);
  }
  isSuppressFillHandle() {
    return !!this.colDef.suppressFillHandle;
  }
  isAutoHeight() {
    return !!this.colDef.autoHeight;
  }
  isAutoHeaderHeight() {
    return !!this.colDef.autoHeaderHeight;
  }
  isRowDrag(e) {
    return this.isColumnFunc(e, this.colDef.rowDrag);
  }
  isDndSource(e) {
    return this.isColumnFunc(e, this.colDef.dndSource);
  }
  isCellCheckboxSelection(e) {
    return this.isColumnFunc(e, this.colDef.checkboxSelection);
  }
  isSuppressPaste(e) {
    return this.isColumnFunc(e, this.colDef ? this.colDef.suppressPaste : null);
  }
  isResizable() {
    return !!this.getColDefValue("resizable");
  }
  getColDefValue(e) {
    return this.colDef[e] ?? en[e];
  }
  isColumnFunc(e, t) {
    return typeof t == "boolean" ? t : typeof t == "function" && t(this.createColumnFunctionCallbackParams(e));
  }
  setMoving(e, t) {
    this.moving = e, this.columnEventService.dispatchEvent(this.createColumnEvent("movingChanged", t));
  }
  createColumnEvent(e, t) {
    return this.gos.addGridCommonParams({ type: e, column: this, columns: [this], source: t });
  }
  isMoving() {
    return this.moving;
  }
  getSort() {
    return this.sort;
  }
  setSort(e, t) {
    this.sort !== e && (this.sort = e, this.columnEventService.dispatchEvent(this.createColumnEvent("sortChanged", t))), this.dispatchStateUpdatedEvent("sort");
  }
  isSortable() {
    return !!this.getColDefValue("sortable");
  }
  isSortAscending() {
    return this.sort === "asc";
  }
  isSortDescending() {
    return this.sort === "desc";
  }
  isSortNone() {
    return A(this.sort);
  }
  isSorting() {
    return S(this.sort);
  }
  getSortIndex() {
    return this.sortIndex;
  }
  setSortIndex(e) {
    this.sortIndex = e, this.dispatchStateUpdatedEvent("sortIndex");
  }
  setMenuVisible(e, t) {
    this.menuVisible !== e && (this.menuVisible = e, this.columnEventService.dispatchEvent(this.createColumnEvent("menuVisibleChanged", t)));
  }
  isMenuVisible() {
    return this.menuVisible;
  }
  setAggFunc(e) {
    this.aggFunc = e, this.dispatchStateUpdatedEvent("aggFunc");
  }
  getAggFunc() {
    return this.aggFunc;
  }
  getLeft() {
    return this.left;
  }
  getOldLeft() {
    return this.oldLeft;
  }
  getRight() {
    return this.left + this.actualWidth;
  }
  setLeft(e, t) {
    this.oldLeft = this.left, this.left !== e && (this.left = e, this.columnEventService.dispatchEvent(this.createColumnEvent("leftChanged", t)));
  }
  isFilterActive() {
    return this.filterActive;
  }
  setFilterActive(e, t, i) {
    this.filterActive !== e && (this.filterActive = e, this.columnEventService.dispatchEvent(this.createColumnEvent("filterActiveChanged", t)));
    const o = this.createColumnEvent("filterChanged", t);
    i && oe(o, i), this.columnEventService.dispatchEvent(o);
  }
  isHovered() {
    return this.columnHoverService.isHovered(this);
  }
  setPinned(e) {
    this.pinned = e === !0 || e === "left" ? "left" : e === "right" ? "right" : null, this.dispatchStateUpdatedEvent("pinned");
  }
  setFirstRightPinned(e, t) {
    this.firstRightPinned !== e && (this.firstRightPinned = e, this.columnEventService.dispatchEvent(this.createColumnEvent("firstRightPinnedChanged", t)));
  }
  setLastLeftPinned(e, t) {
    this.lastLeftPinned !== e && (this.lastLeftPinned = e, this.columnEventService.dispatchEvent(this.createColumnEvent("lastLeftPinnedChanged", t)));
  }
  isFirstRightPinned() {
    return this.firstRightPinned;
  }
  isLastLeftPinned() {
    return this.lastLeftPinned;
  }
  isPinned() {
    return this.pinned === "left" || this.pinned === "right";
  }
  isPinnedLeft() {
    return this.pinned === "left";
  }
  isPinnedRight() {
    return this.pinned === "right";
  }
  getPinned() {
    return this.pinned;
  }
  setVisible(e, t) {
    const i = e === !0;
    this.visible !== i && (this.visible = i, this.columnEventService.dispatchEvent(this.createColumnEvent("visibleChanged", t))), this.dispatchStateUpdatedEvent("hide");
  }
  isVisible() {
    return this.visible;
  }
  isSpanHeaderHeight() {
    const e = this.getColDef();
    return !e.suppressSpanHeaderHeight && !e.autoHeaderHeight;
  }
  getColumnGroupPaddingInfo() {
    let e = this.getParent();
    if (!e || !e.isPadding())
      return { numberOfParents: 0, isSpanningTotal: !1 };
    const t = e.getPaddingLevel() + 1;
    let i = !0;
    for (; e; ) {
      if (!e.isPadding()) {
        i = !1;
        break;
      }
      e = e.getParent();
    }
    return { numberOfParents: t, isSpanningTotal: i };
  }
  getColDef() {
    return this.colDef;
  }
  getDefinition() {
    return this.colDef;
  }
  getColumnGroupShow() {
    return this.colDef.columnGroupShow;
  }
  getColId() {
    return this.colId;
  }
  getId() {
    return this.colId;
  }
  getUniqueId() {
    return this.colId;
  }
  getActualWidth() {
    return this.actualWidth;
  }
  getAutoHeaderHeight() {
    return this.autoHeaderHeight;
  }
  setAutoHeaderHeight(e) {
    const t = e !== this.autoHeaderHeight;
    return this.autoHeaderHeight = e, t;
  }
  createBaseColDefParams(e) {
    return this.gos.addGridCommonParams({ node: e, data: e.data, colDef: this.colDef, column: this });
  }
  getColSpan(e) {
    if (A(this.colDef.colSpan))
      return 1;
    const t = this.createBaseColDefParams(e), i = this.colDef.colSpan(t);
    return Math.max(i, 1);
  }
  getRowSpan(e) {
    if (A(this.colDef.rowSpan))
      return 1;
    const t = this.createBaseColDefParams(e), i = this.colDef.rowSpan(t);
    return Math.max(i, 1);
  }
  setActualWidth(e, t, i = !1) {
    e = Math.max(e, this.minWidth), e = Math.min(e, this.maxWidth), this.actualWidth !== e && (this.actualWidth = e, this.flex && t !== "flex" && t !== "gridInitializing" && (this.flex = null), i || this.fireColumnWidthChangedEvent(t)), this.dispatchStateUpdatedEvent("width");
  }
  fireColumnWidthChangedEvent(e) {
    this.columnEventService.dispatchEvent(this.createColumnEvent("widthChanged", e));
  }
  isGreaterThanMax(e) {
    return e > this.maxWidth;
  }
  getMinWidth() {
    return this.minWidth;
  }
  getMaxWidth() {
    return this.maxWidth;
  }
  getFlex() {
    return this.flex || 0;
  }
  setFlex(e) {
    this.flex !== e && (this.flex = e), this.dispatchStateUpdatedEvent("flex");
  }
  setMinimum(e) {
    this.setActualWidth(this.minWidth, e);
  }
  setRowGroupActive(e, t) {
    this.rowGroupActive !== e && (this.rowGroupActive = e, this.columnEventService.dispatchEvent(this.createColumnEvent("columnRowGroupChanged", t))), this.dispatchStateUpdatedEvent("rowGroup");
  }
  isRowGroupActive() {
    return this.rowGroupActive;
  }
  setPivotActive(e, t) {
    this.pivotActive !== e && (this.pivotActive = e, this.columnEventService.dispatchEvent(this.createColumnEvent("columnPivotChanged", t))), this.dispatchStateUpdatedEvent("pivot");
  }
  isPivotActive() {
    return this.pivotActive;
  }
  isAnyFunctionActive() {
    return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
  }
  isAnyFunctionAllowed() {
    return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
  }
  setValueActive(e, t) {
    this.aggregationActive !== e && (this.aggregationActive = e, this.columnEventService.dispatchEvent(this.createColumnEvent("columnValueChanged", t)));
  }
  isValueActive() {
    return this.aggregationActive;
  }
  isAllowPivot() {
    return this.colDef.enablePivot === !0;
  }
  isAllowValue() {
    return this.colDef.enableValue === !0;
  }
  isAllowRowGroup() {
    return this.colDef.enableRowGroup === !0;
  }
  dispatchStateUpdatedEvent(e) {
    this.columnEventService.dispatchEvent({ type: "columnStateUpdated", key: e });
  }
};
function K(e) {
  return e instanceof Kt;
}
var Kt = class extends f {
  constructor(e, t, i, o) {
    super(), this.isColumn = !1, this.expandable = !1, this.instanceId = us(), this.expandableListenerRemoveCallback = null, this.colGroupDef = e, this.groupId = t, this.expanded = !!e && !!e.openByDefault, this.padding = i, this.level = o;
  }
  destroy() {
    this.expandableListenerRemoveCallback && this.reset(null, void 0), super.destroy();
  }
  reset(e, t) {
    this.colGroupDef = e, this.level = t, this.originalParent = null, this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback(), this.children = void 0, this.expandable = void 0;
  }
  getInstanceId() {
    return this.instanceId;
  }
  setOriginalParent(e) {
    this.originalParent = e;
  }
  getOriginalParent() {
    return this.originalParent;
  }
  getLevel() {
    return this.level;
  }
  isVisible() {
    return !!this.children && this.children.some((e) => e.isVisible());
  }
  isPadding() {
    return this.padding;
  }
  setExpanded(e) {
    this.expanded = e !== void 0 && e, this.dispatchLocalEvent({ type: "expandedChanged" });
  }
  isExpandable() {
    return this.expandable;
  }
  isExpanded() {
    return this.expanded;
  }
  getGroupId() {
    return this.groupId;
  }
  getId() {
    return this.getGroupId();
  }
  setChildren(e) {
    this.children = e;
  }
  getChildren() {
    return this.children;
  }
  getColGroupDef() {
    return this.colGroupDef;
  }
  getLeafColumns() {
    const e = [];
    return this.addLeafColumns(e), e;
  }
  addLeafColumns(e) {
    this.children && this.children.forEach((t) => {
      Le(t) ? e.push(t) : K(t) && t.addLeafColumns(e);
    });
  }
  getColumnGroupShow() {
    const e = this.colGroupDef;
    if (e)
      return e.columnGroupShow;
  }
  setupExpandable() {
    this.setExpandable(), this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback();
    const e = this.onColumnVisibilityChanged.bind(this);
    this.getLeafColumns().forEach((t) => t.addEventListener("visibleChanged", e)), this.expandableListenerRemoveCallback = () => {
      this.getLeafColumns().forEach((t) => t.removeEventListener("visibleChanged", e)), this.expandableListenerRemoveCallback = null;
    };
  }
  setExpandable() {
    if (this.isPadding())
      return;
    let e = !1, t = !1, i = !1;
    const o = this.findChildrenRemovingPadding();
    for (let r = 0, n = o.length; r < n; r++) {
      const a = o[r];
      if (!a.isVisible())
        continue;
      const l = a.getColumnGroupShow();
      l === "open" ? (e = !0, i = !0) : l === "closed" ? (t = !0, i = !0) : (e = !0, t = !0);
    }
    const s = e && t && i;
    this.expandable !== s && (this.expandable = s, this.dispatchLocalEvent({ type: "expandableChanged" }));
  }
  findChildrenRemovingPadding() {
    const e = [], t = (i) => {
      i.forEach((o) => {
        K(o) && o.isPadding() ? t(o.children) : e.push(o);
      });
    };
    return t(this.children), e;
  }
  onColumnVisibilityChanged() {
    this.setExpandable();
  }
}, on = { numericColumn: { headerClass: "ag-right-aligned-header", cellClass: "ag-right-aligned-cell" }, rightAligned: { headerClass: "ag-right-aligned-header", cellClass: "ag-right-aligned-cell" } }, Eo = {};
function Ji(e, t) {
  Eo[t] || (e(), Eo[t] = !0);
}
function se(e, ...t) {
  console.log("AG Grid: " + e, ...t);
}
function b(e, ...t) {
  Ji(() => console.warn("AG Grid: " + e, ...t), e + (t == null ? void 0 : t.join("")));
}
function L(e, ...t) {
  Ji(() => console.error("AG Grid: " + e, ...t), e + (t == null ? void 0 : t.join("")));
}
function Xi(e) {
  return !!(e && e.constructor && e.call && e.apply);
}
var gi = [], ui = !1;
function Po(e) {
  gi.push(e), ui || (ui = !0, window.setTimeout(() => {
    const t = gi.slice();
    gi.length = 0, ui = !1, t.forEach((i) => i());
  }, 0));
}
function q(e, t) {
  let i;
  return function(...o) {
    const s = this;
    window.clearTimeout(i), i = window.setTimeout(function() {
      e.apply(s, o);
    }, t);
  };
}
function ko(e, t) {
  let i = 0;
  return function(...o) {
    const s = (/* @__PURE__ */ new Date()).getTime();
    s - i < t || (i = s, e.apply(this, o));
  };
}
var sn = class {
  constructor() {
    this.existingKeys = {};
  }
  addExistingKeys(e) {
    for (let t = 0; t < e.length; t++)
      this.existingKeys[e[t]] = !0;
  }
  getUniqueKey(e, t) {
    e = Mi(e);
    let i = 0;
    for (; ; ) {
      let o;
      if (e ? (o = e, i !== 0 && (o += "_" + i)) : t ? (o = t, i !== 0 && (o += "_" + i)) : o = i, !this.existingKeys[o])
        return this.existingKeys[o] = !0, String(o);
      i++;
    }
  }
}, Et = "ag-Grid-AutoColumn";
function Zi(e) {
  const t = [], i = (o) => {
    for (let s = 0; s < o.length; s++) {
      const r = o[s];
      Le(r) ? t.push(r) : K(r) && i(r.getChildren());
    }
  };
  return i(e), t;
}
function Se(e) {
  return e.reduce((t, i) => t + i.getActualWidth(), 0);
}
function ot(e, t, i) {
  const o = {};
  if (!t)
    return;
  Fe(null, t, (r) => {
    o[r.getInstanceId()] = r;
  }), i && Fe(null, i, (r) => {
    o[r.getInstanceId()] = null;
  });
  const s = Object.values(o).filter((r) => r != null);
  e.destroyBeans(s);
}
function Ao(e) {
  return e.getId().startsWith(Et);
}
function Qt(e) {
  let t = [];
  return e instanceof Array ? e.some((i) => typeof i != "string") ? b("if colDef.type is supplied an array it should be of type 'string[]'") : t = e : typeof e == "string" ? t = e.split(",") : b("colDef.type should be of type 'string' | 'string[]'"), t;
}
var rn = class extends f {
  constructor() {
    super(...arguments), this.beanName = "columnFactory";
  }
  wireBeans(e) {
    this.dataTypeService = e.dataTypeService;
  }
  createColumnTree(e, t, i, o) {
    const s = new sn(), { existingCols: r, existingGroups: n, existingColKeys: a } = this.extractExistingTreeData(i);
    s.addExistingKeys(a);
    const l = this.recursivelyCreateColumns(e, 0, t, r, s, n, o), d = this.findMaxDept(l, 0), c = this.balanceColumnTree(l, 0, d, s);
    return Fe(null, c, (h, g) => {
      K(h) && h.setupExpandable(), h.setOriginalParent(g);
    }), { columnTree: c, treeDept: d };
  }
  extractExistingTreeData(e) {
    const t = [], i = [], o = [];
    return e && Fe(null, e, (s) => {
      if (K(s)) {
        const r = s;
        i.push(r);
      } else {
        const r = s;
        o.push(r.getId()), t.push(r);
      }
    }), { existingCols: t, existingGroups: i, existingColKeys: o };
  }
  createForAutoGroups(e, t) {
    const i = [], o = this.findDepth(t);
    return e.forEach((s) => {
      let r = s;
      for (let n = o - 1; n >= 0; n--) {
        const a = new Kt(null, `FAKE_PATH_${s.getId()}}_${n}`, !0, n);
        this.createBean(a), a.setChildren([r]), r.setOriginalParent(a), r = a;
      }
      o === 0 && s.setOriginalParent(null), i.push(r);
    }), [i, o];
  }
  findDepth(e) {
    let t = 0, i = e;
    for (; i && i[0] && K(i[0]); )
      t++, i = i[0].getChildren();
    return t;
  }
  balanceColumnTree(e, t, i, o) {
    const s = [];
    for (let r = 0; r < e.length; r++) {
      const n = e[r];
      if (K(n)) {
        const a = n, l = this.balanceColumnTree(a.getChildren(), t + 1, i, o);
        a.setChildren(l), s.push(a);
      } else {
        let a, l;
        for (let d = i - 1; d >= t; d--) {
          const c = o.getUniqueKey(null, null), h = this.createMergedColGroupDef(null), g = new Kt(h, c, !0, t);
          this.createBean(g), l && l.setChildren([g]), l = g, a || (a = l);
        }
        if (a && l) {
          if (s.push(a), e.some((d) => K(d))) {
            l.setChildren([n]);
            continue;
          }
          l.setChildren(e);
          break;
        }
        s.push(n);
      }
    }
    return s;
  }
  findMaxDept(e, t) {
    let i = t;
    for (let o = 0; o < e.length; o++) {
      const s = e[o];
      if (K(s)) {
        const r = s, n = this.findMaxDept(r.getChildren(), t + 1);
        i < n && (i = n);
      }
    }
    return i;
  }
  recursivelyCreateColumns(e, t, i, o, s, r, n) {
    if (!e)
      return [];
    const a = new Array(e.length);
    for (let l = 0; l < a.length; l++) {
      const d = e[l];
      this.isColumnGroup(d) ? a[l] = this.createColumnGroup(i, d, t, o, s, r, n) : a[l] = this.createColumn(i, d, o, s, n);
    }
    return a;
  }
  createColumnGroup(e, t, i, o, s, r, n) {
    const a = this.createMergedColGroupDef(t), l = s.getUniqueKey(a.groupId || null, null), d = new Kt(a, l, !1, i);
    this.createBean(d);
    const c = this.findExistingGroup(t, r);
    c && r.splice(c.idx, 1);
    const h = c == null ? void 0 : c.group;
    h && d.setExpanded(h.isExpanded());
    const g = this.recursivelyCreateColumns(a.children, i + 1, e, o, s, r, n);
    return d.setChildren(g), d;
  }
  createMergedColGroupDef(e) {
    const t = {};
    return Object.assign(t, this.gos.get("defaultColGroupDef")), Object.assign(t, e), t;
  }
  createColumn(e, t, i, o, s) {
    var a;
    const r = this.findExistingColumn(t, i);
    r && (i == null || i.splice(r.idx, 1));
    let n = r == null ? void 0 : r.column;
    if (n) {
      const l = this.addColumnDefaultAndTypes(t, n.getColId());
      n.setColDef(l, t, s), this.applyColumnState(n, l, s);
    } else {
      const l = o.getUniqueKey(t.colId, t.field), d = this.addColumnDefaultAndTypes(t, l);
      n = new ps(d, t, l, e), this.createBean(n);
    }
    return (a = this.dataTypeService) == null || a.addColumnListeners(n), n;
  }
  applyColumnState(e, t, i) {
    const o = We(t.flex);
    if (o !== void 0 && e.setFlex(o), e.getFlex() <= 0) {
      const n = We(t.width);
      if (n != null)
        e.setActualWidth(n, i);
      else {
        const a = e.getActualWidth();
        e.setActualWidth(a, i);
      }
    }
    t.sort !== void 0 && (t.sort == "asc" || t.sort == "desc" ? e.setSort(t.sort, i) : e.setSort(void 0, i));
    const s = We(t.sortIndex);
    s !== void 0 && e.setSortIndex(s);
    const r = Ei(t.hide);
    r !== void 0 && e.setVisible(!r, i), t.pinned !== void 0 && e.setPinned(t.pinned);
  }
  findExistingColumn(e, t) {
    if (t)
      for (let i = 0; i < t.length; i++) {
        const o = t[i].getUserProvidedColDef();
        if (o) {
          if (e.colId == null) {
            if (e.field != null) {
              if (o.field === e.field)
                return { idx: i, column: t[i] };
            } else if (o === e)
              return { idx: i, column: t[i] };
          } else if (t[i].getId() === e.colId)
            return { idx: i, column: t[i] };
        }
      }
  }
  findExistingGroup(e, t) {
    if (e.groupId != null)
      for (let i = 0; i < t.length; i++) {
        const o = t[i];
        if (o.getColGroupDef() && o.getId() === e.groupId)
          return { idx: i, group: o };
      }
  }
  addColumnDefaultAndTypes(e, t) {
    var n;
    const i = {};
    oe(i, this.gos.get("defaultColDef"), !1, !0);
    const o = this.updateColDefAndGetColumnType(i, e, t);
    o && this.assignColumnTypes(o, i), oe(i, e, !1, !0);
    const s = this.gos.get("autoGroupColumnDef"), r = this.gos.isColumnsSortingCoupledToGroup();
    return e.rowGroup && s && r && oe(i, { sort: s.sort, initialSort: s.initialSort }, !1, !0), (n = this.dataTypeService) == null || n.validateColDef(i), i;
  }
  updateColDefAndGetColumnType(e, t, i) {
    var r;
    const o = (r = this.dataTypeService) == null ? void 0 : r.updateColDefAndGetColumnType(e, t, i), s = t.type ?? o ?? e.type;
    return e.type = s, s ? Qt(s) : void 0;
  }
  assignColumnTypes(e, t) {
    if (!e.length)
      return;
    const i = Object.assign({}, on);
    le(this.gos.get("columnTypes") || {}, (o, s) => {
      o in i ? b(`the column type '${o}' is a default column type and cannot be overridden.`) : (s.type && b("Column type definitions 'columnTypes' with a 'type' attribute are not supported because a column type cannot refer to another column type. Only column definitions 'columnDefs' can use the 'type' attribute to refer to a column type."), i[o] = s);
    }), e.forEach((o) => {
      const s = i[o.trim()];
      s ? oe(t, s, !1, !0) : b("colDef.type '" + o + "' does not correspond to defined gridOptions.columnTypes");
    });
  }
  isColumnGroup(e) {
    return e.children !== void 0;
  }
};
function Fe(e, t, i) {
  if (t)
    for (let o = 0; o < t.length; o++) {
      const s = t[o];
      K(s) && Fe(s, s.getChildren(), i), i(s, e);
    }
}
var nn = class extends f {
  constructor() {
    super(...arguments), this.beanName = "columnModel", this.pivotMode = !1, this.autoHeightActiveAtLeastOnce = !1, this.ready = !1, this.changeEventsDispatching = !1, this.shouldQueueResizeOperations = !1, this.resizeOperationQueue = [];
  }
  wireBeans(e) {
    this.context = e.context, this.columnFactory = e.columnFactory, this.columnSizeService = e.columnSizeService, this.visibleColsService = e.visibleColsService, this.columnViewportService = e.columnViewportService, this.pivotResultColsService = e.pivotResultColsService, this.columnAnimationService = e.columnAnimationService, this.autoColService = e.autoColService, this.valueCache = e.valueCache, this.columnDefFactory = e.columnDefFactory, this.columnApplyStateService = e.columnApplyStateService, this.columnGroupStateService = e.columnGroupStateService, this.eventDispatcher = e.columnEventDispatcher, this.columnMoveService = e.columnMoveService, this.columnAutosizeService = e.columnAutosizeService, this.funcColsService = e.funcColsService, this.quickFilterService = e.quickFilterService, this.showRowGroupColsService = e.showRowGroupColsService, this.environment = e.environment;
  }
  postConstruct() {
    const e = this.gos.get("pivotMode");
    this.isPivotSettingAllowed(e) && (this.pivotMode = e), this.addManagedPropertyListeners(["groupDisplayType", "treeData", "treeDataDisplayType", "groupHideOpenParents"], (t) => this.refreshAll(st(t.source))), this.addManagedPropertyListener("autoGroupColumnDef", (t) => this.onAutoGroupColumnDefChanged(st(t.source))), this.addManagedPropertyListeners(["defaultColDef", "columnTypes", "suppressFieldDotNotation"], (t) => this.recreateColumnDefs(st(t.source))), this.addManagedPropertyListener("pivotMode", (t) => this.setPivotMode(this.gos.get("pivotMode"), st(t.source))), this.addManagedEventListeners({ firstDataRendered: () => this.onFirstDataRendered() });
  }
  createColsFromColDefs(e, t) {
    var c;
    const i = e ? this.columnApplyStateService.compareColumnStatesAndDispatchEvents(t) : void 0;
    this.valueCache.expire();
    const o = this.colDefCols && this.colDefCols.list, s = this.colDefCols && this.colDefCols.tree, r = this.columnFactory.createColumnTree(this.colDefs, !0, s, t);
    ot(this.context, (c = this.colDefCols) == null ? void 0 : c.tree, r.columnTree);
    const n = r.columnTree, a = r.treeDept, l = Zi(n), d = {};
    l.forEach((h) => d[h.getId()] = h), this.colDefCols = { tree: n, treeDepth: a, list: l, map: d }, this.funcColsService.extractCols(t, o), this.ready = !0, this.refreshCols(), e && !this.showingPivotResult && !this.gos.get("maintainColumnOrder") && this.orderColsLikeColDefCols(), this.visibleColsService.refresh(t), this.columnViewportService.checkViewportColumns(), this.eventDispatcher.everythingChanged(t), i && (this.changeEventsDispatching = !0, i(), this.changeEventsDispatching = !1), this.eventDispatcher.newColumnsLoaded(t), t === "gridInitializing" && this.columnSizeService.applyAutosizeStrategy();
  }
  refreshCols() {
    var t, i, o;
    if (!this.colDefCols)
      return;
    const e = (t = this.cols) == null ? void 0 : t.tree;
    this.saveColOrder(), this.selectCols(), this.createAutoCols(), this.addAutoCols(), this.restoreColOrder(), this.positionLockedCols(), (i = this.showRowGroupColsService) == null || i.refresh(), (o = this.quickFilterService) == null || o.refreshQuickFilterCols(), this.setColSpanActive(), this.setAutoHeightActive(), this.visibleColsService.clear(), this.columnViewportService.clear(), !Ke(e, this.cols.tree) && this.eventDispatcher.gridColumns();
  }
  selectCols() {
    const e = this.pivotResultColsService.getPivotResultCols();
    if (this.showingPivotResult = e != null, e) {
      const { map: t, list: i, tree: o, treeDepth: s } = e;
      this.cols = { list: i.slice(), map: { ...t }, tree: o.slice(), treeDepth: s }, e.list.some((r) => {
        var n;
        return ((n = this.cols) == null ? void 0 : n.map[r.getColId()]) !== void 0;
      }) || (this.lastPivotOrder = null);
    } else {
      const { map: t, list: i, tree: o, treeDepth: s } = this.colDefCols;
      this.cols = { list: i.slice(), map: { ...t }, tree: o.slice(), treeDepth: s };
    }
  }
  getColsToShow() {
    const e = this.isPivotMode() && !this.isShowingPivotResult(), t = this.funcColsService.getValueColumns();
    return this.cols.list.filter((i) => {
      const o = Ao(i);
      if (e) {
        const s = t && He(t, i);
        return o || s;
      }
      return o || i.isVisible();
    });
  }
  addAutoCols() {
    var e;
    this.autoCols != null && (this.cols.list = this.autoCols.list.concat(this.cols.list), this.cols.tree = this.autoCols.tree.concat(this.cols.tree), (e = this.cols).map = {}, e.list.forEach((t) => e.map[t.getId()] = t));
  }
  createAutoCols() {
    var h, g;
    const e = this.gos.isGroupUseEntireRow(this.pivotMode), t = this.pivotMode ? this.gos.get("pivotSuppressAutoColumn") : this.isSuppressAutoCol(), i = this.funcColsService.getRowGroupColumns(), o = () => {
      this.autoCols && (ot(this.context, this.autoCols.tree), this.autoCols = null);
    };
    if (!(i.length > 0 || this.gos.get("treeData")) || t || e || !this.autoColService)
      return void o();
    const s = this.autoColService.createAutoCols(i) ?? [], r = Ke(s, ((h = this.autoCols) == null ? void 0 : h.list) || null, (u, p) => u.getColId() === p.getColId()), n = this.cols.treeDepth, a = this.autoCols ? this.autoCols.treeDepth : -1;
    if (r && a == n)
      return;
    o();
    const [l, d] = this.columnFactory.createForAutoGroups(s, (g = this.cols) == null ? void 0 : g.tree);
    this.autoCols = { list: s, tree: l, treeDepth: d, map: {} };
    const c = (u) => {
      if (!u)
        return null;
      const p = u.filter((C) => !Ao(C));
      return [...s, ...p];
    };
    this.lastOrder = c(this.lastOrder), this.lastPivotOrder = c(this.lastPivotOrder);
  }
  refreshAll(e) {
    this.isReady() && (this.refreshCols(), this.visibleColsService.refresh(e));
  }
  setColsVisible(e, t = !1, i) {
    this.columnApplyStateService.applyColumnState({ state: e.map((o) => ({ colId: typeof o == "string" ? o : o.getColId(), hide: !t })) }, i);
  }
  setColsPinned(e, t, i) {
    if (!this.cols || W(e))
      return;
    if (this.gos.isDomLayout("print"))
      return void b("Changing the column pinning status is not allowed with domLayout='print'");
    let o;
    this.columnAnimationService.start(), o = t === !0 || t === "left" ? "left" : t === "right" ? "right" : null;
    const s = [];
    e.forEach((r) => {
      if (!r)
        return;
      const n = this.getCol(r);
      n && n.getPinned() !== o && (n.setPinned(o), s.push(n));
    }), s.length && (this.visibleColsService.refresh(i), this.eventDispatcher.columnPinned(s, i)), this.columnAnimationService.finish();
  }
  setColumnGroupOpened(e, t, i) {
    let o;
    o = K(e) ? e.getId() : e || "", this.columnGroupStateService.setColumnGroupState([{ groupId: o, open: t }], i);
  }
  getProvidedColGroup(e) {
    var i;
    let t = null;
    return Fe(null, (i = this.cols) == null ? void 0 : i.tree, (o) => {
      K(o) && o.getId() === e && (t = o);
    }), t;
  }
  isColGroupLocked(e) {
    const t = this.gos.get("groupLockGroupColumns");
    return !(!e.isRowGroupActive() || t === 0) && (t === -1 || t > this.funcColsService.getRowGroupColumns().findIndex((i) => i.getColId() === e.getColId()));
  }
  isSuppressAutoCol() {
    return this.gos.get("groupDisplayType") === "custom" || this.gos.get("treeDataDisplayType") === "custom";
  }
  setAutoHeightActive() {
    this.autoHeightActive = this.cols.list.some((e) => e.isAutoHeight()), this.autoHeightActive && (this.autoHeightActiveAtLeastOnce = !0, this.gos.isRowModelType("clientSide") || this.gos.isRowModelType("serverSide") || b("autoHeight columns only work with Client Side Row Model and Server Side Row Model."));
  }
  restoreColOrder() {
    const e = this.showingPivotResult ? this.lastPivotOrder : this.lastOrder;
    if (!e)
      return;
    const t = new Map(e.map((a, l) => [a, l]));
    if (!this.cols.list.some((a) => t.has(a)))
      return;
    const i = new Map(this.cols.list.map((a) => [a, !0])), o = e.filter((a) => i.has(a)), s = new Map(o.map((a) => [a, !0])), r = this.cols.list.filter((a) => !s.has(a)), n = o.slice();
    r.forEach((a) => {
      let l = a.getOriginalParent();
      if (!l)
        return void n.push(a);
      const d = [];
      for (; !d.length && l; )
        l.getLeafColumns().forEach((g) => {
          const u = n.indexOf(g) >= 0, p = d.indexOf(g) < 0;
          u && p && d.push(g);
        }), l = l.getOriginalParent();
      if (!d.length)
        return void n.push(a);
      const c = d.map((g) => n.indexOf(g)), h = Math.max(...c);
      Jt(n, a, h + 1);
    }), this.cols.list = n;
  }
  orderColsLikeColDefCols() {
    if (!this.colDefCols || !this.cols)
      return;
    const e = this.colDefCols.list.filter((i) => this.cols.list.indexOf(i) >= 0), t = this.cols.list.filter((i) => e.indexOf(i) < 0);
    this.cols.list = [...t, ...e], this.cols.list = this.columnMoveService.placeLockedColumns(this.cols.list);
  }
  sortColsLikeKeys(e) {
    if (this.cols == null)
      return;
    let t = [];
    const i = {};
    e.forEach((s) => {
      if (i[s])
        return;
      const r = this.cols.map[s];
      r && (t.push(r), i[s] = !0);
    });
    let o = 0;
    this.cols.list.forEach((s) => {
      const r = s.getColId();
      i[r] == null && (r.startsWith(Et) ? Jt(t, s, o++) : t.push(s));
    }), t = this.columnMoveService.placeLockedColumns(t), this.columnMoveService.doesMovePassMarryChildren(t) ? this.cols.list = t : b("Applying column order broke a group where columns should be married together. Applying new order has been discarded.");
  }
  sortColsLikeCols(e) {
    !e || e.length <= 1 || e.filter((t) => this.cols.list.indexOf(t) < 0).length > 0 || e.sort((t, i) => this.cols.list.indexOf(t) - this.cols.list.indexOf(i));
  }
  resetColDefIntoCol(e, t) {
    const i = e.getUserProvidedColDef();
    if (!i)
      return !1;
    const o = this.columnFactory.addColumnDefaultAndTypes(i, e.getColId());
    return e.setColDef(o, i, t), !0;
  }
  queueResizeOperations() {
    this.shouldQueueResizeOperations = !0;
  }
  isShouldQueueResizeOperations() {
    return this.shouldQueueResizeOperations;
  }
  processResizeOperations() {
    this.shouldQueueResizeOperations = !1, this.resizeOperationQueue.forEach((e) => e()), this.resizeOperationQueue = [];
  }
  pushResizeOperation(e) {
    this.resizeOperationQueue.push(e);
  }
  moveInCols(e, t, i) {
    var o;
    ds((o = this.cols) == null ? void 0 : o.list, e, t), this.visibleColsService.refresh(i);
  }
  positionLockedCols() {
    this.cols.list = this.columnMoveService.placeLockedColumns(this.cols.list);
  }
  saveColOrder() {
    var e, t;
    this.showingPivotResult ? this.lastPivotOrder = (e = this.cols) == null ? void 0 : e.list : this.lastOrder = (t = this.cols) == null ? void 0 : t.list;
  }
  getColumnDefs() {
    if (!this.colDefCols)
      return;
    const e = this.colDefCols.list.slice();
    this.showingPivotResult ? e.sort((o, s) => this.lastOrder.indexOf(o) - this.lastOrder.indexOf(s)) : this.lastOrder && e.sort((o, s) => this.cols.list.indexOf(o) - this.cols.list.indexOf(s));
    const t = this.funcColsService.getRowGroupColumns(), i = this.funcColsService.getPivotColumns();
    return this.columnDefFactory.buildColumnDefs(e, t, i);
  }
  isShowingPivotResult() {
    return this.showingPivotResult;
  }
  isChangeEventsDispatching() {
    return this.changeEventsDispatching;
  }
  isColSpanActive() {
    return this.colSpanActive;
  }
  isProvidedColGroupsPresent() {
    var e;
    return ((e = this.colDefCols) == null ? void 0 : e.treeDepth) > 0;
  }
  setColSpanActive() {
    this.colSpanActive = this.cols.list.some((e) => e.getColDef().colSpan != null);
  }
  isAutoRowHeightActive() {
    return this.autoHeightActive;
  }
  wasAutoRowHeightEverActive() {
    return this.autoHeightActiveAtLeastOnce;
  }
  getHeaderRowCount() {
    return this.cols ? this.cols.treeDepth + 1 : -1;
  }
  isReady() {
    return this.ready;
  }
  isPivotMode() {
    return this.pivotMode;
  }
  setPivotMode(e, t) {
    e !== this.pivotMode && this.isPivotSettingAllowed(this.pivotMode) && (this.pivotMode = e, this.ready && (this.refreshCols(), this.visibleColsService.refresh(t), this.eventDispatcher.pivotModeChanged()));
  }
  isPivotSettingAllowed(e) {
    return !e || !this.gos.get("treeData") || (b("Pivot mode not available with treeData."), !1);
  }
  isPivotActive() {
    const e = this.funcColsService.getPivotColumns();
    return this.pivotMode && !W(e);
  }
  recreateColumnDefs(e) {
    this.cols && (this.autoCols && this.autoColService.updateAutoCols(this.autoCols.list, e), this.createColsFromColDefs(!0, e));
  }
  setColumnDefs(e, t) {
    const i = !!this.colDefs;
    this.colDefs = e, this.createColsFromColDefs(i, t);
  }
  destroy() {
    var e, t;
    ot(this.context, (e = this.colDefCols) == null ? void 0 : e.tree), ot(this.context, (t = this.autoCols) == null ? void 0 : t.tree), super.destroy();
  }
  getColTree() {
    return this.cols.tree;
  }
  getColDefColTree() {
    return this.colDefCols.tree;
  }
  getColDefCols() {
    var e;
    return (e = this.colDefCols) != null && e.list ? this.colDefCols.list : null;
  }
  getCols() {
    var e;
    return ((e = this.cols) == null ? void 0 : e.list) ?? [];
  }
  getAllCols() {
    var i, o;
    const e = this.pivotResultColsService.getPivotResultCols(), t = e == null ? void 0 : e.list;
    return [].concat(((i = this.colDefCols) == null ? void 0 : i.list) || [], ((o = this.autoCols) == null ? void 0 : o.list) || [], t || []);
  }
  getColsForKeys(e) {
    return e ? e.map((t) => this.getCol(t)).filter((t) => t != null) : [];
  }
  getColDefCol(e) {
    var t;
    return (t = this.colDefCols) != null && t.list ? this.getColFromCollection(e, this.colDefCols) : null;
  }
  getCol(e) {
    return e == null ? null : this.getColFromCollection(e, this.cols);
  }
  getColFromCollection(e, t) {
    if (t == null)
      return null;
    const { map: i, list: o } = t;
    if (typeof e == "string" && i[e])
      return i[e];
    for (let s = 0; s < o.length; s++)
      if (To(o[s], e))
        return o[s];
    return this.getAutoCol(e);
  }
  getAutoCol(e) {
    return this.autoCols == null ? null : this.autoCols.list.find((t) => To(t, e)) || null;
  }
  getAutoCols() {
    var e;
    return ((e = this.autoCols) == null ? void 0 : e.list) || null;
  }
  setColHeaderHeight(e, t) {
    e.setAutoHeaderHeight(t) && this.eventDispatcher.headerHeight(e);
  }
  getColumnGroupHeaderRowHeight() {
    return this.isPivotMode() ? this.getPivotGroupHeaderHeight() : this.getGroupHeaderHeight();
  }
  getColumnHeaderRowHeight() {
    const e = this.isPivotMode() ? this.getPivotHeaderHeight() : this.getHeaderHeight(), t = this.visibleColsService.getAllCols().filter((i) => i.isAutoHeaderHeight()).map((i) => i.getAutoHeaderHeight() || 0);
    return Math.max(e, ...t);
  }
  getHeaderHeight() {
    return this.gos.get("headerHeight") ?? this.environment.getDefaultHeaderHeight();
  }
  getFloatingFiltersHeight() {
    return this.gos.get("floatingFiltersHeight") ?? this.getHeaderHeight();
  }
  getGroupHeaderHeight() {
    return this.gos.get("groupHeaderHeight") ?? this.getHeaderHeight();
  }
  getPivotHeaderHeight() {
    return this.gos.get("pivotHeaderHeight") ?? this.getHeaderHeight();
  }
  getPivotGroupHeaderHeight() {
    return this.gos.get("pivotGroupHeaderHeight") ?? this.getGroupHeaderHeight();
  }
  onFirstDataRendered() {
    const e = this.gos.get("autoSizeStrategy");
    if ((e == null ? void 0 : e.type) !== "fitCellContents")
      return;
    const { colIds: t, skipHeader: i } = e;
    setTimeout(() => {
      t ? this.columnAutosizeService.autoSizeCols({ colKeys: t, skipHeader: i, source: "autosizeColumns" }) : this.columnAutosizeService.autoSizeAllColumns("autosizeColumns", i);
    });
  }
  onAutoGroupColumnDefChanged(e) {
    this.autoCols && this.autoColService.updateAutoCols(this.autoCols.list, e);
  }
};
function st(e) {
  return e === "gridOptionsUpdated" ? "gridOptionsChanged" : e;
}
function To(e, t) {
  const i = e === t, o = e.getColDef() === t, s = e.getColId() == t;
  return i || o || s;
}
var an = class extends f {
  constructor() {
    super(...arguments), this.beanName = "columnAutosizeService", this.timesDelayed = 0;
  }
  wireBeans(e) {
    this.columnModel = e.columnModel, this.visibleColsService = e.visibleColsService, this.animationFrameService = e.animationFrameService, this.autoWidthCalculator = e.autoWidthCalculator, this.eventDispatcher = e.columnEventDispatcher, this.ctrlsService = e.ctrlsService, this.renderStatusService = e.renderStatusService;
  }
  autoSizeCols(e) {
    if (this.columnModel.isShouldQueueResizeOperations())
      return void this.columnModel.pushResizeOperation(() => this.autoSizeCols(e));
    const { colKeys: t, skipHeader: i, skipHeaderGroups: o, stopAtGroup: s, source: r = "api" } = e;
    if (this.animationFrameService.flushAllFrames(), this.timesDelayed < 5 && this.renderStatusService && !this.renderStatusService.areHeaderCellsRendered())
      return this.timesDelayed++, void setTimeout(() => this.autoSizeCols(e));
    this.timesDelayed = 0;
    const n = [];
    let a = -1;
    const l = i ?? this.gos.get("skipHeaderOnAutoSize"), d = o ?? l;
    for (; a !== 0; ) {
      a = 0;
      const c = [];
      t.forEach((h) => {
        if (!h)
          return;
        const g = this.columnModel.getCol(h);
        if (!g || n.indexOf(g) >= 0)
          return;
        const u = this.autoWidthCalculator.getPreferredWidthForColumn(g, l);
        if (u > 0) {
          const p = this.normaliseColumnWidth(g, u);
          g.setActualWidth(p, r), n.push(g), a++;
        }
        c.push(g);
      }), c.length && this.visibleColsService.refresh(r);
    }
    d || this.autoSizeColumnGroupsByColumns(t, r, s), this.eventDispatcher.columnResized(n, !0, "autosizeColumns");
  }
  autoSizeColumn(e, t, i) {
    e && this.autoSizeCols({ colKeys: [e], skipHeader: i, skipHeaderGroups: !0, source: t });
  }
  autoSizeColumnGroupsByColumns(e, t, i) {
    const o = /* @__PURE__ */ new Set();
    let s;
    this.columnModel.getColsForKeys(e).forEach((r) => {
      let n = r.getParent();
      for (; n && n != i; )
        n.isPadding() || o.add(n), n = n.getParent();
    });
    for (const r of o) {
      for (const n of this.ctrlsService.getHeaderRowContainerCtrls())
        if (s = n.getHeaderCtrlForColumn(r), s)
          break;
      s && s.resizeLeafColumnsToFit(t);
    }
    return [];
  }
  autoSizeAllColumns(e, t) {
    if (this.columnModel.isShouldQueueResizeOperations())
      return void this.columnModel.pushResizeOperation(() => this.autoSizeAllColumns(e, t));
    const i = this.visibleColsService.getAllCols();
    this.autoSizeCols({ colKeys: i, skipHeader: t, source: e });
  }
  normaliseColumnWidth(e, t) {
    const i = e.getMinWidth();
    t < i && (t = i);
    const o = e.getMaxWidth();
    return e.isGreaterThanMax(t) && (t = o), t;
  }
}, ln = class extends f {
  constructor() {
    super(...arguments), this.beanName = "funcColsService", this.rowGroupCols = [], this.valueCols = [], this.pivotCols = [];
  }
  wireBeans(e) {
    this.columnModel = e.columnModel, this.eventDispatcher = e.columnEventDispatcher, this.aggFuncService = e.aggFuncService, this.visibleColsService = e.visibleColsService;
  }
  getModifyColumnsNoEventsCallbacks() {
    return { addGroupCol: (e) => this.rowGroupCols.push(e), removeGroupCol: (e) => Y(this.rowGroupCols, e), addPivotCol: (e) => this.pivotCols.push(e), removePivotCol: (e) => Y(this.pivotCols, e), addValueCol: (e) => this.valueCols.push(e), removeValueCol: (e) => Y(this.valueCols, e) };
  }
  getSourceColumnsForGroupColumn(e) {
    const t = e.getColDef().showRowGroup;
    if (!t)
      return null;
    if (t === !0)
      return this.rowGroupCols.slice(0);
    const i = this.columnModel.getColDefCol(t);
    return i ? [i] : null;
  }
  sortRowGroupColumns(e) {
    this.rowGroupCols.sort(e);
  }
  sortPivotColumns(e) {
    this.pivotCols.sort(e);
  }
  getValueColumns() {
    return this.valueCols ? this.valueCols : [];
  }
  getPivotColumns() {
    return this.pivotCols ? this.pivotCols : [];
  }
  getRowGroupColumns() {
    return this.rowGroupCols ? this.rowGroupCols : [];
  }
  isRowGroupEmpty() {
    return W(this.rowGroupCols);
  }
  setColumnAggFunc(e, t, i) {
    if (!e)
      return;
    const o = this.columnModel.getColDefCol(e);
    o && (o.setAggFunc(t), this.eventDispatcher.columnChanged("columnValueChanged", [o], i));
  }
  setRowGroupColumns(e, t) {
    this.setColList(e, this.rowGroupCols, "columnRowGroupChanged", !0, !0, (i, o) => this.setRowGroupActive(i, o, t), t);
  }
  setRowGroupActive(e, t, i) {
    e !== t.isRowGroupActive() && (t.setRowGroupActive(e, i), e && !this.gos.get("suppressRowGroupHidesColumns") && this.columnModel.setColsVisible([t], !1, i), e || this.gos.get("suppressMakeColumnVisibleAfterUnGroup") || this.columnModel.setColsVisible([t], !0, i));
  }
  addRowGroupColumns(e, t) {
    this.updateColList(e, this.rowGroupCols, !0, !0, (i) => this.setRowGroupActive(!0, i, t), "columnRowGroupChanged", t);
  }
  removeRowGroupColumns(e, t) {
    this.updateColList(e, this.rowGroupCols, !1, !0, (i) => this.setRowGroupActive(!1, i, t), "columnRowGroupChanged", t);
  }
  addPivotColumns(e, t) {
    this.updateColList(e, this.pivotCols, !0, !1, (i) => i.setPivotActive(!0, t), "columnPivotChanged", t);
  }
  setPivotColumns(e, t) {
    this.setColList(e, this.pivotCols, "columnPivotChanged", !0, !1, (i, o) => {
      o.setPivotActive(i, t);
    }, t);
  }
  removePivotColumns(e, t) {
    this.updateColList(e, this.pivotCols, !1, !1, (i) => i.setPivotActive(!1, t), "columnPivotChanged", t);
  }
  setValueColumns(e, t) {
    this.setColList(e, this.valueCols, "columnValueChanged", !1, !1, (i, o) => this.setValueActive(i, o, t), t);
  }
  setValueActive(e, t, i) {
    if (e !== t.isValueActive() && (t.setValueActive(e, i), e && !t.getAggFunc() && this.aggFuncService)) {
      const o = this.aggFuncService.getDefaultAggFunc(t);
      t.setAggFunc(o);
    }
  }
  addValueColumns(e, t) {
    this.updateColList(e, this.valueCols, !0, !1, (i) => this.setValueActive(!0, i, t), "columnValueChanged", t);
  }
  removeValueColumns(e, t) {
    this.updateColList(e, this.valueCols, !1, !1, (i) => this.setValueActive(!1, i, t), "columnValueChanged", t);
  }
  moveRowGroupColumn(e, t, i) {
    if (this.isRowGroupEmpty())
      return;
    const o = this.rowGroupCols[e], s = this.rowGroupCols.slice(e, t);
    this.rowGroupCols.splice(e, 1), this.rowGroupCols.splice(t, 0, o), this.eventDispatcher.rowGroupChanged(s, i);
  }
  setColList(e, t, i, o, s, r, n) {
    if (W(this.columnModel.getCols()))
      return;
    const a = /* @__PURE__ */ new Map();
    t.forEach((l, d) => a.set(l, d)), t.length = 0, S(e) && e.forEach((l) => {
      const d = this.columnModel.getColDefCol(l);
      d && t.push(d);
    }), t.forEach((l, d) => {
      const c = a.get(l);
      c !== void 0 ? o && c !== d || a.delete(l) : a.set(l, 0);
    }), (this.columnModel.getColDefCols() || []).forEach((l) => {
      const d = t.indexOf(l) >= 0;
      r(d, l);
    }), s && this.columnModel.refreshCols(), this.visibleColsService.refresh(n), this.eventDispatcher.columnChanged(i, [...a.keys()], n);
  }
  updateColList(e, t, i, o, s, r, n) {
    if (!e || W(e))
      return;
    let a = !1;
    e.forEach((l) => {
      if (!l)
        return;
      const d = this.columnModel.getColDefCol(l);
      if (d) {
        if (i) {
          if (t.indexOf(d) >= 0)
            return;
          t.push(d);
        } else {
          if (t.indexOf(d) < 0)
            return;
          Y(t, d);
        }
        s(d), a = !0;
      }
    }), a && (o && this.columnModel.refreshCols(), this.visibleColsService.refresh(n), this.eventDispatcher.genericColumnEvent(r, t, n));
  }
  extractCols(e, t) {
    this.extractRowGroupCols(e, t), this.extractPivotCols(e, t), this.extractValueCols(e, t);
  }
  extractValueCols(e, t) {
    this.valueCols = this.extractColsCommon(t, this.valueCols, (i, o) => i.setValueActive(o, e), () => {
    }, () => {
    }, (i) => {
      const o = i.aggFunc;
      return o === null || o === "" ? null : o !== void 0 ? !!o : void 0;
    }, (i) => i.initialAggFunc != null && i.initialAggFunc != ""), this.valueCols.forEach((i) => {
      const o = i.getColDef();
      o.aggFunc != null && o.aggFunc != "" ? i.setAggFunc(o.aggFunc) : i.getAggFunc() || i.setAggFunc(o.initialAggFunc);
    });
  }
  extractRowGroupCols(e, t) {
    this.rowGroupCols = this.extractColsCommon(t, this.rowGroupCols, (i, o) => i.setRowGroupActive(o, e), (i) => i.rowGroupIndex, (i) => i.initialRowGroupIndex, (i) => i.rowGroup, (i) => i.initialRowGroup);
  }
  extractPivotCols(e, t) {
    this.pivotCols = this.extractColsCommon(t, this.pivotCols, (i, o) => i.setPivotActive(o, e), (i) => i.pivotIndex, (i) => i.initialPivotIndex, (i) => i.pivot, (i) => i.initialPivot);
  }
  extractColsCommon(e = [], t = [], i, o, s, r, n) {
    const a = [], l = [];
    (this.columnModel.getColDefCols() || []).forEach((h) => {
      const g = e.indexOf(h) < 0, u = h.getColDef(), p = Ei(r(u)), C = Ei(n(u)), y = We(o(u)), w = We(s(u));
      let x;
      x = p !== void 0 ? p : y !== void 0 ? y !== null && y >= 0 : g ? C !== void 0 ? C : w !== void 0 && w != null && w >= 0 : t.indexOf(h) >= 0, x && ((g ? y != null || w != null : y != null) ? a.push(h) : l.push(h));
    });
    const d = (h) => {
      const g = o(h.getColDef()), u = s(h.getColDef());
      return g ?? u;
    };
    a.sort((h, g) => {
      const u = d(h), p = d(g);
      return u === p ? 0 : u < p ? -1 : 1;
    });
    const c = [].concat(a);
    return t.forEach((h) => {
      l.indexOf(h) >= 0 && c.push(h);
    }), l.forEach((h) => {
      c.indexOf(h) < 0 && c.push(h);
    }), t.forEach((h) => {
      c.indexOf(h) < 0 && i(h, !1);
    }), c.forEach((h) => {
      t.indexOf(h) < 0 && i(h, !0);
    }), c;
  }
  generateColumnStateForRowGroupAndPivotIndexes(e, t) {
    const i = {}, o = (s, r, n, a, l, d) => {
      const c = this.columnModel.getColDefCols();
      if (!r.length || !c)
        return [];
      const h = Object.keys(s), g = new Set(h), u = new Set(h), p = new Set(r.map((D) => {
        const F = D.getColId();
        return u.delete(F), F;
      }).concat(h)), C = [], y = {};
      let w = 0;
      for (let D = 0; D < c.length; D++) {
        const F = c[D].getColId();
        p.has(F) && (C.push(F), y[F] = w++);
      }
      let x = 1e3, E = !1, k = 0;
      const P = (D) => {
        const F = y[D];
        for (let G = k; G < F; G++) {
          const N = C[G];
          u.has(N) && (s[N][l] = x++, u.delete(N));
        }
        k = F;
      };
      r.forEach((D) => {
        const F = D.getColId();
        if (g.has(F))
          P(F), s[F][l] = x++;
        else {
          const G = D.getColDef();
          (G[l] === null || G[l] === void 0 && G[d] == null) && (E || (G[n] || G[n] === void 0 && G[a] ? P(F) : (u.forEach((N) => {
            s[N][l] = x + y[N];
          }), x += C.length, E = !0)), i[F] || (i[F] = { colId: F }), i[F][l] = x++);
        }
      });
    };
    return o(e, this.rowGroupCols, "rowGroup", "initialRowGroup", "rowGroupIndex", "initialRowGroupIndex"), o(t, this.pivotCols, "pivot", "initialPivot", "pivotIndex", "initialPivotIndex"), Object.values(i);
  }
}, dn = class extends f {
  constructor() {
    super(...arguments), this.beanName = "columnApplyStateService";
  }
  wireBeans(e) {
    this.columnModel = e.columnModel, this.eventDispatcher = e.columnEventDispatcher, this.sortController = e.sortController, this.columnGetStateService = e.columnGetStateService, this.funcColsService = e.funcColsService, this.visibleColsService = e.visibleColsService, this.columnAnimationService = e.columnAnimationService, this.pivotResultColsService = e.pivotResultColsService;
  }
  applyColumnState(e, t) {
    const i = this.columnModel.getColDefCols() || [];
    if (W(i))
      return !1;
    if (e && e.state && !e.state.forEach)
      return b("applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state."), !1;
    const o = this.funcColsService.getModifyColumnsNoEventsCallbacks(), s = (a, l, d) => {
      const c = this.compareColumnStatesAndDispatchEvents(t), h = l.slice(), g = {}, u = {}, p = [], C = [];
      let y = 0;
      const w = this.funcColsService.getRowGroupColumns().slice(), x = this.funcColsService.getPivotColumns().slice();
      a.forEach((P) => {
        const D = P.colId || "";
        if (D.startsWith(Et))
          return p.push(P), void C.push(P);
        const F = d(D);
        F ? (this.syncColumnWithStateItem(F, P, e.defaultState, g, u, !1, t, o), Y(h, F)) : (C.push(P), y += 1);
      });
      const E = (P) => this.syncColumnWithStateItem(P, null, e.defaultState, g, u, !1, t, o);
      h.forEach(E), this.funcColsService.sortRowGroupColumns(Io.bind(this, g, w)), this.funcColsService.sortPivotColumns(Io.bind(this, u, x)), this.columnModel.refreshCols();
      const k = (this.columnModel.getAutoCols() || []).slice();
      return p.forEach((P) => {
        const D = this.columnModel.getAutoCol(P.colId);
        Y(k, D), this.syncColumnWithStateItem(D, P, e.defaultState, null, null, !0, t, o);
      }), k.forEach(E), this.orderLiveColsLikeState(e), this.visibleColsService.refresh(t), this.eventDispatcher.everythingChanged(t), c(), { unmatchedAndAutoStates: C, unmatchedCount: y };
    };
    this.columnAnimationService.start();
    let { unmatchedAndAutoStates: r, unmatchedCount: n } = s(e.state || [], i, (a) => this.columnModel.getColDefCol(a));
    if (r.length > 0 || S(e.defaultState)) {
      const a = this.pivotResultColsService.getPivotResultCols(), l = a == null ? void 0 : a.list;
      n = s(r, l || [], (d) => this.pivotResultColsService.getPivotResultCol(d)).unmatchedCount;
    }
    return this.columnAnimationService.finish(), n === 0;
  }
  resetColumnState(e) {
    if (W(this.columnModel.getColDefCols()))
      return;
    const t = Zi(this.columnModel.getColDefColTree()), i = [];
    let o = 1e3, s = 1e3, r = [];
    const n = this.columnModel.getAutoCols();
    n && (r = r.concat(n)), t && (r = r.concat(t)), r.forEach((a) => {
      const l = this.getColumnStateFromColDef(a);
      A(l.rowGroupIndex) && l.rowGroup && (l.rowGroupIndex = o++), A(l.pivotIndex) && l.pivot && (l.pivotIndex = s++), i.push(l);
    }), this.applyColumnState({ state: i, applyOrder: !0 }, e);
  }
  getColumnStateFromColDef(e) {
    const t = (p, C) => p ?? C ?? null, i = e.getColDef(), o = t(i.sort, i.initialSort), s = t(i.sortIndex, i.initialSortIndex), r = t(i.hide, i.initialHide), n = t(i.pinned, i.initialPinned), a = t(i.width, i.initialWidth), l = t(i.flex, i.initialFlex);
    let d = t(i.rowGroupIndex, i.initialRowGroupIndex), c = t(i.rowGroup, i.initialRowGroup);
    d != null || c != null && c != 0 || (d = null, c = null);
    let h = t(i.pivotIndex, i.initialPivotIndex), g = t(i.pivot, i.initialPivot);
    h != null || g != null && g != 0 || (h = null, g = null);
    const u = t(i.aggFunc, i.initialAggFunc);
    return { colId: e.getColId(), sort: o, sortIndex: s, hide: r, pinned: n, width: a, flex: l, rowGroup: c, rowGroupIndex: d, pivot: g, pivotIndex: h, aggFunc: u };
  }
  syncColumnWithStateItem(e, t, i, o, s, r, n, a) {
    if (!e)
      return;
    const l = (k, P) => {
      const D = { value1: void 0, value2: void 0 };
      let F = !1;
      return t && (t[k] !== void 0 && (D.value1 = t[k], F = !0), S(P) && t[P] !== void 0 && (D.value2 = t[P], F = !0)), !F && i && (i[k] !== void 0 && (D.value1 = i[k]), S(P) && i[P] !== void 0 && (D.value2 = i[P])), D;
    }, d = l("hide").value1;
    d !== void 0 && e.setVisible(!d, n);
    const c = l("pinned").value1;
    c !== void 0 && e.setPinned(c);
    const h = e.getColDef().minWidth ?? 20, g = l("flex").value1;
    if (g !== void 0 && e.setFlex(g), g == null) {
      const k = l("width").value1;
      k != null && h != null && k >= h && e.setActualWidth(k, n);
    }
    const u = l("sort").value1;
    u !== void 0 && (u === "desc" || u === "asc" ? e.setSort(u, n) : e.setSort(void 0, n));
    const p = l("sortIndex").value1;
    if (p !== void 0 && e.setSortIndex(p), r || !e.isPrimary())
      return;
    const C = l("aggFunc").value1;
    C !== void 0 && (typeof C == "string" ? (e.setAggFunc(C), e.isValueActive() || (e.setValueActive(!0, n), a.addValueCol(e))) : (S(C) && b("stateItem.aggFunc must be a string. if using your own aggregation functions, register the functions first before using them in get/set state. This is because it is intended for the column state to be stored and retrieved as simple JSON."), e.isValueActive() && (e.setValueActive(!1, n), a.removeValueCol(e))));
    const { value1: y, value2: w } = l("rowGroup", "rowGroupIndex");
    y === void 0 && w === void 0 || (typeof w == "number" || y ? (e.isRowGroupActive() || (e.setRowGroupActive(!0, n), a.addGroupCol(e)), o && typeof w == "number" && (o[e.getId()] = w)) : e.isRowGroupActive() && (e.setRowGroupActive(!1, n), a.removeGroupCol(e)));
    const { value1: x, value2: E } = l("pivot", "pivotIndex");
    x === void 0 && E === void 0 || (typeof E == "number" || x ? (e.isPivotActive() || (e.setPivotActive(!0, n), a.addPivotCol(e)), s && typeof E == "number" && (s[e.getId()] = E)) : e.isPivotActive() && (e.setPivotActive(!1, n), a.removePivotCol(e)));
  }
  orderLiveColsLikeState(e) {
    if (!e.applyOrder || !e.state)
      return;
    const t = [];
    e.state.forEach((i) => {
      i.colId != null && t.push(i.colId);
    }), this.columnModel.sortColsLikeKeys(t);
  }
  compareColumnStatesAndDispatchEvents(e) {
    const t = { rowGroupColumns: this.funcColsService.getRowGroupColumns().slice(), pivotColumns: this.funcColsService.getPivotColumns().slice(), valueColumns: this.funcColsService.getValueColumns().slice() }, i = this.columnGetStateService.getColumnState(), o = {};
    return i.forEach((s) => {
      o[s.colId] = s;
    }), () => {
      const s = this.columnModel.getAllCols(), r = (c, h, g, u) => {
        if (Ke(h.map(u), g.map(u)))
          return;
        const p = new Set(h);
        g.forEach((w) => {
          p.delete(w) || p.add(w);
        });
        const C = [...p], y = { type: c, columns: C, column: C.length === 1 ? C[0] : null, source: e };
        this.eventService.dispatchEvent(y);
      }, n = (c) => {
        const h = [];
        return s.forEach((g) => {
          const u = o[g.getColId()];
          u && c(u, g) && h.push(g);
        }), h;
      }, a = (c) => c.getColId();
      r("columnRowGroupChanged", t.rowGroupColumns, this.funcColsService.getRowGroupColumns(), a), r("columnPivotChanged", t.pivotColumns, this.funcColsService.getPivotColumns(), a);
      const l = n((c, h) => {
        const g = c.aggFunc != null, u = g != h.isValueActive(), p = g && c.aggFunc != h.getAggFunc();
        return u || p;
      });
      l.length > 0 && this.eventDispatcher.columnChanged("columnValueChanged", l, e), this.eventDispatcher.columnResized(n((c, h) => c.width != h.getActualWidth()), !0, e), this.eventDispatcher.columnPinned(n((c, h) => c.pinned != h.getPinned()), e), this.eventDispatcher.columnVisible(n((c, h) => c.hide == h.isVisible()), e);
      const d = n((c, h) => c.sort != h.getSort() || c.sortIndex != h.getSortIndex());
      d.length > 0 && this.sortController.dispatchSortChangedEvents(e, d), this.normaliseColumnMovedEventForColumnState(i, e);
    };
  }
  normaliseColumnMovedEventForColumnState(e, t) {
    const i = this.columnGetStateService.getColumnState(), o = {};
    i.forEach((l) => o[l.colId] = l);
    const s = {};
    e.forEach((l) => {
      o[l.colId] && (s[l.colId] = !0);
    });
    const r = e.filter((l) => s[l.colId]), n = i.filter((l) => s[l.colId]), a = [];
    n.forEach((l, d) => {
      const c = r && r[d];
      if (c && c.colId !== l.colId) {
        const h = this.columnModel.getCol(c.colId);
        h && a.push(h);
      }
    }), a.length && this.eventDispatcher.columnMoved({ movedColumns: a, source: t, finished: !0 });
  }
}, Io = (e, t, i, o) => {
  const s = e[i.getId()], r = e[o.getId()], n = s != null, a = r != null;
  if (n && a)
    return s - r;
  if (n)
    return -1;
  if (a)
    return 1;
  const l = t.indexOf(i), d = t.indexOf(o), c = l >= 0;
  return c && d >= 0 ? l - d : c ? -1 : 1;
}, cn = class extends f {
  constructor() {
    super(...arguments), this.beanName = "columnMoveService";
  }
  wireBeans(e) {
    this.columnModel = e.columnModel, this.columnAnimationService = e.columnAnimationService, this.eventDispatcher = e.columnEventDispatcher;
  }
  moveColumnByIndex(e, t, i) {
    const o = this.columnModel.getCols();
    if (!o)
      return;
    const s = o[e];
    this.moveColumns([s], t, i);
  }
  moveColumns(e, t, i, o = !0) {
    const s = this.columnModel.getCols();
    if (!s)
      return;
    if (this.columnAnimationService.start(), t > s.length - e.length)
      return b("tried to insert columns in invalid location, toIndex = ", t), void b("remember that you should not count the moving columns when calculating the new index");
    const r = this.columnModel.getColsForKeys(e);
    !this.doesMovePassRules(r, t) || (this.columnModel.moveInCols(r, t, i), this.eventDispatcher.columnMoved({ movedColumns: r, source: i, toIndex: t, finished: o }), this.columnAnimationService.finish());
  }
  doesMovePassRules(e, t) {
    const i = this.getProposedColumnOrder(e, t);
    return this.doesOrderPassRules(i);
  }
  doesOrderPassRules(e) {
    return !!this.doesMovePassMarryChildren(e) && !!this.doesMovePassLockedPositions(e);
  }
  getProposedColumnOrder(e, t) {
    const i = this.columnModel.getCols().slice();
    return ds(i, e, t), i;
  }
  doesMovePassLockedPositions(e) {
    const t = this.gos.get("enableRtl");
    let i = t ? 1 : -1, o = !0;
    return e.forEach((s) => {
      const r = (n = s.getColDef().lockPosition) ? n === "left" || n === !0 ? -1 : 1 : 0;
      var n;
      t ? r > i && (o = !1) : r < i && (o = !1), i = r;
    }), o;
  }
  doesMovePassMarryChildren(e) {
    let t = !0;
    return Fe(null, this.columnModel.getColTree(), (i) => {
      if (!K(i))
        return;
      const o = i, s = o.getColGroupDef();
      if (!s || !s.marryChildren)
        return;
      const r = [];
      o.getLeafColumns().forEach((n) => {
        const a = e.indexOf(n);
        r.push(a);
      }), Math.max.apply(Math, r) - Math.min.apply(Math, r) > o.getLeafColumns().length - 1 && (t = !1);
    }), t;
  }
  placeLockedColumns(e) {
    const t = [], i = [], o = [];
    return e.forEach((s) => {
      const r = s.getColDef().lockPosition;
      r === "right" ? o.push(s) : r === "left" || r === !0 ? t.push(s) : i.push(s);
    }), this.gos.get("enableRtl") ? [...o, ...i, ...t] : [...t, ...i, ...o];
  }
}, hn = /[&<>"']/g, gn = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };
function fe(e, t) {
  if (e == null)
    return null;
  const i = e.toString().toString();
  return t ? i : i.replace(hn, (o) => gn[o]);
}
var un = class extends f {
  constructor() {
    super(...arguments), this.beanName = "columnNameService";
  }
  wireBeans(e) {
    this.expressionService = e.expressionService, this.funcColsService = e.funcColsService, this.columnModel = e.columnModel;
  }
  getDisplayNameForColumn(e, t, i = !1) {
    if (!e)
      return null;
    const o = this.getHeaderName(e.getColDef(), e, null, null, t);
    return i ? this.wrapHeaderNameWithAggFunc(e, o) : o;
  }
  getDisplayNameForProvidedColumnGroup(e, t, i) {
    const o = t ? t.getColGroupDef() : null;
    return o ? this.getHeaderName(o, null, e, t, i) : null;
  }
  getDisplayNameForColumnGroup(e, t) {
    return this.getDisplayNameForProvidedColumnGroup(e, e.getProvidedColumnGroup(), t);
  }
  getHeaderName(e, t, i, o, s) {
    const r = e.headerValueGetter;
    if (r) {
      const a = this.gos.addGridCommonParams({ colDef: e, column: t, columnGroup: i, providedColumnGroup: o, location: s });
      return typeof r == "function" ? r(a) : typeof r == "string" ? this.expressionService.evaluate(r, a) : (b("headerValueGetter must be a function or a string"), "");
    }
    return e.headerName != null ? e.headerName : e.field ? (n = e.field) && n != null ? n.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/([A-Z]+)([A-Z])([a-z])/g, "$1 $2$3").replace(/\./g, " ").split(" ").map((a) => a.substring(0, 1).toUpperCase() + (a.length > 1 ? a.substring(1, a.length) : "")).join(" ") : null : "";
    var n;
  }
  wrapHeaderNameWithAggFunc(e, t) {
    if (this.gos.get("suppressAggFuncInHeader"))
      return t;
    const i = e.getColDef().pivotValueColumn;
    let o, s = null;
    if (S(i)) {
      const r = this.funcColsService.getValueColumns(), n = this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && r.length === 1, a = e.getColDef().pivotTotalColumnIds !== void 0;
      if (n && !a)
        return t;
      s = i ? i.getAggFunc() : null, o = !0;
    } else {
      const r = e.isValueActive(), n = this.columnModel.isPivotMode() || !this.funcColsService.isRowGroupEmpty();
      r && n ? (s = e.getAggFunc(), o = !0) : o = !1;
    }
    if (o) {
      const r = typeof s == "string" ? s : "func";
      return `${this.localeService.getLocaleTextFunc()(r, r)}(${t})`;
    }
    return t;
  }
}, pn = class extends f {
  constructor() {
    super(...arguments), this.beanName = "pivotResultColsService";
  }
  wireBeans(e) {
    this.context = e.context, this.columnModel = e.columnModel, this.columnFactory = e.columnFactory, this.visibleColsService = e.visibleColsService;
  }
  destroy() {
    var e;
    ot(this.context, (e = this.pivotResultCols) == null ? void 0 : e.tree), super.destroy();
  }
  isPivotResultColsPresent() {
    return this.pivotResultCols != null;
  }
  lookupPivotResultCol(e, t) {
    if (this.pivotResultCols == null)
      return null;
    const i = this.columnModel.getColDefCol(t);
    let o = null;
    return this.pivotResultCols.list.forEach((s) => {
      const r = s.getColDef().pivotKeys, n = s.getColDef().pivotValueColumn;
      Ke(r, e) && n === i && (o = s);
    }), o;
  }
  getPivotResultCols() {
    return this.pivotResultCols;
  }
  getPivotResultCol(e) {
    return this.pivotResultCols ? this.columnModel.getColFromCollection(e, this.pivotResultCols) : null;
  }
  setPivotResultCols(e, t) {
    var i, o;
    if (this.columnModel.isReady() && (e != null || this.pivotResultCols != null)) {
      if (e) {
        this.processPivotResultColDef(e);
        const s = this.columnFactory.createColumnTree(e, !1, ((i = this.pivotResultCols) == null ? void 0 : i.tree) || this.previousPivotResultCols || void 0, t);
        ot(this.context, (o = this.pivotResultCols) == null ? void 0 : o.tree, s.columnTree);
        const r = s.columnTree, n = s.treeDept, a = Zi(r), l = {};
        this.pivotResultCols = { tree: r, treeDepth: n, list: a, map: l }, this.pivotResultCols.list.forEach((d) => this.pivotResultCols.map[d.getId()] = d), this.previousPivotResultCols = null;
      } else
        this.previousPivotResultCols = this.pivotResultCols ? this.pivotResultCols.tree : null, this.pivotResultCols = null;
      this.columnModel.refreshCols(), this.visibleColsService.refresh(t);
    }
  }
  processPivotResultColDef(e) {
    const t = this.gos.get("processPivotResultColDef"), i = this.gos.get("processPivotResultColGroupDef");
    if (!t && !i)
      return;
    const o = (s) => {
      s.forEach((r) => {
        if (S(r.children)) {
          const n = r;
          i && i(n), o(n.children);
        } else
          t && t(r);
      });
    };
    e && o(e);
  }
}, mn = class extends f {
  constructor() {
    super(...arguments), this.beanName = "columnSizeService";
  }
  wireBeans(e) {
    this.columnModel = e.columnModel, this.columnViewportService = e.columnViewportService, this.eventDispatcher = e.columnEventDispatcher, this.visibleColsService = e.visibleColsService, this.ctrlsService = e.ctrlsService;
  }
  setColumnWidths(e, t, i, o) {
    const s = [];
    e.forEach((r) => {
      const n = this.columnModel.getColDefCol(r.key) || this.columnModel.getCol(r.key);
      if (n && (s.push({ width: r.newWidth, ratios: [1], columns: [n] }), this.gos.get("colResizeDefault") === "shift" && (t = !t), t)) {
        const a = this.visibleColsService.getColAfter(n);
        if (!a)
          return;
        const l = n.getActualWidth() - r.newWidth, d = a.getActualWidth() + l;
        s.push({ width: d, ratios: [1], columns: [a] });
      }
    }), s.length !== 0 && this.resizeColumnSets({ resizeSets: s, finished: i, source: o });
  }
  resizeColumnSets(e) {
    const { resizeSets: t, finished: i, source: o } = e;
    if (t && !t.every((d) => this.checkMinAndMaxWidthsForSet(d))) {
      if (i) {
        const d = t && t.length > 0 ? t[0].columns : null;
        this.eventDispatcher.columnResized(d, i, o);
      }
      return;
    }
    const s = [], r = [];
    t.forEach((d) => {
      const { width: c, columns: h, ratios: g } = d, u = {}, p = {};
      h.forEach((w) => r.push(w));
      let C = !0, y = 0;
      for (; C; ) {
        if (y++, y > 1e3) {
          L("infinite loop in resizeColumnSets");
          break;
        }
        C = !1;
        const w = [];
        let x = 0, E = c;
        h.forEach((P, D) => {
          if (p[P.getId()])
            E -= u[P.getId()];
          else {
            w.push(P);
            const F = g[D];
            x += F;
          }
        });
        const k = 1 / x;
        w.forEach((P, D) => {
          let F;
          D === w.length - 1 ? F = E : (F = Math.round(g[D] * c * k), E -= F);
          const G = P.getMinWidth(), N = P.getMaxWidth();
          F < G ? (F = G, p[P.getId()] = !0, C = !0) : N > 0 && F > N && (F = N, p[P.getId()] = !0, C = !0), u[P.getId()] = F;
        });
      }
      h.forEach((w) => {
        const x = u[w.getId()];
        w.getActualWidth() !== x && (w.setActualWidth(x, o), s.push(w));
      });
    });
    const n = s.length > 0;
    let a = [];
    n && (a = this.refreshFlexedColumns({ resizingCols: r, skipSetLeft: !0 }), this.visibleColsService.setLeftValues(o), this.visibleColsService.updateBodyWidths(), this.columnViewportService.checkViewportColumns());
    const l = r.concat(a);
    (n || i) && this.eventDispatcher.columnResized(l, i, o, a);
  }
  checkMinAndMaxWidthsForSet(e) {
    const { columns: t, width: i } = e;
    let o = 0, s = 0, r = !0;
    return t.forEach((n) => {
      const a = n.getMinWidth();
      o += a || 0;
      const l = n.getMaxWidth();
      l > 0 ? s += l : r = !1;
    }), i >= o && (!r || i <= s);
  }
  refreshFlexedColumns(e = {}) {
    const t = e.source ? e.source : "flex";
    if (e.viewportWidth != null && (this.flexViewportWidth = e.viewportWidth), !this.flexViewportWidth)
      return [];
    const i = this.visibleColsService.getCenterCols();
    let o = -1;
    if (e.resizingCols) {
      const g = new Set(e.resizingCols);
      for (let u = i.length - 1; u >= 0; u--)
        if (g.has(i[u])) {
          o = u;
          break;
        }
    }
    let s = 0, r = [], n = 0, a = 0;
    for (let g = 0; g < i.length; g++)
      i[g].getFlex() && g > o ? (r.push(i[g]), a += i[g].getFlex(), n += i[g].getMinWidth()) : s += i[g].getActualWidth();
    if (!r.length)
      return [];
    let l = [];
    s + n > this.flexViewportWidth && (r.forEach((g) => g.setActualWidth(g.getMinWidth(), t)), l = r, r = []);
    const d = [];
    let c;
    e:
      for (; ; ) {
        c = this.flexViewportWidth - s;
        const g = c / a;
        for (let u = 0; u < r.length; u++) {
          const p = r[u], C = g * p.getFlex();
          let y = 0;
          const w = p.getMinWidth(), x = p.getMaxWidth();
          if (C < w ? y = w : C > x && (y = x), y) {
            p.setActualWidth(y, t), ls(r, p), a -= p.getFlex(), l.push(p), s += p.getActualWidth();
            continue e;
          }
          d[u] = Math.round(C);
        }
        break;
      }
    let h = c;
    return r.forEach((g, u) => {
      g.setActualWidth(Math.min(d[u], h), t), l.push(g), h -= d[u];
    }), e.skipSetLeft || this.visibleColsService.setLeftValues(t), e.updateBodyWidths && this.visibleColsService.updateBodyWidths(), e.fireResizedEvent && this.eventDispatcher.columnResized(l, !0, t, r), r;
  }
  sizeColumnsToFit(e, t = "sizeColumnsToFit", i, o) {
    var g;
    if (this.columnModel.isShouldQueueResizeOperations())
      return void this.columnModel.pushResizeOperation(() => this.sizeColumnsToFit(e, t, i, o));
    const s = {};
    o && ((g = o == null ? void 0 : o.columnLimits) == null || g.forEach(({ key: u, ...p }) => {
      s[typeof u == "string" ? u : u.getColId()] = p;
    }));
    const r = this.visibleColsService.getAllCols(), n = e === Se(r);
    if (e <= 0 || !r.length || n)
      return;
    const a = [], l = [];
    r.forEach((u) => {
      u.getColDef().suppressSizeToFit === !0 ? l.push(u) : a.push(u);
    });
    const d = a.slice(0);
    let c = !1;
    const h = (u) => {
      Y(a, u), l.push(u);
    };
    for (a.forEach((u) => {
      u.resetActualWidth(t);
      const p = s == null ? void 0 : s[u.getId()], C = (p == null ? void 0 : p.minWidth) ?? (o == null ? void 0 : o.defaultMinWidth), y = (p == null ? void 0 : p.maxWidth) ?? (o == null ? void 0 : o.defaultMaxWidth), w = u.getActualWidth();
      typeof C == "number" && w < C ? u.setActualWidth(C, t, !0) : typeof y == "number" && w > y && u.setActualWidth(y, t, !0);
    }); !c; ) {
      c = !0;
      const u = e - Se(l);
      if (u <= 0)
        a.forEach((p) => {
          var y;
          const C = ((y = s == null ? void 0 : s[p.getId()]) == null ? void 0 : y.minWidth) ?? (o == null ? void 0 : o.defaultMinWidth);
          typeof C != "number" ? p.setMinimum(t) : p.setActualWidth(C, t, !0);
        });
      else {
        const p = u / Se(a);
        let C = u;
        for (let y = a.length - 1; y >= 0; y--) {
          const w = a[y], x = s == null ? void 0 : s[w.getId()], E = (x == null ? void 0 : x.minWidth) ?? (o == null ? void 0 : o.defaultMinWidth), k = (x == null ? void 0 : x.maxWidth) ?? (o == null ? void 0 : o.defaultMaxWidth), P = w.getMinWidth(), D = w.getMaxWidth(), F = typeof E == "number" && E > P ? E : P, G = typeof k == "number" && k < D ? k : D;
          let N = Math.round(w.getActualWidth() * p);
          N < F ? (N = F, h(w), c = !1) : N > G ? (N = G, h(w), c = !1) : y === 0 && (N = C), w.setActualWidth(N, t, !0), C -= N;
        }
      }
    }
    d.forEach((u) => {
      u.fireColumnWidthChangedEvent(t);
    }), this.visibleColsService.setLeftValues(t), this.visibleColsService.updateBodyWidths(), i || this.eventDispatcher.columnResized(d, !0, t);
  }
  applyAutosizeStrategy() {
    const e = this.gos.get("autoSizeStrategy");
    if (!e)
      return;
    const { type: t } = e;
    setTimeout(() => {
      if (t === "fitGridWidth") {
        const { columnLimits: i, defaultMinWidth: o, defaultMaxWidth: s } = e, r = i == null ? void 0 : i.map(({ colId: n, minWidth: a, maxWidth: l }) => ({ key: n, minWidth: a, maxWidth: l }));
        this.ctrlsService.getGridBodyCtrl().sizeColumnsToFit({ defaultMinWidth: o, defaultMaxWidth: s, columnLimits: r });
      } else
        t === "fitProvidedWidth" && this.sizeColumnsToFit(e.width, "sizeColumnsToFit");
    });
  }
};
function ms(e, t) {
  return e + "_" + t;
}
function V(e) {
  return e instanceof vs;
}
var vs = class extends f {
  constructor(e, t, i, o) {
    super(), this.isColumn = !1, this.displayedChildren = [], this.parent = null, this.groupId = t, this.partId = i, this.providedColumnGroup = e, this.pinned = o;
  }
  reset() {
    this.parent = null, this.children = null, this.displayedChildren = null;
  }
  getParent() {
    return this.parent;
  }
  setParent(e) {
    this.parent = e;
  }
  getUniqueId() {
    return ms(this.groupId, this.partId);
  }
  isEmptyGroup() {
    return this.displayedChildren.length === 0;
  }
  isMoving() {
    const e = this.getProvidedColumnGroup().getLeafColumns();
    return !(!e || e.length === 0) && e.every((t) => t.isMoving());
  }
  checkLeft() {
    if (this.displayedChildren.forEach((e) => {
      V(e) && e.checkLeft();
    }), this.displayedChildren.length > 0)
      if (this.gos.get("enableRtl")) {
        const e = T(this.displayedChildren).getLeft();
        this.setLeft(e);
      } else {
        const e = this.displayedChildren[0].getLeft();
        this.setLeft(e);
      }
    else
      this.setLeft(null);
  }
  getLeft() {
    return this.left;
  }
  getOldLeft() {
    return this.oldLeft;
  }
  setLeft(e) {
    this.oldLeft = this.left, this.left !== e && (this.left = e, this.dispatchLocalEvent({ type: "leftChanged" }));
  }
  getPinned() {
    return this.pinned;
  }
  getGroupId() {
    return this.groupId;
  }
  getPartId() {
    return this.partId;
  }
  getActualWidth() {
    let e = 0;
    return this.displayedChildren && this.displayedChildren.forEach((t) => {
      e += t.getActualWidth();
    }), e;
  }
  isResizable() {
    if (!this.displayedChildren)
      return !1;
    let e = !1;
    return this.displayedChildren.forEach((t) => {
      t.isResizable() && (e = !0);
    }), e;
  }
  getMinWidth() {
    let e = 0;
    return this.displayedChildren.forEach((t) => {
      e += t.getMinWidth();
    }), e;
  }
  addChild(e) {
    this.children || (this.children = []), this.children.push(e);
  }
  getDisplayedChildren() {
    return this.displayedChildren;
  }
  getLeafColumns() {
    const e = [];
    return this.addLeafColumns(e), e;
  }
  getDisplayedLeafColumns() {
    const e = [];
    return this.addDisplayedLeafColumns(e), e;
  }
  getDefinition() {
    return this.providedColumnGroup.getColGroupDef();
  }
  getColGroupDef() {
    return this.providedColumnGroup.getColGroupDef();
  }
  isPadding() {
    return this.providedColumnGroup.isPadding();
  }
  isExpandable() {
    return this.providedColumnGroup.isExpandable();
  }
  isExpanded() {
    return this.providedColumnGroup.isExpanded();
  }
  setExpanded(e) {
    this.providedColumnGroup.setExpanded(e);
  }
  addDisplayedLeafColumns(e) {
    this.displayedChildren.forEach((t) => {
      Le(t) ? e.push(t) : V(t) && t.addDisplayedLeafColumns(e);
    });
  }
  addLeafColumns(e) {
    this.children.forEach((t) => {
      Le(t) ? e.push(t) : V(t) && t.addLeafColumns(e);
    });
  }
  getChildren() {
    return this.children;
  }
  getColumnGroupShow() {
    return this.providedColumnGroup.getColumnGroupShow();
  }
  getProvidedColumnGroup() {
    return this.providedColumnGroup;
  }
  getPaddingLevel() {
    const e = this.getParent();
    return this.isPadding() && e && e.isPadding() ? 1 + e.getPaddingLevel() : 0;
  }
  calculateDisplayedColumns() {
    this.displayedChildren = [];
    let e = this;
    for (; e != null && e.isPadding(); )
      e = e.getParent();
    if (!e || !e.getProvidedColumnGroup().isExpandable())
      return this.displayedChildren = this.children, void this.dispatchLocalEvent({ type: "displayedChildrenChanged" });
    this.children.forEach((t) => {
      if (!V(t) || t.displayedChildren && t.displayedChildren.length)
        switch (t.getColumnGroupShow()) {
          case "open":
            e.getProvidedColumnGroup().isExpanded() && this.displayedChildren.push(t);
            break;
          case "closed":
            e.getProvidedColumnGroup().isExpanded() || this.displayedChildren.push(t);
            break;
          default:
            this.displayedChildren.push(t);
        }
    }), this.dispatchLocalEvent({ type: "displayedChildrenChanged" });
  }
}, fs = class {
  constructor() {
    this.existingIds = {};
  }
  getInstanceIdForKey(e) {
    const t = this.existingIds[e];
    let i;
    return i = typeof t != "number" ? 0 : t + 1, this.existingIds[e] = i, i;
  }
}, vn = class extends f {
  constructor() {
    super(...arguments), this.beanName = "visibleColsService", this.colsAndGroupsMap = {}, this.columnsLeft = [], this.columnsRight = [], this.columnsCenter = [], this.columns = [], this.bodyWidth = 0, this.leftWidth = 0, this.rightWidth = 0, this.bodyWidthDirty = !0;
  }
  wireBeans(e) {
    this.columnModel = e.columnModel, this.columnSizeService = e.columnSizeService, this.columnViewportService = e.columnViewportService, this.eventDispatcher = e.columnEventDispatcher;
  }
  refresh(e, t = !1) {
    t || this.buildTrees(), this.updateOpenClosedVisibilityInColumnGroups(), this.columnsLeft = pi(this.treeLeft), this.columnsCenter = pi(this.treeCenter), this.columnsRight = pi(this.treeRight), this.joinColsAriaOrder(), this.joinCols(), this.setLeftValues(e), this.autoHeightCols = this.columns.filter((i) => i.isAutoHeight()), this.columnSizeService.refreshFlexedColumns(), this.updateBodyWidths(), this.columnViewportService.checkViewportColumns(!1), this.setFirstRightAndLastLeftPinned(e), this.eventDispatcher.visibleCols();
  }
  updateBodyWidths() {
    const e = Se(this.columnsCenter), t = Se(this.columnsLeft), i = Se(this.columnsRight);
    if (this.bodyWidthDirty = this.bodyWidth !== e, this.bodyWidth !== e || this.leftWidth !== t || this.rightWidth !== i) {
      this.bodyWidth = e, this.leftWidth = t, this.rightWidth = i;
      const o = { type: "columnContainerWidthChanged" };
      this.eventService.dispatchEvent(o);
      const s = { type: "displayedColumnsWidthChanged" };
      this.eventService.dispatchEvent(s);
    }
  }
  setLeftValues(e) {
    this.setLeftValuesOfCols(e), this.setLeftValuesOfGroups();
  }
  setFirstRightAndLastLeftPinned(e) {
    let t, i;
    this.gos.get("enableRtl") ? (t = this.columnsLeft ? this.columnsLeft[0] : null, i = this.columnsRight ? T(this.columnsRight) : null) : (t = this.columnsLeft ? T(this.columnsLeft) : null, i = this.columnsRight ? this.columnsRight[0] : null), this.columnModel.getCols().forEach((o) => {
      o.setLastLeftPinned(o === t, e), o.setFirstRightPinned(o === i, e);
    });
  }
  buildTrees() {
    const e = this.columnModel.getColsToShow(), t = e.filter((r) => r.getPinned() == "left"), i = e.filter((r) => r.getPinned() == "right"), o = e.filter((r) => r.getPinned() != "left" && r.getPinned() != "right"), s = new fs();
    this.treeLeft = this.createGroups({ columns: t, idCreator: s, pinned: "left", oldDisplayedGroups: this.treeLeft }), this.treeRight = this.createGroups({ columns: i, idCreator: s, pinned: "right", oldDisplayedGroups: this.treeRight }), this.treeCenter = this.createGroups({ columns: o, idCreator: s, pinned: null, oldDisplayedGroups: this.treeCenter }), this.updateColsAndGroupsMap();
  }
  clear() {
    this.columnsLeft = [], this.columnsRight = [], this.columnsCenter = [], this.columns = [], this.ariaOrderColumns = [];
  }
  joinColsAriaOrder() {
    const e = this.columnModel.getCols(), t = [], i = [], o = [];
    for (const s of e) {
      const r = s.getPinned();
      r ? r === !0 || r === "left" ? t.push(s) : o.push(s) : i.push(s);
    }
    this.ariaOrderColumns = t.concat(i).concat(o);
  }
  getAriaColIndex(e) {
    let t;
    return t = V(e) ? e.getLeafColumns()[0] : e, this.ariaOrderColumns.indexOf(t) + 1;
  }
  getAllAutoHeightCols() {
    return this.autoHeightCols;
  }
  setLeftValuesOfGroups() {
    [this.treeLeft, this.treeRight, this.treeCenter].forEach((e) => {
      e.forEach((t) => {
        V(t) && t.checkLeft();
      });
    });
  }
  setLeftValuesOfCols(e) {
    if (!this.columnModel.getColDefCols())
      return;
    const t = this.columnModel.getCols().slice(0), i = this.gos.get("enableRtl");
    [this.columnsLeft, this.columnsRight, this.columnsCenter].forEach((o) => {
      if (i) {
        let s = Se(o);
        o.forEach((r) => {
          s -= r.getActualWidth(), r.setLeft(s, e);
        });
      } else {
        let s = 0;
        o.forEach((r) => {
          r.setLeft(s, e), s += r.getActualWidth();
        });
      }
      (function(s, r) {
        for (let n = 0; n < r.length; n++)
          ls(s, r[n]);
      })(t, o);
    }), t.forEach((o) => {
      o.setLeft(null, e);
    });
  }
  joinCols() {
    this.gos.get("enableRtl") ? this.columns = this.columnsRight.concat(this.columnsCenter).concat(this.columnsLeft) : this.columns = this.columnsLeft.concat(this.columnsCenter).concat(this.columnsRight);
  }
  getColsCenter() {
    return this.columnsCenter;
  }
  getAllTrees() {
    return this.treeLeft && this.treeRight && this.treeCenter ? this.treeLeft.concat(this.treeCenter).concat(this.treeRight) : null;
  }
  getTreeLeft() {
    return this.treeLeft;
  }
  getTreeRight() {
    return this.treeRight;
  }
  getTreeCenter() {
    return this.treeCenter;
  }
  getAllCols() {
    return this.columns;
  }
  isColDisplayed(e) {
    return this.getAllCols().indexOf(e) >= 0;
  }
  getLeftColsForRow(e) {
    return this.columnModel.isColSpanActive() ? this.getColsForRow(e, this.columnsLeft) : this.columnsLeft;
  }
  getRightColsForRow(e) {
    return this.columnModel.isColSpanActive() ? this.getColsForRow(e, this.columnsRight) : this.columnsRight;
  }
  getColsForRow(e, t, i, o) {
    const s = [];
    let r = null;
    for (let n = 0; n < t.length; n++) {
      const a = t[n], l = t.length - n, d = Math.min(a.getColSpan(e), l), c = [a];
      if (d > 1) {
        const g = d - 1;
        for (let u = 1; u <= g; u++)
          c.push(t[n + u]);
        n += g;
      }
      let h;
      i ? (h = !1, c.forEach((g) => {
        i(g) && (h = !0);
      })) : h = !0, h && (s.length === 0 && r && o && o(a) && s.push(r), s.push(a)), r = a;
    }
    return s;
  }
  getBodyContainerWidth() {
    return this.bodyWidth;
  }
  getContainerWidth(e) {
    switch (e) {
      case "left":
        return this.leftWidth;
      case "right":
        return this.rightWidth;
      default:
        return this.bodyWidth;
    }
  }
  getCenterCols() {
    return this.columnsCenter;
  }
  getLeftCols() {
    return this.columnsLeft;
  }
  getRightCols() {
    return this.columnsRight;
  }
  getColBefore(e) {
    const t = this.getAllCols(), i = t.indexOf(e);
    return i > 0 ? t[i - 1] : null;
  }
  getGroupAtDirection(e, t) {
    const i = e.getProvidedColumnGroup().getLevel() + e.getPaddingLevel(), o = e.getDisplayedLeafColumns(), s = t === "After" ? T(o) : o[0], r = `getCol${t}`;
    for (; ; ) {
      const n = this[r](s);
      if (!n)
        return null;
      const a = this.getColGroupAtLevel(n, i);
      if (a !== e)
        return a;
    }
  }
  getColGroupAtLevel(e, t) {
    let i, o, s = e.getParent();
    for (; i = s.getProvidedColumnGroup().getLevel(), o = s.getPaddingLevel(), !(i + o <= t); )
      s = s.getParent();
    return s;
  }
  isPinningLeft() {
    return this.columnsLeft.length > 0;
  }
  isPinningRight() {
    return this.columnsRight.length > 0;
  }
  updateColsAndGroupsMap() {
    this.colsAndGroupsMap = {};
    const e = (t) => {
      this.colsAndGroupsMap[t.getUniqueId()] = t;
    };
    Ge(this.treeCenter, !1, e), Ge(this.treeLeft, !1, e), Ge(this.treeRight, !1, e);
  }
  isVisible(e) {
    return this.colsAndGroupsMap[e.getUniqueId()] === e;
  }
  updateOpenClosedVisibilityInColumnGroups() {
    Ge(this.getAllTrees(), !1, (e) => {
      V(e) && e.calculateDisplayedColumns();
    });
  }
  getFirstColumn() {
    const e = this.gos.get("enableRtl"), t = ["getLeftCols", "getCenterCols", "getRightCols"];
    e && t.reverse();
    for (let i = 0; i < t.length; i++) {
      const o = this[t[i]]();
      if (o.length)
        return e ? T(o) : o[0];
    }
    return null;
  }
  getColumnGroup(e, t) {
    if (!e)
      return null;
    if (V(e))
      return e;
    const i = this.getAllTrees(), o = typeof t == "number";
    let s = null;
    return Ge(i, !1, (r) => {
      if (V(r)) {
        const n = r;
        let a;
        a = o ? e === n.getGroupId() && t === n.getPartId() : e === n.getGroupId(), a && (s = n);
      }
    }), s;
  }
  getColAfter(e) {
    const t = this.getAllCols(), i = t.indexOf(e);
    return i < t.length - 1 ? t[i + 1] : null;
  }
  isBodyWidthDirty() {
    return this.bodyWidthDirty;
  }
  setBodyWidthDirty() {
    this.bodyWidthDirty = !0;
  }
  getColsLeftWidth() {
    return Se(this.columnsLeft);
  }
  getDisplayedColumnsRightWidth() {
    return Se(this.columnsRight);
  }
  isColAtEdge(e, t) {
    const i = this.getAllCols();
    if (!i.length)
      return !1;
    const o = t === "first";
    let s;
    if (V(e)) {
      const r = e.getDisplayedLeafColumns();
      if (!r.length)
        return !1;
      s = o ? r[0] : T(r);
    } else
      s = e;
    return (o ? i[0] : T(i)) === s;
  }
  createGroups(e) {
    const { columns: t, idCreator: i, pinned: o, oldDisplayedGroups: s, isStandaloneStructure: r } = e, n = this.mapOldGroupsById(s), a = [];
    let l = t;
    for (; l.length; ) {
      const d = l;
      l = [];
      let c = 0;
      const h = (g) => {
        const u = c;
        c = g;
        const p = d[u], C = (V(p) ? p.getProvidedColumnGroup() : p).getOriginalParent();
        if (C == null) {
          for (let w = u; w < g; w++)
            a.push(d[w]);
          return;
        }
        const y = this.createColGroup(C, i, n, o, r);
        for (let w = u; w < g; w++)
          y.addChild(d[w]);
        l.push(y);
      };
      for (let g = 1; g < d.length; g++) {
        const u = d[g], p = (V(u) ? u.getProvidedColumnGroup() : u).getOriginalParent(), C = d[c];
        p !== (V(C) ? C.getProvidedColumnGroup() : C).getOriginalParent() && h(g);
      }
      c < d.length && h(d.length);
    }
    return r || this.setupParentsIntoCols(a, null), a;
  }
  createColGroup(e, t, i, o, s) {
    const r = e.getGroupId(), n = t.getInstanceIdForKey(r);
    let a = i[ms(r, n)];
    return a && a.getProvidedColumnGroup() !== e && (a = null), S(a) ? a.reset() : (a = new vs(e, r, n, o), s || this.createBean(a)), a;
  }
  mapOldGroupsById(e) {
    const t = {}, i = (o) => {
      o.forEach((s) => {
        if (V(s)) {
          const r = s;
          t[s.getUniqueId()] = r, i(r.getChildren());
        }
      });
    };
    return e && i(e), t;
  }
  setupParentsIntoCols(e, t) {
    e.forEach((i) => {
      if (i.setParent(t), V(i)) {
        const o = i;
        this.setupParentsIntoCols(o.getChildren(), o);
      }
    });
  }
};
function Ge(e, t, i) {
  if (e)
    for (let o = 0; o < e.length; o++) {
      const s = e[o];
      V(s) && Ge(t ? s.getDisplayedChildren() : s.getChildren(), t, i), i(s);
    }
}
function pi(e) {
  const t = [];
  return Ge(e, !0, (i) => {
    Le(i) && t.push(i);
  }), t;
}
var Cs = ["columnEverythingChanged", "newColumnsLoaded", "columnPivotModeChanged", "pivotMaxColumnsExceeded", "columnRowGroupChanged", "expandOrCollapseAll", "columnPivotChanged", "gridColumnsChanged", "columnValueChanged", "columnMoved", "columnVisible", "columnPinned", "columnGroupOpened", "columnResized", "displayedColumnsChanged", "virtualColumnsChanged", "columnHeaderMouseOver", "columnHeaderMouseLeave", "columnHeaderClicked", "columnHeaderContextMenu", "asyncTransactionsFlushed", "rowGroupOpened", "rowDataUpdated", "pinnedRowDataChanged", "rangeSelectionChanged", "chartCreated", "chartRangeSelectionChanged", "chartOptionsChanged", "chartDestroyed", "toolPanelVisibleChanged", "toolPanelSizeChanged", "modelUpdated", "cutStart", "cutEnd", "pasteStart", "pasteEnd", "fillStart", "fillEnd", "rangeDeleteStart", "rangeDeleteEnd", "undoStarted", "undoEnded", "redoStarted", "redoEnded", "cellClicked", "cellDoubleClicked", "cellMouseDown", "cellContextMenu", "cellValueChanged", "cellEditRequest", "rowValueChanged", "headerFocused", "cellFocused", "rowSelected", "selectionChanged", "tooltipShow", "tooltipHide", "cellKeyDown", "cellMouseOver", "cellMouseOut", "filterChanged", "filterModified", "filterOpened", "advancedFilterBuilderVisibleChanged", "sortChanged", "virtualRowRemoved", "rowClicked", "rowDoubleClicked", "gridReady", "gridPreDestroyed", "gridSizeChanged", "viewportChanged", "firstDataRendered", "dragStarted", "dragStopped", "rowEditingStarted", "rowEditingStopped", "cellEditingStarted", "cellEditingStopped", "bodyScroll", "bodyScrollEnd", "paginationChanged", "componentStateChanged", "storeRefreshed", "stateUpdated", "columnMenuVisibleChanged", "contextMenuVisibleChanged", "rowDragEnter", "rowDragMove", "rowDragLeave", "rowDragEnd"], fn = [...Cs, "scrollbarWidthChanged", "keyShortcutChangedCellStart", "keyShortcutChangedCellEnd", "pinnedHeightChanged", "cellFocusCleared", "fullWidthRowFocused", "checkboxChanged", "heightScaleChanged", "suppressMovableColumns", "suppressMenuHide", "suppressFieldDotNotation", "columnPanelItemDragStart", "columnPanelItemDragEnd", "bodyHeightChanged", "columnContainerWidthChanged", "displayedColumnsWidthChanged", "scrollVisibilityChanged", "columnHoverChanged", "flashCells", "paginationPixelOffsetChanged", "displayedRowsChanged", "leftPinnedWidthChanged", "rightPinnedWidthChanged", "rowContainerHeightChanged", "headerHeightChanged", "columnHeaderHeightChanged", "gridStylesChanged", "storeUpdated", "filterDestroyed", "rowDataUpdateStarted", "rowCountReady", "advancedFilterEnabledChanged", "dataTypesInferred", "fieldValueChanged", "fieldPickerValueSelected", "richSelectListRowSelected", "sideBarUpdated", "alignedGridScroll", "alignedGridColumn", "gridOptionsChanged", "chartTitleEdit", "recalculateRowBounds", "stickyTopOffsetChanged"], Cn = { enableBrowserTooltips: !0, tooltipTrigger: !0, tooltipMouseTrack: !0, tooltipShowMode: !0, tooltipInteraction: !0, defaultColGroupDef: !0, suppressAutoSize: !0, skipHeaderOnAutoSize: !0, autoSizeStrategy: !0, components: !0, stopEditingWhenCellsLoseFocus: !0, undoRedoCellEditing: !0, undoRedoCellEditingLimit: !0, excelStyles: !0, cacheQuickFilter: !0, advancedFilterModel: !0, customChartThemes: !0, chartThemeOverrides: !0, chartToolPanelsDef: !0, loadingCellRendererSelector: !0, localeText: !0, keepDetailRows: !0, keepDetailRowsCount: !0, detailRowHeight: !0, detailRowAutoHeight: !0, tabIndex: !0, valueCache: !0, valueCacheNeverExpires: !0, enableCellExpressions: !0, suppressTouch: !0, suppressAsyncEvents: !0, suppressBrowserResizeObserver: !0, suppressPropertyNamesCheck: !0, debug: !0, loadingOverlayComponent: !0, suppressLoadingOverlay: !0, noRowsOverlayComponent: !0, paginationPageSizeSelector: !0, paginateChildRows: !0, pivotPanelShow: !0, pivotSuppressAutoColumn: !0, suppressExpandablePivotGroups: !0, aggFuncs: !0, suppressAggFuncInHeader: !0, removePivotHeaderRowWhenSingleValueColumn: !0, allowShowChangeAfterFilter: !0, ensureDomOrder: !0, enableRtl: !0, suppressColumnVirtualisation: !0, suppressMaxRenderedRowRestriction: !0, suppressRowVirtualisation: !0, rowDragText: !0, suppressGroupMaintainValueType: !0, groupLockGroupColumns: !0, rowGroupPanelSuppressSort: !0, suppressGroupRowsSticky: !0, rowModelType: !0, cacheOverflowSize: !0, infiniteInitialRowCount: !0, serverSideInitialRowCount: !0, suppressServerSideInfiniteScroll: !0, maxBlocksInCache: !0, maxConcurrentDatasourceRequests: !0, blockLoadDebounceMillis: !0, serverSideOnlyRefreshFilteredGroups: !0, serverSidePivotResultFieldSeparator: !0, viewportRowModelPageSize: !0, viewportRowModelBufferSize: !0, debounceVerticalScrollbar: !0, suppressAnimationFrame: !0, suppressPreventDefaultOnMouseWheel: !0, scrollbarWidth: !0, icons: !0, suppressRowTransform: !0, gridId: !0, enableGroupEdit: !0, initialState: !0, processUnpinnedColumns: !0, createChartContainer: !0, getLocaleText: !0, getRowId: !0, reactiveCustomComponents: !0, columnMenu: !0 }, U = class {
};
U.STRING_PROPERTIES = ["rowSelection", "overlayLoadingTemplate", "overlayNoRowsTemplate", "gridId", "quickFilterText", "rowModelType", "editType", "domLayout", "clipboardDelimiter", "rowGroupPanelShow", "multiSortKey", "pivotColumnGroupTotals", "pivotRowTotals", "pivotPanelShow", "fillHandleDirection", "groupDisplayType", "treeDataDisplayType", "colResizeDefault", "tooltipTrigger", "serverSidePivotResultFieldSeparator", "columnMenu", "tooltipShowMode", "grandTotalRow"], U.OBJECT_PROPERTIES = ["components", "rowStyle", "context", "autoGroupColumnDef", "localeText", "icons", "datasource", "serverSideDatasource", "viewportDatasource", "groupRowRendererParams", "aggFuncs", "fullWidthCellRendererParams", "defaultColGroupDef", "defaultColDef", "defaultCsvExportParams", "defaultExcelExportParams", "columnTypes", "rowClassRules", "detailCellRendererParams", "loadingCellRendererParams", "loadingOverlayComponentParams", "noRowsOverlayComponentParams", "popupParent", "statusBar", "sideBar", "chartThemeOverrides", "customChartThemes", "chartToolPanelsDef", "dataTypeDefinitions", "advancedFilterModel", "advancedFilterParent", "advancedFilterBuilderParams", "initialState", "autoSizeStrategy"], U.ARRAY_PROPERTIES = ["sortingOrder", "alignedGrids", "rowData", "columnDefs", "excelStyles", "pinnedTopRowData", "pinnedBottomRowData", "chartThemes", "rowClass", "paginationPageSizeSelector"], U.NUMBER_PROPERTIES = ["rowHeight", "detailRowHeight", "rowBuffer", "headerHeight", "groupHeaderHeight", "groupLockGroupColumns", "floatingFiltersHeight", "pivotHeaderHeight", "pivotGroupHeaderHeight", "groupDefaultExpanded", "pivotDefaultExpanded", "viewportRowModelPageSize", "viewportRowModelBufferSize", "autoSizePadding", "maxBlocksInCache", "maxConcurrentDatasourceRequests", "tooltipShowDelay", "tooltipHideDelay", "cacheOverflowSize", "paginationPageSize", "cacheBlockSize", "infiniteInitialRowCount", "serverSideInitialRowCount", "scrollbarWidth", "asyncTransactionWaitMillis", "blockLoadDebounceMillis", "keepDetailRowsCount", "undoRedoCellEditingLimit", "cellFlashDelay", "cellFadeDelay", "cellFlashDuration", "cellFadeDuration", "tabIndex", "pivotMaxGeneratedColumns"], U.BOOLEAN_PROPERTIES = ["suppressMakeColumnVisibleAfterUnGroup", "suppressRowClickSelection", "suppressCellFocus", "suppressHeaderFocus", "suppressHorizontalScroll", "groupSelectsChildren", "alwaysShowHorizontalScroll", "alwaysShowVerticalScroll", "debug", "enableBrowserTooltips", "enableCellExpressions", "groupIncludeTotalFooter", "groupSuppressBlankHeader", "suppressMenuHide", "suppressRowDeselection", "unSortIcon", "suppressMultiSort", "alwaysMultiSort", "singleClickEdit", "suppressLoadingOverlay", "suppressNoRowsOverlay", "suppressAutoSize", "skipHeaderOnAutoSize", "suppressColumnMoveAnimation", "suppressMovableColumns", "suppressFieldDotNotation", "enableRangeSelection", "enableRangeHandle", "enableFillHandle", "suppressClearOnFillReduction", "deltaSort", "suppressTouch", "suppressAsyncEvents", "allowContextMenuWithControlKey", "suppressContextMenu", "enableCellChangeFlash", "suppressDragLeaveHidesColumns", "suppressRowGroupHidesColumns", "suppressMiddleClickScrolls", "suppressPreventDefaultOnMouseWheel", "suppressCopyRowsToClipboard", "copyHeadersToClipboard", "copyGroupHeadersToClipboard", "pivotMode", "suppressAggFuncInHeader", "suppressColumnVirtualisation", "alwaysAggregateAtRootLevel", "suppressFocusAfterRefresh", "functionsReadOnly", "animateRows", "groupSelectsFiltered", "groupRemoveSingleChildren", "groupRemoveLowestSingleChildren", "enableRtl", "suppressClickEdit", "rowDragEntireRow", "rowDragManaged", "suppressRowDrag", "suppressMoveWhenRowDragging", "rowDragMultiRow", "enableGroupEdit", "embedFullWidthRows", "suppressPaginationPanel", "groupHideOpenParents", "groupAllowUnbalanced", "pagination", "paginationAutoPageSize", "suppressScrollOnNewData", "suppressScrollWhenPopupsAreOpen", "purgeClosedRowNodes", "cacheQuickFilter", "includeHiddenColumnsInQuickFilter", "ensureDomOrder", "accentedSort", "suppressChangeDetection", "valueCache", "valueCacheNeverExpires", "aggregateOnlyChangedColumns", "suppressAnimationFrame", "suppressExcelExport", "suppressCsvExport", "includeHiddenColumnsInAdvancedFilter", "suppressMultiRangeSelection", "enterNavigatesVerticallyAfterEdit", "enterNavigatesVertically", "suppressPropertyNamesCheck", "rowMultiSelectWithClick", "suppressRowHoverHighlight", "suppressRowTransform", "suppressClipboardPaste", "suppressLastEmptyLineOnPaste", "enableCharts", "suppressMaintainUnsortedOrder", "enableCellTextSelection", "suppressBrowserResizeObserver", "suppressMaxRenderedRowRestriction", "excludeChildrenWhenTreeDataFiltering", "tooltipMouseTrack", "tooltipInteraction", "keepDetailRows", "paginateChildRows", "preventDefaultOnContextMenu", "undoRedoCellEditing", "allowDragFromColumnsToolPanel", "pivotSuppressAutoColumn", "suppressExpandablePivotGroups", "debounceVerticalScrollbar", "detailRowAutoHeight", "serverSideSortAllLevels", "serverSideEnableClientSideSort", "serverSideOnlyRefreshFilteredGroups", "serverSideSortOnServer", "serverSideFilterOnServer", "suppressAggFilteredOnly", "showOpenedGroup", "suppressClipboardApi", "suppressModelUpdateAfterUpdateTransaction", "stopEditingWhenCellsLoseFocus", "maintainColumnOrder", "groupMaintainOrder", "columnHoverHighlight", "readOnlyEdit", "suppressRowVirtualisation", "enableCellEditingOnBackspace", "resetRowDataOnUpdate", "removePivotHeaderRowWhenSingleValueColumn", "suppressCopySingleCellRanges", "suppressGroupRowsSticky", "suppressCutToClipboard", "suppressServerSideInfiniteScroll", "rowGroupPanelSuppressSort", "allowShowChangeAfterFilter", "enableAdvancedFilter", "masterDetail", "treeData", "suppressGroupMaintainValueType", "reactiveCustomComponents", "applyQuickFilterBeforePivotOrAgg", "suppressServerSideFullWidthLoadingRow", "suppressAdvancedFilterEval", "loading"], U.OTHER_PROPERTIES = ["suppressStickyTotalRow"], U.FUNCTION_PROPERTIES = ["doesExternalFilterPass", "processPivotResultColDef", "processPivotResultColGroupDef", "getBusinessKeyForNode", "isRowSelectable", "rowDragText", "groupRowRenderer", "fullWidthCellRenderer", "loadingCellRenderer", "loadingOverlayComponent", "noRowsOverlayComponent", "detailCellRenderer", "quickFilterParser", "quickFilterMatcher", "getLocaleText", "isExternalFilterPresent", "getRowHeight", "getRowClass", "getRowStyle", "getContextMenuItems", "getMainMenuItems", "processRowPostCreate", "processCellForClipboard", "getGroupRowAgg", "isFullWidthRow", "sendToClipboard", "focusGridInnerElement", "navigateToNextHeader", "tabToNextHeader", "navigateToNextCell", "tabToNextCell", "processCellFromClipboard", "getDocument", "postProcessPopup", "getChildCount", "getDataPath", "isRowMaster", "postSortRows", "processHeaderForClipboard", "processUnpinnedColumns", "processGroupHeaderForClipboard", "paginationNumberFormatter", "processDataFromClipboard", "getServerSideGroupKey", "isServerSideGroup", "createChartContainer", "getChartToolbarItems", "fillOperation", "isApplyServerSideTransaction", "getServerSideGroupLevelParams", "isServerSideGroupOpenByDefault", "isGroupOpenByDefault", "initialGroupOrderComparator", "groupIncludeFooter", "loadingCellRendererSelector", "getRowId", "groupAggFiltering", "chartMenuItems", "groupTotalRow"], U.ALL_PROPERTIES = [...U.ARRAY_PROPERTIES, ...U.OBJECT_PROPERTIES, ...U.STRING_PROPERTIES, ...U.NUMBER_PROPERTIES, ...U.FUNCTION_PROPERTIES, ...U.BOOLEAN_PROPERTIES, ...U.OTHER_PROPERTIES];
var Ft = U, ie = class {
  static getCallbackForEvent(e) {
    return !e || e.length < 2 ? e : "on" + e[0].toUpperCase() + e.substring(1);
  }
};
ie.VUE_OMITTED_PROPERTY = "AG-VUE-OMITTED-PROPERTY", ie.PUBLIC_EVENTS = Cs, ie.EVENT_CALLBACKS = fn.map((e) => ie.getCallbackForEvent(e)), ie.BOOLEAN_PROPERTIES = Ft.BOOLEAN_PROPERTIES, ie.ALL_PROPERTIES = Ft.ALL_PROPERTIES, ie.ALL_PROPERTIES_AND_CALLBACKS = [...ie.ALL_PROPERTIES, ...ie.EVENT_CALLBACKS], ie.ALL_PROPERTIES_AND_CALLBACKS_SET = new Set(ie.ALL_PROPERTIES_AND_CALLBACKS);
var mi, Lt, vi, fi, Ci, wi, Ti, Ii, Ot, ws = ie, wn = class {
  constructor(e) {
    this.cssClassStates = {}, this.getGui = e;
  }
  addCssClass(e) {
    const t = (e || "").split(" ");
    if (t.length > 1)
      t.forEach((i) => this.addCssClass(i));
    else if (this.cssClassStates[e] !== !0 && e.length) {
      const i = this.getGui();
      i && i.classList.add(e), this.cssClassStates[e] = !0;
    }
  }
  removeCssClass(e) {
    const t = (e || "").split(" ");
    if (t.length > 1)
      t.forEach((i) => this.removeCssClass(i));
    else if (this.cssClassStates[e] !== !1 && e.length) {
      const i = this.getGui();
      i && i.classList.remove(e), this.cssClassStates[e] = !1;
    }
  }
  containsCssClass(e) {
    const t = this.getGui();
    return !!t && t.classList.contains(e);
  }
  addOrRemoveCssClass(e, t) {
    if (e) {
      if (e.indexOf(" ") >= 0) {
        const i = (e || "").split(" ");
        if (i.length > 1)
          return void i.forEach((o) => this.addOrRemoveCssClass(o, t));
      }
      if (this.cssClassStates[e] !== t && e.length) {
        const i = this.getGui();
        i && i.classList.toggle(e, t), this.cssClassStates[e] = t;
      }
    }
  }
};
function De(e, t, i) {
  i == null || typeof i == "string" && i == "" ? bs(e, t) : de(e, t, i);
}
function de(e, t, i) {
  e.setAttribute(ys(t), i.toString());
}
function bs(e, t) {
  e.removeAttribute(ys(t));
}
function ys(e) {
  return `aria-${e}`;
}
function X(e, t) {
  t ? e.setAttribute("role", t) : e.removeAttribute("role");
}
function lt(e, t) {
  De(e, "label", t);
}
function Dt(e, t) {
  De(e, "labelledby", t);
}
function Ss(e, t) {
  De(e, "live", t);
}
function _i(e, t) {
  De(e, "hidden", t);
}
function Zt(e, t) {
  de(e, "expanded", t);
}
function Rs(e, t) {
  de(e, "rowindex", t);
}
function xs(e, t) {
  de(e, "colindex", t);
}
function _t(e, t) {
  De(e, "selected", t);
}
function eo(e, t) {
  return t === void 0 ? e("ariaIndeterminate", "indeterminate") : t === !0 ? e("ariaChecked", "checked") : e("ariaUnchecked", "unchecked");
}
function Me() {
  return mi === void 0 && (mi = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)), mi;
}
function Fs() {
  if (Lt === void 0)
    if (Me()) {
      const e = navigator.userAgent.match(/version\/(\d+)/i);
      e && (Lt = e[1] != null ? parseFloat(e[1]) : 0);
    } else
      Lt = 0;
  return Lt;
}
function to() {
  if (vi === void 0) {
    const e = window;
    vi = !!e.chrome && (!!e.chrome.webstore || !!e.chrome.runtime) || /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  }
  return vi;
}
function Ds() {
  return fi === void 0 && (fi = /(firefox)/i.test(navigator.userAgent)), fi;
}
function Ms() {
  return Ci === void 0 && (Ci = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)), Ci;
}
function Oe() {
  return wi === void 0 && (wi = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1), wi;
}
function Li() {
  return !Me() || Fs() >= 15;
}
function Oi(e) {
  if (!e)
    return null;
  const t = e.tabIndex, i = e.getAttribute("tabIndex");
  return t !== -1 || i !== null && (i !== "" || Ds()) ? t.toString() : null;
}
function Es() {
  const e = document.body, t = document.createElement("div");
  t.style.width = t.style.height = "100px", t.style.opacity = "0", t.style.overflow = "scroll", t.style.msOverflowStyle = "scrollbar", t.style.position = "absolute", e.appendChild(t);
  let i = t.offsetWidth - t.clientWidth;
  i === 0 && t.clientWidth === 0 && (i = null), t.parentNode && t.parentNode.removeChild(t), i != null && (Ii = i, Ti = i === 0);
}
function Ps() {
  return Ti == null && Es(), Ti;
}
var ks = "[disabled], .ag-disabled:not(.ag-button), .ag-disabled *";
function io(e) {
  const t = Element.prototype.matches || Element.prototype.msMatchesSelector, i = t.call(e, "input, select, button, textarea"), o = t.call(e, ks), s = he(e);
  return i && !o && s;
}
function H(e, t, i = {}) {
  const { skipAriaHidden: o } = i;
  e.classList.toggle("ag-hidden", !t), o || _i(e, !t);
}
function Mt(e, t) {
  const i = "disabled", o = t ? (s) => s.setAttribute(i, "") : (s) => s.removeAttribute(i);
  o(e), Gs(e.querySelectorAll("input"), (s) => o(s));
}
function rt(e, t, i) {
  let o = 0;
  for (; e; ) {
    if (e.classList.contains(t))
      return !0;
    if (e = e.parentElement, typeof i == "number") {
      if (++o > i)
        break;
    } else if (e === i)
      break;
  }
  return !1;
}
function Ye(e) {
  const { height: t, width: i, borderTopWidth: o, borderRightWidth: s, borderBottomWidth: r, borderLeftWidth: n, paddingTop: a, paddingRight: l, paddingBottom: d, paddingLeft: c, marginTop: h, marginRight: g, marginBottom: u, marginLeft: p, boxSizing: C } = window.getComputedStyle(e);
  return { height: parseFloat(t || "0"), width: parseFloat(i || "0"), borderTopWidth: parseFloat(o || "0"), borderRightWidth: parseFloat(s || "0"), borderBottomWidth: parseFloat(r || "0"), borderLeftWidth: parseFloat(n || "0"), paddingTop: parseFloat(a || "0"), paddingRight: parseFloat(l || "0"), paddingBottom: parseFloat(d || "0"), paddingLeft: parseFloat(c || "0"), marginTop: parseFloat(h || "0"), marginRight: parseFloat(g || "0"), marginBottom: parseFloat(u || "0"), marginLeft: parseFloat(p || "0"), boxSizing: C };
}
function oo(e) {
  const t = Ye(e);
  return t.boxSizing === "border-box" ? t.height - t.paddingTop - t.paddingBottom : t.height;
}
function Pt(e) {
  const t = Ye(e);
  return t.boxSizing === "border-box" ? t.width - t.paddingLeft - t.paddingRight : t.width;
}
function As(e) {
  const { height: t, marginBottom: i, marginTop: o } = Ye(e);
  return Math.floor(t + i + o);
}
function ei(e) {
  const { width: t, marginLeft: i, marginRight: o } = Ye(e);
  return Math.floor(t + i + o);
}
function Ts(e) {
  const t = e.getBoundingClientRect(), { borderTopWidth: i, borderLeftWidth: o, borderRightWidth: s, borderBottomWidth: r } = Ye(e);
  return { top: t.top + (i || 0), left: t.left + (o || 0), right: t.right + (s || 0), bottom: t.bottom + (r || 0) };
}
function ti() {
  if (typeof Ot == "boolean")
    return Ot;
  const e = document.createElement("div");
  return e.style.direction = "rtl", e.style.width = "1px", e.style.height = "1px", e.style.position = "fixed", e.style.top = "0px", e.style.overflow = "hidden", e.dir = "rtl", e.innerHTML = `<div style="width: 2px">
            <span style="display: inline-block; width: 1px"></span>
            <span style="display: inline-block; width: 1px"></span>
        </div>`, document.body.appendChild(e), e.scrollLeft = 1, Ot = Math.floor(e.scrollLeft) === 0, document.body.removeChild(e), Ot;
}
function ii(e, t) {
  let i = e.scrollLeft;
  return t && (i = Math.abs(i), to() && !ti() && (i = e.scrollWidth - e.clientWidth - i)), i;
}
function oi(e, t, i) {
  i && (ti() ? t *= -1 : (Me() || to()) && (t = e.scrollWidth - e.clientWidth - t)), e.scrollLeft = t;
}
function j(e) {
  for (; e && e.firstChild; )
    e.removeChild(e.firstChild);
}
function ve(e) {
  e && e.parentNode && e.parentNode.removeChild(e);
}
function Is(e) {
  return !!e.offsetParent;
}
function he(e) {
  const t = e;
  return t.checkVisibility ? t.checkVisibility({ checkVisibilityCSS: !0 }) : !(!Is(e) || window.getComputedStyle(e).visibility !== "visible");
}
function dt(e) {
  const t = document.createElement("div");
  return t.innerHTML = (e || "").trim(), t.firstChild;
}
function Ls(e, t, i) {
  i && i.nextSibling === t || (i ? i.nextSibling ? e.insertBefore(t, i.nextSibling) : e.appendChild(t) : e.firstChild && e.firstChild !== t && e.insertAdjacentElement("afterbegin", t));
}
function Os(e, t) {
  for (let i = 0; i < t.length; i++) {
    const o = t[i], s = e.children[i];
    s !== o && e.insertBefore(o, s);
  }
}
function Ns(e, t) {
  if (t)
    for (const [i, o] of Object.entries(t)) {
      if (!i || !i.length || o == null)
        continue;
      const s = i.replace(/[A-Z]/g, (l) => `-${l.toLocaleLowerCase()}`), r = o.toString(), n = r.replace(/\s*!important/g, ""), a = n.length != r.length ? "important" : void 0;
      e.style.setProperty(s, n, a);
    }
}
function si(e, t) {
  t === "flex" ? (e.style.removeProperty("width"), e.style.removeProperty("minWidth"), e.style.removeProperty("maxWidth"), e.style.flex = "1 1 auto") : ce(e, t);
}
function ce(e, t) {
  t = so(t), e.style.width = t.toString(), e.style.maxWidth = t.toString(), e.style.minWidth = t.toString();
}
function yt(e, t) {
  t = so(t), e.style.height = t.toString(), e.style.maxHeight = t.toString(), e.style.minHeight = t.toString();
}
function so(e) {
  return typeof e == "number" ? `${e}px` : e;
}
function ro(e) {
  return e instanceof Node || e instanceof HTMLElement;
}
function Re(e, t, i) {
  i == null ? e.removeAttribute(t) : e.setAttribute(t, i.toString());
}
function Gs(e, t) {
  if (e != null)
    for (let i = 0; i < e.length; i++)
      t(e[i]);
}
var ct = class {
  constructor(e = 0, t = 1) {
    this.nextValue = e, this.step = t;
  }
  next() {
    const e = this.nextValue;
    return this.nextValue += this.step, e;
  }
  peek() {
    return this.nextValue;
  }
  skip(e) {
    this.nextValue += e;
  }
}, zs = class Ne extends f {
  constructor(t, i, o, s) {
    super(), this.parentComp = t, this.tooltipShowDelayOverride = i, this.tooltipHideDelayOverride = o, this.shouldDisplayTooltip = s, this.interactionEnabled = !1, this.isInteractingWithTooltip = !1, this.state = 0, this.tooltipInstanceCount = 0, this.tooltipMouseTrack = !1;
  }
  wireBeans(t) {
    this.popupService = t.popupService, this.userComponentFactory = t.userComponentFactory;
  }
  postConstruct() {
    this.gos.get("tooltipInteraction") && (this.interactionEnabled = !0), this.tooltipTrigger = this.getTooltipTrigger(), this.tooltipMouseTrack = this.gos.get("tooltipMouseTrack");
    const t = this.parentComp.getGui();
    this.tooltipTrigger === 0 && this.addManagedListeners(t, { mouseenter: this.onMouseEnter.bind(this), mouseleave: this.onMouseLeave.bind(this) }), this.tooltipTrigger === 1 && this.addManagedListeners(t, { focusin: this.onFocusIn.bind(this), focusout: this.onFocusOut.bind(this) }), this.addManagedListeners(t, { mousemove: this.onMouseMove.bind(this) }), this.interactionEnabled || this.addManagedListeners(t, { mousedown: this.onMouseDown.bind(this), keydown: this.onKeyDown.bind(this) });
  }
  getGridOptionsTooltipDelay(t) {
    const i = this.gos.get(t);
    return i < 0 && b(`${t} should not be lower than 0`), Math.max(200, i);
  }
  getTooltipDelay(t) {
    return t === "show" ? this.tooltipShowDelayOverride ?? this.getGridOptionsTooltipDelay("tooltipShowDelay") : this.tooltipHideDelayOverride ?? this.getGridOptionsTooltipDelay("tooltipHideDelay");
  }
  destroy() {
    this.setToDoNothing(), super.destroy();
  }
  getTooltipTrigger() {
    const t = this.gos.get("tooltipTrigger");
    return t && t !== "hover" ? 1 : 0;
  }
  onMouseEnter(t) {
    this.interactionEnabled && this.interactiveTooltipTimeoutId && (this.unlockService(), this.startHideTimeout()), Oe() || (Ne.isLocked ? this.showTooltipTimeoutId = window.setTimeout(() => {
      this.prepareToShowTooltip(t);
    }, 100) : this.prepareToShowTooltip(t));
  }
  onMouseMove(t) {
    this.lastMouseEvent && (this.lastMouseEvent = t), this.tooltipMouseTrack && this.state === 2 && this.tooltipComp && this.positionTooltip();
  }
  onMouseDown() {
    this.setToDoNothing();
  }
  onMouseLeave() {
    this.interactionEnabled ? this.lockService() : this.setToDoNothing();
  }
  onFocusIn() {
    this.prepareToShowTooltip();
  }
  onFocusOut(t) {
    var r;
    const i = t.relatedTarget, o = this.parentComp.getGui(), s = (r = this.tooltipComp) == null ? void 0 : r.getGui();
    this.isInteractingWithTooltip || o.contains(i) || this.interactionEnabled && (s != null && s.contains(i)) || this.setToDoNothing();
  }
  onKeyDown() {
    this.setToDoNothing();
  }
  prepareToShowTooltip(t) {
    if (this.state != 0 || Ne.isLocked)
      return;
    let i = 0;
    t && (i = this.isLastTooltipHiddenRecently() ? 200 : this.getTooltipDelay("show")), this.lastMouseEvent = t || null, this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), i), this.state = 1;
  }
  isLastTooltipHiddenRecently() {
    return (/* @__PURE__ */ new Date()).getTime() - Ne.lastTooltipHideTime < 1e3;
  }
  setToDoNothing() {
    this.state === 2 && this.hideTooltip(), this.onBodyScrollEventCallback && (this.onBodyScrollEventCallback(), this.onBodyScrollEventCallback = void 0), this.onColumnMovedEventCallback && (this.onColumnMovedEventCallback(), this.onColumnMovedEventCallback = void 0), this.clearTimeouts(), this.state = 0, this.lastMouseEvent = null;
  }
  showTooltip() {
    const t = { ...this.parentComp.getTooltipParams() };
    if (!S(t.value) || this.shouldDisplayTooltip && !this.shouldDisplayTooltip())
      return void this.setToDoNothing();
    this.state = 2, this.tooltipInstanceCount++;
    const i = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount);
    this.userComponentFactory.getTooltipCompDetails(t).newAgStackInstance().then(i);
  }
  hideTooltip(t) {
    if (!t && this.isInteractingWithTooltip)
      return;
    this.tooltipComp && (this.destroyTooltipComp(), Ne.lastTooltipHideTime = (/* @__PURE__ */ new Date()).getTime());
    const i = { type: "tooltipHide", parentGui: this.parentComp.getGui() };
    this.eventService.dispatchEvent(i), t && (this.isInteractingWithTooltip = !1), this.state = 0;
  }
  newTooltipComponentCallback(t, i) {
    if (this.state !== 2 || this.tooltipInstanceCount !== t)
      return void this.destroyBean(i);
    const o = i.getGui();
    this.tooltipComp = i, o.classList.contains("ag-tooltip") || o.classList.add("ag-tooltip-custom"), this.tooltipTrigger === 0 && o.classList.add("ag-tooltip-animate"), this.interactionEnabled && o.classList.add("ag-tooltip-interactive");
    const s = this.localeService.getLocaleTextFunc(), r = this.popupService.addPopup({ eChild: o, ariaLabel: s("ariaLabelTooltip", "Tooltip") });
    if (r && (this.tooltipPopupDestroyFunc = r.hideFunc), this.positionTooltip(), this.tooltipTrigger === 1) {
      const a = this.setToDoNothing.bind(this);
      [this.onBodyScrollEventCallback, this.onColumnMovedEventCallback] = this.addManagedEventListeners({ bodyScroll: a, columnMoved: a });
    }
    this.interactionEnabled && (this.tooltipTrigger === 0 ? [this.tooltipMouseEnterListener, this.tooltipMouseLeaveListener] = this.addManagedElementListeners(o, { mouseenter: this.onTooltipMouseEnter.bind(this), mouseleave: this.onTooltipMouseLeave.bind(this) }) : [this.tooltipFocusInListener, this.tooltipFocusOutListener] = this.addManagedElementListeners(o, { focusin: this.onTooltipFocusIn.bind(this), focusout: this.onTooltipFocusOut.bind(this) }));
    const n = { type: "tooltipShow", tooltipGui: o, parentGui: this.parentComp.getGui() };
    this.eventService.dispatchEvent(n), this.startHideTimeout();
  }
  onTooltipMouseEnter() {
    this.isInteractingWithTooltip = !0, this.unlockService();
  }
  onTooltipMouseLeave() {
    this.isInteractingWithTooltip = !1, this.lockService();
  }
  onTooltipFocusIn() {
    this.isInteractingWithTooltip = !0;
  }
  onTooltipFocusOut(t) {
    var r;
    const i = this.parentComp.getGui(), o = (r = this.tooltipComp) == null ? void 0 : r.getGui(), s = t.relatedTarget;
    o != null && o.contains(s) || (this.isInteractingWithTooltip = !1, i.contains(s) ? this.startHideTimeout() : this.hideTooltip());
  }
  positionTooltip() {
    const t = { type: "tooltip", ePopup: this.tooltipComp.getGui(), nudgeY: 18, skipObserver: this.tooltipMouseTrack };
    this.lastMouseEvent ? this.popupService.positionPopupUnderMouseEvent({ ...t, mouseEvent: this.lastMouseEvent }) : this.popupService.positionPopupByComponent({ ...t, eventSource: this.parentComp.getGui(), position: "under", keepWithinBounds: !0, nudgeY: 5 });
  }
  destroyTooltipComp() {
    this.tooltipComp.getGui().classList.add("ag-tooltip-hiding");
    const t = this.tooltipPopupDestroyFunc, i = this.tooltipComp, o = this.tooltipTrigger === 0 ? 1e3 : 0;
    window.setTimeout(() => {
      t(), this.destroyBean(i);
    }, o), this.clearTooltipListeners(), this.tooltipPopupDestroyFunc = void 0, this.tooltipComp = void 0;
  }
  clearTooltipListeners() {
    [this.tooltipMouseEnterListener, this.tooltipMouseLeaveListener, this.tooltipFocusInListener, this.tooltipFocusOutListener].forEach((t) => {
      t && t();
    }), this.tooltipMouseEnterListener = this.tooltipMouseLeaveListener = this.tooltipFocusInListener = this.tooltipFocusOutListener = null;
  }
  lockService() {
    Ne.isLocked = !0, this.interactiveTooltipTimeoutId = window.setTimeout(() => {
      this.unlockService(), this.setToDoNothing();
    }, 100);
  }
  unlockService() {
    Ne.isLocked = !1, this.clearInteractiveTimeout();
  }
  startHideTimeout() {
    this.clearHideTimeout(), this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.getTooltipDelay("hide"));
  }
  clearShowTimeout() {
    this.showTooltipTimeoutId && (window.clearTimeout(this.showTooltipTimeoutId), this.showTooltipTimeoutId = void 0);
  }
  clearHideTimeout() {
    this.hideTooltipTimeoutId && (window.clearTimeout(this.hideTooltipTimeoutId), this.hideTooltipTimeoutId = void 0);
  }
  clearInteractiveTimeout() {
    this.interactiveTooltipTimeoutId && (window.clearTimeout(this.interactiveTooltipTimeoutId), this.interactiveTooltipTimeoutId = void 0);
  }
  clearTimeouts() {
    this.clearShowTimeout(), this.clearHideTimeout(), this.clearInteractiveTimeout();
  }
};
zs.isLocked = !1;
var bn = zs, gt = class extends f {
  constructor(e, t) {
    super(), this.ctrl = e, t && (this.beans = t);
  }
  wireBeans(e) {
    this.beans = e;
  }
  postConstruct() {
    this.refreshToolTip();
  }
  setBrowserTooltip(e) {
    const t = "title", i = this.ctrl.getGui();
    i && (e != null && e != "" ? i.setAttribute(t, e) : i.removeAttribute(t));
  }
  updateTooltipText() {
    this.tooltip = this.ctrl.getTooltipValue();
  }
  createTooltipFeatureIfNeeded() {
    var t, i, o, s;
    if (this.tooltipManager != null)
      return;
    const e = { getTooltipParams: () => this.getTooltipParams(), getGui: () => this.ctrl.getGui() };
    this.tooltipManager = this.createBean(new bn(e, (i = (t = this.ctrl).getTooltipShowDelayOverride) == null ? void 0 : i.call(t), (s = (o = this.ctrl).getTooltipHideDelayOverride) == null ? void 0 : s.call(o), this.ctrl.shouldDisplayTooltip), this.beans.context);
  }
  refreshToolTip() {
    this.browserTooltips = this.beans.gos.get("enableBrowserTooltips"), this.updateTooltipText(), this.browserTooltips ? (this.setBrowserTooltip(this.tooltip), this.tooltipManager && (this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context))) : (this.setBrowserTooltip(null), this.createTooltipFeatureIfNeeded());
  }
  getTooltipParams() {
    const e = this.ctrl, t = e.getColumn ? e.getColumn() : void 0, i = e.getColDef ? e.getColDef() : void 0, o = e.getRowNode ? e.getRowNode() : void 0;
    return { location: e.getLocation(), colDef: i, column: t, rowIndex: e.getRowIndex ? e.getRowIndex() : void 0, node: o, data: o ? o.data : void 0, value: this.getTooltipText(), valueFormatted: e.getValueFormatted ? e.getValueFormatted() : void 0, hideTooltipCallback: () => {
      var s;
      return (s = this.tooltipManager) == null ? void 0 : s.hideTooltip(!0);
    } };
  }
  getTooltipText() {
    return this.tooltip;
  }
  destroy() {
    this.tooltipManager && (this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context)), super.destroy();
  }
}, yn = new ct(), R = null, O = class Bs extends f {
  constructor(t, i) {
    super(), this.suppressDataRefValidation = !1, this.displayed = !0, this.visible = !0, this.compId = yn.next(), this.cssClassManager = new wn(() => this.eGui), this.componentSelectors = new Map((i ?? []).map((o) => [o.selector, o])), t && this.setTemplate(t);
  }
  preWireBeans(t) {
    super.preWireBeans(t);
  }
  preConstruct() {
    this.usingBrowserTooltips = this.gos.get("enableBrowserTooltips"), this.wireTemplate(this.getGui());
  }
  wireTemplate(t, i) {
    t && this.gos && (this.applyElementsToComponent(t), this.createChildComponentsFromTags(t, i));
  }
  getCompId() {
    return this.compId;
  }
  getTooltipParams() {
    return { value: this.tooltipText, location: "UNKNOWN" };
  }
  setTooltip(t) {
    const { newTooltipText: i, showDelayOverride: o, hideDelayOverride: s, location: r, shouldDisplayTooltip: n } = t || {};
    this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature)), this.tooltipText !== i && (this.tooltipText = i), i != null && (this.tooltipFeature = this.createBean(new gt({ getTooltipValue: () => this.tooltipText, getGui: () => this.getGui(), getLocation: () => r ?? "UNKNOWN", getColDef: t == null ? void 0 : t.getColDef, getColumn: t == null ? void 0 : t.getColumn, getTooltipShowDelayOverride: o != null ? () => o : void 0, getTooltipHideDelayOverride: s != null ? () => s : void 0, shouldDisplayTooltip: n })));
  }
  getDataRefAttribute(t) {
    return t.getAttribute ? t.getAttribute("data-ref") : null;
  }
  applyElementsToComponent(t, i, o, s = null) {
    if (i === void 0 && (i = this.getDataRefAttribute(t)), i) {
      const r = this[i];
      if (r === R)
        this[i] = s ?? t;
      else {
        const n = o && o[i];
        this.suppressDataRefValidation || n || b(`Issue with data-ref: ${i} on ${this.constructor.name} with ${r}`);
      }
    }
  }
  createChildComponentsFromTags(t, i) {
    (function(o) {
      if (o == null)
        return [];
      const s = [];
      return Gs(o, (r) => s.push(r)), s;
    })(t.childNodes).forEach((o) => {
      if (!(o instanceof HTMLElement))
        return;
      const s = this.createComponentFromElement(o, (r) => {
        r.getGui() && this.copyAttributesFromNode(o, r.getGui());
      }, i);
      if (s) {
        if (s.addItems && o.children.length) {
          this.createChildComponentsFromTags(o, i);
          const r = Array.prototype.slice.call(o.children);
          s.addItems(r);
        }
        this.swapComponentForNode(s, t, o);
      } else
        o.childNodes && this.createChildComponentsFromTags(o, i);
    });
  }
  createComponentFromElement(t, i, o) {
    const s = t.nodeName, r = this.getDataRefAttribute(t), n = s.indexOf("AG-") === 0, a = n ? this.componentSelectors.get(s) : null;
    let l = null;
    if (a) {
      Bs.elementGettingCreated = t;
      const d = o && r ? o[r] : void 0;
      l = new a.component(d), l.setParentComponent(this), this.createBean(l, null, i);
    } else
      n && b(`Missing selector: ${s}`);
    return this.applyElementsToComponent(t, r, o, l), l;
  }
  copyAttributesFromNode(t, i) {
    (function(o, s) {
      if (o)
        for (let a = 0; a < o.length; a++) {
          const l = o[a];
          r = l.name, n = l.value, i.setAttribute(r, n);
        }
      var r, n;
    })(t.attributes);
  }
  swapComponentForNode(t, i, o) {
    const s = t.getGui();
    i.replaceChild(s, o), i.insertBefore(document.createComment(o.nodeName), s), this.addDestroyFunc(this.destroyBean.bind(this, t));
  }
  activateTabIndex(t) {
    const i = this.gos.get("tabIndex");
    t || (t = []), t.length || t.push(this.getGui()), t.forEach((o) => o.setAttribute("tabindex", i.toString()));
  }
  setTemplate(t, i, o) {
    const s = dt(t);
    this.setTemplateFromElement(s, i, o);
  }
  setTemplateFromElement(t, i, o, s = !1) {
    if (this.eGui = t, this.suppressDataRefValidation = s, i)
      for (let r = 0; r < i.length; r++) {
        const n = i[r];
        this.componentSelectors.set(n.selector, n);
      }
    this.wireTemplate(t, o);
  }
  getGui() {
    return this.eGui;
  }
  getFocusableElement() {
    return this.eGui;
  }
  getAriaElement() {
    return this.getFocusableElement();
  }
  setParentComponent(t) {
    this.parentComponent = t;
  }
  getParentComponent() {
    return this.parentComponent;
  }
  setGui(t) {
    this.eGui = t;
  }
  queryForHtmlElement(t) {
    return this.eGui.querySelector(t);
  }
  getContainerAndElement(t, i) {
    let o = i;
    return t == null ? null : (o || (o = this.eGui), ro(t) ? { element: t, parent: o } : { element: t.getGui(), parent: o });
  }
  prependChild(t, i) {
    const { element: o, parent: s } = this.getContainerAndElement(t, i) || {};
    o && s && s.insertAdjacentElement("afterbegin", o);
  }
  appendChild(t, i) {
    const { element: o, parent: s } = this.getContainerAndElement(t, i) || {};
    o && s && s.appendChild(o);
  }
  isDisplayed() {
    return this.displayed;
  }
  setVisible(t, i = {}) {
    if (t !== this.visible) {
      this.visible = t;
      const { skipAriaHidden: o } = i;
      (function(s, r, n = {}) {
        const { skipAriaHidden: a } = n;
        s.classList.toggle("ag-invisible", !r), a || _i(s, !r);
      })(this.eGui, t, { skipAriaHidden: o });
    }
  }
  setDisplayed(t, i = {}) {
    if (t !== this.displayed) {
      this.displayed = t;
      const { skipAriaHidden: o } = i;
      H(this.eGui, t, { skipAriaHidden: o });
      const s = { type: "displayChanged", visible: this.displayed };
      this.dispatchLocalEvent(s);
    }
  }
  destroy() {
    this.parentComponent && (this.parentComponent = void 0), this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature)), super.destroy();
  }
  addGuiEventListener(t, i, o) {
    this.eGui.addEventListener(t, i, o), this.addDestroyFunc(() => this.eGui.removeEventListener(t, i));
  }
  addCssClass(t) {
    this.cssClassManager.addCssClass(t);
  }
  removeCssClass(t) {
    this.cssClassManager.removeCssClass(t);
  }
  containsCssClass(t) {
    return this.cssClassManager.containsCssClass(t);
  }
  addOrRemoveCssClass(t, i) {
    this.cssClassManager.addOrRemoveCssClass(t, i);
  }
}, Sn = { columnGroupOpened: "expanded", columnGroupClosed: "contracted", columnSelectClosed: "tree-closed", columnSelectOpen: "tree-open", columnSelectIndeterminate: "tree-indeterminate", columnMovePin: "pin", columnMoveHide: "eye-slash", columnMoveMove: "arrows", columnMoveLeft: "left", columnMoveRight: "right", columnMoveGroup: "group", columnMoveValue: "aggregation", columnMovePivot: "pivot", dropNotAllowed: "not-allowed", groupContracted: "tree-closed", groupExpanded: "tree-open", setFilterGroupClosed: "tree-closed", setFilterGroupOpen: "tree-open", setFilterGroupIndeterminate: "tree-indeterminate", chart: "chart", close: "cross", cancel: "cancel", check: "tick", first: "first", previous: "previous", next: "next", last: "last", linked: "linked", unlinked: "unlinked", colorPicker: "color-picker", groupLoading: "loading", menu: "menu", menuAlt: "menu-alt", filter: "filter", columns: "columns", maximize: "maximize", minimize: "minimize", menuPin: "pin", menuValue: "aggregation", menuAddRowGroup: "group", menuRemoveRowGroup: "group", clipboardCopy: "copy", clipboardCut: "cut", clipboardPaste: "paste", pivotPanel: "pivot", rowGroupPanel: "group", valuePanel: "aggregation", columnDrag: "grip", rowDrag: "grip", save: "save", csvExport: "csv", excelExport: "excel", smallDown: "small-down", smallLeft: "small-left", smallRight: "small-right", smallUp: "small-up", sortAscending: "asc", sortDescending: "desc", sortUnSort: "none", advancedFilterBuilder: "group", advancedFilterBuilderDrag: "grip", advancedFilterBuilderInvalid: "not-allowed", advancedFilterBuilderMoveUp: "up", advancedFilterBuilderMoveDown: "down", advancedFilterBuilderAdd: "plus", advancedFilterBuilderRemove: "minus", chartsMenuEdit: "chart", chartsMenuAdvancedSettings: "settings", chartsMenuAdd: "plus", checkboxChecked: "checkbox-checked", checkboxIndeterminate: "checkbox-indeterminate", checkboxUnchecked: "checkbox-unchecked", radioButtonOn: "radio-button-on", radioButtonOff: "radio-button-off" };
function be(e, t, i) {
  const o = te(e, t, i);
  if (o) {
    const { className: r } = o;
    if (typeof r == "string" && r.indexOf("ag-icon") > -1 || typeof r == "object" && r["ag-icon"])
      return o;
  }
  const s = document.createElement("span");
  return s.appendChild(o), s;
}
function te(e, t, i, o) {
  let s = null;
  const r = i && i.getColDef().icons;
  if (r && (s = r[e]), t && !s) {
    const n = t.get("icons");
    n && (s = n[e]);
  }
  if (!s) {
    const n = document.createElement("span");
    let a = Sn[e];
    return a || (o ? a = e : (b(`Did not find icon ${e}`), a = "")), n.setAttribute("class", `ag-icon ag-icon-${a}`), n.setAttribute("unselectable", "on"), X(n, "presentation"), n;
  }
  {
    let n;
    if (typeof s == "function")
      n = s();
    else {
      if (typeof s != "string")
        throw new Error("icon from grid options needs to be a string or a function");
      n = s;
    }
    if (typeof n == "string")
      return dt(n);
    if (ro(n))
      return n;
    b("iconRenderer should return back a string or a dom object");
  }
}
function Hs(e, t, i) {
  if (i === 0)
    return !1;
  const o = Math.abs(e.clientX - t.clientX), s = Math.abs(e.clientY - t.clientY);
  return Math.max(o, s) <= i;
}
var Te = class {
  constructor(e, t = !1) {
    this.DOUBLE_TAP_MILLIS = 500, this.destroyFuncs = [], this.touching = !1, this.localEventService = new ht(), this.eElement = e, this.preventMouseClick = t;
    const i = this.onTouchStart.bind(this), o = this.onTouchMove.bind(this), s = this.onTouchEnd.bind(this);
    this.eElement.addEventListener("touchstart", i, { passive: !0 }), this.eElement.addEventListener("touchmove", o, { passive: !0 }), this.eElement.addEventListener("touchend", s, { passive: !1 }), this.destroyFuncs.push(() => {
      this.eElement.removeEventListener("touchstart", i, { passive: !0 }), this.eElement.removeEventListener("touchmove", o, { passive: !0 }), this.eElement.removeEventListener("touchend", s, { passive: !1 });
    });
  }
  getActiveTouch(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].identifier === this.touchStart.identifier)
        return e[t];
    return null;
  }
  addEventListener(e, t) {
    this.localEventService.addEventListener(e, t);
  }
  removeEventListener(e, t) {
    this.localEventService.removeEventListener(e, t);
  }
  onTouchStart(e) {
    if (this.touching)
      return;
    this.touchStart = e.touches[0], this.touching = !0, this.moved = !1;
    const t = this.touchStart;
    window.setTimeout(() => {
      const i = this.touchStart === t;
      if (this.touching && i && !this.moved) {
        this.moved = !0;
        const o = { type: "longTap", touchStart: this.touchStart, touchEvent: e };
        this.localEventService.dispatchEvent(o);
      }
    }, 500);
  }
  onTouchMove(e) {
    if (!this.touching)
      return;
    const t = this.getActiveTouch(e.touches);
    t && !Hs(t, this.touchStart, 4) && (this.moved = !0);
  }
  onTouchEnd(e) {
    if (this.touching) {
      if (!this.moved) {
        const t = { type: "tap", touchStart: this.touchStart };
        this.localEventService.dispatchEvent(t), this.checkForDoubleTap();
      }
      this.preventMouseClick && e.cancelable && e.preventDefault(), this.touching = !1;
    }
  }
  checkForDoubleTap() {
    const e = (/* @__PURE__ */ new Date()).getTime();
    if (this.lastTapTime && this.lastTapTime > 0)
      if (e - this.lastTapTime > this.DOUBLE_TAP_MILLIS) {
        const t = { type: "doubleTap", touchStart: this.touchStart };
        this.localEventService.dispatchEvent(t), this.lastTapTime = null;
      } else
        this.lastTapTime = e;
    else
      this.lastTapTime = e;
  }
  destroy() {
    this.destroyFuncs.forEach((e) => e());
  }
}, no = class extends O {
  constructor(e) {
    super(), this.eSortOrder = R, this.eSortAsc = R, this.eSortDesc = R, this.eSortMixed = R, this.eSortNone = R, e || this.setTemplate(`<span class="ag-sort-indicator-container">
        <span data-ref="eSortOrder" class="ag-sort-indicator-icon ag-sort-order ag-hidden" aria-hidden="true"></span>
        <span data-ref="eSortAsc" class="ag-sort-indicator-icon ag-sort-ascending-icon ag-hidden" aria-hidden="true"></span>
        <span data-ref="eSortDesc" class="ag-sort-indicator-icon ag-sort-descending-icon ag-hidden" aria-hidden="true"></span>
        <span data-ref="eSortMixed" class="ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden" aria-hidden="true"></span>
        <span data-ref="eSortNone" class="ag-sort-indicator-icon ag-sort-none-icon ag-hidden" aria-hidden="true"></span>
    </span>`);
  }
  wireBeans(e) {
    this.sortController = e.sortController;
  }
  attachCustomElements(e, t, i, o, s) {
    this.eSortOrder = e, this.eSortAsc = t, this.eSortDesc = i, this.eSortMixed = o, this.eSortNone = s;
  }
  setupSort(e, t = !1) {
    this.column = e, this.suppressOrder = t, this.setupMultiSortIndicator(), (this.column.isSortable() || this.column.getColDef().showRowGroup) && (this.addInIcon("sortAscending", this.eSortAsc, e), this.addInIcon("sortDescending", this.eSortDesc, e), this.addInIcon("sortUnSort", this.eSortNone, e), this.addManagedPropertyListener("unSortIcon", () => this.updateIcons()), this.addManagedEventListeners({ newColumnsLoaded: this.updateIcons.bind(this), sortChanged: this.onSortChanged.bind(this), columnRowGroupChanged: this.onSortChanged.bind(this) }), this.onSortChanged());
  }
  addInIcon(e, t, i) {
    if (t == null)
      return;
    const o = te(e, this.gos, i);
    o && t.appendChild(o);
  }
  onSortChanged() {
    this.updateIcons(), this.suppressOrder || this.updateSortOrder();
  }
  updateIcons() {
    const e = this.sortController.getDisplaySortForColumn(this.column);
    if (this.eSortAsc) {
      const t = e === "asc";
      H(this.eSortAsc, t, { skipAriaHidden: !0 });
    }
    if (this.eSortDesc) {
      const t = e === "desc";
      H(this.eSortDesc, t, { skipAriaHidden: !0 });
    }
    if (this.eSortNone) {
      const t = !this.column.getColDef().unSortIcon && !this.gos.get("unSortIcon"), i = e == null;
      H(this.eSortNone, !t && i, { skipAriaHidden: !0 });
    }
  }
  setupMultiSortIndicator() {
    this.addInIcon("sortUnSort", this.eSortMixed, this.column);
    const e = this.column.getColDef().showRowGroup;
    this.gos.isColumnsSortingCoupledToGroup() && e && (this.addManagedEventListeners({ sortChanged: this.updateMultiSortIndicator.bind(this), columnRowGroupChanged: this.updateMultiSortIndicator.bind(this) }), this.updateMultiSortIndicator());
  }
  updateMultiSortIndicator() {
    if (this.eSortMixed) {
      const e = this.sortController.getDisplaySortForColumn(this.column) === "mixed";
      H(this.eSortMixed, e, { skipAriaHidden: !0 });
    }
  }
  updateSortOrder() {
    if (!this.eSortOrder)
      return;
    const e = this.sortController.getColumnsWithSortingOrdered(), t = this.sortController.getDisplaySortIndexForColumn(this.column) ?? -1, i = e.some((s) => this.sortController.getDisplaySortIndexForColumn(s) ?? !1), o = t >= 0 && i;
    H(this.eSortOrder, o, { skipAriaHidden: !0 }), t >= 0 ? this.eSortOrder.textContent = (t + 1).toString() : j(this.eSortOrder);
  }
}, Rn = { selector: "AG-SORT-INDICATOR", component: no }, Ni = class extends O {
  constructor() {
    super(...arguments), this.eFilter = R, this.eFilterButton = R, this.eSortIndicator = R, this.eMenu = R, this.eLabel = R, this.eText = R, this.eSortOrder = R, this.eSortAsc = R, this.eSortDesc = R, this.eSortMixed = R, this.eSortNone = R, this.lastMovingChanged = 0;
  }
  wireBeans(e) {
    this.sortController = e.sortController, this.menuService = e.menuService, this.funcColsService = e.funcColsService;
  }
  destroy() {
    super.destroy();
  }
  refresh(e) {
    const t = this.params;
    return this.params = e, this.workOutTemplate() == this.currentTemplate && this.workOutShowMenu() == this.currentShowMenu && this.workOutSort() == this.currentSort && this.shouldSuppressMenuHide() == this.currentSuppressMenuHide && t.enableFilterButton == e.enableFilterButton && t.enableFilterIcon == e.enableFilterIcon && (this.setDisplayName(e), !0);
  }
  workOutTemplate() {
    let e = this.params.template ?? `<div class="ag-cell-label-container" role="presentation">
        <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
        <span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button" aria-hidden="true"></span>
        <div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
            <span data-ref="eText" class="ag-header-cell-text"></span>
            <span data-ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
            <ag-sort-indicator data-ref="eSortIndicator"></ag-sort-indicator>
        </div>
    </div>`;
    return e = e && e.trim ? e.trim() : e, e;
  }
  init(e) {
    this.params = e, this.currentTemplate = this.workOutTemplate(), this.setTemplate(this.currentTemplate, [Rn]), this.setupTap(), this.setMenu(), this.setupSort(), this.setupFilterIcon(), this.setupFilterButton(), this.setDisplayName(e);
  }
  setDisplayName(e) {
    if (this.currentDisplayName != e.displayName) {
      this.currentDisplayName = e.displayName;
      const t = fe(this.currentDisplayName, !0);
      this.eText && (this.eText.textContent = t);
    }
  }
  addInIcon(e, t, i) {
    if (t == null)
      return;
    const o = te(e, this.gos, i);
    o && t.appendChild(o);
  }
  setupTap() {
    const { gos: e } = this;
    if (e.get("suppressTouch"))
      return;
    const t = new Te(this.getGui(), !0), i = this.shouldSuppressMenuHide(), o = i && S(this.eMenu), s = o ? new Te(this.eMenu, !0) : t;
    if (this.params.enableMenu) {
      const r = o ? "tap" : "longTap", n = (a) => this.params.showColumnMenuAfterMouseClick(a.touchStart);
      this.addManagedListeners(s, { [r]: n });
    }
    if (this.params.enableSorting) {
      const r = (n) => {
        var l, d;
        const a = n.touchStart.target;
        i && ((l = this.eMenu) != null && l.contains(a) || (d = this.eFilterButton) != null && d.contains(a)) || this.sortController.progressSort(this.params.column, !1, "uiColumnSorted");
      };
      this.addManagedListeners(t, { tap: r });
    }
    if (this.params.enableFilterButton) {
      const r = new Te(this.eFilterButton, !0);
      this.addManagedListeners(r, { tap: () => this.params.showFilter(this.eFilterButton) }), this.addDestroyFunc(() => r.destroy());
    }
    this.addDestroyFunc(() => t.destroy()), o && this.addDestroyFunc(() => s.destroy());
  }
  workOutShowMenu() {
    return this.params.enableMenu && this.menuService.isHeaderMenuButtonEnabled();
  }
  shouldSuppressMenuHide() {
    return this.menuService.isHeaderMenuButtonAlwaysShowEnabled();
  }
  setMenu() {
    if (!this.eMenu)
      return;
    if (this.currentShowMenu = this.workOutShowMenu(), !this.currentShowMenu)
      return ve(this.eMenu), void (this.eMenu = void 0);
    const e = this.menuService.isLegacyMenuEnabled();
    this.addInIcon(e ? "menu" : "menuAlt", this.eMenu, this.params.column), this.eMenu.classList.toggle("ag-header-menu-icon", !e), this.currentSuppressMenuHide = this.shouldSuppressMenuHide(), this.addManagedElementListeners(this.eMenu, { click: () => this.params.showColumnMenu(this.eMenu) }), this.eMenu.classList.toggle("ag-header-menu-always-show", this.currentSuppressMenuHide);
  }
  onMenuKeyboardShortcut(e) {
    const t = this.params.column, i = this.menuService.isLegacyMenuEnabled();
    if (e && !i) {
      if (this.menuService.isFilterMenuInHeaderEnabled(t))
        return this.params.showFilter(this.eFilterButton ?? this.eMenu ?? this.getGui()), !0;
    } else if (this.params.enableMenu)
      return this.params.showColumnMenu(this.eMenu ?? this.eFilterButton ?? this.getGui()), !0;
    return !1;
  }
  workOutSort() {
    return this.params.enableSorting;
  }
  setupSort() {
    if (this.currentSort = this.params.enableSorting, this.eSortIndicator || (this.eSortIndicator = this.createBean(new no(!0)), this.eSortIndicator.attachCustomElements(this.eSortOrder, this.eSortAsc, this.eSortDesc, this.eSortMixed, this.eSortNone)), this.eSortIndicator.setupSort(this.params.column), !this.currentSort)
      return;
    this.addManagedListeners(this.params.column, { movingChanged: () => {
      this.lastMovingChanged = (/* @__PURE__ */ new Date()).getTime();
    } }), this.eLabel && this.addManagedElementListeners(this.eLabel, { click: (t) => {
      const i = this.params.column.isMoving(), o = (/* @__PURE__ */ new Date()).getTime() - this.lastMovingChanged < 50;
      if (!i && !o) {
        const s = this.gos.get("multiSortKey") === "ctrl" ? t.ctrlKey || t.metaKey : t.shiftKey;
        this.params.progressSort(s);
      }
    } });
    const e = () => {
      const t = this.params.column.getSort();
      if (this.addOrRemoveCssClass("ag-header-cell-sorted-asc", t === "asc"), this.addOrRemoveCssClass("ag-header-cell-sorted-desc", t === "desc"), this.addOrRemoveCssClass("ag-header-cell-sorted-none", !t), this.params.column.getColDef().showRowGroup) {
        const i = this.funcColsService.getSourceColumnsForGroupColumn(this.params.column), o = i == null ? void 0 : i.every((r) => this.params.column.getSort() == r.getSort()), s = !o;
        this.addOrRemoveCssClass("ag-header-cell-sorted-mixed", s);
      }
    };
    this.addManagedEventListeners({ sortChanged: e, columnRowGroupChanged: e });
  }
  setupFilterIcon() {
    this.eFilter && this.configureFilter(this.params.enableFilterIcon, this.eFilter, this.onFilterChangedIcon.bind(this));
  }
  setupFilterButton() {
    this.eFilterButton && (this.configureFilter(this.params.enableFilterButton, this.eFilterButton, this.onFilterChangedButton.bind(this)) ? this.addManagedElementListeners(this.eFilterButton, { click: () => this.params.showFilter(this.eFilterButton) }) : this.eFilterButton = void 0);
  }
  configureFilter(e, t, i) {
    if (!e)
      return ve(t), !1;
    const o = this.params.column;
    return this.addInIcon("filter", t, o), this.addManagedListeners(o, { filterChanged: i }), i(), !0;
  }
  onFilterChangedIcon() {
    const e = this.params.column.isFilterActive();
    H(this.eFilter, e, { skipAriaHidden: !0 });
  }
  onFilterChangedButton() {
    const e = this.params.column.isFilterActive();
    this.eFilterButton.classList.toggle("ag-filter-active", e);
  }
  getAnchorElementForMenu(e) {
    return e ? this.eFilterButton ?? this.eMenu ?? this.getGui() : this.eMenu ?? this.eFilterButton ?? this.getGui();
  }
}, xn = class extends O {
  constructor() {
    super(`<div class="ag-header-group-cell-label" role="presentation">
            <span data-ref="agLabel" class="ag-header-group-text" role="presentation"></span>
            <span data-ref="agOpened" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded"></span>
            <span data-ref="agClosed" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed"></span>
        </div>`), this.agOpened = R, this.agClosed = R, this.agLabel = R;
  }
  wireBeans(e) {
    this.columnModel = e.columnModel;
  }
  destroy() {
    super.destroy();
  }
  init(e) {
    this.params = e, this.checkWarnings(), this.setupLabel(), this.addGroupExpandIcon(), this.setupExpandIcons();
  }
  checkWarnings() {
    this.params.template && b("A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)");
  }
  setupExpandIcons() {
    this.addInIcon("columnGroupOpened", this.agOpened), this.addInIcon("columnGroupClosed", this.agClosed);
    const e = (s) => {
      if (Ae(s))
        return;
      const r = !this.params.columnGroup.isExpanded();
      this.columnModel.setColumnGroupOpened(this.params.columnGroup.getProvidedColumnGroup(), r, "uiColumnExpanded");
    };
    this.addTouchAndClickListeners(this.agClosed, e), this.addTouchAndClickListeners(this.agOpened, e);
    const t = (s) => {
      at(s);
    };
    this.addManagedElementListeners(this.agClosed, { dblclick: t }), this.addManagedElementListeners(this.agOpened, { dblclick: t }), this.addManagedElementListeners(this.getGui(), { dblclick: e }), this.updateIconVisibility();
    const i = this.params.columnGroup.getProvidedColumnGroup(), o = this.updateIconVisibility.bind(this);
    this.addManagedListeners(i, { expandedChanged: o, expandableChanged: o });
  }
  addTouchAndClickListeners(e, t) {
    const i = new Te(e, !0);
    this.addManagedListeners(i, { tap: t }), this.addDestroyFunc(() => i.destroy()), this.addManagedElementListeners(e, { click: t });
  }
  updateIconVisibility() {
    if (this.params.columnGroup.isExpandable()) {
      const e = this.params.columnGroup.isExpanded();
      H(this.agOpened, e), H(this.agClosed, !e);
    } else
      H(this.agOpened, !1), H(this.agClosed, !1);
  }
  addInIcon(e, t) {
    const i = te(e, this.gos, null);
    i && t.appendChild(i);
  }
  addGroupExpandIcon() {
    if (!this.params.columnGroup.isExpandable())
      return H(this.agOpened, !1), void H(this.agClosed, !1);
  }
  setupLabel() {
    var i;
    const { displayName: e, columnGroup: t } = this.params;
    if (S(e)) {
      const o = fe(e, !0);
      this.agLabel.textContent = o;
    }
    this.addOrRemoveCssClass("ag-sticky-label", !((i = t.getColGroupDef()) != null && i.suppressStickyLabel));
  }
}, Vs = ((e) => (e.CommunityCoreModule = "@ag-grid-community/core", e.InfiniteRowModelModule = "@ag-grid-community/infinite-row-model", e.ClientSideRowModelModule = "@ag-grid-community/client-side-row-model", e.CsvExportModule = "@ag-grid-community/csv-export", e.EnterpriseCoreModule = "@ag-grid-enterprise/core", e.RowGroupingModule = "@ag-grid-enterprise/row-grouping", e.ColumnsToolPanelModule = "@ag-grid-enterprise/column-tool-panel", e.FiltersToolPanelModule = "@ag-grid-enterprise/filter-tool-panel", e.MenuModule = "@ag-grid-enterprise/menu", e.SetFilterModule = "@ag-grid-enterprise/set-filter", e.MultiFilterModule = "@ag-grid-enterprise/multi-filter", e.StatusBarModule = "@ag-grid-enterprise/status-bar", e.SideBarModule = "@ag-grid-enterprise/side-bar", e.RangeSelectionModule = "@ag-grid-enterprise/range-selection", e.MasterDetailModule = "@ag-grid-enterprise/master-detail", e.RichSelectModule = "@ag-grid-enterprise/rich-select", e.GridChartsModule = "@ag-grid-enterprise/charts", e.ViewportRowModelModule = "@ag-grid-enterprise/viewport-row-model", e.ServerSideRowModelModule = "@ag-grid-enterprise/server-side-row-model", e.ExcelExportModule = "@ag-grid-enterprise/excel-export", e.ClipboardModule = "@ag-grid-enterprise/clipboard", e.SparklinesModule = "@ag-grid-enterprise/sparklines", e.AdvancedFilterModule = "@ag-grid-enterprise/advanced-filter", e.AngularModule = "@ag-grid-community/angular", e.ReactModule = "@ag-grid-community/react", e.VueModule = "@ag-grid-community/vue", e))(Vs || {}), Yt = class z {
  static register(t) {
    z.__register(t, !0, void 0);
  }
  static registerModules(t) {
    z.__registerModules(t, !0, void 0);
  }
  static __register(t, i, o) {
    z.runVersionChecks(t), o !== void 0 ? (z.areGridScopedModules = !0, z.gridModulesMap[o] === void 0 && (z.gridModulesMap[o] = {}), z.gridModulesMap[o][t.moduleName] = t) : z.globalModulesMap[t.moduleName] = t, z.setModuleBased(i);
  }
  static __unRegisterGridModules(t) {
    delete z.gridModulesMap[t];
  }
  static __registerModules(t, i, o) {
    z.setModuleBased(i), t && t.forEach((s) => z.__register(s, i, o));
  }
  static isValidModuleVersion(t) {
    const [i, o] = t.version.split(".") || [], [s, r] = z.currentModuleVersion.split(".") || [];
    return i === s && o === r;
  }
  static runVersionChecks(t) {
    z.currentModuleVersion || (z.currentModuleVersion = t.version);
    const i = (o) => `You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. ${o} Please update all modules to the same version.`;
    if (t.version ? z.isValidModuleVersion(t) || L(i(`'${t.moduleName}' is version ${t.version} but the other modules are version ${z.currentModuleVersion}.`)) : L(i(`'${t.moduleName}' is incompatible.`)), t.validate) {
      const o = t.validate();
      o.isValid || L(`${o.message}`);
    }
  }
  static setModuleBased(t) {
    z.moduleBased === void 0 ? z.moduleBased = t : z.moduleBased !== t && (L("AG Grid: You are mixing modules (i.e. @ag-grid-community/core) and packages (ag-grid-community) - you can only use one or the other of these mechanisms."), L("Please see https://www.ag-grid.com/javascript-grid/modules/ for more information."));
  }
  static __setIsBundled() {
    z.isBundled = !0;
  }
  static __assertRegistered(t, i, o) {
    var r;
    if (this.__isRegistered(t, o))
      return !0;
    let s;
    if (z.isBundled)
      s = `AG Grid: unable to use ${i} as 'ag-grid-enterprise' has not been loaded. Check you are using the Enterprise bundle:
        
        <script src="https://cdn.jsdelivr.net/npm/ag-grid-enterprise@AG_GRID_VERSION/dist/ag-grid-enterprise.min.js"><\/script>
        
For more info see: https://ag-grid.com/javascript-data-grid/getting-started/#getting-started-with-ag-grid-enterprise`;
    else if (z.moduleBased || z.moduleBased === void 0) {
      const n = (r = Object.entries(Vs).find(([a, l]) => l === t)) == null ? void 0 : r[0];
      s = `AG Grid: unable to use ${i} as the ${n} is not registered${z.areGridScopedModules ? ` for gridId: ${o}` : ""}. Check if you have registered the module:
           
    import { ModuleRegistry } from '@ag-grid-community/core';
    import { ${n} } from '${t}';
    
    ModuleRegistry.registerModules([ ${n} ]);

For more info see: https://www.ag-grid.com/javascript-grid/modules/`;
    } else
      s = `AG Grid: unable to use ${i} as package 'ag-grid-enterprise' has not been imported. Check that you have imported the package:
            
    import 'ag-grid-enterprise';`;
    return L(s), !1;
  }
  static __isRegistered(t, i) {
    var o;
    return !!z.globalModulesMap[t] || !!((o = z.gridModulesMap[i]) != null && o[t]);
  }
  static __getRegisteredModules(t) {
    return [...jt(z.globalModulesMap), ...jt(z.gridModulesMap[t] || {})];
  }
  static __getGridRegisteredModules(t) {
    return jt(z.gridModulesMap[t] ?? {}) || [];
  }
  static __isPackageBased() {
    return !z.moduleBased;
  }
};
Yt.globalModulesMap = {}, Yt.gridModulesMap = {}, Yt.areGridScopedModules = !1;
var Q = Yt, Fn = class extends O {
  constructor() {
    super(), this.refreshCount = 0;
    const e = document.createElement("span"), t = document.createElement("span");
    t.setAttribute("class", "ag-value-change-delta");
    const i = document.createElement("span");
    i.setAttribute("class", "ag-value-change-value"), e.appendChild(t), e.appendChild(i), this.setTemplateFromElement(e);
  }
  wireBeans(e) {
    this.filterManager = e.filterManager;
  }
  init(e) {
    this.eValue = this.queryForHtmlElement(".ag-value-change-value"), this.eDelta = this.queryForHtmlElement(".ag-value-change-delta"), this.refresh(e, !0);
  }
  showDelta(e, t) {
    const i = Math.abs(t), o = e.formatValue(i), s = S(o) ? o : i, r = t >= 0;
    this.eDelta.textContent = r ? "↑" + s : "↓" + s, this.eDelta.classList.toggle("ag-value-change-delta-up", r), this.eDelta.classList.toggle("ag-value-change-delta-down", !r);
  }
  setTimerToRemoveDelta() {
    this.refreshCount++;
    const e = this.refreshCount;
    this.getFrameworkOverrides().wrapIncoming(() => {
      window.setTimeout(() => {
        e === this.refreshCount && this.hideDeltaValue();
      }, 2e3);
    });
  }
  hideDeltaValue() {
    this.eValue.classList.remove("ag-value-change-value-highlight"), j(this.eDelta);
  }
  refresh(e, t = !1) {
    var o;
    const i = e.value;
    if (i === this.lastValue || (S(e.valueFormatted) ? this.eValue.textContent = e.valueFormatted : S(e.value) ? this.eValue.textContent = i : j(this.eValue), (o = this.filterManager) == null ? void 0 : o.isSuppressFlashingCellsBecauseFiltering()))
      return !1;
    if (typeof i == "number" && typeof this.lastValue == "number") {
      const s = i - this.lastValue;
      this.showDelta(e, s);
    }
    return this.lastValue && this.eValue.classList.add("ag-value-change-value-highlight"), t || this.setTimerToRemoveDelta(), this.lastValue = i, !0;
  }
}, Dn = class extends O {
  constructor() {
    super(), this.refreshCount = 0;
    const e = document.createElement("span"), t = document.createElement("span");
    t.setAttribute("class", "ag-value-slide-current"), e.appendChild(t), this.setTemplateFromElement(e), this.eCurrent = this.queryForHtmlElement(".ag-value-slide-current");
  }
  wireBeans(e) {
    this.filterManager = e.filterManager;
  }
  init(e) {
    this.refresh(e, !0);
  }
  addSlideAnimation() {
    this.refreshCount++;
    const e = this.refreshCount;
    this.ePrevious && this.getGui().removeChild(this.ePrevious);
    const t = document.createElement("span");
    t.setAttribute("class", "ag-value-slide-previous ag-value-slide-out"), this.ePrevious = t, this.ePrevious.textContent = this.eCurrent.textContent, this.getGui().insertBefore(this.ePrevious, this.eCurrent), this.getFrameworkOverrides().wrapIncoming(() => {
      window.setTimeout(() => {
        e === this.refreshCount && this.ePrevious.classList.add("ag-value-slide-out-end");
      }, 50), window.setTimeout(() => {
        e === this.refreshCount && (this.getGui().removeChild(this.ePrevious), this.ePrevious = null);
      }, 3e3);
    });
  }
  refresh(e, t = !1) {
    var o;
    let i = e.value;
    return A(i) && (i = ""), i !== this.lastValue && !((o = this.filterManager) != null && o.isSuppressFlashingCellsBecauseFiltering()) && (t || this.addSlideAnimation(), this.lastValue = i, S(e.valueFormatted) ? this.eCurrent.textContent = e.valueFormatted : S(e.value) ? this.eCurrent.textContent = i : j(this.eCurrent), !0);
  }
}, v = class {
};
v.BACKSPACE = "Backspace", v.TAB = "Tab", v.ENTER = "Enter", v.ESCAPE = "Escape", v.SPACE = " ", v.LEFT = "ArrowLeft", v.UP = "ArrowUp", v.RIGHT = "ArrowRight", v.DOWN = "ArrowDown", v.DELETE = "Delete", v.F2 = "F2", v.PAGE_UP = "PageUp", v.PAGE_DOWN = "PageDown", v.PAGE_HOME = "Home", v.PAGE_END = "End", v.A = "KeyA", v.C = "KeyC", v.D = "KeyD", v.V = "KeyV", v.X = "KeyX", v.Y = "KeyY", v.Z = "KeyZ";
var Mn = class extends O {
  constructor(e, t, i) {
    super(t, i), this.labelSeparator = "", this.labelAlignment = "left", this.disabled = !1, this.label = "", this.config = e || {};
  }
  postConstruct() {
    this.addCssClass("ag-labeled"), this.eLabel.classList.add("ag-label");
    const { labelSeparator: e, label: t, labelWidth: i, labelAlignment: o, disabled: s } = this.config;
    s != null && this.setDisabled(s), e != null && this.setLabelSeparator(e), t != null && this.setLabel(t), i != null && this.setLabelWidth(i), this.setLabelAlignment(o || this.labelAlignment), this.refreshLabel();
  }
  refreshLabel() {
    j(this.eLabel), typeof this.label == "string" ? this.eLabel.innerText = this.label + this.labelSeparator : this.label && this.eLabel.appendChild(this.label), this.label === "" ? (H(this.eLabel, !1), X(this.eLabel, "presentation")) : (H(this.eLabel, !0), X(this.eLabel, null));
  }
  setLabelSeparator(e) {
    return this.labelSeparator === e || (this.labelSeparator = e, this.label != null && this.refreshLabel()), this;
  }
  getLabelId() {
    return this.eLabel.id = this.eLabel.id || `ag-${this.getCompId()}-label`, this.eLabel.id;
  }
  getLabel() {
    return this.label;
  }
  setLabel(e) {
    return this.label === e || (this.label = e, this.refreshLabel()), this;
  }
  setLabelAlignment(e) {
    const t = this.getGui().classList;
    return t.toggle("ag-label-align-left", e === "left"), t.toggle("ag-label-align-right", e === "right"), t.toggle("ag-label-align-top", e === "top"), this;
  }
  setLabelEllipsis(e) {
    return this.eLabel.classList.toggle("ag-label-ellipsis", e), this;
  }
  setLabelWidth(e) {
    return this.label == null || si(this.eLabel, e), this;
  }
  setDisabled(e) {
    e = !!e;
    const t = this.getGui();
    return Mt(t, e), t.classList.toggle("ag-disabled", e), this.disabled = e, this;
  }
  isDisabled() {
    return !!this.disabled;
  }
}, Ws = class extends Mn {
  constructor(e, t, i, o) {
    super(e, t, i), this.className = o;
  }
  postConstruct() {
    super.postConstruct();
    const { width: e, value: t, onValueChange: i } = this.config;
    e != null && this.setWidth(e), t != null && this.setValue(t), i != null && this.onValueChange(i), this.className && this.addCssClass(this.className), this.refreshAriaLabelledBy();
  }
  setLabel(e) {
    return super.setLabel(e), this.refreshAriaLabelledBy(), this;
  }
  refreshAriaLabelledBy() {
    const e = this.getAriaElement(), t = this.getLabelId(), i = this.getLabel();
    i == null || i == "" || e.getAttribute("aria-label") !== null ? Dt(e, "") : Dt(e, t ?? "");
  }
  setAriaLabel(e) {
    return lt(this.getAriaElement(), e), this.refreshAriaLabelledBy(), this;
  }
  onValueChange(e) {
    return this.addManagedListeners(this, { fieldValueChanged: () => e(this.getValue()) }), this;
  }
  getWidth() {
    return this.getGui().clientWidth;
  }
  setWidth(e) {
    return ce(this.getGui(), e), this;
  }
  getPreviousValue() {
    return this.previousValue;
  }
  getValue() {
    return this.value;
  }
  setValue(e, t) {
    return this.value === e || (this.previousValue = this.value, this.value = e, t || this.dispatchLocalEvent({ type: "fieldValueChanged" })), this;
  }
}, ze = class extends Ws {
  constructor(e, t, i = "text", o = "input") {
    super(e, (e == null ? void 0 : e.template) ?? `
            <div role="presentation">
                <div data-ref="eLabel" class="ag-input-field-label"></div>
                <div data-ref="eWrapper" class="ag-wrapper ag-input-wrapper" role="presentation">
                    <${o} data-ref="eInput" class="ag-input-field-input"></${o}>
                </div>
            </div>`, [], t), this.inputType = i, this.displayFieldTag = o, this.eLabel = R, this.eWrapper = R, this.eInput = R;
  }
  postConstruct() {
    super.postConstruct(), this.setInputType(), this.eLabel.classList.add(`${this.className}-label`), this.eWrapper.classList.add(`${this.className}-input-wrapper`), this.eInput.classList.add(`${this.className}-input`), this.addCssClass("ag-input-field"), this.eInput.id = this.eInput.id || `ag-${this.getCompId()}-input`;
    const { inputName: e, inputWidth: t } = this.config;
    e != null && this.setInputName(e), t != null && this.setInputWidth(t), this.addInputListeners(), this.activateTabIndex([this.eInput]);
  }
  addInputListeners() {
    this.addManagedElementListeners(this.eInput, { input: (e) => this.setValue(e.target.value) });
  }
  setInputType() {
    this.displayFieldTag === "input" && this.eInput.setAttribute("type", this.inputType);
  }
  getInputElement() {
    return this.eInput;
  }
  setInputWidth(e) {
    return si(this.eWrapper, e), this;
  }
  setInputName(e) {
    return this.getInputElement().setAttribute("name", e), this;
  }
  getFocusableElement() {
    return this.eInput;
  }
  setMaxLength(e) {
    return this.eInput.maxLength = e, this;
  }
  setInputPlaceholder(e) {
    return Re(this.eInput, "placeholder", e), this;
  }
  setInputAriaLabel(e) {
    return lt(this.eInput, e), this.refreshAriaLabelledBy(), this;
  }
  setDisabled(e) {
    return Mt(this.eInput, e), super.setDisabled(e);
  }
  setAutoComplete(e) {
    if (e === !0)
      Re(this.eInput, "autocomplete", null);
    else {
      const t = typeof e == "string" ? e : "off";
      Re(this.eInput, "autocomplete", t);
    }
    return this;
  }
}, ao = class extends ze {
  constructor(e, t = "ag-checkbox", i = "checkbox") {
    super(e, t, i), this.labelAlignment = "right", this.selected = !1, this.readOnly = !1, this.passive = !1;
  }
  postConstruct() {
    super.postConstruct();
    const { readOnly: e, passive: t } = this.config;
    typeof e == "boolean" && this.setReadOnly(e), typeof t == "boolean" && this.setPassive(t);
  }
  addInputListeners() {
    this.addManagedElementListeners(this.eInput, { click: this.onCheckboxClick.bind(this) }), this.addManagedElementListeners(this.eLabel, { click: this.toggle.bind(this) });
  }
  getNextValue() {
    return this.selected === void 0 || !this.selected;
  }
  setPassive(e) {
    this.passive = e;
  }
  isReadOnly() {
    return this.readOnly;
  }
  setReadOnly(e) {
    this.eWrapper.classList.toggle("ag-disabled", e), this.eInput.disabled = e, this.readOnly = e;
  }
  setDisabled(e) {
    return this.eWrapper.classList.toggle("ag-disabled", e), super.setDisabled(e);
  }
  toggle() {
    if (this.eInput.disabled)
      return;
    const e = this.isSelected(), t = this.getNextValue();
    this.passive ? this.dispatchChange(t, e) : this.setValue(t);
  }
  getValue() {
    return this.isSelected();
  }
  setValue(e, t) {
    return this.refreshSelectedClass(e), this.setSelected(e, t), this;
  }
  setName(e) {
    return this.getInputElement().name = e, this;
  }
  isSelected() {
    return this.selected;
  }
  setSelected(e, t) {
    this.isSelected() !== e && (this.previousValue = this.isSelected(), e = this.selected = typeof e == "boolean" ? e : void 0, this.eInput.checked = e, this.eInput.indeterminate = e === void 0, t || this.dispatchChange(this.selected, this.previousValue));
  }
  dispatchChange(e, t, i) {
    this.dispatchLocalEvent({ type: "fieldValueChanged", selected: e, previousValue: t, event: i });
    const o = this.getInputElement(), s = { type: "checkboxChanged", id: o.id, name: o.name, selected: e, previousValue: t };
    this.eventService.dispatchEvent(s);
  }
  onCheckboxClick(e) {
    if (this.passive || this.eInput.disabled)
      return;
    const t = this.isSelected(), i = this.selected = e.target.checked;
    this.refreshSelectedClass(i), this.dispatchChange(i, t, e);
  }
  refreshSelectedClass(e) {
    this.eWrapper.classList.toggle("ag-checked", e === !0), this.eWrapper.classList.toggle("ag-indeterminate", e == null);
  }
}, lo = { selector: "AG-CHECKBOX", component: ao }, En = class extends O {
  constructor() {
    super(`
            <div class="ag-cell-wrapper ag-checkbox-cell" role="presentation">
                <ag-checkbox role="presentation" data-ref="eCheckbox"></ag-checkbox>
            </div>`, [lo]), this.eCheckbox = R;
  }
  init(e) {
    this.params = e, this.updateCheckbox(e);
    const t = this.eCheckbox.getInputElement();
    t.setAttribute("tabindex", "-1"), Ss(t, "polite"), this.addManagedListeners(t, { click: (i) => {
      if (at(i), this.eCheckbox.isDisabled())
        return;
      const o = this.eCheckbox.getValue();
      this.onCheckboxChanged(o);
    }, dblclick: (i) => {
      at(i);
    } }), this.addManagedElementListeners(this.params.eGridCell, { keydown: (i) => {
      if (i.key === v.SPACE && !this.eCheckbox.isDisabled()) {
        this.params.eGridCell === this.gos.getActiveDomElement() && this.eCheckbox.toggle();
        const o = this.eCheckbox.getValue();
        this.onCheckboxChanged(o), i.preventDefault();
      }
    } });
  }
  refresh(e) {
    return this.params = e, this.updateCheckbox(e), !0;
  }
  updateCheckbox(e) {
    var a;
    let t, i = !0;
    if (e.node.group && e.column) {
      const l = e.column.getColId();
      l.startsWith(Et) ? t = e.value == null || e.value === "" ? void 0 : e.value === "true" : e.node.aggData && e.node.aggData[l] !== void 0 ? t = e.value ?? void 0 : i = !1;
    } else
      t = e.value ?? void 0;
    if (!i)
      return void this.eCheckbox.setDisplayed(!1);
    this.eCheckbox.setValue(t);
    const o = e.disabled != null ? e.disabled : !((a = e.column) != null && a.isCellEditable(e.node));
    this.eCheckbox.setDisabled(o);
    const s = this.localeService.getLocaleTextFunc(), r = eo(s, t), n = o ? r : `${s("ariaToggleCellValue", "Press SPACE to toggle cell value")} (${r})`;
    this.eCheckbox.setInputAriaLabel(n);
  }
  onCheckboxChanged(e) {
    const { column: t, node: i, value: o } = this.params, s = { type: "cellEditingStarted", column: t, colDef: t == null ? void 0 : t.getColDef(), data: i.data, node: i, rowIndex: i.rowIndex, rowPinned: i.rowPinned, value: o };
    this.eventService.dispatchEvent(s);
    const r = this.params.node.setDataValue(this.params.column, e, "edit"), n = { type: "cellEditingStopped", column: t, colDef: t == null ? void 0 : t.getColDef(), data: i.data, node: i, rowIndex: i.rowIndex, rowPinned: i.rowPinned, value: o, oldValue: o, newValue: e, valueChanged: r };
    this.eventService.dispatchEvent(n);
  }
}, Pn = class extends O {
  constructor() {
    super(`<div class="ag-loading">
            <span class="ag-loading-icon" data-ref="eLoadingIcon"></span>
            <span class="ag-loading-text" data-ref="eLoadingText"></span>
        </div>`), this.eLoadingIcon = R, this.eLoadingText = R;
  }
  init(e) {
    e.node.failedLoad ? this.setupFailed() : this.setupLoading();
  }
  setupFailed() {
    const e = this.localeService.getLocaleTextFunc();
    this.eLoadingText.innerText = e("loadingError", "ERR");
  }
  setupLoading() {
    const e = te("groupLoading", this.gos, null);
    e && this.eLoadingIcon.appendChild(e);
    const t = this.localeService.getLocaleTextFunc();
    this.eLoadingText.innerText = t("loadingOoo", "Loading");
  }
  refresh(e) {
    return !1;
  }
  destroy() {
    super.destroy();
  }
}, kn = class extends O {
  constructor() {
    super('<div class="ag-skeleton-container"></div>');
  }
  init(e) {
    const t = `ag-cell-skeleton-renderer-${this.getCompId()}`;
    this.getGui().setAttribute("id", t), this.addDestroyFunc(() => Dt(e.eParentOfValue)), Dt(e.eParentOfValue, t), e.node.failedLoad ? this.setupFailed() : this.setupLoading(e);
  }
  setupFailed() {
    const e = this.localeService.getLocaleTextFunc();
    this.getGui().innerText = e("loadingError", "ERR");
    const t = e("ariaSkeletonCellLoadingFailed", "Row failed to load");
    lt(this.getGui(), t);
  }
  setupLoading(e) {
    const t = this.gos.getDocument().createElement("div");
    t.classList.add("ag-skeleton-effect");
    const i = e.node.rowIndex;
    if (i != null) {
      const s = 75 + 25 * (i % 2 == 0 ? Math.sin(i) : Math.cos(i));
      t.style.width = `${s}%`;
    }
    this.getGui().appendChild(t);
    const o = this.localeService.getLocaleTextFunc()("ariaSkeletonCellLoading", "Row data is loading");
    lt(this.getGui(), o);
  }
  refresh(e) {
    return !1;
  }
  destroy() {
    super.destroy();
  }
}, Us = class extends O {
  constructor() {
    super();
  }
  destroy() {
    super.destroy();
  }
}, An = class extends Us {
  init() {
    const e = this.gos.get("overlayLoadingTemplate");
    if (this.setTemplate(e ?? '<span aria-live="polite" aria-atomic="true" class="ag-overlay-loading-center"></span>'), !e) {
      const t = this.localeService.getLocaleTextFunc();
      setTimeout(() => {
        this.getGui().textContent = t("loadingOoo", "Loading...");
      });
    }
  }
}, Tn = class extends Us {
  init() {
    const e = this.gos.get("overlayNoRowsTemplate");
    if (this.setTemplate(e ?? '<span class="ag-overlay-no-rows-center"></span>'), !e) {
      const t = this.localeService.getLocaleTextFunc();
      setTimeout(() => {
        this.getGui().textContent = t("noRowsToShow", "No Rows To Show");
      });
    }
  }
}, nt = class extends O {
  isPopup() {
    return !0;
  }
  setParentComponent(e) {
    e.addCssClass("ag-has-popup"), super.setParentComponent(e);
  }
  destroy() {
    const e = this.parentComponent;
    e && e.isAlive() && e.getGui().classList.remove("ag-has-popup"), super.destroy();
  }
}, In = class extends nt {
  constructor() {
    super('<div class="ag-tooltip"></div>');
  }
  init(e) {
    const { value: t } = e;
    this.getGui().textContent = fe(t, !0);
  }
};
function js(e, t, i, o) {
  let s = t.map((a, l) => ({ value: a, relevance: Ln(e.toLowerCase(), a.toLocaleLowerCase()), idx: l }));
  if (s.sort((a, l) => l.relevance - a.relevance), i && (s = s.filter((a) => a.relevance !== 0)), s.length > 0 && o && o > 0) {
    const a = s[0].relevance * o;
    s = s.filter((l) => a - l.relevance < 0);
  }
  const r = [], n = [];
  for (const a of s)
    r.push(a.value), n.push(a.idx);
  return { values: r, indices: n };
}
function Ln(e, t) {
  const i = e.replace(/\s/g, ""), o = t.replace(/\s/g, "");
  let s = 0, r = -1;
  for (let n = 0; n < i.length; n++) {
    const a = o.indexOf(i[n], r + 1);
    a !== -1 && (r = a, s += 100 - 100 * r / 1e4 * 100);
  }
  return s;
}
var On = class extends f {
  constructor() {
    super(...arguments), this.beanName = "userComponentRegistry", this.agGridDefaults = { agColumnHeader: Ni, agColumnGroupHeader: xn, agSortIndicator: no, agAnimateShowChangeCellRenderer: Fn, agAnimateSlideCellRenderer: Dn, agLoadingCellRenderer: Pn, agSkeletonCellRenderer: kn, agCheckboxCellRenderer: En, agLoadingOverlay: An, agNoRowsOverlay: Tn, agTooltipComponent: In }, this.enterpriseAgDefaultCompsModule = { agSetColumnFilter: "@ag-grid-enterprise/set-filter", agSetColumnFloatingFilter: "@ag-grid-enterprise/set-filter", agMultiColumnFilter: "@ag-grid-enterprise/multi-filter", agMultiColumnFloatingFilter: "@ag-grid-enterprise/multi-filter", agGroupColumnFilter: "@ag-grid-enterprise/row-grouping", agGroupColumnFloatingFilter: "@ag-grid-enterprise/row-grouping", agGroupCellRenderer: "@ag-grid-enterprise/row-grouping", agGroupRowRenderer: "@ag-grid-enterprise/row-grouping", agRichSelect: "@ag-grid-enterprise/rich-select", agRichSelectCellEditor: "@ag-grid-enterprise/rich-select", agDetailCellRenderer: "@ag-grid-enterprise/master-detail", agSparklineCellRenderer: "@ag-grid-enterprise/sparklines" }, this.jsComps = {};
  }
  postConstruct() {
    const e = this.gos.get("components");
    e != null && le(e, (t, i) => this.registerJsComponent(t, i));
  }
  registerDefaultComponent(e, t) {
    this.agGridDefaults[e] = t;
  }
  registerJsComponent(e, t) {
    this.jsComps[e] = t;
  }
  retrieve(e, t) {
    const i = (a, l) => ({ componentFromFramework: l, component: a }), o = this.getFrameworkOverrides().frameworkComponent(t, this.gos.get("components"));
    if (o != null)
      return i(o, !0);
    const s = this.jsComps[t];
    if (s)
      return i(s, this.getFrameworkOverrides().isFrameworkComponent(s));
    const r = this.agGridDefaults[t];
    if (r)
      return i(r, !1);
    const n = this.enterpriseAgDefaultCompsModule[t];
    return n ? Q.__assertRegistered(n, `AG Grid '${e}' component: ${t}`, this.gridId) : Ji(() => {
      this.warnAboutMissingComponent(e, t);
    }, "MissingComp" + t), null;
  }
  warnAboutMissingComponent(e, t) {
    const i = js(t, [...Object.keys(this.agGridDefaults).filter((o) => !["agCellEditor", "agGroupRowRenderer", "agSortIndicator"].includes(o)), ...Object.keys(this.jsComps)], !0, 0.8).values;
    b(`Could not find '${t}' component. It was configured as "${e}: '${t}'" but it wasn't found in the list of registered components.`), i.length > 0 && b(`         Did you mean: [${i.slice(0, 3)}]?`), b(`If using a custom component check it has been registered as described in: ${this.getFrameworkOverrides().getDocLink("components/")}`);
  }
}, ee = class ft {
  constructor(t) {
    this.status = 0, this.resolution = null, this.waiters = [], t((i) => this.onDone(i), (i) => this.onReject(i));
  }
  static all(t) {
    return t.length ? new ft((i) => {
      let o = t.length;
      const s = new Array(o);
      t.forEach((r, n) => {
        r.then((a) => {
          s[n] = a, o--, o === 0 && i(s);
        });
      });
    }) : ft.resolve();
  }
  static resolve(t = null) {
    return new ft((i) => i(t));
  }
  then(t) {
    return new ft((i) => {
      this.status === 1 ? i(t(this.resolution)) : this.waiters.push((o) => i(t(o)));
    });
  }
  onDone(t) {
    this.status = 1, this.resolution = t, this.waiters.forEach((i) => i(t));
  }
  onReject(t) {
  }
}, Nn = { propertyName: "dateComponent", cellRenderer: !1 }, Gn = { propertyName: "headerComponent", cellRenderer: !1 }, zn = { propertyName: "headerGroupComponent", cellRenderer: !1 }, Lo = { propertyName: "cellRenderer", cellRenderer: !0 }, Bn = { propertyName: "cellRenderer", cellRenderer: !1 }, Hn = { propertyName: "loadingCellRenderer", cellRenderer: !0 }, Vn = { propertyName: "cellEditor", cellRenderer: !1 }, Oo = { propertyName: "innerRenderer", cellRenderer: !0 }, Wn = { propertyName: "loadingOverlayComponent", cellRenderer: !1 }, Un = { propertyName: "noRowsOverlayComponent", cellRenderer: !1 }, jn = { propertyName: "tooltipComponent", cellRenderer: !1 }, Gi = { propertyName: "filter", cellRenderer: !1 }, Kn = { propertyName: "floatingFilterComponent", cellRenderer: !1 }, Qn = { propertyName: "toolPanel", cellRenderer: !1 }, Yn = { propertyName: "statusPanel", cellRenderer: !1 }, qn = { propertyName: "fullWidthCellRenderer", cellRenderer: !0 }, $n = { propertyName: "loadingCellRenderer", cellRenderer: !0 }, Jn = { propertyName: "groupRowRenderer", cellRenderer: !0 }, Xn = { propertyName: "detailCellRenderer", cellRenderer: !0 }, Zn = { propertyName: "menuItem", cellRenderer: !1 }, Ks = class Qs extends f {
  constructor() {
    super(...arguments), this.beanName = "userComponentFactory";
  }
  wireBeans(t) {
    this.agComponentUtils = t.agComponentUtils, this.componentMetadataProvider = t.componentMetadataProvider, this.userComponentRegistry = t.userComponentRegistry, this.frameworkComponentWrapper = t.frameworkComponentWrapper, this.gridOptions = t.gridOptions;
  }
  getHeaderCompDetails(t, i) {
    return this.getCompDetails(t, Gn, "agColumnHeader", i);
  }
  getHeaderGroupCompDetails(t) {
    const i = t.columnGroup.getColGroupDef();
    return this.getCompDetails(i, zn, "agColumnGroupHeader", t);
  }
  getFullWidthCellRendererDetails(t) {
    return this.getCompDetails(this.gridOptions, qn, null, t, !0);
  }
  getFullWidthLoadingCellRendererDetails(t) {
    return this.getCompDetails(this.gridOptions, $n, "agLoadingCellRenderer", t, !0);
  }
  getFullWidthGroupCellRendererDetails(t) {
    return this.getCompDetails(this.gridOptions, Jn, "agGroupRowRenderer", t, !0);
  }
  getFullWidthDetailCellRendererDetails(t) {
    return this.getCompDetails(this.gridOptions, Xn, "agDetailCellRenderer", t, !0);
  }
  getInnerRendererDetails(t, i) {
    return this.getCompDetails(t, Oo, null, i);
  }
  getFullWidthGroupRowInnerCellRenderer(t, i) {
    return this.getCompDetails(t, Oo, null, i);
  }
  getCellRendererDetails(t, i) {
    return this.getCompDetails(t, Lo, null, i);
  }
  getEditorRendererDetails(t, i) {
    return this.getCompDetails(t, Bn, null, i);
  }
  getLoadingCellRendererDetails(t, i) {
    return this.getCompDetails(t, Hn, "agSkeletonCellRenderer", i, !0);
  }
  getCellEditorDetails(t, i) {
    return this.getCompDetails(t, Vn, "agCellEditor", i, !0);
  }
  getFilterDetails(t, i, o) {
    return this.getCompDetails(t, Gi, o, i, !0);
  }
  getDateCompDetails(t) {
    return this.getCompDetails(this.gridOptions, Nn, "agDateInput", t, !0);
  }
  getLoadingOverlayCompDetails(t) {
    return this.getCompDetails(this.gridOptions, Wn, "agLoadingOverlay", t, !0);
  }
  getNoRowsOverlayCompDetails(t) {
    return this.getCompDetails(this.gridOptions, Un, "agNoRowsOverlay", t, !0);
  }
  getTooltipCompDetails(t) {
    return this.getCompDetails(t.colDef, jn, "agTooltipComponent", t, !0);
  }
  getSetFilterCellRendererDetails(t, i) {
    return this.getCompDetails(t, Lo, null, i);
  }
  getFloatingFilterCompDetails(t, i, o) {
    return this.getCompDetails(t, Kn, o, i);
  }
  getToolPanelCompDetails(t, i) {
    return this.getCompDetails(t, Qn, null, i, !0);
  }
  getStatusPanelCompDetails(t, i) {
    return this.getCompDetails(t, Yn, null, i, !0);
  }
  getMenuItemCompDetails(t, i) {
    return this.getCompDetails(t, Zn, "agMenuItem", i, !0);
  }
  getCompDetails(t, i, o, s, r = !1) {
    const { propertyName: n, cellRenderer: a } = i;
    let { compName: l, jsComp: d, fwComp: c, paramsFromSelector: h, popupFromSelector: g, popupPositionFromSelector: u } = Qs.getCompKeys(this.frameworkOverrides, t, i, s);
    const p = (x) => {
      const E = this.userComponentRegistry.retrieve(n, x);
      E && (d = E.componentFromFramework ? void 0 : E.component, c = E.componentFromFramework ? E.component : void 0);
    };
    if (l != null && p(l), d == null && c == null && o != null && p(o), d && a && !this.agComponentUtils.doesImplementIComponent(d) && (d = this.agComponentUtils.adaptFunction(n, d)), !d && !c)
      return void (r && L(`Could not find component ${l}, did you forget to configure this component?`));
    const C = this.mergeParamsWithApplicationProvidedParams(t, i, s, h), y = d == null, w = d || c;
    return { componentFromFramework: y, componentClass: w, params: C, type: i, popupFromSelector: g, popupPositionFromSelector: u, newAgStackInstance: () => this.newAgStackInstance(w, y, C, i) };
  }
  static getCompKeys(t, i, o, s) {
    const { propertyName: r } = o;
    let n, a, l, d, c, h;
    if (i) {
      const g = i, u = g[r + "Selector"], p = u ? u(s) : null, C = (y) => {
        typeof y == "string" ? n = y : y != null && y !== !0 && (t.isFrameworkComponent(y) ? l = y : a = y);
      };
      p ? (C(p.component), d = p.params, c = p.popup, h = p.popupPosition) : C(g[r]);
    }
    return { compName: n, jsComp: a, fwComp: l, paramsFromSelector: d, popupFromSelector: c, popupPositionFromSelector: h };
  }
  newAgStackInstance(t, i, o, s) {
    const r = s.propertyName;
    let n;
    if (i) {
      const l = this.componentMetadataProvider.retrieve(r);
      n = this.frameworkComponentWrapper.wrap(t, l.mandatoryMethodList, l.optionalMethodList, s);
    } else
      n = new t();
    const a = this.initComponent(n, o);
    return a == null ? ee.resolve(n) : a.then(() => n);
  }
  mergeParamsWithApplicationProvidedParams(t, i, o, s = null) {
    const r = this.gos.getGridCommonParams();
    oe(r, o);
    const n = t && t[i.propertyName + "Params"];
    return typeof n == "function" ? oe(r, n(o)) : typeof n == "object" && oe(r, n), oe(r, s), r;
  }
  initComponent(t, i) {
    if (this.createBean(t), t.init != null)
      return t.init(i);
  }
};
function St(e) {
  const t = e;
  return t != null && t.getFrameworkComponentInstance != null ? t.getFrameworkComponentInstance() : e;
}
var _n = class {
  constructor(e) {
    this.beans = {}, this.createdBeans = [], this.destroyed = !1, e && e.beanClasses && (this.beanDestroyComparator = e.beanDestroyComparator, this.init(e));
  }
  init(e) {
    var t;
    Object.entries(e.providedBeanInstances).forEach(([i, o]) => {
      this.beans[i] = o;
    }), e.beanClasses.forEach((i) => {
      const o = new i();
      o.beanName ? this.beans[o.beanName] = o : console.error(`Bean ${i.name} is missing beanName`), this.createdBeans.push(o);
    }), (t = e.derivedBeans) == null || t.forEach((i) => {
      const { beanName: o, bean: s } = i(this);
      this.beans[o] = s, this.createdBeans.push(s);
    }), e.beanInitComparator && this.createdBeans.sort(e.beanInitComparator), this.initBeans(this.createdBeans);
  }
  getBeanInstances() {
    return Object.values(this.beans);
  }
  createBean(e, t) {
    if (!e)
      throw Error("Can't wire to bean since it is null");
    return this.initBeans([e], t), e;
  }
  initBeans(e, t) {
    e.forEach((i) => {
      var o, s;
      (o = i.preWireBeans) == null || o.call(i, this.beans), (s = i.wireBeans) == null || s.call(i, this.beans);
    }), e.forEach((i) => {
      var o;
      return (o = i.preConstruct) == null ? void 0 : o.call(i);
    }), t && e.forEach(t), e.forEach((i) => {
      var o;
      return (o = i.postConstruct) == null ? void 0 : o.call(i);
    });
  }
  getBeans() {
    return this.beans;
  }
  getBean(e) {
    return this.beans[e];
  }
  destroy() {
    if (this.destroyed)
      return;
    this.destroyed = !0;
    const e = this.getBeanInstances();
    this.beanDestroyComparator && e.sort(this.beanDestroyComparator), this.destroyBeans(e), this.beans = {}, this.createdBeans = [];
  }
  destroyBean(e) {
    var t;
    (t = e == null ? void 0 : e.destroy) == null || t.call(e);
  }
  destroyBeans(e) {
    if (e)
      for (let t = 0; t < e.length; t++)
        this.destroyBean(e[t]);
    return [];
  }
  isDestroyed() {
    return this.destroyed;
  }
}, ea = class extends _n {
  init(e) {
    this.gridId = e.gridId, this.beans.context = this, super.init(e);
  }
  destroy() {
    super.destroy(), Q.__unRegisterGridModules(this.gridId);
  }
  getGridId() {
    return this.gridId;
  }
}, Ys = ((e) => (e[e.Left = 0] = "Left", e[e.Right = 1] = "Right", e))(Ys || {}), ta = class extends f {
  constructor() {
    super(...arguments), this.beanName = "dragAndDropService", this.dragSourceAndParamsList = [], this.dropTargets = [];
  }
  wireBeans(e) {
    this.dragService = e.dragService, this.mouseEventService = e.mouseEventService, this.environment = e.environment;
  }
  postConstruct() {
    this.dropIconMap = { pinned: be("columnMovePin", this.gos, null), hide: be("columnMoveHide", this.gos, null), move: be("columnMoveMove", this.gos, null), left: be("columnMoveLeft", this.gos, null), right: be("columnMoveRight", this.gos, null), group: be("columnMoveGroup", this.gos, null), aggregate: be("columnMoveValue", this.gos, null), pivot: be("columnMovePivot", this.gos, null), notAllowed: be("dropNotAllowed", this.gos, null) };
  }
  addDragSource(e, t = !1) {
    const i = { eElement: e.eElement, dragStartPixels: e.dragStartPixels, onDragStart: this.onDragStart.bind(this, e), onDragStop: this.onDragStop.bind(this), onDragging: this.onDragging.bind(this), includeTouch: t };
    this.dragSourceAndParamsList.push({ params: i, dragSource: e }), this.dragService.addDragSource(i);
  }
  removeDragSource(e) {
    const t = this.dragSourceAndParamsList.find((i) => i.dragSource === e);
    t && (this.dragService.removeDragSource(t.params), Y(this.dragSourceAndParamsList, t));
  }
  destroy() {
    this.dragSourceAndParamsList.forEach((e) => this.dragService.removeDragSource(e.params)), this.dragSourceAndParamsList.length = 0, this.dropTargets.length = 0, super.destroy();
  }
  nudge() {
    this.dragging && this.onDragging(this.eventLastTime, !0);
  }
  onDragStart(e, t) {
    this.dragging = !0, this.dragSource = e, this.eventLastTime = t, this.dragItem = this.dragSource.getDragItem(), this.dragSource.onDragStarted && this.dragSource.onDragStarted(), this.createGhost();
  }
  onDragStop(e) {
    if (this.eventLastTime = null, this.dragging = !1, this.dragSource.onDragStopped && this.dragSource.onDragStopped(), this.lastDropTarget && this.lastDropTarget.onDragStop) {
      const t = this.createDropTargetEvent(this.lastDropTarget, e, null, null, !1);
      this.lastDropTarget.onDragStop(t);
    }
    this.lastDropTarget = void 0, this.dragItem = null, this.removeGhost();
  }
  onDragging(e, t) {
    var n, a, l, d;
    const i = this.getHorizontalDirection(e), o = this.getVerticalDirection(e);
    this.eventLastTime = e, this.positionGhost(e);
    const s = this.dropTargets.filter((c) => this.isMouseOnDropTarget(e, c)), r = this.findCurrentDropTarget(e, s);
    if (r !== this.lastDropTarget)
      this.leaveLastTargetIfExists(e, i, o, t), this.lastDropTarget !== null && r === null && ((a = (n = this.dragSource).onGridExit) == null || a.call(n, this.dragItem)), this.lastDropTarget === null && r !== null && ((d = (l = this.dragSource).onGridEnter) == null || d.call(l, this.dragItem)), this.enterDragTargetIfExists(r, e, i, o, t), this.lastDropTarget = r;
    else if (r && r.onDragging) {
      const c = this.createDropTargetEvent(r, e, i, o, t);
      r.onDragging(c);
    }
  }
  getAllContainersFromDropTarget(e) {
    const t = e.getSecondaryContainers ? e.getSecondaryContainers() : null, i = [[e.getContainer()]];
    return t ? i.concat(t) : i;
  }
  allContainersIntersect(e, t) {
    for (const i of t) {
      const o = i.getBoundingClientRect();
      if (o.width === 0 || o.height === 0)
        return !1;
      const s = e.clientX >= o.left && e.clientX < o.right, r = e.clientY >= o.top && e.clientY < o.bottom;
      if (!s || !r)
        return !1;
    }
    return !0;
  }
  isMouseOnDropTarget(e, t) {
    const i = this.getAllContainersFromDropTarget(t);
    let o = !1;
    for (const s of i)
      if (this.allContainersIntersect(e, s)) {
        o = !0;
        break;
      }
    return !(t.targetContainsSource && !t.getContainer().contains(this.dragSource.eElement)) && o && t.isInterestedIn(this.dragSource.type, this.dragSource.eElement);
  }
  findCurrentDropTarget(e, t) {
    const i = t.length;
    if (i === 0)
      return null;
    if (i === 1)
      return t[0];
    const o = this.gos.getRootNode().elementsFromPoint(e.clientX, e.clientY);
    for (const r of o)
      for (const n of t)
        if ((s = this.getAllContainersFromDropTarget(n), [].concat.apply([], s)).indexOf(r) !== -1)
          return n;
    var s;
    return null;
  }
  enterDragTargetIfExists(e, t, i, o, s) {
    if (e) {
      if (e.onDragEnter) {
        const r = this.createDropTargetEvent(e, t, i, o, s);
        e.onDragEnter(r);
      }
      this.setGhostIcon(e.getIconName ? e.getIconName() : null);
    }
  }
  leaveLastTargetIfExists(e, t, i, o) {
    if (this.lastDropTarget) {
      if (this.lastDropTarget.onDragLeave) {
        const s = this.createDropTargetEvent(this.lastDropTarget, e, t, i, o);
        this.lastDropTarget.onDragLeave(s);
      }
      this.setGhostIcon(null);
    }
  }
  addDropTarget(e) {
    this.dropTargets.push(e);
  }
  removeDropTarget(e) {
    this.dropTargets = this.dropTargets.filter((t) => t.getContainer() !== e.getContainer());
  }
  hasExternalDropZones() {
    return this.dropTargets.some((e) => e.external);
  }
  findExternalZone(e) {
    return this.dropTargets.filter((t) => t.external).find((t) => t.getContainer() === e.getContainer()) || null;
  }
  getHorizontalDirection(e) {
    const t = this.eventLastTime && this.eventLastTime.clientX, i = e.clientX;
    return t === i ? null : t > i ? 0 : 1;
  }
  getVerticalDirection(e) {
    const t = this.eventLastTime && this.eventLastTime.clientY, i = e.clientY;
    return t === i ? null : t > i ? 0 : 1;
  }
  createDropTargetEvent(e, t, i, o, s) {
    const r = e.getContainer(), n = r.getBoundingClientRect(), { dragItem: a, dragSource: l } = this, d = t.clientX - n.left, c = t.clientY - n.top;
    return this.gos.addGridCommonParams({ event: t, x: d, y: c, vDirection: o, hDirection: i, dragSource: l, fromNudge: s, dragItem: a, dropZoneTarget: r });
  }
  positionGhost(e) {
    var p, C, y, w;
    const t = this.eGhost;
    if (!t)
      return;
    const i = t.getBoundingClientRect().height, o = (((p = document.body) == null ? void 0 : p.clientWidth) ?? (window.innerHeight || ((C = document.documentElement) == null ? void 0 : C.clientWidth) || -1)) - 2, s = (((y = document.body) == null ? void 0 : y.clientHeight) ?? (window.innerHeight || ((w = document.documentElement) == null ? void 0 : w.clientHeight) || -1)) - 2, r = Ts(t.offsetParent), { clientY: n, clientX: a } = e;
    let l = n - r.top - i / 2, d = a - r.left - 10;
    const c = this.gos.getDocument(), h = c.defaultView || window, g = h.pageYOffset || c.documentElement.scrollTop, u = h.pageXOffset || c.documentElement.scrollLeft;
    o > 0 && d + t.clientWidth > o + u && (d = o + u - t.clientWidth), d < 0 && (d = 0), s > 0 && l + t.clientHeight > s + g && (l = s + g - t.clientHeight), l < 0 && (l = 0), t.style.left = `${d}px`, t.style.top = `${l}px`;
  }
  removeGhost() {
    this.eGhost && this.eGhostParent && this.eGhostParent.removeChild(this.eGhost), this.eGhost = null;
  }
  createGhost() {
    this.eGhost = dt(`<div class="ag-dnd-ghost ag-unselectable">
<span class="ag-dnd-ghost-icon ag-shake-left-to-right"></span>
<div class="ag-dnd-ghost-label"></div>
</div>`), this.mouseEventService.stampTopLevelGridCompWithGridInstance(this.eGhost), this.environment.applyThemeClasses(this.eGhost), this.eGhostIcon = this.eGhost.querySelector(".ag-dnd-ghost-icon"), this.setGhostIcon(null);
    const e = this.eGhost.querySelector(".ag-dnd-ghost-label");
    let t = this.dragSource.dragItemName;
    Xi(t) && (t = t()), e.innerHTML = fe(t) || "", this.eGhost.style.height = "25px", this.eGhost.style.top = "20px", this.eGhost.style.left = "20px";
    const i = this.gos.getDocument();
    let o = null, s = null;
    try {
      o = i.fullscreenElement;
    } catch {
    } finally {
      o || (o = this.gos.getRootNode()), s = o.querySelector("body") || (o instanceof ShadowRoot ? o : o instanceof Document ? o == null ? void 0 : o.documentElement : o);
    }
    this.eGhostParent = s, this.eGhostParent ? this.eGhostParent.appendChild(this.eGhost) : b("Could not find document body, it is needed for dragging columns");
  }
  setGhostIcon(e, t = !1) {
    j(this.eGhostIcon);
    let i = null;
    e || (e = this.dragSource.getDefaultIconName ? this.dragSource.getDefaultIconName() : "notAllowed"), i = this.dropIconMap[e], this.eGhostIcon.classList.toggle("ag-shake-left-to-right", t), i === this.dropIconMap.hide && this.gos.get("suppressDragLeaveHidesColumns") || i && this.eGhostIcon.appendChild(i);
  }
}, ia = class {
  constructor(e) {
    this.tickingInterval = null, this.onScrollCallback = null, this.scrollContainer = e.scrollContainer, this.scrollHorizontally = e.scrollAxis.indexOf("x") !== -1, this.scrollVertically = e.scrollAxis.indexOf("y") !== -1, this.scrollByTick = e.scrollByTick != null ? e.scrollByTick : 20, e.onScrollCallback && (this.onScrollCallback = e.onScrollCallback), this.scrollVertically && (this.getVerticalPosition = e.getVerticalPosition, this.setVerticalPosition = e.setVerticalPosition), this.scrollHorizontally && (this.getHorizontalPosition = e.getHorizontalPosition, this.setHorizontalPosition = e.setHorizontalPosition), this.shouldSkipVerticalScroll = e.shouldSkipVerticalScroll || (() => !1), this.shouldSkipHorizontalScroll = e.shouldSkipHorizontalScroll || (() => !1);
  }
  check(e, t = !1) {
    const i = t || this.shouldSkipVerticalScroll();
    if (i && this.shouldSkipHorizontalScroll())
      return;
    const o = this.scrollContainer.getBoundingClientRect(), s = this.scrollByTick;
    this.tickLeft = e.clientX < o.left + s, this.tickRight = e.clientX > o.right - s, this.tickUp = e.clientY < o.top + s && !i, this.tickDown = e.clientY > o.bottom - s && !i, this.tickLeft || this.tickRight || this.tickUp || this.tickDown ? this.ensureTickingStarted() : this.ensureCleared();
  }
  ensureTickingStarted() {
    this.tickingInterval === null && (this.tickingInterval = window.setInterval(this.doTick.bind(this), 100), this.tickCount = 0);
  }
  doTick() {
    this.tickCount++;
    const e = this.tickCount > 20 ? 200 : this.tickCount > 10 ? 80 : 40;
    if (this.scrollVertically) {
      const t = this.getVerticalPosition();
      this.tickUp && this.setVerticalPosition(t - e), this.tickDown && this.setVerticalPosition(t + e);
    }
    if (this.scrollHorizontally) {
      const t = this.getHorizontalPosition();
      this.tickLeft && this.setHorizontalPosition(t - e), this.tickRight && this.setHorizontalPosition(t + e);
    }
    this.onScrollCallback && this.onScrollCallback();
  }
  ensureCleared() {
    this.tickingInterval && (window.clearInterval(this.tickingInterval), this.tickingInterval = null);
  }
}, oa = class extends f {
  wireBeans(e) {
    this.dragAndDropService = e.dragAndDropService, this.rowModel = e.rowModel, this.pageBoundsService = e.pageBoundsService, this.focusService = e.focusService, this.sortController = e.sortController, this.filterManager = e.filterManager, this.selectionService = e.selectionService, this.mouseEventService = e.mouseEventService, this.ctrlsService = e.ctrlsService, this.funcColsService = e.funcColsService, this.rangeService = e.rangeService;
  }
  constructor(e) {
    super(), this.eContainer = e;
  }
  postConstruct() {
    this.gos.isRowModelType("clientSide") && (this.clientSideRowModel = this.rowModel), this.ctrlsService.whenReady((e) => {
      const t = e.gridBodyCtrl;
      this.autoScrollService = new ia({ scrollContainer: t.getBodyViewportElement(), scrollAxis: "y", getVerticalPosition: () => t.getScrollFeature().getVScrollPosition().top, setVerticalPosition: (i) => t.getScrollFeature().setVerticalScrollPosition(i), onScrollCallback: () => {
        this.onDragging(this.lastDraggingEvent);
      } });
    });
  }
  getContainer() {
    return this.eContainer;
  }
  isInterestedIn(e) {
    return e === 2;
  }
  getIconName() {
    return this.gos.get("rowDragManaged") && this.shouldPreventRowMove() ? "notAllowed" : "move";
  }
  shouldPreventRowMove() {
    var t;
    return this.funcColsService.getRowGroupColumns().length ? !0 : !!((t = this.filterManager) == null ? void 0 : t.isAnyFilterPresent()) || !!this.sortController.isSortActive();
  }
  getRowNodes(e) {
    if (!this.isFromThisGrid(e))
      return e.dragItem.rowNodes || [];
    const t = e.dragItem.rowNode;
    if (this.gos.get("rowDragMultiRow")) {
      const i = [...this.selectionService.getSelectedNodes()].sort((o, s) => o.rowIndex == null || s.rowIndex == null ? 0 : this.getRowIndexNumber(o) - this.getRowIndexNumber(s));
      if (i.indexOf(t) !== -1)
        return i;
    }
    return [t];
  }
  onDragEnter(e) {
    e.dragItem.rowNodes = this.getRowNodes(e), this.dispatchGridEvent("rowDragEnter", e), this.getRowNodes(e).forEach((t) => {
      t.setDragging(!0);
    }), this.onEnterOrDragging(e);
  }
  onDragging(e) {
    this.onEnterOrDragging(e);
  }
  isFromThisGrid(e) {
    const { dragSourceDomDataKey: t } = e.dragSource;
    return t === this.gos.getDomDataKey();
  }
  isDropZoneWithinThisGrid(e) {
    const t = this.ctrlsService.getGridBodyCtrl().getGui(), { dropZoneTarget: i } = e;
    return !t.contains(i);
  }
  onEnterOrDragging(e) {
    this.dispatchGridEvent("rowDragMove", e), this.lastDraggingEvent = e;
    const t = this.mouseEventService.getNormalisedPosition(e).y;
    this.gos.get("rowDragManaged") && this.doManagedDrag(e, t), this.autoScrollService.check(e.event);
  }
  doManagedDrag(e, t) {
    const i = this.isFromThisGrid(e), o = this.gos.get("rowDragManaged"), s = e.dragItem.rowNodes;
    o && this.shouldPreventRowMove() || (this.gos.get("suppressMoveWhenRowDragging") || !i ? this.isDropZoneWithinThisGrid(e) || this.clientSideRowModel.highlightRowAtPixel(s[0], t) : this.moveRows(s, t));
  }
  getRowIndexNumber(e) {
    const t = e.getRowIndexString();
    return parseInt(T(t.split("-")), 10);
  }
  moveRowAndClearHighlight(e) {
    const t = this.clientSideRowModel.getLastHighlightedRowNode(), i = t && t.highlighted === 1, o = this.mouseEventService.getNormalisedPosition(e).y, s = e.dragItem.rowNodes;
    let r = i ? 1 : 0;
    if (this.isFromThisGrid(e))
      s.forEach((n) => {
        n.rowTop < o && (r -= 1);
      }), this.moveRows(s, o, r);
    else {
      const n = this.gos.getRowIdCallback();
      let a = this.clientSideRowModel.getRowIndexAtPixel(o) + 1;
      this.clientSideRowModel.getHighlightPosition(o) === 0 && a--, this.clientSideRowModel.updateRowData({ add: s.filter((l) => !this.clientSideRowModel.getRowNode((n == null ? void 0 : n({ data: l.data, level: 0, rowPinned: l.rowPinned })) ?? l.data.id)).map((l) => l.data), addIndex: a });
    }
    this.clearRowHighlight();
  }
  clearRowHighlight() {
    this.clientSideRowModel.highlightRowAtPixel(null);
  }
  moveRows(e, t, i = 0) {
    var o;
    this.clientSideRowModel.ensureRowsAtPixel(e, t, i) && (this.focusService.clearFocusedCell(), (o = this.rangeService) == null || o.removeAllCellRanges());
  }
  addRowDropZone(e) {
    if (!e.getContainer())
      return void b("addRowDropZone - A container target needs to be provided");
    if (this.dragAndDropService.findExternalZone(e))
      return void b("addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.");
    let t = { getContainer: e.getContainer };
    e.fromGrid ? t = e : (e.onDragEnter && (t.onDragEnter = (i) => {
      e.onDragEnter(this.draggingToRowDragEvent("rowDragEnter", i));
    }), e.onDragLeave && (t.onDragLeave = (i) => {
      e.onDragLeave(this.draggingToRowDragEvent("rowDragLeave", i));
    }), e.onDragging && (t.onDragging = (i) => {
      e.onDragging(this.draggingToRowDragEvent("rowDragMove", i));
    }), e.onDragStop && (t.onDragStop = (i) => {
      e.onDragStop(this.draggingToRowDragEvent("rowDragEnd", i));
    })), this.dragAndDropService.addDropTarget({ isInterestedIn: (i) => i === 2, getIconName: () => "move", external: !0, ...t });
  }
  getRowDropZone(e) {
    const t = this.getContainer.bind(this), i = this.onDragEnter.bind(this), o = this.onDragLeave.bind(this), s = this.onDragging.bind(this), r = this.onDragStop.bind(this);
    return e ? { getContainer: t, onDragEnter: e.onDragEnter ? (n) => {
      i(n), e.onDragEnter(this.draggingToRowDragEvent("rowDragEnter", n));
    } : i, onDragLeave: e.onDragLeave ? (n) => {
      o(n), e.onDragLeave(this.draggingToRowDragEvent("rowDragLeave", n));
    } : o, onDragging: e.onDragging ? (n) => {
      s(n), e.onDragging(this.draggingToRowDragEvent("rowDragMove", n));
    } : s, onDragStop: e.onDragStop ? (n) => {
      r(n), e.onDragStop(this.draggingToRowDragEvent("rowDragEnd", n));
    } : r, fromGrid: !0 } : { getContainer: t, onDragEnter: i, onDragLeave: o, onDragging: s, onDragStop: r, fromGrid: !0 };
  }
  draggingToRowDragEvent(e, t) {
    const i = this.mouseEventService.getNormalisedPosition(t).y;
    let o, s, r = -1;
    switch (i > this.pageBoundsService.getCurrentPageHeight() || (r = this.rowModel.getRowIndexAtPixel(i), o = this.rowModel.getRow(r)), t.vDirection) {
      case 1:
        s = "down";
        break;
      case 0:
        s = "up";
        break;
      default:
        s = null;
    }
    return this.gos.addGridCommonParams({ type: e, event: t.event, node: t.dragItem.rowNode, nodes: t.dragItem.rowNodes, overIndex: r, overNode: o, y: i, vDirection: s });
  }
  dispatchGridEvent(e, t) {
    const i = this.draggingToRowDragEvent(e, t);
    this.eventService.dispatchEvent(i);
  }
  onDragLeave(e) {
    this.dispatchGridEvent("rowDragLeave", e), this.stopDragging(e), this.gos.get("rowDragManaged") && this.clearRowHighlight();
  }
  onDragStop(e) {
    this.dispatchGridEvent("rowDragEnd", e), this.stopDragging(e), !this.gos.get("rowDragManaged") || !this.gos.get("suppressMoveWhenRowDragging") && this.isFromThisGrid(e) || this.isDropZoneWithinThisGrid(e) || this.moveRowAndClearHighlight(e);
  }
  stopDragging(e) {
    this.autoScrollService.ensureCleared(), this.getRowNodes(e).forEach((t) => {
      t.setDragging(!1);
    });
  }
}, sa = class extends f {
  constructor() {
    super(...arguments), this.beanName = "dragService", this.dragEndFunctions = [], this.dragSources = [];
  }
  wireBeans(e) {
    this.mouseEventService = e.mouseEventService;
  }
  destroy() {
    this.dragSources.forEach(this.removeListener.bind(this)), this.dragSources.length = 0, super.destroy();
  }
  removeListener(e) {
    const t = e.dragSource.eElement, i = e.mouseDownListener;
    if (t.removeEventListener("mousedown", i), e.touchEnabled) {
      const o = e.touchStartListener;
      t.removeEventListener("touchstart", o, { passive: !0 });
    }
  }
  removeDragSource(e) {
    const t = this.dragSources.find((i) => i.dragSource === e);
    t && (this.removeListener(t), Y(this.dragSources, t));
  }
  isDragging() {
    return this.dragging;
  }
  addDragSource(e) {
    const t = this.onMouseDown.bind(this, e), { eElement: i, includeTouch: o, stopPropagationForTouch: s } = e;
    i.addEventListener("mousedown", t);
    let r = null;
    const n = this.gos.get("suppressTouch");
    o && !n && (r = (a) => {
      io(a.target) || (a.cancelable && (a.preventDefault(), s && a.stopPropagation()), this.onTouchStart(e, a));
    }, i.addEventListener("touchstart", r, { passive: !1 })), this.dragSources.push({ dragSource: e, mouseDownListener: t, touchStartListener: r, touchEnabled: !!o });
  }
  getStartTarget() {
    return this.startTarget;
  }
  onTouchStart(e, t) {
    this.currentDragParams = e, this.dragging = !1;
    const i = t.touches[0];
    this.touchLastTime = i, this.touchStart = i;
    const o = (n) => this.onTouchUp(n, e.eElement), s = t.target, r = [{ target: this.gos.getRootNode(), type: "touchmove", listener: (n) => {
      n.cancelable && n.preventDefault();
    }, options: { passive: !1 } }, { target: s, type: "touchmove", listener: (n) => this.onTouchMove(n, e.eElement), options: { passive: !0 } }, { target: s, type: "touchend", listener: o, options: { passive: !0 } }, { target: s, type: "touchcancel", listener: o, options: { passive: !0 } }];
    this.addTemporaryEvents(r), e.dragStartPixels === 0 && this.onCommonMove(i, this.touchStart, e.eElement);
  }
  onMouseDown(e, t) {
    const i = t;
    if (e.skipMouseEvent && e.skipMouseEvent(t) || i._alreadyProcessedByDragService || (i._alreadyProcessedByDragService = !0, t.button !== 0))
      return;
    this.shouldPreventMouseEvent(t) && t.preventDefault(), this.currentDragParams = e, this.dragging = !1, this.mouseStartEvent = t, this.startTarget = t.target;
    const o = this.gos.getRootNode(), s = [{ target: o, type: "mousemove", listener: (r) => this.onMouseMove(r, e.eElement) }, { target: o, type: "mouseup", listener: (r) => this.onMouseUp(r, e.eElement) }, { target: o, type: "contextmenu", listener: (r) => r.preventDefault() }];
    this.addTemporaryEvents(s), e.dragStartPixels === 0 && this.onMouseMove(t, e.eElement);
  }
  addTemporaryEvents(e) {
    e.forEach((t) => {
      const { target: i, type: o, listener: s, options: r } = t;
      i.addEventListener(o, s, r);
    }), this.dragEndFunctions.push(() => {
      e.forEach((t) => {
        const { target: i, type: o, listener: s, options: r } = t;
        i.removeEventListener(o, s, r);
      });
    });
  }
  isEventNearStartEvent(e, t) {
    const { dragStartPixels: i } = this.currentDragParams;
    return Hs(e, t, S(i) ? i : 4);
  }
  getFirstActiveTouch(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].identifier === this.touchStart.identifier)
        return e[t];
    return null;
  }
  onCommonMove(e, t, i) {
    if (!this.dragging) {
      if (!this.dragging && this.isEventNearStartEvent(e, t))
        return;
      this.dragging = !0;
      const o = { type: "dragStarted", target: i };
      this.eventService.dispatchEvent(o), this.currentDragParams.onDragStart(t), this.currentDragParams.onDragging(t);
    }
    this.currentDragParams.onDragging(e);
  }
  onTouchMove(e, t) {
    const i = this.getFirstActiveTouch(e.touches);
    i && this.onCommonMove(i, this.touchStart, t);
  }
  onMouseMove(e, t) {
    var i;
    Me() && ((i = this.gos.getDocument().getSelection()) == null || i.removeAllRanges()), this.shouldPreventMouseEvent(e) && e.preventDefault(), this.onCommonMove(e, this.mouseStartEvent, t);
  }
  shouldPreventMouseEvent(e) {
    const t = this.gos.get("enableCellTextSelection"), i = e.type === "mousemove";
    return t && i && e.cancelable && this.mouseEventService.isEventFromThisGrid(e) && !this.isOverFormFieldElement(e);
  }
  isOverFormFieldElement(e) {
    const t = e.target, i = t == null ? void 0 : t.tagName.toLocaleLowerCase();
    return !!(i != null && i.match("^a$|textarea|input|select|button"));
  }
  onTouchUp(e, t) {
    let i = this.getFirstActiveTouch(e.changedTouches);
    i || (i = this.touchLastTime), this.onUpCommon(i, t);
  }
  onMouseUp(e, t) {
    this.onUpCommon(e, t);
  }
  onUpCommon(e, t) {
    if (this.dragging) {
      this.dragging = !1, this.currentDragParams.onDragStop(e);
      const i = { type: "dragStopped", target: t };
      this.eventService.dispatchEvent(i);
    }
    this.mouseStartEvent = null, this.startTarget = null, this.touchStart = null, this.touchLastTime = null, this.currentDragParams = null, this.dragEndFunctions.forEach((i) => i()), this.dragEndFunctions.length = 0;
  }
}, zi = class extends O {
  constructor(e, t, i, o, s, r) {
    super(), this.cellValueFn = e, this.rowNode = t, this.column = i, this.customGui = o, this.dragStartPixels = s, this.suppressVisibilityChange = r, this.dragSource = null;
  }
  wireBeans(e) {
    this.beans = e;
  }
  isCustomGui() {
    return this.customGui != null;
  }
  postConstruct() {
    if (this.customGui ? this.setDragElement(this.customGui, this.dragStartPixels) : (this.setTemplate('<div class="ag-drag-handle ag-row-drag" aria-hidden="true"></div>'), this.getGui().appendChild(te("rowDrag", this.gos, null)), this.addDragSource()), this.checkCompatibility(), !this.suppressVisibilityChange) {
      const e = this.gos.get("rowDragManaged") ? new na(this, this.beans, this.rowNode, this.column) : new ra(this, this.beans, this.rowNode, this.column);
      this.createManagedBean(e, this.beans.context);
    }
  }
  setDragElement(e, t) {
    this.setTemplateFromElement(e), this.addDragSource(t);
  }
  getSelectedNodes() {
    if (!this.gos.get("rowDragMultiRow"))
      return [this.rowNode];
    const e = this.beans.selectionService.getSelectedNodes();
    return e.indexOf(this.rowNode) !== -1 ? e : [this.rowNode];
  }
  checkCompatibility() {
    const e = this.gos.get("rowDragManaged");
    this.gos.get("treeData") && e && b("If using row drag with tree data, you cannot have rowDragManaged=true");
  }
  getDragItem() {
    return { rowNode: this.rowNode, rowNodes: this.getSelectedNodes(), columns: this.column ? [this.column] : void 0, defaultTextValue: this.cellValueFn() };
  }
  getRowDragText(e) {
    if (e) {
      const t = e.getColDef();
      if (t.rowDragText)
        return t.rowDragText;
    }
    return this.gos.get("rowDragText");
  }
  addDragSource(e = 4) {
    this.dragSource && this.removeDragSource();
    const t = this.getGui();
    this.gos.get("enableCellTextSelection") && (this.removeMouseDownListener(), this.mouseDownListener = this.addManagedElementListeners(t, { mousedown: (o) => {
      o == null || o.preventDefault();
    } })[0]);
    const i = this.localeService.getLocaleTextFunc();
    this.dragSource = { type: 2, eElement: t, dragItemName: () => {
      var n;
      const o = this.getDragItem(), s = ((n = o.rowNodes) == null ? void 0 : n.length) || 1, r = this.getRowDragText(this.column);
      return r ? r(o, s) : s === 1 ? this.cellValueFn() : `${s} ${i("rowDragRows", "rows")}`;
    }, getDragItem: () => this.getDragItem(), dragStartPixels: e, dragSourceDomDataKey: this.gos.getDomDataKey() }, this.beans.dragAndDropService.addDragSource(this.dragSource, !0);
  }
  destroy() {
    this.removeDragSource(), this.removeMouseDownListener(), super.destroy();
  }
  removeDragSource() {
    this.dragSource && (this.beans.dragAndDropService.removeDragSource(this.dragSource), this.dragSource = null);
  }
  removeMouseDownListener() {
    this.mouseDownListener && (this.mouseDownListener(), this.mouseDownListener = void 0);
  }
}, qs = class extends f {
  constructor(e, t, i) {
    super(), this.parent = e, this.rowNode = t, this.column = i;
  }
  setDisplayedOrVisible(e) {
    const t = { skipAriaHidden: !0 };
    if (e)
      this.parent.setDisplayed(!1, t);
    else {
      let i = !0, o = !1;
      this.column && (i = this.column.isRowDrag(this.rowNode) || this.parent.isCustomGui(), o = Xi(this.column.getColDef().rowDrag)), o ? (this.parent.setDisplayed(!0, t), this.parent.setVisible(i, t)) : (this.parent.setDisplayed(i, t), this.parent.setVisible(!0, t));
    }
  }
}, ra = class extends qs {
  constructor(e, t, i, o) {
    super(e, i, o), this.beans = t;
  }
  postConstruct() {
    this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this));
    const e = this.workOutVisibility.bind(this);
    this.addManagedListeners(this.rowNode, { dataChanged: e, cellChanged: e }), this.addManagedListeners(this.beans.eventService, { newColumnsLoaded: e }), this.workOutVisibility();
  }
  onSuppressRowDrag() {
    this.workOutVisibility();
  }
  workOutVisibility() {
    const e = this.gos.get("suppressRowDrag");
    this.setDisplayedOrVisible(e);
  }
}, na = class extends qs {
  constructor(e, t, i, o) {
    super(e, i, o), this.beans = t;
  }
  postConstruct() {
    const e = this.workOutVisibility.bind(this);
    this.addManagedListeners(this.beans.eventService, { sortChanged: e, filterChanged: e, columnRowGroupChanged: e, newColumnsLoaded: e }), this.addManagedListeners(this.rowNode, { dataChanged: e, cellChanged: e }), this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this)), this.workOutVisibility();
  }
  onSuppressRowDrag() {
    this.workOutVisibility();
  }
  workOutVisibility() {
    const e = this.beans.ctrlsService.getGridBodyCtrl().getRowDragFeature(), t = e && e.shouldPreventRowMove(), i = this.gos.get("suppressRowDrag"), o = this.beans.dragAndDropService.hasExternalDropZones(), s = t && !o || i;
    this.setDisplayedOrVisible(s);
  }
}, Ct = class tt {
  constructor(t) {
    this.rowIndex = null, this.key = null, this.childrenMapped = {}, this.displayed = !1, this.rowTop = null, this.oldRowTop = null, this.selectable = !0, this.__objectId = tt.OBJECT_ID_SEQUENCE++, this.__autoHeights = {}, this.alreadyRendered = !1, this.highlighted = null, this.hovered = !1, this.selected = !1, this.beans = t;
  }
  setData(t) {
    this.setDataCommon(t, !1);
  }
  updateData(t) {
    this.setDataCommon(t, !0);
  }
  setDataCommon(t, i) {
    var r;
    const o = this.data;
    this.data = t, this.beans.valueCache.onDataChanged(), this.updateDataOnDetailNode(), this.checkRowSelectable(), this.resetQuickFilterAggregateText();
    const s = this.createDataChangedEvent(t, o, i);
    (r = this.localEventService) == null || r.dispatchEvent(s);
  }
  updateDataOnDetailNode() {
    this.detailNode && (this.detailNode.data = this.data);
  }
  createDataChangedEvent(t, i, o) {
    return { type: "dataChanged", node: this, oldData: i, newData: t, update: o };
  }
  getRowIndexString() {
    return this.rowIndex == null ? (L("Could not find rowIndex, this means tasks are being executed on a rowNode that has been removed from the grid."), null) : this.rowPinned === "top" ? "t-" + this.rowIndex : this.rowPinned === "bottom" ? "b-" + this.rowIndex : this.rowIndex.toString();
  }
  createDaemonNode() {
    const t = new tt(this.beans);
    return t.id = this.id, t.data = this.data, t.__daemon = !0, t.selected = this.selected, t.level = this.level, t;
  }
  setDataAndId(t, i) {
    var n;
    const o = S(this.id) ? this.createDaemonNode() : null, s = this.data;
    this.data = t, this.updateDataOnDetailNode(), this.setId(i), this.checkRowSelectable(), this.beans.selectionService.syncInRowNode(this, o);
    const r = this.createDataChangedEvent(t, s, !1);
    (n = this.localEventService) == null || n.dispatchEvent(r);
  }
  checkRowSelectable() {
    const t = this.beans.gos.get("isRowSelectable");
    this.setRowSelectable(!t || t(this));
  }
  setRowSelectable(t, i) {
    if (this.selectable !== t) {
      if (this.selectable = t, this.dispatchRowEvent("selectableChanged"), i)
        return;
      if (this.beans.gos.get("groupSelectsChildren")) {
        const o = this.calculateSelectedFromChildren();
        return void this.setSelectedParams({ newValue: o ?? !1, source: "selectableChanged" });
      }
      this.isSelected() && !this.selectable && this.setSelectedParams({ newValue: !1, source: "selectableChanged" });
    }
  }
  setId(t) {
    const i = this.beans.gos.getRowIdCallback();
    if (i)
      if (this.data) {
        const o = this.getGroupKeys(!0);
        this.id = i({ data: this.data, parentKeys: o.length > 0 ? o : void 0, level: this.level, rowPinned: this.rowPinned }), this.id.startsWith(tt.ID_PREFIX_ROW_GROUP) && L(`Row IDs cannot start with ${tt.ID_PREFIX_ROW_GROUP}, this is a reserved prefix for AG Grid's row grouping feature.`);
      } else
        this.id = void 0;
    else
      this.id = t;
  }
  getGroupKeys(t = !1) {
    const i = [];
    let o = this;
    for (t && (o = o.parent); o && o.level >= 0; )
      i.push(o.key), o = o.parent;
    return i.reverse(), i;
  }
  isPixelInRange(t) {
    return !(!S(this.rowTop) || !S(this.rowHeight)) && t >= this.rowTop && t < this.rowTop + this.rowHeight;
  }
  updateIfDifferent(t, i, o) {
    this[t] !== i && (this[t] = i, this.dispatchRowEvent(o));
  }
  setFirstChild(t) {
    this.updateIfDifferent("firstChild", t, "firstChildChanged");
  }
  setLastChild(t) {
    this.updateIfDifferent("lastChild", t, "lastChildChanged");
  }
  setChildIndex(t) {
    this.updateIfDifferent("childIndex", t, "childIndexChanged");
  }
  setRowTop(t) {
    this.oldRowTop = this.rowTop, this.rowTop !== t && (this.rowTop = t, this.dispatchRowEvent("topChanged"), this.setDisplayed(t !== null));
  }
  clearRowTopAndRowIndex() {
    this.oldRowTop = null, this.setRowTop(null), this.setRowIndex(null);
  }
  setDisplayed(t) {
    this.updateIfDifferent("displayed", t, "displayedChanged");
  }
  setDragging(t) {
    this.updateIfDifferent("dragging", t, "draggingChanged");
  }
  setHighlighted(t) {
    this.updateIfDifferent("highlighted", t, "rowHighlightChanged");
  }
  setHovered(t) {
    this.hovered !== t && (this.hovered = t);
  }
  isHovered() {
    return this.hovered;
  }
  setAllChildrenCount(t) {
    this.updateIfDifferent("allChildrenCount", t, "allChildrenCountChanged");
  }
  setMaster(t) {
    this.master !== t && (this.master && !t && (this.expanded = !1), this.master = t, this.dispatchRowEvent("masterChanged"));
  }
  setGroup(t) {
    this.group !== t && (this.group && !t && (this.expanded = !1), this.group = t, this.updateHasChildren(), this.checkRowSelectable(), this.dispatchRowEvent("groupChanged"));
  }
  setRowHeight(t, i = !1) {
    this.rowHeight = t, this.rowHeightEstimated = i, this.dispatchRowEvent("heightChanged");
  }
  setRowAutoHeight(t, i) {
    this.__autoHeights || (this.__autoHeights = {}), this.__autoHeights[i.getId()] = t, t != null && (this.checkAutoHeightsDebounced == null && (this.checkAutoHeightsDebounced = q(this.checkAutoHeights.bind(this), 1)), this.checkAutoHeightsDebounced());
  }
  checkAutoHeights() {
    let t = !1, i = !0, o = 0;
    const s = this.__autoHeights;
    if (s == null || (this.beans.visibleColsService.getAllAutoHeightCols().forEach((n) => {
      let a = s[n.getId()];
      if (a == null) {
        if (!this.beans.columnModel.isColSpanActive())
          return void (t = !0);
        {
          let l = [];
          switch (n.getPinned()) {
            case "left":
              l = this.beans.visibleColsService.getLeftColsForRow(this);
              break;
            case "right":
              l = this.beans.visibleColsService.getRightColsForRow(this);
              break;
            case null:
              l = this.beans.columnViewportService.getColsWithinViewport(this);
          }
          if (l.includes(n))
            return void (t = !0);
          a = -1;
        }
      } else
        i = !1;
      a > o && (o = a);
    }), t) || ((i || o < 10) && (o = this.beans.gos.getRowHeightForNode(this).height), o == this.rowHeight))
      return;
    this.setRowHeight(o);
    const r = this.beans.rowModel;
    r.onRowHeightChangedDebounced && r.onRowHeightChangedDebounced();
  }
  setRowIndex(t) {
    this.updateIfDifferent("rowIndex", t, "rowIndexChanged");
  }
  setUiLevel(t) {
    this.updateIfDifferent("uiLevel", t, "uiLevelChanged");
  }
  setExpanded(t, i, o) {
    if (this.expanded === t)
      return;
    this.expanded = t, this.dispatchRowEvent("expandedChanged");
    const s = { ...this.createGlobalRowEvent("rowGroupOpened"), expanded: t, event: i || null };
    this.beans.rowNodeEventThrottle.dispatchExpanded(s, o), this.beans.rowRenderer.refreshCells({ rowNodes: [this] });
  }
  createGlobalRowEvent(t) {
    return this.beans.gos.addGridCommonParams({ type: t, node: this, data: this.data, rowIndex: this.rowIndex, rowPinned: this.rowPinned });
  }
  setDataValue(t, i, o) {
    const s = (() => typeof t != "string" ? t : this.beans.columnModel.getCol(t) ?? this.beans.columnModel.getColDefCol(t))(), r = this.getValueFromValueService(s);
    if (this.beans.gos.get("readOnlyEdit"))
      return this.dispatchEventForSaveValueReadOnly(s, r, i, o), !1;
    const n = this.beans.valueService.setValue(this, s, i, o);
    return this.dispatchCellChangedEvent(s, i, r), this.checkRowSelectable(), n;
  }
  getValueFromValueService(t) {
    const i = this.leafGroup && this.beans.columnModel.isPivotMode(), o = this.group && this.expanded && !this.footer && !i;
    let s = !1;
    const r = this.beans.gos.get("groupTotalRow") ?? this.beans.gos.get("groupIncludeFooter");
    s = typeof r != "function" ? !!r : !!(this.beans.gos.getCallback("groupTotalRow") ?? this.beans.gos.getCallback("groupIncludeFooter"))({ node: this });
    const n = this.beans.gos.get("groupSuppressBlankHeader"), a = o && s && !n;
    return this.beans.valueService.getValue(t, this, !1, a);
  }
  dispatchEventForSaveValueReadOnly(t, i, o, s) {
    const r = this.beans.gos.addGridCommonParams({ type: "cellEditRequest", event: null, rowIndex: this.rowIndex, rowPinned: this.rowPinned, column: t, colDef: t.getColDef(), data: this.data, node: this, oldValue: i, newValue: o, value: o, source: s });
    this.beans.eventService.dispatchEvent(r);
  }
  setGroupValue(t, i) {
    const o = this.beans.columnModel.getCol(t);
    A(this.groupData) && (this.groupData = {});
    const s = o.getColId(), r = this.groupData[s];
    r !== i && (this.groupData[s] = i, this.dispatchCellChangedEvent(o, i, r));
  }
  setAggData(t) {
    const i = this.aggData;
    if (this.aggData = t, this.localEventService) {
      const o = (s) => {
        const r = this.aggData ? this.aggData[s] : void 0, n = i ? i[s] : void 0;
        if (r === n)
          return;
        const a = this.beans.columnModel.getCol(s);
        a && this.dispatchCellChangedEvent(a, r, n);
      };
      for (const s in this.aggData)
        o(s);
      for (const s in t)
        s in this.aggData || o(s);
    }
  }
  updateHasChildren() {
    let t = this.group && !this.footer || this.childrenAfterGroup && this.childrenAfterGroup.length > 0;
    if (this.beans.gos.isRowModelType("serverSide")) {
      const i = this.beans.gos.get("treeData"), o = this.beans.gos.get("isServerSideGroup");
      t = !this.stub && !this.footer && (i ? !!o && o(this.data) : !!this.group);
    }
    t !== this.__hasChildren && (this.__hasChildren = !!t, this.dispatchRowEvent("hasChildrenChanged"));
  }
  hasChildren() {
    return this.__hasChildren == null && this.updateHasChildren(), this.__hasChildren;
  }
  isEmptyRowGroupNode() {
    return (this.group && W(this.childrenAfterGroup)) ?? !1;
  }
  dispatchCellChangedEvent(t, i, o) {
    var r;
    const s = { type: "cellChanged", node: this, column: t, newValue: i, oldValue: o };
    (r = this.localEventService) == null || r.dispatchEvent(s);
  }
  resetQuickFilterAggregateText() {
    this.quickFilterAggregateText = null;
  }
  isExpandable() {
    return !this.footer && (this.beans.columnModel.isPivotMode() ? this.hasChildren() && !this.leafGroup : this.hasChildren() || !!this.master);
  }
  isSelected() {
    return this.footer ? this.sibling.isSelected() : this.selected;
  }
  depthFirstSearch(t) {
    this.childrenAfterGroup && this.childrenAfterGroup.forEach((i) => i.depthFirstSearch(t)), t(this);
  }
  calculateSelectedFromChildren() {
    var s;
    let t = !1, i = !1, o = !1;
    if (!((s = this.childrenAfterGroup) != null && s.length))
      return this.selectable ? this.selected : null;
    for (let r = 0; r < this.childrenAfterGroup.length; r++) {
      const n = this.childrenAfterGroup[r];
      let a = n.isSelected();
      if (!n.selectable) {
        const l = n.calculateSelectedFromChildren();
        if (l === null)
          continue;
        a = l;
      }
      switch (a) {
        case !0:
          t = !0;
          break;
        case !1:
          i = !0;
          break;
        default:
          o = !0;
      }
    }
    return o || t && i ? void 0 : !!t || !i && (this.selectable ? this.selected : null);
  }
  setSelectedInitialValue(t) {
    this.selected = t;
  }
  dispatchRowEvent(t) {
    var o;
    const i = { type: t, node: this };
    (o = this.localEventService) == null || o.dispatchEvent(i);
  }
  selectThisNode(t, i, o = "api") {
    const s = !this.selectable && t, r = this.selected === t;
    if (s || r)
      return !1;
    this.selected = t, this.dispatchRowEvent("rowSelected");
    const n = this.sibling;
    n && n.footer && n.localEventService && n.dispatchRowEvent("rowSelected");
    const a = { ...this.createGlobalRowEvent("rowSelected"), event: i || null, source: o };
    return this.beans.eventService.dispatchEvent(a), !0;
  }
  setSelected(t, i = !1, o = "api") {
    typeof o != "boolean" ? this.setSelectedParams({ newValue: t, clearSelection: i, rangeSelect: !1, source: o }) : b("since version v30, rowNode.setSelected() property `suppressFinishActions` has been removed, please use `gridApi.setNodesSelected()` for bulk actions, and the event `source` property for ignoring events instead.");
  }
  setSelectedParams(t) {
    return this.rowPinned ? (b("cannot select pinned rows"), 0) : this.id === void 0 ? (b("cannot select node until id for node is known"), 0) : this.beans.selectionService.setNodesSelected({ ...t, nodes: [this.footer ? this.sibling : this] });
  }
  isRowPinned() {
    return this.rowPinned === "top" || this.rowPinned === "bottom";
  }
  isParentOfNode(t) {
    let i = this.parent;
    for (; i; ) {
      if (i === t)
        return !0;
      i = i.parent;
    }
    return !1;
  }
  addEventListener(t, i) {
    var s;
    this.localEventService || (this.localEventService = new ht()), this.beans.frameworkOverrides.shouldWrapOutgoing && !this.frameworkEventListenerService && (this.localEventService.setFrameworkOverrides(this.beans.frameworkOverrides), this.frameworkEventListenerService = new qi(this.beans.frameworkOverrides));
    const o = ((s = this.frameworkEventListenerService) == null ? void 0 : s.wrap(i)) ?? i;
    this.localEventService.addEventListener(t, o);
  }
  removeEventListener(t, i) {
    var s;
    if (!this.localEventService)
      return;
    const o = ((s = this.frameworkEventListenerService) == null ? void 0 : s.unwrap(i)) ?? i;
    this.localEventService.removeEventListener(t, o), this.localEventService.noRegisteredListenersExist() && (this.localEventService = null);
  }
  onMouseEnter() {
    this.dispatchRowEvent("mouseEnter");
  }
  onMouseLeave() {
    this.dispatchRowEvent("mouseLeave");
  }
  getFirstChildOfFirstChild(t) {
    let i = this, o = !0, s = !1, r = null;
    for (; o && !s; ) {
      const n = i.parent;
      S(n) && i.firstChild ? n.rowGroupColumn === t && (s = !0, r = n) : o = !1, i = n;
    }
    return s ? r : null;
  }
  isFullWidthCell() {
    if (this.detail)
      return !0;
    const t = this.beans.gos.getCallback("isFullWidthRow");
    return !!t && t({ rowNode: this });
  }
  getRoute() {
    if (this.key == null)
      return;
    const t = [];
    let i = this;
    for (; i && i.key != null; )
      t.push(i.key), i = i.parent;
    return t.reverse();
  }
  createFooter() {
    if (this.sibling)
      return;
    const t = /* @__PURE__ */ new Set(["eventService", "__objectId", "sticky"]), i = new tt(this.beans);
    Object.keys(this).forEach((o) => {
      t.has(o) || (i[o] = this[o]);
    }), i.footer = !0, i.setRowTop(null), i.setRowIndex(null), i.oldRowTop = null, i.id = "rowGroupFooter_" + this.id, i.sibling = this, this.sibling = i;
  }
  destroyFooter() {
    this.sibling && (this.sibling.setRowTop(null), this.sibling.setRowIndex(null), this.sibling = void 0);
  }
};
Ct.ID_PREFIX_ROW_GROUP = "row-group-", Ct.ID_PREFIX_TOP_PINNED = "t-", Ct.ID_PREFIX_BOTTOM_PINNED = "b-", Ct.OBJECT_ID_SEQUENCE = 0;
var xe = Ct, aa = class extends O {
  constructor(e, t) {
    super('<div class="ag-filter"></div>'), this.column = e, this.source = t, this.filterWrapper = null;
  }
  wireBeans(e) {
    this.filterManager = e.filterManager, this.columnModel = e.columnModel;
  }
  postConstruct() {
    this.createFilter(!0), this.addManagedEventListeners({ filterDestroyed: this.onFilterDestroyed.bind(this) });
  }
  hasFilter() {
    return !!this.filterWrapper;
  }
  getFilter() {
    var e;
    return ((e = this.filterWrapper) == null ? void 0 : e.filterPromise) ?? null;
  }
  afterInit() {
    var e, t;
    return ((t = (e = this.filterWrapper) == null ? void 0 : e.filterPromise) == null ? void 0 : t.then(() => {
    })) ?? ee.resolve();
  }
  afterGuiAttached(e) {
    var t, i;
    (i = (t = this.filterWrapper) == null ? void 0 : t.filterPromise) == null || i.then((o) => {
      var s;
      (s = o == null ? void 0 : o.afterGuiAttached) == null || s.call(o, e);
    });
  }
  afterGuiDetached() {
    var e, t;
    (t = (e = this.filterWrapper) == null ? void 0 : e.filterPromise) == null || t.then((i) => {
      var o;
      (o = i == null ? void 0 : i.afterGuiDetached) == null || o.call(i);
    });
  }
  createFilter(e) {
    var o, s;
    const { column: t, source: i } = this;
    this.filterWrapper = ((o = this.filterManager) == null ? void 0 : o.getOrCreateFilterWrapper(t)) ?? null, (s = this.filterWrapper) != null && s.filterPromise && this.filterWrapper.filterPromise.then((r) => {
      const n = r.getGui();
      if (S(n) || b(`getGui method from filter returned ${n}; it should be a DOM element.`), this.appendChild(n), e) {
        const a = { type: "filterOpened", column: t, source: i, eGui: this.getGui() };
        this.eventService.dispatchEvent(a);
      }
    });
  }
  onFilterDestroyed(e) {
    e.source !== "api" && e.source !== "paramsUpdated" || e.column.getId() !== this.column.getId() || !this.columnModel.getColDefCol(this.column) || (j(this.getGui()), this.createFilter());
  }
  destroy() {
    this.filterWrapper = null, super.destroy();
  }
}, $s = "ag-resizer-wrapper", la = `<div class="${$s}">
        <div data-ref="eTopLeftResizer" class="ag-resizer ag-resizer-topLeft"></div>
        <div data-ref="eTopResizer" class="ag-resizer ag-resizer-top"></div>
        <div data-ref="eTopRightResizer" class="ag-resizer ag-resizer-topRight"></div>
        <div data-ref="eRightResizer" class="ag-resizer ag-resizer-right"></div>
        <div data-ref="eBottomRightResizer" class="ag-resizer ag-resizer-bottomRight"></div>
        <div data-ref="eBottomResizer" class="ag-resizer ag-resizer-bottom"></div>
        <div data-ref="eBottomLeftResizer" class="ag-resizer ag-resizer-bottomLeft"></div>
        <div data-ref="eLeftResizer" class="ag-resizer ag-resizer-left"></div>
    </div>`, da = class extends f {
  constructor(e, t) {
    super(), this.element = e, this.dragStartPosition = { x: 0, y: 0 }, this.position = { x: 0, y: 0 }, this.lastSize = { width: -1, height: -1 }, this.positioned = !1, this.resizersAdded = !1, this.resizeListeners = [], this.boundaryEl = null, this.isResizing = !1, this.isMoving = !1, this.resizable = {}, this.movable = !1, this.currentResizer = null, this.config = Object.assign({}, { popup: !1 }, t);
  }
  wireBeans(e) {
    this.popupService = e.popupService, this.resizeObserverService = e.resizeObserverService, this.dragService = e.dragService;
  }
  center() {
    const { clientHeight: e, clientWidth: t } = this.offsetParent, i = t / 2 - this.getWidth() / 2, o = e / 2 - this.getHeight() / 2;
    this.offsetElement(i, o);
  }
  initialisePosition() {
    if (this.positioned)
      return;
    const { centered: e, forcePopupParentAsOffsetParent: t, minWidth: i, width: o, minHeight: s, height: r, x: n, y: a } = this.config;
    this.offsetParent || this.setOffsetParent();
    let l = 0, d = 0;
    const c = he(this.element);
    if (c) {
      const h = this.findBoundaryElement(), g = window.getComputedStyle(h);
      if (g.minWidth != null) {
        const u = h.offsetWidth - this.element.offsetWidth;
        d = parseInt(g.minWidth, 10) - u;
      }
      if (g.minHeight != null) {
        const u = h.offsetHeight - this.element.offsetHeight;
        l = parseInt(g.minHeight, 10) - u;
      }
    }
    if (this.minHeight = s || l, this.minWidth = i || d, o && this.setWidth(o), r && this.setHeight(r), o && r || this.refreshSize(), e)
      this.center();
    else if (n || a)
      this.offsetElement(n, a);
    else if (c && t) {
      let h = this.boundaryEl, g = !0;
      if (h || (h = this.findBoundaryElement(), g = !1), h) {
        const u = parseFloat(h.style.top), p = parseFloat(h.style.left);
        g ? this.offsetElement(isNaN(p) ? 0 : p, isNaN(u) ? 0 : u) : this.setPosition(p, u);
      }
    }
    this.positioned = !!this.offsetParent;
  }
  isPositioned() {
    return this.positioned;
  }
  getPosition() {
    return this.position;
  }
  setMovable(e, t) {
    if (!this.config.popup || e === this.movable)
      return;
    this.movable = e;
    const i = this.moveElementDragListener || { eElement: t, onDragStart: this.onMoveStart.bind(this), onDragging: this.onMove.bind(this), onDragStop: this.onMoveEnd.bind(this) };
    e ? (this.dragService.addDragSource(i), this.moveElementDragListener = i) : (this.dragService.removeDragSource(i), this.moveElementDragListener = void 0);
  }
  setResizable(e) {
    if (this.clearResizeListeners(), e ? this.addResizers() : this.removeResizers(), typeof e == "boolean") {
      if (e === !1)
        return;
      e = { topLeft: e, top: e, topRight: e, right: e, bottomRight: e, bottom: e, bottomLeft: e, left: e };
    }
    Object.keys(e).forEach((t) => {
      const i = !!e[t], o = this.getResizerElement(t), s = { dragStartPixels: 0, eElement: o, onDragStart: (r) => this.onResizeStart(r, t), onDragging: this.onResize.bind(this), onDragStop: (r) => this.onResizeEnd(r, t) };
      (i || !this.isAlive() && !i) && (i ? (this.dragService.addDragSource(s), this.resizeListeners.push(s), o.style.pointerEvents = "all") : o.style.pointerEvents = "none", this.resizable[t] = i);
    });
  }
  removeSizeFromEl() {
    this.element.style.removeProperty("height"), this.element.style.removeProperty("width"), this.element.style.removeProperty("flex");
  }
  restoreLastSize() {
    this.element.style.flex = "0 0 auto";
    const { height: e, width: t } = this.lastSize;
    t !== -1 && (this.element.style.width = `${t}px`), e !== -1 && (this.element.style.height = `${e}px`);
  }
  getHeight() {
    return this.element.offsetHeight;
  }
  setHeight(e) {
    const { popup: t } = this.config, i = this.element;
    let o = !1;
    if (typeof e == "string" && e.indexOf("%") !== -1)
      yt(i, e), e = As(i), o = !0;
    else if (e = Math.max(this.minHeight, e), this.positioned) {
      const s = this.getAvailableHeight();
      s && e > s && (e = s);
    }
    this.getHeight() !== e && (o ? (i.style.maxHeight = "unset", i.style.minHeight = "unset") : t ? yt(i, e) : (i.style.height = `${e}px`, i.style.flex = "0 0 auto", this.lastSize.height = typeof e == "number" ? e : parseFloat(e)));
  }
  getAvailableHeight() {
    const { popup: e, forcePopupParentAsOffsetParent: t } = this.config;
    this.positioned || this.initialisePosition();
    const { clientHeight: i } = this.offsetParent;
    if (!i)
      return null;
    const o = this.element.getBoundingClientRect(), s = this.offsetParent.getBoundingClientRect(), r = e ? this.position.y : o.top, n = e ? 0 : s.top;
    let a = 0;
    if (t) {
      const l = this.element.parentElement;
      if (l) {
        const { bottom: d } = l.getBoundingClientRect();
        a = d - o.bottom;
      }
    }
    return i + n - r - a;
  }
  getWidth() {
    return this.element.offsetWidth;
  }
  setWidth(e) {
    const t = this.element, { popup: i } = this.config;
    let o = !1;
    if (typeof e == "string" && e.indexOf("%") !== -1)
      ce(t, e), e = ei(t), o = !0;
    else if (this.positioned) {
      e = Math.max(this.minWidth, e);
      const { clientWidth: s } = this.offsetParent, r = i ? this.position.x : this.element.getBoundingClientRect().left;
      s && e + r > s && (e = s - r);
    }
    this.getWidth() !== e && (o ? (t.style.maxWidth = "unset", t.style.minWidth = "unset") : this.config.popup ? ce(t, e) : (t.style.width = `${e}px`, t.style.flex = " unset", this.lastSize.width = typeof e == "number" ? e : parseFloat(e)));
  }
  offsetElement(e = 0, t = 0) {
    const { forcePopupParentAsOffsetParent: i } = this.config, o = i ? this.boundaryEl : this.element;
    o && (this.popupService.positionPopup({ ePopup: o, keepWithinBounds: !0, skipObserver: this.movable || this.isResizable(), updatePosition: () => ({ x: e, y: t }) }), this.setPosition(parseFloat(o.style.left), parseFloat(o.style.top)));
  }
  constrainSizeToAvailableHeight(e) {
    this.config.forcePopupParentAsOffsetParent && (e ? this.resizeObserverSubscriber = this.resizeObserverService.observeResize(this.popupService.getPopupParent(), () => {
      const t = this.getAvailableHeight();
      this.element.style.setProperty("max-height", `${t}px`);
    }) : (this.element.style.removeProperty("max-height"), this.resizeObserverSubscriber && (this.resizeObserverSubscriber(), this.resizeObserverSubscriber = void 0)));
  }
  setPosition(e, t) {
    this.position.x = e, this.position.y = t;
  }
  updateDragStartPosition(e, t) {
    this.dragStartPosition = { x: e, y: t };
  }
  calculateMouseMovement(e) {
    const { e: t, isLeft: i, isTop: o, anywhereWithin: s, topBuffer: r } = e, n = t.clientX - this.dragStartPosition.x, a = t.clientY - this.dragStartPosition.y;
    return { movementX: this.shouldSkipX(t, !!i, !!s, n) ? 0 : n, movementY: this.shouldSkipY(t, !!o, r, a) ? 0 : a };
  }
  shouldSkipX(e, t, i, o) {
    const s = this.element.getBoundingClientRect(), r = this.offsetParent.getBoundingClientRect(), n = this.boundaryEl.getBoundingClientRect(), a = this.config.popup ? this.position.x : s.left;
    let l = a <= 0 && r.left >= e.clientX || r.right <= e.clientX && r.right <= n.right;
    return !!l || (l = t ? o < 0 && e.clientX > a + r.left || o > 0 && e.clientX < a + r.left : i ? o < 0 && e.clientX > n.right || o > 0 && e.clientX < a + r.left : o < 0 && e.clientX > n.right || o > 0 && e.clientX < n.right, l);
  }
  shouldSkipY(e, t, i = 0, o) {
    const s = this.element.getBoundingClientRect(), r = this.offsetParent.getBoundingClientRect(), n = this.boundaryEl.getBoundingClientRect(), a = this.config.popup ? this.position.y : s.top;
    let l = a <= 0 && r.top >= e.clientY || r.bottom <= e.clientY && r.bottom <= n.bottom;
    return !!l || (l = t ? o < 0 && e.clientY > a + r.top + i || o > 0 && e.clientY < a + r.top : o < 0 && e.clientY > n.bottom || o > 0 && e.clientY < n.bottom, l);
  }
  createResizeMap() {
    const e = this.element;
    this.resizerMap = { topLeft: { element: e.querySelector("[data-ref=eTopLeftResizer]") }, top: { element: e.querySelector("[data-ref=eTopResizer]") }, topRight: { element: e.querySelector("[data-ref=eTopRightResizer]") }, right: { element: e.querySelector("[data-ref=eRightResizer]") }, bottomRight: { element: e.querySelector("[data-ref=eBottomRightResizer]") }, bottom: { element: e.querySelector("[data-ref=eBottomResizer]") }, bottomLeft: { element: e.querySelector("[data-ref=eBottomLeftResizer]") }, left: { element: e.querySelector("[data-ref=eLeftResizer]") } };
  }
  addResizers() {
    if (this.resizersAdded)
      return;
    const e = this.element;
    if (!e)
      return;
    const t = new DOMParser().parseFromString(la, "text/html").body;
    e.appendChild(t.firstChild), this.createResizeMap(), this.resizersAdded = !0;
  }
  removeResizers() {
    this.resizerMap = void 0;
    const e = this.element.querySelector(`.${$s}`);
    e && this.element.removeChild(e), this.resizersAdded = !1;
  }
  getResizerElement(e) {
    return this.resizerMap[e].element;
  }
  onResizeStart(e, t) {
    this.boundaryEl = this.findBoundaryElement(), this.positioned || this.initialisePosition(), this.currentResizer = { isTop: !!t.match(/top/i), isRight: !!t.match(/right/i), isBottom: !!t.match(/bottom/i), isLeft: !!t.match(/left/i) }, this.element.classList.add("ag-resizing"), this.resizerMap[t].element.classList.add("ag-active");
    const { popup: i, forcePopupParentAsOffsetParent: o } = this.config;
    i || o || this.applySizeToSiblings(this.currentResizer.isBottom || this.currentResizer.isTop), this.isResizing = !0, this.updateDragStartPosition(e.clientX, e.clientY);
  }
  getSiblings() {
    const e = this.element.parentElement;
    return e ? Array.prototype.slice.call(e.children).filter((t) => !t.classList.contains("ag-hidden")) : null;
  }
  getMinSizeOfSiblings() {
    const e = this.getSiblings() || [];
    let t = 0, i = 0;
    for (let o = 0; o < e.length; o++) {
      const s = e[o], r = !!s.style.flex && s.style.flex !== "0 0 auto";
      if (s === this.element)
        continue;
      let n = this.minHeight || 0, a = this.minWidth || 0;
      if (r) {
        const l = window.getComputedStyle(s);
        l.minHeight && (n = parseInt(l.minHeight, 10)), l.minWidth && (a = parseInt(l.minWidth, 10));
      } else
        n = s.offsetHeight, a = s.offsetWidth;
      t += n, i += a;
    }
    return { height: t, width: i };
  }
  applySizeToSiblings(e) {
    let t = null;
    const i = this.getSiblings();
    if (i) {
      for (let o = 0; o < i.length; o++) {
        const s = i[o];
        s !== t && (e ? s.style.height = `${s.offsetHeight}px` : s.style.width = `${s.offsetWidth}px`, s.style.flex = "0 0 auto", s === this.element && (t = i[o + 1]));
      }
      t && (t.style.removeProperty("height"), t.style.removeProperty("min-height"), t.style.removeProperty("max-height"), t.style.flex = "1 1 auto");
    }
  }
  isResizable() {
    return Object.values(this.resizable).some((e) => e);
  }
  onResize(e) {
    if (!this.isResizing || !this.currentResizer)
      return;
    const { popup: t, forcePopupParentAsOffsetParent: i } = this.config, { isTop: o, isRight: s, isBottom: r, isLeft: n } = this.currentResizer, a = s || n, l = r || o, { movementX: d, movementY: c } = this.calculateMouseMovement({ e, isLeft: n, isTop: o }), h = this.position.x, g = this.position.y;
    let u = 0, p = 0;
    if (a && d) {
      const C = n ? -1 : 1, y = this.getWidth(), w = y + d * C;
      let x = !1;
      n && (u = y - w, (h + u <= 0 || w <= this.minWidth) && (x = !0, u = 0)), x || this.setWidth(w);
    }
    if (l && c) {
      const C = o ? -1 : 1, y = this.getHeight(), w = y + c * C;
      let x = !1;
      o ? (p = y - w, (g + p <= 0 || w <= this.minHeight) && (x = !0, p = 0)) : !this.config.popup && !this.config.forcePopupParentAsOffsetParent && y < w && this.getMinSizeOfSiblings().height + w > this.element.parentElement.offsetHeight && (x = !0), x || this.setHeight(w);
    }
    this.updateDragStartPosition(e.clientX, e.clientY), ((t || i) && u || p) && this.offsetElement(h + u, g + p);
  }
  onResizeEnd(e, t) {
    this.isResizing = !1, this.currentResizer = null, this.boundaryEl = null, this.element.classList.remove("ag-resizing"), this.resizerMap[t].element.classList.remove("ag-active"), this.dispatchLocalEvent({ type: "resize" });
  }
  refreshSize() {
    const e = this.element;
    this.config.popup && (this.config.width || this.setWidth(e.offsetWidth), this.config.height || this.setHeight(e.offsetHeight));
  }
  onMoveStart(e) {
    this.boundaryEl = this.findBoundaryElement(), this.positioned || this.initialisePosition(), this.isMoving = !0, this.element.classList.add("ag-moving"), this.updateDragStartPosition(e.clientX, e.clientY);
  }
  onMove(e) {
    if (!this.isMoving)
      return;
    const { x: t, y: i } = this.position;
    let o;
    this.config.calculateTopBuffer && (o = this.config.calculateTopBuffer());
    const { movementX: s, movementY: r } = this.calculateMouseMovement({ e, isTop: !0, anywhereWithin: !0, topBuffer: o });
    this.offsetElement(t + s, i + r), this.updateDragStartPosition(e.clientX, e.clientY);
  }
  onMoveEnd() {
    this.isMoving = !1, this.boundaryEl = null, this.element.classList.remove("ag-moving");
  }
  setOffsetParent() {
    this.config.forcePopupParentAsOffsetParent ? this.offsetParent = this.popupService.getPopupParent() : this.offsetParent = this.element.offsetParent;
  }
  findBoundaryElement() {
    let e = this.element;
    for (; e; ) {
      if (window.getComputedStyle(e).position !== "static")
        return e;
      e = e.parentElement;
    }
    return this.element;
  }
  clearResizeListeners() {
    for (; this.resizeListeners.length; ) {
      const e = this.resizeListeners.pop();
      this.dragService.removeDragSource(e);
    }
  }
  destroy() {
    super.destroy(), this.moveElementDragListener && this.dragService.removeDragSource(this.moveElementDragListener), this.constrainSizeToAvailableHeight(!1), this.clearResizeListeners(), this.removeResizers();
  }
}, Js = class Xs extends f {
  constructor(t, i = {}) {
    super(), this.eFocusableElement = t, this.callbacks = i, this.callbacks = { shouldStopEventPropagation: () => !1, onTabKeyDown: (o) => {
      if (o.defaultPrevented)
        return;
      const s = this.focusService.findNextFocusableElement(this.eFocusableElement, !1, o.shiftKey);
      s && (s.focus(), o.preventDefault());
    }, ...i };
  }
  wireBeans(t) {
    this.focusService = t.focusService;
  }
  postConstruct() {
    this.eFocusableElement.classList.add(Xs.FOCUS_MANAGED_CLASS), this.addKeyDownListeners(this.eFocusableElement), this.callbacks.onFocusIn && this.addManagedElementListeners(this.eFocusableElement, { focusin: this.callbacks.onFocusIn }), this.callbacks.onFocusOut && this.addManagedElementListeners(this.eFocusableElement, { focusout: this.callbacks.onFocusOut });
  }
  addKeyDownListeners(t) {
    this.addManagedElementListeners(t, { keydown: (i) => {
      i.defaultPrevented || Ae(i) || (this.callbacks.shouldStopEventPropagation(i) ? at(i) : i.key === v.TAB ? this.callbacks.onTabKeyDown(i) : this.callbacks.handleKeyDown && this.callbacks.handleKeyDown(i));
    } });
  }
};
Js.FOCUS_MANAGED_CLASS = "ag-focus-managed";
var qe = Js, Zs = { applyFilter: "Apply", clearFilter: "Clear", resetFilter: "Reset", cancelFilter: "Cancel", textFilter: "Text Filter", numberFilter: "Number Filter", dateFilter: "Date Filter", setFilter: "Set Filter", filterOoo: "Filter...", empty: "Choose one", equals: "Equals", notEqual: "Does not equal", lessThan: "Less than", greaterThan: "Greater than", inRange: "Between", inRangeStart: "From", inRangeEnd: "To", lessThanOrEqual: "Less than or equal to", greaterThanOrEqual: "Greater than or equal to", contains: "Contains", notContains: "Does not contain", startsWith: "Begins with", endsWith: "Ends with", blank: "Blank", notBlank: "Not blank", before: "Before", after: "After", andCondition: "AND", orCondition: "OR", dateFormatOoo: "yyyy-mm-dd" };
function co(e, t) {
  return ri(e) ? (e.debounceMs != null && b("debounceMs is ignored when apply button is present"), 0) : e.debounceMs != null ? e.debounceMs : t;
}
function ri(e) {
  return !!e.buttons && e.buttons.indexOf("apply") >= 0;
}
var ca = class extends O {
  constructor(e) {
    super(), this.filterNameKey = e, this.applyActive = !1, this.hidePopup = null, this.debouncePending = !1, this.appliedModel = null, this.eFilterBody = R, this.buttonListeners = [];
  }
  wireBeans(e) {
    this.rowModel = e.rowModel;
  }
  postConstruct() {
    this.resetTemplate(), this.createManagedBean(new qe(this.getFocusableElement(), { handleKeyDown: this.handleKeyDown.bind(this) })), this.positionableFeature = new da(this.getPositionableElement(), { forcePopupParentAsOffsetParent: !0 }), this.createBean(this.positionableFeature);
  }
  handleKeyDown(e) {
  }
  getFilterTitle() {
    return this.translate(this.filterNameKey);
  }
  isFilterActive() {
    return !!this.appliedModel;
  }
  resetTemplate(e) {
    let t = this.getGui();
    t && t.removeEventListener("submit", this.onFormSubmit);
    const i = `
            <form class="ag-filter-wrapper">
                <div class="ag-filter-body-wrapper ag-${this.getCssIdentifier()}-body-wrapper" data-ref="eFilterBody">
                    ${this.createBodyTemplate()}
                </div>
            </form>`;
    this.setTemplate(i, this.getAgComponents(), e), t = this.getGui(), t && t.addEventListener("submit", this.onFormSubmit);
  }
  isReadOnly() {
    return !!this.providedFilterParams.readOnly;
  }
  init(e) {
    this.setParams(e), this.resetUiToDefaults(!0).then(() => {
      this.updateUiVisibility(), this.setupOnBtApplyDebounce();
    });
  }
  setParams(e) {
    this.providedFilterParams = e, this.applyActive = ri(e), this.resetButtonsPanel();
  }
  updateParams(e) {
    this.providedFilterParams = e, this.applyActive = ri(e), this.resetUiToActiveModel(this.getModel(), () => {
      this.updateUiVisibility(), this.setupOnBtApplyDebounce();
    });
  }
  resetButtonsPanel() {
    const { buttons: e } = this.providedFilterParams, t = e && e.length > 0 && !this.isReadOnly();
    if (this.eButtonsPanel ? (j(this.eButtonsPanel), this.buttonListeners.forEach((s) => s()), this.buttonListeners = []) : t && (this.eButtonsPanel = document.createElement("div"), this.eButtonsPanel.classList.add("ag-filter-apply-panel")), !t)
      return void (this.eButtonsPanel && ve(this.eButtonsPanel));
    const i = document.createDocumentFragment(), o = (s) => {
      let r, n;
      switch (s) {
        case "apply":
          r = this.translate("applyFilter"), n = (l) => this.onBtApply(!1, !1, l);
          break;
        case "clear":
          r = this.translate("clearFilter"), n = () => this.onBtClear();
          break;
        case "reset":
          r = this.translate("resetFilter"), n = () => this.onBtReset();
          break;
        case "cancel":
          r = this.translate("cancelFilter"), n = (l) => {
            this.onBtCancel(l);
          };
          break;
        default:
          return void b("Unknown button type specified");
      }
      const a = dt(`<button
                    type="${s === "apply" ? "submit" : "button"}"
                    data-ref="${s}FilterButton"
                    class="ag-button ag-standard-button ag-filter-apply-panel-button"
                >${r}
                </button>`);
      this.buttonListeners.push(...this.addManagedElementListeners(a, { click: n })), i.append(a);
    };
    e.forEach((s) => o(s)), this.eButtonsPanel.append(i), this.getGui().appendChild(this.eButtonsPanel);
  }
  getDefaultDebounceMs() {
    return 0;
  }
  setupOnBtApplyDebounce() {
    const e = co(this.providedFilterParams, this.getDefaultDebounceMs()), t = q(this.checkApplyDebounce.bind(this), e);
    this.onBtApplyDebounce = () => {
      this.debouncePending = !0, t();
    };
  }
  checkApplyDebounce() {
    this.debouncePending && (this.debouncePending = !1, this.onBtApply());
  }
  getModel() {
    return this.appliedModel ? this.appliedModel : null;
  }
  setModel(e) {
    return (e != null ? this.setModelIntoUi(e) : this.resetUiToDefaults()).then(() => {
      this.updateUiVisibility(), this.applyModel("api");
    });
  }
  onBtCancel(e) {
    this.resetUiToActiveModel(this.getModel(), () => {
      this.handleCancelEnd(e);
    });
  }
  handleCancelEnd(e) {
    this.providedFilterParams.closeOnApply && this.close(e);
  }
  resetUiToActiveModel(e, t) {
    const i = () => {
      this.onUiChanged(!1, "prevent"), t == null || t();
    };
    e != null ? this.setModelIntoUi(e).then(i) : this.resetUiToDefaults().then(i);
  }
  onBtClear() {
    this.resetUiToDefaults().then(() => this.onUiChanged());
  }
  onBtReset() {
    this.onBtClear(), this.onBtApply();
  }
  applyModel(e = "api") {
    const t = this.getModelFromUi();
    if (!this.isModelValid(t))
      return !1;
    const i = this.appliedModel;
    return this.appliedModel = t, !this.areModelsEqual(i, t);
  }
  isModelValid(e) {
    return !0;
  }
  onFormSubmit(e) {
    e.preventDefault();
  }
  onBtApply(e = !1, t = !1, i) {
    if (i && i.preventDefault(), this.applyModel(t ? "rowDataUpdated" : "ui")) {
      const s = "columnFilter";
      this.providedFilterParams.filterChangedCallback({ afterFloatingFilter: e, afterDataChange: t, source: s });
    }
    const { closeOnApply: o } = this.providedFilterParams;
    o && this.applyActive && !e && !t && this.close(i);
  }
  onNewRowsLoaded() {
  }
  close(e) {
    if (!this.hidePopup)
      return;
    const t = e, i = t && t.key;
    let o;
    i !== "Enter" && i !== "Space" || (o = { keyboardEvent: t }), this.hidePopup(o), this.hidePopup = null;
  }
  onUiChanged(e = !1, t) {
    if (this.updateUiVisibility(), this.providedFilterParams.filterModifiedCallback(), this.applyActive && !this.isReadOnly()) {
      const i = this.isModelValid(this.getModelFromUi()), o = this.queryForHtmlElement('[data-ref="applyFilterButton"]');
      o && Mt(o, !i);
    }
    e && !t || t === "immediately" ? this.onBtApply(e) : (this.applyActive || t) && t !== "debounce" || this.onBtApplyDebounce();
  }
  afterGuiAttached(e) {
    e && (this.hidePopup = e.hidePopup), this.refreshFilterResizer(e == null ? void 0 : e.container);
  }
  refreshFilterResizer(e) {
    if (!this.positionableFeature || e === "toolPanel")
      return;
    const t = e === "floatingFilter" || e === "columnFilter", { positionableFeature: i, gos: o } = this;
    t ? (i.restoreLastSize(), i.setResizable(o.get("enableRtl") ? { bottom: !0, bottomLeft: !0, left: !0 } : { bottom: !0, bottomRight: !0, right: !0 })) : (this.positionableFeature.removeSizeFromEl(), this.positionableFeature.setResizable(!1)), this.positionableFeature.constrainSizeToAvailableHeight(!0);
  }
  afterGuiDetached() {
    this.checkApplyDebounce(), this.positionableFeature && this.positionableFeature.constrainSizeToAvailableHeight(!1);
  }
  refresh(e) {
    return this.providedFilterParams = e, !0;
  }
  destroy() {
    const e = this.getGui();
    e && e.removeEventListener("submit", this.onFormSubmit), this.hidePopup = null, this.positionableFeature && (this.positionableFeature = this.destroyBean(this.positionableFeature)), this.appliedModel = null, super.destroy();
  }
  translate(e) {
    return this.localeService.getLocaleTextFunc()(e, Zs[e]);
  }
  getCellValue(e) {
    return this.providedFilterParams.getValue(e);
  }
  getPositionableElement() {
    return this.eFilterBody;
  }
}, ha = class extends ao {
  constructor(e) {
    super(e, "ag-radio-button", "radio");
  }
  isSelected() {
    return this.eInput.checked;
  }
  toggle() {
    this.eInput.disabled || this.isSelected() || this.setValue(!0);
  }
  addInputListeners() {
    super.addInputListeners(), this.addManagedEventListeners({ checkboxChanged: this.onChange.bind(this) });
  }
  onChange(e) {
    e.selected && e.name && this.eInput.name && this.eInput.name === e.name && e.id && this.eInput.id !== e.id && this.setValue(!1, !0);
  }
}, ga = class extends O {
  constructor(e = "default", t = !1) {
    super(`<div class="ag-list ag-${e}-list" role="listbox"></div>`), this.cssIdentifier = e, this.unFocusable = t, this.activeClass = "ag-active-item", this.options = [], this.itemEls = [];
  }
  postConstruct() {
    const e = this.getGui();
    this.addManagedElementListeners(e, { mouseleave: () => this.clearHighlighted() }), this.unFocusable || this.addManagedElementListeners(e, { keydown: this.handleKeyDown.bind(this) });
  }
  handleKeyDown(e) {
    const t = e.key;
    switch (t) {
      case v.ENTER:
        if (this.highlightedEl) {
          const i = this.itemEls.indexOf(this.highlightedEl);
          this.setValueByIndex(i);
        } else
          this.setValue(this.getValue());
        break;
      case v.DOWN:
      case v.UP:
        e.preventDefault(), this.navigate(t);
        break;
      case v.PAGE_DOWN:
      case v.PAGE_UP:
      case v.PAGE_HOME:
      case v.PAGE_END:
        e.preventDefault(), this.navigateToPage(t);
    }
  }
  navigate(e) {
    const t = e === v.DOWN;
    let i;
    if (this.highlightedEl) {
      let o = this.itemEls.indexOf(this.highlightedEl) + (t ? 1 : -1);
      o = Math.min(Math.max(o, 0), this.itemEls.length - 1), i = this.itemEls[o];
    } else
      i = this.itemEls[t ? 0 : this.itemEls.length - 1];
    this.highlightItem(i);
  }
  navigateToPage(e) {
    if (!this.highlightedEl || this.itemEls.length === 0)
      return;
    const t = this.itemEls.indexOf(this.highlightedEl), i = this.options.length - 1, o = this.itemEls[0].clientHeight, s = Math.floor(this.getGui().clientHeight / o);
    let r = -1;
    e === v.PAGE_HOME ? r = 0 : e === v.PAGE_END ? r = i : e === v.PAGE_DOWN ? r = Math.min(t + s, i) : e === v.PAGE_UP && (r = Math.max(t - s, 0)), r !== -1 && this.highlightItem(this.itemEls[r]);
  }
  addOptions(e) {
    return e.forEach((t) => this.addOption(t)), this;
  }
  addOption(e) {
    const { value: t, text: i } = e, o = i || t;
    return this.options.push({ value: t, text: o }), this.renderOption(t, o), this.updateIndices(), this;
  }
  clearOptions() {
    this.options = [], this.reset(!0), this.itemEls.forEach((e) => {
      ve(e);
    }), this.itemEls = [];
  }
  updateIndices() {
    const e = this.getGui().querySelectorAll(".ag-list-item");
    e.forEach((t, i) => {
      var o, s;
      de(t, "posinset", i + 1), o = t, s = e.length, de(o, "setsize", s);
    });
  }
  renderOption(e, t) {
    const i = this.gos.getDocument(), o = i.createElement("div");
    X(o, "option"), o.classList.add("ag-list-item", `ag-${this.cssIdentifier}-list-item`);
    const s = i.createElement("span");
    o.appendChild(s), s.textContent = t, this.unFocusable || (o.tabIndex = -1), this.itemEls.push(o), this.addManagedListeners(o, { mouseover: () => this.highlightItem(o), mousedown: (r) => {
      r.preventDefault(), r.stopPropagation(), this.setValue(e);
    } }), this.createManagedBean(new gt({ getTooltipValue: () => t, getGui: () => o, getLocation: () => "UNKNOWN", shouldDisplayTooltip: () => s.scrollWidth > s.clientWidth })), this.getGui().appendChild(o);
  }
  setValue(e, t) {
    if (this.value === e)
      return this.fireItemSelected(), this;
    if (e == null)
      return this.reset(t), this;
    const i = this.options.findIndex((o) => o.value === e);
    if (i !== -1) {
      const o = this.options[i];
      this.value = o.value, this.displayValue = o.text, this.highlightItem(this.itemEls[i]), t || this.fireChangeEvent();
    }
    return this;
  }
  setValueByIndex(e) {
    return this.setValue(this.options[e].value);
  }
  getValue() {
    return this.value;
  }
  getDisplayValue() {
    return this.displayValue;
  }
  refreshHighlighted() {
    this.clearHighlighted();
    const e = this.options.findIndex((t) => t.value === this.value);
    e !== -1 && this.highlightItem(this.itemEls[e]);
  }
  reset(e) {
    this.value = null, this.displayValue = null, this.clearHighlighted(), e || this.fireChangeEvent();
  }
  highlightItem(e) {
    if (!he(e))
      return;
    this.clearHighlighted(), this.highlightedEl = e, this.highlightedEl.classList.add(this.activeClass), _t(this.highlightedEl, !0);
    const t = this.getGui(), { scrollTop: i, clientHeight: o } = t, { offsetTop: s, offsetHeight: r } = e;
    (s + r > i + o || s < i) && this.highlightedEl.scrollIntoView({ block: "nearest" }), this.unFocusable || this.highlightedEl.focus();
  }
  clearHighlighted() {
    this.highlightedEl && he(this.highlightedEl) && (this.highlightedEl.classList.remove(this.activeClass), _t(this.highlightedEl, !1), this.highlightedEl = null);
  }
  fireChangeEvent() {
    this.dispatchLocalEvent({ type: "fieldValueChanged" }), this.fireItemSelected();
  }
  fireItemSelected() {
    this.dispatchLocalEvent({ type: "selectedItem" });
  }
}, ua = class extends Ws {
  constructor(e) {
    if (super(e, (e == null ? void 0 : e.template) || `
            <div class="ag-picker-field" role="presentation">
                <div data-ref="eLabel"></div>
                    <div data-ref="eWrapper" class="ag-wrapper ag-picker-field-wrapper ag-picker-collapsed">
                    <div data-ref="eDisplayField" class="ag-picker-field-display"></div>
                    <div data-ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>
                </div>
            </div>`, (e == null ? void 0 : e.agComponents) || [], e == null ? void 0 : e.className), this.isPickerDisplayed = !1, this.skipClick = !1, this.pickerGap = 4, this.hideCurrentPicker = null, this.eLabel = R, this.eWrapper = R, this.eDisplayField = R, this.eIcon = R, this.ariaRole = e == null ? void 0 : e.ariaRole, this.onPickerFocusIn = this.onPickerFocusIn.bind(this), this.onPickerFocusOut = this.onPickerFocusOut.bind(this), !e)
      return;
    const { pickerGap: t, maxPickerHeight: i, variableWidth: o, minPickerWidth: s, maxPickerWidth: r } = e;
    t != null && (this.pickerGap = t), this.variableWidth = !!o, i != null && this.setPickerMaxHeight(i), s != null && this.setPickerMinWidth(s), r != null && this.setPickerMaxWidth(r);
  }
  wireBeans(e) {
    this.popupService = e.popupService;
  }
  postConstruct() {
    super.postConstruct(), this.setupAria();
    const e = `ag-${this.getCompId()}-display`;
    this.eDisplayField.setAttribute("id", e);
    const t = this.getAriaElement();
    this.addManagedElementListeners(t, { keydown: this.onKeyDown.bind(this) }), this.addManagedElementListeners(this.eLabel, { mousedown: this.onLabelOrWrapperMouseDown.bind(this) }), this.addManagedElementListeners(this.eWrapper, { mousedown: this.onLabelOrWrapperMouseDown.bind(this) });
    const { pickerIcon: i, inputWidth: o } = this.config;
    if (i) {
      const s = te(i, this.gos);
      s && this.eIcon.appendChild(s);
    }
    o != null && this.setInputWidth(o);
  }
  setupAria() {
    const e = this.getAriaElement();
    e.setAttribute("tabindex", this.gos.get("tabIndex").toString()), Zt(e, !1), this.ariaRole && X(e, this.ariaRole);
  }
  onLabelOrWrapperMouseDown(e) {
    if (e) {
      const t = this.getFocusableElement();
      if (t !== this.eWrapper && (e == null ? void 0 : e.target) === t)
        return;
      e.preventDefault(), this.getFocusableElement().focus();
    }
    this.skipClick ? this.skipClick = !1 : this.isDisabled() || (this.isPickerDisplayed ? this.hidePicker() : this.showPicker());
  }
  onKeyDown(e) {
    switch (e.key) {
      case v.UP:
      case v.DOWN:
      case v.ENTER:
      case v.SPACE:
        e.preventDefault(), this.onLabelOrWrapperMouseDown();
        break;
      case v.ESCAPE:
        this.isPickerDisplayed && (e.preventDefault(), e.stopPropagation(), this.hideCurrentPicker && this.hideCurrentPicker());
    }
  }
  showPicker() {
    this.isPickerDisplayed = !0, this.pickerComponent || (this.pickerComponent = this.createPickerComponent());
    const e = this.pickerComponent.getGui();
    e.addEventListener("focusin", this.onPickerFocusIn), e.addEventListener("focusout", this.onPickerFocusOut), this.hideCurrentPicker = this.renderAndPositionPicker(), this.toggleExpandedStyles(!0);
  }
  renderAndPositionPicker() {
    const e = this.gos.getDocument(), t = this.pickerComponent.getGui();
    this.gos.get("suppressScrollWhenPopupsAreOpen") || ([this.destroyMouseWheelFunc] = this.addManagedEventListeners({ bodyScroll: () => {
      this.hidePicker();
    } }));
    const i = this.localeService.getLocaleTextFunc(), { pickerAriaLabelKey: o, pickerAriaLabelValue: s, modalPicker: r = !0 } = this.config, n = { modal: r, eChild: t, closeOnEsc: !0, closedCallback: () => {
      const u = this.gos.getActiveDomElement(), p = !u || u === e.body;
      this.beforeHidePicker(), p && this.isAlive() && this.getFocusableElement().focus();
    }, ariaLabel: i(o, s) }, a = this.popupService.addPopup(n), { maxPickerHeight: l, minPickerWidth: d, maxPickerWidth: c, variableWidth: h } = this;
    h ? (d && (t.style.minWidth = d), t.style.width = so(ei(this.eWrapper)), c && (t.style.maxWidth = c)) : si(t, c ?? ei(this.eWrapper));
    const g = l ?? `${oo(this.popupService.getPopupParent())}px`;
    return t.style.setProperty("max-height", g), t.style.position = "absolute", this.alignPickerToComponent(), a.hideFunc;
  }
  alignPickerToComponent() {
    if (!this.pickerComponent)
      return;
    const { pickerType: e } = this.config, { pickerGap: t } = this, i = this.gos.get("enableRtl") ? "right" : "left";
    this.popupService.positionPopupByComponent({ type: e, eventSource: this.eWrapper, ePopup: this.pickerComponent.getGui(), position: "under", alignSide: i, keepWithinBounds: !0, nudgeY: t });
  }
  beforeHidePicker() {
    this.destroyMouseWheelFunc && (this.destroyMouseWheelFunc(), this.destroyMouseWheelFunc = void 0), this.toggleExpandedStyles(!1);
    const e = this.pickerComponent.getGui();
    e.removeEventListener("focusin", this.onPickerFocusIn), e.removeEventListener("focusout", this.onPickerFocusOut), this.isPickerDisplayed = !1, this.pickerComponent = void 0, this.hideCurrentPicker = null;
  }
  toggleExpandedStyles(e) {
    this.isAlive() && (Zt(this.getAriaElement(), e), this.eWrapper.classList.toggle("ag-picker-expanded", e), this.eWrapper.classList.toggle("ag-picker-collapsed", !e));
  }
  onPickerFocusIn() {
    this.togglePickerHasFocus(!0);
  }
  onPickerFocusOut(e) {
    var t;
    (t = this.pickerComponent) != null && t.getGui().contains(e.relatedTarget) || this.togglePickerHasFocus(!1);
  }
  togglePickerHasFocus(e) {
    this.pickerComponent && this.eWrapper.classList.toggle("ag-picker-has-focus", e);
  }
  hidePicker() {
    this.hideCurrentPicker && this.hideCurrentPicker();
  }
  setInputWidth(e) {
    return si(this.eWrapper, e), this;
  }
  getFocusableElement() {
    return this.eWrapper;
  }
  setPickerGap(e) {
    return this.pickerGap = e, this;
  }
  setPickerMinWidth(e) {
    return typeof e == "number" && (e = `${e}px`), this.minPickerWidth = e ?? void 0, this;
  }
  setPickerMaxWidth(e) {
    return typeof e == "number" && (e = `${e}px`), this.maxPickerWidth = e ?? void 0, this;
  }
  setPickerMaxHeight(e) {
    return typeof e == "number" && (e = `${e}px`), this.maxPickerHeight = e ?? void 0, this;
  }
  destroy() {
    this.hidePicker(), super.destroy();
  }
}, ho = class extends ua {
  constructor(e) {
    super({ pickerAriaLabelKey: "ariaLabelSelectField", pickerAriaLabelValue: "Select Field", pickerType: "ag-list", className: "ag-select", pickerIcon: "smallDown", ariaRole: "combobox", ...e });
  }
  postConstruct() {
    super.postConstruct(), this.createListComponent(), this.eWrapper.tabIndex = this.gos.get("tabIndex");
    const { options: e, value: t, placeholder: i } = this.config;
    e != null && this.addOptions(e), t != null && this.setValue(t, !0), i && t == null && (this.eDisplayField.textContent = i), this.addManagedElementListeners(this.eWrapper, { focusout: this.onWrapperFocusOut.bind(this) });
  }
  onWrapperFocusOut(e) {
    this.eWrapper.contains(e.relatedTarget) || this.hidePicker();
  }
  createListComponent() {
    this.listComponent = this.createBean(new ga("select", !0)), this.listComponent.setParentComponent(this);
    const e = this.listComponent.getAriaElement(), t = `ag-select-list-${this.listComponent.getCompId()}`;
    var i, o;
    e.setAttribute("id", t), De(i = this.getAriaElement(), "controls", (o = e).id), Dt(o, i.id), this.listComponent.addManagedListeners(this.listComponent, { selectedItem: () => {
      this.hidePicker(), this.dispatchLocalEvent({ type: "selectedItem" });
    } }), this.listComponent.addManagedListeners(this.listComponent, { fieldValueChanged: () => {
      this.listComponent && (this.setValue(this.listComponent.getValue(), !1, !0), this.hidePicker());
    } });
  }
  createPickerComponent() {
    return this.listComponent;
  }
  onKeyDown(e) {
    var i;
    const { key: t } = e;
    switch (t === v.TAB && this.hidePicker(), t) {
      case v.ENTER:
      case v.UP:
      case v.DOWN:
      case v.PAGE_UP:
      case v.PAGE_DOWN:
      case v.PAGE_HOME:
      case v.PAGE_END:
        e.preventDefault(), this.isPickerDisplayed ? (i = this.listComponent) == null || i.handleKeyDown(e) : super.onKeyDown(e);
        break;
      case v.ESCAPE:
        super.onKeyDown(e);
    }
  }
  showPicker() {
    this.listComponent && (super.showPicker(), this.listComponent.refreshHighlighted());
  }
  addOptions(e) {
    return e.forEach((t) => this.addOption(t)), this;
  }
  addOption(e) {
    return this.listComponent.addOption(e), this;
  }
  clearOptions() {
    var e;
    return (e = this.listComponent) == null || e.clearOptions(), this;
  }
  setValue(e, t, i) {
    if (this.value === e || !this.listComponent)
      return this;
    if (i || this.listComponent.setValue(e, !0), this.listComponent.getValue() === this.getValue())
      return this;
    let o = this.listComponent.getDisplayValue();
    return o == null && this.config.placeholder && (o = this.config.placeholder), this.eDisplayField.textContent = o, this.setTooltip({ newTooltipText: o ?? null, shouldDisplayTooltip: () => this.eDisplayField.scrollWidth > this.eDisplayField.clientWidth }), super.setValue(e, t);
  }
  destroy() {
    this.listComponent && (this.listComponent = this.destroyBean(this.listComponent)), super.destroy();
  }
}, pa = { selector: "AG-SELECT", component: ho }, _s = class {
  constructor() {
    this.customFilterOptions = {};
  }
  init(e, t) {
    this.filterOptions = e.filterOptions || t, this.mapCustomOptions(), this.selectDefaultItem(e);
  }
  getFilterOptions() {
    return this.filterOptions;
  }
  mapCustomOptions() {
    this.filterOptions && this.filterOptions.forEach((e) => {
      typeof e != "string" && ([["displayKey"], ["displayName"], ["predicate", "test"]].every((t) => !!t.some((i) => e[i] != null) || (b(`ignoring FilterOptionDef as it doesn't contain one of '${t}'`), !1)) ? this.customFilterOptions[e.displayKey] = e : this.filterOptions = this.filterOptions.filter((t) => t === e) || []);
    });
  }
  selectDefaultItem(e) {
    if (e.defaultOption)
      this.defaultOption = e.defaultOption;
    else if (this.filterOptions.length >= 1) {
      const t = this.filterOptions[0];
      typeof t == "string" ? this.defaultOption = t : t.displayKey ? this.defaultOption = t.displayKey : b("invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'");
    } else
      b("no filter options for filter");
  }
  getDefaultOption() {
    return this.defaultOption;
  }
  getCustomOption(e) {
    return this.customFilterOptions[e];
  }
}, er = class extends ca {
  constructor() {
    super(...arguments), this.eTypes = [], this.eJoinOperatorPanels = [], this.eJoinOperatorsAnd = [], this.eJoinOperatorsOr = [], this.eConditionBodies = [], this.listener = () => this.onUiChanged(), this.lastUiCompletePosition = null, this.joinOperatorId = 0;
  }
  getNumberOfInputs(e) {
    const t = this.optionsFactory.getCustomOption(e);
    if (t) {
      const { numberOfInputs: i } = t;
      return i ?? 1;
    }
    return e && ["empty", "notBlank", "blank"].indexOf(e) >= 0 ? 0 : e === "inRange" ? 2 : 1;
  }
  onFloatingFilterChanged(e, t) {
    this.setTypeFromFloatingFilter(e), this.setValueFromFloatingFilter(t), this.onUiChanged(!0);
  }
  setTypeFromFloatingFilter(e) {
    this.eTypes.forEach((t, i) => {
      i === 0 ? t.setValue(e, !0) : t.setValue(this.optionsFactory.getDefaultOption(), !0);
    });
  }
  getModelFromUi() {
    const e = this.getUiCompleteConditions();
    return e.length === 0 ? null : this.maxNumConditions > 1 && e.length > 1 ? { filterType: this.getFilterType(), operator: this.getJoinOperator(), conditions: e } : e[0];
  }
  getConditionTypes() {
    return this.eTypes.map((e) => e.getValue());
  }
  getConditionType(e) {
    return this.eTypes[e].getValue();
  }
  getJoinOperator() {
    return this.eJoinOperatorsOr.length === 0 ? this.defaultJoinOperator : this.eJoinOperatorsOr[0].getValue() === !0 ? "OR" : "AND";
  }
  areModelsEqual(e, t) {
    if (!e && !t)
      return !0;
    if (!e && t || e && !t)
      return !1;
    const i = !e.operator, o = !t.operator;
    if (!i && o || i && !o)
      return !1;
    let s;
    if (i) {
      const r = e, n = t;
      s = this.areSimpleModelsEqual(r, n);
    } else {
      const r = e, n = t;
      s = r.operator === n.operator && Ke(r.conditions, n.conditions, (a, l) => this.areSimpleModelsEqual(a, l));
    }
    return s;
  }
  shouldRefresh(e) {
    var s;
    const t = this.getModel(), i = t ? t.conditions ?? [t] : null, o = ((s = e.filterOptions) == null ? void 0 : s.map((r) => typeof r == "string" ? r : r.displayKey)) ?? this.getDefaultFilterOptions();
    return !(i && !i.every((r) => o.find((n) => n === r.type) !== void 0) || typeof e.maxNumConditions == "number" && i && i.length > e.maxNumConditions);
  }
  refresh(e) {
    return !!this.shouldRefresh(e) && !!super.refresh(e) && (this.setParams(e), this.removeConditionsAndOperators(0), this.createOption(), this.setModel(this.getModel()), !0);
  }
  setModelIntoUi(e) {
    if (e.operator) {
      const t = e;
      let i = t.conditions;
      i == null && (i = [], b("Filter model is missing 'conditions'"));
      const o = this.validateAndUpdateConditions(i), s = this.getNumConditions();
      if (o < s)
        this.removeConditionsAndOperators(o);
      else if (o > s)
        for (let n = s; n < o; n++)
          this.createJoinOperatorPanel(), this.createOption();
      const r = t.operator === "OR";
      this.eJoinOperatorsAnd.forEach((n) => n.setValue(!r, !0)), this.eJoinOperatorsOr.forEach((n) => n.setValue(r, !0)), i.forEach((n, a) => {
        this.eTypes[a].setValue(n.type, !0), this.setConditionIntoUi(n, a);
      });
    } else {
      const t = e;
      this.getNumConditions() > 1 && this.removeConditionsAndOperators(1), this.eTypes[0].setValue(t.type, !0), this.setConditionIntoUi(t, 0);
    }
    return this.lastUiCompletePosition = this.getNumConditions() - 1, this.createMissingConditionsAndOperators(), this.onUiChanged(), ee.resolve();
  }
  validateAndUpdateConditions(e) {
    let t = e.length;
    return t > this.maxNumConditions && (e.splice(this.maxNumConditions), b('Filter Model contains more conditions than "filterParams.maxNumConditions". Additional conditions have been ignored.'), t = this.maxNumConditions), t;
  }
  doesFilterPass(e) {
    const t = this.getModel();
    if (t == null)
      return !0;
    const { operator: i } = t, o = [];
    if (i) {
      const s = t;
      o.push(...s.conditions ?? []);
    } else
      o.push(t);
    return o[i && i === "OR" ? "some" : "every"]((s) => this.individualConditionPasses(e, s));
  }
  setParams(e) {
    super.setParams(e), this.setNumConditions(e), this.defaultJoinOperator = this.getDefaultJoinOperator(e.defaultJoinOperator), this.filterPlaceholder = e.filterPlaceholder, this.optionsFactory = new _s(), this.optionsFactory.init(e, this.getDefaultFilterOptions()), this.createFilterListOptions(), this.createOption(), this.createMissingConditionsAndOperators(), this.isReadOnly() && this.eFilterBody.setAttribute("tabindex", "-1");
  }
  setNumConditions(e) {
    this.maxNumConditions = e.maxNumConditions ?? 2, this.maxNumConditions < 1 && (b('"filterParams.maxNumConditions" must be greater than or equal to zero.'), this.maxNumConditions = 1), this.numAlwaysVisibleConditions = e.numAlwaysVisibleConditions ?? 1, this.numAlwaysVisibleConditions < 1 && (b('"filterParams.numAlwaysVisibleConditions" must be greater than or equal to zero.'), this.numAlwaysVisibleConditions = 1), this.numAlwaysVisibleConditions > this.maxNumConditions && (b('"filterParams.numAlwaysVisibleConditions" cannot be greater than "filterParams.maxNumConditions".'), this.numAlwaysVisibleConditions = this.maxNumConditions);
  }
  createOption() {
    const e = this.createManagedBean(new ho());
    this.eTypes.push(e), e.addCssClass("ag-filter-select"), this.eFilterBody.appendChild(e.getGui());
    const t = this.createValueElement();
    this.eConditionBodies.push(t), this.eFilterBody.appendChild(t), this.putOptionsIntoDropdown(e), this.resetType(e);
    const i = this.getNumConditions() - 1;
    this.forEachPositionInput(i, (o) => this.resetInput(o)), this.addChangedListeners(e, i);
  }
  createJoinOperatorPanel() {
    const e = document.createElement("div");
    this.eJoinOperatorPanels.push(e), e.classList.add("ag-filter-condition");
    const t = this.createJoinOperator(this.eJoinOperatorsAnd, e, "and"), i = this.createJoinOperator(this.eJoinOperatorsOr, e, "or");
    this.eFilterBody.appendChild(e);
    const o = this.eJoinOperatorPanels.length - 1, s = this.joinOperatorId++;
    this.resetJoinOperatorAnd(t, o, s), this.resetJoinOperatorOr(i, o, s), this.isReadOnly() || (t.onValueChange(this.listener), i.onValueChange(this.listener));
  }
  createJoinOperator(e, t, i) {
    const o = this.createManagedBean(new ha());
    return e.push(o), o.addCssClass("ag-filter-condition-operator"), o.addCssClass(`ag-filter-condition-operator-${i}`), t.appendChild(o.getGui()), o;
  }
  getDefaultJoinOperator(e) {
    return e === "AND" || e === "OR" ? e : "AND";
  }
  createFilterListOptions() {
    const e = this.optionsFactory.getFilterOptions();
    this.filterListOptions = e.map((t) => typeof t == "string" ? this.createBoilerplateListOption(t) : this.createCustomListOption(t));
  }
  putOptionsIntoDropdown(e) {
    this.filterListOptions.forEach((t) => {
      e.addOption(t);
    }), e.setDisabled(this.filterListOptions.length <= 1);
  }
  createBoilerplateListOption(e) {
    return { value: e, text: this.translate(e) };
  }
  createCustomListOption(e) {
    const { displayKey: t } = e, i = this.optionsFactory.getCustomOption(e.displayKey);
    return { value: t, text: i ? this.localeService.getLocaleTextFunc()(i.displayKey, i.displayName) : this.translate(t) };
  }
  createBodyTemplate() {
    return "";
  }
  getAgComponents() {
    return [];
  }
  getCssIdentifier() {
    return "simple-filter";
  }
  updateUiVisibility() {
    const e = this.getJoinOperator();
    this.updateNumConditions(), this.updateConditionStatusesAndValues(this.lastUiCompletePosition, e);
  }
  updateNumConditions() {
    let e = -1, t = !0;
    for (let i = 0; i < this.getNumConditions(); i++)
      this.isConditionUiComplete(i) ? e = i : t = !1;
    if (this.shouldAddNewConditionAtEnd(t))
      this.createJoinOperatorPanel(), this.createOption();
    else {
      const i = this.lastUiCompletePosition ?? this.getNumConditions() - 2;
      if (e < i) {
        this.removeConditionsAndOperators(i + 1);
        const o = e + 1, s = i - o;
        s > 0 && this.removeConditionsAndOperators(o, s), this.createMissingConditionsAndOperators();
      }
    }
    this.lastUiCompletePosition = e;
  }
  updateConditionStatusesAndValues(e, t) {
    this.eTypes.forEach((o, s) => {
      const r = this.isConditionDisabled(s, e);
      o.setDisabled(r || this.filterListOptions.length <= 1), s === 1 && (Mt(this.eJoinOperatorPanels[0], r), this.eJoinOperatorsAnd[0].setDisabled(r), this.eJoinOperatorsOr[0].setDisabled(r));
    }), this.eConditionBodies.forEach((o, s) => {
      H(o, this.isConditionBodyVisible(s));
    });
    const i = (t ?? this.getJoinOperator()) === "OR";
    this.eJoinOperatorsAnd.forEach((o) => {
      o.setValue(!i, !0);
    }), this.eJoinOperatorsOr.forEach((o) => {
      o.setValue(i, !0);
    }), this.forEachInput((o, s, r, n) => {
      this.setElementDisplayed(o, s < n), this.setElementDisabled(o, this.isConditionDisabled(r, e));
    }), this.resetPlaceholder();
  }
  shouldAddNewConditionAtEnd(e) {
    return e && this.getNumConditions() < this.maxNumConditions && !this.isReadOnly();
  }
  removeConditionsAndOperators(e, t) {
    if (e >= this.getNumConditions())
      return;
    this.removeComponents(this.eTypes, e, t), this.removeElements(this.eConditionBodies, e, t), this.removeValueElements(e, t);
    const i = Math.max(e - 1, 0);
    this.removeElements(this.eJoinOperatorPanels, i, t), this.removeComponents(this.eJoinOperatorsAnd, i, t), this.removeComponents(this.eJoinOperatorsOr, i, t);
  }
  removeElements(e, t, i) {
    this.removeItems(e, t, i).forEach((o) => ve(o));
  }
  removeComponents(e, t, i) {
    this.removeItems(e, t, i).forEach((o) => {
      ve(o.getGui()), this.destroyBean(o);
    });
  }
  removeItems(e, t, i) {
    return i == null ? e.splice(t) : e.splice(t, i);
  }
  afterGuiAttached(e) {
    if (super.afterGuiAttached(e), this.resetPlaceholder(), !(e != null && e.suppressFocus))
      if (this.isReadOnly())
        this.eFilterBody.focus();
      else {
        const t = this.getInputs(0)[0];
        if (!t)
          return;
        t instanceof ze && t.getInputElement().focus();
      }
  }
  afterGuiDetached() {
    super.afterGuiDetached();
    const e = this.getModel();
    this.resetUiToActiveModel(e);
    let t = -1, i = -1, o = !1;
    const s = this.getJoinOperator();
    for (let n = this.getNumConditions() - 1; n >= 0; n--)
      if (this.isConditionUiComplete(n))
        t === -1 && (t = n, i = n);
      else {
        const a = n < t;
        (n >= this.numAlwaysVisibleConditions && !this.isConditionUiComplete(n - 1) || a) && (this.removeConditionsAndOperators(n, 1), o = !0, a && i--);
      }
    let r = !1;
    this.getNumConditions() < this.numAlwaysVisibleConditions && (this.createMissingConditionsAndOperators(), r = !0), this.shouldAddNewConditionAtEnd(i === this.getNumConditions() - 1) && (this.createJoinOperatorPanel(), this.createOption(), r = !0), r && this.updateConditionStatusesAndValues(i, s), o && this.updateJoinOperatorsDisabled(), this.lastUiCompletePosition = i;
  }
  getPlaceholderText(e, t) {
    let i = this.translate(e);
    if (Xi(this.filterPlaceholder)) {
      const o = this.filterPlaceholder, s = this.eTypes[t].getValue();
      i = o({ filterOptionKey: s, filterOption: this.translate(s), placeholder: i });
    } else
      typeof this.filterPlaceholder == "string" && (i = this.filterPlaceholder);
    return i;
  }
  resetPlaceholder() {
    const e = this.localeService.getLocaleTextFunc();
    this.forEachInput((t, i, o, s) => {
      if (!(t instanceof ze))
        return;
      const r = i === 0 && s > 1 ? "inRangeStart" : i === 0 ? "filterOoo" : "inRangeEnd", n = i === 0 && s > 1 ? e("ariaFilterFromValue", "Filter from value") : i === 0 ? e("ariaFilterValue", "Filter Value") : e("ariaFilterToValue", "Filter to Value");
      t.setInputPlaceholder(this.getPlaceholderText(r, o)), t.setInputAriaLabel(n);
    });
  }
  setElementValue(e, t, i) {
    e instanceof ze && e.setValue(t != null ? String(t) : null, !0);
  }
  setElementDisplayed(e, t) {
    e instanceof O && H(e.getGui(), t);
  }
  setElementDisabled(e, t) {
    e instanceof O && Mt(e.getGui(), t);
  }
  attachElementOnChange(e, t) {
    e instanceof ze && e.onValueChange(t);
  }
  forEachInput(e) {
    this.getConditionTypes().forEach((t, i) => {
      this.forEachPositionTypeInput(i, t, e);
    });
  }
  forEachPositionInput(e, t) {
    const i = this.getConditionType(e);
    this.forEachPositionTypeInput(e, i, t);
  }
  forEachPositionTypeInput(e, t, i) {
    const o = this.getNumberOfInputs(t), s = this.getInputs(e);
    for (let r = 0; r < s.length; r++) {
      const n = s[r];
      n != null && i(n, r, e, o);
    }
  }
  isConditionDisabled(e, t) {
    return !!this.isReadOnly() || e !== 0 && e > t + 1;
  }
  isConditionBodyVisible(e) {
    const t = this.getConditionType(e);
    return this.getNumberOfInputs(t) > 0;
  }
  isConditionUiComplete(e) {
    return !(e >= this.getNumConditions()) && this.getConditionType(e) !== "empty" && !this.getValues(e).some((t) => t == null);
  }
  getNumConditions() {
    return this.eTypes.length;
  }
  getUiCompleteConditions() {
    const e = [];
    for (let t = 0; t < this.getNumConditions(); t++)
      this.isConditionUiComplete(t) && e.push(this.createCondition(t));
    return e;
  }
  createMissingConditionsAndOperators() {
    if (!this.isReadOnly())
      for (let e = this.getNumConditions(); e < this.numAlwaysVisibleConditions; e++)
        this.createJoinOperatorPanel(), this.createOption();
  }
  resetUiToDefaults(e) {
    return this.removeConditionsAndOperators(this.isReadOnly() ? 1 : this.numAlwaysVisibleConditions), this.eTypes.forEach((t) => this.resetType(t)), this.eJoinOperatorsAnd.forEach((t, i) => this.resetJoinOperatorAnd(t, i, this.joinOperatorId + i)), this.eJoinOperatorsOr.forEach((t, i) => this.resetJoinOperatorOr(t, i, this.joinOperatorId + i)), this.joinOperatorId++, this.forEachInput((t) => this.resetInput(t)), this.resetPlaceholder(), this.createMissingConditionsAndOperators(), this.lastUiCompletePosition = null, e || this.onUiChanged(), ee.resolve();
  }
  resetType(e) {
    const t = this.localeService.getLocaleTextFunc()("ariaFilteringOperator", "Filtering operator");
    e.setValue(this.optionsFactory.getDefaultOption(), !0).setAriaLabel(t).setDisabled(this.isReadOnly() || this.filterListOptions.length <= 1);
  }
  resetJoinOperatorAnd(e, t, i) {
    this.resetJoinOperator(e, t, this.isDefaultOperator("AND"), this.translate("andCondition"), i);
  }
  resetJoinOperatorOr(e, t, i) {
    this.resetJoinOperator(e, t, this.isDefaultOperator("OR"), this.translate("orCondition"), i);
  }
  resetJoinOperator(e, t, i, o, s) {
    this.updateJoinOperatorDisabled(e.setValue(i, !0).setName(`ag-simple-filter-and-or-${this.getCompId()}-${s}`).setLabel(o), t);
  }
  updateJoinOperatorsDisabled() {
    this.eJoinOperatorsAnd.forEach((e, t) => this.updateJoinOperatorDisabled(e, t)), this.eJoinOperatorsOr.forEach((e, t) => this.updateJoinOperatorDisabled(e, t));
  }
  updateJoinOperatorDisabled(e, t) {
    e.setDisabled(this.isReadOnly() || t > 0);
  }
  resetInput(e) {
    this.setElementValue(e, null), this.setElementDisabled(e, this.isReadOnly());
  }
  setConditionIntoUi(e, t) {
    const i = this.mapValuesFromModel(e);
    this.forEachInput((o, s, r) => {
      r === t && this.setElementValue(o, i[s] != null ? i[s] : null);
    });
  }
  setValueFromFloatingFilter(e) {
    this.forEachInput((t, i, o) => {
      this.setElementValue(t, i === 0 && o === 0 ? e : null, !0);
    });
  }
  isDefaultOperator(e) {
    return e === this.defaultJoinOperator;
  }
  addChangedListeners(e, t) {
    this.isReadOnly() || (e.onValueChange(this.listener), this.forEachPositionInput(t, (i) => {
      this.attachElementOnChange(i, this.listener);
    }));
  }
  individualConditionPasses(e, t) {
    const i = this.getCellValue(e.node), o = this.mapValuesFromModel(t), s = this.optionsFactory.getCustomOption(t.type), r = this.evaluateCustomFilter(s, o, i);
    return r ?? (i == null ? this.evaluateNullValue(t.type) : this.evaluateNonNullValue(o, i, t, e));
  }
  evaluateCustomFilter(e, t, i) {
    if (e == null)
      return;
    const { predicate: o } = e;
    return o == null || t.some((s) => s == null) ? void 0 : o(t, i);
  }
  isBlank(e) {
    return e == null || typeof e == "string" && e.trim().length === 0;
  }
  hasInvalidInputs() {
    return !1;
  }
}, No = class extends er {
  setParams(e) {
    super.setParams(e), this.scalarFilterParams = e;
  }
  evaluateNullValue(e) {
    switch (e) {
      case "equals":
      case "notEqual":
        if (this.scalarFilterParams.includeBlanksInEquals)
          return !0;
        break;
      case "greaterThan":
      case "greaterThanOrEqual":
        if (this.scalarFilterParams.includeBlanksInGreaterThan)
          return !0;
        break;
      case "lessThan":
      case "lessThanOrEqual":
        if (this.scalarFilterParams.includeBlanksInLessThan)
          return !0;
        break;
      case "inRange":
        if (this.scalarFilterParams.includeBlanksInRange)
          return !0;
        break;
      case "blank":
        return !0;
      case "notBlank":
        return !1;
    }
    return !1;
  }
  evaluateNonNullValue(e, t, i) {
    const o = this.comparator(), s = e[0] != null ? o(e[0], t) : 0;
    switch (i.type) {
      case "equals":
        return s === 0;
      case "notEqual":
        return s !== 0;
      case "greaterThan":
        return s > 0;
      case "greaterThanOrEqual":
        return s >= 0;
      case "lessThan":
        return s < 0;
      case "lessThanOrEqual":
        return s <= 0;
      case "inRange": {
        const r = o(e[1], t);
        return this.scalarFilterParams.inRangeInclusive ? s >= 0 && r <= 0 : s > 0 && r < 0;
      }
      case "blank":
        return this.isBlank(t);
      case "notBlank":
        return !this.isBlank(t);
      default:
        return b('Unexpected type of filter "' + i.type + '", it looks like the filter was configured with incorrect Filter Options'), !0;
    }
  }
};
function tr(e) {
  return !(e.altKey || e.ctrlKey || e.metaKey) && e.key.length === 1;
}
function Bi(e, t, i, o, s) {
  const r = o ? o.getColDef().suppressKeyboardEvent : void 0;
  if (!r)
    return !1;
  const n = e.addGridCommonParams({ event: t, editing: s, column: o, node: i, data: i.data, colDef: o.getColDef() });
  return !(!r || !r(n));
}
var Qe = class extends ze {
  constructor(e, t = "ag-text-field", i = "text") {
    super(e, t, i);
  }
  postConstruct() {
    super.postConstruct(), this.config.allowedCharPattern && this.preventDisallowedCharacters();
  }
  setValue(e, t) {
    return this.eInput.value !== e && (this.eInput.value = S(e) ? e : ""), super.setValue(e, t);
  }
  setStartValue(e) {
    this.setValue(e, !0);
  }
  preventDisallowedCharacters() {
    const e = new RegExp(`[${this.config.allowedCharPattern}]`);
    this.addManagedListeners(this.eInput, { keydown: (t) => {
      tr(t) && t.key && !e.test(t.key) && t.preventDefault();
    }, paste: (t) => {
      var o;
      const i = (o = t.clipboardData) == null ? void 0 : o.getData("text");
      i && i.split("").some((s) => !e.test(s)) && t.preventDefault();
    } });
  }
}, ni = { selector: "AG-INPUT-TEXT-FIELD", component: Qe }, go = class extends Qe {
  constructor(e) {
    super(e, "ag-number-field", "number");
  }
  postConstruct() {
    super.postConstruct(), this.addManagedListeners(this.eInput, { blur: () => {
      const s = parseFloat(this.eInput.value), r = isNaN(s) ? "" : this.normalizeValue(s.toString());
      this.value !== r && this.setValue(r);
    }, wheel: this.onWheel.bind(this) }), this.eInput.step = "any";
    const { precision: e, min: t, max: i, step: o } = this.config;
    typeof e == "number" && this.setPrecision(e), typeof t == "number" && this.setMin(t), typeof i == "number" && this.setMax(i), typeof o == "number" && this.setStep(o);
  }
  onWheel(e) {
    this.gos.getActiveDomElement() === this.eInput && e.preventDefault();
  }
  normalizeValue(e) {
    if (e === "")
      return "";
    this.precision != null && (e = this.adjustPrecision(e));
    const t = parseFloat(e);
    return this.min != null && t < this.min ? e = this.min.toString() : this.max != null && t > this.max && (e = this.max.toString()), e;
  }
  adjustPrecision(e, t) {
    if (this.precision == null)
      return e;
    if (t) {
      const o = parseFloat(e).toFixed(this.precision);
      return parseFloat(o).toString();
    }
    const i = String(e).split(".");
    if (i.length > 1) {
      if (i[1].length <= this.precision)
        return e;
      if (this.precision > 0)
        return `${i[0]}.${i[1].slice(0, this.precision)}`;
    }
    return i[0];
  }
  setMin(e) {
    return this.min === e || (this.min = e, Re(this.eInput, "min", e)), this;
  }
  setMax(e) {
    return this.max === e || (this.max = e, Re(this.eInput, "max", e)), this;
  }
  setPrecision(e) {
    return this.precision = e, this;
  }
  setStep(e) {
    return this.step === e || (this.step = e, Re(this.eInput, "step", e)), this;
  }
  setValue(e, t) {
    return this.setValueOrInputValue((i) => super.setValue(i, t), () => this, e);
  }
  setStartValue(e) {
    return this.setValueOrInputValue((t) => super.setValue(t, !0), (t) => {
      this.eInput.value = t;
    }, e);
  }
  setValueOrInputValue(e, t, i) {
    if (S(i)) {
      let o = this.isScientificNotation(i);
      if (o && this.eInput.validity.valid)
        return e(i);
      if (o || (o = (i = this.adjustPrecision(i)) != this.normalizeValue(i)), o)
        return t(i);
    }
    return e(i);
  }
  getValue() {
    if (!this.eInput.validity.valid)
      return;
    const e = this.eInput.value;
    return this.isScientificNotation(e) ? this.adjustPrecision(e, !0) : super.getValue();
  }
  isScientificNotation(e) {
    return typeof e == "string" && e.includes("e");
  }
}, ma = { selector: "AG-INPUT-NUMBER-FIELD", component: go }, ir = ["equals", "notEqual", "greaterThan", "greaterThanOrEqual", "lessThan", "lessThanOrEqual", "inRange", "blank", "notBlank"], uo = class {
  constructor(e, t, i) {
    this.localeService = e, this.optionsFactory = t, this.valueFormatter = i;
  }
  getModelAsString(e) {
    if (!e)
      return null;
    const t = e.operator != null, i = this.localeService.getLocaleTextFunc();
    if (t) {
      const o = e, s = (o.conditions ?? []).map((n) => this.getModelAsString(n)), r = o.operator === "AND" ? "andCondition" : "orCondition";
      return s.join(` ${i(r, Zs[r])} `);
    }
    if (e.type === "blank" || e.type === "notBlank")
      return i(e.type, e.type);
    {
      const o = e, s = this.optionsFactory.getCustomOption(o.type), { displayKey: r, displayName: n, numberOfInputs: a } = s || {};
      return r && n && a === 0 ? (i(r, n), n) : this.conditionToString(o, s);
    }
  }
  updateParams(e) {
    this.optionsFactory = e.optionsFactory;
  }
  formatValue(e) {
    return this.valueFormatter ? this.valueFormatter(e ?? null) ?? "" : String(e);
  }
}, or = class extends uo {
  conditionToString(e, t) {
    const { numberOfInputs: i } = t || {};
    return e.type == "inRange" || i === 2 ? `${this.formatValue(e.filter)}-${this.formatValue(e.filterTo)}` : e.filter != null ? this.formatValue(e.filter) : `${e.type}`;
  }
};
function Hi(e) {
  const { allowedCharPattern: t } = e ?? {};
  return t ?? null;
}
var sr = ["contains", "notContains", "equals", "notEqual", "startsWith", "endsWith", "blank", "notBlank"], rr = class extends uo {
  conditionToString(e, t) {
    const { numberOfInputs: i } = t || {};
    return e.type == "inRange" || i === 2 ? `${e.filter}-${e.filterTo}` : e.filter != null ? `${e.filter}` : `${e.type}`;
  }
};
function nr(e) {
  const t = e && e.trim();
  return t === "" ? e : t;
}
function ar(e) {
  if (typeof e == "number")
    return e;
  if (typeof e == "string") {
    const t = parseInt(e);
    return isNaN(t) ? void 0 : t;
  }
}
function ue(e, t = Number.MAX_VALUE) {
  return (i) => {
    const o = ar(i);
    if (!(o == null || o < e || o > t))
      return o;
  };
}
function Rt(e, t) {
  return e.toString().padStart(t, "0");
}
function re(e, t = !0, i = "-") {
  if (!e)
    return null;
  let o = [e.getFullYear(), e.getMonth() + 1, e.getDate()].map((s) => Rt(s, 2)).join(i);
  return t && (o += " " + [e.getHours(), e.getMinutes(), e.getSeconds()].map((s) => Rt(s, 2)).join(":")), o;
}
var bi = (e) => {
  if (e > 3 && e < 21)
    return "th";
  switch (e % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
  }
  return "th";
};
function xt(e, t = "YYYY-MM-DD") {
  const i = Rt(e.getFullYear(), 4), o = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], s = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], r = { YYYY: () => i.slice(i.length - 4, i.length), YY: () => i.slice(i.length - 2, i.length), Y: () => `${e.getFullYear()}`, MMMM: () => o[e.getMonth()], MMM: () => o[e.getMonth()].slice(0, 3), MM: () => Rt(e.getMonth() + 1, 2), Mo: () => `${e.getMonth() + 1}${bi(e.getMonth() + 1)}`, M: () => `${e.getMonth() + 1}`, Do: () => `${e.getDate()}${bi(e.getDate())}`, DD: () => Rt(e.getDate(), 2), D: () => `${e.getDate()}`, dddd: () => s[e.getDay()], ddd: () => s[e.getDay()].slice(0, 3), dd: () => s[e.getDay()].slice(0, 2), do: () => `${e.getDay()}${bi(e.getDay())}`, d: () => `${e.getDay()}` }, n = new RegExp(Object.keys(r).join("|"), "g");
  return t.replace(n, (a) => a in r ? r[a]() : a);
}
function J(e) {
  if (!e)
    return null;
  const [t, i] = e.split(" ");
  if (!t)
    return null;
  const o = t.split("-").map((h) => parseInt(h, 10));
  if (o.filter((h) => !isNaN(h)).length !== 3)
    return null;
  const [s, r, n] = o, a = new Date(s, r - 1, n);
  if (a.getFullYear() !== s || a.getMonth() !== r - 1 || a.getDate() !== n)
    return null;
  if (!i || i === "00:00:00")
    return a;
  const [l, d, c] = i.split(":").map((h) => parseInt(h, 10));
  return l >= 0 && l < 24 && a.setHours(l), d >= 0 && d < 60 && a.setMinutes(d), c >= 0 && c < 60 && a.setSeconds(c), a;
}
var lr = class {
  constructor(e, t, i, o, s) {
    this.alive = !0, this.context = e, this.eParent = o, t.getDateCompDetails(i).newAgStackInstance().then((r) => {
      this.alive ? (this.dateComp = r, r && (o.appendChild(r.getGui()), r.afterGuiAttached && r.afterGuiAttached(), this.tempValue && r.setDate(this.tempValue), this.disabled != null && this.setDateCompDisabled(this.disabled), s == null || s(this))) : e.destroyBean(r);
    });
  }
  destroy() {
    this.alive = !1, this.dateComp = this.context.destroyBean(this.dateComp);
  }
  getDate() {
    return this.dateComp ? this.dateComp.getDate() : this.tempValue;
  }
  setDate(e) {
    this.dateComp ? this.dateComp.setDate(e) : this.tempValue = e;
  }
  setDisabled(e) {
    this.dateComp ? this.setDateCompDisabled(e) : this.disabled = e;
  }
  setDisplayed(e) {
    H(this.eParent, e);
  }
  setInputPlaceholder(e) {
    this.dateComp && this.dateComp.setInputPlaceholder && this.dateComp.setInputPlaceholder(e);
  }
  setInputAriaLabel(e) {
    this.dateComp && this.dateComp.setInputAriaLabel && this.dateComp.setInputAriaLabel(e);
  }
  afterGuiAttached(e) {
    this.dateComp && typeof this.dateComp.afterGuiAttached == "function" && this.dateComp.afterGuiAttached(e);
  }
  updateParams(e) {
    var i, o;
    let t = !1;
    (i = this.dateComp) != null && i.refresh && typeof this.dateComp.refresh == "function" && this.dateComp.refresh(e) !== null && (t = !0), !t && ((o = this.dateComp) != null && o.onParamsUpdated) && typeof this.dateComp.onParamsUpdated == "function" && this.dateComp.onParamsUpdated(e) !== null && b("Custom date component method 'onParamsUpdated' is deprecated. Use 'refresh' instead.");
  }
  setDateCompDisabled(e) {
    this.dateComp != null && this.dateComp.setDisabled != null && this.dateComp.setDisabled(e);
  }
}, dr = ["equals", "notEqual", "lessThan", "greaterThan", "inRange", "blank", "notBlank"], cr = class extends uo {
  constructor(e, t, i) {
    super(t, i), this.dateFilterParams = e;
  }
  conditionToString(e, t) {
    const { type: i } = e, { numberOfInputs: o } = t || {}, s = i == "inRange" || o === 2, r = J(e.dateFrom), n = J(e.dateTo), a = this.dateFilterParams.inRangeFloatingFilterDateFormat;
    return s ? `${r !== null ? xt(r, a) : "null"}-${n !== null ? xt(n, a) : "null"}` : r != null ? xt(r, a) : `${i}`;
  }
  updateParams(e) {
    super.updateParams(e), this.dateFilterParams = e.dateFilterParams;
  }
}, Go = 1 / 0, po = class extends f {
  constructor(e, t, i, o) {
    super(), this.columnOrGroup = e, this.columnOrGroup = e, this.eCell = t, this.ariaEl = this.eCell.querySelector("[role=columnheader]") || this.eCell, this.colsSpanning = o, this.beans = i;
  }
  setColsSpanning(e) {
    this.colsSpanning = e, this.onLeftChanged();
  }
  getColumnOrGroup() {
    return this.beans.gos.get("enableRtl") && this.colsSpanning ? T(this.colsSpanning) : this.columnOrGroup;
  }
  postConstruct() {
    const e = this.onLeftChanged.bind(this);
    this.addManagedListeners(this.columnOrGroup, { leftChanged: e }), this.setLeftFirstTime(), this.addManagedEventListeners({ displayedColumnsWidthChanged: e }), this.addManagedPropertyListener("domLayout", e);
  }
  setLeftFirstTime() {
    const e = this.beans.gos.get("suppressColumnMoveAnimation"), t = S(this.columnOrGroup.getOldLeft());
    this.beans.columnAnimationService.isActive() && t && !e ? this.animateInLeft() : this.onLeftChanged();
  }
  animateInLeft() {
    const e = this.getColumnOrGroup(), t = e.getLeft(), i = e.getOldLeft(), o = this.modifyLeftForPrintLayout(e, i), s = this.modifyLeftForPrintLayout(e, t);
    this.setLeft(o), this.actualLeft = s, this.beans.columnAnimationService.executeNextVMTurn(() => {
      this.actualLeft === s && this.setLeft(s);
    });
  }
  onLeftChanged() {
    const e = this.getColumnOrGroup(), t = e.getLeft();
    this.actualLeft = this.modifyLeftForPrintLayout(e, t), this.setLeft(this.actualLeft);
  }
  modifyLeftForPrintLayout(e, t) {
    if (!this.beans.gos.isDomLayout("print") || e.getPinned() === "left")
      return t;
    const i = this.beans.visibleColsService.getColsLeftWidth();
    return e.getPinned() === "right" ? i + this.beans.visibleColsService.getBodyContainerWidth() + t : i + t;
  }
  setLeft(e) {
    if (S(e) && (this.eCell.style.left = `${e}px`), V(this.columnOrGroup)) {
      const t = this.columnOrGroup.getLeafColumns();
      if (!t.length)
        return;
      t.length > 1 && de(this.ariaEl, "colspan", t.length);
    }
  }
};
function hr(e, t, i, o) {
  return A(e) ? [] : function(s, r, n, a, l) {
    if (A(s))
      return [];
    let d;
    if (typeof s == "function") {
      const c = function(h, g, u, p) {
        return g.addGridCommonParams({ colDef: h, column: u, columnGroup: p });
      }(r, n, a, l);
      d = s(c);
    } else
      d = s;
    return typeof d == "string" ? [d] : Array.isArray(d) ? [...d] : [];
  }(e.headerClass, e, t, i, o);
}
function gr(e, t, i) {
  e.addOrRemoveCssClass("ag-column-first", i.isColAtEdge(t, "first")), e.addOrRemoveCssClass("ag-column-last", i.isColAtEdge(t, "last"));
}
var va = 0, ur = class pr extends f {
  constructor(t, i, o) {
    super(), this.resizeToggleTimeout = 0, this.resizeMultiplier = 1, this.resizeFeature = null, this.lastFocusEvent = null, this.dragSource = null, this.columnGroupChild = t, this.parentRowCtrl = o, this.beans = i, this.instanceId = t.getUniqueId() + "-" + va++;
  }
  wireBeans(t) {
    this.pinnedWidthService = t.pinnedWidthService, this.focusService = t.focusService, this.userComponentFactory = t.userComponentFactory, this.ctrlsService = t.ctrlsService, this.dragAndDropService = t.dragAndDropService, this.menuService = t.menuService;
  }
  postConstruct() {
    this.addManagedPropertyListeners(["suppressHeaderFocus"], () => this.refreshTabIndex());
  }
  shouldStopEventPropagation(t) {
    const { headerRowIndex: i, column: o } = this.focusService.getFocusedHeader();
    return function(s, r, n, a) {
      const l = a.getDefinition(), d = l && l.suppressHeaderKeyboardEvent;
      return !!S(d) && !!d(s.addGridCommonParams({ colDef: l, column: a, headerRowIndex: n, event: r }));
    }(this.gos, t, i, o);
  }
  getWrapperHasFocus() {
    return this.gos.getActiveDomElement() === this.eGui;
  }
  setGui(t) {
    this.eGui = t, this.addDomData(), this.addManagedListeners(this.beans.eventService, { displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this) }), this.addManagedElementListeners(this.eGui, { focus: this.onGuiFocus.bind(this) }), this.onDisplayedColumnsChanged(), this.refreshTabIndex();
  }
  onGuiFocus() {
    const t = { type: "headerFocused", column: this.column };
    this.eventService.dispatchEvent(t);
  }
  onDisplayedColumnsChanged() {
    this.comp && this.column && (this.refreshFirstAndLastStyles(), this.refreshAriaColIndex());
  }
  refreshFirstAndLastStyles() {
    const { comp: t, column: i, beans: o } = this;
    gr(t, i, o.visibleColsService);
  }
  refreshAriaColIndex() {
    const { beans: t, column: i } = this, o = t.visibleColsService.getAriaColIndex(i);
    xs(this.eGui, o);
  }
  addResizeAndMoveKeyboardListeners() {
    this.resizeFeature && this.addManagedListeners(this.eGui, { keydown: this.onGuiKeyDown.bind(this), keyup: this.onGuiKeyUp.bind(this) });
  }
  refreshTabIndex() {
    this.gos.get("suppressHeaderFocus") ? this.eGui.removeAttribute("tabindex") : this.eGui.setAttribute("tabindex", "-1");
  }
  onGuiKeyDown(t) {
    var n;
    const i = this.gos.getActiveDomElement(), o = t.key === v.LEFT || t.key === v.RIGHT;
    if (this.isResizing && (t.preventDefault(), t.stopImmediatePropagation()), i !== this.eGui || !t.shiftKey && !t.altKey || ((this.isResizing || o) && (t.preventDefault(), t.stopImmediatePropagation()), !o))
      return;
    const s = t.key === v.LEFT !== this.gos.get("enableRtl"), r = Ys[s ? "Left" : "Right"];
    if (t.altKey) {
      this.isResizing = !0, this.resizeMultiplier += 1;
      const a = this.getViewportAdjustedResizeDiff(t);
      this.resizeHeader(a, t.shiftKey), (n = this.resizeFeature) == null || n.toggleColumnResizing(!0);
    } else
      this.moveHeader(r);
  }
  getViewportAdjustedResizeDiff(t) {
    let i = this.getResizeDiff(t);
    if (this.column.getPinned()) {
      const o = this.pinnedWidthService.getPinnedLeftWidth(), s = this.pinnedWidthService.getPinnedRightWidth(), r = Pt(this.ctrlsService.getGridBodyCtrl().getBodyViewportElement()) - 50;
      if (o + s + i > r) {
        if (!(r > o + s))
          return 0;
        i = r - o - s;
      }
    }
    return i;
  }
  getResizeDiff(t) {
    let i = t.key === v.LEFT !== this.gos.get("enableRtl");
    const o = this.column.getPinned(), s = this.gos.get("enableRtl");
    return o && s !== (o === "right") && (i = !i), (i ? -1 : 1) * this.resizeMultiplier;
  }
  onGuiKeyUp() {
    this.isResizing && (this.resizeToggleTimeout && (window.clearTimeout(this.resizeToggleTimeout), this.resizeToggleTimeout = 0), this.isResizing = !1, this.resizeMultiplier = 1, this.resizeToggleTimeout = window.setTimeout(() => {
      var t;
      (t = this.resizeFeature) == null || t.toggleColumnResizing(!1);
    }, 150));
  }
  handleKeyDown(t) {
    const i = this.getWrapperHasFocus();
    switch (t.key) {
      case v.PAGE_DOWN:
      case v.PAGE_UP:
      case v.PAGE_HOME:
      case v.PAGE_END:
        i && t.preventDefault();
    }
  }
  addDomData() {
    const t = pr.DOM_DATA_KEY_HEADER_CTRL;
    this.gos.setDomData(this.eGui, t, this), this.addDestroyFunc(() => this.gos.setDomData(this.eGui, t, null));
  }
  getGui() {
    return this.eGui;
  }
  focus(t) {
    return !!this.eGui && (this.lastFocusEvent = t || null, this.eGui.focus(), !0);
  }
  getRowIndex() {
    return this.parentRowCtrl.getRowIndex();
  }
  getParentRowCtrl() {
    return this.parentRowCtrl;
  }
  getPinned() {
    return this.parentRowCtrl.getPinned();
  }
  getInstanceId() {
    return this.instanceId;
  }
  getColumnGroupChild() {
    return this.columnGroupChild;
  }
  removeDragSource() {
    this.dragSource && (this.dragAndDropService.removeDragSource(this.dragSource), this.dragSource = null);
  }
  handleContextMenuMouseEvent(t, i, o) {
    const s = t ?? i;
    this.gos.get("preventDefaultOnContextMenu") && s.preventDefault();
    const r = Le(o) ? o : void 0;
    this.menuService.isHeaderContextMenuEnabled(r) && this.menuService.showHeaderContextMenu(r, t, i), this.dispatchColumnMouseEvent("columnHeaderContextMenu", o);
  }
  dispatchColumnMouseEvent(t, i) {
    const o = { type: t, column: i };
    this.eventService.dispatchEvent(o);
  }
  destroy() {
    super.destroy(), this.removeDragSource(), this.comp = null, this.column = null, this.resizeFeature = null, this.lastFocusEvent = null, this.columnGroupChild = null, this.parentRowCtrl = null, this.eGui = null;
  }
};
ur.DOM_DATA_KEY_HEADER_CTRL = "headerCtrl";
var ai = ur, mo = class extends f {
  wireBeans(e) {
    this.columnHoverService = e.columnHoverService;
  }
  constructor(e, t) {
    super(), this.columns = e, this.element = t;
  }
  postConstruct() {
    this.gos.get("columnHoverHighlight") && this.addMouseHoverListeners();
  }
  addMouseHoverListeners() {
    this.addManagedListeners(this.element, { mouseout: this.onMouseOut.bind(this), mouseover: this.onMouseOver.bind(this) });
  }
  onMouseOut() {
    this.columnHoverService.clearMouseOver();
  }
  onMouseOver() {
    this.columnHoverService.setMouseOver(this.columns);
  }
}, M = "32.0.2", mr = class extends O {
  wireBeans(e) {
    this.columnNameService = e.columnNameService;
  }
  getDefaultDebounceMs() {
    return 0;
  }
  destroy() {
    super.destroy();
  }
  isEventFromFloatingFilter(e) {
    return e && e.afterFloatingFilter;
  }
  isEventFromDataChange(e) {
    return e == null ? void 0 : e.afterDataChange;
  }
  getLastType() {
    return this.lastType;
  }
  isReadOnly() {
    return this.readOnly;
  }
  setLastTypeFromModel(e) {
    if (!e)
      return void (this.lastType = this.optionsFactory.getDefaultOption());
    let t;
    t = e.operator ? e.conditions[0] : e, this.lastType = t.type;
  }
  canWeEditAfterModelFromParentFilter(e) {
    if (!e)
      return this.isTypeEditable(this.lastType);
    if (e.operator)
      return !1;
    const t = e;
    return this.isTypeEditable(t.type);
  }
  init(e) {
    this.setSimpleParams(e, !1);
  }
  setSimpleParams(e, t = !0) {
    this.optionsFactory = new _s(), this.optionsFactory.init(e.filterParams, this.getDefaultFilterOptions()), t || (this.lastType = this.optionsFactory.getDefaultOption()), this.readOnly = !!e.filterParams.readOnly;
    const i = this.isTypeEditable(this.optionsFactory.getDefaultOption());
    this.setEditable(i);
  }
  onParamsUpdated(e) {
    this.refresh(e);
  }
  refresh(e) {
    this.setSimpleParams(e);
  }
  doesFilterHaveSingleInput(e) {
    const t = this.optionsFactory.getCustomOption(e), { numberOfInputs: i } = t || {};
    return i == null || i == 1;
  }
  isTypeEditable(e) {
    return !!e && !this.isReadOnly() && this.doesFilterHaveSingleInput(e) && ["inRange", "empty", "blank", "notBlank"].indexOf(e) < 0;
  }
  getAriaLabel(e) {
    return `${this.columnNameService.getDisplayNameForColumn(e.column, "header", !0)} ${this.localeService.getLocaleTextFunc()("ariaFilterInput", "Filter Input")}`;
  }
}, zo = class extends f {
  constructor(e) {
    super(), this.params = e, this.eFloatingFilterTextInput = R, this.valueChangedListener = () => {
    };
  }
  setupGui(e) {
    var o;
    this.eFloatingFilterTextInput = this.createManagedBean(new Qe((o = this.params) == null ? void 0 : o.config));
    const t = this.eFloatingFilterTextInput.getGui();
    e.appendChild(t);
    const i = (s) => this.valueChangedListener(s);
    this.addManagedListeners(t, { input: i, keydown: i });
  }
  setEditable(e) {
    this.eFloatingFilterTextInput.setDisabled(!e);
  }
  setAutoComplete(e) {
    this.eFloatingFilterTextInput.setAutoComplete(e);
  }
  getValue() {
    return this.eFloatingFilterTextInput.getValue();
  }
  setValue(e, t) {
    this.eFloatingFilterTextInput.setValue(e, t);
  }
  setValueChangedListener(e) {
    this.valueChangedListener = e;
  }
  setParams(e) {
    this.setAriaLabel(e.ariaLabel), e.autoComplete !== void 0 && this.setAutoComplete(e.autoComplete);
  }
  setAriaLabel(e) {
    this.eFloatingFilterTextInput.setInputAriaLabel(e);
  }
}, Bo = class extends mr {
  constructor() {
    super(...arguments), this.eFloatingFilterInputContainer = R;
  }
  postConstruct() {
    this.setTemplate(`
            <div class="ag-floating-filter-input" role="presentation" data-ref="eFloatingFilterInputContainer"></div>
        `);
  }
  getDefaultDebounceMs() {
    return 500;
  }
  onParentModelChanged(e, t) {
    this.isEventFromFloatingFilter(t) || this.isEventFromDataChange(t) || (this.setLastTypeFromModel(e), this.setEditable(this.canWeEditAfterModelFromParentFilter(e)), this.floatingFilterInputService.setValue(this.getFilterModelFormatter().getModelAsString(e)));
  }
  init(e) {
    this.setupFloatingFilterInputService(e), super.init(e), this.setTextInputParams(e);
  }
  setupFloatingFilterInputService(e) {
    this.floatingFilterInputService = this.createFloatingFilterInputService(e), this.floatingFilterInputService.setupGui(this.eFloatingFilterInputContainer);
  }
  setTextInputParams(e) {
    this.params = e;
    const t = e.browserAutoComplete ?? !1;
    if (this.floatingFilterInputService.setParams({ ariaLabel: this.getAriaLabel(e), autoComplete: t }), this.applyActive = ri(this.params.filterParams), !this.isReadOnly()) {
      const i = co(this.params.filterParams, this.getDefaultDebounceMs()), o = q(this.syncUpWithParentFilter.bind(this), i);
      this.floatingFilterInputService.setValueChangedListener(o);
    }
  }
  onParamsUpdated(e) {
    this.refresh(e);
  }
  refresh(e) {
    super.refresh(e), this.setTextInputParams(e);
  }
  recreateFloatingFilterInputService(e) {
    const t = this.floatingFilterInputService.getValue();
    j(this.eFloatingFilterInputContainer), this.destroyBean(this.floatingFilterInputService), this.setupFloatingFilterInputService(e), this.floatingFilterInputService.setValue(t, !0);
  }
  syncUpWithParentFilter(e) {
    const t = e.key === v.ENTER;
    if (this.applyActive && !t)
      return;
    let i = this.floatingFilterInputService.getValue();
    this.params.filterParams.trimInput && (i = nr(i), this.floatingFilterInputService.setValue(i, !0)), this.params.parentFilterInstance((o) => {
      o && o.onFloatingFilterChanged(this.getLastType() || null, i || null);
    });
  }
  setEditable(e) {
    this.floatingFilterInputService.setEditable(e);
  }
}, fa = class extends f {
  constructor() {
    super(...arguments), this.valueChangedListener = () => {
    }, this.numberInputActive = !0;
  }
  setupGui(e) {
    this.eFloatingFilterNumberInput = this.createManagedBean(new go()), this.eFloatingFilterTextInput = this.createManagedBean(new Qe()), this.eFloatingFilterTextInput.setDisabled(!0);
    const t = this.eFloatingFilterNumberInput.getGui(), i = this.eFloatingFilterTextInput.getGui();
    e.appendChild(t), e.appendChild(i), this.setupListeners(t, (o) => this.valueChangedListener(o)), this.setupListeners(i, (o) => this.valueChangedListener(o));
  }
  setEditable(e) {
    this.numberInputActive = e, this.eFloatingFilterNumberInput.setDisplayed(this.numberInputActive), this.eFloatingFilterTextInput.setDisplayed(!this.numberInputActive);
  }
  setAutoComplete(e) {
    this.eFloatingFilterNumberInput.setAutoComplete(e), this.eFloatingFilterTextInput.setAutoComplete(e);
  }
  getValue() {
    return this.getActiveInputElement().getValue();
  }
  setValue(e, t) {
    this.getActiveInputElement().setValue(e, t);
  }
  getActiveInputElement() {
    return this.numberInputActive ? this.eFloatingFilterNumberInput : this.eFloatingFilterTextInput;
  }
  setValueChangedListener(e) {
    this.valueChangedListener = e;
  }
  setupListeners(e, t) {
    this.addManagedListeners(e, { input: t, keydown: t });
  }
  setParams(e) {
    this.setAriaLabel(e.ariaLabel), e.autoComplete !== void 0 && this.setAutoComplete(e.autoComplete);
  }
  setAriaLabel(e) {
    this.eFloatingFilterNumberInput.setInputAriaLabel(e), this.eFloatingFilterTextInput.setInputAriaLabel(e);
  }
}, vo = { version: M, moduleName: "@ag-grid-community/filter-core", beans: [class extends f {
  constructor() {
    super(...arguments), this.beanName = "filterManager", this.advancedFilterModelUpdateQueue = [];
  }
  wireBeans(e) {
    this.columnModel = e.columnModel, this.dataTypeService = e.dataTypeService, this.quickFilterService = e.quickFilterService, this.advancedFilterService = e.advancedFilterService, this.columnFilterService = e.columnFilterService;
  }
  postConstruct() {
    this.addManagedEventListeners({ columnValueChanged: this.refreshFiltersForAggregations.bind(this), columnPivotChanged: this.refreshFiltersForAggregations.bind(this), columnPivotModeChanged: this.refreshFiltersForAggregations.bind(this), newColumnsLoaded: this.updateAdvancedFilterColumns.bind(this), columnVisible: this.updateAdvancedFilterColumns.bind(this), advancedFilterEnabledChanged: ({ enabled: e }) => this.onAdvancedFilterEnabledChanged(e), dataTypesInferred: this.processFilterModelUpdateQueue.bind(this) }), this.externalFilterPresent = this.isExternalFilterPresentCallback(), this.addManagedPropertyListeners(["isExternalFilterPresent", "doesExternalFilterPass"], () => {
      this.onFilterChanged({ source: "api" });
    }), this.updateAggFiltering(), this.addManagedPropertyListener("groupAggFiltering", () => {
      this.updateAggFiltering(), this.onFilterChanged();
    }), this.addManagedPropertyListener("advancedFilterModel", (e) => this.setAdvancedFilterModel(e.currentValue)), this.quickFilterService && this.addManagedListeners(this.quickFilterService, { quickFilterChanged: () => this.onFilterChanged({ source: "quickFilter" }) });
  }
  isExternalFilterPresentCallback() {
    const e = this.gos.getCallback("isExternalFilterPresent");
    return typeof e == "function" && e({});
  }
  doesExternalFilterPass(e) {
    const t = this.gos.get("doesExternalFilterPass");
    return typeof t == "function" && t(e);
  }
  setFilterModel(e, t = "api") {
    var i;
    this.isAdvancedFilterEnabled() ? this.warnAdvancedFilters() : (i = this.columnFilterService) == null || i.setFilterModel(e, t);
  }
  getFilterModel() {
    var e;
    return ((e = this.columnFilterService) == null ? void 0 : e.getFilterModel()) ?? {};
  }
  isColumnFilterPresent() {
    var e;
    return !!((e = this.columnFilterService) != null && e.isColumnFilterPresent());
  }
  isAggregateFilterPresent() {
    var e;
    return !!((e = this.columnFilterService) != null && e.isAggregateFilterPresent());
  }
  isExternalFilterPresent() {
    return this.externalFilterPresent;
  }
  isChildFilterPresent() {
    return this.isColumnFilterPresent() || this.isQuickFilterPresent() || this.isExternalFilterPresent() || this.isAdvancedFilterPresent();
  }
  isAdvancedFilterPresent() {
    return this.isAdvancedFilterEnabled() && this.advancedFilterService.isFilterPresent();
  }
  onAdvancedFilterEnabledChanged(e) {
    var t, i;
    e ? (t = this.columnFilterService) != null && t.disableColumnFilters() && this.onFilterChanged({ source: "advancedFilter" }) : (i = this.advancedFilterService) != null && i.isFilterPresent() && (this.advancedFilterService.setModel(null), this.onFilterChanged({ source: "advancedFilter" }));
  }
  isAdvancedFilterEnabled() {
    var e;
    return !!((e = this.advancedFilterService) != null && e.isEnabled());
  }
  isAdvancedFilterHeaderActive() {
    return this.isAdvancedFilterEnabled() && this.advancedFilterService.isHeaderActive();
  }
  isAnyFilterPresent() {
    return this.isQuickFilterPresent() || this.isColumnFilterPresent() || this.isAggregateFilterPresent() || this.isExternalFilterPresent() || this.isAdvancedFilterPresent();
  }
  resetQuickFilterCache() {
    var e;
    (e = this.quickFilterService) == null || e.resetQuickFilterCache();
  }
  refreshFiltersForAggregations() {
    this.gos.getGroupAggFiltering() && this.onFilterChanged();
  }
  onFilterChanged(e = {}) {
    const { source: t, additionalEventAttributes: i, columns: o = [] } = e;
    this.externalFilterPresent = this.isExternalFilterPresentCallback(), (this.columnFilterService ? this.columnFilterService.updateBeforeFilterChanged(e) : ee.resolve()).then(() => {
      var r;
      const s = { source: t, type: "filterChanged", columns: o };
      i && oe(s, i), this.eventService.dispatchEvent(s), (r = this.columnFilterService) == null || r.updateAfterFilterChanged();
    });
  }
  isSuppressFlashingCellsBecauseFiltering() {
    var e;
    return !!((e = this.columnFilterService) != null && e.isSuppressFlashingCellsBecauseFiltering());
  }
  isQuickFilterPresent() {
    var e;
    return !!((e = this.quickFilterService) != null && e.isQuickFilterPresent());
  }
  updateAggFiltering() {
    this.aggFiltering = !!this.gos.getGroupAggFiltering();
  }
  isAggregateQuickFilterPresent() {
    return this.isQuickFilterPresent() && this.shouldApplyQuickFilterAfterAgg();
  }
  isNonAggregateQuickFilterPresent() {
    return this.isQuickFilterPresent() && !this.shouldApplyQuickFilterAfterAgg();
  }
  shouldApplyQuickFilterAfterAgg() {
    return (this.aggFiltering || this.columnModel.isPivotMode()) && !this.gos.get("applyQuickFilterBeforePivotOrAgg");
  }
  doesRowPassOtherFilters(e, t) {
    return this.doesRowPassFilter({ rowNode: t, filterInstanceToSkip: e });
  }
  doesRowPassAggregateFilters(e) {
    return !(this.isAggregateQuickFilterPresent() && !this.quickFilterService.doesRowPassQuickFilter(e.rowNode) || this.isAggregateFilterPresent() && !this.columnFilterService.doAggregateFiltersPass(e.rowNode, e.filterInstanceToSkip));
  }
  doesRowPassFilter(e) {
    return !(this.isNonAggregateQuickFilterPresent() && !this.quickFilterService.doesRowPassQuickFilter(e.rowNode) || this.isExternalFilterPresent() && !this.doesExternalFilterPass(e.rowNode) || this.isColumnFilterPresent() && !this.columnFilterService.doColumnFiltersPass(e.rowNode, e.filterInstanceToSkip) || this.isAdvancedFilterPresent() && !this.advancedFilterService.doesFilterPass(e.rowNode));
  }
  isFilterActive(e) {
    var t;
    return !!((t = this.columnFilterService) != null && t.isFilterActive(e));
  }
  getOrCreateFilterWrapper(e) {
    var t;
    return ((t = this.columnFilterService) == null ? void 0 : t.getOrCreateFilterWrapper(e)) ?? null;
  }
  getDefaultFloatingFilter(e) {
    return this.columnFilterService.getDefaultFloatingFilter(e);
  }
  createFilterParams(e, t) {
    return this.columnFilterService.createFilterParams(e, t);
  }
  isFilterAllowed(e) {
    var t;
    return !this.isAdvancedFilterEnabled() && !!((t = this.columnFilterService) != null && t.isFilterAllowed(e));
  }
  getFloatingFilterCompDetails(e, t) {
    var i;
    return (i = this.columnFilterService) == null ? void 0 : i.getFloatingFilterCompDetails(e, t);
  }
  getCurrentFloatingFilterParentModel(e) {
    var t;
    return (t = this.columnFilterService) == null ? void 0 : t.getCurrentFloatingFilterParentModel(e);
  }
  destroyFilter(e, t = "api") {
    var i;
    (i = this.columnFilterService) == null || i.destroyFilter(e, t);
  }
  areFilterCompsDifferent(e, t) {
    var i;
    return !!((i = this.columnFilterService) != null && i.areFilterCompsDifferent(e, t));
  }
  getAdvancedFilterModel() {
    return this.isAdvancedFilterEnabled() ? this.advancedFilterService.getModel() : null;
  }
  setAdvancedFilterModel(e) {
    var t;
    this.isAdvancedFilterEnabled() && ((t = this.dataTypeService) != null && t.isPendingInference() ? this.advancedFilterModelUpdateQueue.push(e) : (this.advancedFilterService.setModel(e ?? null), this.onFilterChanged({ source: "advancedFilter" })));
  }
  toggleAdvancedFilterBuilder(e, t) {
    this.isAdvancedFilterEnabled() && this.advancedFilterService.getCtrl().toggleFilterBuilder(t, e);
  }
  updateAdvancedFilterColumns() {
    this.isAdvancedFilterEnabled() && this.advancedFilterService.updateValidity() && this.onFilterChanged({ source: "advancedFilter" });
  }
  hasFloatingFilters() {
    var e;
    return !this.isAdvancedFilterEnabled() && !!((e = this.columnFilterService) != null && e.hasFloatingFilters());
  }
  getFilterInstance(e, t) {
    var i;
    if (!this.isAdvancedFilterEnabled())
      return (i = this.columnFilterService) == null ? void 0 : i.getFilterInstance(e, t);
    this.warnAdvancedFilters();
  }
  getColumnFilterInstance(e) {
    var t;
    return this.isAdvancedFilterEnabled() ? (this.warnAdvancedFilters(), Promise.resolve(void 0)) : ((t = this.columnFilterService) == null ? void 0 : t.getColumnFilterInstance(e)) ?? Promise.resolve(void 0);
  }
  warnAdvancedFilters() {
    b("Column Filter API methods have been disabled as Advanced Filters are enabled.");
  }
  setupAdvancedFilterHeaderComp(e) {
    var t;
    (t = this.advancedFilterService) == null || t.getCtrl().setupHeaderComp(e);
  }
  getHeaderRowCount() {
    return this.isAdvancedFilterHeaderActive() ? 1 : 0;
  }
  getHeaderHeight() {
    return this.isAdvancedFilterHeaderActive() ? this.advancedFilterService.getCtrl().getHeaderHeight() : 0;
  }
  processFilterModelUpdateQueue() {
    this.advancedFilterModelUpdateQueue.forEach((e) => this.setAdvancedFilterModel(e)), this.advancedFilterModelUpdateQueue = [];
  }
  getColumnFilterModel(e) {
    var t;
    return (t = this.columnFilterService) == null ? void 0 : t.getColumnFilterModel(e);
  }
  setColumnFilterModel(e, t) {
    var i;
    return this.isAdvancedFilterEnabled() ? (this.warnAdvancedFilters(), Promise.resolve()) : ((i = this.columnFilterService) == null ? void 0 : i.setColumnFilterModel(e, t)) ?? Promise.resolve();
  }
}] }, Ca = { version: M, moduleName: "@ag-grid-community/filter-api", apiFunctions: { isAnyFilterPresent: function(e) {
  var t;
  return !!((t = e.filterManager) != null && t.isAnyFilterPresent());
}, onFilterChanged: function(e, t = "api") {
  var i;
  (i = e.filterManager) == null || i.onFilterChanged({ source: t });
} }, dependantModules: [vo] }, fo = { version: M, moduleName: "@ag-grid-community/column-filter", beans: [class extends f {
  constructor() {
    super(...arguments), this.beanName = "columnFilterService", this.allColumnFilters = /* @__PURE__ */ new Map(), this.allColumnListeners = /* @__PURE__ */ new Map(), this.activeAggregateFilters = [], this.activeColumnFilters = [], this.processingFilterChange = !1, this.filterModelUpdateQueue = [], this.columnFilterModelUpdateQueue = [];
  }
  wireBeans(e) {
    this.valueService = e.valueService, this.columnModel = e.columnModel, this.rowModel = e.rowModel, this.userComponentFactory = e.userComponentFactory, this.rowRenderer = e.rowRenderer, this.dataTypeService = e.dataTypeService, this.filterManager = e.filterManager;
  }
  postConstruct() {
    var e, t;
    this.addManagedEventListeners({ gridColumnsChanged: this.onColumnsChanged.bind(this), rowDataUpdated: () => this.onNewRowsLoaded("rowDataUpdated"), dataTypesInferred: this.processFilterModelUpdateQueue.bind(this) }), this.initialFilterModel = { ...((t = (e = this.gos.get("initialState")) == null ? void 0 : e.filter) == null ? void 0 : t.filterModel) ?? {} };
  }
  setFilterModel(e, t = "api") {
    var s;
    if ((s = this.dataTypeService) != null && s.isPendingInference())
      return void this.filterModelUpdateQueue.push({ model: e, source: t });
    const i = [], o = this.getFilterModel();
    if (e) {
      const r = new Set(Object.keys(e));
      this.allColumnFilters.forEach((n, a) => {
        const l = e[a];
        i.push(this.setModelOnFilterWrapper(n.filterPromise, l)), r.delete(a);
      }), r.forEach((n) => {
        const a = this.columnModel.getColDefCol(n) || this.columnModel.getCol(n);
        if (!a)
          return void b("setFilterModel() - no column found for colId: " + n);
        if (!a.isFilterAllowed())
          return void b("setFilterModel() - unable to fully apply model, filtering disabled for colId: " + n);
        const l = this.getOrCreateFilterWrapper(a);
        l ? i.push(this.setModelOnFilterWrapper(l.filterPromise, e[n])) : b("setFilterModel() - unable to fully apply model, unable to create filter for colId: " + n);
      });
    } else
      this.allColumnFilters.forEach((r) => {
        i.push(this.setModelOnFilterWrapper(r.filterPromise, null));
      });
    ee.all(i).then(() => {
      var a;
      const r = this.getFilterModel(), n = [];
      this.allColumnFilters.forEach((l, d) => {
        Xt(o ? o[d] : null, r ? r[d] : null) || n.push(l.column);
      }), n.length > 0 && ((a = this.filterManager) == null || a.onFilterChanged({ columns: n, source: t }));
    });
  }
  setModelOnFilterWrapper(e, t) {
    return new ee((i) => {
      e.then((o) => {
        typeof o.setModel != "function" && (b("filter missing setModel method, which is needed for setFilterModel"), i()), (o.setModel(t) || ee.resolve()).then(() => i());
      });
    });
  }
  getFilterModel() {
    const e = {};
    return this.allColumnFilters.forEach((t, i) => {
      const o = this.getModelFromFilterWrapper(t);
      S(o) && (e[i] = o);
    }), e;
  }
  getModelFromFilterWrapper(e) {
    const { filter: t } = e;
    return t ? typeof t.getModel != "function" ? (b("filter API missing getModel method, which is needed for getFilterModel"), null) : t.getModel() : this.getModelFromInitialState(e.column);
  }
  getModelFromInitialState(e) {
    return this.initialFilterModel[e.getColId()] ?? null;
  }
  isColumnFilterPresent() {
    return this.activeColumnFilters.length > 0;
  }
  isAggregateFilterPresent() {
    return !!this.activeAggregateFilters.length;
  }
  disableColumnFilters() {
    return !!this.allColumnFilters.size && (this.allColumnFilters.forEach((e) => this.disposeFilterWrapper(e, "advancedFilterEnabled")), !0);
  }
  doAggregateFiltersPass(e, t) {
    return this.doColumnFiltersPass(e, t, !0);
  }
  updateActiveFilters() {
    const e = !!this.gos.getGroupAggFiltering(), t = (s) => {
      if (!s.isPrimary())
        return !0;
      const r = !this.columnModel.isPivotActive();
      return !(!s.isValueActive() || !r) && (!!this.columnModel.isPivotMode() || e);
    }, i = [], o = [];
    return this.forEachColumnFilter((s, r) => {
      ((a) => !!a && (a.isFilterActive ? a.isFilterActive() : (b("Filter is missing isFilterActive() method"), !1)))(s) && (t(r.column) ? i.push(s) : o.push(s));
    }).then(() => {
      this.activeAggregateFilters = i, this.activeColumnFilters = o;
    });
  }
  updateFilterFlagInColumns(e, t) {
    return this.forEachColumnFilter((i, o) => o.column.setFilterActive(i.isFilterActive(), e, t));
  }
  forEachColumnFilter(e) {
    return ee.all(Array.from(this.allColumnFilters.values()).map((t) => t.filterPromise.then((i) => e(i, t))));
  }
  doColumnFiltersPass(e, t, i) {
    const { data: o, aggData: s } = e, r = i ? this.activeAggregateFilters : this.activeColumnFilters, n = i ? s : o;
    for (let a = 0; a < r.length; a++) {
      const l = r[a];
      if (l != null && l !== t) {
        if (typeof l.doesFilterPass != "function")
          throw new Error("Filter is missing method doesFilterPass");
        if (!l.doesFilterPass({ node: e, data: n }))
          return !1;
      }
    }
    return !0;
  }
  callOnFilterChangedOutsideRenderCycle(e) {
    const t = () => {
      var i;
      return (i = this.filterManager) == null ? void 0 : i.onFilterChanged(e);
    };
    this.rowRenderer.isRefreshInProgress() ? setTimeout(t, 0) : t();
  }
  updateBeforeFilterChanged(e = {}) {
    const { filterInstance: t, additionalEventAttributes: i } = e;
    return this.updateDependentFilters(), this.updateActiveFilters().then(() => this.updateFilterFlagInColumns("filterChanged", i).then(() => {
      this.allColumnFilters.forEach((o) => {
        o.filterPromise && o.filterPromise.then((s) => {
          s && s !== t && s.onAnyFilterChanged && s.onAnyFilterChanged();
        });
      }), this.processingFilterChange = !0;
    }));
  }
  updateAfterFilterChanged() {
    this.processingFilterChange = !1;
  }
  isSuppressFlashingCellsBecauseFiltering() {
    return !this.gos.get("allowShowChangeAfterFilter") && this.processingFilterChange;
  }
  onNewRowsLoaded(e) {
    this.forEachColumnFilter((t) => {
      t.onNewRowsLoaded && t.onNewRowsLoaded();
    }).then(() => this.updateFilterFlagInColumns(e, { afterDataChange: !0 })).then(() => this.updateActiveFilters());
  }
  createValueGetter(e) {
    return ({ node: t }) => this.valueService.getValue(e, t, !0);
  }
  createGetValue(e) {
    return (t, i) => {
      const o = i ? this.columnModel.getCol(i) : e;
      return o ? this.valueService.getValue(o, t, !0) : void 0;
    };
  }
  isFilterActive(e) {
    const { filter: t } = this.cachedFilter(e) ?? {};
    return t ? t.isFilterActive() : this.getModelFromInitialState(e) != null;
  }
  getOrCreateFilterWrapper(e) {
    if (!e.isFilterAllowed())
      return null;
    let t = this.cachedFilter(e);
    return t || (t = this.createFilterWrapper(e), this.setColumnFilterWrapper(e, t)), t;
  }
  cachedFilter(e) {
    return this.allColumnFilters.get(e.getColId());
  }
  getDefaultFilter(e) {
    var i;
    let t;
    if (Q.__isRegistered("@ag-grid-enterprise/set-filter", this.gridId))
      t = "agSetColumnFilter";
    else {
      const o = (i = this.dataTypeService) == null ? void 0 : i.getBaseDataType(e);
      t = o === "number" ? "agNumberColumnFilter" : o === "date" || o === "dateString" ? "agDateColumnFilter" : "agTextColumnFilter";
    }
    return t;
  }
  getDefaultFloatingFilter(e) {
    var i;
    let t;
    if (Q.__isRegistered("@ag-grid-enterprise/set-filter", this.gridId))
      t = "agSetColumnFloatingFilter";
    else {
      const o = (i = this.dataTypeService) == null ? void 0 : i.getBaseDataType(e);
      t = o === "number" ? "agNumberColumnFloatingFilter" : o === "date" || o === "dateString" ? "agDateColumnFloatingFilter" : "agTextColumnFloatingFilter";
    }
    return t;
  }
  createFilterInstance(e, t) {
    const i = this.getDefaultFilter(e), o = e.getColDef();
    let s;
    const r = { ...this.createFilterParams(e, o), filterModifiedCallback: () => this.filterModifiedCallbackFactory(s, e)(), filterChangedCallback: (a) => this.filterChangedCallbackFactory(s, e)(a), doesRowPassOtherFilter: (a) => !this.filterManager || this.filterManager.doesRowPassOtherFilters(s, a) }, n = this.userComponentFactory.getFilterDetails(o, r, i);
    return n ? { filterPromise: () => {
      const a = n.newAgStackInstance();
      return a != null && a.then((l) => {
        s = l, t && (t.filter = l);
      }), a;
    }, compDetails: n } : { filterPromise: null, compDetails: null };
  }
  createFilterParams(e, t) {
    return this.gos.addGridCommonParams({ column: e, colDef: gs(t), rowModel: this.rowModel, filterChangedCallback: () => {
    }, filterModifiedCallback: () => {
    }, valueGetter: this.createValueGetter(e), getValue: this.createGetValue(e), doesRowPassOtherFilter: () => !0 });
  }
  createFilterWrapper(e) {
    const t = { column: e, filterPromise: null, compiledElement: null, compDetails: null }, { filterPromise: i, compDetails: o } = this.createFilterInstance(e, t);
    return t.filterPromise = (i == null ? void 0 : i()) ?? null, t.compDetails = o, t;
  }
  onColumnsChanged() {
    var t;
    const e = [];
    this.allColumnFilters.forEach((i, o) => {
      let s;
      s = i.column.isPrimary() ? this.columnModel.getColDefCol(o) : this.columnModel.getCol(o), s && s === i.column || (e.push(i.column), this.disposeFilterWrapper(i, "columnChanged"), this.disposeColumnListener(o));
    }), e.length > 0 ? (t = this.filterManager) == null || t.onFilterChanged({ columns: e, source: "api" }) : this.updateDependentFilters();
  }
  updateDependentFilters() {
    const e = this.columnModel.getAutoCols();
    e == null || e.forEach((t) => {
      t.getColDef().filter === "agGroupColumnFilter" && this.getOrCreateFilterWrapper(t);
    });
  }
  isFilterAllowed(e) {
    if (!e.isFilterAllowed())
      return !1;
    const { filter: t } = this.allColumnFilters.get(e.getColId()) ?? {};
    return !t || typeof (t == null ? void 0 : t.isFilterAllowed) != "function" || t.isFilterAllowed();
  }
  getFloatingFilterCompDetails(e, t) {
    const i = (l) => {
      var c;
      const d = (c = this.getOrCreateFilterWrapper(e)) == null ? void 0 : c.filterPromise;
      d != null && d.then((h) => {
        l(St(h));
      });
    }, o = e.getColDef(), s = { ...this.createFilterParams(e, o), filterChangedCallback: () => i((l) => this.filterChangedCallbackFactory(l, e)()) }, r = this.userComponentFactory.mergeParamsWithApplicationProvidedParams(o, Gi, s);
    let n = function(l, d, c) {
      if (d == null)
        return null;
      let h = null;
      const { compName: g, jsComp: u, fwComp: p } = Ks.getCompKeys(l, d, Gi);
      return g ? h = { set: "agSetColumnFloatingFilter", agSetColumnFilter: "agSetColumnFloatingFilter", multi: "agMultiColumnFloatingFilter", agMultiColumnFilter: "agMultiColumnFloatingFilter", group: "agGroupColumnFloatingFilter", agGroupColumnFilter: "agGroupColumnFloatingFilter", number: "agNumberColumnFloatingFilter", agNumberColumnFilter: "agNumberColumnFloatingFilter", date: "agDateColumnFloatingFilter", agDateColumnFilter: "agDateColumnFloatingFilter", text: "agTextColumnFloatingFilter", agTextColumnFilter: "agTextColumnFloatingFilter" }[g] : u == null && p == null && d.filter === !0 && (h = c()), h;
    }(this.frameworkOverrides, o, () => this.getDefaultFloatingFilter(e));
    n == null && (n = "agReadOnlyFloatingFilter");
    const a = { column: e, filterParams: r, currentParentModel: () => this.getCurrentFloatingFilterParentModel(e), parentFilterInstance: i, showParentFilter: t, suppressFilterButton: !1 };
    return this.userComponentFactory.getFloatingFilterCompDetails(o, a, n);
  }
  getCurrentFloatingFilterParentModel(e) {
    return this.getModelFromFilterWrapper(this.cachedFilter(e) ?? { column: e });
  }
  destroyFilter(e, t = "api") {
    var s;
    const i = e.getColId(), o = this.allColumnFilters.get(i);
    this.disposeColumnListener(i), delete this.initialFilterModel[i], o && (this.disposeFilterWrapper(o, t), (s = this.filterManager) == null || s.onFilterChanged({ columns: [e], source: "api" }));
  }
  disposeColumnListener(e) {
    const t = this.allColumnListeners.get(e);
    t && (this.allColumnListeners.delete(e), t());
  }
  disposeFilterWrapper(e, t) {
    e.filterPromise.then((i) => {
      this.destroyBean(i), e.column.setFilterActive(!1, "filterDestroyed"), this.allColumnFilters.delete(e.column.getColId());
      const o = { type: "filterDestroyed", source: t, column: e.column };
      this.eventService.dispatchEvent(o);
    });
  }
  filterModifiedCallbackFactory(e, t) {
    return () => {
      const i = { type: "filterModified", column: t, filterInstance: e };
      this.eventService.dispatchEvent(i);
    };
  }
  filterChangedCallbackFactory(e, t) {
    return (i) => {
      const o = { filter: e, additionalEventAttributes: i, columns: [t], source: (i == null ? void 0 : i.source) ?? "columnFilter" };
      this.callOnFilterChangedOutsideRenderCycle(o);
    };
  }
  checkDestroyFilter(e) {
    const t = this.allColumnFilters.get(e);
    if (!t)
      return;
    const i = t.column, { compDetails: o } = i.isFilterAllowed() ? this.createFilterInstance(i) : { compDetails: null };
    if (this.areFilterCompsDifferent(t.compDetails, o))
      return void this.destroyFilter(i, "paramsUpdated");
    const s = i.getColDef().filterParams;
    t.filterPromise ? t.filterPromise.then((r) => {
      (!(r != null && r.refresh) || r.refresh({ ...this.createFilterParams(i, i.getColDef()), filterModifiedCallback: this.filterModifiedCallbackFactory(r, i), filterChangedCallback: this.filterChangedCallbackFactory(r, i), doesRowPassOtherFilter: (n) => !this.filterManager || this.filterManager.doesRowPassOtherFilters(r, n), ...s })) === !1 && this.destroyFilter(i, "paramsUpdated");
    }) : this.destroyFilter(i, "paramsUpdated");
  }
  setColumnFilterWrapper(e, t) {
    const i = e.getColId();
    this.allColumnFilters.set(i, t), this.allColumnListeners.set(i, this.addManagedListeners(e, { colDefChanged: () => this.checkDestroyFilter(i) })[0]);
  }
  areFilterCompsDifferent(e, t) {
    if (!t || !e)
      return !0;
    const { componentClass: i } = e, { componentClass: o } = t;
    return !(i === o || i != null && i.render && (o != null && o.render) && i.render === o.render);
  }
  hasFloatingFilters() {
    return this.columnModel.getCols().some((e) => e.getColDef().floatingFilter);
  }
  getFilterInstance(e, t) {
    t && this.getFilterInstanceImpl(e).then((i) => {
      const o = St(i);
      t(o);
    });
  }
  getColumnFilterInstance(e) {
    return new Promise((t) => {
      this.getFilterInstanceImpl(e).then((i) => {
        t(St(i));
      });
    });
  }
  getFilterInstanceImpl(e) {
    var o;
    const t = this.columnModel.getColDefCol(e);
    return t ? ((o = this.getOrCreateFilterWrapper(t)) == null ? void 0 : o.filterPromise) ?? ee.resolve(null) : ee.resolve(void 0);
  }
  processFilterModelUpdateQueue() {
    this.filterModelUpdateQueue.forEach(({ model: e, source: t }) => this.setFilterModel(e, t)), this.filterModelUpdateQueue = [], this.columnFilterModelUpdateQueue.forEach(({ key: e, model: t, resolve: i }) => {
      this.setColumnFilterModel(e, t).then(() => i());
    }), this.columnFilterModelUpdateQueue = [];
  }
  getColumnFilterModel(e) {
    const t = this.getFilterWrapper(e);
    return t ? this.getModelFromFilterWrapper(t) : null;
  }
  setColumnFilterModel(e, t) {
    var r;
    if ((r = this.dataTypeService) != null && r.isPendingInference()) {
      let n = () => {
      };
      const a = new Promise((l) => {
        n = l;
      });
      return this.columnFilterModelUpdateQueue.push({ key: e, model: t, resolve: n }), a;
    }
    const i = this.columnModel.getColDefCol(e), o = i ? this.getOrCreateFilterWrapper(i) : null;
    return o ? (s = this.setModelOnFilterWrapper(o.filterPromise, t), new Promise((n) => {
      s.then((a) => n(a));
    })) : Promise.resolve();
    var s;
  }
  getFilterWrapper(e) {
    const t = this.columnModel.getColDefCol(e);
    return t ? this.cachedFilter(t) ?? null : null;
  }
  destroy() {
    super.destroy(), this.allColumnFilters.forEach((e) => this.disposeFilterWrapper(e, "gridDestroyed")), this.allColumnListeners.clear();
  }
}], dependantModules: [vo] }, wa = { version: M, moduleName: "@ag-grid-community/column-filter-api", apiFunctions: { isColumnFilterPresent: function(e) {
  var t, i;
  return !!((t = e.filterManager) != null && t.isColumnFilterPresent()) || !!((i = e.filterManager) != null && i.isAggregateFilterPresent());
}, getFilterInstance: function(e, t, i) {
  var o;
  return (o = e.filterManager) == null ? void 0 : o.getFilterInstance(t, i);
}, getColumnFilterInstance: function(e, t) {
  var i;
  return ((i = e.filterManager) == null ? void 0 : i.getColumnFilterInstance(t)) ?? Promise.resolve(void 0);
}, destroyFilter: function(e, t) {
  var o;
  const i = e.columnModel.getColDefCol(t);
  if (i)
    return (o = e.filterManager) == null ? void 0 : o.destroyFilter(i, "api");
}, setFilterModel: function(e, t) {
  e.frameworkOverrides.wrapIncoming(() => {
    var i;
    return (i = e.filterManager) == null ? void 0 : i.setFilterModel(t);
  });
}, getFilterModel: function(e) {
  var t;
  return ((t = e.filterManager) == null ? void 0 : t.getFilterModel()) ?? {};
}, getColumnFilterModel: function(e, t) {
  var i;
  return ((i = e.filterManager) == null ? void 0 : i.getColumnFilterModel(t)) ?? null;
}, setColumnFilterModel: function(e, t, i) {
  var o;
  return ((o = e.filterManager) == null ? void 0 : o.setColumnFilterModel(t, i)) ?? Promise.resolve();
}, showColumnFilter: function(e, t) {
  const i = e.columnModel.getCol(t);
  i ? e.menuService.showFilterMenu({ column: i, containerType: "columnFilter", positionBy: "auto" }) : L(`column '${t}' not found`);
} }, dependantModules: [fo, Ca] }, vr = { version: M, moduleName: "@ag-grid-community/floating-filter-core", controllers: [{ name: "headerFilterCell", classImp: class extends ai {
  constructor(e, t, i) {
    super(e, t, i), this.iconCreated = !1, this.column = e;
  }
  setComp(e, t, i, o) {
    this.comp = e, this.eButtonShowMainFilter = i, this.eFloatingFilterBody = o, this.setGui(t), this.setupActive(), this.setupWidth(), this.setupLeft(), this.setupHover(), this.setupFocus(), this.setupAria(), this.setupFilterButton(), this.setupUserComp(), this.setupSyncWithFilter(), this.setupUi(), this.addManagedElementListeners(this.eButtonShowMainFilter, { click: this.showParentFilter.bind(this) }), this.setupFilterChangedListener(), this.addManagedListeners(this.column, { colDefChanged: this.onColDefChanged.bind(this) });
  }
  resizeHeader() {
  }
  moveHeader() {
  }
  setupActive() {
    const e = this.column.getColDef(), t = !!e.filter, i = !!e.floatingFilter;
    this.active = t && i;
  }
  setupUi() {
    if (this.comp.setButtonWrapperDisplayed(!this.suppressFilterButton && this.active), this.comp.addOrRemoveBodyCssClass("ag-floating-filter-full-body", this.suppressFilterButton), this.comp.addOrRemoveBodyCssClass("ag-floating-filter-body", !this.suppressFilterButton), !this.active || this.iconCreated)
      return;
    const e = te("filter", this.gos, this.column);
    e && (this.iconCreated = !0, this.eButtonShowMainFilter.appendChild(e));
  }
  setupFocus() {
    this.createManagedBean(new qe(this.eGui, { shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this), onTabKeyDown: this.onTabKeyDown.bind(this), handleKeyDown: this.handleKeyDown.bind(this), onFocusIn: this.onFocusIn.bind(this) }));
  }
  setupAria() {
    const e = this.localeService.getLocaleTextFunc();
    lt(this.eButtonShowMainFilter, e("ariaFilterMenuOpen", "Open Filter Menu"));
  }
  onTabKeyDown(e) {
    if (this.gos.getActiveDomElement() === this.eGui)
      return;
    const t = this.focusService.findNextFocusableElement(this.eGui, null, e.shiftKey);
    if (t)
      return this.beans.headerNavigationService.scrollToColumn(this.column), e.preventDefault(), void t.focus();
    const i = this.findNextColumnWithFloatingFilter(e.shiftKey);
    i && this.focusService.focusHeaderPosition({ headerPosition: { headerRowIndex: this.getParentRowCtrl().getRowIndex(), column: i }, event: e }) && e.preventDefault();
  }
  findNextColumnWithFloatingFilter(e) {
    const t = this.beans.visibleColsService;
    let i = this.column;
    do
      if (i = e ? t.getColBefore(i) : t.getColAfter(i), !i)
        break;
    while (!i.getColDef().filter || !i.getColDef().floatingFilter);
    return i;
  }
  handleKeyDown(e) {
    super.handleKeyDown(e);
    const t = this.getWrapperHasFocus();
    switch (e.key) {
      case v.UP:
      case v.DOWN:
        t || e.preventDefault();
      case v.LEFT:
      case v.RIGHT:
        if (t)
          return;
        e.stopPropagation();
      case v.ENTER:
        t && this.focusService.focusInto(this.eGui) && e.preventDefault();
        break;
      case v.ESCAPE:
        t || this.eGui.focus();
    }
  }
  onFocusIn(e) {
    if (this.eGui.contains(e.relatedTarget))
      return;
    const t = !!e.relatedTarget && !e.relatedTarget.classList.contains("ag-floating-filter"), i = !!e.relatedTarget && rt(e.relatedTarget, "ag-floating-filter");
    if (t && i && e.target === this.eGui) {
      const s = this.lastFocusEvent, r = !(!s || s.key !== v.TAB);
      if (s && r) {
        const n = s.shiftKey;
        this.focusService.focusInto(this.eGui, n);
      }
    }
    const o = this.getRowIndex();
    this.beans.focusService.setFocusedHeader(o, this.column);
  }
  setupHover() {
    this.createManagedBean(new mo([this.column], this.eGui));
    const e = () => {
      if (!this.gos.get("columnHoverHighlight"))
        return;
      const t = this.beans.columnHoverService.isHovered(this.column);
      this.comp.addOrRemoveCssClass("ag-column-hover", t);
    };
    this.addManagedEventListeners({ columnHoverChanged: e }), e();
  }
  setupLeft() {
    const e = new po(this.column, this.eGui, this.beans);
    this.createManagedBean(e);
  }
  setupFilterButton() {
    this.suppressFilterButton = !this.menuService.isFloatingFilterButtonEnabled(this.column), this.highlightFilterButtonWhenActive = !this.menuService.isLegacyMenuEnabled();
  }
  setupUserComp() {
    var t;
    if (!this.active)
      return;
    const e = (t = this.beans.filterManager) == null ? void 0 : t.getFloatingFilterCompDetails(this.column, () => this.showParentFilter());
    e && this.setCompDetails(e);
  }
  setCompDetails(e) {
    this.userCompDetails = e, this.comp.setCompDetails(e);
  }
  showParentFilter() {
    const e = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
    this.menuService.showFilterMenu({ column: this.column, buttonElement: e, containerType: "floatingFilter", positionBy: "button" });
  }
  setupSyncWithFilter() {
    if (!this.active)
      return;
    const { filterManager: e } = this.beans, t = (i) => {
      if ((i == null ? void 0 : i.source) === "filterDestroyed" && !this.isAlive())
        return;
      const o = this.comp.getFloatingFilterComp();
      o && o.then((s) => {
        if (s) {
          const r = e == null ? void 0 : e.getCurrentFloatingFilterParentModel(this.column), n = i ? { ...i, columns: i.columns ?? [], source: i.source === "api" ? "api" : "columnFilter" } : null;
          s.onParentModelChanged(r, n);
        }
      });
    };
    [this.destroySyncListener] = this.addManagedListeners(this.column, { filterChanged: t }), e != null && e.isFilterActive(this.column) && t(null);
  }
  setupWidth() {
    const e = () => {
      const t = `${this.column.getActualWidth()}px`;
      this.comp.setWidth(t);
    };
    this.addManagedListeners(this.column, { widthChanged: e }), e();
  }
  setupFilterChangedListener() {
    this.active && ([this.destroyFilterChangedListener] = this.addManagedListeners(this.column, { filterChanged: this.updateFilterButton.bind(this) }), this.updateFilterButton());
  }
  updateFilterButton() {
    var e;
    if (!this.suppressFilterButton && this.comp) {
      const t = !!((e = this.beans.filterManager) != null && e.isFilterAllowed(this.column));
      this.comp.setButtonWrapperDisplayed(t), this.highlightFilterButtonWhenActive && t && this.eButtonShowMainFilter.classList.toggle("ag-filter-active", this.column.isFilterActive());
    }
  }
  onColDefChanged() {
    var s;
    const e = this.active;
    this.setupActive();
    const t = !e && this.active;
    e && !this.active && (this.destroySyncListener(), this.destroyFilterChangedListener());
    const i = this.active ? (s = this.beans.filterManager) == null ? void 0 : s.getFloatingFilterCompDetails(this.column, () => this.showParentFilter()) : null, o = this.comp.getFloatingFilterComp();
    o && i ? o.then((r) => {
      var n;
      !r || (n = this.beans.filterManager) != null && n.areFilterCompsDifferent(this.userCompDetails ?? null, i) ? this.updateCompDetails(i, t) : this.updateFloatingFilterParams(i);
    }) : this.updateCompDetails(i, t);
  }
  updateCompDetails(e, t) {
    this.isAlive() && (this.setCompDetails(e), this.setupFilterButton(), this.setupUi(), t && (this.setupSyncWithFilter(), this.setupFilterChangedListener()));
  }
  updateFloatingFilterParams(e) {
    var i;
    if (!e)
      return;
    const t = e.params;
    (i = this.comp.getFloatingFilterComp()) == null || i.then((o) => {
      let s = !1;
      o != null && o.refresh && typeof o.refresh == "function" && o.refresh(t) !== null && (s = !0), !s && (o != null && o.onParamsUpdated) && typeof o.onParamsUpdated == "function" && o.onParamsUpdated(t) !== null && b("Custom floating filter method 'onParamsUpdated' is deprecated. Use 'refresh' instead.");
    });
  }
  destroy() {
    super.destroy(), this.eButtonShowMainFilter = null, this.eFloatingFilterBody = null, this.userCompDetails = null, this.destroySyncListener = null, this.destroyFilterChangedListener = null;
  }
} }], dependantModules: [fo] }, ba = { version: M, moduleName: "@ag-grid-community/read-only-floating-filter", userComponents: [{ name: "agReadOnlyFloatingFilter", classImp: class extends O {
  constructor() {
    super(`
            <div class="ag-floating-filter-input" role="presentation">
                <ag-input-text-field data-ref="eFloatingFilterText"></ag-input-text-field>
            </div>`, [ni]), this.eFloatingFilterText = R;
  }
  wireBeans(e) {
    this.columnNameService = e.columnNameService;
  }
  destroy() {
    super.destroy();
  }
  init(e) {
    this.params = e;
    const t = this.columnNameService.getDisplayNameForColumn(e.column, "header", !0), i = this.localeService.getLocaleTextFunc();
    this.eFloatingFilterText.setDisabled(!0).setInputAriaLabel(`${t} ${i("ariaFilterInput", "Filter Input")}`);
  }
  onParentModelChanged(e) {
    e != null ? this.params.parentFilterInstance((t) => {
      if (t.getModelAsString) {
        const i = t.getModelAsString(e);
        this.eFloatingFilterText.setValue(i);
      }
    }) : this.eFloatingFilterText.setValue("");
  }
  onParamsUpdated(e) {
    this.refresh(e);
  }
  refresh(e) {
    this.init(e);
  }
} }], dependantModules: [vr] }, ya = { version: M, moduleName: "@ag-grid-community/simple-filter", dependantModules: [fo], userComponents: [{ name: "agTextColumnFilter", classImp: class extends er {
  constructor() {
    super("textFilter"), this.defaultFormatter = (e) => e, this.defaultLowercaseFormatter = (e) => e == null ? null : e.toString().toLowerCase(), this.defaultMatcher = ({ filterOption: e, value: t, filterText: i }) => {
      if (i == null)
        return !1;
      switch (e) {
        case "contains":
          return t.indexOf(i) >= 0;
        case "notContains":
          return t.indexOf(i) < 0;
        case "equals":
          return t === i;
        case "notEqual":
          return t != i;
        case "startsWith":
          return t.indexOf(i) === 0;
        case "endsWith": {
          const o = t.lastIndexOf(i);
          return o >= 0 && o === t.length - i.length;
        }
        default:
          return !1;
      }
    }, this.eValuesFrom = [], this.eValuesTo = [];
  }
  getDefaultDebounceMs() {
    return 500;
  }
  setParams(e) {
    this.textFilterParams = e, super.setParams(e), this.matcher = this.getTextMatcher(), this.formatter = this.textFilterParams.textFormatter || (this.textFilterParams.caseSensitive ? this.defaultFormatter : this.defaultLowercaseFormatter), this.filterModelFormatter = new rr(this.localeService, this.optionsFactory);
  }
  getTextMatcher() {
    const e = this.textFilterParams.textCustomComparator;
    return e ? (b("textCustomComparator is deprecated, use textMatcher instead."), ({ filterOption: t, value: i, filterText: o }) => e(t, i, o)) : this.textFilterParams.textMatcher || this.defaultMatcher;
  }
  createCondition(e) {
    const t = this.getConditionType(e), i = { filterType: this.getFilterType(), type: t }, o = this.getValuesWithSideEffects(e, !0);
    return o.length > 0 && (i.filter = o[0]), o.length > 1 && (i.filterTo = o[1]), i;
  }
  getFilterType() {
    return "text";
  }
  areSimpleModelsEqual(e, t) {
    return e.filter === t.filter && e.filterTo === t.filterTo && e.type === t.type;
  }
  getInputs(e) {
    return e >= this.eValuesFrom.length ? [null, null] : [this.eValuesFrom[e], this.eValuesTo[e]];
  }
  getValues(e) {
    return this.getValuesWithSideEffects(e, !1);
  }
  getValuesWithSideEffects(e, t) {
    const i = [];
    return this.forEachPositionInput(e, (o, s, r, n) => {
      if (s < n) {
        let a = Ve(o.getValue());
        t && this.textFilterParams.trimInput && (a = nr(a) ?? null, o.setValue(a, !0)), i.push(a);
      }
    }), i;
  }
  getDefaultFilterOptions() {
    return sr;
  }
  createValueElement() {
    const e = document.createElement("div");
    return e.classList.add("ag-filter-body"), X(e, "presentation"), this.createFromToElement(e, this.eValuesFrom, "from"), this.createFromToElement(e, this.eValuesTo, "to"), e;
  }
  createFromToElement(e, t, i) {
    const o = this.createManagedBean(new Qe());
    o.addCssClass(`ag-filter-${i}`), o.addCssClass("ag-filter-filter"), t.push(o), e.appendChild(o.getGui());
  }
  removeValueElements(e, t) {
    this.removeComponents(this.eValuesFrom, e, t), this.removeComponents(this.eValuesTo, e, t);
  }
  mapValuesFromModel(e) {
    const { filter: t, filterTo: i, type: o } = e || {};
    return [t || null, i || null].slice(0, this.getNumberOfInputs(o));
  }
  evaluateNullValue(e) {
    return !!e && ["notEqual", "notContains", "blank"].indexOf(e) >= 0;
  }
  evaluateNonNullValue(e, t, i, o) {
    const s = e.map((g) => this.formatter(g)) || [], r = this.formatter(t), { api: n, colDef: a, column: l, context: d, textFormatter: c } = this.textFilterParams;
    if (i.type === "blank")
      return this.isBlank(t);
    if (i.type === "notBlank")
      return !this.isBlank(t);
    const h = { api: n, colDef: a, column: l, context: d, node: o.node, data: o.data, filterOption: i.type, value: r, textFormatter: c };
    return s.some((g) => this.matcher({ ...h, filterText: g }));
  }
  getModelAsString(e) {
    return this.filterModelFormatter.getModelAsString(e) ?? "";
  }
} }, { name: "agNumberColumnFilter", classImp: class extends No {
  constructor() {
    super("numberFilter"), this.eValuesFrom = [], this.eValuesTo = [];
  }
  refresh(e) {
    return this.numberFilterParams.allowedCharPattern === e.allowedCharPattern && super.refresh(e);
  }
  mapValuesFromModel(e) {
    const { filter: t, filterTo: i, type: o } = e || {};
    return [this.processValue(t), this.processValue(i)].slice(0, this.getNumberOfInputs(o));
  }
  getDefaultDebounceMs() {
    return 500;
  }
  comparator() {
    return (e, t) => e === t ? 0 : e < t ? 1 : -1;
  }
  setParams(e) {
    this.numberFilterParams = e, super.setParams(e), this.filterModelFormatter = new or(this.localeService, this.optionsFactory, this.numberFilterParams.numberFormatter);
  }
  getDefaultFilterOptions() {
    return ir;
  }
  setElementValue(e, t, i) {
    const o = !i && this.numberFilterParams.numberFormatter ? this.numberFilterParams.numberFormatter(t ?? null) : t;
    super.setElementValue(e, o);
  }
  createValueElement() {
    const e = Hi(this.numberFilterParams), t = document.createElement("div");
    return t.classList.add("ag-filter-body"), X(t, "presentation"), this.createFromToElement(t, this.eValuesFrom, "from", e), this.createFromToElement(t, this.eValuesTo, "to", e), t;
  }
  createFromToElement(e, t, i, o) {
    const s = this.createManagedBean(o ? new Qe({ allowedCharPattern: o }) : new go());
    s.addCssClass(`ag-filter-${i}`), s.addCssClass("ag-filter-filter"), t.push(s), e.appendChild(s.getGui());
  }
  removeValueElements(e, t) {
    this.removeComponents(this.eValuesFrom, e, t), this.removeComponents(this.eValuesTo, e, t);
  }
  getValues(e) {
    const t = [];
    return this.forEachPositionInput(e, (i, o, s, r) => {
      o < r && t.push(this.processValue(this.stringToFloat(i.getValue())));
    }), t;
  }
  areSimpleModelsEqual(e, t) {
    return e.filter === t.filter && e.filterTo === t.filterTo && e.type === t.type;
  }
  getFilterType() {
    return "number";
  }
  processValue(e) {
    return e == null || isNaN(e) ? null : e;
  }
  stringToFloat(e) {
    if (typeof e == "number")
      return e;
    let t = Ve(e);
    return t != null && t.trim() === "" && (t = null), this.numberFilterParams.numberParser ? this.numberFilterParams.numberParser(t) : t == null || t.trim() === "-" ? null : parseFloat(t);
  }
  createCondition(e) {
    const t = this.getConditionType(e), i = { filterType: this.getFilterType(), type: t }, o = this.getValues(e);
    return o.length > 0 && (i.filter = o[0]), o.length > 1 && (i.filterTo = o[1]), i;
  }
  getInputs(e) {
    return e >= this.eValuesFrom.length ? [null, null] : [this.eValuesFrom[e], this.eValuesTo[e]];
  }
  getModelAsString(e) {
    return this.filterModelFormatter.getModelAsString(e) ?? "";
  }
  hasInvalidInputs() {
    let e = !1;
    return this.forEachInput((t) => {
      t.getInputElement().validity.valid || (e = !0);
    }), e;
  }
} }, { name: "agDateColumnFilter", classImp: class extends No {
  constructor() {
    super("dateFilter"), this.eConditionPanelsFrom = [], this.eConditionPanelsTo = [], this.dateConditionFromComps = [], this.dateConditionToComps = [], this.minValidYear = 1e3, this.maxValidYear = Go, this.minValidDate = null, this.maxValidDate = null;
  }
  wireBeans(e) {
    super.wireBeans(e), this.context = e.context, this.userComponentFactory = e.userComponentFactory;
  }
  afterGuiAttached(e) {
    super.afterGuiAttached(e), this.dateConditionFromComps[0].afterGuiAttached(e);
  }
  mapValuesFromModel(e) {
    const { dateFrom: t, dateTo: i, type: o } = e || {};
    return [t && J(t) || null, i && J(i) || null].slice(0, this.getNumberOfInputs(o));
  }
  comparator() {
    return this.dateFilterParams.comparator ? this.dateFilterParams.comparator : this.defaultComparator.bind(this);
  }
  defaultComparator(e, t) {
    return t == null || t < e ? -1 : t > e ? 1 : 0;
  }
  setParams(e) {
    this.dateFilterParams = e, super.setParams(e);
    const t = (i, o) => {
      if (e[i] != null) {
        if (!isNaN(e[i]))
          return e[i] == null ? o : Number(e[i]);
        b(`DateFilter ${i} is not a number`);
      }
      return o;
    };
    this.minValidYear = t("minValidYear", 1e3), this.maxValidYear = t("maxValidYear", Go), this.minValidYear > this.maxValidYear && b("DateFilter minValidYear should be <= maxValidYear"), e.minValidDate ? this.minValidDate = e.minValidDate instanceof Date ? e.minValidDate : J(e.minValidDate) : this.minValidDate = null, e.maxValidDate ? this.maxValidDate = e.maxValidDate instanceof Date ? e.maxValidDate : J(e.maxValidDate) : this.maxValidDate = null, this.minValidDate && this.maxValidDate && this.minValidDate > this.maxValidDate && b("DateFilter minValidDate should be <= maxValidDate"), this.filterModelFormatter = new cr(this.dateFilterParams, this.localeService, this.optionsFactory);
  }
  createDateCompWrapper(e) {
    const t = new lr(this.context, this.userComponentFactory, { onDateChanged: () => this.onUiChanged(), filterParams: this.dateFilterParams }, e);
    return this.addDestroyFunc(() => t.destroy()), t;
  }
  setElementValue(e, t) {
    e.setDate(t);
  }
  setElementDisplayed(e, t) {
    e.setDisplayed(t);
  }
  setElementDisabled(e, t) {
    e.setDisabled(t);
  }
  getDefaultFilterOptions() {
    return dr;
  }
  createValueElement() {
    const e = this.gos.getDocument().createElement("div");
    return e.classList.add("ag-filter-body"), this.createFromToElement(e, this.eConditionPanelsFrom, this.dateConditionFromComps, "from"), this.createFromToElement(e, this.eConditionPanelsTo, this.dateConditionToComps, "to"), e;
  }
  createFromToElement(e, t, i, o) {
    const s = this.gos.getDocument().createElement("div");
    s.classList.add(`ag-filter-${o}`), s.classList.add(`ag-filter-date-${o}`), t.push(s), e.appendChild(s), i.push(this.createDateCompWrapper(s));
  }
  removeValueElements(e, t) {
    this.removeDateComps(this.dateConditionFromComps, e, t), this.removeDateComps(this.dateConditionToComps, e, t), this.removeItems(this.eConditionPanelsFrom, e, t), this.removeItems(this.eConditionPanelsTo, e, t);
  }
  removeDateComps(e, t, i) {
    this.removeItems(e, t, i).forEach((o) => o.destroy());
  }
  isValidDateValue(e) {
    if (e === null)
      return !1;
    if (this.minValidDate) {
      if (e < this.minValidDate)
        return !1;
    } else if (e.getUTCFullYear() < this.minValidYear)
      return !1;
    if (this.maxValidDate) {
      if (e > this.maxValidDate)
        return !1;
    } else if (e.getUTCFullYear() > this.maxValidYear)
      return !1;
    return !0;
  }
  isConditionUiComplete(e) {
    if (!super.isConditionUiComplete(e))
      return !1;
    let t = !0;
    return this.forEachInput((i, o, s, r) => {
      s !== e || !t || o >= r || (t = t && this.isValidDateValue(i.getDate()));
    }), t;
  }
  areSimpleModelsEqual(e, t) {
    return e.dateFrom === t.dateFrom && e.dateTo === t.dateTo && e.type === t.type;
  }
  getFilterType() {
    return "date";
  }
  createCondition(e) {
    const t = this.getConditionType(e), i = {}, o = this.getValues(e);
    return o.length > 0 && (i.dateFrom = re(o[0])), o.length > 1 && (i.dateTo = re(o[1])), { dateFrom: null, dateTo: null, filterType: this.getFilterType(), type: t, ...i };
  }
  resetPlaceholder() {
    const e = this.localeService.getLocaleTextFunc(), t = this.translate("dateFormatOoo"), i = e("ariaFilterValue", "Filter Value");
    this.forEachInput((o) => {
      o.setInputPlaceholder(t), o.setInputAriaLabel(i);
    });
  }
  getInputs(e) {
    return e >= this.dateConditionFromComps.length ? [null, null] : [this.dateConditionFromComps[e], this.dateConditionToComps[e]];
  }
  getValues(e) {
    const t = [];
    return this.forEachPositionInput(e, (i, o, s, r) => {
      o < r && t.push(i.getDate());
    }), t;
  }
  translate(e) {
    return e === "lessThan" ? super.translate("before") : e === "greaterThan" ? super.translate("after") : super.translate(e);
  }
  getModelAsString(e) {
    return this.filterModelFormatter.getModelAsString(e) ?? "";
  }
} }, { name: "agDateInput", classImp: class extends O {
  constructor() {
    super(`
            <div class="ag-filter-filter">
                <ag-input-text-field class="ag-date-filter" data-ref="eDateInput"></ag-input-text-field>
            </div>`, [ni]), this.eDateInput = R;
  }
  destroy() {
    super.destroy();
  }
  init(e) {
    this.params = e, this.setParams(e);
    const t = this.eDateInput.getInputElement();
    this.addManagedListeners(t, { mouseDown: () => {
      this.eDateInput.isDisabled() || this.usingSafariDatePicker || t.focus();
    }, input: (i) => {
      i.target === this.gos.getActiveDomElement() && (this.eDateInput.isDisabled() || this.params.onDateChanged());
    } });
  }
  setParams(e) {
    const t = this.eDateInput.getInputElement(), i = this.shouldUseBrowserDatePicker(e);
    this.usingSafariDatePicker = i && Me(), t.type = i ? "date" : "text";
    const { minValidYear: o, maxValidYear: s, minValidDate: r, maxValidDate: n } = e.filterParams || {};
    if (r && o && b("DateFilter should not have both minValidDate and minValidYear parameters set at the same time! minValidYear will be ignored."), n && s && b("DateFilter should not have both maxValidDate and maxValidYear parameters set at the same time! maxValidYear will be ignored."), r && n) {
      const [a, l] = [r, n].map((d) => d instanceof Date ? d : J(d));
      a && l && a.getTime() > l.getTime() && b("DateFilter parameter minValidDate should always be lower than or equal to parameter maxValidDate.");
    }
    r ? r instanceof Date ? t.min = xt(r) : t.min = r : o && (t.min = `${o}-01-01`), n ? n instanceof Date ? t.max = xt(n) : t.max = n : s && (t.max = `${s}-12-31`);
  }
  onParamsUpdated(e) {
    this.refresh(e);
  }
  refresh(e) {
    this.params = e, this.setParams(e);
  }
  getDate() {
    return J(this.eDateInput.getValue());
  }
  setDate(e) {
    this.eDateInput.setValue(re(e, !1));
  }
  setInputPlaceholder(e) {
    this.eDateInput.setInputPlaceholder(e);
  }
  setInputAriaLabel(e) {
    this.eDateInput.setAriaLabel(e);
  }
  setDisabled(e) {
    this.eDateInput.setDisabled(e);
  }
  afterGuiAttached(e) {
    e && e.suppressFocus || this.eDateInput.getInputElement().focus();
  }
  shouldUseBrowserDatePicker(e) {
    return e.filterParams && e.filterParams.browserDatePicker != null ? e.filterParams.browserDatePicker : to() || Ds() || Me() && Fs() >= 14.1;
  }
} }] }, Sa = { version: M, moduleName: "@ag-grid-community/simple-floating-filter", dependantModules: [ya, vr], userComponents: [{ name: "agTextColumnFloatingFilter", classImp: class extends Bo {
  init(e) {
    super.init(e), this.filterModelFormatter = new rr(this.localeService, this.optionsFactory);
  }
  onParamsUpdated(e) {
    this.refresh(e);
  }
  refresh(e) {
    super.refresh(e), this.filterModelFormatter.updateParams({ optionsFactory: this.optionsFactory });
  }
  getDefaultFilterOptions() {
    return sr;
  }
  getFilterModelFormatter() {
    return this.filterModelFormatter;
  }
  createFloatingFilterInputService() {
    return this.createManagedBean(new zo());
  }
} }, { name: "agNumberColumnFloatingFilter", classImp: class extends Bo {
  init(e) {
    var t;
    super.init(e), this.filterModelFormatter = new or(this.localeService, this.optionsFactory, (t = e.filterParams) == null ? void 0 : t.numberFormatter);
  }
  onParamsUpdated(e) {
    this.refresh(e);
  }
  refresh(e) {
    Hi(e.filterParams) !== this.allowedCharPattern && this.recreateFloatingFilterInputService(e), super.refresh(e), this.filterModelFormatter.updateParams({ optionsFactory: this.optionsFactory });
  }
  getDefaultFilterOptions() {
    return ir;
  }
  getFilterModelFormatter() {
    return this.filterModelFormatter;
  }
  createFloatingFilterInputService(e) {
    return this.allowedCharPattern = Hi(e.filterParams), this.allowedCharPattern ? this.createManagedBean(new zo({ config: { allowedCharPattern: this.allowedCharPattern } })) : this.createManagedBean(new fa());
  }
} }, { name: "agDateColumnFloatingFilter", classImp: class extends mr {
  constructor() {
    super(`
            <div class="ag-floating-filter-input" role="presentation">
                <ag-input-text-field data-ref="eReadOnlyText"></ag-input-text-field>
                <div data-ref="eDateWrapper" style="display: flex;"></div>
            </div>`, [ni]), this.eReadOnlyText = R, this.eDateWrapper = R;
  }
  wireBeans(e) {
    super.wireBeans(e), this.context = e.context, this.userComponentFactory = e.userComponentFactory;
  }
  getDefaultFilterOptions() {
    return dr;
  }
  init(e) {
    super.init(e), this.params = e, this.filterParams = e.filterParams, this.createDateComponent(), this.filterModelFormatter = new cr(this.filterParams, this.localeService, this.optionsFactory);
    const t = this.localeService.getLocaleTextFunc();
    this.eReadOnlyText.setDisabled(!0).setInputAriaLabel(t("ariaDateFilterInput", "Date Filter Input"));
  }
  onParamsUpdated(e) {
    this.refresh(e);
  }
  refresh(e) {
    super.refresh(e), this.params = e, this.filterParams = e.filterParams, this.updateDateComponent(), this.filterModelFormatter.updateParams({ optionsFactory: this.optionsFactory, dateFilterParams: this.filterParams }), this.updateCompOnModelChange(e.currentParentModel());
  }
  updateCompOnModelChange(e) {
    const t = !this.isReadOnly() && this.canWeEditAfterModelFromParentFilter(e);
    if (this.setEditable(t), t) {
      if (e) {
        const i = e;
        this.dateComp.setDate(J(i.dateFrom));
      } else
        this.dateComp.setDate(null);
      this.eReadOnlyText.setValue("");
    } else
      this.eReadOnlyText.setValue(this.filterModelFormatter.getModelAsString(e)), this.dateComp.setDate(null);
  }
  setEditable(e) {
    H(this.eDateWrapper, e), H(this.eReadOnlyText.getGui(), !e);
  }
  onParentModelChanged(e, t) {
    this.isEventFromFloatingFilter(t) || this.isEventFromDataChange(t) || (super.setLastTypeFromModel(e), this.updateCompOnModelChange(e));
  }
  onDateChanged() {
    const e = re(this.dateComp.getDate());
    this.params.parentFilterInstance((t) => {
      if (t) {
        const i = J(e);
        t.onFloatingFilterChanged(this.getLastType() || null, i);
      }
    });
  }
  getDateComponentParams() {
    const e = co(this.params.filterParams, this.getDefaultDebounceMs());
    return { onDateChanged: q(this.onDateChanged.bind(this), e), filterParams: this.params.column.getColDef().filterParams };
  }
  createDateComponent() {
    this.dateComp = new lr(this.context, this.userComponentFactory, this.getDateComponentParams(), this.eDateWrapper, (e) => {
      e.setInputAriaLabel(this.getAriaLabel(this.params));
    }), this.addDestroyFunc(() => this.dateComp.destroy());
  }
  updateDateComponent() {
    const e = this.gos.addGridCommonParams(this.getDateComponentParams());
    this.dateComp.updateParams(e);
  }
  getFilterModelFormatter() {
    return this.filterModelFormatter;
  }
} }] }, Ho = { version: M, moduleName: "@ag-grid-community/quick-filter-core", beans: [class extends f {
  constructor() {
    super(...arguments), this.beanName = "quickFilterService", this.quickFilter = null, this.quickFilterParts = null;
  }
  wireBeans(e) {
    this.valueService = e.valueService, this.columnModel = e.columnModel, this.rowModel = e.rowModel, this.pivotResultColsService = e.pivotResultColsService;
  }
  postConstruct() {
    const e = this.resetQuickFilterCache.bind(this);
    this.addManagedEventListeners({ columnPivotModeChanged: e, newColumnsLoaded: e, columnRowGroupChanged: e, columnVisible: () => {
      this.gos.get("includeHiddenColumnsInQuickFilter") || this.resetQuickFilterCache();
    } }), this.addManagedPropertyListener("quickFilterText", (t) => this.setQuickFilter(t.currentValue)), this.addManagedPropertyListeners(["includeHiddenColumnsInQuickFilter", "applyQuickFilterBeforePivotOrAgg"], () => this.onQuickFilterColumnConfigChanged()), this.quickFilter = this.parseQuickFilter(this.gos.get("quickFilterText")), this.parser = this.gos.get("quickFilterParser"), this.matcher = this.gos.get("quickFilterMatcher"), this.setQuickFilterParts(), this.addManagedPropertyListeners(["quickFilterMatcher", "quickFilterParser"], () => this.setQuickFilterParserAndMatcher());
  }
  refreshQuickFilterCols() {
    var s;
    const e = this.columnModel.isPivotMode(), t = this.columnModel.getAutoCols(), i = this.columnModel.getColDefCols();
    let o = (e && !this.gos.get("applyQuickFilterBeforePivotOrAgg") ? (s = this.pivotResultColsService.getPivotResultCols()) == null ? void 0 : s.list : i) ?? [];
    t && (o = o.concat(t)), this.colsForQuickFilter = this.gos.get("includeHiddenColumnsInQuickFilter") ? o : o.filter((r) => r.isVisible() || r.isRowGroupActive());
  }
  isQuickFilterPresent() {
    return this.quickFilter !== null;
  }
  doesRowPassQuickFilter(e) {
    const t = this.gos.get("cacheQuickFilter");
    return this.matcher ? this.doesRowPassQuickFilterMatcher(t, e) : this.quickFilterParts.every((i) => t ? this.doesRowPassQuickFilterCache(e, i) : this.doesRowPassQuickFilterNoCache(e, i));
  }
  resetQuickFilterCache() {
    this.rowModel.forEachNode((e) => e.quickFilterAggregateText = null);
  }
  setQuickFilterParts() {
    const { quickFilter: e, parser: t } = this;
    this.quickFilterParts = e ? t ? t(e) : e.split(" ") : null;
  }
  parseQuickFilter(e) {
    return S(e) ? this.gos.isRowModelType("clientSide") ? e.toUpperCase() : (b("Quick filtering only works with the Client-Side Row Model"), null) : null;
  }
  setQuickFilter(e) {
    if (e != null && typeof e != "string")
      return void b("Grid option quickFilterText only supports string inputs, received: " + typeof e);
    const t = this.parseQuickFilter(e);
    this.quickFilter !== t && (this.quickFilter = t, this.setQuickFilterParts(), this.dispatchLocalEvent({ type: "quickFilterChanged" }));
  }
  setQuickFilterParserAndMatcher() {
    const e = this.gos.get("quickFilterParser"), t = this.gos.get("quickFilterMatcher"), i = e !== this.parser || t !== this.matcher;
    this.parser = e, this.matcher = t, i && (this.setQuickFilterParts(), this.dispatchLocalEvent({ type: "quickFilterChanged" }));
  }
  onQuickFilterColumnConfigChanged() {
    this.refreshQuickFilterCols(), this.resetQuickFilterCache(), this.isQuickFilterPresent() && this.dispatchLocalEvent({ type: "quickFilterChanged" });
  }
  doesRowPassQuickFilterNoCache(e, t) {
    return this.colsForQuickFilter.some((i) => {
      const o = this.getQuickFilterTextForColumn(i, e);
      return S(o) && o.indexOf(t) >= 0;
    });
  }
  doesRowPassQuickFilterCache(e, t) {
    return this.checkGenerateQuickFilterAggregateText(e), e.quickFilterAggregateText.indexOf(t) >= 0;
  }
  doesRowPassQuickFilterMatcher(e, t) {
    let i;
    e ? (this.checkGenerateQuickFilterAggregateText(t), i = t.quickFilterAggregateText) : i = this.getQuickFilterAggregateText(t);
    const { quickFilterParts: o, matcher: s } = this;
    return s(o, i);
  }
  checkGenerateQuickFilterAggregateText(e) {
    e.quickFilterAggregateText || (e.quickFilterAggregateText = this.getQuickFilterAggregateText(e));
  }
  getQuickFilterTextForColumn(e, t) {
    let i = this.valueService.getValue(e, t, !0);
    const o = e.getColDef();
    if (o.getQuickFilterText) {
      const s = this.gos.addGridCommonParams({ value: i, node: t, data: t.data, column: e, colDef: o });
      i = o.getQuickFilterText(s);
    }
    return S(i) ? i.toString().toUpperCase() : null;
  }
  getQuickFilterAggregateText(e) {
    const t = [];
    return this.colsForQuickFilter.forEach((i) => {
      const o = this.getQuickFilterTextForColumn(i, e);
      S(o) && t.push(o);
    }), t.join(`
`);
  }
}], dependantModules: [vo] }, Ra = { version: M, moduleName: "@ag-grid-community/filter", dependantModules: [Sa, ba, { version: M, moduleName: "@ag-grid-community/quick-filter", dependantModules: [Ho, { version: M, moduleName: "@ag-grid-community/quick-filter-api", apiFunctions: { isQuickFilterPresent: function(e) {
  var t;
  return !!((t = e.filterManager) != null && t.isQuickFilterPresent());
}, getQuickFilter: function(e) {
  return e.gos.get("quickFilterText");
}, resetQuickFilter: function(e) {
  var t;
  (t = e.filterManager) == null || t.resetQuickFilterCache();
} }, dependantModules: [Ho] }] }, wa] }, Co = class extends O {
  constructor(e, t) {
    super(e), this.ctrl = t;
  }
  getCtrl() {
    return this.ctrl;
  }
}, xa = class extends Co {
  constructor(e) {
    super(`<div class="ag-header-cell ag-floating-filter" role="gridcell">
            <div data-ref="eFloatingFilterBody" role="presentation"></div>
            <div class="ag-floating-filter-button ag-hidden" data-ref="eButtonWrapper" role="presentation">
                <button type="button" class="ag-button ag-floating-filter-button-button" data-ref="eButtonShowMainFilter" tabindex="-1"></button>
            </div>
        </div>`, e), this.eFloatingFilterBody = R, this.eButtonWrapper = R, this.eButtonShowMainFilter = R;
  }
  postConstruct() {
    const e = this.getGui(), t = { addOrRemoveCssClass: (i, o) => this.addOrRemoveCssClass(i, o), addOrRemoveBodyCssClass: (i, o) => this.eFloatingFilterBody.classList.toggle(i, o), setButtonWrapperDisplayed: (i) => H(this.eButtonWrapper, i), setCompDetails: (i) => this.setCompDetails(i), getFloatingFilterComp: () => this.compPromise, setWidth: (i) => e.style.width = i, setMenuIcon: (i) => this.eButtonShowMainFilter.appendChild(i) };
    this.ctrl.setComp(t, e, this.eButtonShowMainFilter, this.eFloatingFilterBody);
  }
  setCompDetails(e) {
    if (!e)
      return this.destroyFloatingFilterComp(), void (this.compPromise = null);
    this.compPromise = e.newAgStackInstance(), this.compPromise.then((t) => this.afterCompCreated(t));
  }
  destroy() {
    this.destroyFloatingFilterComp(), super.destroy();
  }
  destroyFloatingFilterComp() {
    this.floatingFilterComp && (this.eFloatingFilterBody.removeChild(this.floatingFilterComp.getGui()), this.floatingFilterComp = this.destroyBean(this.floatingFilterComp));
  }
  afterCompCreated(e) {
    e && (this.isAlive() ? (this.destroyFloatingFilterComp(), this.floatingFilterComp = e, this.eFloatingFilterBody.appendChild(e.getGui()), e.afterGuiAttached && e.afterGuiAttached()) : this.destroyBean(e));
  }
}, Fa = class extends Co {
  constructor(e) {
    super(`<div class="ag-header-cell" role="columnheader">
            <div data-ref="eResize" class="ag-header-cell-resize" role="presentation"></div>
            <div data-ref="eHeaderCompWrapper" class="ag-header-cell-comp-wrapper" role="presentation"></div>
        </div>`, e), this.eResize = R, this.eHeaderCompWrapper = R, this.headerCompVersion = 0, this.column = e.getColumnGroupChild(), this.pinned = e.getPinned();
  }
  postConstruct() {
    const e = this.getGui();
    var t, i;
    t = "col-id", (i = this.column.getColId()) != null && i != "" ? e.setAttribute(t, i) : e.removeAttribute(t);
    const o = { setWidth: (r) => e.style.width = r, addOrRemoveCssClass: (r, n) => this.addOrRemoveCssClass(r, n), setAriaSort: (r) => r ? function(n, a) {
      de(n, "sort", a);
    }(e, r) : void bs(e, "sort"), setUserCompDetails: (r) => this.setUserCompDetails(r), getUserCompInstance: () => this.headerComp };
    this.ctrl.setComp(o, this.getGui(), this.eResize, this.eHeaderCompWrapper);
    const s = this.ctrl.getSelectAllGui();
    this.eResize.insertAdjacentElement("afterend", s);
  }
  destroy() {
    this.destroyHeaderComp(), super.destroy();
  }
  destroyHeaderComp() {
    this.headerComp && (this.eHeaderCompWrapper.removeChild(this.headerCompGui), this.headerComp = this.destroyBean(this.headerComp), this.headerCompGui = void 0);
  }
  setUserCompDetails(e) {
    this.headerCompVersion++;
    const t = this.headerCompVersion;
    e.newAgStackInstance().then((i) => this.afterCompCreated(t, i));
  }
  afterCompCreated(e, t) {
    e == this.headerCompVersion && this.isAlive() ? (this.destroyHeaderComp(), this.headerComp = t, this.headerCompGui = t.getGui(), this.eHeaderCompWrapper.appendChild(this.headerCompGui), this.ctrl.setDragSource(this.getGui())) : this.destroyBean(t);
  }
}, Da = class extends Co {
  constructor(e) {
    super(`<div class="ag-header-group-cell" role="columnheader">
            <div data-ref="eResize" class="ag-header-cell-resize" role="presentation"></div>
        </div>`, e), this.eResize = R;
  }
  postConstruct() {
    const e = this.getGui();
    e.setAttribute("col-id", this.ctrl.getColId());
    const t = { addOrRemoveCssClass: (i, o) => this.addOrRemoveCssClass(i, o), setResizableDisplayed: (i) => H(this.eResize, i), setWidth: (i) => e.style.width = i, setAriaExpanded: (i) => {
      return o = "aria-expanded", (s = i) != null ? e.setAttribute(o, s) : e.removeAttribute(o);
      var o, s;
    }, setUserCompDetails: (i) => this.setUserCompDetails(i), getUserCompInstance: () => this.headerGroupComp };
    this.ctrl.setComp(t, e, this.eResize);
  }
  setUserCompDetails(e) {
    e.newAgStackInstance().then((t) => this.afterHeaderCompCreated(t));
  }
  afterHeaderCompCreated(e) {
    const t = () => this.destroyBean(e);
    if (!this.isAlive())
      return void t();
    const i = this.getGui(), o = e.getGui();
    i.appendChild(o), this.addDestroyFunc(t), this.headerGroupComp = e, this.ctrl.setDragSource(i);
  }
}, Ma = class extends O {
  constructor(e) {
    super(), this.headerComps = {}, this.ctrl = e, this.setTemplate(`<div class="${this.ctrl.getHeaderRowClass()}" role="row"></div>`);
  }
  postConstruct() {
    Rs(this.getGui(), this.ctrl.getAriaRowIndex());
    const e = { setHeight: (t) => this.getGui().style.height = t, setTop: (t) => this.getGui().style.top = t, setHeaderCtrls: (t, i) => this.setHeaderCtrls(t, i), setWidth: (t) => this.getGui().style.width = t };
    this.ctrl.setComp(e);
  }
  destroy() {
    this.setHeaderCtrls([], !1), super.destroy();
  }
  setHeaderCtrls(e, t) {
    if (!this.isAlive())
      return;
    const i = this.headerComps;
    if (this.headerComps = {}, e.forEach((o) => {
      const s = o.getInstanceId();
      let r = i[s];
      delete i[s], r == null && (r = this.createHeaderComp(o), this.getGui().appendChild(r.getGui())), this.headerComps[s] = r;
    }), le(i, (o, s) => {
      this.getGui().removeChild(s.getGui()), this.destroyBean(s);
    }), t) {
      const o = Ie(this.headerComps);
      o.sort((r, n) => r.getCtrl().getColumnGroupChild().getLeft() - n.getCtrl().getColumnGroupChild().getLeft());
      const s = o.map((r) => r.getGui());
      Os(this.getGui(), s);
    }
  }
  createHeaderComp(e) {
    let t;
    switch (this.ctrl.getType()) {
      case "group":
        t = new Da(e);
        break;
      case "filter":
        t = new xa(e);
        break;
      default:
        t = new Fa(e);
    }
    return this.createBean(t), t.setParentComponent(this), t;
  }
}, Ea = class extends f {
  constructor() {
    super(...arguments), this.beanName = "headerNavigationService", this.currentHeaderRowWithoutSpan = -1;
  }
  wireBeans(e) {
    this.focusService = e.focusService, this.headerPositionUtils = e.headerPositionUtils, this.ctrlsService = e.ctrlsService, this.columnModel = e.columnModel, this.visibleColService = e.visibleColsService;
  }
  postConstruct() {
    this.ctrlsService.whenReady((t) => {
      this.gridBodyCon = t.gridBodyCtrl;
    });
    const e = this.gos.getDocument();
    this.addManagedElementListeners(e, { mousedown: () => this.setCurrentHeaderRowWithoutSpan(-1) });
  }
  getHeaderRowCount() {
    const e = this.ctrlsService.getHeaderRowContainerCtrl();
    return e ? e.getRowCount() : 0;
  }
  getHeaderPositionForColumn(e, t) {
    let i;
    if (typeof e == "string" ? (i = this.columnModel.getCol(e), i || (i = this.visibleColService.getColumnGroup(e))) : i = e, !i)
      return null;
    const o = T(this.ctrlsService.getHeaderRowContainerCtrl().getAllCtrls()).getType() === "filter", s = this.getHeaderRowCount() - 1;
    let r = -1, n = i;
    for (; n; )
      r++, n = n.getParent();
    let a = r;
    return t && o && a === s - 1 && a++, a === -1 ? null : { headerRowIndex: a, column: i };
  }
  navigateVertically(e, t, i) {
    if (t || (t = this.focusService.getFocusedHeader()), !t)
      return !1;
    const { headerRowIndex: o } = t, s = t.column, r = this.getHeaderRowCount(), n = e === 0;
    let { headerRowIndex: a, column: l, headerRowIndexWithoutSpan: d } = n ? this.headerPositionUtils.getColumnVisibleParent(s, o) : this.headerPositionUtils.getColumnVisibleChild(s, o), c = !1;
    return a < 0 && (a = 0, l = s, c = !0), a >= r ? (a = -1, this.setCurrentHeaderRowWithoutSpan(-1)) : d !== void 0 && (this.currentHeaderRowWithoutSpan = d), !(!c && !l) && this.focusService.focusHeaderPosition({ headerPosition: { headerRowIndex: a, column: l }, allowUserOverride: !0, event: i });
  }
  setCurrentHeaderRowWithoutSpan(e) {
    this.currentHeaderRowWithoutSpan = e;
  }
  navigateHorizontally(e, t = !1, i) {
    const o = this.focusService.getFocusedHeader(), s = e === 2, r = this.gos.get("enableRtl");
    let n, a;
    if (this.currentHeaderRowWithoutSpan !== -1 ? o.headerRowIndex = this.currentHeaderRowWithoutSpan : this.currentHeaderRowWithoutSpan = o.headerRowIndex, s !== r ? (a = "Before", n = this.headerPositionUtils.findHeader(o, a)) : (a = "After", n = this.headerPositionUtils.findHeader(o, a)), n || !t)
      return this.focusService.focusHeaderPosition({ headerPosition: n, direction: a, fromTab: t, allowUserOverride: !0, event: i });
    if (t) {
      const l = this.gos.getCallback("tabToNextHeader");
      if (l)
        return this.focusService.focusHeaderPositionFromUserFunc({ userFunc: l, headerPosition: n, direction: a });
    }
    return this.focusNextHeaderRow(o, a, i);
  }
  focusNextHeaderRow(e, t, i) {
    const o = e.headerRowIndex;
    let s, r = null;
    if (t === "Before" ? o > 0 && (s = o - 1, this.currentHeaderRowWithoutSpan -= 1, r = this.headerPositionUtils.findColAtEdgeForHeaderRow(s, "end")) : (s = o + 1, this.currentHeaderRowWithoutSpan < this.getHeaderRowCount() ? this.currentHeaderRowWithoutSpan += 1 : this.setCurrentHeaderRowWithoutSpan(-1), r = this.headerPositionUtils.findColAtEdgeForHeaderRow(s, "start")), !r)
      return !1;
    const { column: n, headerRowIndex: a } = this.headerPositionUtils.getHeaderIndexToFocus(r.column, r == null ? void 0 : r.headerRowIndex);
    return this.focusService.focusHeaderPosition({ headerPosition: { column: n, headerRowIndex: a }, direction: t, fromTab: !0, allowUserOverride: !0, event: i });
  }
  scrollToColumn(e, t = "After") {
    if (e.getPinned())
      return;
    let i;
    if (V(e)) {
      const o = e.getDisplayedLeafColumns();
      i = t === "Before" ? T(o) : o[0];
    } else
      i = e;
    this.gridBodyCon.getScrollFeature().ensureColumnVisible(i);
  }
}, Pa = class extends f {
  wireBeans(e) {
    this.headerNavigationService = e.headerNavigationService, this.focusService = e.focusService, this.columnModel = e.columnModel, this.visibleColsService = e.visibleColsService, this.ctrlsService = e.ctrlsService, this.filterManager = e.filterManager, this.menuService = e.menuService;
  }
  setComp(e, t, i) {
    this.comp = e, this.eGui = t, this.createManagedBean(new qe(i, { onTabKeyDown: this.onTabKeyDown.bind(this), handleKeyDown: this.handleKeyDown.bind(this), onFocusOut: this.onFocusOut.bind(this) })), this.addManagedEventListeners({ columnPivotModeChanged: this.onPivotModeChanged.bind(this), displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this) }), this.onPivotModeChanged(), this.setupHeaderHeight();
    const o = this.onHeaderContextMenu.bind(this);
    this.addManagedElementListeners(this.eGui, { contextmenu: o }), this.mockContextMenuForIPad(o), this.ctrlsService.register("gridHeaderCtrl", this);
  }
  setupHeaderHeight() {
    const e = this.setHeaderHeight.bind(this);
    e(), this.addManagedPropertyListener("headerHeight", e), this.addManagedPropertyListener("pivotHeaderHeight", e), this.addManagedPropertyListener("groupHeaderHeight", e), this.addManagedPropertyListener("pivotGroupHeaderHeight", e), this.addManagedPropertyListener("floatingFiltersHeight", e), this.addManagedEventListeners({ displayedColumnsChanged: e, columnHeaderHeightChanged: e, gridStylesChanged: e, advancedFilterEnabledChanged: e });
  }
  getHeaderHeight() {
    return this.headerHeight;
  }
  setHeaderHeight() {
    var d;
    const { columnModel: e } = this;
    let t, i = 0, o = e.getHeaderRowCount();
    ((d = this.filterManager) == null ? void 0 : d.hasFloatingFilters()) && (o++, i = 1);
    const r = this.columnModel.getColumnGroupHeaderRowHeight(), n = this.columnModel.getColumnHeaderRowHeight(), a = o - (1 + i);
    if (t = i * e.getFloatingFiltersHeight(), t += a * r, t += n, this.headerHeight === t)
      return;
    this.headerHeight = t;
    const l = `${t + 1}px`;
    this.comp.setHeightAndMinHeight(l), this.eventService.dispatchEvent({ type: "headerHeightChanged" });
  }
  onPivotModeChanged() {
    const e = this.columnModel.isPivotMode();
    this.comp.addOrRemoveCssClass("ag-pivot-on", e), this.comp.addOrRemoveCssClass("ag-pivot-off", !e);
  }
  onDisplayedColumnsChanged() {
    const e = this.visibleColsService.getAllCols().some((t) => t.isSpanHeaderHeight());
    this.comp.addOrRemoveCssClass("ag-header-allow-overflow", e);
  }
  onTabKeyDown(e) {
    const t = this.gos.get("enableRtl"), i = e.shiftKey !== t ? 2 : 3;
    (this.headerNavigationService.navigateHorizontally(i, !0, e) || this.focusService.focusNextGridCoreContainer(e.shiftKey)) && e.preventDefault();
  }
  handleKeyDown(e) {
    let t = null;
    switch (e.key) {
      case v.LEFT:
        t = 2;
      case v.RIGHT:
        S(t) || (t = 3), this.headerNavigationService.navigateHorizontally(t, !1, e);
        break;
      case v.UP:
        t = 0;
      case v.DOWN:
        S(t) || (t = 1), this.headerNavigationService.navigateVertically(t, null, e) && e.preventDefault();
        break;
      default:
        return;
    }
  }
  onFocusOut(e) {
    const { relatedTarget: t } = e;
    !t && this.eGui.contains(this.gos.getActiveDomElement()) || this.eGui.contains(t) || this.focusService.clearFocusedHeader();
  }
  onHeaderContextMenu(e, t, i) {
    if (!e && !i || !this.menuService.isHeaderContextMenuEnabled())
      return;
    const { target: o } = e ?? t;
    o !== this.eGui && o !== this.ctrlsService.getHeaderRowContainerCtrl().getViewport() || this.menuService.showHeaderContextMenu(void 0, e, i);
  }
  mockContextMenuForIPad(e) {
    if (!Oe())
      return;
    const t = new Te(this.eGui);
    this.addManagedListeners(t, { longTap: (i) => {
      e(void 0, i.touchStart, i.touchEvent);
    } }), this.addDestroyFunc(() => t.destroy());
  }
}, wo = class extends f {
  constructor(e, t = !1) {
    super(), this.callback = e, this.addSpacer = t;
  }
  wireBeans(e) {
    this.visibleColsService = e.visibleColsService, this.scrollVisibleService = e.scrollVisibleService;
  }
  postConstruct() {
    const e = this.setWidth.bind(this);
    this.addManagedPropertyListener("domLayout", e), this.addManagedEventListeners({ columnContainerWidthChanged: e, displayedColumnsChanged: e, leftPinnedWidthChanged: e }), this.addSpacer && this.addManagedEventListeners({ rightPinnedWidthChanged: e, scrollVisibilityChanged: e, scrollbarWidthChanged: e }), this.setWidth();
  }
  setWidth() {
    const e = this.gos.isDomLayout("print"), t = this.visibleColsService.getBodyContainerWidth(), i = this.visibleColsService.getColsLeftWidth(), o = this.visibleColsService.getDisplayedColumnsRightWidth();
    let s;
    e ? s = t + i + o : (s = t, this.addSpacer && (this.gos.get("enableRtl") ? i : o) === 0 && this.scrollVisibleService.isVerticalScrollShowing() && (s += this.gos.getScrollbarWidth())), this.callback(s);
  }
}, ka = class extends f {
  constructor(e) {
    super(), this.columnsToAggregate = [], this.columnsToGroup = [], this.columnsToPivot = [], this.pinned = e;
  }
  wireBeans(e) {
    this.funcColsService = e.funcColsService;
  }
  onDragEnter(e) {
    if (this.clearColumnsList(), this.gos.get("functionsReadOnly"))
      return;
    const t = e.dragItem.columns;
    t && t.forEach((i) => {
      i.isPrimary() && (i.isAnyFunctionActive() || (i.isAllowValue() ? this.columnsToAggregate.push(i) : i.isAllowRowGroup() ? this.columnsToGroup.push(i) : i.isAllowPivot() && this.columnsToPivot.push(i)));
    });
  }
  getIconName() {
    return this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length > 0 ? this.pinned ? "pinned" : "move" : null;
  }
  onDragLeave(e) {
    this.clearColumnsList();
  }
  clearColumnsList() {
    this.columnsToAggregate.length = 0, this.columnsToGroup.length = 0, this.columnsToPivot.length = 0;
  }
  onDragging(e) {
  }
  onDragStop(e) {
    this.columnsToAggregate.length > 0 && this.funcColsService.addValueColumns(this.columnsToAggregate, "toolPanelDragAndDrop"), this.columnsToGroup.length > 0 && this.funcColsService.addRowGroupColumns(this.columnsToGroup, "toolPanelDragAndDrop"), this.columnsToPivot.length > 0 && this.funcColsService.addPivotColumns(this.columnsToPivot, "toolPanelDragAndDrop");
  }
};
function bo(e) {
  const { isFromHeader: t, hDirection: i, xPosition: o, fromEnter: s, fakeEvent: r, pinned: n, gos: a, columnModel: l, columnMoveService: d, presentedColsService: c } = e, h = i === 0, g = i === 1;
  let { allMovingColumns: u } = e;
  if (t) {
    const D = [];
    u.forEach((F) => {
      var Ce;
      let G = null, N = F.getParent();
      for (; N != null && N.getDisplayedLeafColumns().length === 1; )
        G = N, N = N.getParent();
      G != null ? ((Ce = G.getColGroupDef()) != null && Ce.marryChildren ? G.getProvidedColumnGroup().getLeafColumns() : G.getLeafColumns()).forEach((ge) => {
        D.includes(ge) || D.push(ge);
      }) : D.includes(F) || D.push(F);
    }), u = D;
  }
  const p = u.slice();
  l.sortColsLikeCols(p);
  const C = function(D) {
    const { movingCols: F, draggingRight: G, xPosition: N, pinned: Ce, gos: ge, columnModel: di, presentedColsService: Br } = D;
    if (ge.get("suppressMovableColumns") || F.some((I) => I.getColDef().suppressMovable))
      return [];
    const ci = function(I, we) {
      switch (we) {
        case "left":
          return I.getLeftCols();
        case "right":
          return I.getRightCols();
        default:
          return I.getCenterCols();
      }
    }(Br, Ce), ut = di.getCols(), Hr = ci.filter((I) => He(F, I)), kt = ci.filter((I) => !He(F, I)), Ro = ut.filter((I) => !He(F, I));
    let Ee, At = 0, Tt = N;
    if (G) {
      let I = 0;
      Hr.forEach((we) => I += we.getActualWidth()), Tt -= I;
    }
    if (Tt > 0) {
      for (let I = 0; I < kt.length && (Tt -= kt[I].getActualWidth(), !(Tt < 0)); I++)
        At++;
      G && At++;
    }
    if (At > 0) {
      const I = kt[At - 1];
      Ee = Ro.indexOf(I) + 1;
    } else
      Ee = Ro.indexOf(kt[0]), Ee === -1 && (Ee = 0);
    const $e = [Ee], xo = (I, we) => I - we;
    if (G) {
      let I = Ee + 1;
      const we = ut.length - 1;
      for (; I <= we; )
        $e.push(I), I++;
      $e.sort(xo);
    } else {
      let I = Ee;
      const we = ut.length - 1;
      let Fo = ut[I];
      for (; I <= we && ci.indexOf(Fo) < 0; )
        I++, $e.push(I), Fo = ut[I];
      I = Ee - 1;
      const Vr = 0;
      for (; I >= Vr; )
        $e.push(I), I--;
      $e.sort(xo).reverse();
    }
    return $e;
  }({ movingCols: p, draggingRight: g, xPosition: o, pinned: n, gos: a, columnModel: l, presentedColsService: c }), y = function(D, F) {
    const G = F.getCols(), N = D.map((ge) => G.indexOf(ge)).sort((ge, di) => ge - di), Ce = N[0];
    return T(N) - Ce != N.length - 1 ? null : Ce;
  }(p, l);
  if (C.length === 0)
    return;
  const w = C[0];
  let x = y !== null && !s;
  if (t && (x = y !== null), x && !r && (h && w >= y || g && w <= y))
    return;
  const E = c.getAllCols(), k = [];
  let P = null;
  for (let D = 0; D < C.length; D++) {
    const F = C[D], G = d.getProposedColumnOrder(p, F);
    if (!d.doesOrderPassRules(G))
      continue;
    const N = G.filter((ge) => E.includes(ge));
    if (P === null)
      P = N;
    else if (!Ke(N, P))
      break;
    const Ce = Aa(G);
    k.push({ move: F, fragCount: Ce });
  }
  return k.length !== 0 ? (k.sort((D, F) => D.fragCount - F.fragCount), fr(u, k[0].move, "uiColumnMoved", !1, d)) : void 0;
}
function fr(e, t, i, o, s) {
  return s.moveColumns(e, t, i, o), o ? null : { columns: e, toIndex: t };
}
function Aa(e) {
  function t(o) {
    const s = [];
    let r = o.getOriginalParent();
    for (; r != null; )
      s.push(r), r = r.getOriginalParent();
    return s;
  }
  let i = 0;
  for (let o = 0; o < e.length - 1; o++) {
    let s = t(e[o]), r = t(e[o + 1]);
    [s, r] = s.length > r.length ? [s, r] : [r, s], s.forEach((n) => {
      r.indexOf(n) === -1 && i++;
    });
  }
  return i;
}
function yo(e, t, i, o, s) {
  const r = s.getHeaderRowContainerCtrl(t).getViewport();
  return i && (e -= r.getBoundingClientRect().left), o.get("enableRtl") && (e = r.clientWidth - e), t == null && (e += s.get("center").getCenterViewportScrollLeft()), e;
}
var Ta = class extends f {
  constructor(e) {
    super(), this.needToMoveLeft = !1, this.needToMoveRight = !1, this.lastMovedInfo = null, this.pinned = e, this.isCenterContainer = !S(e);
  }
  wireBeans(e) {
    this.columnModel = e.columnModel, this.visibleColsService = e.visibleColsService, this.columnMoveService = e.columnMoveService, this.dragAndDropService = e.dragAndDropService, this.ctrlsService = e.ctrlsService;
  }
  postConstruct() {
    this.ctrlsService.whenReady((e) => {
      this.gridBodyCon = e.gridBodyCtrl;
    });
  }
  getIconName() {
    return this.pinned ? "pinned" : "move";
  }
  onDragEnter(e) {
    const t = e.dragItem.columns;
    if (e.dragSource.type === 0)
      this.setColumnsVisible(t, !0, "uiColumnDragged");
    else {
      const i = e.dragItem.visibleState, o = (t || []).filter((s) => i[s.getId()]);
      this.setColumnsVisible(o, !0, "uiColumnDragged");
    }
    this.setColumnsPinned(t, this.pinned, "uiColumnDragged"), this.onDragging(e, !0, !0);
  }
  onDragLeave() {
    this.ensureIntervalCleared(), this.lastMovedInfo = null;
  }
  setColumnsVisible(e, t, i) {
    if (e) {
      const o = e.filter((s) => !s.getColDef().lockVisible);
      this.columnModel.setColsVisible(o, t, i);
    }
  }
  setColumnsPinned(e, t, i) {
    if (e) {
      const o = e.filter((s) => !s.getColDef().lockPinned);
      this.columnModel.setColsPinned(o, t, i);
    }
  }
  onDragStop() {
    this.onDragging(this.lastDraggingEvent, !1, !0, !0), this.ensureIntervalCleared(), this.lastMovedInfo = null;
  }
  checkCenterForScrolling(e) {
    if (this.isCenterContainer) {
      const t = this.ctrlsService.get("center"), i = t.getCenterViewportScrollLeft(), o = i + t.getCenterWidth();
      this.gos.get("enableRtl") ? (this.needToMoveRight = e < i + 50, this.needToMoveLeft = e > o - 50) : (this.needToMoveLeft = e < i + 50, this.needToMoveRight = e > o - 50), this.needToMoveLeft || this.needToMoveRight ? this.ensureIntervalStarted() : this.ensureIntervalCleared();
    }
  }
  onDragging(e = this.lastDraggingEvent, t = !1, i = !1, o = !1) {
    var l;
    if (o) {
      if (this.lastMovedInfo) {
        const { columns: d, toIndex: c } = this.lastMovedInfo;
        fr(d, c, "uiColumnMoved", !0, this.columnMoveService);
      }
      return;
    }
    if (this.lastDraggingEvent = e, A(e.hDirection))
      return;
    const s = yo(e.x, this.pinned, !1, this.gos, this.ctrlsService);
    t || this.checkCenterForScrolling(s);
    const r = this.normaliseDirection(e.hDirection), n = e.dragSource.type, a = bo({ allMovingColumns: ((l = e.dragSource.getDragItem().columns) == null ? void 0 : l.filter((d) => !d.getColDef().lockPinned || d.getPinned() == this.pinned)) || [], isFromHeader: n === 1, hDirection: r, xPosition: s, pinned: this.pinned, fromEnter: t, fakeEvent: i, gos: this.gos, columnModel: this.columnModel, columnMoveService: this.columnMoveService, presentedColsService: this.visibleColsService });
    a && (this.lastMovedInfo = a);
  }
  normaliseDirection(e) {
    if (!this.gos.get("enableRtl"))
      return e;
    switch (e) {
      case 0:
        return 1;
      case 1:
        return 0;
      default:
        L(`Unknown direction ${e}`);
    }
  }
  ensureIntervalStarted() {
    this.movingIntervalId || (this.intervalCount = 0, this.failedMoveAttempts = 0, this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), 100), this.dragAndDropService.setGhostIcon(this.needToMoveLeft ? "left" : "right", !0));
  }
  ensureIntervalCleared() {
    this.movingIntervalId && (window.clearInterval(this.movingIntervalId), this.movingIntervalId = null, this.dragAndDropService.setGhostIcon("move"));
  }
  moveInterval() {
    let e;
    this.intervalCount++, e = 10 + 5 * this.intervalCount, e > 100 && (e = 100);
    let t = null;
    const i = this.gridBodyCon.getScrollFeature();
    if (this.needToMoveLeft ? t = i.scrollHorizontally(-e) : this.needToMoveRight && (t = i.scrollHorizontally(e)), t !== 0)
      this.onDragging(this.lastDraggingEvent), this.failedMoveAttempts = 0;
    else {
      this.failedMoveAttempts++;
      const o = this.lastDraggingEvent.dragItem.columns.filter((s) => !s.getColDef().lockPinned);
      if (o.length > 0 && (this.dragAndDropService.setGhostIcon("pinned"), this.failedMoveAttempts > 7)) {
        const s = this.needToMoveLeft ? "left" : "right";
        this.setColumnsPinned(o, s, "uiColumnDragged"), this.dragAndDropService.nudge();
      }
    }
  }
}, Ia = class extends f {
  wireBeans(e) {
    this.dragAndDropService = e.dragAndDropService, this.columnModel = e.columnModel, this.ctrlsService = e.ctrlsService;
  }
  constructor(e, t) {
    super(), this.pinned = e, this.eContainer = t;
  }
  postConstruct() {
    this.ctrlsService.whenReady((e) => {
      switch (this.pinned) {
        case "left":
          this.eSecondaryContainers = [[e.gridBodyCtrl.getBodyViewportElement(), e.left.getContainerElement()], [e.bottomLeft.getContainerElement()], [e.topLeft.getContainerElement()]];
          break;
        case "right":
          this.eSecondaryContainers = [[e.gridBodyCtrl.getBodyViewportElement(), e.right.getContainerElement()], [e.bottomRight.getContainerElement()], [e.topRight.getContainerElement()]];
          break;
        default:
          this.eSecondaryContainers = [[e.gridBodyCtrl.getBodyViewportElement(), e.center.getViewportElement()], [e.bottomCenter.getViewportElement()], [e.topCenter.getViewportElement()]];
      }
    }), this.moveColumnFeature = this.createManagedBean(new Ta(this.pinned)), this.bodyDropPivotTarget = this.createManagedBean(new ka(this.pinned)), this.dragAndDropService.addDropTarget(this);
  }
  isInterestedIn(e) {
    return e === 1 || e === 0 && this.gos.get("allowDragFromColumnsToolPanel");
  }
  getSecondaryContainers() {
    return this.eSecondaryContainers;
  }
  getContainer() {
    return this.eContainer;
  }
  getIconName() {
    return this.currentDropListener.getIconName();
  }
  isDropColumnInPivotMode(e) {
    return this.columnModel.isPivotMode() && e.dragSource.type === 0;
  }
  onDragEnter(e) {
    this.currentDropListener = this.isDropColumnInPivotMode(e) ? this.bodyDropPivotTarget : this.moveColumnFeature, this.currentDropListener.onDragEnter(e);
  }
  onDragLeave(e) {
    this.currentDropListener.onDragLeave(e);
  }
  onDragging(e) {
    this.currentDropListener.onDragging(e);
  }
  onDragStop(e) {
    this.currentDropListener.onDragStop(e);
  }
}, La = class extends f {
  wireBeans(e) {
    this.horizontalResizeService = e.horizontalResizeService, this.pinnedWidthService = e.pinnedWidthService, this.ctrlsService = e.ctrlsService, this.columnSizeService = e.columnSizeService, this.columnAutosizeService = e.columnAutosizeService;
  }
  constructor(e, t, i, o, s) {
    super(), this.pinned = e, this.column = t, this.eResize = i, this.comp = o, this.ctrl = s;
  }
  postConstruct() {
    const e = [];
    let t, i;
    const o = () => {
      if (H(this.eResize, t), !t)
        return;
      const n = this.horizontalResizeService.addResizeBar({ eResizeBar: this.eResize, onResizeStart: this.onResizeStart.bind(this), onResizing: this.onResizing.bind(this, !1), onResizeEnd: this.onResizing.bind(this, !0) });
      if (e.push(n), i) {
        const a = this.gos.get("skipHeaderOnAutoSize"), l = () => {
          this.columnAutosizeService.autoSizeColumn(this.column, "uiColumnResized", a);
        };
        this.eResize.addEventListener("dblclick", l);
        const d = new Te(this.eResize);
        d.addEventListener("doubleTap", l), e.push(() => {
          this.eResize.removeEventListener("dblclick", l), d.removeEventListener("doubleTap", l), d.destroy();
        });
      }
    }, s = () => {
      e.forEach((n) => n()), e.length = 0;
    }, r = () => {
      const n = this.column.isResizable(), a = !this.gos.get("suppressAutoSize") && !this.column.getColDef().suppressAutoSize;
      (n !== t || a !== i) && (t = n, i = a, s(), o());
    };
    r(), this.addDestroyFunc(s), this.ctrl.addRefreshFunction(r);
  }
  onResizing(e, t) {
    const { column: i, lastResizeAmount: o, resizeStartWidth: s } = this, r = this.normaliseResizeAmount(t), n = [{ key: i, newWidth: s + r }];
    this.column.getPinned() && this.pinnedWidthService.getPinnedLeftWidth() + this.pinnedWidthService.getPinnedRightWidth() + (r - o) > Pt(this.ctrlsService.getGridBodyCtrl().getBodyViewportElement()) - 50 || (this.lastResizeAmount = r, this.columnSizeService.setColumnWidths(n, this.resizeWithShiftKey, e, "uiColumnResized"), e && this.toggleColumnResizing(!1));
  }
  onResizeStart(e) {
    this.resizeStartWidth = this.column.getActualWidth(), this.lastResizeAmount = 0, this.resizeWithShiftKey = e, this.toggleColumnResizing(!0);
  }
  toggleColumnResizing(e) {
    this.comp.addOrRemoveCssClass("ag-column-resizing", e);
  }
  normaliseResizeAmount(e) {
    let t = e;
    const i = this.pinned !== "left", o = this.pinned === "right";
    return this.gos.get("enableRtl") ? i && (t *= -1) : o && (t *= -1), t;
  }
}, Oa = class extends f {
  constructor(e) {
    super(), this.cbSelectAllVisible = !1, this.processingEventFromCheckbox = !1, this.column = e;
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.selectionService = e.selectionService;
  }
  onSpaceKeyDown(e) {
    const t = this.cbSelectAll;
    t.isDisplayed() && !t.getGui().contains(this.gos.getActiveDomElement()) && (e.preventDefault(), t.setValue(!t.getValue()));
  }
  getCheckboxGui() {
    return this.cbSelectAll.getGui();
  }
  setComp(e) {
    this.headerCellCtrl = e, this.cbSelectAll = this.createManagedBean(new ao()), this.cbSelectAll.addCssClass("ag-header-select-all"), X(this.cbSelectAll.getGui(), "presentation"), this.showOrHideSelectAll(), this.addManagedEventListeners({ newColumnsLoaded: this.onNewColumnsLoaded.bind(this), displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this), selectionChanged: this.onSelectionChanged.bind(this), paginationChanged: this.onSelectionChanged.bind(this), modelUpdated: this.onModelChanged.bind(this) }), this.addManagedListeners(this.cbSelectAll, { fieldValueChanged: this.onCbSelectAll.bind(this) }), _i(this.cbSelectAll.getGui(), !0), this.cbSelectAll.getInputElement().setAttribute("tabindex", "-1"), this.refreshSelectAllLabel();
  }
  onNewColumnsLoaded() {
    this.showOrHideSelectAll();
  }
  onDisplayedColumnsChanged() {
    this.isAlive() && this.showOrHideSelectAll();
  }
  showOrHideSelectAll() {
    this.cbSelectAllVisible = this.isCheckboxSelection(), this.cbSelectAll.setDisplayed(this.cbSelectAllVisible, { skipAriaHidden: !0 }), this.cbSelectAllVisible && (this.checkRightRowModelType("selectAllCheckbox"), this.checkSelectionType("selectAllCheckbox"), this.updateStateOfCheckbox()), this.refreshSelectAllLabel();
  }
  onModelChanged() {
    this.cbSelectAllVisible && this.updateStateOfCheckbox();
  }
  onSelectionChanged() {
    this.cbSelectAllVisible && this.updateStateOfCheckbox();
  }
  updateStateOfCheckbox() {
    if (this.processingEventFromCheckbox)
      return;
    this.processingEventFromCheckbox = !0;
    const e = this.selectionService.getSelectAllState(this.isFilteredOnly(), this.isCurrentPageOnly());
    this.cbSelectAll.setValue(e);
    const t = this.selectionService.hasNodesToSelect(this.isFilteredOnly(), this.isCurrentPageOnly());
    this.cbSelectAll.setDisabled(!t), this.refreshSelectAllLabel(), this.processingEventFromCheckbox = !1;
  }
  refreshSelectAllLabel() {
    const e = this.localeService.getLocaleTextFunc(), t = this.cbSelectAll.getValue() ? e("ariaChecked", "checked") : e("ariaUnchecked", "unchecked"), i = e("ariaRowSelectAll", "Press Space to toggle all rows selection");
    this.cbSelectAllVisible ? this.headerCellCtrl.setAriaDescriptionProperty("selectAll", `${i} (${t})`) : this.headerCellCtrl.setAriaDescriptionProperty("selectAll", null), this.cbSelectAll.setInputAriaLabel(`${i} (${t})`), this.headerCellCtrl.announceAriaDescription();
  }
  checkSelectionType(e) {
    return !(this.gos.get("rowSelection") !== "multiple" && (b(`${e} is only available if using 'multiple' rowSelection.`), 1));
  }
  checkRightRowModelType(e) {
    const t = this.rowModel.getType();
    return !(t !== "clientSide" && t !== "serverSide" && (b(`${e} is only available if using 'clientSide' or 'serverSide' rowModelType, you are using ${t}.`), 1));
  }
  onCbSelectAll() {
    if (this.processingEventFromCheckbox || !this.cbSelectAllVisible)
      return;
    const e = this.cbSelectAll.getValue(), t = this.isFilteredOnly(), i = this.isCurrentPageOnly();
    let o = "uiSelectAll";
    i ? o = "uiSelectAllCurrentPage" : t && (o = "uiSelectAllFiltered");
    const s = { source: o, justFiltered: t, justCurrentPage: i };
    e ? this.selectionService.selectAllRowNodes(s) : this.selectionService.deselectAllRowNodes(s);
  }
  isCheckboxSelection() {
    let e = this.column.getColDef().headerCheckboxSelection;
    return typeof e == "function" && (e = e(this.gos.addGridCommonParams({ column: this.column, colDef: this.column.getColDef() }))), !!e && this.checkRightRowModelType("headerCheckboxSelection") && this.checkSelectionType("headerCheckboxSelection");
  }
  isFilteredOnly() {
    return !!this.column.getColDef().headerCheckboxSelectionFilteredOnly;
  }
  isCurrentPageOnly() {
    return !!this.column.getColDef().headerCheckboxSelectionCurrentPageOnly;
  }
}, Na = class extends ai {
  constructor(e, t, i) {
    super(e, t, i), this.refreshFunctions = [], this.userHeaderClasses = /* @__PURE__ */ new Set(), this.ariaDescriptionProperties = /* @__PURE__ */ new Map(), this.column = e;
  }
  setComp(e, t, i, o) {
    this.comp = e, this.setGui(t), this.updateState(), this.setupWidth(), this.setupMovingCss(), this.setupMenuClass(), this.setupSortableClass(), this.setupWrapTextClass(), this.refreshSpanHeaderHeight(), this.setupAutoHeight(o), this.addColumnHoverListener(), this.setupFilterClass(), this.setupClassesFromColDef(), this.setupTooltip(), this.addActiveHeaderMouseListeners(), this.setupSelectAll(), this.setupUserComp(), this.refreshAria(), this.resizeFeature = this.createManagedBean(new La(this.getPinned(), this.column, i, e, this)), this.createManagedBean(new mo([this.column], t)), this.createManagedBean(new po(this.column, t, this.beans)), this.createManagedBean(new qe(t, { shouldStopEventPropagation: (s) => this.shouldStopEventPropagation(s), onTabKeyDown: () => null, handleKeyDown: this.handleKeyDown.bind(this), onFocusIn: this.onFocusIn.bind(this), onFocusOut: this.onFocusOut.bind(this) })), this.addResizeAndMoveKeyboardListeners(), this.addManagedPropertyListeners(["suppressMovableColumns", "suppressMenuHide", "suppressAggFuncInHeader"], this.refresh.bind(this)), this.addManagedListeners(this.column, { colDefChanged: this.refresh.bind(this) }), this.addManagedEventListeners({ columnValueChanged: this.onColumnValueChanged.bind(this), columnRowGroupChanged: this.onColumnRowGroupChanged.bind(this), columnPivotChanged: this.onColumnPivotChanged.bind(this), headerHeightChanged: this.onHeaderHeightChanged.bind(this) });
  }
  resizeHeader(e, t) {
    if (!this.column.isResizable())
      return;
    const i = this.column.getActualWidth(), o = this.column.getMinWidth(), s = this.column.getMaxWidth(), r = Math.min(Math.max(i + e, o), s);
    this.beans.columnSizeService.setColumnWidths([{ key: this.column, newWidth: r }], t, !0, "uiColumnResized");
  }
  moveHeader(e) {
    const { eGui: t, column: i, gos: o, ctrlsService: s } = this, r = this.getPinned(), n = t.getBoundingClientRect().left, a = i.getActualWidth();
    bo({ allMovingColumns: [i], isFromHeader: !0, hDirection: e, xPosition: yo(e === 0 !== o.get("enableRtl") ? n - 20 : n + a + 20, r, !0, o, s), pinned: r, fromEnter: !1, fakeEvent: !1, gos: o, columnModel: this.beans.columnModel, columnMoveService: this.beans.columnMoveService, presentedColsService: this.beans.visibleColsService }), s.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(i, "auto");
  }
  setupUserComp() {
    const e = this.lookupUserCompDetails();
    this.setCompDetails(e);
  }
  setCompDetails(e) {
    this.userCompDetails = e, this.comp.setUserCompDetails(e);
  }
  lookupUserCompDetails() {
    const e = this.createParams(), t = this.column.getColDef();
    return this.userComponentFactory.getHeaderCompDetails(t, e);
  }
  createParams() {
    return this.gos.addGridCommonParams({ column: this.column, displayName: this.displayName, enableSorting: this.column.isSortable(), enableMenu: this.menuEnabled, enableFilterButton: this.openFilterEnabled && this.menuService.isHeaderFilterButtonEnabled(this.column), enableFilterIcon: !this.openFilterEnabled || this.menuService.isLegacyMenuEnabled(), showColumnMenu: (e) => {
      this.menuService.showColumnMenu({ column: this.column, buttonElement: e, positionBy: "button" });
    }, showColumnMenuAfterMouseClick: (e) => {
      this.menuService.showColumnMenu({ column: this.column, mouseEvent: e, positionBy: "mouse" });
    }, showFilter: (e) => {
      this.menuService.showFilterMenu({ column: this.column, buttonElement: e, containerType: "columnFilter", positionBy: "button" });
    }, progressSort: (e) => {
      this.beans.sortController.progressSort(this.column, !!e, "uiColumnSorted");
    }, setSort: (e, t) => {
      this.beans.sortController.setSortForColumn(this.column, e, !!t, "uiColumnSorted");
    }, eGridHeader: this.getGui(), setTooltip: (e, t) => {
      this.setupTooltip(e, t);
    } });
  }
  setupSelectAll() {
    this.selectAllFeature = this.createManagedBean(new Oa(this.column)), this.selectAllFeature.setComp(this);
  }
  getSelectAllGui() {
    return this.selectAllFeature.getCheckboxGui();
  }
  handleKeyDown(e) {
    super.handleKeyDown(e), e.key === v.SPACE && this.selectAllFeature.onSpaceKeyDown(e), e.key === v.ENTER && this.onEnterKeyDown(e), e.key === v.DOWN && e.altKey && this.showMenuOnKeyPress(e, !1);
  }
  onEnterKeyDown(e) {
    if (e.ctrlKey || e.metaKey)
      this.showMenuOnKeyPress(e, !0);
    else if (this.sortable) {
      const t = e.shiftKey;
      this.beans.sortController.progressSort(this.column, t, "uiColumnSorted");
    }
  }
  showMenuOnKeyPress(e, t) {
    const i = this.comp.getUserCompInstance();
    i && i instanceof Ni && i.onMenuKeyboardShortcut(t) && e.preventDefault();
  }
  onFocusIn(e) {
    if (!this.getGui().contains(e.relatedTarget)) {
      const t = this.getRowIndex();
      this.focusService.setFocusedHeader(t, this.column), this.announceAriaDescription();
    }
    this.focusService.isKeyboardMode() && this.setActiveHeader(!0);
  }
  onFocusOut(e) {
    this.getGui().contains(e.relatedTarget) || this.setActiveHeader(!1);
  }
  setupTooltip(e, t) {
    this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature));
    const i = this.gos.get("tooltipShowMode") === "whenTruncated", o = this.eGui, s = this.column.getColDef();
    t || !i || s.headerComponent || (t = () => {
      const a = o.querySelector(".ag-header-cell-text");
      return !a || a.scrollWidth > a.clientWidth;
    });
    const r = { getColumn: () => this.column, getColDef: () => this.column.getColDef(), getGui: () => o, getLocation: () => "header", getTooltipValue: () => e ?? this.column.getColDef().headerTooltip, shouldDisplayTooltip: t }, n = this.createManagedBean(new gt(r));
    this.refreshFunctions.push(() => n.refreshToolTip());
  }
  setupClassesFromColDef() {
    const e = () => {
      const t = hr(this.column.getColDef(), this.gos, this.column, null), i = this.userHeaderClasses;
      this.userHeaderClasses = new Set(t), t.forEach((o) => {
        i.has(o) ? i.delete(o) : this.comp.addOrRemoveCssClass(o, !0);
      }), i.forEach((o) => this.comp.addOrRemoveCssClass(o, !1));
    };
    this.refreshFunctions.push(e), e();
  }
  setDragSource(e) {
    if (this.dragSourceElement = e, this.removeDragSource(), !e || !this.draggable)
      return;
    const { column: t, beans: i, displayName: o, dragAndDropService: s, gos: r } = this, { columnModel: n } = i;
    let a = !this.gos.get("suppressDragLeaveHidesColumns");
    const l = this.dragSource = { type: 1, eElement: e, getDefaultIconName: () => a ? "hide" : "notAllowed", getDragItem: () => this.createDragItem(t), dragItemName: o, onDragStarted: () => {
      a = !r.get("suppressDragLeaveHidesColumns"), t.setMoving(!0, "uiColumnMoved");
    }, onDragStopped: () => t.setMoving(!1, "uiColumnMoved"), onGridEnter: (d) => {
      var c;
      if (a) {
        const h = ((c = d == null ? void 0 : d.columns) == null ? void 0 : c.filter((g) => !g.getColDef().lockVisible)) || [];
        n.setColsVisible(h, !0, "uiColumnMoved");
      }
    }, onGridExit: (d) => {
      var c;
      if (a) {
        const h = ((c = d == null ? void 0 : d.columns) == null ? void 0 : c.filter((g) => !g.getColDef().lockVisible)) || [];
        n.setColsVisible(h, !1, "uiColumnMoved");
      }
    } };
    s.addDragSource(l, !0);
  }
  createDragItem(e) {
    const t = {};
    return t[e.getId()] = e.isVisible(), { columns: [e], visibleState: t };
  }
  updateState() {
    this.menuEnabled = this.menuService.isColumnMenuInHeaderEnabled(this.column), this.openFilterEnabled = this.menuService.isFilterMenuInHeaderEnabled(this.column), this.sortable = this.column.isSortable(), this.displayName = this.calculateDisplayName(), this.draggable = this.workOutDraggable();
  }
  addRefreshFunction(e) {
    this.refreshFunctions.push(e);
  }
  refresh() {
    this.updateState(), this.refreshHeaderComp(), this.refreshAria(), this.refreshFunctions.forEach((e) => e());
  }
  refreshHeaderComp() {
    const e = this.lookupUserCompDetails();
    this.comp.getUserCompInstance() != null && this.userCompDetails.componentClass == e.componentClass && this.attemptHeaderCompRefresh(e.params) ? this.setDragSource(this.dragSourceElement) : this.setCompDetails(e);
  }
  attemptHeaderCompRefresh(e) {
    const t = this.comp.getUserCompInstance();
    return !!t && !!t.refresh && t.refresh(e);
  }
  calculateDisplayName() {
    return this.beans.columnNameService.getDisplayNameForColumn(this.column, "header", !0);
  }
  checkDisplayName() {
    this.displayName !== this.calculateDisplayName() && this.refresh();
  }
  workOutDraggable() {
    const e = this.column.getColDef();
    return !(this.gos.get("suppressMovableColumns") || e.suppressMovable || e.lockPosition) || !!e.enableRowGroup || !!e.enablePivot;
  }
  onColumnRowGroupChanged() {
    this.checkDisplayName();
  }
  onColumnPivotChanged() {
    this.checkDisplayName();
  }
  onColumnValueChanged() {
    this.checkDisplayName();
  }
  setupWidth() {
    const e = () => {
      const t = this.column.getActualWidth();
      this.comp.setWidth(`${t}px`);
    };
    this.addManagedListeners(this.column, { widthChanged: e }), e();
  }
  setupMovingCss() {
    const e = () => {
      this.comp.addOrRemoveCssClass("ag-header-cell-moving", this.column.isMoving());
    };
    this.addManagedListeners(this.column, { movingChanged: e }), e();
  }
  setupMenuClass() {
    const e = () => {
      this.comp.addOrRemoveCssClass("ag-column-menu-visible", this.column.isMenuVisible());
    };
    this.addManagedListeners(this.column, { menuVisibleChanged: e }), e();
  }
  setupSortableClass() {
    const e = () => {
      this.comp.addOrRemoveCssClass("ag-header-cell-sortable", !!this.sortable);
    };
    e(), this.addRefreshFunction(e), this.addManagedEventListeners({ sortChanged: this.refreshAriaSort.bind(this) });
  }
  setupFilterClass() {
    const e = () => {
      const t = this.column.isFilterActive();
      this.comp.addOrRemoveCssClass("ag-header-cell-filtered", t), this.refreshAria();
    };
    this.addManagedListeners(this.column, { filterActiveChanged: e }), e();
  }
  setupWrapTextClass() {
    const e = () => {
      const t = !!this.column.getColDef().wrapHeaderText;
      this.comp.addOrRemoveCssClass("ag-header-cell-wrap-text", t);
    };
    e(), this.addRefreshFunction(e);
  }
  onDisplayedColumnsChanged() {
    super.onDisplayedColumnsChanged(), this.isAlive() && this.onHeaderHeightChanged();
  }
  onHeaderHeightChanged() {
    this.refreshSpanHeaderHeight();
  }
  refreshSpanHeaderHeight() {
    const { eGui: e, column: t, comp: i, beans: o } = this;
    if (!t.isSpanHeaderHeight())
      return e.style.removeProperty("top"), e.style.removeProperty("height"), i.addOrRemoveCssClass("ag-header-span-height", !1), void i.addOrRemoveCssClass("ag-header-span-total", !1);
    const { numberOfParents: s, isSpanningTotal: r } = this.column.getColumnGroupPaddingInfo();
    i.addOrRemoveCssClass("ag-header-span-height", s > 0);
    const { columnModel: n } = o, a = n.getColumnHeaderRowHeight();
    if (s === 0)
      return i.addOrRemoveCssClass("ag-header-span-total", !1), e.style.setProperty("top", "0px"), void e.style.setProperty("height", `${a}px`);
    i.addOrRemoveCssClass("ag-header-span-total", r);
    const l = s * (n.isPivotMode() ? n.getPivotGroupHeaderHeight() : n.getGroupHeaderHeight());
    e.style.setProperty("top", -l + "px"), e.style.setProperty("height", `${a + l}px`);
  }
  setupAutoHeight(e) {
    const { columnModel: t, resizeObserverService: i } = this.beans, o = (d) => {
      if (!this.isAlive())
        return;
      const { paddingTop: c, paddingBottom: h, borderBottomWidth: g, borderTopWidth: u } = Ye(this.getGui()), p = c + h + g + u, C = e.offsetHeight + p;
      if (d < 5) {
        const y = this.beans.gos.getDocument();
        if (!y || !y.contains(e) || C == 0)
          return void window.setTimeout(() => o(d + 1), 0);
      }
      t.setColHeaderHeight(this.column, C);
    };
    let s, r = !1;
    const n = () => {
      const d = this.column.isAutoHeaderHeight();
      d && !r && a(), !d && r && l();
    }, a = () => {
      r = !0, o(0), this.comp.addOrRemoveCssClass("ag-header-cell-auto-height", !0), s = i.observeResize(e, () => o(0));
    }, l = () => {
      r = !1, s && s(), this.comp.addOrRemoveCssClass("ag-header-cell-auto-height", !1), s = void 0;
    };
    n(), this.addDestroyFunc(() => l()), this.addManagedListeners(this.column, { widthChanged: () => r && o(0) }), this.addManagedEventListeners({ sortChanged: () => {
      r && window.setTimeout(() => o(0));
    } }), this.addRefreshFunction(n);
  }
  refreshAriaSort() {
    if (this.sortable) {
      const e = this.localeService.getLocaleTextFunc(), t = this.beans.sortController.getDisplaySortForColumn(this.column) || null;
      this.comp.setAriaSort(function(i) {
        let o;
        return o = i === "asc" ? "ascending" : i === "desc" ? "descending" : i === "mixed" ? "other" : "none", o;
      }(t)), this.setAriaDescriptionProperty("sort", e("ariaSortableColumn", "Press ENTER to sort"));
    } else
      this.comp.setAriaSort(), this.setAriaDescriptionProperty("sort", null);
  }
  refreshAriaMenu() {
    if (this.menuEnabled) {
      const e = this.localeService.getLocaleTextFunc();
      this.setAriaDescriptionProperty("menu", e("ariaMenuColumn", "Press ALT DOWN to open column menu"));
    } else
      this.setAriaDescriptionProperty("menu", null);
  }
  refreshAriaFilterButton() {
    if (this.openFilterEnabled && !this.menuService.isLegacyMenuEnabled()) {
      const e = this.localeService.getLocaleTextFunc();
      this.setAriaDescriptionProperty("filterButton", e("ariaFilterColumn", "Press CTRL ENTER to open filter"));
    } else
      this.setAriaDescriptionProperty("filterButton", null);
  }
  refreshAriaFiltered() {
    const e = this.localeService.getLocaleTextFunc();
    this.column.isFilterActive() ? this.setAriaDescriptionProperty("filter", e("ariaColumnFiltered", "Column Filtered")) : this.setAriaDescriptionProperty("filter", null);
  }
  setAriaDescriptionProperty(e, t) {
    t != null ? this.ariaDescriptionProperties.set(e, t) : this.ariaDescriptionProperties.delete(e);
  }
  announceAriaDescription() {
    if (!this.eGui.contains(this.beans.gos.getActiveDomElement()))
      return;
    const e = Array.from(this.ariaDescriptionProperties.keys()).sort((t, i) => t === "filter" ? -1 : i.charCodeAt(0) - t.charCodeAt(0)).map((t) => this.ariaDescriptionProperties.get(t)).join(". ");
    this.beans.ariaAnnouncementService.announceValue(e);
  }
  refreshAria() {
    this.refreshAriaSort(), this.refreshAriaMenu(), this.refreshAriaFilterButton(), this.refreshAriaFiltered();
  }
  addColumnHoverListener() {
    const e = () => {
      if (!this.gos.get("columnHoverHighlight"))
        return;
      const t = this.beans.columnHoverService.isHovered(this.column);
      this.comp.addOrRemoveCssClass("ag-column-hover", t);
    };
    this.addManagedEventListeners({ columnHoverChanged: e }), e();
  }
  getColId() {
    return this.column.getColId();
  }
  addActiveHeaderMouseListeners() {
    const e = (t) => this.handleMouseOverChange(t.type === "mouseenter");
    this.addManagedListeners(this.getGui(), { mouseenter: e, mouseleave: e, click: () => this.dispatchColumnMouseEvent("columnHeaderClicked", this.column), contextmenu: (t) => this.handleContextMenuMouseEvent(t, void 0, this.column) });
  }
  handleMouseOverChange(e) {
    this.setActiveHeader(e);
    const t = { type: e ? "columnHeaderMouseOver" : "columnHeaderMouseLeave", column: this.column };
    this.eventService.dispatchEvent(t);
  }
  setActiveHeader(e) {
    this.comp.addOrRemoveCssClass("ag-header-active", e);
  }
  getAnchorElementForMenu(e) {
    const t = this.comp.getUserCompInstance();
    return t instanceof Ni ? t.getAnchorElementForMenu(e) : this.getGui();
  }
  destroy() {
    super.destroy(), this.refreshFunctions = null, this.selectAllFeature = null, this.dragSourceElement = null, this.userCompDetails = null, this.userHeaderClasses = null, this.ariaDescriptionProperties = null;
  }
}, Ga = class extends f {
  wireBeans(e) {
    this.horizontalResizeService = e.horizontalResizeService, this.autoWidthCalculator = e.autoWidthCalculator, this.visibleColsService = e.visibleColsService, this.columnSizeService = e.columnSizeService, this.columnAutosizeService = e.columnAutosizeService;
  }
  constructor(e, t, i, o) {
    super(), this.eResize = t, this.comp = e, this.pinned = i, this.columnGroup = o;
  }
  postConstruct() {
    if (!this.columnGroup.isResizable())
      return void this.comp.setResizableDisplayed(!1);
    const e = this.horizontalResizeService.addResizeBar({ eResizeBar: this.eResize, onResizeStart: this.onResizeStart.bind(this), onResizing: this.onResizing.bind(this, !1), onResizeEnd: this.onResizing.bind(this, !0) });
    if (this.addDestroyFunc(e), !this.gos.get("suppressAutoSize")) {
      const t = this.gos.get("skipHeaderOnAutoSize");
      this.eResize.addEventListener("dblclick", () => {
        const i = [];
        this.columnGroup.getDisplayedLeafColumns().forEach((o) => {
          o.getColDef().suppressAutoSize || i.push(o.getColId());
        }), i.length > 0 && this.columnAutosizeService.autoSizeCols({ colKeys: i, skipHeader: t, stopAtGroup: this.columnGroup, source: "uiColumnResized" }), this.resizeLeafColumnsToFit("uiColumnResized");
      });
    }
  }
  onResizeStart(e) {
    const t = this.getInitialValues(e);
    this.storeLocalValues(t), this.toggleColumnResizing(!0);
  }
  onResizing(e, t, i = "uiColumnResized") {
    const o = this.normaliseDragChange(t), s = this.resizeStartWidth + o;
    this.resizeColumnsFromLocalValues(s, i, e);
  }
  getInitialValues(e) {
    const t = this.getColumnsToResize(), i = this.getInitialSizeOfColumns(t), o = { columnsToResize: t, resizeStartWidth: i, resizeRatios: this.getSizeRatiosOfColumns(t, i) };
    let s = null;
    if (e && (s = this.visibleColsService.getGroupAtDirection(this.columnGroup, "After")), s) {
      const r = s.getDisplayedLeafColumns(), n = o.groupAfterColumns = r.filter((l) => l.isResizable()), a = o.groupAfterStartWidth = this.getInitialSizeOfColumns(n);
      o.groupAfterRatios = this.getSizeRatiosOfColumns(n, a);
    } else
      o.groupAfterColumns = void 0, o.groupAfterStartWidth = void 0, o.groupAfterRatios = void 0;
    return o;
  }
  storeLocalValues(e) {
    const { columnsToResize: t, resizeStartWidth: i, resizeRatios: o, groupAfterColumns: s, groupAfterStartWidth: r, groupAfterRatios: n } = e;
    this.resizeCols = t, this.resizeStartWidth = i, this.resizeRatios = o, this.resizeTakeFromCols = s, this.resizeTakeFromStartWidth = r, this.resizeTakeFromRatios = n;
  }
  clearLocalValues() {
    this.resizeCols = void 0, this.resizeRatios = void 0, this.resizeTakeFromCols = void 0, this.resizeTakeFromRatios = void 0;
  }
  resizeLeafColumnsToFit(e) {
    const t = this.autoWidthCalculator.getPreferredWidthForColumnGroup(this.columnGroup), i = this.getInitialValues();
    t > i.resizeStartWidth && this.resizeColumns(i, t, e, !0);
  }
  resizeColumnsFromLocalValues(e, t, i = !0) {
    if (!this.resizeCols || !this.resizeRatios)
      return;
    const o = { columnsToResize: this.resizeCols, resizeStartWidth: this.resizeStartWidth, resizeRatios: this.resizeRatios, groupAfterColumns: this.resizeTakeFromCols ?? void 0, groupAfterStartWidth: this.resizeTakeFromStartWidth ?? void 0, groupAfterRatios: this.resizeTakeFromRatios ?? void 0 };
    this.resizeColumns(o, e, t, i);
  }
  resizeColumns(e, t, i, o = !0) {
    const { columnsToResize: s, resizeStartWidth: r, resizeRatios: n, groupAfterColumns: a, groupAfterStartWidth: l, groupAfterRatios: d } = e, c = [];
    if (c.push({ columns: s, ratios: n, width: t }), a) {
      const h = t - r;
      c.push({ columns: a, ratios: d, width: l - h });
    }
    this.columnSizeService.resizeColumnSets({ resizeSets: c, finished: o, source: i }), o && this.toggleColumnResizing(!1);
  }
  toggleColumnResizing(e) {
    this.comp.addOrRemoveCssClass("ag-column-resizing", e);
  }
  getColumnsToResize() {
    return this.columnGroup.getDisplayedLeafColumns().filter((e) => e.isResizable());
  }
  getInitialSizeOfColumns(e) {
    return e.reduce((t, i) => t + i.getActualWidth(), 0);
  }
  getSizeRatiosOfColumns(e, t) {
    return e.map((i) => i.getActualWidth() / t);
  }
  normaliseDragChange(e) {
    let t = e;
    return this.gos.get("enableRtl") ? this.pinned !== "left" && (t *= -1) : this.pinned === "right" && (t *= -1), t;
  }
  destroy() {
    super.destroy(), this.clearLocalValues();
  }
}, za = class extends f {
  constructor(e, t) {
    super(), this.removeChildListenersFuncs = [], this.columnGroup = t, this.comp = e;
  }
  postConstruct() {
    this.addListenersToChildrenColumns(), this.addManagedListeners(this.columnGroup, { displayedChildrenChanged: this.onDisplayedChildrenChanged.bind(this) }), this.onWidthChanged(), this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
  }
  addListenersToChildrenColumns() {
    this.removeListenersOnChildrenColumns();
    const e = this.onWidthChanged.bind(this);
    this.columnGroup.getLeafColumns().forEach((t) => {
      t.addEventListener("widthChanged", e), t.addEventListener("visibleChanged", e), this.removeChildListenersFuncs.push(() => {
        t.removeEventListener("widthChanged", e), t.removeEventListener("visibleChanged", e);
      });
    });
  }
  removeListenersOnChildrenColumns() {
    this.removeChildListenersFuncs.forEach((e) => e()), this.removeChildListenersFuncs = [];
  }
  onDisplayedChildrenChanged() {
    this.addListenersToChildrenColumns(), this.onWidthChanged();
  }
  onWidthChanged() {
    const e = this.columnGroup.getActualWidth();
    this.comp.setWidth(`${e}px`), this.comp.addOrRemoveCssClass("ag-hidden", e === 0);
  }
}, Ba = class extends ai {
  constructor(e, t, i) {
    super(e, t, i), this.onSuppressColMoveChange = () => {
      if (!this.isAlive() || this.isSuppressMoving())
        this.removeDragSource();
      else if (!this.dragSource) {
        const o = this.getGui();
        this.setDragSource(o);
      }
    }, this.column = e;
  }
  setComp(e, t, i) {
    this.comp = e, this.setGui(t), this.displayName = this.beans.columnNameService.getDisplayNameForColumnGroup(this.column, "header"), this.addClasses(), this.setupMovingCss(), this.setupExpandable(), this.setupTooltip(), this.addDestroyFunc(() => {
      this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature));
    }), this.setupUserComp(), this.addHeaderMouseListeners();
    const o = this.getParentRowCtrl().getPinned(), s = this.column.getProvidedColumnGroup().getLeafColumns();
    this.createManagedBean(new mo(s, t)), this.createManagedBean(new po(this.column, t, this.beans)), this.createManagedBean(new za(e, this.column)), this.resizeFeature = this.createManagedBean(new Ga(e, i, o, this.column)), this.createManagedBean(new qe(t, { shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this), onTabKeyDown: () => {
    }, handleKeyDown: this.handleKeyDown.bind(this), onFocusIn: this.onFocusIn.bind(this) })), this.addManagedPropertyListener("suppressMovableColumns", this.onSuppressColMoveChange), this.addResizeAndMoveKeyboardListeners();
  }
  resizeHeader(e, t) {
    if (!this.resizeFeature)
      return;
    const i = this.resizeFeature.getInitialValues(t);
    this.resizeFeature.resizeColumns(i, i.resizeStartWidth + e, "uiColumnResized", !0);
  }
  moveHeader(e) {
    const { beans: t, eGui: i, column: o, gos: s, ctrlsService: r } = this, n = s.get("enableRtl"), a = e === 0, l = this.getPinned(), d = i.getBoundingClientRect(), c = d.left, h = d.width, g = yo(a !== n ? c - 20 : c + h + 20, l, !0, s, r), u = o.getGroupId(), p = this.focusService.getFocusedHeader();
    bo({ allMovingColumns: this.column.getLeafColumns(), isFromHeader: !0, hDirection: e, xPosition: g, pinned: l, fromEnter: !1, fakeEvent: !1, gos: s, columnModel: t.columnModel, columnMoveService: t.columnMoveService, presentedColsService: t.visibleColsService });
    const C = o.getDisplayedLeafColumns(), y = a ? C[0] : T(C);
    this.ctrlsService.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(y, "auto"), !this.isAlive() && p && this.restoreFocus(u, o, p);
  }
  restoreFocus(e, t, i) {
    const o = t.getLeafColumns();
    if (!o.length)
      return;
    const s = o[0].getParent();
    if (!s)
      return;
    const r = this.findGroupWidthId(s, e);
    r && this.focusService.focusHeaderPosition({ headerPosition: { ...i, column: r } });
  }
  findGroupWidthId(e, t) {
    for (; e; ) {
      if (e.getGroupId() === t)
        return e;
      e = e.getParent();
    }
    return null;
  }
  resizeLeafColumnsToFit(e) {
    this.resizeFeature && this.resizeFeature.resizeLeafColumnsToFit(e);
  }
  setupUserComp() {
    const e = this.gos.addGridCommonParams({ displayName: this.displayName, columnGroup: this.column, setExpanded: (i) => {
      this.beans.columnModel.setColumnGroupOpened(this.column.getProvidedColumnGroup(), i, "gridInitializing");
    }, setTooltip: (i, o) => {
      this.setupTooltip(i, o);
    } }), t = this.userComponentFactory.getHeaderGroupCompDetails(e);
    this.comp.setUserCompDetails(t);
  }
  addHeaderMouseListeners() {
    const e = (t) => this.handleMouseOverChange(t.type === "mouseenter");
    this.addManagedListeners(this.getGui(), { mouseenter: e, mouseleave: e, click: () => this.dispatchColumnMouseEvent("columnHeaderClicked", this.column.getProvidedColumnGroup()), contextmenu: (t) => this.handleContextMenuMouseEvent(t, void 0, this.column.getProvidedColumnGroup()) });
  }
  handleMouseOverChange(e) {
    const t = { type: e ? "columnHeaderMouseOver" : "columnHeaderMouseLeave", column: this.column.getProvidedColumnGroup() };
    this.eventService.dispatchEvent(t);
  }
  setupTooltip(e, t) {
    this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature));
    const i = this.column.getColGroupDef(), o = this.gos.get("tooltipShowMode") === "whenTruncated", s = this.eGui;
    t || !o || i != null && i.headerGroupComponent || (t = () => {
      const n = s.querySelector(".ag-header-group-text");
      return !n || n.scrollWidth > n.clientWidth;
    });
    const r = { getColumn: () => this.column, getGui: () => s, getLocation: () => "headerGroup", getTooltipValue: () => e ?? (i && i.headerTooltip), shouldDisplayTooltip: t };
    i && (r.getColDef = () => i), this.createManagedBean(new gt(r));
  }
  setupExpandable() {
    const e = this.column.getProvidedColumnGroup();
    this.refreshExpanded();
    const t = this.refreshExpanded.bind(this);
    this.addManagedListeners(e, { expandedChanged: t, expandableChanged: t });
  }
  refreshExpanded() {
    const { column: e } = this;
    this.expandable = e.isExpandable();
    const t = e.isExpanded();
    this.expandable ? this.comp.setAriaExpanded(t ? "true" : "false") : this.comp.setAriaExpanded(void 0);
  }
  getColId() {
    return this.column.getUniqueId();
  }
  addClasses() {
    const e = hr(this.column.getColGroupDef(), this.gos, null, this.column);
    this.column.isPadding() ? (e.push("ag-header-group-cell-no-group"), this.column.getLeafColumns().every((t) => t.isSpanHeaderHeight()) && e.push("ag-header-span-height")) : e.push("ag-header-group-cell-with-group"), e.forEach((t) => this.comp.addOrRemoveCssClass(t, !0));
  }
  setupMovingCss() {
    const e = this.column.getProvidedColumnGroup().getLeafColumns(), t = () => this.comp.addOrRemoveCssClass("ag-header-cell-moving", this.column.isMoving());
    e.forEach((i) => {
      this.addManagedListeners(i, { movingChanged: t });
    }), t();
  }
  onFocusIn(e) {
    if (!this.eGui.contains(e.relatedTarget)) {
      const t = this.getRowIndex();
      this.beans.focusService.setFocusedHeader(t, this.column);
    }
  }
  handleKeyDown(e) {
    super.handleKeyDown(e);
    const t = this.getWrapperHasFocus();
    if (this.expandable && t && e.key === v.ENTER) {
      const i = this.column, o = !i.isExpanded();
      this.beans.columnModel.setColumnGroupOpened(i.getProvidedColumnGroup(), o, "uiColumnExpanded");
    }
  }
  setDragSource(e) {
    if (!this.isAlive() || this.isSuppressMoving() || (this.removeDragSource(), !e))
      return;
    const { beans: t, column: i, displayName: o, gos: s, dragAndDropService: r } = this, { columnModel: n } = t, a = i.getProvidedColumnGroup().getLeafColumns();
    let l = !s.get("suppressDragLeaveHidesColumns");
    const d = this.dragSource = { type: 1, eElement: e, getDefaultIconName: () => l ? "hide" : "notAllowed", dragItemName: o, getDragItem: () => this.getDragItemForGroup(i), onDragStarted: () => {
      l = !s.get("suppressDragLeaveHidesColumns"), a.forEach((c) => c.setMoving(!0, "uiColumnDragged"));
    }, onDragStopped: () => a.forEach((c) => c.setMoving(!1, "uiColumnDragged")), onGridEnter: (c) => {
      var h;
      if (l) {
        const g = ((h = c == null ? void 0 : c.columns) == null ? void 0 : h.filter((u) => !u.getColDef().lockVisible)) || [];
        n.setColsVisible(g, !0, "uiColumnMoved");
      }
    }, onGridExit: (c) => {
      var h;
      if (l) {
        const g = ((h = c == null ? void 0 : c.columns) == null ? void 0 : h.filter((u) => !u.getColDef().lockVisible)) || [];
        n.setColsVisible(g, !1, "uiColumnMoved");
      }
    } };
    r.addDragSource(d, !0);
  }
  getDragItemForGroup(e) {
    const t = e.getProvidedColumnGroup().getLeafColumns(), i = {};
    t.forEach((s) => i[s.getId()] = s.isVisible());
    const o = [];
    return this.beans.visibleColsService.getAllCols().forEach((s) => {
      t.indexOf(s) >= 0 && (o.push(s), Y(t, s));
    }), t.forEach((s) => o.push(s)), { columns: o, visibleState: i };
  }
  isSuppressMoving() {
    let e = !1;
    return this.column.getLeafColumns().forEach((t) => {
      (t.getColDef().suppressMovable || t.getColDef().lockPosition) && (e = !0);
    }), e || this.gos.get("suppressMovableColumns");
  }
}, Ha = 0, yi = class extends f {
  constructor(e, t, i) {
    super(), this.instanceId = Ha++, this.rowIndex = e, this.pinned = t, this.type = i;
    const o = i == "group" ? "ag-header-row-column-group" : i == "filter" ? "ag-header-row-column-filter" : "ag-header-row-column";
    this.headerRowClass = `ag-header-row ${o}`;
  }
  wireBeans(e) {
    this.beans = e;
  }
  postConstruct() {
    this.isPrintLayout = this.gos.isDomLayout("print"), this.isEnsureDomOrder = this.gos.get("ensureDomOrder");
  }
  getInstanceId() {
    return this.instanceId;
  }
  areCellsRendered() {
    return !!this.comp && this.getHeaderCellCtrls().every((e) => e.getGui() != null);
  }
  setComp(e, t = !0) {
    this.comp = e, t && (this.onRowHeightChanged(), this.onVirtualColumnsChanged()), this.setWidth(), this.addEventListeners();
  }
  getHeaderRowClass() {
    return this.headerRowClass;
  }
  getAriaRowIndex() {
    return this.rowIndex + 1;
  }
  addEventListeners() {
    const e = this.onRowHeightChanged.bind(this);
    this.addManagedEventListeners({ columnResized: this.onColumnResized.bind(this), displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this), virtualColumnsChanged: (t) => this.onVirtualColumnsChanged(t.afterScroll), columnHeaderHeightChanged: e, gridStylesChanged: e, advancedFilterEnabledChanged: e }), this.addManagedPropertyListener("domLayout", this.onDisplayedColumnsChanged.bind(this)), this.addManagedPropertyListener("ensureDomOrder", (t) => this.isEnsureDomOrder = t.currentValue), this.addManagedPropertyListeners(["headerHeight", "pivotHeaderHeight", "groupHeaderHeight", "pivotGroupHeaderHeight", "floatingFiltersHeight"], e);
  }
  getHeaderCellCtrl(e) {
    if (this.headerCellCtrls)
      return jt(this.headerCellCtrls).find((t) => t.getColumnGroupChild() === e);
  }
  onDisplayedColumnsChanged() {
    this.isPrintLayout = this.gos.isDomLayout("print"), this.onVirtualColumnsChanged(), this.setWidth(), this.onRowHeightChanged();
  }
  getType() {
    return this.type;
  }
  onColumnResized() {
    this.setWidth();
  }
  setWidth() {
    const e = this.getWidthForRow();
    this.comp.setWidth(`${e}px`);
  }
  getWidthForRow() {
    const { visibleColsService: e } = this.beans;
    return this.isPrintLayout ? this.pinned != null ? 0 : e.getContainerWidth("right") + e.getContainerWidth("left") + e.getContainerWidth(null) : e.getContainerWidth(this.pinned);
  }
  onRowHeightChanged() {
    const { topOffset: e, rowHeight: t } = this.getTopAndHeight();
    this.comp.setTop(e + "px"), this.comp.setHeight(t + "px");
  }
  getTopAndHeight() {
    const { columnModel: e, filterManager: t } = this.beans;
    let i = e.getHeaderRowCount();
    const o = [];
    let s = 0;
    t != null && t.hasFloatingFilters() && (i++, s = 1);
    const r = e.getColumnGroupHeaderRowHeight(), n = e.getColumnHeaderRowHeight(), a = i - (1 + s);
    for (let d = 0; d < a; d++)
      o.push(r);
    o.push(n);
    for (let d = 0; d < s; d++)
      o.push(e.getFloatingFiltersHeight());
    let l = 0;
    for (let d = 0; d < this.rowIndex; d++)
      l += o[d];
    return { topOffset: l, rowHeight: o[this.rowIndex] };
  }
  getPinned() {
    return this.pinned;
  }
  getRowIndex() {
    return this.rowIndex;
  }
  onVirtualColumnsChanged(e = !1) {
    const t = this.getHeaderCtrls(), i = this.isEnsureDomOrder || this.isPrintLayout;
    this.comp.setHeaderCtrls(t, i, e);
  }
  getHeaderCtrls() {
    const e = this.headerCellCtrls;
    this.headerCellCtrls = /* @__PURE__ */ new Map();
    const t = this.getColumnsInViewport();
    for (const o of t)
      this.recycleAndCreateHeaderCtrls(o, e);
    const i = (o) => {
      const { focusService: s, visibleColsService: r } = this.beans;
      return !!s.isHeaderWrapperFocused(o) && r.isVisible(o.getColumnGroupChild());
    };
    if (e)
      for (const [o, s] of e)
        i(s) ? this.headerCellCtrls.set(o, s) : this.destroyBean(s);
    return this.getHeaderCellCtrls();
  }
  getHeaderCellCtrls() {
    var e;
    return Array.from(((e = this.headerCellCtrls) == null ? void 0 : e.values()) ?? []);
  }
  recycleAndCreateHeaderCtrls(e, t) {
    if (!this.headerCellCtrls || e.isEmptyGroup())
      return;
    const i = e.getUniqueId();
    let o;
    if (t && (o = t.get(i), t.delete(i)), o && o.getColumnGroupChild() != e && (this.destroyBean(o), o = void 0), o == null)
      switch (this.type) {
        case "filter":
          o = this.createBean(this.beans.ctrlsFactory.getInstance("headerFilterCell", e, this.beans, this));
          break;
        case "group":
          o = this.createBean(new Ba(e, this.beans, this));
          break;
        default:
          o = this.createBean(new Na(e, this.beans, this));
      }
    this.headerCellCtrls.set(i, o);
  }
  getColumnsInViewport() {
    return this.isPrintLayout ? this.getColumnsInViewportPrintLayout() : this.getColumnsInViewportNormalLayout();
  }
  getColumnsInViewportPrintLayout() {
    if (this.pinned != null)
      return [];
    let e = [];
    const t = this.getActualDepth(), { columnViewportService: i } = this.beans;
    return ["left", null, "right"].forEach((o) => {
      const s = i.getHeadersToRender(o, t);
      e = e.concat(s);
    }), e;
  }
  getActualDepth() {
    return this.type == "filter" ? this.rowIndex - 1 : this.rowIndex;
  }
  getColumnsInViewportNormalLayout() {
    return this.beans.columnViewportService.getHeadersToRender(this.pinned, this.getActualDepth());
  }
  findHeaderCellCtrl(e) {
    if (this.headerCellCtrls)
      return this.getHeaderCellCtrls().find((t) => t.getColumnGroupChild() == e);
  }
  focusHeader(e, t) {
    const i = this.findHeaderCellCtrl(e);
    return !!i && i.focus(t);
  }
  destroy() {
    this.headerCellCtrls && this.headerCellCtrls.forEach((e) => {
      this.destroyBean(e);
    }), this.headerCellCtrls = void 0, super.destroy();
  }
}, Va = class extends f {
  constructor(e) {
    super(), this.hidden = !1, this.includeFloatingFilter = !1, this.groupsRowCtrls = [], this.pinned = e;
  }
  wireBeans(e) {
    this.ctrlsService = e.ctrlsService, this.scrollVisibleService = e.scrollVisibleService, this.pinnedWidthService = e.pinnedWidthService, this.columnModel = e.columnModel, this.focusService = e.focusService, this.filterManager = e.filterManager;
  }
  setComp(e, t) {
    this.comp = e, this.eViewport = t, this.setupCenterWidth(), this.setupPinnedWidth(), this.setupDragAndDrop(this.eViewport);
    const i = this.onDisplayedColumnsChanged.bind(this);
    this.addManagedEventListeners({ gridColumnsChanged: this.onGridColumnsChanged.bind(this), displayedColumnsChanged: i, advancedFilterEnabledChanged: i }), this.ctrlsService.registerHeaderContainer(this, this.pinned), this.columnModel.isReady() && this.refresh();
  }
  getAllCtrls() {
    const e = [...this.groupsRowCtrls];
    return this.columnsRowCtrl && e.push(this.columnsRowCtrl), this.filtersRowCtrl && e.push(this.filtersRowCtrl), e;
  }
  refresh(e = !1) {
    const t = new ct(), i = this.focusService.getFocusHeaderToUseAfterRefresh();
    (() => {
      const s = this.columnModel.getHeaderRowCount() - 1;
      this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls);
      for (let r = 0; r < s; r++) {
        const n = this.createBean(new yi(t.next(), this.pinned, "group"));
        this.groupsRowCtrls.push(n);
      }
    })(), (() => {
      const s = t.next(), r = !(this.hidden || this.columnsRowCtrl != null && e && this.columnsRowCtrl.getRowIndex() === s);
      (r || this.hidden) && (this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl)), r && (this.columnsRowCtrl = this.createBean(new yi(s, this.pinned, "column")));
    })(), (() => {
      var n;
      this.includeFloatingFilter = !!((n = this.filterManager) != null && n.hasFloatingFilters()) && !this.hidden;
      const s = () => {
        this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
      };
      if (!this.includeFloatingFilter)
        return void s();
      const r = t.next();
      if (this.filtersRowCtrl) {
        const a = this.filtersRowCtrl.getRowIndex() !== r;
        e && !a || s();
      }
      this.filtersRowCtrl || (this.filtersRowCtrl = this.createBean(new yi(r, this.pinned, "filter")));
    })();
    const o = this.getAllCtrls();
    this.comp.setCtrls(o), this.restoreFocusOnHeader(i);
  }
  getHeaderCtrlForColumn(e) {
    if (Le(e))
      return this.columnsRowCtrl ? this.columnsRowCtrl.getHeaderCellCtrl(e) : void 0;
    if (this.groupsRowCtrls.length !== 0)
      for (let t = 0; t < this.groupsRowCtrls.length; t++) {
        const i = this.groupsRowCtrls[t].getHeaderCellCtrl(e);
        if (i)
          return i;
      }
  }
  getHtmlElementForColumnHeader(e) {
    const t = this.getHeaderCtrlForColumn(e);
    return t ? t.getGui() : null;
  }
  getRowType(e) {
    const t = this.getAllCtrls()[e];
    return t ? t.getType() : void 0;
  }
  focusHeader(e, t, i) {
    const o = this.getAllCtrls()[e];
    return !!o && o.focusHeader(t, i);
  }
  getViewport() {
    return this.eViewport;
  }
  getRowCount() {
    return this.groupsRowCtrls.length + (this.columnsRowCtrl ? 1 : 0) + (this.filtersRowCtrl ? 1 : 0);
  }
  setHorizontalScroll(e) {
    this.comp.setViewportScrollLeft(e);
  }
  destroy() {
    this.filtersRowCtrl && (this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl)), this.columnsRowCtrl && (this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl)), this.groupsRowCtrls && this.groupsRowCtrls.length && (this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls)), super.destroy();
  }
  setupDragAndDrop(e) {
    const t = new Ia(this.pinned, e);
    this.createManagedBean(t);
  }
  restoreFocusOnHeader(e) {
    if (!e)
      return;
    const { column: t } = e;
    t.getPinned() == this.pinned && this.focusService.focusHeaderPosition({ headerPosition: e });
  }
  onGridColumnsChanged() {
    this.refresh(!0);
  }
  onDisplayedColumnsChanged() {
    var t;
    const e = ((t = this.filterManager) == null ? void 0 : t.hasFloatingFilters()) && !this.hidden;
    this.includeFloatingFilter !== e && this.refresh(!0);
  }
  setupCenterWidth() {
    this.pinned == null && this.createManagedBean(new wo((e) => this.comp.setCenterWidth(`${e}px`), !0));
  }
  setupPinnedWidth() {
    if (this.pinned == null)
      return;
    const e = this.pinned === "left", t = this.pinned === "right";
    this.hidden = !0;
    const i = () => {
      const o = e ? this.pinnedWidthService.getPinnedLeftWidth() : this.pinnedWidthService.getPinnedRightWidth();
      if (o == null)
        return;
      const s = o == 0, r = this.hidden !== s, n = this.gos.get("enableRtl"), a = this.gos.getScrollbarWidth(), l = this.scrollVisibleService.isVerticalScrollShowing() && (n && e || !n && t) ? o + a : o;
      this.comp.setPinnedContainerWidth(`${l}px`), this.comp.setDisplayed(!s), r && (this.hidden = s, this.refresh());
    };
    this.addManagedEventListeners({ leftPinnedWidthChanged: i, rightPinnedWidthChanged: i, scrollVisibilityChanged: i, scrollbarWidthChanged: i });
  }
}, Si = class extends O {
  constructor(e) {
    super(), this.eCenterContainer = R, this.headerRowComps = {}, this.rowCompsList = [], this.pinned = e;
  }
  postConstruct() {
    this.selectAndSetTemplate();
    const e = { setDisplayed: (t) => this.setDisplayed(t), setCtrls: (t) => this.setCtrls(t), setCenterWidth: (t) => this.eCenterContainer.style.width = t, setViewportScrollLeft: (t) => this.getGui().scrollLeft = t, setPinnedContainerWidth: (t) => {
      const i = this.getGui();
      i.style.width = t, i.style.maxWidth = t, i.style.minWidth = t;
    } };
    this.createManagedBean(new Va(this.pinned)).setComp(e, this.getGui());
  }
  selectAndSetTemplate() {
    const e = this.pinned == "left", t = this.pinned == "right", i = e ? '<div class="ag-pinned-left-header" role="rowgroup"></div>' : t ? '<div class="ag-pinned-right-header" role="rowgroup"></div>' : `<div class="ag-header-viewport" role="presentation">
        <div class="ag-header-container" data-ref="eCenterContainer" role="rowgroup"></div>
    </div>`;
    this.setTemplate(i), this.eRowContainer = this.eCenterContainer !== R ? this.eCenterContainer : this.getGui();
  }
  destroy() {
    this.setCtrls([]), super.destroy();
  }
  destroyRowComp(e) {
    this.destroyBean(e), this.eRowContainer.removeChild(e.getGui());
  }
  setCtrls(e) {
    const t = this.headerRowComps;
    let i;
    this.headerRowComps = {}, this.rowCompsList = [];
    const o = (s) => {
      const r = s.getGui();
      r.parentElement != this.eRowContainer && this.eRowContainer.appendChild(r), i && Ls(this.eRowContainer, r, i), i = r;
    };
    e.forEach((s) => {
      const r = s.getInstanceId(), n = t[r];
      delete t[r];
      const a = n || this.createBean(new Ma(s));
      this.headerRowComps[r] = a, this.rowCompsList.push(a), o(a);
    }), Ie(t).forEach((s) => this.destroyRowComp(s));
  }
}, Wa = { selector: "AG-HEADER-ROOT", component: class extends O {
  constructor() {
    super('<div class="ag-header" role="presentation"/>');
  }
  postConstruct() {
    const e = { addOrRemoveCssClass: (i, o) => this.addOrRemoveCssClass(i, o), setHeightAndMinHeight: (i) => {
      this.getGui().style.height = i, this.getGui().style.minHeight = i;
    } };
    this.createManagedBean(new Pa()).setComp(e, this.getGui(), this.getFocusableElement());
    const t = (i) => {
      this.createManagedBean(i), this.appendChild(i);
    };
    t(new Si("left")), t(new Si(null)), t(new Si("right"));
  }
} }, So = class extends f {
  constructor(e) {
    super(), this.view = e;
  }
  postConstruct() {
    this.addManagedPropertyListener("domLayout", this.updateLayoutClasses.bind(this)), this.updateLayoutClasses();
  }
  updateLayoutClasses() {
    const e = this.getDomLayout(), t = { autoHeight: e === "autoHeight", normal: e === "normal", print: e === "print" }, i = t.autoHeight ? "ag-layout-auto-height" : t.print ? "ag-layout-print" : "ag-layout-normal";
    this.view.updateLayoutClasses(i, t);
  }
  getDomLayout() {
    const e = this.gos.get("domLayout") ?? "normal";
    return ["normal", "print", "autoHeight"].indexOf(e) === -1 ? (b(`${e} is not valid for DOM Layout, valid values are 'normal', 'autoHeight', 'print'.`), "normal") : e;
  }
}, Ua = { selector: "AG-OVERLAY-WRAPPER", component: class extends O {
  constructor() {
    super(`
            <div class="ag-overlay" role="presentation">
                <div class="ag-overlay-panel" role="presentation">
                    <div class="ag-overlay-wrapper" data-ref="eOverlayWrapper" role="presentation"></div>
                </div>
            </div>`), this.eOverlayWrapper = R, this.activePromise = null, this.activeOverlay = null, this.updateListenerDestroyFunc = null, this.activeOverlayWrapperCssClass = null;
  }
  wireBeans(e) {
    this.overlayService = e.overlayService;
  }
  updateLayoutClasses(e, t) {
    const i = this.eOverlayWrapper.classList;
    i.toggle("ag-layout-auto-height", t.autoHeight), i.toggle("ag-layout-normal", t.normal), i.toggle("ag-layout-print", t.print);
  }
  postConstruct() {
    this.createManagedBean(new So(this)), this.setDisplayed(!1, { skipAriaHidden: !0 }), this.overlayService.registerOverlayWrapperComp(this);
  }
  setWrapperTypeClass(e) {
    const t = this.eOverlayWrapper.classList;
    this.activeOverlayWrapperCssClass && t.toggle(this.activeOverlayWrapperCssClass, !1), this.activeOverlayWrapperCssClass = e, t.toggle(e, !0);
  }
  showOverlay(e, t, i) {
    this.setWrapperTypeClass(t), this.destroyActiveOverlay(), this.activePromise = e, e == null || e.then((o) => {
      if (this.activePromise === e) {
        if (this.activePromise = null, o && this.activeOverlay != o && (this.eOverlayWrapper.appendChild(o.getGui()), this.activeOverlay = o, i)) {
          const s = o;
          this.updateListenerDestroyFunc = this.addManagedPropertyListener(i, ({ currentValue: r }) => {
            var n;
            (n = s.refresh) == null || n.call(s, this.gos.addGridCommonParams({ ...r ?? {} }));
          });
        }
      } else
        this.activeOverlay !== o && (this.destroyBean(o), o = null);
    }), this.setDisplayed(!0, { skipAriaHidden: !0 });
  }
  destroyActiveOverlay() {
    this.activePromise = null;
    const e = this.activeOverlay;
    if (!e)
      return;
    this.activeOverlay = null;
    const t = this.updateListenerDestroyFunc;
    t && (t(), this.updateListenerDestroyFunc = null), this.destroyBean(e), j(this.eOverlayWrapper);
  }
  hideOverlay() {
    this.destroyActiveOverlay(), this.setDisplayed(!1, { skipAriaHidden: !0 });
  }
  destroy() {
    this.destroyActiveOverlay(), super.destroy();
  }
} }, Cr = class extends O {
  constructor(e, t) {
    super(), this.direction = t, this.eViewport = R, this.eContainer = R, this.hideTimeout = null, this.setTemplate(e);
  }
  wireBeans(e) {
    this.animationFrameService = e.animationFrameService;
  }
  postConstruct() {
    this.addManagedEventListeners({ scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this) }), this.onScrollVisibilityChanged(), this.addOrRemoveCssClass("ag-apple-scrollbar", Ms() || Oe());
  }
  initialiseInvisibleScrollbar() {
    this.invisibleScrollbar === void 0 && (this.invisibleScrollbar = Ps(), this.invisibleScrollbar && (this.hideAndShowInvisibleScrollAsNeeded(), this.addActiveListenerToggles()));
  }
  addActiveListenerToggles() {
    const e = this.getGui(), t = () => this.addOrRemoveCssClass("ag-scrollbar-active", !0), i = () => this.addOrRemoveCssClass("ag-scrollbar-active", !1);
    this.addManagedListeners(e, { mouseenter: t, mousedown: t, touchstart: t, mouseleave: i, touchend: i });
  }
  onScrollVisibilityChanged() {
    this.invisibleScrollbar === void 0 && this.initialiseInvisibleScrollbar(), this.animationFrameService.requestAnimationFrame(() => this.setScrollVisible());
  }
  hideAndShowInvisibleScrollAsNeeded() {
    this.addManagedEventListeners({ bodyScroll: (e) => {
      e.direction === this.direction && (this.hideTimeout !== null && (window.clearTimeout(this.hideTimeout), this.hideTimeout = null), this.addOrRemoveCssClass("ag-scrollbar-scrolling", !0));
    }, bodyScrollEnd: () => {
      this.hideTimeout = window.setTimeout(() => {
        this.addOrRemoveCssClass("ag-scrollbar-scrolling", !1), this.hideTimeout = null;
      }, 400);
    } });
  }
  attemptSettingScrollPosition(e) {
    const t = this.getViewport();
    (function(i, o, s = 100, r) {
      const n = (/* @__PURE__ */ new Date()).getTime();
      let a = null, l = !1;
      const d = () => {
        const c = (/* @__PURE__ */ new Date()).getTime() - n > s;
        (i() || c) && (o(), l = !0, a != null && (window.clearInterval(a), a = null), c && r && b(r));
      };
      d(), l || (a = window.setInterval(d, 10));
    })(() => he(t), () => this.setScrollPosition(e), 100);
  }
  getViewport() {
    return this.eViewport;
  }
  getContainer() {
    return this.eContainer;
  }
  onScrollCallback(e) {
    this.addManagedElementListeners(this.getViewport(), { scroll: e });
  }
}, ja = { selector: "AG-FAKE-HORIZONTAL-SCROLL", component: class extends Cr {
  constructor() {
    super(`<div class="ag-body-horizontal-scroll" aria-hidden="true">
            <div class="ag-horizontal-left-spacer" data-ref="eLeftSpacer"></div>
            <div class="ag-body-horizontal-scroll-viewport" data-ref="eViewport">
                <div class="ag-body-horizontal-scroll-container" data-ref="eContainer"></div>
            </div>
            <div class="ag-horizontal-right-spacer" data-ref="eRightSpacer"></div>
        </div>`, "horizontal"), this.eLeftSpacer = R, this.eRightSpacer = R;
  }
  wireBeans(e) {
    super.wireBeans(e), this.visibleColsService = e.visibleColsService, this.pinnedRowModel = e.pinnedRowModel, this.ctrlsService = e.ctrlsService, this.scrollVisibleService = e.scrollVisibleService;
  }
  postConstruct() {
    super.postConstruct();
    const e = this.setFakeHScrollSpacerWidths.bind(this);
    this.addManagedEventListeners({ displayedColumnsChanged: e, displayedColumnsWidthChanged: e, pinnedRowDataChanged: this.onPinnedRowDataChanged.bind(this) }), this.addManagedPropertyListener("domLayout", e), this.ctrlsService.register("fakeHScrollComp", this), this.createManagedBean(new wo((t) => this.eContainer.style.width = `${t}px`)), this.addManagedPropertyListeners(["suppressHorizontalScroll"], this.onScrollVisibilityChanged.bind(this));
  }
  initialiseInvisibleScrollbar() {
    this.invisibleScrollbar === void 0 && (this.enableRtl = this.gos.get("enableRtl"), super.initialiseInvisibleScrollbar(), this.invisibleScrollbar && this.refreshCompBottom());
  }
  onPinnedRowDataChanged() {
    this.refreshCompBottom();
  }
  refreshCompBottom() {
    if (!this.invisibleScrollbar)
      return;
    const e = this.pinnedRowModel.getPinnedBottomTotalHeight();
    this.getGui().style.bottom = `${e}px`;
  }
  onScrollVisibilityChanged() {
    super.onScrollVisibilityChanged(), this.setFakeHScrollSpacerWidths();
  }
  setFakeHScrollSpacerWidths() {
    const e = this.scrollVisibleService.isVerticalScrollShowing();
    let t = this.visibleColsService.getDisplayedColumnsRightWidth();
    const i = !this.enableRtl && e, o = this.gos.getScrollbarWidth();
    i && (t += o), ce(this.eRightSpacer, t), this.eRightSpacer.classList.toggle("ag-scroller-corner", t <= o);
    let s = this.visibleColsService.getColsLeftWidth();
    this.enableRtl && e && (s += o), ce(this.eLeftSpacer, s), this.eLeftSpacer.classList.toggle("ag-scroller-corner", s <= o);
  }
  setScrollVisible() {
    const e = this.scrollVisibleService.isHorizontalScrollShowing(), t = this.invisibleScrollbar, i = this.gos.get("suppressHorizontalScroll"), o = e && this.gos.getScrollbarWidth() || 0, s = i ? 0 : o === 0 && t ? 16 : o;
    this.addOrRemoveCssClass("ag-scrollbar-invisible", t), yt(this.getGui(), s), yt(this.eViewport, s), yt(this.eContainer, s), this.setDisplayed(e, { skipAriaHidden: !0 });
  }
  getScrollPosition() {
    return ii(this.getViewport(), this.enableRtl);
  }
  setScrollPosition(e) {
    he(this.getViewport()) || this.attemptSettingScrollPosition(e), oi(this.getViewport(), e, this.enableRtl);
  }
} }, wr = class extends f {
  wireBeans(e) {
    this.maxDivHeightScaler = e.rowContainerHeightService;
  }
  constructor(e, t) {
    super(), this.eContainer = e, this.eViewport = t;
  }
  postConstruct() {
    this.addManagedEventListeners({ rowContainerHeightChanged: this.onHeightChanged.bind(this) });
  }
  onHeightChanged() {
    const e = this.maxDivHeightScaler.getUiContainerHeight(), t = e != null ? `${e}px` : "";
    this.eContainer.style.height = t, this.eViewport && (this.eViewport.style.height = t);
  }
}, Ka = { selector: "AG-FAKE-VERTICAL-SCROLL", component: class extends Cr {
  wireBeans(e) {
    super.wireBeans(e), this.ctrlsService = e.ctrlsService, this.scrollVisibleService = e.scrollVisibleService;
  }
  constructor() {
    super(`<div class="ag-body-vertical-scroll" aria-hidden="true">
            <div class="ag-body-vertical-scroll-viewport" data-ref="eViewport">
                <div class="ag-body-vertical-scroll-container" data-ref="eContainer"></div>
            </div>
        </div>`, "vertical");
  }
  postConstruct() {
    super.postConstruct(), this.createManagedBean(new wr(this.eContainer)), this.ctrlsService.register("fakeVScrollComp", this), this.addManagedEventListeners({ rowContainerHeightChanged: this.onRowContainerHeightChanged.bind(this) });
  }
  setScrollVisible() {
    const e = this.scrollVisibleService.isVerticalScrollShowing(), t = this.invisibleScrollbar, i = e && this.gos.getScrollbarWidth() || 0, o = i === 0 && t ? 16 : i;
    this.addOrRemoveCssClass("ag-scrollbar-invisible", t), ce(this.getGui(), o), ce(this.eViewport, o), ce(this.eContainer, o), this.setDisplayed(e, { skipAriaHidden: !0 });
  }
  onRowContainerHeightChanged() {
    const { ctrlsService: e } = this, t = e.getGridBodyCtrl().getBodyViewportElement(), i = this.getScrollPosition(), o = t.scrollTop;
    i != o && this.setScrollPosition(o, !0);
  }
  getScrollPosition() {
    return this.getViewport().scrollTop;
  }
  setScrollPosition(e, t) {
    t || he(this.getViewport()) || this.attemptSettingScrollPosition(e), this.getViewport().scrollTop = e;
  }
} }, Qa = class extends f {
  constructor(e) {
    super(), this.lastScrollSource = [null, null], this.scrollLeft = -1, this.nextScrollTop = -1, this.scrollTop = -1, this.lastOffsetHeight = -1, this.lastScrollTop = -1, this.eBodyViewport = e, this.resetLastHScrollDebounced = q(() => this.lastScrollSource[1] = null, 500), this.resetLastVScrollDebounced = q(() => this.lastScrollSource[0] = null, 500);
  }
  wireBeans(e) {
    this.ctrlsService = e.ctrlsService, this.animationFrameService = e.animationFrameService, this.paginationService = e.paginationService, this.pageBoundsService = e.pageBoundsService, this.rowModel = e.rowModel, this.heightScaler = e.rowContainerHeightService, this.rowRenderer = e.rowRenderer, this.columnModel = e.columnModel, this.visibleColsService = e.visibleColsService;
  }
  postConstruct() {
    this.enableRtl = this.gos.get("enableRtl"), this.addManagedEventListeners({ displayedColumnsWidthChanged: this.onDisplayedColumnsWidthChanged.bind(this) }), this.ctrlsService.whenReady((e) => {
      this.centerRowsCtrl = e.center, this.onDisplayedColumnsWidthChanged(), this.addScrollListener();
    });
  }
  addScrollListener() {
    const { fakeHScrollComp: e, fakeVScrollComp: t } = this.ctrlsService.getParams();
    this.addManagedElementListeners(this.centerRowsCtrl.getViewportElement(), { scroll: this.onHScroll.bind(this) }), e.onScrollCallback(this.onFakeHScroll.bind(this));
    const i = this.gos.get("debounceVerticalScrollbar"), o = i ? q(this.onVScroll.bind(this), 100) : this.onVScroll.bind(this), s = i ? q(this.onFakeVScroll.bind(this), 100) : this.onFakeVScroll.bind(this);
    this.addManagedElementListeners(this.eBodyViewport, { scroll: o }), t.onScrollCallback(s);
  }
  onDisplayedColumnsWidthChanged() {
    this.enableRtl && this.horizontallyScrollHeaderCenterAndFloatingCenter();
  }
  horizontallyScrollHeaderCenterAndFloatingCenter(e) {
    if (this.centerRowsCtrl == null)
      return;
    e === void 0 && (e = this.centerRowsCtrl.getCenterViewportScrollLeft());
    const t = this.enableRtl ? e : -e, { topCenter: i, stickyTopCenter: o, stickyBottomCenter: s, centerHeader: r, bottomCenter: n, fakeHScrollComp: a } = this.ctrlsService.getParams();
    r.setHorizontalScroll(-t), n.setContainerTranslateX(t), i.setContainerTranslateX(t), o.setContainerTranslateX(t), s.setContainerTranslateX(t);
    const l = this.centerRowsCtrl.getViewportElement(), d = this.lastScrollSource[1] === 0;
    e = Math.abs(e), d ? a.setScrollPosition(e) : oi(l, e, this.enableRtl);
  }
  isControllingScroll(e, t) {
    return this.lastScrollSource[t] == null ? (this.lastScrollSource[t] = e, !0) : this.lastScrollSource[t] === e;
  }
  onFakeHScroll() {
    this.isControllingScroll(1, 1) && this.onHScrollCommon(1);
  }
  onHScroll() {
    this.isControllingScroll(0, 1) && this.onHScrollCommon(0);
  }
  onHScrollCommon(e) {
    const t = this.centerRowsCtrl.getViewportElement(), { scrollLeft: i } = t;
    if (this.shouldBlockScrollUpdate(1, i, !0))
      return;
    let o;
    o = e === 0 ? ii(t, this.enableRtl) : this.ctrlsService.get("fakeHScrollComp").getScrollPosition(), this.doHorizontalScroll(Math.round(o)), this.resetLastHScrollDebounced();
  }
  onFakeVScroll() {
    this.isControllingScroll(1, 0) && this.onVScrollCommon(1);
  }
  onVScroll() {
    this.isControllingScroll(0, 0) && this.onVScrollCommon(0);
  }
  onVScrollCommon(e) {
    let t;
    t = e === 0 ? this.eBodyViewport.scrollTop : this.ctrlsService.get("fakeVScrollComp").getScrollPosition(), this.shouldBlockScrollUpdate(0, t, !0) || (this.animationFrameService.setScrollTop(t), this.nextScrollTop = t, e === 0 ? this.ctrlsService.get("fakeVScrollComp").setScrollPosition(t) : this.eBodyViewport.scrollTop = t, this.gos.get("suppressAnimationFrame") ? this.scrollGridIfNeeded() : this.animationFrameService.schedule(), this.resetLastVScrollDebounced());
  }
  doHorizontalScroll(e) {
    const t = this.ctrlsService.get("fakeHScrollComp").getScrollPosition();
    this.scrollLeft === e && e === t || (this.scrollLeft = e, this.fireScrollEvent(1), this.horizontallyScrollHeaderCenterAndFloatingCenter(e), this.centerRowsCtrl.onHorizontalViewportChanged(!0));
  }
  fireScrollEvent(e) {
    const t = { type: "bodyScroll", direction: e === 1 ? "horizontal" : "vertical", left: this.scrollLeft, top: this.scrollTop };
    this.eventService.dispatchEvent(t), window.clearTimeout(this.scrollTimer), this.scrollTimer = void 0, this.scrollTimer = window.setTimeout(() => {
      const i = { ...t, type: "bodyScrollEnd" };
      this.eventService.dispatchEvent(i);
    }, 100);
  }
  shouldBlockScrollUpdate(e, t, i = !1) {
    return !(i && !Oe()) && (e === 0 ? this.shouldBlockVerticalScroll(t) : this.shouldBlockHorizontalScroll(t));
  }
  shouldBlockVerticalScroll(e) {
    const t = oo(this.eBodyViewport), { scrollHeight: i } = this.eBodyViewport;
    return e < 0 || e + t > i;
  }
  shouldBlockHorizontalScroll(e) {
    const t = this.centerRowsCtrl.getCenterWidth(), { scrollWidth: i } = this.centerRowsCtrl.getViewportElement();
    if (this.enableRtl && ti()) {
      if (e > 0)
        return !0;
    } else if (e < 0)
      return !0;
    return Math.abs(e) + t > i;
  }
  redrawRowsAfterScroll() {
    this.fireScrollEvent(0);
  }
  checkScrollLeft() {
    this.scrollLeft !== this.centerRowsCtrl.getCenterViewportScrollLeft() && this.onHScrollCommon(0);
  }
  scrollGridIfNeeded() {
    const e = this.scrollTop != this.nextScrollTop;
    return e && (this.scrollTop = this.nextScrollTop, this.redrawRowsAfterScroll()), e;
  }
  setHorizontalScrollPosition(e, t = !1) {
    const i = this.centerRowsCtrl.getViewportElement().scrollWidth - this.centerRowsCtrl.getCenterWidth();
    !t && this.shouldBlockScrollUpdate(1, e) && (e = this.enableRtl && ti() ? e > 0 ? 0 : i : Math.min(Math.max(e, 0), i)), oi(this.centerRowsCtrl.getViewportElement(), Math.abs(e), this.enableRtl), this.doHorizontalScroll(e);
  }
  setVerticalScrollPosition(e) {
    this.eBodyViewport.scrollTop = e;
  }
  getVScrollPosition() {
    return this.lastScrollTop = this.eBodyViewport.scrollTop, this.lastOffsetHeight = this.eBodyViewport.offsetHeight, { top: this.lastScrollTop, bottom: this.lastScrollTop + this.lastOffsetHeight };
  }
  getApproximateVScollPosition() {
    return this.lastScrollTop >= 0 && this.lastOffsetHeight >= 0 ? { top: this.scrollTop, bottom: this.scrollTop + this.lastOffsetHeight } : this.getVScrollPosition();
  }
  getHScrollPosition() {
    return this.centerRowsCtrl.getHScrollPosition();
  }
  isHorizontalScrollShowing() {
    return this.centerRowsCtrl.isHorizontalScrollShowing();
  }
  scrollHorizontally(e) {
    const t = this.centerRowsCtrl.getViewportElement().scrollLeft;
    return this.setHorizontalScrollPosition(t + e), this.centerRowsCtrl.getViewportElement().scrollLeft - t;
  }
  scrollToTop() {
    this.eBodyViewport.scrollTop = 0;
  }
  ensureNodeVisible(e, t = null) {
    const i = this.rowModel.getRowCount();
    let o = -1;
    for (let s = 0; s < i; s++) {
      const r = this.rowModel.getRow(s);
      if (typeof e == "function") {
        if (r && e(r)) {
          o = s;
          break;
        }
      } else if (e === r || e === r.data) {
        o = s;
        break;
      }
    }
    o >= 0 && this.ensureIndexVisible(o, t);
  }
  ensureIndexVisible(e, t) {
    if (this.gos.isDomLayout("print"))
      return;
    const i = this.rowModel.getRowCount();
    if (typeof e != "number" || e < 0 || e >= i)
      return void b("Invalid row index for ensureIndexVisible: " + e);
    const o = this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel");
    this.getFrameworkOverrides().wrapIncoming(() => {
      var d;
      o || ((d = this.paginationService) == null || d.goToPageWithIndex(e));
      const s = this.ctrlsService.getGridBodyCtrl(), r = s.getStickyTopHeight(), n = s.getStickyBottomHeight(), a = this.rowModel.getRow(e);
      let l;
      do {
        const c = a.rowTop, h = a.rowHeight, g = this.pageBoundsService.getPixelOffset(), u = a.rowTop - g, p = u + a.rowHeight, C = this.getVScrollPosition(), y = this.heightScaler.getDivStretchOffset(), w = C.top + y, x = C.bottom + y, E = x - w, k = this.heightScaler.getScrollPositionForPixel(u), P = this.heightScaler.getScrollPositionForPixel(p - E), D = Math.min((k + P) / 2, u);
        let F = null;
        t === "top" ? F = k : t === "bottom" ? F = P : t === "middle" ? F = D : w + r > u ? F = k - r : x - n < p && (F = P + n), F !== null && (this.setVerticalScrollPosition(F), this.rowRenderer.redraw({ afterScroll: !0 })), l = c !== a.rowTop || h !== a.rowHeight;
      } while (l);
      this.animationFrameService.flushAllFrames();
    });
  }
  ensureColumnVisible(e, t = "auto") {
    const i = this.columnModel.getCol(e);
    if (!i || i.isPinned() || !this.visibleColsService.isColDisplayed(i))
      return;
    const o = this.getPositionedHorizontalScroll(i, t);
    this.getFrameworkOverrides().wrapIncoming(() => {
      o !== null && this.centerRowsCtrl.setCenterViewportScrollLeft(o), this.centerRowsCtrl.onHorizontalViewportChanged(), this.animationFrameService.flushAllFrames();
    });
  }
  setScrollPosition(e, t) {
    this.getFrameworkOverrides().wrapIncoming(() => {
      this.centerRowsCtrl.setCenterViewportScrollLeft(t), this.setVerticalScrollPosition(e), this.rowRenderer.redraw({ afterScroll: !0 }), this.animationFrameService.flushAllFrames();
    });
  }
  getPositionedHorizontalScroll(e, t) {
    const { columnBeforeStart: i, columnAfterEnd: o } = this.isColumnOutsideViewport(e), s = this.centerRowsCtrl.getCenterWidth() < e.getActualWidth(), r = this.centerRowsCtrl.getCenterWidth(), n = this.enableRtl;
    let a = (n ? i : o) || s, l = n ? o : i;
    t !== "auto" && (a = t === "start", l = t === "end");
    const d = t === "middle";
    if (a || l || d) {
      const { colLeft: c, colMiddle: h, colRight: g } = this.getColumnBounds(e);
      return d ? h - r / 2 : a ? n ? g : c : n ? c - r : g - r;
    }
    return null;
  }
  isColumnOutsideViewport(e) {
    const { start: t, end: i } = this.getViewportBounds(), { colLeft: o, colRight: s } = this.getColumnBounds(e), r = this.enableRtl;
    return { columnBeforeStart: r ? t > s : i < s, columnAfterEnd: r ? i < o : t > o };
  }
  getColumnBounds(e) {
    const t = this.enableRtl, i = this.visibleColsService.getBodyContainerWidth(), o = e.getActualWidth(), s = e.getLeft(), r = t ? -1 : 1, n = t ? i - s : s;
    return { colLeft: n, colMiddle: n + o / 2 * r, colRight: n + o * r };
  }
  getViewportBounds() {
    const e = this.centerRowsCtrl.getCenterWidth(), t = this.centerRowsCtrl.getCenterViewportScrollLeft();
    return { start: t, end: e + t, width: e };
  }
}, br = "ag-force-vertical-scroll", Ya = class extends f {
  constructor() {
    super(...arguments), this.stickyTopHeight = 0, this.stickyBottomHeight = 0;
  }
  wireBeans(e) {
    this.animationFrameService = e.animationFrameService, this.rowContainerHeightService = e.rowContainerHeightService, this.ctrlsService = e.ctrlsService, this.columnModel = e.columnModel, this.columnSizeService = e.columnSizeService, this.scrollVisibleService = e.scrollVisibleService, this.menuService = e.menuService, this.headerNavigationService = e.headerNavigationService, this.dragAndDropService = e.dragAndDropService, this.pinnedRowModel = e.pinnedRowModel, this.rowRenderer = e.rowRenderer, this.popupService = e.popupService, this.mouseEventService = e.mouseEventService, this.rowModel = e.rowModel, this.filterManager = e.filterManager, this.environment = e.environment;
  }
  getScrollFeature() {
    return this.bodyScrollFeature;
  }
  getBodyViewportElement() {
    return this.eBodyViewport;
  }
  setComp(e, t, i, o, s, r, n) {
    var a;
    this.comp = e, this.eGridBody = t, this.eBodyViewport = i, this.eTop = o, this.eBottom = s, this.eStickyTop = r, this.eStickyBottom = n, this.setCellTextSelection(this.gos.get("enableCellTextSelection")), this.addManagedPropertyListener("enableCellTextSelection", (l) => this.setCellTextSelection(l.currentValue)), this.createManagedBean(new So(this.comp)), this.bodyScrollFeature = this.createManagedBean(new Qa(this.eBodyViewport)), this.addRowDragListener(), this.setupRowAnimationCssClass(), this.addEventListeners(), this.addFocusListeners([o, i, s, r, n]), this.onGridColumnsChanged(), this.addBodyViewportListener(), this.setFloatingHeights(), this.disableBrowserDragging(), this.addStopEditingWhenGridLosesFocus(), (a = this.filterManager) == null || a.setupAdvancedFilterHeaderComp(o), this.ctrlsService.register("gridBodyCtrl", this);
  }
  getComp() {
    return this.comp;
  }
  addEventListeners() {
    this.addManagedEventListeners({ gridColumnsChanged: this.onGridColumnsChanged.bind(this), scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this), pinnedRowDataChanged: this.setFloatingHeights.bind(this), pinnedHeightChanged: this.setFloatingHeights.bind(this), headerHeightChanged: this.onHeaderHeightChanged.bind(this) });
  }
  addFocusListeners(e) {
    e.forEach((t) => {
      this.addManagedElementListeners(t, { focusin: (i) => {
        const { target: o } = i, s = rt(o, "ag-root", t);
        t.classList.toggle("ag-has-focus", !s);
      }, focusout: (i) => {
        const { target: o, relatedTarget: s } = i, r = t.contains(s), n = rt(s, "ag-root", t);
        rt(o, "ag-root", t) || r && !n || t.classList.remove("ag-has-focus");
      } });
    });
  }
  setColumnMovingCss(e) {
    this.comp.setColumnMovingCss("ag-column-moving", e);
  }
  setCellTextSelection(e = !1) {
    this.comp.setCellSelectableCss("ag-selectable", e);
  }
  onScrollVisibilityChanged() {
    const e = this.scrollVisibleService.isVerticalScrollShowing();
    this.setVerticalScrollPaddingVisible(e), this.setStickyWidth(e), this.setStickyBottomOffsetBottom();
    const t = `calc(100% + ${(e && this.gos.getScrollbarWidth() || 0) + (Ps() ? 16 : 0)}px)`;
    this.animationFrameService.requestAnimationFrame(() => this.comp.setBodyViewportWidth(t));
  }
  onGridColumnsChanged() {
    const e = this.columnModel.getCols();
    this.comp.setColumnCount(e.length);
  }
  disableBrowserDragging() {
    this.addManagedElementListeners(this.eGridBody, { dragstart: (e) => {
      if (e.target instanceof HTMLImageElement)
        return e.preventDefault(), !1;
    } });
  }
  addStopEditingWhenGridLosesFocus() {
    if (!this.gos.get("stopEditingWhenCellsLoseFocus"))
      return;
    const e = (i) => {
      const o = i.relatedTarget;
      if (Oi(o) === null)
        return void this.rowRenderer.stopEditing();
      let s = t.some((r) => r.contains(o)) && this.mouseEventService.isElementInThisGrid(o);
      if (!s) {
        const r = this.popupService;
        s = r.getActivePopups().some((n) => n.contains(o)) || r.isElementWithinCustomPopup(o);
      }
      s || this.rowRenderer.stopEditing();
    }, t = [this.eBodyViewport, this.eBottom, this.eTop, this.eStickyTop, this.eStickyBottom];
    t.forEach((i) => this.addManagedElementListeners(i, { focusout: e }));
  }
  updateRowCount() {
    var o;
    const e = this.headerNavigationService.getHeaderRowCount() + (((o = this.filterManager) == null ? void 0 : o.getHeaderRowCount()) ?? 0), t = this.rowModel.isLastRowIndexKnown() ? this.rowModel.getRowCount() : -1, i = t === -1 ? -1 : e + t;
    this.comp.setRowCount(i);
  }
  registerBodyViewportResizeListener(e) {
    this.comp.registerBodyViewportResizeListener(e);
  }
  setVerticalScrollPaddingVisible(e) {
    const t = e ? "scroll" : "hidden";
    this.comp.setPinnedTopBottomOverflowY(t);
  }
  isVerticalScrollShowing() {
    const e = this.gos.get("alwaysShowVerticalScroll"), t = e ? br : null, i = this.gos.isDomLayout("normal");
    return this.comp.setAlwaysVerticalScrollClass(t, e), e || i && (o = this.eBodyViewport).clientHeight < o.scrollHeight;
    var o;
  }
  setupRowAnimationCssClass() {
    let e = this.environment.hasMeasuredSizes();
    const t = () => {
      const i = e && this.gos.isAnimateRows() && !this.rowContainerHeightService.isStretching(), o = i ? "ag-row-animation" : "ag-row-no-animation";
      this.comp.setRowAnimationCssOnBodyViewport(o, i);
    };
    t(), this.addManagedEventListeners({ heightScaleChanged: t }), this.addManagedPropertyListener("animateRows", t), this.addManagedEventListeners({ gridStylesChanged: () => {
      !e && this.environment.hasMeasuredSizes() && (e = !0, t());
    } });
  }
  getGridBodyElement() {
    return this.eGridBody;
  }
  addBodyViewportListener() {
    const e = this.onBodyViewportContextMenu.bind(this);
    this.addManagedElementListeners(this.eBodyViewport, { contextmenu: e }), this.mockContextMenuForIPad(e), this.addManagedElementListeners(this.eBodyViewport, { wheel: this.onBodyViewportWheel.bind(this) }), this.addManagedElementListeners(this.eStickyTop, { wheel: this.onStickyWheel.bind(this) }), this.addManagedElementListeners(this.eStickyBottom, { wheel: this.onStickyWheel.bind(this) }), this.addFullWidthContainerWheelListener();
  }
  addFullWidthContainerWheelListener() {
    const e = this.eBodyViewport.querySelector(".ag-full-width-container"), t = this.eBodyViewport.querySelector(".ag-center-cols-viewport");
    e && t && this.addManagedElementListeners(e, { wheel: (i) => this.onFullWidthContainerWheel(i, t) });
  }
  onFullWidthContainerWheel(e, t) {
    !e.deltaX || Math.abs(e.deltaY) > Math.abs(e.deltaX) || !this.mouseEventService.isEventFromThisGrid(e) || (e.preventDefault(), t.scrollBy({ left: e.deltaX }));
  }
  onBodyViewportContextMenu(e, t, i) {
    if (!e && !i)
      return;
    this.gos.get("preventDefaultOnContextMenu") && (e || i).preventDefault();
    const { target: o } = e || t;
    o !== this.eBodyViewport && o !== this.ctrlsService.get("center").getViewportElement() || this.menuService.showContextMenu({ mouseEvent: e, touchEvent: i, value: null, anchorToElement: this.eGridBody });
  }
  mockContextMenuForIPad(e) {
    if (!Oe())
      return;
    const t = new Te(this.eBodyViewport);
    this.addManagedListeners(t, { longTap: (i) => {
      e(void 0, i.touchStart, i.touchEvent);
    } }), this.addDestroyFunc(() => t.destroy());
  }
  onBodyViewportWheel(e) {
    this.gos.get("suppressScrollWhenPopupsAreOpen") && this.popupService.hasAnchoredPopup() && e.preventDefault();
  }
  onStickyWheel(e) {
    e.preventDefault(), e.offsetY && this.scrollVertically(e.deltaY);
  }
  getGui() {
    return this.eGridBody;
  }
  scrollVertically(e) {
    const t = this.eBodyViewport.scrollTop;
    return this.bodyScrollFeature.setVerticalScrollPosition(t + e), this.eBodyViewport.scrollTop - t;
  }
  addRowDragListener() {
    this.rowDragFeature = this.createManagedBean(new oa(this.eBodyViewport)), this.dragAndDropService.addDropTarget(this.rowDragFeature);
  }
  getRowDragFeature() {
    return this.rowDragFeature;
  }
  setFloatingHeights() {
    const { pinnedRowModel: e } = this, t = e.getPinnedTopTotalHeight(), i = e.getPinnedBottomTotalHeight();
    this.comp.setTopHeight(t), this.comp.setBottomHeight(i), this.comp.setTopDisplay(t ? "inherit" : "none"), this.comp.setBottomDisplay(i ? "inherit" : "none"), this.setStickyTopOffsetTop(), this.setStickyBottomOffsetBottom();
  }
  setStickyTopHeight(e = 0) {
    this.comp.setStickyTopHeight(`${e}px`), this.stickyTopHeight = e;
  }
  getStickyTopHeight() {
    return this.stickyTopHeight;
  }
  setStickyBottomHeight(e = 0) {
    this.comp.setStickyBottomHeight(`${e}px`), this.stickyBottomHeight = e;
  }
  getStickyBottomHeight() {
    return this.stickyBottomHeight;
  }
  setStickyWidth(e) {
    if (e) {
      const t = this.gos.getScrollbarWidth();
      this.comp.setStickyTopWidth(`calc(100% - ${t}px)`), this.comp.setStickyBottomWidth(`calc(100% - ${t}px)`);
    } else
      this.comp.setStickyTopWidth("100%"), this.comp.setStickyBottomWidth("100%");
  }
  onHeaderHeightChanged() {
    this.setStickyTopOffsetTop();
  }
  setStickyTopOffsetTop() {
    var o;
    const e = this.ctrlsService.get("gridHeaderCtrl").getHeaderHeight() + (((o = this.filterManager) == null ? void 0 : o.getHeaderHeight()) ?? 0), t = this.pinnedRowModel.getPinnedTopTotalHeight();
    let i = 0;
    e > 0 && (i += e), t > 0 && (i += t), i > 0 && (i += 1), this.comp.setStickyTopTop(`${i}px`);
  }
  setStickyBottomOffsetBottom() {
    const e = this.pinnedRowModel.getPinnedBottomTotalHeight() + (this.scrollVisibleService.isHorizontalScrollShowing() && this.gos.getScrollbarWidth() || 0);
    this.comp.setStickyBottomBottom(`${e}px`);
  }
  sizeColumnsToFit(e, t) {
    const i = this.isVerticalScrollShowing() ? this.gos.getScrollbarWidth() : 0, o = Pt(this.eGridBody) - i;
    o > 0 ? this.columnSizeService.sizeColumnsToFit(o, "sizeColumnsToFit", !1, e) : t === void 0 ? window.setTimeout(() => {
      this.sizeColumnsToFit(e, 100);
    }, 0) : t === 100 ? window.setTimeout(() => {
      this.sizeColumnsToFit(e, 500);
    }, 100) : t === 500 ? window.setTimeout(() => {
      this.sizeColumnsToFit(e, -1);
    }, 500) : b("tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?");
  }
  addScrollEventListener(e) {
    this.eBodyViewport.addEventListener("scroll", e, { passive: !0 });
  }
  removeScrollEventListener(e) {
    this.eBodyViewport.removeEventListener("scroll", e);
  }
}, qa = class extends O {
  constructor(e, t, i, o, s) {
    super(), this.rendererVersion = 0, this.editorVersion = 0, this.beans = e, this.column = t.getColumn(), this.rowNode = t.getRowNode(), this.rowCtrl = t.getRowCtrl(), this.eRow = o, this.cellCtrl = t;
    const r = document.createElement("div");
    r.setAttribute("comp-id", `${this.getCompId()}`), this.setTemplateFromElement(r);
    const n = this.getGui();
    this.forceWrapper = t.isForceWrapper(), this.refreshWrapper(!1);
    const a = (c, h) => {
      h != null && h != "" ? n.setAttribute(c, h) : n.removeAttribute(c);
    };
    X(n, t.getCellAriaRole()), a("col-id", t.getColumnIdSanitised());
    const l = t.getTabIndex();
    l !== void 0 && a("tabindex", l.toString());
    const d = { addOrRemoveCssClass: (c, h) => this.addOrRemoveCssClass(c, h), setUserStyles: (c) => Ns(n, c), getFocusableElement: () => this.getFocusableElement(), setIncludeSelection: (c) => this.includeSelection = c, setIncludeRowDrag: (c) => this.includeRowDrag = c, setIncludeDndSource: (c) => this.includeDndSource = c, setRenderDetails: (c, h, g) => this.setRenderDetails(c, h, g), setEditDetails: (c, h, g) => this.setEditDetails(c, h, g), getCellEditor: () => this.cellEditor || null, getCellRenderer: () => this.cellRenderer || null, getParentOfValue: () => this.getParentOfValue() };
    t.setComp(d, this.getGui(), this.eCellWrapper, i, s);
  }
  getParentOfValue() {
    return this.eCellValue ? this.eCellValue : this.eCellWrapper ? this.eCellWrapper : this.getGui();
  }
  setRenderDetails(e, t, i) {
    if (this.cellEditor && !this.cellEditorPopupWrapper)
      return;
    this.firstRender = this.firstRender == null;
    const o = this.refreshWrapper(!1);
    this.refreshEditStyles(!1), e ? !i && !o && this.refreshCellRenderer(e) || (this.destroyRenderer(), this.createCellRendererInstance(e)) : (this.destroyRenderer(), this.insertValueWithoutCellRenderer(t));
  }
  setEditDetails(e, t, i) {
    e ? this.createCellEditorInstance(e, t, i) : this.destroyEditor();
  }
  removeControls() {
    this.checkboxSelectionComp = this.beans.context.destroyBean(this.checkboxSelectionComp), this.dndSourceComp = this.beans.context.destroyBean(this.dndSourceComp), this.rowDraggingComp = this.beans.context.destroyBean(this.rowDraggingComp);
  }
  refreshWrapper(e) {
    const t = this.includeRowDrag || this.includeDndSource || this.includeSelection, i = t || this.forceWrapper, o = i && this.eCellWrapper == null;
    if (o) {
      const d = document.createElement("div");
      d.setAttribute("role", "presentation"), d.setAttribute("class", "ag-cell-wrapper"), this.eCellWrapper = d, this.getGui().appendChild(this.eCellWrapper);
    }
    const s = !i && this.eCellWrapper != null;
    s && (ve(this.eCellWrapper), this.eCellWrapper = void 0), this.addOrRemoveCssClass("ag-cell-value", !i);
    const r = !e && i, n = r && this.eCellValue == null;
    if (n) {
      const d = document.createElement("span");
      d.setAttribute("role", "presentation"), d.setAttribute("class", "ag-cell-value"), this.eCellValue = d, this.eCellWrapper.appendChild(this.eCellValue);
    }
    const a = !r && this.eCellValue != null;
    a && (ve(this.eCellValue), this.eCellValue = void 0);
    const l = o || s || n || a;
    return l && this.removeControls(), e || t && this.addControls(), l;
  }
  addControls() {
    this.includeRowDrag && this.rowDraggingComp == null && (this.rowDraggingComp = this.cellCtrl.createRowDragComp(), this.rowDraggingComp && this.eCellWrapper.insertBefore(this.rowDraggingComp.getGui(), this.eCellValue)), this.includeDndSource && this.dndSourceComp == null && (this.dndSourceComp = this.cellCtrl.createDndSource(), this.eCellWrapper.insertBefore(this.dndSourceComp.getGui(), this.eCellValue)), this.includeSelection && this.checkboxSelectionComp == null && (this.checkboxSelectionComp = this.cellCtrl.createSelectionCheckbox(), this.eCellWrapper.insertBefore(this.checkboxSelectionComp.getGui(), this.eCellValue));
  }
  createCellEditorInstance(e, t, i) {
    const o = this.editorVersion, s = e.newAgStackInstance();
    if (s == null)
      return;
    const { params: r } = e;
    s.then((n) => this.afterCellEditorCreated(o, n, r, t, i)), A(this.cellEditor) && r.cellStartedEdit && this.cellCtrl.focusCell(!0);
  }
  insertValueWithoutCellRenderer(e) {
    const t = this.getParentOfValue();
    j(t);
    const i = e != null ? fe(e, !0) : null;
    i != null && (t.textContent = i);
  }
  destroyEditorAndRenderer() {
    this.destroyRenderer(), this.destroyEditor();
  }
  destroyRenderer() {
    const { context: e } = this.beans;
    this.cellRenderer = e.destroyBean(this.cellRenderer), ve(this.cellRendererGui), this.cellRendererGui = null, this.rendererVersion++;
  }
  destroyEditor() {
    const { context: e } = this.beans;
    this.hideEditorPopup && this.hideEditorPopup(), this.hideEditorPopup = void 0, this.cellEditor = e.destroyBean(this.cellEditor), this.cellEditorPopupWrapper = e.destroyBean(this.cellEditorPopupWrapper), ve(this.cellEditorGui), this.cellEditorGui = null, this.editorVersion++;
  }
  refreshCellRenderer(e) {
    if (this.cellRenderer == null || this.cellRenderer.refresh == null || this.cellRendererClass !== e.componentClass)
      return !1;
    const t = this.cellRenderer.refresh(e.params);
    return t === !0 || t === void 0;
  }
  createCellRendererInstance(e) {
    const t = !this.beans.gos.get("suppressAnimationFrame"), i = this.rendererVersion, { componentClass: o } = e, s = () => {
      if (this.rendererVersion !== i || !this.isAlive())
        return;
      const r = e.newAgStackInstance(), n = this.afterCellRendererCreated.bind(this, i, o);
      r && r.then(n);
    };
    t && this.firstRender ? this.beans.animationFrameService.createTask(s, this.rowNode.rowIndex, "createTasksP2") : s();
  }
  getCtrl() {
    return this.cellCtrl;
  }
  getRowCtrl() {
    return this.rowCtrl;
  }
  getCellRenderer() {
    return this.cellRenderer;
  }
  getCellEditor() {
    return this.cellEditor;
  }
  afterCellRendererCreated(e, t, i) {
    if (this.isAlive() && e === this.rendererVersion) {
      if (this.cellRenderer = i, this.cellRendererClass = t, this.cellRendererGui = this.cellRenderer.getGui(), this.cellRendererGui != null) {
        const o = this.getParentOfValue();
        j(o), o.appendChild(this.cellRendererGui);
      }
    } else
      this.beans.context.destroyBean(i);
  }
  afterCellEditorCreated(e, t, i, o, s) {
    if (e !== this.editorVersion)
      return void this.beans.context.destroyBean(t);
    if (t.isCancelBeforeStart && t.isCancelBeforeStart())
      return this.beans.context.destroyBean(t), void this.cellCtrl.stopEditing(!0);
    if (!t.getGui)
      return b(`cellEditor for column ${this.column.getId()} is missing getGui() method`), void this.beans.context.destroyBean(t);
    this.cellEditor = t, this.cellEditorGui = t.getGui();
    const r = o || t.isPopup !== void 0 && t.isPopup();
    r ? this.addPopupCellEditor(i, s) : this.addInCellEditor(), this.refreshEditStyles(!0, r), t.afterGuiAttached && t.afterGuiAttached();
  }
  refreshEditStyles(e, t) {
    var i;
    this.addOrRemoveCssClass("ag-cell-inline-editing", e && !t), this.addOrRemoveCssClass("ag-cell-popup-editing", e && !!t), this.addOrRemoveCssClass("ag-cell-not-inline-editing", !e || !!t), (i = this.rowCtrl) == null || i.setInlineEditingCss(e);
  }
  addInCellEditor() {
    const e = this.getGui();
    e.contains(this.beans.gos.getActiveDomElement()) && e.focus(), this.destroyRenderer(), this.refreshWrapper(!0), this.clearParentOfValue(), this.cellEditorGui && this.getParentOfValue().appendChild(this.cellEditorGui);
  }
  addPopupCellEditor(e, t) {
    this.beans.gos.get("editType") === "fullRow" && b("popup cellEditor does not work with fullRowEdit - you cannot use them both - either turn off fullRowEdit, or stop using popup editors.");
    const i = this.cellEditor;
    this.cellEditorPopupWrapper = this.beans.context.createBean(this.beans.editService.createPopupEditorWrapper(e));
    const o = this.cellEditorPopupWrapper.getGui();
    this.cellEditorGui && o.appendChild(this.cellEditorGui);
    const s = this.beans.popupService, r = this.beans.gos.get("stopEditingWhenCellsLoseFocus"), n = t ?? (i.getPopupPosition ? i.getPopupPosition() : "over"), a = this.beans.gos.get("enableRtl"), l = { ePopup: o, column: this.column, rowNode: this.rowNode, type: "popupCellEditor", eventSource: this.getGui(), position: n, alignSide: a ? "right" : "left", keepWithinBounds: !0 }, d = s.positionPopupByComponent.bind(s, l), c = this.beans.localeService.getLocaleTextFunc(), h = s.addPopup({ modal: r, eChild: o, closeOnEsc: !0, closedCallback: () => {
      this.cellCtrl.onPopupEditorClosed();
    }, anchorToElement: this.getGui(), positionCallback: d, ariaLabel: c("ariaLabelCellEditor", "Cell Editor") });
    h && (this.hideEditorPopup = h.hideFunc);
  }
  detach() {
    this.eRow.removeChild(this.getGui());
  }
  destroy() {
    this.cellCtrl.stopEditing(), this.destroyEditorAndRenderer(), this.removeControls(), super.destroy();
  }
  clearParentOfValue() {
    const e = this.getGui();
    e.contains(this.beans.gos.getActiveDomElement()) && Li() && e.focus({ preventScroll: !0 }), j(this.getParentOfValue());
  }
}, $a = class extends O {
  constructor(e, t, i) {
    super(), this.cellComps = {}, this.beans = t, this.rowCtrl = e;
    const o = document.createElement("div");
    o.setAttribute("comp-id", `${this.getCompId()}`), o.setAttribute("style", this.getInitialStyle(i)), this.setTemplateFromElement(o);
    const s = this.getGui(), r = s.style;
    this.domOrder = this.rowCtrl.getDomOrder(), X(s, "row");
    const n = this.rowCtrl.getTabIndex();
    n != null && s.setAttribute("tabindex", n.toString());
    const a = { setDomOrder: (l) => this.domOrder = l, setCellCtrls: (l) => this.setCellCtrls(l), showFullWidth: (l) => this.showFullWidth(l), getFullWidthCellRenderer: () => this.getFullWidthCellRenderer(), addOrRemoveCssClass: (l, d) => this.addOrRemoveCssClass(l, d), setUserStyles: (l) => Ns(s, l), setTop: (l) => r.top = l, setTransform: (l) => r.transform = l, setRowIndex: (l) => s.setAttribute("row-index", l), setRowId: (l) => s.setAttribute("row-id", l), setRowBusinessKey: (l) => s.setAttribute("row-business-key", l), refreshFullWidth: (l) => this.refreshFullWidth(l) };
    e.setComp(a, this.getGui(), i), this.addDestroyFunc(() => {
      e.unsetComp(i);
    });
  }
  getInitialStyle(e) {
    const t = this.rowCtrl.getInitialTransform(e);
    return t ? `transform: ${t}` : `top: ${this.rowCtrl.getInitialRowTop(e)}`;
  }
  showFullWidth(e) {
    const t = e.newAgStackInstance();
    t && t.then((i) => {
      if (this.isAlive()) {
        const o = i.getGui();
        this.getGui().appendChild(o), this.rowCtrl.setupDetailRowAutoHeight(o), this.setFullWidthRowComp(i);
      } else
        this.beans.context.destroyBean(i);
    });
  }
  setCellCtrls(e) {
    const t = Object.assign({}, this.cellComps);
    e.forEach((o) => {
      const s = o.getInstanceId();
      this.cellComps[s] == null ? this.newCellComp(o) : t[s] = null;
    });
    const i = Ie(t).filter((o) => o != null);
    this.destroyCells(i), this.ensureDomOrder(e);
  }
  ensureDomOrder(e) {
    if (!this.domOrder)
      return;
    const t = [];
    e.forEach((i) => {
      const o = this.cellComps[i.getInstanceId()];
      o && t.push(o.getGui());
    }), Os(this.getGui(), t);
  }
  newCellComp(e) {
    const t = new qa(this.beans, e, this.rowCtrl.isPrintLayout(), this.getGui(), this.rowCtrl.isEditing());
    this.cellComps[e.getInstanceId()] = t, this.getGui().appendChild(t.getGui());
  }
  destroy() {
    super.destroy(), this.destroyAllCells();
  }
  destroyAllCells() {
    const e = Ie(this.cellComps).filter((t) => t != null);
    this.destroyCells(e);
  }
  setFullWidthRowComp(e) {
    this.fullWidthCellRenderer && L("should not be setting fullWidthRowComponent twice"), this.fullWidthCellRenderer = e, this.addDestroyFunc(() => {
      this.fullWidthCellRenderer = this.beans.context.destroyBean(this.fullWidthCellRenderer);
    });
  }
  getFullWidthCellRenderer() {
    return this.fullWidthCellRenderer;
  }
  destroyCells(e) {
    e.forEach((t) => {
      if (!t)
        return;
      const i = t.getCtrl().getInstanceId();
      this.cellComps[i] === t && (t.detach(), t.destroy(), this.cellComps[i] = null);
    });
  }
  refreshFullWidth(e) {
    const { fullWidthCellRenderer: t } = this;
    if (!t || !t.refresh)
      return !1;
    const i = e();
    return t.refresh(i);
  }
}, Ja = class extends f {
  wireBeans(e) {
    this.ctrlsService = e.ctrlsService, this.pinnedWidthService = e.pinnedWidthService, this.columnModel = e.columnModel, this.visibleColsService = e.visibleColsService, this.columnSizeService = e.columnSizeService, this.scrollVisibleService = e.scrollVisibleService, this.columnViewportService = e.columnViewportService;
  }
  constructor(e) {
    super(), this.centerContainerCtrl = e;
  }
  postConstruct() {
    this.ctrlsService.whenReady((e) => {
      this.gridBodyCtrl = e.gridBodyCtrl, this.listenForResize();
    }), this.addManagedEventListeners({ scrollbarWidthChanged: this.onScrollbarWidthChanged.bind(this) }), this.addManagedPropertyListeners(["alwaysShowHorizontalScroll", "alwaysShowVerticalScroll"], () => {
      this.checkViewportAndScrolls();
    });
  }
  listenForResize() {
    const e = () => this.onCenterViewportResized();
    this.centerContainerCtrl.registerViewportResizeListener(e), this.gridBodyCtrl.registerBodyViewportResizeListener(e);
  }
  onScrollbarWidthChanged() {
    this.checkViewportAndScrolls();
  }
  onCenterViewportResized() {
    if (this.centerContainerCtrl.isViewportInTheDOMTree()) {
      this.keepPinnedColumnsNarrowerThanViewport(), this.checkViewportAndScrolls();
      const e = this.centerContainerCtrl.getCenterWidth();
      e !== this.centerWidth && (this.centerWidth = e, this.columnSizeService.refreshFlexedColumns({ viewportWidth: this.centerWidth, updateBodyWidths: !0, fireResizedEvent: !0 }));
    } else
      this.bodyHeight = 0;
  }
  keepPinnedColumnsNarrowerThanViewport() {
    const e = Pt(this.gridBodyCtrl.getBodyViewportElement());
    if (e <= 50)
      return;
    let t = this.getPinnedColumnsOverflowingViewport(e - 50);
    const i = this.gos.getCallback("processUnpinnedColumns");
    t.length && (i && (t = i({ columns: t, viewportWidth: e })), this.columnModel.setColsPinned(t, null, "viewportSizeFeature"));
  }
  getPinnedColumnsOverflowingViewport(e) {
    const t = this.pinnedWidthService.getPinnedRightWidth() + this.pinnedWidthService.getPinnedLeftWidth();
    if (t < e)
      return [];
    const i = [...this.visibleColsService.getLeftCols()], o = [...this.visibleColsService.getRightCols()];
    let s = 0, r = 0;
    const n = [];
    let a = t - 0 - e;
    for (; (r < i.length || s < o.length) && a > 0; ) {
      if (s < o.length) {
        const l = o[s++];
        a -= l.getActualWidth(), n.push(l);
      }
      if (r < i.length && a > 0) {
        const l = i[r++];
        a -= l.getActualWidth(), n.push(l);
      }
    }
    return n;
  }
  checkViewportAndScrolls() {
    this.updateScrollVisibleService(), this.checkBodyHeight(), this.onHorizontalViewportChanged(), this.gridBodyCtrl.getScrollFeature().checkScrollLeft();
  }
  getBodyHeight() {
    return this.bodyHeight;
  }
  checkBodyHeight() {
    const e = oo(this.gridBodyCtrl.getBodyViewportElement());
    if (this.bodyHeight !== e) {
      this.bodyHeight = e;
      const t = { type: "bodyHeightChanged" };
      this.eventService.dispatchEvent(t);
    }
  }
  updateScrollVisibleService() {
    this.updateScrollVisibleServiceImpl(), setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
  }
  updateScrollVisibleServiceImpl() {
    const e = { horizontalScrollShowing: this.isHorizontalScrollShowing(), verticalScrollShowing: this.gridBodyCtrl.isVerticalScrollShowing() };
    this.scrollVisibleService.setScrollsVisible(e);
  }
  isHorizontalScrollShowing() {
    return this.centerContainerCtrl.isHorizontalScrollShowing();
  }
  onHorizontalViewportChanged() {
    const e = this.centerContainerCtrl.getCenterWidth(), t = this.centerContainerCtrl.getViewportScrollLeft();
    this.columnViewportService.setScrollPosition(e, t);
  }
}, Xa = class extends f {
  wireBeans(e) {
    this.dragService = e.dragService, this.rangeService = e.rangeService;
  }
  constructor(e) {
    super(), this.eContainer = e;
  }
  postConstruct() {
    this.rangeService && (this.params = { eElement: this.eContainer, onDragStart: this.rangeService.onDragStart.bind(this.rangeService), onDragStop: this.rangeService.onDragStop.bind(this.rangeService), onDragging: this.rangeService.onDragging.bind(this.rangeService) }, this.addManagedPropertyListener("enableRangeSelection", (e) => {
      e.currentValue ? this.enableFeature() : this.disableFeature();
    }), this.addDestroyFunc(() => this.disableFeature()), this.gos.get("enableRangeSelection") && this.enableFeature());
  }
  enableFeature() {
    this.dragService.addDragSource(this.params);
  }
  disableFeature() {
    this.dragService.removeDragSource(this.params);
  }
}, Za = class extends O {
  constructor() {
    super(`
            <div class="ag-selection-checkbox" role="presentation">
                <ag-checkbox role="presentation" data-ref="eCheckbox"></ag-checkbox>
            </div>`, [lo]), this.eCheckbox = R;
  }
  postConstruct() {
    this.eCheckbox.setPassive(!0);
  }
  getCheckboxId() {
    return this.eCheckbox.getInputElement().id;
  }
  onDataChanged() {
    this.onSelectionChanged();
  }
  onSelectableChanged() {
    this.showOrHideSelect();
  }
  onSelectionChanged() {
    const e = this.localeService.getLocaleTextFunc(), t = this.rowNode.isSelected(), i = eo(e, t), [o, s] = this.rowNode.selectable ? ["ariaRowToggleSelection", "Press Space to toggle row selection"] : ["ariaRowSelectionDisabled", "Row Selection is disabled for this row"], r = e(o, s);
    this.eCheckbox.setValue(t, !0), this.eCheckbox.setInputAriaLabel(`${r} (${i})`);
  }
  onClicked(e, t, i) {
    return this.rowNode.setSelectedParams({ newValue: e, rangeSelect: i.shiftKey, groupSelectsFiltered: t, event: i, source: "checkboxSelected" });
  }
  init(e) {
    if (this.rowNode = e.rowNode, this.column = e.column, this.overrides = e.overrides, this.onSelectionChanged(), this.addManagedListeners(this.eCheckbox.getInputElement(), { dblclick: (t) => at(t), click: (t) => {
      at(t);
      const i = this.gos.get("groupSelectsFiltered"), o = this.eCheckbox.getValue();
      this.shouldHandleIndeterminateState(o, i) ? this.onClicked(!0, i, t || {}) === 0 && this.onClicked(!1, i, t) : o ? this.onClicked(!1, i, t) : this.onClicked(!0, i, t || {});
    } }), this.addManagedListeners(this.rowNode, { rowSelected: this.onSelectionChanged.bind(this), dataChanged: this.onDataChanged.bind(this), selectableChanged: this.onSelectableChanged.bind(this) }), this.gos.get("isRowSelectable") || typeof this.getIsVisible() == "function") {
      const t = this.showOrHideSelect.bind(this);
      this.addManagedEventListeners({ displayedColumnsChanged: t }), this.addManagedListeners(this.rowNode, { dataChanged: t, cellChanged: t }), this.showOrHideSelect();
    }
    this.eCheckbox.getInputElement().setAttribute("tabindex", "-1");
  }
  shouldHandleIndeterminateState(e, t) {
    return t && (this.eCheckbox.getPreviousValue() === void 0 || e === void 0) && this.gos.isRowModelType("clientSide");
  }
  showOrHideSelect() {
    var o, s, r;
    let e = this.rowNode.selectable;
    const t = this.getIsVisible();
    if (e)
      if (typeof t == "function") {
        const n = (o = this.overrides) == null ? void 0 : o.callbackParams;
        if (this.column) {
          const a = this.column.createColumnFunctionCallbackParams(this.rowNode);
          e = t({ ...n, ...a });
        } else
          e = t({ ...n, node: this.rowNode, data: this.rowNode.data });
      } else
        e = t ?? !1;
    if ((s = this.column) == null ? void 0 : s.getColDef().showDisabledCheckboxes)
      return this.eCheckbox.setDisabled(!e), this.setVisible(!0), void this.setDisplayed(!0);
    (r = this.overrides) != null && r.removeHidden ? this.setDisplayed(e) : this.setVisible(e);
  }
  getIsVisible() {
    var e, t;
    return this.overrides ? this.overrides.isVisible : (t = (e = this.column) == null ? void 0 : e.getColDef()) == null ? void 0 : t.checkboxSelection;
  }
}, _a = class extends O {
  constructor(e, t, i) {
    super('<div class="ag-drag-handle ag-row-drag" draggable="true"></div>'), this.rowNode = e, this.column = t, this.eCell = i;
  }
  postConstruct() {
    this.getGui().appendChild(te("rowDrag", this.gos, null)), this.addGuiEventListener("mousedown", (e) => {
      e.stopPropagation();
    }), this.addDragSource(), this.checkVisibility();
  }
  addDragSource() {
    this.addGuiEventListener("dragstart", this.onDragStart.bind(this));
  }
  onDragStart(e) {
    const t = this.column.getColDef().dndSourceOnRowDrag;
    e.dataTransfer.setDragImage(this.eCell, 0, 0), t ? t(this.gos.addGridCommonParams({ rowNode: this.rowNode, dragEvent: e })) : (() => {
      try {
        const i = JSON.stringify(this.rowNode.data);
        e.dataTransfer.setData("application/json", i), e.dataTransfer.setData("text/plain", i);
      } catch {
      }
    })();
  }
  checkVisibility() {
    const e = this.column.isDndSource(this.rowNode);
    this.setDisplayed(e);
  }
}, el = class extends f {
  constructor(e, t) {
    super(), this.staticClasses = [], this.cellCtrl = e, this.beans = t, this.column = e.getColumn(), this.rowNode = e.getRowNode();
  }
  setComp(e) {
    this.cellComp = e, this.applyUserStyles(), this.applyCellClassRules(), this.applyClassesFromColDef();
  }
  applyCellClassRules() {
    const e = this.column.getColDef(), { cellClassRules: t } = e, i = this.beans.gos.addGridCommonParams({ value: this.cellCtrl.getValue(), data: this.rowNode.data, node: this.rowNode, colDef: e, column: this.column, rowIndex: this.rowNode.rowIndex });
    this.beans.stylingService.processClassRules(t === this.cellClassRules ? void 0 : this.cellClassRules, t, i, (o) => this.cellComp.addOrRemoveCssClass(o, !0), (o) => this.cellComp.addOrRemoveCssClass(o, !1)), this.cellClassRules = t;
  }
  applyUserStyles() {
    const e = this.column.getColDef();
    if (!e.cellStyle)
      return;
    let t;
    if (typeof e.cellStyle == "function") {
      const i = this.beans.gos.addGridCommonParams({ column: this.column, value: this.cellCtrl.getValue(), colDef: e, data: this.rowNode.data, node: this.rowNode, rowIndex: this.rowNode.rowIndex });
      t = (0, e.cellStyle)(i);
    } else
      t = e.cellStyle;
    t && this.cellComp.setUserStyles(t);
  }
  applyClassesFromColDef() {
    const e = this.column.getColDef(), t = this.beans.gos.addGridCommonParams({ value: this.cellCtrl.getValue(), data: this.rowNode.data, node: this.rowNode, column: this.column, colDef: e, rowIndex: this.rowNode.rowIndex });
    this.staticClasses.length && this.staticClasses.forEach((i) => this.cellComp.addOrRemoveCssClass(i, !1)), this.staticClasses = this.beans.stylingService.getStaticCellClasses(e, t), this.staticClasses.length && this.staticClasses.forEach((i) => this.cellComp.addOrRemoveCssClass(i, !0));
  }
  destroy() {
    super.destroy();
  }
}, tl = class extends f {
  constructor(e, t, i, o, s) {
    super(), this.cellCtrl = e, this.beans = t, this.rowNode = o, this.rowCtrl = s;
  }
  setComp(e) {
    this.eGui = e;
  }
  onKeyDown(e) {
    const t = e.key;
    switch (t) {
      case v.ENTER:
        this.onEnterKeyDown(e);
        break;
      case v.F2:
        this.onF2KeyDown(e);
        break;
      case v.ESCAPE:
        this.onEscapeKeyDown(e);
        break;
      case v.TAB:
        this.onTabKeyDown(e);
        break;
      case v.BACKSPACE:
      case v.DELETE:
        this.onBackspaceOrDeleteKeyDown(t, e);
        break;
      case v.DOWN:
      case v.UP:
      case v.RIGHT:
      case v.LEFT:
        this.onNavigationKeyDown(e, t);
    }
  }
  onNavigationKeyDown(e, t) {
    this.cellCtrl.isEditing() || (e.shiftKey && this.cellCtrl.isRangeSelectionEnabled() ? this.onShiftRangeSelect(e) : this.beans.navigationService.navigateToNextCell(e, t, this.cellCtrl.getCellPosition(), !0), e.preventDefault());
  }
  onShiftRangeSelect(e) {
    if (!this.beans.rangeService)
      return;
    const t = this.beans.rangeService.extendLatestRangeInDirection(e);
    t && this.beans.navigationService.ensureCellVisible(t);
  }
  onTabKeyDown(e) {
    this.beans.navigationService.onTabKeyDown(this.cellCtrl, e);
  }
  onBackspaceOrDeleteKeyDown(e, t) {
    const { cellCtrl: i, beans: o, rowNode: s } = this, { gos: r, rangeService: n, eventService: a } = o;
    if (!i.isEditing()) {
      if (a.dispatchEvent({ type: "keyShortcutChangedCellStart" }), function(l, d = !1) {
        return l === v.DELETE || !d && l === v.BACKSPACE && Ms();
      }(e, r.get("enableCellEditingOnBackspace"))) {
        if (n && r.get("enableRangeSelection"))
          n.clearCellRangeCellValues({ dispatchWrapperEvents: !0, wrapperEventSource: "deleteKey" });
        else if (i.isCellEditable()) {
          const l = i.getColumn(), d = this.beans.valueService.parseValue(l, s, "", s.getValueFromValueService(l)) ?? null;
          s.setDataValue(l, d, "cellClear");
        }
      } else
        i.startRowOrCellEdit(e, t);
      a.dispatchEvent({ type: "keyShortcutChangedCellEnd" });
    }
  }
  onEnterKeyDown(e) {
    if (this.cellCtrl.isEditing() || this.rowCtrl.isEditing())
      this.cellCtrl.stopEditingAndFocus(!1, e.shiftKey);
    else if (this.beans.gos.get("enterNavigatesVertically")) {
      const t = e.shiftKey ? v.UP : v.DOWN;
      this.beans.navigationService.navigateToNextCell(null, t, this.cellCtrl.getCellPosition(), !1);
    } else
      this.cellCtrl.startRowOrCellEdit(v.ENTER, e), this.cellCtrl.isEditing() && e.preventDefault();
  }
  onF2KeyDown(e) {
    this.cellCtrl.isEditing() || this.cellCtrl.startRowOrCellEdit(v.F2, e);
  }
  onEscapeKeyDown(e) {
    this.cellCtrl.isEditing() && (this.cellCtrl.stopRowOrCellEdit(!0), this.cellCtrl.focusCell(!0));
  }
  processCharacter(e) {
    if (e.target !== this.eGui || this.cellCtrl.isEditing())
      return;
    const t = e.key;
    t === " " ? this.onSpaceKeyDown(e) : (this.cellCtrl.startRowOrCellEdit(t, e), e.preventDefault());
  }
  onSpaceKeyDown(e) {
    const { gos: t } = this.beans;
    if (!this.cellCtrl.isEditing() && t.isRowSelection()) {
      const i = this.rowNode.isSelected(), o = !i;
      if (o || !t.get("suppressRowDeselection")) {
        const s = this.beans.gos.get("groupSelectsFiltered"), r = this.rowNode.setSelectedParams({ newValue: o, rangeSelect: e.shiftKey, groupSelectsFiltered: s, event: e, source: "spaceKey" });
        i === void 0 && r === 0 && this.rowNode.setSelectedParams({ newValue: !1, rangeSelect: e.shiftKey, groupSelectsFiltered: s, event: e, source: "spaceKey" });
      }
    }
    e.preventDefault();
  }
  destroy() {
    super.destroy();
  }
}, il = class extends f {
  constructor(e, t, i) {
    super(), this.cellCtrl = e, this.beans = t, this.column = i;
  }
  onMouseEvent(e, t) {
    if (!Ae(t))
      switch (e) {
        case "click":
          this.onCellClicked(t);
          break;
        case "mousedown":
        case "touchstart":
          this.onMouseDown(t);
          break;
        case "dblclick":
          this.onCellDoubleClicked(t);
          break;
        case "mouseout":
          this.onMouseOut(t);
          break;
        case "mouseover":
          this.onMouseOver(t);
      }
  }
  onCellClicked(e) {
    if (this.isDoubleClickOnIPad())
      return this.onCellDoubleClicked(e), void e.preventDefault();
    const { eventService: t, rangeService: i, gos: o } = this.beans, s = e.ctrlKey || e.metaKey;
    i && s && i.getCellRangeCount(this.cellCtrl.getCellPosition()) > 1 && i.intersectLastRange(!0);
    const r = this.cellCtrl.createEvent(e, "cellClicked");
    t.dispatchEvent(r);
    const n = this.column.getColDef();
    n.onCellClicked && window.setTimeout(() => {
      this.beans.frameworkOverrides.wrapOutgoing(() => {
        n.onCellClicked(r);
      });
    }, 0), !o.get("singleClickEdit") && !n.singleClickEdit || o.get("suppressClickEdit") || e.shiftKey && (i == null ? void 0 : i.getCellRanges().length) != 0 || this.cellCtrl.startRowOrCellEdit();
  }
  isDoubleClickOnIPad() {
    if (!Oe() || hs("dblclick"))
      return !1;
    const e = (/* @__PURE__ */ new Date()).getTime(), t = e - this.lastIPadMouseClickEvent < 200;
    return this.lastIPadMouseClickEvent = e, t;
  }
  onCellDoubleClicked(e) {
    const { column: t, beans: i, cellCtrl: o } = this, { eventService: s, frameworkOverrides: r, gos: n } = i, a = t.getColDef(), l = o.createEvent(e, "cellDoubleClicked");
    s.dispatchEvent(l), typeof a.onCellDoubleClicked == "function" && window.setTimeout(() => {
      r.wrapOutgoing(() => {
        a.onCellDoubleClicked(l);
      });
    }, 0), !n.get("singleClickEdit") && !n.get("suppressClickEdit") && o.startRowOrCellEdit(null, e);
  }
  onMouseDown(e) {
    const { ctrlKey: t, metaKey: i, shiftKey: o } = e, s = e.target, { cellCtrl: r, beans: n } = this, { eventService: a, rangeService: l, focusService: d, gos: c } = n;
    if (this.isRightClickInExistingRange(e))
      return;
    const h = l && l.getCellRanges().length != 0;
    if (!o || !h) {
      const g = c.get("enableCellTextSelection") && e.defaultPrevented, u = (Me() || g) && !r.isEditing() && !io(s);
      r.focusCell(u);
    }
    if (o && h && !d.isCellFocused(r.getCellPosition())) {
      e.preventDefault();
      const g = d.getFocusedCell();
      if (g) {
        const { column: u, rowIndex: p, rowPinned: C } = g, y = n.rowRenderer.getRowByPosition({ rowIndex: p, rowPinned: C }), w = y == null ? void 0 : y.getCellCtrl(u);
        w != null && w.isEditing() && w.stopEditing(), d.setFocusedCell({ column: u, rowIndex: p, rowPinned: C, forceBrowserFocus: !0, preventScrollOnBrowserFocus: !0 });
      }
    }
    if (!this.containsWidget(s)) {
      if (l) {
        const g = this.cellCtrl.getCellPosition();
        if (o)
          l.extendLatestRangeToCell(g);
        else {
          const u = t || i;
          l.setRangeToCell(g, u);
        }
      }
      a.dispatchEvent(this.cellCtrl.createEvent(e, "cellMouseDown"));
    }
  }
  isRightClickInExistingRange(e) {
    const { rangeService: t } = this.beans;
    if (t) {
      const i = t.isCellInAnyRange(this.cellCtrl.getCellPosition()), o = e.button === 2 || e.ctrlKey && this.beans.gos.get("allowContextMenuWithControlKey");
      if (i && o)
        return !0;
    }
    return !1;
  }
  containsWidget(e) {
    return rt(e, "ag-selection-checkbox", 3);
  }
  onMouseOut(e) {
    if (this.mouseStayingInsideCell(e))
      return;
    const t = this.cellCtrl.createEvent(e, "cellMouseOut");
    this.beans.eventService.dispatchEvent(t), this.beans.columnHoverService.clearMouseOver();
  }
  onMouseOver(e) {
    if (this.mouseStayingInsideCell(e))
      return;
    const t = this.cellCtrl.createEvent(e, "cellMouseOver");
    this.beans.eventService.dispatchEvent(t), this.beans.columnHoverService.setMouseOver([this.column]);
  }
  mouseStayingInsideCell(e) {
    if (!e.target || !e.relatedTarget)
      return !1;
    const t = this.cellCtrl.getGui(), i = t.contains(e.target), o = t.contains(e.relatedTarget);
    return i && o;
  }
  destroy() {
    super.destroy();
  }
}, ol = class extends f {
  constructor(e, t) {
    super(), this.cellCtrl = e, this.beans = t, this.column = e.getColumn(), this.rowNode = e.getRowNode();
  }
  setupRowSpan() {
    this.rowSpan = this.column.getRowSpan(this.rowNode), this.addManagedListeners(this.beans.eventService, { newColumnsLoaded: () => this.onNewColumnsLoaded() });
  }
  setComp(e) {
    this.eGui = e, this.setupColSpan(), this.setupRowSpan(), this.onLeftChanged(), this.onWidthChanged(), this.applyRowSpan();
  }
  onNewColumnsLoaded() {
    const e = this.column.getRowSpan(this.rowNode);
    this.rowSpan !== e && (this.rowSpan = e, this.applyRowSpan(!0));
  }
  onDisplayColumnsChanged() {
    const e = this.getColSpanningList();
    Ke(this.colsSpanning, e) || (this.colsSpanning = e, this.onWidthChanged(), this.onLeftChanged());
  }
  setupColSpan() {
    this.column.getColDef().colSpan != null && (this.colsSpanning = this.getColSpanningList(), this.addManagedListeners(this.beans.eventService, { displayedColumnsChanged: this.onDisplayColumnsChanged.bind(this), displayedColumnsWidthChanged: this.onWidthChanged.bind(this) }));
  }
  onWidthChanged() {
    if (!this.eGui)
      return;
    const e = this.getCellWidth();
    this.eGui.style.width = `${e}px`;
  }
  getCellWidth() {
    return this.colsSpanning ? this.colsSpanning.reduce((e, t) => e + t.getActualWidth(), 0) : this.column.getActualWidth();
  }
  getColSpanningList() {
    const e = this.column.getColSpan(this.rowNode), t = [];
    if (e === 1)
      t.push(this.column);
    else {
      let i = this.column;
      const o = this.column.getPinned();
      for (let s = 0; i && s < e && (t.push(i), i = this.beans.visibleColsService.getColAfter(i), i && !A(i)) && o === i.getPinned(); s++)
        ;
    }
    return t;
  }
  onLeftChanged() {
    if (!this.eGui)
      return;
    const e = this.modifyLeftForPrintLayout(this.getCellLeft());
    this.eGui.style.left = e + "px";
  }
  getCellLeft() {
    let e;
    return e = this.beans.gos.get("enableRtl") && this.colsSpanning ? T(this.colsSpanning) : this.column, e.getLeft();
  }
  modifyLeftForPrintLayout(e) {
    if (!this.cellCtrl.isPrintLayout() || this.column.getPinned() === "left")
      return e;
    const t = this.beans.visibleColsService.getColsLeftWidth();
    return this.column.getPinned() === "right" ? t + this.beans.visibleColsService.getBodyContainerWidth() + (e || 0) : t + (e || 0);
  }
  applyRowSpan(e) {
    if (this.rowSpan === 1 && !e)
      return;
    const t = this.beans.gos.getRowHeightAsNumber() * this.rowSpan;
    this.eGui.style.height = `${t}px`, this.eGui.style.zIndex = "1";
  }
  destroy() {
    super.destroy();
  }
}, pt = "ag-cell-range-selected", sl = class {
  constructor(e, t) {
    this.beans = e, this.rangeService = e.rangeService, this.selectionHandleFactory = e.selectionHandleFactory, this.cellCtrl = t;
  }
  setComp(e, t) {
    this.cellComp = e, this.eGui = t, this.onRangeSelectionChanged();
  }
  onRangeSelectionChanged() {
    this.cellComp && (this.rangeCount = this.rangeService.getCellRangeCount(this.cellCtrl.getCellPosition()), this.hasChartRange = this.getHasChartRange(), this.cellComp.addOrRemoveCssClass(pt, this.rangeCount !== 0), this.cellComp.addOrRemoveCssClass(`${pt}-1`, this.rangeCount === 1), this.cellComp.addOrRemoveCssClass(`${pt}-2`, this.rangeCount === 2), this.cellComp.addOrRemoveCssClass(`${pt}-3`, this.rangeCount === 3), this.cellComp.addOrRemoveCssClass(`${pt}-4`, this.rangeCount >= 4), this.cellComp.addOrRemoveCssClass("ag-cell-range-chart", this.hasChartRange), _t(this.eGui, this.rangeCount > 0 || void 0), this.cellComp.addOrRemoveCssClass("ag-cell-range-single-cell", this.isSingleCell()), this.updateRangeBorders(), this.refreshHandle());
  }
  updateRangeBorders() {
    const e = this.getRangeBorders(), t = this.isSingleCell(), i = !t && e.top, o = !t && e.right, s = !t && e.bottom, r = !t && e.left;
    this.cellComp.addOrRemoveCssClass("ag-cell-range-top", i), this.cellComp.addOrRemoveCssClass("ag-cell-range-right", o), this.cellComp.addOrRemoveCssClass("ag-cell-range-bottom", s), this.cellComp.addOrRemoveCssClass("ag-cell-range-left", r);
  }
  isSingleCell() {
    const { rangeService: e } = this.beans;
    return this.rangeCount === 1 && !!e && !e.isMoreThanOneCell();
  }
  getHasChartRange() {
    const { rangeService: e } = this.beans;
    if (!this.rangeCount || !e)
      return !1;
    const t = e.getCellRanges();
    return t.length > 0 && t.every((i) => He([1, 0], i.type));
  }
  updateRangeBordersIfRangeCount() {
    this.rangeCount > 0 && (this.updateRangeBorders(), this.refreshHandle());
  }
  getRangeBorders() {
    const e = this.beans.gos.get("enableRtl");
    let t = !1, i = !1, o = !1, s = !1;
    const r = this.cellCtrl.getCellPosition().column, n = this.beans.visibleColsService;
    let a, l;
    e ? (a = n.getColAfter(r), l = n.getColBefore(r)) : (a = n.getColBefore(r), l = n.getColAfter(r));
    const d = this.rangeService.getCellRanges().filter((c) => this.rangeService.isCellInSpecificRange(this.cellCtrl.getCellPosition(), c));
    a || (s = !0), l || (i = !0);
    for (let c = 0; c < d.length && !(t && i && o && s); c++) {
      const h = d[c], g = this.rangeService.getRangeStartRow(h), u = this.rangeService.getRangeEndRow(h);
      !t && this.beans.rowPositionUtils.sameRow(g, this.cellCtrl.getCellPosition()) && (t = !0), !o && this.beans.rowPositionUtils.sameRow(u, this.cellCtrl.getCellPosition()) && (o = !0), !s && a && h.columns.indexOf(a) < 0 && (s = !0), !i && l && h.columns.indexOf(l) < 0 && (i = !0);
    }
    return { top: t, right: i, bottom: o, left: s };
  }
  refreshHandle() {
    if (this.beans.context.isDestroyed())
      return;
    const e = this.shouldHaveSelectionHandle();
    this.selectionHandle && !e && (this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle)), e && this.addSelectionHandle(), this.cellComp.addOrRemoveCssClass("ag-cell-range-handle", !!this.selectionHandle);
  }
  shouldHaveSelectionHandle() {
    const e = this.beans.gos, t = this.rangeService.getCellRanges(), i = t.length;
    if (this.rangeCount < 1 || i < 1)
      return !1;
    const o = T(t), s = this.cellCtrl.getCellPosition(), r = e.get("enableFillHandle") && !this.cellCtrl.isSuppressFillHandle(), n = e.get("enableRangeHandle");
    let a = i === 1 && !this.cellCtrl.isEditing() && (r || n);
    if (this.hasChartRange) {
      const l = t[0].type === 1 && this.rangeService.isCellInSpecificRange(s, t[0]);
      this.cellComp.addOrRemoveCssClass("ag-cell-range-chart-category", l), a = o.type === 0;
    }
    return a && o.endRow != null && this.rangeService.isContiguousRange(o) && this.rangeService.isBottomRightCell(o, s);
  }
  addSelectionHandle() {
    const e = this.beans.gos, t = T(this.rangeService.getCellRanges()).type, i = e.get("enableFillHandle") && A(t) ? 0 : 1;
    this.selectionHandle && this.selectionHandle.getType() !== i && (this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle)), this.selectionHandle || (this.selectionHandle = this.selectionHandleFactory.createSelectionHandle(i)), this.selectionHandle.refresh(this.cellCtrl);
  }
  destroy() {
    this.beans.context.destroyBean(this.selectionHandle);
  }
}, rl = 0, yr = class Vi extends f {
  constructor(t, i, o, s) {
    super(), this.column = t, this.rowNode = i, this.beans = o, this.rowCtrl = s, this.cellRangeFeature = null, this.cellPositionFeature = null, this.cellCustomStyleFeature = null, this.tooltipFeature = null, this.cellMouseListenerFeature = null, this.cellKeyboardListenerFeature = null, this.suppressRefreshCell = !1, this.onCellCompAttachedFuncs = [], this.instanceId = t.getId() + "-" + rl++, this.colIdSanitised = fe(this.column.getId()), o.gos.get("suppressCellFocus") || (this.tabIndex = -1), this.createCellPosition(), this.addFeatures(), this.updateAndFormatValue(!1);
  }
  shouldRestoreFocus() {
    return this.beans.focusService.shouldRestoreFocus(this.cellPosition);
  }
  addFeatures() {
    this.cellPositionFeature = new ol(this, this.beans), this.addDestroyFunc(() => {
      var t;
      (t = this.cellPositionFeature) == null || t.destroy(), this.cellPositionFeature = null;
    }), this.cellCustomStyleFeature = new el(this, this.beans), this.addDestroyFunc(() => {
      var t;
      (t = this.cellCustomStyleFeature) == null || t.destroy(), this.cellCustomStyleFeature = null;
    }), this.cellMouseListenerFeature = new il(this, this.beans, this.column), this.addDestroyFunc(() => {
      var t;
      (t = this.cellMouseListenerFeature) == null || t.destroy(), this.cellMouseListenerFeature = null;
    }), this.cellKeyboardListenerFeature = new tl(this, this.beans, this.column, this.rowNode, this.rowCtrl), this.addDestroyFunc(() => {
      var t;
      (t = this.cellKeyboardListenerFeature) == null || t.destroy(), this.cellKeyboardListenerFeature = null;
    }), this.column.isTooltipEnabled() && (this.enableTooltipFeature(), this.addDestroyFunc(() => {
      this.disableTooltipFeature();
    })), this.beans.rangeService && this.beans.gos.get("enableRangeSelection") && (this.cellRangeFeature = new sl(this.beans, this), this.addDestroyFunc(() => {
      var t;
      (t = this.cellRangeFeature) == null || t.destroy(), this.cellRangeFeature = null;
    }));
  }
  enableTooltipFeature(t, i) {
    const o = this.beans.gos.get("tooltipShowMode") === "whenTruncated";
    i || !o || this.isCellRenderer() || (i = () => {
      const r = this.getGui(), n = r.children.length === 0 ? r : r.querySelector(".ag-cell-value");
      return !n || n.scrollWidth > n.clientWidth;
    });
    const s = { getColumn: () => this.column, getColDef: () => this.column.getColDef(), getRowIndex: () => this.cellPosition.rowIndex, getRowNode: () => this.rowNode, getGui: () => this.getGui(), getLocation: () => "cell", getTooltipValue: t != null ? () => t : () => {
      const r = this.column.getColDef(), n = this.rowNode.data;
      if (r.tooltipField && S(n))
        return bt(n, r.tooltipField, this.column.isTooltipFieldContainsDots());
      const a = r.tooltipValueGetter;
      return a ? a(this.beans.gos.addGridCommonParams({ location: "cell", colDef: this.column.getColDef(), column: this.column, rowIndex: this.cellPosition.rowIndex, node: this.rowNode, data: this.rowNode.data, value: this.value, valueFormatted: this.valueFormatted })) : null;
    }, getValueFormatted: () => this.valueFormatted, shouldDisplayTooltip: i };
    this.tooltipFeature = new gt(s, this.beans);
  }
  disableTooltipFeature() {
    this.tooltipFeature && (this.tooltipFeature.destroy(), this.tooltipFeature = null);
  }
  setComp(t, i, o, s, r) {
    var n, a, l, d;
    this.cellComp = t, this.eGui = i, this.printLayout = s, this.addDomData(), this.onCellFocused(this.focusEventToRestore), this.applyStaticCssClasses(), this.setWrapText(), this.onFirstRightPinnedChanged(), this.onLastLeftPinnedChanged(), this.onColumnHover(), this.setupControlComps(), this.setupAutoHeight(o), this.refreshFirstAndLastStyles(), this.refreshAriaColIndex(), (n = this.cellPositionFeature) == null || n.setComp(i), (a = this.cellCustomStyleFeature) == null || a.setComp(t), (l = this.tooltipFeature) == null || l.refreshToolTip(), (d = this.cellKeyboardListenerFeature) == null || d.setComp(this.eGui), this.cellRangeFeature && this.cellRangeFeature.setComp(t, i), r && this.isCellEditable() ? this.startEditing() : this.showValue(), this.onCellCompAttachedFuncs.length && (this.onCellCompAttachedFuncs.forEach((c) => c()), this.onCellCompAttachedFuncs = []);
  }
  setupAutoHeight(t) {
    if (this.isAutoHeight = this.column.isAutoHeight(), !this.isAutoHeight || !t)
      return;
    const i = t.parentElement, o = this.beans.gos.getRowHeightForNode(this.rowNode).height, s = (a) => {
      if (this.editing || !this.isAlive())
        return;
      const { paddingTop: l, paddingBottom: d, borderBottomWidth: c, borderTopWidth: h } = Ye(i), g = l + d + c + h, u = t.offsetHeight + g;
      if (a < 5) {
        const C = this.beans.gos.getDocument();
        if (!C || !C.contains(t) || u == 0)
          return void window.setTimeout(() => s(a + 1), 0);
      }
      const p = Math.max(u, o);
      this.rowNode.setRowAutoHeight(p, this.column);
    }, r = () => s(0);
    r();
    const n = this.beans.resizeObserverService.observeResize(t, r);
    this.addDestroyFunc(() => {
      n(), this.rowNode.setRowAutoHeight(void 0, this.column);
    });
  }
  getCellAriaRole() {
    return this.column.getColDef().cellAriaRole ?? "gridcell";
  }
  getInstanceId() {
    return this.instanceId;
  }
  getColumnIdSanitised() {
    return this.colIdSanitised;
  }
  getTabIndex() {
    return this.tabIndex;
  }
  isCellRenderer() {
    const t = this.column.getColDef();
    return t.cellRenderer != null || t.cellRendererSelector != null;
  }
  getValueToDisplay() {
    return this.valueFormatted ?? this.value;
  }
  showValue(t = !1) {
    var s;
    const i = this.getValueToDisplay();
    let o;
    if (this.rowNode.stub) {
      const r = this.createCellRendererParams();
      o = this.beans.userComponentFactory.getLoadingCellRendererDetails(this.column.getColDef(), r);
    } else if (this.isCellRenderer()) {
      const r = this.createCellRendererParams();
      o = this.beans.userComponentFactory.getCellRendererDetails(this.column.getColDef(), r);
    }
    this.cellComp.setRenderDetails(o, i, t), (s = this.cellRangeFeature) == null || s.refreshHandle();
  }
  setupControlComps() {
    const t = this.column.getColDef();
    this.includeSelection = this.isIncludeControl(t.checkboxSelection), this.includeRowDrag = this.isIncludeControl(t.rowDrag), this.includeDndSource = this.isIncludeControl(t.dndSource), this.cellComp.setIncludeSelection(this.includeSelection), this.cellComp.setIncludeDndSource(this.includeDndSource), this.cellComp.setIncludeRowDrag(this.includeRowDrag);
  }
  isForceWrapper() {
    return this.beans.gos.get("enableCellTextSelection") || this.column.isAutoHeight();
  }
  isIncludeControl(t) {
    return !(this.rowNode.rowPinned != null || typeof t != "function" && t !== !0);
  }
  refreshShouldDestroy() {
    const t = this.column.getColDef(), i = this.includeSelection != this.isIncludeControl(t.checkboxSelection), o = this.includeRowDrag != this.isIncludeControl(t.rowDrag), s = this.includeDndSource != this.isIncludeControl(t.dndSource), r = this.isAutoHeight != this.column.isAutoHeight();
    return i || o || s || r;
  }
  startEditing(t = null, i = !1, o = null) {
    const { editService: s } = this.beans;
    this.isCellEditable() && !this.editing && s && (this.cellComp ? s.startEditing(this, t, i, o) : this.onCellCompAttachedFuncs.push(() => {
      this.startEditing(t, i, o);
    }));
  }
  setEditing(t, i) {
    var o;
    this.editCompDetails = i, this.editing !== t && (this.editing = t, (o = this.cellRangeFeature) == null || o.refreshHandle());
  }
  stopRowOrCellEdit(t = !1) {
    this.beans.gos.get("editType") === "fullRow" ? this.rowCtrl.stopEditing(t) : this.stopEditing(t);
  }
  onPopupEditorClosed() {
    this.editing && this.stopEditingAndFocus();
  }
  stopEditing(t = !1) {
    const { editService: i } = this.beans;
    return !(!this.editing || !i) && i.stopEditing(this, t);
  }
  createCellRendererParams() {
    return this.beans.gos.addGridCommonParams({ value: this.value, valueFormatted: this.valueFormatted, getValue: () => this.rowNode.getValueFromValueService(this.column), setValue: (t) => this.beans.valueService.setValue(this.rowNode, this.column, t), formatValue: this.formatValue.bind(this), data: this.rowNode.data, node: this.rowNode, pinned: this.column.getPinned(), colDef: this.column.getColDef(), column: this.column, refreshCell: this.refreshCell.bind(this), eGridCell: this.getGui(), eParentOfValue: this.cellComp.getParentOfValue(), registerRowDragger: (t, i, o, s) => this.registerRowDragger(t, i, s), setTooltip: (t, i) => {
      var o;
      this.tooltipFeature && this.disableTooltipFeature(), this.enableTooltipFeature(t, i), (o = this.tooltipFeature) == null || o.refreshToolTip();
    } });
  }
  setFocusOutOnEditor() {
    var t;
    this.editing && ((t = this.beans.editService) == null || t.setFocusOutOnEditor(this));
  }
  setFocusInOnEditor() {
    var t;
    this.editing && ((t = this.beans.editService) == null || t.setFocusInOnEditor(this));
  }
  onCellChanged(t) {
    t.column === this.column && this.refreshCell({});
  }
  refreshOrDestroyCell(t) {
    var i;
    this.refreshShouldDestroy() ? (i = this.rowCtrl) == null || i.recreateCell(this) : this.refreshCell(t);
  }
  refreshCell(t) {
    var d, c, h, g, u;
    if (this.suppressRefreshCell || this.editing)
      return;
    const i = this.column.getColDef(), o = t != null && !!t.newData, s = t != null && !!t.suppressFlash || !!i.suppressCellFlash, r = i.field == null && i.valueGetter == null && i.showRowGroup == null, n = t && t.forceRefresh || r || o, a = !!this.cellComp, l = this.updateAndFormatValue(a);
    if (a) {
      if (n || l) {
        this.showValue(o);
        const p = (d = this.beans.filterManager) == null ? void 0 : d.isSuppressFlashingCellsBecauseFiltering();
        !s && !p && (this.beans.gos.get("enableCellChangeFlash") || i.enableCellChangeFlash) && this.flashCell(), (c = this.cellCustomStyleFeature) == null || c.applyUserStyles(), (h = this.cellCustomStyleFeature) == null || h.applyClassesFromColDef();
      }
      (g = this.tooltipFeature) == null || g.refreshToolTip(), (u = this.cellCustomStyleFeature) == null || u.applyCellClassRules();
    }
  }
  stopEditingAndFocus(t = !1, i = !1) {
    var o;
    (o = this.beans.editService) == null || o.stopEditingAndFocus(this, t, i);
  }
  flashCell(t) {
    const i = (t == null ? void 0 : t.flashDuration) ?? (t == null ? void 0 : t.flashDelay), o = (t == null ? void 0 : t.fadeDuration) ?? (t == null ? void 0 : t.fadeDelay);
    this.animateCell("data-changed", i, o);
  }
  animateCell(t, i, o) {
    if (!this.cellComp)
      return;
    const s = `ag-cell-${t}`, r = `ag-cell-${t}-animation`, { gos: n } = this.beans;
    i || (i = n.get("cellFlashDuration")), S(o) || (o = n.get("cellFadeDuration")), this.cellComp.addOrRemoveCssClass(s, !0), this.cellComp.addOrRemoveCssClass(r, !1), this.beans.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(() => {
        this.isAlive() && (this.cellComp.addOrRemoveCssClass(s, !1), this.cellComp.addOrRemoveCssClass(r, !0), this.eGui.style.transition = `background-color ${o}ms`, window.setTimeout(() => {
          this.isAlive() && (this.cellComp.addOrRemoveCssClass(r, !1), this.eGui.style.transition = "");
        }, o));
      }, i);
    });
  }
  onFlashCells(t) {
    if (!this.cellComp)
      return;
    const i = this.beans.cellPositionUtils.createId(this.getCellPosition());
    t.cells[i] && this.animateCell("highlight");
  }
  isCellEditable() {
    return this.column.isCellEditable(this.rowNode);
  }
  isSuppressFillHandle() {
    return this.column.isSuppressFillHandle();
  }
  formatValue(t) {
    return this.callValueFormatter(t) ?? t;
  }
  callValueFormatter(t) {
    return this.beans.valueService.formatValue(this.column, this.rowNode, t);
  }
  updateAndFormatValue(t) {
    const i = this.value, o = this.valueFormatted;
    return this.value = this.rowNode.getValueFromValueService(this.column), this.valueFormatted = this.callValueFormatter(this.value), !t || !this.valuesAreEqual(i, this.value) || this.valueFormatted != o;
  }
  valuesAreEqual(t, i) {
    const o = this.column.getColDef();
    return o.equals ? o.equals(t, i) : t === i;
  }
  getComp() {
    return this.cellComp;
  }
  getValue() {
    return this.value;
  }
  addDomData() {
    const t = this.getGui();
    this.beans.gos.setDomData(t, Vi.DOM_DATA_KEY_CELL_CTRL, this), this.addDestroyFunc(() => this.beans.gos.setDomData(t, Vi.DOM_DATA_KEY_CELL_CTRL, null));
  }
  createEvent(t, i) {
    return this.beans.gos.addGridCommonParams({ type: i, node: this.rowNode, data: this.rowNode.data, value: this.value, column: this.column, colDef: this.column.getColDef(), rowPinned: this.rowNode.rowPinned, event: t, rowIndex: this.rowNode.rowIndex });
  }
  processCharacter(t) {
    var i;
    (i = this.cellKeyboardListenerFeature) == null || i.processCharacter(t);
  }
  onKeyDown(t) {
    var i;
    (i = this.cellKeyboardListenerFeature) == null || i.onKeyDown(t);
  }
  onMouseEvent(t, i) {
    var o;
    (o = this.cellMouseListenerFeature) == null || o.onMouseEvent(t, i);
  }
  getGui() {
    return this.eGui;
  }
  getColSpanningList() {
    return this.cellPositionFeature.getColSpanningList();
  }
  onLeftChanged() {
    var t;
    this.cellComp && ((t = this.cellPositionFeature) == null || t.onLeftChanged());
  }
  onDisplayedColumnsChanged() {
    this.eGui && (this.refreshAriaColIndex(), this.refreshFirstAndLastStyles());
  }
  refreshFirstAndLastStyles() {
    const { cellComp: t, column: i, beans: o } = this;
    gr(t, i, o.visibleColsService);
  }
  refreshAriaColIndex() {
    const t = this.beans.visibleColsService.getAriaColIndex(this.column);
    xs(this.getGui(), t);
  }
  isSuppressNavigable() {
    return this.column.isSuppressNavigable(this.rowNode);
  }
  onWidthChanged() {
    var t;
    return (t = this.cellPositionFeature) == null ? void 0 : t.onWidthChanged();
  }
  getColumn() {
    return this.column;
  }
  getRowNode() {
    return this.rowNode;
  }
  isPrintLayout() {
    return this.printLayout;
  }
  getCellPosition() {
    return this.cellPosition;
  }
  isEditing() {
    return this.editing;
  }
  startRowOrCellEdit(t, i = null) {
    this.cellComp ? this.beans.gos.get("editType") === "fullRow" ? this.rowCtrl.startRowEditing(t, this) : this.startEditing(t, !0, i) : this.onCellCompAttachedFuncs.push(() => {
      this.startRowOrCellEdit(t, i);
    });
  }
  getRowCtrl() {
    return this.rowCtrl;
  }
  getRowPosition() {
    return { rowIndex: this.cellPosition.rowIndex, rowPinned: this.cellPosition.rowPinned };
  }
  updateRangeBordersIfRangeCount() {
    this.cellComp && this.cellRangeFeature && this.cellRangeFeature.updateRangeBordersIfRangeCount();
  }
  onRangeSelectionChanged() {
    this.cellComp && this.cellRangeFeature && this.cellRangeFeature.onRangeSelectionChanged();
  }
  isRangeSelectionEnabled() {
    return this.cellRangeFeature != null;
  }
  focusCell(t = !1) {
    this.beans.focusService.setFocusedCell({ rowIndex: this.getCellPosition().rowIndex, column: this.column, rowPinned: this.rowNode.rowPinned, forceBrowserFocus: t });
  }
  onRowIndexChanged() {
    this.createCellPosition(), this.onCellFocused(), this.cellRangeFeature && this.cellRangeFeature.onRangeSelectionChanged();
  }
  onFirstRightPinnedChanged() {
    if (!this.cellComp)
      return;
    const t = this.column.isFirstRightPinned();
    this.cellComp.addOrRemoveCssClass("ag-cell-first-right-pinned", t);
  }
  onLastLeftPinnedChanged() {
    if (!this.cellComp)
      return;
    const t = this.column.isLastLeftPinned();
    this.cellComp.addOrRemoveCssClass("ag-cell-last-left-pinned", t);
  }
  onCellFocused(t) {
    if (this.beans.gos.get("suppressCellFocus"))
      return;
    const i = this.beans.focusService.isCellFocused(this.cellPosition);
    if (!this.cellComp)
      return void (i && (t == null ? void 0 : t.forceBrowserFocus) && (this.focusEventToRestore = t));
    if (this.focusEventToRestore = void 0, this.cellComp.addOrRemoveCssClass("ag-cell-focus", i), i && t && t.forceBrowserFocus) {
      let s = this.cellComp.getFocusableElement();
      if (this.editing) {
        const r = this.beans.focusService.findFocusableElements(s, null, !0);
        r.length && (s = r[0]);
      }
      s.focus({ preventScroll: !!t.preventScrollOnBrowserFocus });
    }
    const o = this.beans.gos.get("editType") === "fullRow";
    i || o || !this.editing || this.stopRowOrCellEdit(), i && this.rowCtrl.announceDescription();
  }
  createCellPosition() {
    this.cellPosition = { rowIndex: this.rowNode.rowIndex, rowPinned: Ve(this.rowNode.rowPinned), column: this.column };
  }
  applyStaticCssClasses() {
    this.cellComp.addOrRemoveCssClass("ag-cell", !0), this.cellComp.addOrRemoveCssClass("ag-cell-not-inline-editing", !0);
    const t = this.column.isAutoHeight() == 1;
    this.cellComp.addOrRemoveCssClass("ag-cell-auto-height", t), this.cellComp.addOrRemoveCssClass("ag-cell-normal-height", !t);
  }
  onColumnHover() {
    if (!this.cellComp || !this.beans.gos.get("columnHoverHighlight"))
      return;
    const t = this.beans.columnHoverService.isHovered(this.column);
    this.cellComp.addOrRemoveCssClass("ag-column-hover", t);
  }
  onColDefChanged() {
    var t;
    this.cellComp && (this.column.isTooltipEnabled() ? (this.disableTooltipFeature(), this.enableTooltipFeature()) : this.disableTooltipFeature(), this.setWrapText(), this.editing ? (t = this.beans.editService) == null || t.handleColDefChanged(this) : this.refreshOrDestroyCell({ forceRefresh: !0, suppressFlash: !0 }));
  }
  setWrapText() {
    const t = this.column.getColDef().wrapText == 1;
    this.cellComp.addOrRemoveCssClass("ag-cell-wrap-text", t);
  }
  dispatchCellContextMenuEvent(t) {
    const i = this.column.getColDef(), o = this.createEvent(t, "cellContextMenu");
    this.beans.eventService.dispatchEvent(o), i.onCellContextMenu && window.setTimeout(() => {
      this.beans.frameworkOverrides.wrapOutgoing(() => {
        i.onCellContextMenu(o);
      });
    }, 0);
  }
  getCellRenderer() {
    return this.cellComp ? this.cellComp.getCellRenderer() : null;
  }
  getCellEditor() {
    return this.cellComp ? this.cellComp.getCellEditor() : null;
  }
  destroy() {
    this.onCellCompAttachedFuncs = [], super.destroy();
  }
  createSelectionCheckbox() {
    const t = new Za();
    return this.beans.context.createBean(t), t.init({ rowNode: this.rowNode, column: this.column }), t;
  }
  createDndSource() {
    const t = new _a(this.rowNode, this.column, this.eGui);
    return this.beans.context.createBean(t), t;
  }
  registerRowDragger(t, i, o) {
    if (this.customRowDragComp)
      return void this.customRowDragComp.setDragElement(t, i);
    const s = this.createRowDragComp(t, i, o);
    s && (this.customRowDragComp = s, this.addDestroyFunc(() => {
      this.beans.context.destroyBean(s), this.customRowDragComp = null;
    }));
  }
  createRowDragComp(t, i, o) {
    const s = this.beans.gos.get("pagination"), r = this.beans.gos.get("rowDragManaged"), n = this.beans.gos.isRowModelType("clientSide");
    if (r) {
      if (!n)
        return void b("managed row dragging is only allowed in the Client Side Row Model");
      if (s)
        return void b("managed row dragging is not possible when doing pagination");
    }
    const a = new zi(() => this.value, this.rowNode, this.column, t, i, o);
    return this.beans.context.createBean(a), a;
  }
  setSuppressRefreshCell(t) {
    this.suppressRefreshCell = t;
  }
  getEditCompDetails() {
    return this.editCompDetails;
  }
};
yr.DOM_DATA_KEY_CELL_CTRL = "cellCtrl";
var Ue = yr, nl = 0, Sr = class Wi extends f {
  constructor(t, i, o, s, r) {
    var n;
    super(), this.allRowGuis = [], this.active = !0, this.centerCellCtrls = { list: [], map: {} }, this.leftCellCtrls = { list: [], map: {} }, this.rightCellCtrls = { list: [], map: {} }, this.slideInAnimation = { left: !1, center: !1, right: !1, fullWidth: !1 }, this.fadeInAnimation = { left: !1, center: !1, right: !1, fullWidth: !1 }, this.rowDragComps = [], this.lastMouseDownOnDragger = !1, this.emptyStyle = {}, this.updateColumnListsPending = !1, this.rowId = null, this.businessKeySanitised = null, this.beans = i, this.gos = i.gos, this.rowNode = t, this.paginationPage = ((n = i.paginationService) == null ? void 0 : n.getCurrentPage()) ?? 0, this.useAnimationFrameForCreate = s, this.printLayout = r, this.suppressRowTransform = this.gos.get("suppressRowTransform"), this.instanceId = t.id + "-" + nl++, this.rowId = fe(t.id), this.initRowBusinessKey(), this.rowFocused = i.focusService.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned), this.rowLevel = i.rowCssClassCalculator.calculateRowLevel(this.rowNode), this.setRowType(), this.setAnimateFlags(o), this.rowStyles = this.processStylesFromGridOptions(), this.isFullWidth() && !this.gos.get("suppressCellFocus") && (this.tabIndex = -1), this.addListeners();
  }
  initRowBusinessKey() {
    this.businessKeyForNodeFunc = this.gos.get("getBusinessKeyForNode"), this.updateRowBusinessKey();
  }
  updateRowBusinessKey() {
    if (typeof this.businessKeyForNodeFunc != "function")
      return;
    const t = this.businessKeyForNodeFunc(this.rowNode);
    this.businessKeySanitised = fe(t);
  }
  getRowId() {
    return this.rowId;
  }
  getRowStyles() {
    return this.rowStyles;
  }
  getTabIndex() {
    return this.tabIndex;
  }
  isSticky() {
    return this.rowNode.sticky;
  }
  getInstanceId() {
    return this.instanceId;
  }
  updateGui(t, i) {
    t === "left" ? this.leftGui = i : t === "right" ? this.rightGui = i : t === "fullWidth" ? this.fullWidthGui = i : this.centerGui = i;
  }
  setComp(t, i, o) {
    const s = { rowComp: t, element: i, containerType: o };
    this.allRowGuis.push(s), this.updateGui(o, s), this.initialiseRowComp(s), this.rowType === "FullWidthLoading" || this.rowNode.rowPinned || this.beans.rowRenderer.dispatchFirstDataRenderedEvent();
  }
  unsetComp(t) {
    this.allRowGuis = this.allRowGuis.filter((i) => i.containerType !== t), this.updateGui(t, void 0);
  }
  isCacheable() {
    return this.rowType === "FullWidthDetail" && this.gos.get("keepDetailRows");
  }
  setCached(t) {
    const i = t ? "none" : "";
    this.allRowGuis.forEach((o) => o.element.style.display = i);
  }
  initialiseRowComp(t) {
    const i = this.gos;
    this.listenOnDomOrder(t), this.beans.columnModel.wasAutoRowHeightEverActive() && this.rowNode.checkAutoHeights(), this.onRowHeightChanged(t), this.updateRowIndexes(t), this.setFocusedClasses(t), this.setStylesFromGridOptions(!1, t), i.isRowSelection() && this.rowNode.selectable && this.onRowSelected(t), this.updateColumnLists(!this.useAnimationFrameForCreate);
    const o = t.rowComp;
    this.getInitialRowClasses(t.containerType).forEach((s) => o.addOrRemoveCssClass(s, !0)), this.executeSlideAndFadeAnimations(t), this.rowNode.group && Zt(t.element, this.rowNode.expanded == 1), this.setRowCompRowId(o), this.setRowCompRowBusinessKey(o), i.setDomData(t.element, Wi.DOM_DATA_KEY_ROW_CTRL, this), this.addDestroyFunc(() => i.setDomData(t.element, Wi.DOM_DATA_KEY_ROW_CTRL, null)), this.useAnimationFrameForCreate ? this.beans.animationFrameService.createTask(this.addHoverFunctionality.bind(this, t.element), this.rowNode.rowIndex, "createTasksP2") : this.addHoverFunctionality(t.element), this.isFullWidth() && this.setupFullWidth(t), i.get("rowDragEntireRow") && this.addRowDraggerToRow(t), this.useAnimationFrameForCreate && this.beans.animationFrameService.addDestroyTask(() => {
      this.isAlive() && t.rowComp.addOrRemoveCssClass("ag-after-created", !0);
    }), this.executeProcessRowPostCreateFunc();
  }
  setRowCompRowBusinessKey(t) {
    this.businessKeySanitised != null && t.setRowBusinessKey(this.businessKeySanitised);
  }
  getBusinessKey() {
    return this.businessKeySanitised;
  }
  setRowCompRowId(t) {
    this.rowId = fe(this.rowNode.id), this.rowId != null && t.setRowId(this.rowId);
  }
  executeSlideAndFadeAnimations(t) {
    const { containerType: i } = t;
    this.slideInAnimation[i] && (Po(() => {
      this.onTopChanged();
    }), this.slideInAnimation[i] = !1), this.fadeInAnimation[i] && (Po(() => {
      t.rowComp.addOrRemoveCssClass("ag-opacity-zero", !1);
    }), this.fadeInAnimation[i] = !1);
  }
  addRowDraggerToRow(t) {
    if (this.gos.get("enableRangeSelection"))
      return void b("Setting `rowDragEntireRow: true` in the gridOptions doesn't work with `enableRangeSelection: true`");
    const i = this.beans.localeService.getLocaleTextFunc(), o = new zi(() => `1 ${i("rowDragRow", "row")}`, this.rowNode, void 0, t.element, void 0, !0), s = this.createBean(o, this.beans.context);
    this.rowDragComps.push(s);
  }
  setupFullWidth(t) {
    const i = this.getPinnedForContainer(t.containerType);
    if (this.rowType == "FullWidthDetail" && !Q.__assertRegistered("@ag-grid-enterprise/master-detail", "cell renderer 'agDetailCellRenderer' (for master detail)", this.beans.context.getGridId()))
      return;
    const o = this.createFullWidthCompDetails(t.element, i);
    t.rowComp.showFullWidth(o);
  }
  isPrintLayout() {
    return this.printLayout;
  }
  getFullWidthCellRenderers() {
    var t, i;
    return this.gos.get("embedFullWidthRows") ? this.allRowGuis.map((o) => {
      var s;
      return (s = o == null ? void 0 : o.rowComp) == null ? void 0 : s.getFullWidthCellRenderer();
    }) : [(i = (t = this.fullWidthGui) == null ? void 0 : t.rowComp) == null ? void 0 : i.getFullWidthCellRenderer()];
  }
  getCellElement(t) {
    const i = this.getCellCtrl(t);
    return i ? i.getGui() : null;
  }
  executeProcessRowPostCreateFunc() {
    const t = this.gos.getCallback("processRowPostCreate");
    t && this.areAllContainersReady() && t({ eRow: this.centerGui.element, ePinnedLeftRow: this.leftGui ? this.leftGui.element : void 0, ePinnedRightRow: this.rightGui ? this.rightGui.element : void 0, node: this.rowNode, rowIndex: this.rowNode.rowIndex, addRenderedRowListener: this.addEventListener.bind(this) });
  }
  areAllContainersReady() {
    const t = !!this.leftGui || !this.beans.visibleColsService.isPinningLeft(), i = !!this.centerGui, o = !!this.rightGui || !this.beans.visibleColsService.isPinningRight();
    return t && i && o;
  }
  setRowType() {
    const t = this.rowNode.stub && !this.gos.get("suppressServerSideFullWidthLoadingRow"), i = this.rowNode.isFullWidthCell(), o = this.gos.get("masterDetail") && this.rowNode.detail, s = this.beans.columnModel.isPivotMode(), r = !!this.rowNode.group && !this.rowNode.footer && this.gos.isGroupUseEntireRow(s);
    this.rowType = t ? "FullWidthLoading" : o ? "FullWidthDetail" : i ? "FullWidth" : r ? "FullWidthGroup" : "Normal";
  }
  updateColumnLists(t = !1, i = !1) {
    this.isFullWidth() || (t || this.gos.get("suppressAnimationFrame") || this.printLayout ? this.updateColumnListsImpl(i) : this.updateColumnListsPending || (this.beans.animationFrameService.createTask(() => {
      this.active && this.updateColumnListsImpl(!0);
    }, this.rowNode.rowIndex, "createTasksP1"), this.updateColumnListsPending = !0));
  }
  createCellCtrls(t, i, o = null) {
    const s = { list: [], map: {} }, r = (n, a) => {
      s.list.push(a), s.map[n] = a;
    };
    return i.forEach((n) => {
      const a = n.getInstanceId();
      let l = t.map[a];
      l || (l = new Ue(n, this.rowNode, this.beans, this)), r(a, l);
    }), t.list.forEach((n) => {
      s.map[n.getColumn().getInstanceId()] == null && (this.isCellEligibleToBeRemoved(n, o) ? n.destroy() : r(n.getColumn().getInstanceId(), n));
    }), s;
  }
  updateColumnListsImpl(t) {
    this.updateColumnListsPending = !1, this.createAllCellCtrls(), this.setCellCtrls(t);
  }
  setCellCtrls(t) {
    this.allRowGuis.forEach((i) => {
      const o = this.getCellCtrlsForContainer(i.containerType);
      i.rowComp.setCellCtrls(o, t);
    });
  }
  getCellCtrlsForContainer(t) {
    switch (t) {
      case "left":
        return this.leftCellCtrls.list;
      case "right":
        return this.rightCellCtrls.list;
      case "fullWidth":
        return [];
      case "center":
        return this.centerCellCtrls.list;
    }
  }
  createAllCellCtrls() {
    const t = this.beans.columnViewportService, i = this.beans.visibleColsService;
    if (this.printLayout)
      this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, i.getAllCols()), this.leftCellCtrls = { list: [], map: {} }, this.rightCellCtrls = { list: [], map: {} };
    else {
      const o = t.getColsWithinViewport(this.rowNode);
      this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, o);
      const s = i.getLeftColsForRow(this.rowNode);
      this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, s, "left");
      const r = i.getRightColsForRow(this.rowNode);
      this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, r, "right");
    }
  }
  isCellEligibleToBeRemoved(t, i) {
    if (t.getColumn().getPinned() != i)
      return !0;
    const s = t.isEditing(), r = this.beans.focusService.isCellFocused(t.getCellPosition());
    if (s || r) {
      const n = t.getColumn();
      return !(this.beans.visibleColsService.getAllCols().indexOf(n) >= 0) && !0;
    }
    return !0;
  }
  getDomOrder() {
    return this.gos.get("ensureDomOrder") || this.gos.isDomLayout("print");
  }
  listenOnDomOrder(t) {
    const i = () => {
      t.rowComp.setDomOrder(this.getDomOrder());
    };
    this.addManagedPropertyListener("domLayout", i), this.addManagedPropertyListener("ensureDomOrder", i);
  }
  setAnimateFlags(t) {
    if (this.isSticky() || !t)
      return;
    const i = S(this.rowNode.oldRowTop), o = this.beans.visibleColsService.isPinningLeft(), s = this.beans.visibleColsService.isPinningRight();
    if (i) {
      if (this.isFullWidth() && !this.gos.get("embedFullWidthRows"))
        return void (this.slideInAnimation.fullWidth = !0);
      this.slideInAnimation.center = !0, this.slideInAnimation.left = o, this.slideInAnimation.right = s;
    } else {
      if (this.isFullWidth() && !this.gos.get("embedFullWidthRows"))
        return void (this.fadeInAnimation.fullWidth = !0);
      this.fadeInAnimation.center = !0, this.fadeInAnimation.left = o, this.fadeInAnimation.right = s;
    }
  }
  isEditing() {
    return this.editingRow;
  }
  isFullWidth() {
    return this.rowType !== "Normal";
  }
  refreshFullWidth() {
    const t = (n, a) => !n || n.rowComp.refreshFullWidth(() => this.createFullWidthCompDetails(n.element, a).params), i = t(this.fullWidthGui, null), o = t(this.centerGui, null), s = t(this.leftGui, "left"), r = t(this.rightGui, "right");
    return i && o && s && r;
  }
  addListeners() {
    this.addManagedListeners(this.rowNode, { heightChanged: () => this.onRowHeightChanged(), rowSelected: () => this.onRowSelected(), rowIndexChanged: this.onRowIndexChanged.bind(this), topChanged: this.onTopChanged.bind(this), expandedChanged: this.updateExpandedCss.bind(this), hasChildrenChanged: this.updateExpandedCss.bind(this) }), this.rowNode.detail && this.addManagedListeners(this.rowNode.parent, { dataChanged: this.onRowNodeDataChanged.bind(this) }), this.addManagedListeners(this.rowNode, { dataChanged: this.onRowNodeDataChanged.bind(this), cellChanged: this.postProcessCss.bind(this), rowHighlightChanged: this.onRowNodeHighlightChanged.bind(this), draggingChanged: this.postProcessRowDragging.bind(this), uiLevelChanged: this.onUiLevelChanged.bind(this) }), this.addManagedListeners(this.beans.eventService, { paginationPixelOffsetChanged: this.onPaginationPixelOffsetChanged.bind(this), heightScaleChanged: this.onTopChanged.bind(this), displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this), virtualColumnsChanged: this.onVirtualColumnsChanged.bind(this), cellFocused: this.onCellFocusChanged.bind(this), cellFocusCleared: this.onCellFocusChanged.bind(this), paginationChanged: this.onPaginationChanged.bind(this), modelUpdated: this.refreshFirstAndLastRowStyles.bind(this), columnMoved: () => this.updateColumnLists() }), this.addDestroyFunc(() => {
      this.destroyBeans(this.rowDragComps, this.beans.context), this.tooltipFeature && (this.tooltipFeature = this.destroyBean(this.tooltipFeature, this.beans.context));
    }), this.addManagedPropertyListeners(["rowDragEntireRow"], () => {
      this.gos.get("rowDragEntireRow") ? this.allRowGuis.forEach((t) => {
        this.addRowDraggerToRow(t);
      }) : this.rowDragComps = this.destroyBeans(this.rowDragComps, this.beans.context);
    }), this.addListenersForCellComps();
  }
  addListenersForCellComps() {
    this.addManagedListeners(this.rowNode, { rowIndexChanged: () => {
      this.getAllCellCtrls().forEach((t) => t.onRowIndexChanged());
    }, cellChanged: (t) => {
      this.getAllCellCtrls().forEach((i) => i.onCellChanged(t));
    } });
  }
  onRowNodeDataChanged(t) {
    this.isFullWidth() !== !!this.rowNode.isFullWidthCell() ? this.beans.rowRenderer.redrawRow(this.rowNode) : this.isFullWidth() ? this.refreshFullWidth() || this.beans.rowRenderer.redrawRow(this.rowNode) : (this.getAllCellCtrls().forEach((i) => i.refreshCell({ suppressFlash: !t.update, newData: !t.update })), this.allRowGuis.forEach((i) => {
      this.setRowCompRowId(i.rowComp), this.updateRowBusinessKey(), this.setRowCompRowBusinessKey(i.rowComp);
    }), this.onRowSelected(), this.postProcessCss());
  }
  postProcessCss() {
    this.setStylesFromGridOptions(!0), this.postProcessClassesFromGridOptions(), this.postProcessRowClassRules(), this.postProcessRowDragging();
  }
  onRowNodeHighlightChanged() {
    const t = this.rowNode.highlighted;
    this.allRowGuis.forEach((i) => {
      const o = t === 0, s = t === 1;
      i.rowComp.addOrRemoveCssClass("ag-row-highlight-above", o), i.rowComp.addOrRemoveCssClass("ag-row-highlight-below", s);
    });
  }
  postProcessRowDragging() {
    const t = this.rowNode.dragging;
    this.allRowGuis.forEach((i) => i.rowComp.addOrRemoveCssClass("ag-row-dragging", t));
  }
  updateExpandedCss() {
    const t = this.rowNode.isExpandable(), i = this.rowNode.expanded == 1;
    this.allRowGuis.forEach((o) => {
      o.rowComp.addOrRemoveCssClass("ag-row-group", t), o.rowComp.addOrRemoveCssClass("ag-row-group-expanded", t && i), o.rowComp.addOrRemoveCssClass("ag-row-group-contracted", t && !i), Zt(o.element, t && i);
    });
  }
  onDisplayedColumnsChanged() {
    this.updateColumnLists(!0), this.beans.columnModel.wasAutoRowHeightEverActive() && this.rowNode.checkAutoHeights();
  }
  onVirtualColumnsChanged() {
    this.updateColumnLists(!1, !0);
  }
  getRowPosition() {
    return { rowPinned: Ve(this.rowNode.rowPinned), rowIndex: this.rowNode.rowIndex };
  }
  onKeyboardNavigate(t) {
    const i = this.allRowGuis.find((n) => n.element.contains(t.target));
    if ((i ? i.element : null) !== t.target)
      return;
    const o = this.rowNode, s = this.beans.focusService.getFocusedCell(), r = { rowIndex: o.rowIndex, rowPinned: o.rowPinned, column: s && s.column };
    this.beans.navigationService.navigateToNextCell(t, t.key, r, !0), t.preventDefault();
  }
  onTabKeyDown(t) {
    if (t.defaultPrevented || Ae(t))
      return;
    const i = this.allRowGuis.find((n) => n.element.contains(t.target)), o = i ? i.element : null, s = o === t.target;
    let r = null;
    s || (r = this.beans.focusService.findNextFocusableElement(o, !1, t.shiftKey)), (this.isFullWidth() && s || !r) && this.beans.navigationService.onTabKeyDown(this, t);
  }
  getFullWidthElement() {
    return this.fullWidthGui ? this.fullWidthGui.element : null;
  }
  getRowYPosition() {
    var i;
    const t = (i = this.allRowGuis.find((o) => he(o.element))) == null ? void 0 : i.element;
    return t ? t.getBoundingClientRect().top : 0;
  }
  onFullWidthRowFocused(t) {
    var r;
    const i = this.rowNode, o = !!t && this.isFullWidth() && t.rowIndex === i.rowIndex && t.rowPinned == i.rowPinned, s = this.fullWidthGui ? this.fullWidthGui.element : (r = this.centerGui) == null ? void 0 : r.element;
    s && (s.classList.toggle("ag-full-width-focus", o), o && (t != null && t.forceBrowserFocus) && s.focus({ preventScroll: !0 }));
  }
  recreateCell(t) {
    this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, t), this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, t), this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, t), t.destroy(), this.updateColumnLists();
  }
  removeCellCtrl(t, i) {
    const o = { list: [], map: {} };
    return t.list.forEach((s) => {
      s !== i && (o.list.push(s), o.map[s.getColumn().getInstanceId()] = s);
    }), o;
  }
  onMouseEvent(t, i) {
    switch (t) {
      case "dblclick":
        this.onRowDblClick(i);
        break;
      case "click":
        this.onRowClick(i);
        break;
      case "touchstart":
      case "mousedown":
        this.onRowMouseDown(i);
    }
  }
  createRowEvent(t, i) {
    return this.gos.addGridCommonParams({ type: t, node: this.rowNode, data: this.rowNode.data, rowIndex: this.rowNode.rowIndex, rowPinned: this.rowNode.rowPinned, event: i });
  }
  createRowEventWithSource(t, i) {
    const o = this.createRowEvent(t, i);
    return o.source = this, o;
  }
  onRowDblClick(t) {
    if (Ae(t))
      return;
    const i = this.createRowEventWithSource("rowDoubleClicked", t);
    this.beans.eventService.dispatchEvent(i);
  }
  onRowMouseDown(t) {
    if (this.lastMouseDownOnDragger = rt(t.target, "ag-row-drag", 3), !this.isFullWidth())
      return;
    const i = this.rowNode, o = this.beans.visibleColsService;
    this.beans.rangeService && this.beans.rangeService.removeAllCellRanges();
    const s = this.getFullWidthElement(), r = t.target;
    let n = !0;
    s && s.contains(r) && io(r) && (n = !1), this.beans.focusService.setFocusedCell({ rowIndex: i.rowIndex, column: o.getAllCols()[0], rowPinned: i.rowPinned, forceBrowserFocus: n });
  }
  onRowClick(t) {
    if (Ae(t) || this.lastMouseDownOnDragger)
      return;
    const i = this.createRowEventWithSource("rowClicked", t);
    this.beans.eventService.dispatchEvent(i);
    const o = t.ctrlKey || t.metaKey, s = t.shiftKey;
    if (this.gos.get("groupSelectsChildren") && this.rowNode.group || this.isRowSelectionBlocked() || this.gos.get("suppressRowClickSelection"))
      return;
    const r = this.gos.get("rowMultiSelectWithClick"), n = !this.gos.get("suppressRowDeselection"), a = "rowClicked";
    if (this.rowNode.isSelected())
      r ? this.rowNode.setSelectedParams({ newValue: !1, event: t, source: a }) : o ? n && this.rowNode.setSelectedParams({ newValue: !1, event: t, source: a }) : this.rowNode.setSelectedParams({ newValue: !0, clearSelection: !s, rangeSelect: s, event: t, source: a });
    else {
      const l = !r && !o;
      this.rowNode.setSelectedParams({ newValue: !0, clearSelection: l, rangeSelect: s, event: t, source: a });
    }
  }
  isRowSelectionBlocked() {
    return !this.rowNode.selectable || !!this.rowNode.rowPinned || !this.gos.isRowSelection();
  }
  setupDetailRowAutoHeight(t) {
    if (this.rowType !== "FullWidthDetail" || !this.gos.get("detailRowAutoHeight"))
      return;
    const i = () => {
      const s = t.clientHeight;
      if (s != null && s > 0) {
        const r = () => {
          this.rowNode.setRowHeight(s), (this.beans.rowModel.getType() === "clientSide" || this.beans.rowModel.getType() === "serverSide") && this.beans.rowModel.onRowHeightChanged();
        };
        window.setTimeout(r, 0);
      }
    }, o = this.beans.resizeObserverService.observeResize(t, i);
    this.addDestroyFunc(o), i();
  }
  createFullWidthCompDetails(t, i) {
    const { gos: o, rowNode: s } = this, r = o.addGridCommonParams({ fullWidth: !0, data: s.data, node: s, value: s.key, valueFormatted: s.key, eGridCell: t, eParentOfValue: t, pinned: i, addRenderedRowListener: this.addEventListener.bind(this), registerRowDragger: (a, l, d, c) => this.addFullWidthRowDragging(a, l, d, c), setTooltip: (a, l) => this.refreshRowTooltip(a, l) }), n = this.beans.userComponentFactory;
    switch (this.rowType) {
      case "FullWidthDetail":
        return n.getFullWidthDetailCellRendererDetails(r);
      case "FullWidthGroup":
        return n.getFullWidthGroupCellRendererDetails(r);
      case "FullWidthLoading":
        return n.getFullWidthLoadingCellRendererDetails(r);
      default:
        return n.getFullWidthCellRendererDetails(r);
    }
  }
  refreshRowTooltip(t, i) {
    if (!this.fullWidthGui)
      return;
    const o = { getGui: () => this.fullWidthGui.element, getTooltipValue: () => t, getLocation: () => "fullWidthRow", shouldDisplayTooltip: i };
    this.tooltipFeature && this.destroyBean(this.tooltipFeature, this.beans.context), this.tooltipFeature = this.createBean(new gt(o, this.beans));
  }
  addFullWidthRowDragging(t, i, o = "", s) {
    if (!this.isFullWidth())
      return;
    const r = new zi(() => o, this.rowNode, void 0, t, i, s);
    this.createBean(r, this.beans.context), this.addDestroyFunc(() => {
      this.destroyBean(r, this.beans.context);
    });
  }
  onUiLevelChanged() {
    const t = this.beans.rowCssClassCalculator.calculateRowLevel(this.rowNode);
    if (this.rowLevel != t) {
      const i = "ag-row-level-" + t, o = "ag-row-level-" + this.rowLevel;
      this.allRowGuis.forEach((s) => {
        s.rowComp.addOrRemoveCssClass(i, !0), s.rowComp.addOrRemoveCssClass(o, !1);
      });
    }
    this.rowLevel = t;
  }
  isFirstRowOnPage() {
    return this.rowNode.rowIndex === this.beans.pageBoundsService.getFirstRow();
  }
  isLastRowOnPage() {
    return this.rowNode.rowIndex === this.beans.pageBoundsService.getLastRow();
  }
  refreshFirstAndLastRowStyles() {
    const t = this.isFirstRowOnPage(), i = this.isLastRowOnPage();
    this.firstRowOnPage !== t && (this.firstRowOnPage = t, this.allRowGuis.forEach((o) => o.rowComp.addOrRemoveCssClass("ag-row-first", t))), this.lastRowOnPage !== i && (this.lastRowOnPage = i, this.allRowGuis.forEach((o) => o.rowComp.addOrRemoveCssClass("ag-row-last", i)));
  }
  stopEditing(t = !1) {
    var i;
    this.stoppingRowEdit || ((i = this.beans.rowEditService) == null || i.stopEditing(this, t));
  }
  setInlineEditingCss(t) {
    this.allRowGuis.forEach((i) => {
      i.rowComp.addOrRemoveCssClass("ag-row-inline-editing", t), i.rowComp.addOrRemoveCssClass("ag-row-not-inline-editing", !t);
    });
  }
  setEditingRow(t) {
    this.editingRow = t;
  }
  startRowEditing(t = null, i = null, o = null) {
    var s;
    this.editingRow || ((s = this.beans.rowEditService) == null || s.startEditing(this, t, i, o));
  }
  getAllCellCtrls() {
    return this.leftCellCtrls.list.length === 0 && this.rightCellCtrls.list.length === 0 ? this.centerCellCtrls.list : [...this.centerCellCtrls.list, ...this.leftCellCtrls.list, ...this.rightCellCtrls.list];
  }
  postProcessClassesFromGridOptions() {
    const t = this.beans.rowCssClassCalculator.processClassesFromGridOptions(this.rowNode);
    t && t.length && t.forEach((i) => {
      this.allRowGuis.forEach((o) => o.rowComp.addOrRemoveCssClass(i, !0));
    });
  }
  postProcessRowClassRules() {
    this.beans.rowCssClassCalculator.processRowClassRules(this.rowNode, (t) => {
      this.allRowGuis.forEach((i) => i.rowComp.addOrRemoveCssClass(t, !0));
    }, (t) => {
      this.allRowGuis.forEach((i) => i.rowComp.addOrRemoveCssClass(t, !1));
    });
  }
  setStylesFromGridOptions(t, i) {
    t && (this.rowStyles = this.processStylesFromGridOptions()), this.forEachGui(i, (o) => o.rowComp.setUserStyles(this.rowStyles));
  }
  getPinnedForContainer(t) {
    return t === "left" || t === "right" ? t : null;
  }
  getInitialRowClasses(t) {
    const i = this.getPinnedForContainer(t), o = { rowNode: this.rowNode, rowFocused: this.rowFocused, fadeRowIn: this.fadeInAnimation[t], rowIsEven: this.rowNode.rowIndex % 2 == 0, rowLevel: this.rowLevel, fullWidthRow: this.isFullWidth(), firstRowOnPage: this.isFirstRowOnPage(), lastRowOnPage: this.isLastRowOnPage(), printLayout: this.printLayout, expandable: this.rowNode.isExpandable(), pinned: i };
    return this.beans.rowCssClassCalculator.getInitialRowClasses(o);
  }
  processStylesFromGridOptions() {
    const t = this.gos.get("rowStyle");
    if (t && typeof t == "function")
      return void b("rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead");
    const i = this.gos.getCallback("getRowStyle");
    let o;
    return i && (o = i({ data: this.rowNode.data, node: this.rowNode, rowIndex: this.rowNode.rowIndex })), o || t ? Object.assign({}, t, o) : this.emptyStyle;
  }
  onRowSelected(t) {
    const i = !!this.rowNode.isSelected();
    this.forEachGui(t, (o) => {
      o.rowComp.addOrRemoveCssClass("ag-row-selected", i), _t(o.element, i), !o.element.contains(this.gos.getActiveDomElement()) || o !== this.centerGui && o !== this.fullWidthGui || this.announceDescription();
    });
  }
  announceDescription() {
    if (this.isRowSelectionBlocked())
      return;
    const t = this.rowNode.isSelected();
    if (t && this.gos.get("suppressRowDeselection"))
      return;
    const i = this.beans.localeService.getLocaleTextFunc()(t ? "ariaRowDeselect" : "ariaRowSelect", `Press SPACE to ${t ? "deselect" : "select"} this row.`);
    this.beans.ariaAnnouncementService.announceValue(i);
  }
  addHoverFunctionality(t) {
    if (!this.active)
      return;
    const { rowNode: i, beans: o, gos: s } = this;
    this.addManagedListeners(t, { mouseenter: () => i.onMouseEnter(), mouseleave: () => i.onMouseLeave() }), this.addManagedListeners(i, { mouseEnter: () => {
      o.dragService.isDragging() || s.get("suppressRowHoverHighlight") || (t.classList.add("ag-row-hover"), i.setHovered(!0));
    }, mouseLeave: () => {
      t.classList.remove("ag-row-hover"), i.setHovered(!1);
    } });
  }
  roundRowTopToBounds(t) {
    const i = this.beans.ctrlsService.getGridBodyCtrl().getScrollFeature().getApproximateVScollPosition(), o = this.applyPaginationOffset(i.top, !0) - 100, s = this.applyPaginationOffset(i.bottom, !0) + 100;
    return Math.min(Math.max(o, t), s);
  }
  getFrameworkOverrides() {
    return this.beans.frameworkOverrides;
  }
  forEachGui(t, i) {
    t ? i(t) : this.allRowGuis.forEach(i);
  }
  onRowHeightChanged(t) {
    if (this.rowNode.rowHeight == null)
      return;
    const i = this.rowNode.rowHeight, o = this.beans.environment.getDefaultRowHeight(), s = this.gos.isGetRowHeightFunction() ? this.gos.getRowHeightForNode(this.rowNode).height : void 0, r = s ? Math.min(o, s) - 2 + "px" : void 0;
    this.forEachGui(t, (n) => {
      n.element.style.height = `${i}px`, r && n.element.style.setProperty("--ag-line-height", r);
    });
  }
  addEventListener(t, i) {
    super.addEventListener(t, i);
  }
  removeEventListener(t, i) {
    super.removeEventListener(t, i);
  }
  destroyFirstPass(t = !1) {
    if (this.active = !1, !t && this.gos.isAnimateRows() && !this.isSticky())
      if (this.rowNode.rowTop != null) {
        const o = this.roundRowTopToBounds(this.rowNode.rowTop);
        this.setRowTop(o);
      } else
        this.allRowGuis.forEach((o) => o.rowComp.addOrRemoveCssClass("ag-opacity-zero", !0));
    this.rowNode.setHovered(!1);
    const i = this.createRowEvent("virtualRowRemoved");
    this.dispatchLocalEvent(i), this.beans.eventService.dispatchEvent(i), super.destroy();
  }
  destroySecondPass() {
    this.allRowGuis.length = 0, this.stopEditing();
    const t = (i) => (i.list.forEach((o) => o.destroy()), { list: [], map: {} });
    this.centerCellCtrls = t(this.centerCellCtrls), this.leftCellCtrls = t(this.leftCellCtrls), this.rightCellCtrls = t(this.rightCellCtrls);
  }
  setFocusedClasses(t) {
    this.forEachGui(t, (i) => {
      i.rowComp.addOrRemoveCssClass("ag-row-focus", this.rowFocused), i.rowComp.addOrRemoveCssClass("ag-row-no-focus", !this.rowFocused);
    });
  }
  onCellFocusChanged() {
    const t = this.beans.focusService.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
    t !== this.rowFocused && (this.rowFocused = t, this.setFocusedClasses()), !t && this.editingRow && this.stopEditing(!1);
  }
  onPaginationChanged() {
    var i;
    const t = ((i = this.beans.paginationService) == null ? void 0 : i.getCurrentPage()) ?? 0;
    this.paginationPage !== t && (this.paginationPage = t, this.onTopChanged()), this.refreshFirstAndLastRowStyles();
  }
  onTopChanged() {
    this.setRowTop(this.rowNode.rowTop);
  }
  onPaginationPixelOffsetChanged() {
    this.onTopChanged();
  }
  applyPaginationOffset(t, i = !1) {
    return this.rowNode.isRowPinned() || this.rowNode.sticky ? t : t + this.beans.pageBoundsService.getPixelOffset() * (i ? 1 : -1);
  }
  setRowTop(t) {
    if (!this.printLayout && S(t)) {
      const i = this.applyPaginationOffset(t), o = `${this.rowNode.isRowPinned() || this.rowNode.sticky ? i : this.beans.rowContainerHeightService.getRealPixelPosition(i)}px`;
      this.setRowTopStyle(o);
    }
  }
  getInitialRowTop(t) {
    return this.suppressRowTransform ? this.getInitialRowTopShared(t) : void 0;
  }
  getInitialTransform(t) {
    return this.suppressRowTransform ? void 0 : `translateY(${this.getInitialRowTopShared(t)})`;
  }
  getInitialRowTopShared(t) {
    if (this.printLayout)
      return "";
    const i = this.rowNode;
    let o;
    if (this.isSticky())
      o = i.stickyRowTop;
    else {
      const s = this.slideInAnimation[t] ? this.roundRowTopToBounds(i.oldRowTop) : i.rowTop, r = this.applyPaginationOffset(s);
      o = i.isRowPinned() ? r : this.beans.rowContainerHeightService.getRealPixelPosition(r);
    }
    return o + "px";
  }
  setRowTopStyle(t) {
    this.allRowGuis.forEach((i) => this.suppressRowTransform ? i.rowComp.setTop(t) : i.rowComp.setTransform(`translateY(${t})`));
  }
  getRowNode() {
    return this.rowNode;
  }
  getCellCtrl(t) {
    let i = null;
    return this.getAllCellCtrls().forEach((o) => {
      o.getColumn() == t && (i = o);
    }), i != null || this.getAllCellCtrls().forEach((o) => {
      o.getColSpanningList().indexOf(t) >= 0 && (i = o);
    }), i;
  }
  onRowIndexChanged() {
    this.rowNode.rowIndex != null && (this.onCellFocusChanged(), this.updateRowIndexes(), this.postProcessCss());
  }
  getRowIndex() {
    return this.rowNode.getRowIndexString();
  }
  updateRowIndexes(t) {
    var n;
    const i = this.rowNode.getRowIndexString();
    if (i === null)
      return;
    const o = this.beans.headerNavigationService.getHeaderRowCount() + (((n = this.beans.filterManager) == null ? void 0 : n.getHeaderRowCount()) ?? 0), s = this.rowNode.rowIndex % 2 == 0, r = o + this.rowNode.rowIndex + 1;
    this.forEachGui(t, (a) => {
      a.rowComp.setRowIndex(i), a.rowComp.addOrRemoveCssClass("ag-row-even", s), a.rowComp.addOrRemoveCssClass("ag-row-odd", !s), Rs(a.element, r);
    });
  }
  setStoppingRowEdit(t) {
    this.stoppingRowEdit = t;
  }
};
Sr.DOM_DATA_KEY_ROW_CTRL = "renderedRow";
var je = Sr, al = class extends f {
  wireBeans(e) {
    this.mouseEventService = e.mouseEventService, this.valueService = e.valueService, this.menuService = e.menuService, this.ctrlsService = e.ctrlsService, this.navigationService = e.navigationService, this.focusService = e.focusService, this.undoRedoService = e.undoRedoService, this.visibleColsService = e.visibleColsService, this.rowModel = e.rowModel, this.pinnedRowModel = e.pinnedRowModel, this.rangeService = e.rangeService, this.clipboardService = e.clipboardService;
  }
  constructor(e) {
    super(), this.element = e;
  }
  postConstruct() {
    this.addKeyboardListeners(), this.addMouseListeners(), this.mockContextMenuForIPad();
  }
  addKeyboardListeners() {
    const e = "keydown", t = this.processKeyboardEvent.bind(this, e);
    this.addManagedElementListeners(this.element, { [e]: t });
  }
  addMouseListeners() {
    ["dblclick", "contextmenu", "mouseover", "mouseout", "click", hs("touchstart") ? "touchstart" : "mousedown"].forEach((e) => {
      const t = this.processMouseEvent.bind(this, e);
      this.addManagedElementListeners(this.element, { [e]: t });
    });
  }
  processMouseEvent(e, t) {
    if (!this.mouseEventService.isEventFromThisGrid(t) || Ae(t))
      return;
    const i = this.getRowForEvent(t), o = this.mouseEventService.getRenderedCellForEvent(t);
    e === "contextmenu" ? this.handleContextMenuMouseEvent(t, void 0, i, o) : (o && o.onMouseEvent(e, t), i && i.onMouseEvent(e, t));
  }
  mockContextMenuForIPad() {
    if (!Oe())
      return;
    const e = new Te(this.element);
    this.addManagedListeners(e, { longTap: (t) => {
      const i = this.getRowForEvent(t.touchEvent), o = this.mouseEventService.getRenderedCellForEvent(t.touchEvent);
      this.handleContextMenuMouseEvent(void 0, t.touchEvent, i, o);
    } }), this.addDestroyFunc(() => e.destroy());
  }
  getRowForEvent(e) {
    let t = e.target;
    for (; t; ) {
      const i = this.gos.getDomData(t, je.DOM_DATA_KEY_ROW_CTRL);
      if (i)
        return i;
      t = t.parentElement;
    }
    return null;
  }
  handleContextMenuMouseEvent(e, t, i, o) {
    const s = i ? i.getRowNode() : null, r = o ? o.getColumn() : null;
    let n = null;
    if (r) {
      const d = e || t;
      o.dispatchCellContextMenuEvent(d ?? null), n = this.valueService.getValue(r, s);
    }
    const a = this.ctrlsService.getGridBodyCtrl(), l = o ? o.getGui() : a.getGridBodyElement();
    this.menuService.showContextMenu({ mouseEvent: e, touchEvent: t, rowNode: s, column: r, value: n, anchorToElement: l });
  }
  getControlsForEventTarget(e) {
    return { cellCtrl: Di(this.gos, e, Ue.DOM_DATA_KEY_CELL_CTRL), rowCtrl: Di(this.gos, e, je.DOM_DATA_KEY_ROW_CTRL) };
  }
  processKeyboardEvent(e, t) {
    const { cellCtrl: i, rowCtrl: o } = this.getControlsForEventTarget(t.target);
    t.defaultPrevented || (i ? this.processCellKeyboardEvent(i, e, t) : o && o.isFullWidth() && this.processFullWidthRowKeyboardEvent(o, e, t));
  }
  processCellKeyboardEvent(e, t, i) {
    const o = e.getRowNode(), s = e.getColumn(), r = e.isEditing();
    if (Bi(this.gos, i, o, s, r) || t !== "keydown" || (!r && this.navigationService.handlePageScrollingKey(i) || e.onKeyDown(i), this.doGridOperations(i, e.isEditing()), tr(i) && e.processCharacter(i)), t === "keydown") {
      const n = e.createEvent(i, "cellKeyDown");
      this.eventService.dispatchEvent(n);
    }
  }
  processFullWidthRowKeyboardEvent(e, t, i) {
    const o = e.getRowNode(), s = this.focusService.getFocusedCell(), r = s && s.column;
    if (!Bi(this.gos, i, o, r, !1)) {
      const n = i.key;
      if (t === "keydown")
        switch (n) {
          case v.PAGE_HOME:
          case v.PAGE_END:
          case v.PAGE_UP:
          case v.PAGE_DOWN:
            this.navigationService.handlePageScrollingKey(i, !0);
            break;
          case v.UP:
          case v.DOWN:
            e.onKeyboardNavigate(i);
            break;
          case v.TAB:
            e.onTabKeyDown(i);
        }
    }
    if (t === "keydown") {
      const n = e.createRowEvent("cellKeyDown", i);
      this.eventService.dispatchEvent(n);
    }
  }
  doGridOperations(e, t) {
    if (!e.ctrlKey && !e.metaKey || t || !this.mouseEventService.isEventFromThisGrid(e))
      return;
    const i = function(o) {
      const { keyCode: s } = o;
      let r;
      switch (s) {
        case 65:
          r = v.A;
          break;
        case 67:
          r = v.C;
          break;
        case 86:
          r = v.V;
          break;
        case 68:
          r = v.D;
          break;
        case 90:
          r = v.Z;
          break;
        case 89:
          r = v.Y;
          break;
        default:
          r = o.code;
      }
      return r;
    }(e);
    return i === v.A ? this.onCtrlAndA(e) : i === v.C ? this.onCtrlAndC(e) : i === v.D ? this.onCtrlAndD(e) : i === v.V ? this.onCtrlAndV(e) : i === v.X ? this.onCtrlAndX(e) : i === v.Y ? this.onCtrlAndY() : i === v.Z ? this.onCtrlAndZ(e) : void 0;
  }
  onCtrlAndA(e) {
    const { pinnedRowModel: t, rowModel: i, rangeService: o } = this;
    if (o && i.isRowsToRender()) {
      const [s, r] = [t.isEmpty("top"), t.isEmpty("bottom")], n = s ? null : "top";
      let a, l;
      r ? (a = null, l = i.getRowCount() - 1) : (a = "bottom", l = t.getPinnedBottomRowNodes().length - 1);
      const d = this.visibleColsService.getAllCols();
      if (W(d))
        return;
      o.setCellRange({ rowStartIndex: 0, rowStartPinned: n, rowEndIndex: l, rowEndPinned: a, columnStart: d[0], columnEnd: T(d) });
    }
    e.preventDefault();
  }
  onCtrlAndC(e) {
    if (!this.clipboardService || this.gos.get("enableCellTextSelection"))
      return;
    const { cellCtrl: t, rowCtrl: i } = this.getControlsForEventTarget(e.target);
    t != null && t.isEditing() || i != null && i.isEditing() || (e.preventDefault(), this.clipboardService.copyToClipboard());
  }
  onCtrlAndX(e) {
    if (!this.clipboardService || this.gos.get("enableCellTextSelection") || this.gos.get("suppressCutToClipboard"))
      return;
    const { cellCtrl: t, rowCtrl: i } = this.getControlsForEventTarget(e.target);
    t != null && t.isEditing() || i != null && i.isEditing() || (e.preventDefault(), this.clipboardService.cutToClipboard(void 0, "ui"));
  }
  onCtrlAndV(e) {
    const { cellCtrl: t, rowCtrl: i } = this.getControlsForEventTarget(e.target);
    t != null && t.isEditing() || i != null && i.isEditing() || this.clipboardService && !this.gos.get("suppressClipboardPaste") && this.clipboardService.pasteFromClipboard();
  }
  onCtrlAndD(e) {
    this.clipboardService && !this.gos.get("suppressClipboardPaste") && this.clipboardService.copyRangeDown(), e.preventDefault();
  }
  onCtrlAndZ(e) {
    this.gos.get("undoRedoCellEditing") && this.undoRedoService && (e.preventDefault(), e.shiftKey ? this.undoRedoService.redo("ui") : this.undoRedoService.undo("ui"));
  }
  onCtrlAndY() {
    var e;
    (e = this.undoRedoService) == null || e.redo("ui");
  }
}, ll = class extends f {
  wireBeans(e) {
    this.pinnedWidthService = e.pinnedWidthService;
  }
  constructor(e) {
    super(), this.element = e;
  }
  postConstruct() {
    this.addManagedEventListeners({ leftPinnedWidthChanged: this.onPinnedLeftWidthChanged.bind(this) });
  }
  onPinnedLeftWidthChanged() {
    const e = this.pinnedWidthService.getPinnedLeftWidth(), t = e > 0;
    H(this.element, t), ce(this.element, e);
  }
  getWidth() {
    return this.pinnedWidthService.getPinnedLeftWidth();
  }
}, dl = class extends f {
  wireBeans(e) {
    this.pinnedWidthService = e.pinnedWidthService;
  }
  constructor(e) {
    super(), this.element = e;
  }
  postConstruct() {
    this.addManagedEventListeners({ rightPinnedWidthChanged: this.onPinnedRightWidthChanged.bind(this) });
  }
  onPinnedRightWidthChanged() {
    const e = this.pinnedWidthService.getPinnedRightWidth(), t = e > 0;
    H(this.element, t), ce(this.element, e);
  }
  getWidth() {
    return this.pinnedWidthService.getPinnedRightWidth();
  }
}, Nt = (e) => e.getTopRowCtrls(), Gt = (e) => e.getStickyTopRowCtrls(), zt = (e) => e.getStickyBottomRowCtrls(), Bt = (e) => e.getBottomRowCtrls(), Ht = (e) => e.getCentreRowCtrls(), cl = { center: { type: "center", container: "ag-center-cols-container", viewport: "ag-center-cols-viewport", getRowCtrls: Ht }, left: { type: "left", container: "ag-pinned-left-cols-container", pinnedType: "left", getRowCtrls: Ht }, right: { type: "right", container: "ag-pinned-right-cols-container", pinnedType: "right", getRowCtrls: Ht }, fullWidth: { type: "fullWidth", container: "ag-full-width-container", fullWidth: !0, getRowCtrls: Ht }, topCenter: { type: "center", container: "ag-floating-top-container", viewport: "ag-floating-top-viewport", getRowCtrls: Nt }, topLeft: { type: "left", container: "ag-pinned-left-floating-top", pinnedType: "left", getRowCtrls: Nt }, topRight: { type: "right", container: "ag-pinned-right-floating-top", pinnedType: "right", getRowCtrls: Nt }, topFullWidth: { type: "fullWidth", container: "ag-floating-top-full-width-container", fullWidth: !0, getRowCtrls: Nt }, stickyTopCenter: { type: "center", container: "ag-sticky-top-container", viewport: "ag-sticky-top-viewport", getRowCtrls: Gt }, stickyTopLeft: { type: "left", container: "ag-pinned-left-sticky-top", pinnedType: "left", getRowCtrls: Gt }, stickyTopRight: { type: "right", container: "ag-pinned-right-sticky-top", pinnedType: "right", getRowCtrls: Gt }, stickyTopFullWidth: { type: "fullWidth", container: "ag-sticky-top-full-width-container", fullWidth: !0, getRowCtrls: Gt }, stickyBottomCenter: { type: "center", container: "ag-sticky-bottom-container", viewport: "ag-sticky-bottom-viewport", getRowCtrls: zt }, stickyBottomLeft: { type: "left", container: "ag-pinned-left-sticky-bottom", pinnedType: "left", getRowCtrls: zt }, stickyBottomRight: { type: "right", container: "ag-pinned-right-sticky-bottom", pinnedType: "right", getRowCtrls: zt }, stickyBottomFullWidth: { type: "fullWidth", container: "ag-sticky-bottom-full-width-container", fullWidth: !0, getRowCtrls: zt }, bottomCenter: { type: "center", container: "ag-floating-bottom-container", viewport: "ag-floating-bottom-viewport", getRowCtrls: Bt }, bottomLeft: { type: "left", container: "ag-pinned-left-floating-bottom", pinnedType: "left", getRowCtrls: Bt }, bottomRight: { type: "right", container: "ag-pinned-right-floating-bottom", pinnedType: "right", getRowCtrls: Bt }, bottomFullWidth: { type: "fullWidth", container: "ag-floating-bottom-full-width-container", fullWidth: !0, getRowCtrls: Bt } };
function Rr(e) {
  return cl[e];
}
var hl = ["center", "left", "right", "fullWidth"], gl = ["stickyTopCenter", "stickyBottomCenter", "center", "topCenter", "bottomCenter"], ul = ["left", "bottomLeft", "topLeft", "stickyTopLeft", "stickyBottomLeft"], pl = ["right", "bottomRight", "topRight", "stickyTopRight", "stickyBottomRight"], xr = ["stickyTopCenter", "stickyTopLeft", "stickyTopRight"], Fr = ["stickyBottomCenter", "stickyBottomLeft", "stickyBottomRight"], ml = [...xr, "stickyTopFullWidth", ...Fr, "stickyBottomFullWidth"], vl = ["topCenter", "topLeft", "topRight", "bottomCenter", "bottomLeft", "bottomRight", "center", "left", "right", ...xr, ...Fr], fl = class extends f {
  constructor(e) {
    super(), this.visible = !0, this.EMPTY_CTRLS = [], this.name = e, this.options = Rr(e);
  }
  wireBeans(e) {
    this.dragService = e.dragService, this.ctrlsService = e.ctrlsService, this.columnViewportService = e.columnViewportService, this.resizeObserverService = e.resizeObserverService, this.rowRenderer = e.rowRenderer;
  }
  postConstruct() {
    this.enableRtl = this.gos.get("enableRtl"), this.forContainers(["center"], () => {
      this.viewportSizeFeature = this.createManagedBean(new Ja(this)), this.addManagedEventListeners({ stickyTopOffsetChanged: this.onStickyTopOffsetChanged.bind(this) });
    });
  }
  onStickyTopOffsetChanged(e) {
    this.comp.setOffsetTop(`${e.offset}px`);
  }
  registerWithCtrlsService() {
    this.options.fullWidth || this.ctrlsService.register(this.name, this);
  }
  forContainers(e, t) {
    e.indexOf(this.name) >= 0 && t();
  }
  getContainerElement() {
    return this.eContainer;
  }
  getViewportSizeFeature() {
    return this.viewportSizeFeature;
  }
  setComp(e, t, i) {
    this.comp = e, this.eContainer = t, this.eViewport = i, this.createManagedBean(new al(this.eContainer)), this.addPreventScrollWhileDragging(), this.listenOnDomOrder(), this.stopHScrollOnPinnedRows(), this.forContainers(ul, () => {
      this.pinnedWidthFeature = this.createManagedBean(new ll(this.eContainer)), this.addManagedEventListeners({ leftPinnedWidthChanged: () => this.onPinnedWidthChanged() });
    }), this.forContainers(pl, () => {
      this.pinnedWidthFeature = this.createManagedBean(new dl(this.eContainer)), this.addManagedEventListeners({ rightPinnedWidthChanged: () => this.onPinnedWidthChanged() });
    }), this.forContainers(hl, () => this.createManagedBean(new wr(this.eContainer, this.name === "center" ? i : void 0))), this.forContainers(vl, () => this.createManagedBean(new Xa(this.eContainer))), this.forContainers(gl, () => this.createManagedBean(new wo((o) => this.comp.setContainerWidth(`${o}px`)))), this.addListeners(), this.registerWithCtrlsService();
  }
  addListeners() {
    this.addManagedEventListeners({ displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this), displayedColumnsWidthChanged: this.onDisplayedColumnsWidthChanged.bind(this), displayedRowsChanged: (e) => this.onDisplayedRowsChanged(e.afterScroll) }), this.onDisplayedColumnsChanged(), this.onDisplayedColumnsWidthChanged(), this.onDisplayedRowsChanged();
  }
  listenOnDomOrder() {
    if (ml.indexOf(this.name) >= 0)
      return void this.comp.setDomOrder(!0);
    const e = () => {
      const t = this.gos.get("ensureDomOrder"), i = this.gos.isDomLayout("print");
      this.comp.setDomOrder(t || i);
    };
    this.addManagedPropertyListener("domLayout", e), e();
  }
  stopHScrollOnPinnedRows() {
    this.forContainers(["topCenter", "stickyTopCenter", "bottomCenter", "stickyBottomCenter"], () => {
      this.addManagedElementListeners(this.eViewport, { scroll: () => this.eViewport.scrollLeft = 0 });
    });
  }
  onDisplayedColumnsChanged() {
    this.forContainers(["center"], () => this.onHorizontalViewportChanged());
  }
  onDisplayedColumnsWidthChanged() {
    this.forContainers(["center"], () => this.onHorizontalViewportChanged());
  }
  addPreventScrollWhileDragging() {
    const e = (t) => {
      this.dragService.isDragging() && t.cancelable && t.preventDefault();
    };
    this.eContainer.addEventListener("touchmove", e, { passive: !1 }), this.addDestroyFunc(() => this.eContainer.removeEventListener("touchmove", e));
  }
  onHorizontalViewportChanged(e = !1) {
    const t = this.getCenterWidth(), i = this.getCenterViewportScrollLeft();
    this.columnViewportService.setScrollPosition(t, i, e);
  }
  getCenterWidth() {
    return Pt(this.eViewport);
  }
  getCenterViewportScrollLeft() {
    return ii(this.eViewport, this.enableRtl);
  }
  registerViewportResizeListener(e) {
    const t = this.resizeObserverService.observeResize(this.eViewport, e);
    this.addDestroyFunc(() => t());
  }
  isViewportInTheDOMTree() {
    return Is(this.eViewport);
  }
  getViewportScrollLeft() {
    return ii(this.eViewport, this.enableRtl);
  }
  isHorizontalScrollShowing() {
    return this.gos.get("alwaysShowHorizontalScroll") || (e = this.eViewport).clientWidth < e.scrollWidth;
    var e;
  }
  getViewportElement() {
    return this.eViewport;
  }
  setContainerTranslateX(e) {
    this.eContainer.style.transform = `translateX(${e}px)`;
  }
  getHScrollPosition() {
    return { left: this.eViewport.scrollLeft, right: this.eViewport.scrollLeft + this.eViewport.offsetWidth };
  }
  setCenterViewportScrollLeft(e) {
    oi(this.eViewport, e, this.enableRtl);
  }
  isContainerVisible() {
    return this.options.pinnedType == null || !!this.pinnedWidthFeature && this.pinnedWidthFeature.getWidth() > 0;
  }
  onPinnedWidthChanged() {
    const e = this.isContainerVisible();
    this.visible != e && (this.visible = e, this.onDisplayedRowsChanged());
  }
  onDisplayedRowsChanged(e = !1) {
    const t = this.options.getRowCtrls(this.rowRenderer);
    if (!this.visible || t.length === 0)
      return void this.comp.setRowCtrls({ rowCtrls: this.EMPTY_CTRLS });
    const i = this.gos.isDomLayout("print"), o = this.gos.get("embedFullWidthRows") || i, s = t.filter((r) => {
      const n = r.isFullWidth();
      return this.options.fullWidth ? !o && n : o || !n;
    });
    this.comp.setRowCtrls({ rowCtrls: s, useFlushSync: e });
  }
}, Cl = { selector: "AG-ROW-CONTAINER", component: class extends O {
  constructor() {
    super(), this.eViewport = R, this.eContainer = R, this.rowComps = {}, this.name = O.elementGettingCreated.getAttribute("name"), this.options = Rr(this.name), this.setTemplate(function(e) {
      let t;
      return t = e.type === "center" ? `<div class="${e.viewport}" data-ref="eViewport" role="presentation">
                <div class="${e.container}" data-ref="eContainer"></div>
            </div>` : `<div class="${e.container}" data-ref="eContainer"></div>`, t;
    }(this.options));
  }
  wireBeans(e) {
    this.beans = e;
  }
  postConstruct() {
    const e = { setViewportHeight: (t) => this.eViewport.style.height = t, setRowCtrls: ({ rowCtrls: t }) => this.setRowCtrls(t), setDomOrder: (t) => {
      this.domOrder = t;
    }, setContainerWidth: (t) => this.eContainer.style.width = t, setOffsetTop: (t) => this.eContainer.style.transform = `translateY(${t})` };
    this.createManagedBean(new fl(this.name)).setComp(e, this.eContainer, this.eViewport);
  }
  destroy() {
    this.setRowCtrls([]), super.destroy();
  }
  setRowCtrls(e) {
    const t = { ...this.rowComps };
    this.rowComps = {}, this.lastPlacedElement = null, e.forEach((i) => {
      const o = i.getInstanceId(), s = t[o];
      if (s)
        this.rowComps[o] = s, delete t[o], this.ensureDomOrder(s.getGui());
      else {
        if (!i.getRowNode().displayed)
          return;
        const r = new $a(i, this.beans, this.options.type);
        this.rowComps[o] = r, this.appendRow(r.getGui());
      }
    }), Ie(t).forEach((i) => {
      this.eContainer.removeChild(i.getGui()), i.destroy();
    }), X(this.eContainer, "rowgroup");
  }
  appendRow(e) {
    var t, i, o;
    this.domOrder ? (t = this.eContainer, i = e, (o = this.lastPlacedElement) ? o.insertAdjacentElement("afterend", i) : t.firstChild ? t.insertAdjacentElement("afterbegin", i) : t.appendChild(i)) : this.eContainer.appendChild(e), this.lastPlacedElement = e;
  }
  ensureDomOrder(e) {
    this.domOrder && (Ls(this.eContainer, e, this.lastPlacedElement), this.lastPlacedElement = e);
  }
} };
function mt(e) {
  return e.map((t) => `<ag-row-container name="${t}"></ag-row-container>`).join("");
}
var wl = `<div class="ag-root ag-unselectable" role="treegrid">
        <ag-header-root></ag-header-root>
        <div class="ag-floating-top" data-ref="eTop" role="presentation">
            ${mt(["topLeft", "topCenter", "topRight", "topFullWidth"])}
        </div>
        <div class="ag-body" data-ref="eBody" role="presentation">
            <div class="ag-body-viewport" data-ref="eBodyViewport" role="presentation">
            ${mt(["left", "center", "right", "fullWidth"])}
            </div>
            <ag-fake-vertical-scroll></ag-fake-vertical-scroll>
        </div>
        <div class="ag-sticky-top" data-ref="eStickyTop" role="presentation">
            ${mt(["stickyTopLeft", "stickyTopCenter", "stickyTopRight", "stickyTopFullWidth"])}
        </div>
        <div class="ag-sticky-bottom" data-ref="eStickyBottom" role="presentation">
            ${mt(["stickyBottomLeft", "stickyBottomCenter", "stickyBottomRight", "stickyBottomFullWidth"])}
        </div>
        <div class="ag-floating-bottom" data-ref="eBottom" role="presentation">
            ${mt(["bottomLeft", "bottomCenter", "bottomRight", "bottomFullWidth"])}
        </div>
        <ag-fake-horizontal-scroll></ag-fake-horizontal-scroll>
        <ag-overlay-wrapper></ag-overlay-wrapper>
    </div>`, bl = { selector: "AG-GRID-BODY", component: class extends O {
  constructor() {
    super(wl, [Ua, ja, Ka, Wa, Cl]), this.eBodyViewport = R, this.eStickyTop = R, this.eStickyBottom = R, this.eTop = R, this.eBottom = R, this.eBody = R;
  }
  wireBeans(e) {
    this.resizeObserverService = e.resizeObserverService, this.rangeService = e.rangeService;
  }
  postConstruct() {
    const e = (i, o) => {
      const s = `${i}px`;
      o.style.minHeight = s, o.style.height = s;
    }, t = { setRowAnimationCssOnBodyViewport: (i, o) => this.setRowAnimationCssOnBodyViewport(i, o), setColumnCount: (i) => {
      de(this.getGui(), "colcount", i);
    }, setRowCount: (i) => {
      de(this.getGui(), "rowcount", i);
    }, setTopHeight: (i) => e(i, this.eTop), setBottomHeight: (i) => e(i, this.eBottom), setTopDisplay: (i) => this.eTop.style.display = i, setBottomDisplay: (i) => this.eBottom.style.display = i, setStickyTopHeight: (i) => this.eStickyTop.style.height = i, setStickyTopTop: (i) => this.eStickyTop.style.top = i, setStickyTopWidth: (i) => this.eStickyTop.style.width = i, setStickyBottomHeight: (i) => this.eStickyBottom.style.height = i, setStickyBottomBottom: (i) => this.eStickyBottom.style.bottom = i, setStickyBottomWidth: (i) => this.eStickyBottom.style.width = i, setColumnMovingCss: (i, o) => this.addOrRemoveCssClass(i, o), updateLayoutClasses: (i, o) => {
      [this.eBodyViewport.classList, this.eBody.classList].forEach((s) => {
        s.toggle("ag-layout-auto-height", o.autoHeight), s.toggle("ag-layout-normal", o.normal), s.toggle("ag-layout-print", o.print);
      }), this.addOrRemoveCssClass("ag-layout-auto-height", o.autoHeight), this.addOrRemoveCssClass("ag-layout-normal", o.normal), this.addOrRemoveCssClass("ag-layout-print", o.print);
    }, setAlwaysVerticalScrollClass: (i, o) => this.eBodyViewport.classList.toggle(br, o), registerBodyViewportResizeListener: (i) => {
      const o = this.resizeObserverService.observeResize(this.eBodyViewport, i);
      this.addDestroyFunc(() => o());
    }, setPinnedTopBottomOverflowY: (i) => this.eTop.style.overflowY = this.eBottom.style.overflowY = i, setCellSelectableCss: (i, o) => {
      [this.eTop, this.eBodyViewport, this.eBottom].forEach((s) => s.classList.toggle(i, o));
    }, setBodyViewportWidth: (i) => this.eBodyViewport.style.width = i };
    this.ctrl = this.createManagedBean(new Ya()), this.ctrl.setComp(t, this.getGui(), this.eBodyViewport, this.eTop, this.eBottom, this.eStickyTop, this.eStickyBottom), (this.rangeService && this.gos.get("enableRangeSelection") || this.gos.get("rowSelection") === "multiple") && de(this.getGui(), "multiselectable", !0);
  }
  setRowAnimationCssOnBodyViewport(e, t) {
    const i = this.eBodyViewport.classList;
    i.toggle("ag-row-animation", t), i.toggle("ag-row-no-animation", !t);
  }
  getFloatingTopBottom() {
    return [this.eTop, this.eBottom];
  }
} }, yl = class extends f {
  constructor() {
    super(...arguments), this.beanName = "scrollVisibleService";
  }
  wireBeans(e) {
    this.ctrlsService = e.ctrlsService, this.columnAnimationService = e.columnAnimationService;
  }
  postConstruct() {
    this.addManagedEventListeners({ displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this), displayedColumnsWidthChanged: this.onDisplayedColumnsWidthChanged.bind(this) });
  }
  onDisplayedColumnsChanged() {
    this.update();
  }
  onDisplayedColumnsWidthChanged() {
    this.update();
  }
  update() {
    this.columnAnimationService.isActive() ? this.columnAnimationService.executeLaterVMTurn(() => {
      this.columnAnimationService.executeLaterVMTurn(() => this.updateImpl());
    }) : this.updateImpl();
  }
  updateImpl() {
    const e = this.ctrlsService.get("center");
    if (!e || this.columnAnimationService.isActive())
      return;
    const t = { horizontalScrollShowing: e.isHorizontalScrollShowing(), verticalScrollShowing: this.isVerticalScrollShowing() };
    this.setScrollsVisible(t);
  }
  setScrollsVisible(e) {
    if (this.horizontalScrollShowing !== e.horizontalScrollShowing || this.verticalScrollShowing !== e.verticalScrollShowing) {
      this.horizontalScrollShowing = e.horizontalScrollShowing, this.verticalScrollShowing = e.verticalScrollShowing;
      const t = { type: "scrollVisibilityChanged" };
      this.eventService.dispatchEvent(t);
    }
  }
  isHorizontalScrollShowing() {
    return this.horizontalScrollShowing;
  }
  isVerticalScrollShowing() {
    return this.verticalScrollShowing;
  }
}, Vo = "__ag_grid_instance", Dr = class Mr extends f {
  constructor() {
    super(...arguments), this.beanName = "mouseEventService", this.gridInstanceId = Mr.gridInstanceSequence.next();
  }
  wireBeans(t) {
    this.ctrlsService = t.ctrlsService;
  }
  stampTopLevelGridCompWithGridInstance(t) {
    t[Vo] = this.gridInstanceId;
  }
  getRenderedCellForEvent(t) {
    return Di(this.gos, t.target, Ue.DOM_DATA_KEY_CELL_CTRL);
  }
  isEventFromThisGrid(t) {
    return this.isElementInThisGrid(t.target);
  }
  isElementInThisGrid(t) {
    let i = t;
    for (; i; ) {
      const o = i[Vo];
      if (S(o))
        return o === this.gridInstanceId;
      i = i.parentElement;
    }
    return !1;
  }
  getCellPositionForEvent(t) {
    const i = this.getRenderedCellForEvent(t);
    return i ? i.getCellPosition() : null;
  }
  getNormalisedPosition(t) {
    const i = this.gos.isDomLayout("normal"), o = t;
    let s, r;
    if (o.clientX != null || o.clientY != null ? (s = o.clientX, r = o.clientY) : (s = o.x, r = o.y), i) {
      const n = this.ctrlsService.getGridBodyCtrl(), a = n.getScrollFeature().getVScrollPosition();
      s += n.getScrollFeature().getHScrollPosition().left, r += a.top;
    }
    return { x: s, y: r };
  }
};
Dr.gridInstanceSequence = new ct();
var Sl = Dr, Rl = class extends f {
  constructor() {
    super(), this.beanName = "navigationService", this.onPageDown = ko(this.onPageDown, 100), this.onPageUp = ko(this.onPageUp, 100);
  }
  wireBeans(e) {
    this.mouseEventService = e.mouseEventService, this.pageBoundsService = e.pageBoundsService, this.focusService = e.focusService, this.columnModel = e.columnModel, this.visibleColsService = e.visibleColsService, this.rowModel = e.rowModel, this.ctrlsService = e.ctrlsService, this.rowRenderer = e.rowRenderer, this.headerNavigationService = e.headerNavigationService, this.rowPositionUtils = e.rowPositionUtils, this.cellNavigationService = e.cellNavigationService, this.pinnedRowModel = e.pinnedRowModel, this.rangeService = e.rangeService;
  }
  postConstruct() {
    this.ctrlsService.whenReady((e) => {
      this.gridBodyCon = e.gridBodyCtrl;
    });
  }
  handlePageScrollingKey(e, t = !1) {
    const i = e.key, o = e.altKey, s = e.ctrlKey || e.metaKey, r = !!this.rangeService && e.shiftKey, n = this.mouseEventService.getCellPositionForEvent(e);
    let a = !1;
    switch (i) {
      case v.PAGE_HOME:
      case v.PAGE_END:
        s || o || (this.onHomeOrEndKey(i), a = !0);
        break;
      case v.LEFT:
      case v.RIGHT:
      case v.UP:
      case v.DOWN:
        if (!n)
          return !1;
        !s || o || r || (this.onCtrlUpDownLeftRight(i, n), a = !0);
        break;
      case v.PAGE_DOWN:
      case v.PAGE_UP:
        s || o || (a = this.handlePageUpDown(i, n, t));
    }
    return a && e.preventDefault(), a;
  }
  handlePageUpDown(e, t, i) {
    return i && (t = this.focusService.getFocusedCell()), !!t && (e === v.PAGE_UP ? this.onPageUp(t) : this.onPageDown(t), !0);
  }
  navigateTo(e) {
    var n;
    const { scrollIndex: t, scrollType: i, scrollColumn: o, focusIndex: s, focusColumn: r } = e;
    S(o) && !o.isPinned() && this.gridBodyCon.getScrollFeature().ensureColumnVisible(o), S(t) && this.gridBodyCon.getScrollFeature().ensureIndexVisible(t, i), e.isAsync || this.gridBodyCon.getScrollFeature().ensureIndexVisible(s), this.focusService.setFocusedCell({ rowIndex: s, column: r, rowPinned: null, forceBrowserFocus: !0 }), (n = this.rangeService) == null || n.setRangeToCell({ rowIndex: s, rowPinned: null, column: r });
  }
  onPageDown(e) {
    const t = this.ctrlsService.getGridBodyCtrl().getScrollFeature().getVScrollPosition(), i = this.getViewportHeight(), o = this.pageBoundsService.getPixelOffset(), s = t.top + i, r = this.rowModel.getRowIndexAtPixel(s + o);
    this.columnModel.isAutoRowHeightActive() ? this.navigateToNextPageWithAutoHeight(e, r) : this.navigateToNextPage(e, r);
  }
  onPageUp(e) {
    const t = this.ctrlsService.getGridBodyCtrl().getScrollFeature().getVScrollPosition(), i = this.pageBoundsService.getPixelOffset(), o = t.top, s = this.rowModel.getRowIndexAtPixel(o + i);
    this.columnModel.isAutoRowHeightActive() ? this.navigateToNextPageWithAutoHeight(e, s, !0) : this.navigateToNextPage(e, s, !0);
  }
  navigateToNextPage(e, t, i = !1) {
    const o = this.getViewportHeight(), s = this.pageBoundsService.getFirstRow(), r = this.pageBoundsService.getLastRow(), n = this.pageBoundsService.getPixelOffset(), a = this.rowModel.getRow(e.rowIndex), l = i ? (a == null ? void 0 : a.rowHeight) - o - n : o - n, d = (a == null ? void 0 : a.rowTop) + l;
    let c, h = this.rowModel.getRowIndexAtPixel(d + n);
    if (h === e.rowIndex) {
      const g = i ? -1 : 1;
      t = h = e.rowIndex + g;
    }
    i ? (c = "bottom", h < s && (h = s), t < s && (t = s)) : (c = "top", h > r && (h = r), t > r && (t = r)), this.isRowTallerThanView(h) && (t = h, c = "top"), this.navigateTo({ scrollIndex: t, scrollType: c, scrollColumn: null, focusIndex: h, focusColumn: e.column });
  }
  navigateToNextPageWithAutoHeight(e, t, i = !1) {
    this.navigateTo({ scrollIndex: t, scrollType: i ? "bottom" : "top", scrollColumn: null, focusIndex: t, focusColumn: e.column }), setTimeout(() => {
      const o = this.getNextFocusIndexForAutoHeight(e, i);
      this.navigateTo({ scrollIndex: t, scrollType: i ? "bottom" : "top", scrollColumn: null, focusIndex: o, focusColumn: e.column, isAsync: !0 });
    }, 50);
  }
  getNextFocusIndexForAutoHeight(e, t = !1) {
    const i = t ? -1 : 1, o = this.getViewportHeight(), s = this.pageBoundsService.getLastRow();
    let r = 0, n = e.rowIndex;
    for (; n >= 0 && n <= s; ) {
      const a = this.rowModel.getRow(n);
      if (a) {
        const l = a.rowHeight ?? 0;
        if (r + l > o)
          break;
        r += l;
      }
      n += i;
    }
    return Math.max(0, Math.min(n, s));
  }
  getViewportHeight() {
    const { gridBodyCtrl: e, center: t } = this.ctrlsService.getParams(), i = e.getScrollFeature().getVScrollPosition(), o = this.gos.getScrollbarWidth();
    let s = i.bottom - i.top;
    return t.isHorizontalScrollShowing() && (s -= o), s;
  }
  isRowTallerThanView(e) {
    const t = this.rowModel.getRow(e);
    if (!t)
      return !1;
    const i = t.rowHeight;
    return typeof i == "number" && i > this.getViewportHeight();
  }
  onCtrlUpDownLeftRight(e, t) {
    const i = this.cellNavigationService.getNextCellToFocus(e, t, !0), { rowIndex: o } = i, s = i.column;
    this.navigateTo({ scrollIndex: o, scrollType: null, scrollColumn: s, focusIndex: o, focusColumn: s });
  }
  onHomeOrEndKey(e) {
    const t = e === v.PAGE_HOME, i = this.visibleColsService.getAllCols(), o = t ? i[0] : T(i), s = t ? this.pageBoundsService.getFirstRow() : this.pageBoundsService.getLastRow();
    this.navigateTo({ scrollIndex: s, scrollType: null, scrollColumn: o, focusIndex: s, focusColumn: o });
  }
  onTabKeyDown(e, t) {
    const i = t.shiftKey, o = this.tabToNextCellCommon(e, i, t);
    if (o === !1)
      if (i) {
        const { rowIndex: s, rowPinned: r } = e.getRowPosition();
        (r ? s === 0 : s === this.pageBoundsService.getFirstRow()) && (this.gos.get("headerHeight") === 0 || this.gos.get("suppressHeaderFocus") ? this.focusService.focusNextGridCoreContainer(!0, !0) : (t.preventDefault(), this.focusService.focusPreviousFromFirstCell(t)));
      } else
        e instanceof Ue && e.focusCell(!0), this.focusService.focusNextGridCoreContainer(i) && t.preventDefault();
    else
      o && t.preventDefault();
  }
  tabToNextCell(e, t) {
    const i = this.focusService.getFocusedCell();
    if (!i)
      return !1;
    let o = this.getCellByPosition(i);
    return !!(o || (o = this.rowRenderer.getRowByPosition(i), o && o.isFullWidth())) && !!this.tabToNextCellCommon(o, e, t);
  }
  tabToNextCellCommon(e, t, i) {
    let o, s = e.isEditing();
    if (!s && e instanceof Ue) {
      const r = e.getRowCtrl();
      r && (s = r.isEditing());
    }
    return o = s ? this.gos.get("editType") === "fullRow" ? this.moveToNextEditingRow(e, t, i) : this.moveToNextEditingCell(e, t, i) : this.moveToNextCellNotEditing(e, t), o === null ? o : o || !!this.focusService.getFocusedHeader();
  }
  moveToNextEditingCell(e, t, i = null) {
    const o = e.getCellPosition();
    e.getGui().focus(), e.stopEditing();
    const s = this.findNextCellToFocusOn(o, t, !0);
    return s === !1 ? null : s != null && (s.startEditing(null, !0, i), s.focusCell(!1), !0);
  }
  moveToNextEditingRow(e, t, i = null) {
    const o = e.getCellPosition(), s = this.findNextCellToFocusOn(o, t, !0);
    if (s === !1)
      return null;
    if (s == null)
      return !1;
    const r = s.getCellPosition(), n = this.isCellEditable(o), a = this.isCellEditable(r), l = r && o.rowIndex === r.rowIndex && o.rowPinned === r.rowPinned;
    return n && e.setFocusOutOnEditor(), l || (e.getRowCtrl().stopEditing(), s.getRowCtrl().startRowEditing(void 0, void 0, i)), a ? (s.setFocusInOnEditor(), s.focusCell()) : s.focusCell(!0), !0;
  }
  moveToNextCellNotEditing(e, t) {
    const i = this.visibleColsService.getAllCols();
    let o;
    o = e instanceof je ? { ...e.getRowPosition(), column: t ? i[0] : T(i) } : e.getCellPosition();
    const s = this.findNextCellToFocusOn(o, t, !1);
    if (s === !1)
      return null;
    if (s instanceof Ue)
      s.focusCell(!0);
    else if (s)
      return this.tryToFocusFullWidthRow(s.getRowPosition(), t);
    return S(s);
  }
  findNextCellToFocusOn(e, t, i) {
    var s;
    let o = e;
    for (; ; ) {
      e !== o && (e = o), t || (o = this.getLastCellOfColSpan(o)), o = this.cellNavigationService.getNextTabbedCell(o, t);
      const r = this.gos.getCallback("tabToNextCell");
      if (S(r)) {
        const l = r({ backwards: t, editing: i, previousCellPosition: e, nextCellPosition: o || null });
        if (l === !0 || l === null)
          l === null && b("Returning `null` from tabToNextCell is deprecated. Return `true` to stay on the current cell, or `false` to let the browser handle the tab behaviour."), o = e;
        else {
          if (l === !1)
            return !1;
          o = { rowIndex: l.rowIndex, column: l.column, rowPinned: l.rowPinned };
        }
      }
      if (!o)
        return null;
      if (o.rowIndex < 0) {
        const l = this.headerNavigationService.getHeaderRowCount();
        return this.focusService.focusHeaderPosition({ headerPosition: { headerRowIndex: l + o.rowIndex, column: o.column }, fromCell: !0 }), null;
      }
      const n = this.gos.get("editType") === "fullRow";
      if (i && !n && !this.isCellEditable(o))
        continue;
      this.ensureCellVisible(o);
      const a = this.getCellByPosition(o);
      if (!a) {
        const l = this.rowRenderer.getRowByPosition(o);
        if (!l || !l.isFullWidth() || i)
          continue;
        return l;
      }
      if (!a.isSuppressNavigable())
        return (s = this.rangeService) == null || s.setRangeToCell(o), a;
    }
  }
  isCellEditable(e) {
    const t = this.lookupRowNodeForCell(e);
    return !!t && e.column.isCellEditable(t);
  }
  getCellByPosition(e) {
    const t = this.rowRenderer.getRowByPosition(e);
    return t ? t.getCellCtrl(e.column) : null;
  }
  lookupRowNodeForCell(e) {
    return e.rowPinned === "top" ? this.pinnedRowModel.getPinnedTopRow(e.rowIndex) : e.rowPinned === "bottom" ? this.pinnedRowModel.getPinnedBottomRow(e.rowIndex) : this.rowModel.getRow(e.rowIndex);
  }
  navigateToNextCell(e, t, i, o) {
    let s = i, r = !1;
    for (; s && (s === i || !this.isValidNavigateCell(s)); )
      this.gos.get("enableRtl") ? t === v.LEFT && (s = this.getLastCellOfColSpan(s)) : t === v.RIGHT && (s = this.getLastCellOfColSpan(s)), s = this.cellNavigationService.getNextCellToFocus(t, s), r = A(s);
    if (r && e && e.key === v.UP && (s = { rowIndex: -1, rowPinned: null, column: i.column }), o) {
      const a = this.gos.getCallback("navigateToNextCell");
      if (S(a)) {
        const l = a({ key: t, previousCellPosition: i, nextCellPosition: s || null, event: e });
        s = S(l) ? { rowPinned: l.rowPinned, rowIndex: l.rowIndex, column: l.column } : null;
      }
    }
    if (!s)
      return;
    if (s.rowIndex < 0) {
      const a = this.headerNavigationService.getHeaderRowCount();
      return void this.focusService.focusHeaderPosition({ headerPosition: { headerRowIndex: a + s.rowIndex, column: i.column }, event: e || void 0, fromCell: !0 });
    }
    const n = this.getNormalisedPosition(s);
    n ? this.focusPosition(n) : this.tryToFocusFullWidthRow(s);
  }
  getNormalisedPosition(e) {
    this.ensureCellVisible(e);
    const t = this.getCellByPosition(e);
    return t ? (e = t.getCellPosition(), this.ensureCellVisible(e), e) : null;
  }
  tryToFocusFullWidthRow(e, t = !1) {
    const i = this.visibleColsService.getAllCols(), o = this.rowRenderer.getRowByPosition(e);
    if (!o || !o.isFullWidth())
      return !1;
    const s = this.focusService.getFocusedCell(), r = { rowIndex: e.rowIndex, rowPinned: e.rowPinned, column: e.column || (t ? T(i) : i[0]) };
    this.focusPosition(r);
    const n = s != null && this.rowPositionUtils.before(r, s), a = { type: "fullWidthRowFocused", rowIndex: r.rowIndex, rowPinned: r.rowPinned, column: r.column, isFullWidthCell: !0, fromBelow: n };
    return this.eventService.dispatchEvent(a), !0;
  }
  focusPosition(e) {
    var t;
    this.focusService.setFocusedCell({ rowIndex: e.rowIndex, column: e.column, rowPinned: e.rowPinned, forceBrowserFocus: !0 }), (t = this.rangeService) == null || t.setRangeToCell(e);
  }
  isValidNavigateCell(e) {
    return !!this.rowPositionUtils.getRowNode(e);
  }
  getLastCellOfColSpan(e) {
    const t = this.getCellByPosition(e);
    if (!t)
      return e;
    const i = t.getColSpanningList();
    return i.length === 1 ? e : { rowIndex: e.rowIndex, column: T(i), rowPinned: e.rowPinned };
  }
  ensureCellVisible(e) {
    const t = this.gos.isGroupRowsSticky(), i = this.rowModel.getRow(e.rowIndex);
    !(t && (i != null && i.sticky)) && A(e.rowPinned) && this.gridBodyCon.getScrollFeature().ensureIndexVisible(e.rowIndex), e.column.isPinned() || this.gridBodyCon.getScrollFeature().ensureColumnVisible(e.column);
  }
}, xl = class extends f {
  constructor() {
    super(...arguments), this.beanName = "horizontalResizeService";
  }
  wireBeans(e) {
    this.dragService = e.dragService, this.ctrlsService = e.ctrlsService;
  }
  addResizeBar(e) {
    const t = { dragStartPixels: e.dragStartPixels || 0, eElement: e.eResizeBar, onDragStart: this.onDragStart.bind(this, e), onDragStop: this.onDragStop.bind(this, e), onDragging: this.onDragging.bind(this, e), includeTouch: !0, stopPropagationForTouch: !0 };
    return this.dragService.addDragSource(t), () => this.dragService.removeDragSource(t);
  }
  onDragStart(e, t) {
    this.dragStartX = t.clientX, this.setResizeIcons();
    const i = t instanceof MouseEvent && t.shiftKey === !0;
    e.onResizeStart(i);
  }
  setResizeIcons() {
    const e = this.ctrlsService.get("gridCtrl");
    e.setResizeCursor(!0), e.disableUserSelect(!0);
  }
  onDragStop(e, t) {
    e.onResizeEnd(this.resizeAmount), this.resetIcons();
  }
  resetIcons() {
    const e = this.ctrlsService.get("gridCtrl");
    e.setResizeCursor(!1), e.disableUserSelect(!1);
  }
  onDragging(e, t) {
    this.resizeAmount = t.clientX - this.dragStartX, e.onResizing(this.resizeAmount);
  }
}, Fl = class extends f {
  constructor() {
    super(...arguments), this.beanName = "filterMenuFactory";
  }
  wireBeans(e) {
    this.popupService = e.popupService, this.focusService = e.focusService, this.ctrlsService = e.ctrlsService, this.menuService = e.menuService;
  }
  hideActiveMenu() {
    this.hidePopup && this.hidePopup();
  }
  showMenuAfterMouseEvent(e, t, i) {
    this.showPopup(e, (o) => {
      this.popupService.positionPopupUnderMouseEvent({ column: e, type: i, mouseEvent: t, ePopup: o });
    }, i, t.target, this.menuService.isLegacyMenuEnabled());
  }
  showMenuAfterButtonClick(e, t, i) {
    let o = -1, s = "left";
    const r = this.menuService.isLegacyMenuEnabled();
    !r && this.gos.get("enableRtl") && (o = 1, s = "right");
    const n = r ? void 0 : 4 * o, a = r ? void 0 : 4;
    this.showPopup(e, (l) => {
      this.popupService.positionPopupByComponent({ type: i, eventSource: t, ePopup: l, nudgeX: n, nudgeY: a, alignSide: s, keepWithinBounds: !0, position: "under", column: e });
    }, i, t, r);
  }
  showPopup(e, t, i, o, s) {
    const r = e ? this.createBean(new aa(e, "COLUMN_MENU")) : void 0;
    if (this.activeMenu = r, !(r != null && r.hasFilter()) || !e)
      throw new Error("AG Grid - unable to show popup filter, filter instantiation failed");
    const n = document.createElement("div");
    let a;
    X(n, "presentation"), n.classList.add("ag-menu"), s || n.classList.add("ag-filter-menu"), [this.tabListener] = this.addManagedElementListeners(n, { keydown: (g) => this.trapFocusWithin(g, n) }), n.appendChild(r == null ? void 0 : r.getGui());
    const l = this.menuService.isColumnMenuAnchoringEnabled() ? o ?? this.ctrlsService.getGridBodyCtrl().getGui() : void 0, d = this.localeService.getLocaleTextFunc(), c = s && i !== "columnFilter" ? d("ariaLabelColumnMenu", "Column Menu") : d("ariaLabelColumnFilter", "Column Filter"), h = this.popupService.addPopup({ modal: !0, eChild: n, closeOnEsc: !0, closedCallback: (g) => {
      e.setMenuVisible(!1, "contextMenu");
      const u = g instanceof KeyboardEvent;
      if (this.tabListener && (this.tabListener = this.tabListener()), u && o && he(o)) {
        const p = this.focusService.findTabbableParent(o);
        p && p.focus();
      }
      r == null || r.afterGuiDetached(), this.destroyBean(this.activeMenu), this.dispatchVisibleChangedEvent(!1, i, e);
    }, positionCallback: () => t(n), anchorToElement: l, ariaLabel: c });
    h && (this.hidePopup = a = h.hideFunc), r.afterInit().then(() => {
      t(n), r.afterGuiAttached({ container: i, hidePopup: a });
    }), e.setMenuVisible(!0, "contextMenu"), this.dispatchVisibleChangedEvent(!0, i, e);
  }
  trapFocusWithin(e, t) {
    e.key !== v.TAB || e.defaultPrevented || this.focusService.findNextFocusableElement(t, !1, e.shiftKey) || (e.preventDefault(), this.focusService.focusInto(t, e.shiftKey));
  }
  dispatchVisibleChangedEvent(e, t, i) {
    const o = { type: "columnMenuVisibleChanged", visible: e, switchingTab: !1, key: t, column: i ?? null };
    this.eventService.dispatchEvent(o);
  }
  isMenuEnabled(e) {
    return e.isFilterAllowed() && (e.getColDef().menuTabs ?? ["filterMenuTab"]).includes("filterMenuTab");
  }
  showMenuAfterContextMenuEvent() {
  }
  destroy() {
    this.destroyBean(this.activeMenu), super.destroy();
  }
}, Dl = class extends f {
  constructor() {
    super(...arguments), this.beanName = "resizeObserverService", this.polyfillFunctions = [];
  }
  observeResize(e, t) {
    const i = this.gos.getWindow(), o = () => {
      let r = (e == null ? void 0 : e.clientWidth) ?? 0, n = (e == null ? void 0 : e.clientHeight) ?? 0, a = !0;
      const l = () => {
        if (a) {
          const d = (e == null ? void 0 : e.clientWidth) ?? 0, c = (e == null ? void 0 : e.clientHeight) ?? 0;
          (d !== r || c !== n) && (r = d, n = c, t()), this.doNextPolyfillTurn(l);
        }
      };
      return l(), () => a = !1;
    }, s = this.gos.get("suppressBrowserResizeObserver");
    return i.ResizeObserver && !s ? (() => {
      const r = new i.ResizeObserver(t);
      return r.observe(e), () => r.disconnect();
    })() : this.getFrameworkOverrides().wrapIncoming(() => o(), "resize-observer");
  }
  doNextPolyfillTurn(e) {
    this.polyfillFunctions.push(e), this.schedulePolyfill();
  }
  schedulePolyfill() {
    this.polyfillScheduled || (this.polyfillScheduled = !0, window.setTimeout(() => {
      const e = this.polyfillFunctions;
      this.polyfillScheduled = !1, this.polyfillFunctions = [], e.forEach((t) => t());
    }, 50));
  }
}, Ml = class extends f {
  constructor() {
    super(...arguments), this.beanName = "animationFrameService", this.createTasksP1 = { list: [], sorted: !1 }, this.createTasksP2 = { list: [], sorted: !1 }, this.destroyTasks = [], this.ticking = !1, this.scrollGoingDown = !0, this.lastPage = 0, this.lastScrollTop = 0, this.taskCount = 0, this.cancelledTasks = /* @__PURE__ */ new Set();
  }
  wireBeans(e) {
    this.ctrlsService = e.ctrlsService, this.paginationService = e.paginationService;
  }
  setScrollTop(e) {
    var i;
    const t = this.gos.get("pagination");
    if (this.scrollGoingDown = e >= this.lastScrollTop, t && e === 0) {
      const o = ((i = this.paginationService) == null ? void 0 : i.getCurrentPage()) ?? 0;
      o !== this.lastPage && (this.lastPage = o, this.scrollGoingDown = !0);
    }
    this.lastScrollTop = e;
  }
  postConstruct() {
    this.useAnimationFrame = !this.gos.get("suppressAnimationFrame");
  }
  isOn() {
    return this.useAnimationFrame;
  }
  verifyAnimationFrameOn(e) {
    this.useAnimationFrame === !1 && b(`AnimationFrameService.${e} called but animation frames are off`);
  }
  createTask(e, t, i) {
    this.verifyAnimationFrameOn(i);
    const o = { task: e, index: t, createOrder: ++this.taskCount };
    this.addTaskToList(this[i], o), this.schedule();
  }
  cancelTask(e) {
    this.cancelledTasks.add(e);
  }
  addTaskToList(e, t) {
    e.list.push(t), e.sorted = !1;
  }
  sortTaskList(e) {
    if (e.sorted)
      return;
    const t = this.scrollGoingDown ? 1 : -1;
    e.list.sort((i, o) => i.index !== o.index ? t * (o.index - i.index) : o.createOrder - i.createOrder), e.sorted = !0;
  }
  addDestroyTask(e) {
    this.verifyAnimationFrameOn("createTasksP3"), this.destroyTasks.push(e), this.schedule();
  }
  executeFrame(e) {
    this.verifyAnimationFrameOn("executeFrame");
    const t = this.createTasksP1, i = t.list, o = this.createTasksP2, s = o.list, r = this.destroyTasks, n = (/* @__PURE__ */ new Date()).getTime();
    let a = (/* @__PURE__ */ new Date()).getTime() - n;
    const l = e <= 0, d = this.ctrlsService.getGridBodyCtrl();
    for (; l || a < e; ) {
      if (!d.getScrollFeature().scrollGridIfNeeded()) {
        let c;
        if (i.length)
          this.sortTaskList(t), c = i.pop().task;
        else if (s.length)
          this.sortTaskList(o), c = s.pop().task;
        else {
          if (!r.length) {
            this.cancelledTasks.clear();
            break;
          }
          c = r.pop();
        }
        this.cancelledTasks.has(c) || c();
      }
      a = (/* @__PURE__ */ new Date()).getTime() - n;
    }
    i.length || s.length || r.length ? this.requestFrame() : this.stopTicking();
  }
  stopTicking() {
    this.ticking = !1;
  }
  flushAllFrames() {
    this.useAnimationFrame && this.executeFrame(-1);
  }
  schedule() {
    this.useAnimationFrame && (this.ticking || (this.ticking = !0, this.requestFrame()));
  }
  requestFrame() {
    const e = this.executeFrame.bind(this, 60);
    this.requestAnimationFrame(e);
  }
  requestAnimationFrame(e) {
    const t = this.gos.getWindow();
    t.requestAnimationFrame ? t.requestAnimationFrame(e) : t.webkitRequestAnimationFrame ? t.webkitRequestAnimationFrame(e) : t.setTimeout(e, 0);
  }
  isQueueEmpty() {
    return !this.ticking;
  }
  debounce(e) {
    let t = !1;
    return () => {
      this.isOn() ? t || (t = !0, this.addDestroyTask(() => {
        t = !1, e();
      })) : window.setTimeout(e, 0);
    };
  }
}, El = class extends f {
  constructor() {
    super(...arguments), this.beanName = "expansionService";
  }
  wireBeans(e) {
    this.rowModel = e.rowModel;
  }
  postConstruct() {
    this.isClientSideRowModel = this.rowModel.getType() === "clientSide";
  }
  expandRows(e) {
    if (!this.isClientSideRowModel)
      return;
    const t = new Set(e);
    this.rowModel.forEachNode((i) => {
      i.id && t.has(i.id) && (i.expanded = !0);
    }), this.onGroupExpandedOrCollapsed();
  }
  getExpandedRows() {
    const e = [];
    return this.rowModel.forEachNode(({ expanded: t, id: i }) => {
      t && i && e.push(i);
    }), e;
  }
  expandAll(e) {
    this.isClientSideRowModel && this.rowModel.expandOrCollapseAll(e);
  }
  setRowNodeExpanded(e, t, i, o) {
    e && (i && e.parent && e.parent.level !== -1 && this.setRowNodeExpanded(e.parent, t, i, o), e.setExpanded(t, void 0, o));
  }
  onGroupExpandedOrCollapsed() {
    this.isClientSideRowModel && this.rowModel.refreshModel({ step: "map" });
  }
}, Pl = class extends f {
  constructor() {
    super(...arguments), this.beanName = "menuService";
  }
  wireBeans(e) {
    this.filterMenuFactory = e.filterMenuFactory, this.ctrlsService = e.ctrlsService, this.animationFrameService = e.animationFrameService, this.filterManager = e.filterManager, this.rowRenderer = e.rowRenderer, this.columnChooserFactory = e.columnChooserFactory, this.contextMenuFactory = e.contextMenuFactory, this.enterpriseMenuFactory = e.enterpriseMenuFactory;
  }
  postConstruct() {
    this.activeMenuFactory = this.enterpriseMenuFactory ?? this.filterMenuFactory;
  }
  showColumnMenu(e) {
    this.showColumnMenuCommon(this.activeMenuFactory, e, "columnMenu");
  }
  showFilterMenu(e) {
    const t = this.enterpriseMenuFactory && this.isLegacyMenuEnabled() ? this.enterpriseMenuFactory : this.filterMenuFactory;
    this.showColumnMenuCommon(t, e, e.containerType, !0);
  }
  showHeaderContextMenu(e, t, i) {
    this.activeMenuFactory.showMenuAfterContextMenuEvent(e, t, i);
  }
  getContextMenuPosition(e, t) {
    const i = this.getRowCtrl(e), o = this.getCellGui(i, t);
    if (!o)
      return i ? { x: 0, y: i.getRowYPosition() } : { x: 0, y: 0 };
    const s = o.getBoundingClientRect();
    return { x: s.x + s.width / 2, y: s.y + s.height / 2 };
  }
  showContextMenu(e) {
    var r;
    const { rowNode: t } = e, i = e.column;
    let { anchorToElement: o, value: s } = e;
    t && i && s == null && (s = t.getValueFromValueService(i)), o == null && (o = this.getContextMenuAnchorElement(t, i)), (r = this.contextMenuFactory) == null || r.onContextMenu(e.mouseEvent ?? null, e.touchEvent ?? null, t ?? null, i ?? null, s, o);
  }
  showColumnChooser(e) {
    var t;
    (t = this.columnChooserFactory) == null || t.showColumnChooser(e);
  }
  hidePopupMenu() {
    var e;
    (e = this.contextMenuFactory) == null || e.hideActiveMenu(), this.activeMenuFactory.hideActiveMenu();
  }
  hideColumnChooser() {
    var e;
    (e = this.columnChooserFactory) == null || e.hideActiveColumnChooser();
  }
  isColumnMenuInHeaderEnabled(e) {
    const { suppressMenu: t, suppressHeaderMenuButton: i } = e.getColDef();
    return !(i ?? t) && this.activeMenuFactory.isMenuEnabled(e) && (this.isLegacyMenuEnabled() || !!this.enterpriseMenuFactory);
  }
  isFilterMenuInHeaderEnabled(e) {
    var t;
    return !e.getColDef().suppressHeaderFilterButton && !!((t = this.filterManager) != null && t.isFilterAllowed(e));
  }
  isHeaderContextMenuEnabled(e) {
    return !(e != null && e.getColDef().suppressHeaderContextMenu) && this.getColumnMenuType() === "new";
  }
  isHeaderMenuButtonAlwaysShowEnabled() {
    return this.isSuppressMenuHide();
  }
  isHeaderMenuButtonEnabled() {
    const e = !this.isSuppressMenuHide();
    return !(Oe() && e);
  }
  isHeaderFilterButtonEnabled(e) {
    return this.isFilterMenuInHeaderEnabled(e) && !this.isLegacyMenuEnabled() && !this.isFloatingFilterButtonDisplayed(e);
  }
  isFilterMenuItemEnabled(e) {
    var t;
    return !(!((t = this.filterManager) != null && t.isFilterAllowed(e)) || this.isLegacyMenuEnabled() || this.isFilterMenuInHeaderEnabled(e) || this.isFloatingFilterButtonDisplayed(e));
  }
  isColumnMenuAnchoringEnabled() {
    return !this.isLegacyMenuEnabled();
  }
  areAdditionalColumnMenuItemsEnabled() {
    return this.getColumnMenuType() === "new";
  }
  isLegacyMenuEnabled() {
    return this.getColumnMenuType() === "legacy";
  }
  isFloatingFilterButtonEnabled(e) {
    var o;
    const t = e.getColDef(), i = (o = t.floatingFilterComponentParams) == null ? void 0 : o.suppressFilterButton;
    return i != null && b("As of v31.1, 'colDef.floatingFilterComponentParams.suppressFilterButton' is deprecated. Use 'colDef.suppressFloatingFilterButton' instead."), t.suppressFloatingFilterButton == null ? !i : !t.suppressFloatingFilterButton;
  }
  getColumnMenuType() {
    return this.gos.get("columnMenu");
  }
  isFloatingFilterButtonDisplayed(e) {
    return !!e.getColDef().floatingFilter && this.isFloatingFilterButtonEnabled(e);
  }
  isSuppressMenuHide() {
    const e = this.gos.get("suppressMenuHide");
    return this.isLegacyMenuEnabled() ? !!this.gos.exists("suppressMenuHide") && e : e;
  }
  showColumnMenuCommon(e, t, i, o) {
    const { positionBy: s } = t, r = t.column;
    if (s === "button") {
      const { buttonElement: n } = t;
      e.showMenuAfterButtonClick(r, n, i, o);
    } else if (s === "mouse") {
      const { mouseEvent: n } = t;
      e.showMenuAfterMouseEvent(r, n, i, o);
    } else
      r && (this.ctrlsService.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(r, "auto"), this.animationFrameService.requestAnimationFrame(() => {
        const n = this.ctrlsService.getHeaderRowContainerCtrl(r.getPinned()).getHeaderCtrlForColumn(r);
        e.showMenuAfterButtonClick(r, n.getAnchorElementForMenu(o), i, !0);
      }));
  }
  getRowCtrl(e) {
    const { rowIndex: t, rowPinned: i } = e || {};
    if (t != null)
      return this.rowRenderer.getRowByPosition({ rowIndex: t, rowPinned: i }) || void 0;
  }
  getCellGui(e, t) {
    if (!e || !t)
      return;
    const i = e.getCellCtrl(t);
    return (i == null ? void 0 : i.getGui()) || void 0;
  }
  getContextMenuAnchorElement(e, t) {
    const i = this.ctrlsService.getGridBodyCtrl().getGridBodyElement(), o = this.getRowCtrl(e);
    return o ? this.getCellGui(o, t) || (o.isFullWidth() ? o.getFullWidthElement() : i) : i;
  }
}, kl = { selector: "AG-INPUT-TEXT-AREA", component: class extends ze {
  constructor(e) {
    super(e, "ag-text-area", null, "textarea");
  }
  setValue(e, t) {
    const i = super.setValue(e, t);
    return this.eInput.value = e, i;
  }
  setCols(e) {
    return this.eInput.cols = e, this;
  }
  setRows(e) {
    return this.eInput.rows = e, this;
  }
} }, Al = class extends nt {
  constructor(e) {
    super('<div class="ag-popup-editor" tabindex="-1"/>'), this.params = e;
  }
  postConstruct() {
    this.gos.setDomData(this.getGui(), "popupEditorWrapper", !0), this.addKeyDownListener();
  }
  addKeyDownListener() {
    const e = this.getGui(), t = this.params;
    this.addManagedElementListeners(e, { keydown: (i) => {
      Bi(this.gos, i, t.node, t.column, !0) || t.onKeyDown(i);
    } });
  }
}, qt = class extends nt {
  constructor(e) {
    super(`
            <div class="ag-cell-edit-wrapper">
                ${e.getTemplate()}
            </div>`, e.getAgComponents()), this.cellEditorInput = e, this.eInput = R;
  }
  init(e) {
    this.params = e;
    const t = this.eInput;
    let i;
    if (this.cellEditorInput.init(t, e), e.cellStartedEdit) {
      this.focusAfterAttached = !0;
      const o = e.eventKey;
      o === v.BACKSPACE || e.eventKey === v.DELETE ? i = "" : o && o.length === 1 ? i = o : (i = this.cellEditorInput.getStartValue(), o !== v.F2 && (this.highlightAllOnFocus = !0));
    } else
      this.focusAfterAttached = !1, i = this.cellEditorInput.getStartValue();
    i != null && t.setStartValue(i), this.addManagedElementListeners(t.getGui(), { keydown: (o) => {
      const { key: s } = o;
      s !== v.PAGE_UP && s !== v.PAGE_DOWN || o.preventDefault();
    } });
  }
  afterGuiAttached() {
    var o, s;
    const e = this.localeService.getLocaleTextFunc(), t = this.eInput;
    if (t.setInputAriaLabel(e("ariaInputEditor", "Input Editor")), !this.focusAfterAttached)
      return;
    Me() || t.getFocusableElement().focus();
    const i = t.getInputElement();
    this.highlightAllOnFocus ? i.select() : (s = (o = this.cellEditorInput).setCaret) == null || s.call(o);
  }
  focusIn() {
    const e = this.eInput, t = e.getFocusableElement(), i = e.getInputElement();
    t.focus(), i.select();
  }
  getValue() {
    return this.cellEditorInput.getValue();
  }
  isPopup() {
    return !1;
  }
}, Tl = class {
  getTemplate() {
    return '<ag-input-text-field class="ag-cell-editor" data-ref="eInput"></ag-input-text-field>';
  }
  getAgComponents() {
    return [ni];
  }
  init(e, t) {
    this.eInput = e, this.params = t, t.maxLength != null && e.setMaxLength(t.maxLength);
  }
  getValue() {
    const e = this.eInput.getValue();
    return S(e) || S(this.params.value) ? this.params.parseValue(e) : this.params.value;
  }
  getStartValue() {
    return this.params.useFormatter || this.params.column.getColDef().refData ? this.params.formatValue(this.params.value) : this.params.value;
  }
  setCaret() {
    const e = this.eInput.getValue(), t = S(e) && e.length || 0;
    t && this.eInput.getInputElement().setSelectionRange(t, t);
  }
}, Er = class extends qt {
  constructor() {
    super(new Tl());
  }
}, Il = class {
  getTemplate() {
    return '<ag-input-number-field class="ag-cell-editor" data-ref="eInput"></ag-input-number-field>';
  }
  getAgComponents() {
    return [ma];
  }
  init(e, t) {
    this.eInput = e, this.params = t, t.max != null && e.setMax(t.max), t.min != null && e.setMin(t.min), t.precision != null && e.setPrecision(t.precision), t.step != null && e.setStep(t.step);
    const i = e.getInputElement();
    t.preventStepping ? e.addManagedElementListeners(i, { keydown: this.preventStepping }) : t.showStepperButtons && i.classList.add("ag-number-field-input-stepper");
  }
  preventStepping(e) {
    e.key !== v.UP && e.key !== v.DOWN || e.preventDefault();
  }
  getValue() {
    const e = this.eInput.getValue();
    if (!S(e) && !S(this.params.value))
      return this.params.value;
    let t = this.params.parseValue(e);
    if (t == null)
      return t;
    if (typeof t == "string") {
      if (t === "")
        return null;
      t = Number(t);
    }
    return isNaN(t) ? null : t;
  }
  getStartValue() {
    return this.params.value;
  }
}, Pr = { selector: "AG-INPUT-DATE-FIELD", component: class extends Qe {
  constructor(e) {
    super(e, "ag-date-field", "date");
  }
  postConstruct() {
    super.postConstruct();
    const e = Me();
    this.addManagedListeners(this.eInput, { wheel: this.onWheel.bind(this), mousedown: () => {
      this.isDisabled() || e || this.eInput.focus();
    } }), this.eInput.step = "any";
  }
  onWheel(e) {
    this.gos.getActiveDomElement() === this.eInput && e.preventDefault();
  }
  setMin(e) {
    const t = e instanceof Date ? re(e ?? null, !1) ?? void 0 : e;
    return this.min === t || (this.min = t, Re(this.eInput, "min", t)), this;
  }
  setMax(e) {
    const t = e instanceof Date ? re(e ?? null, !1) ?? void 0 : e;
    return this.max === t || (this.max = t, Re(this.eInput, "max", t)), this;
  }
  setStep(e) {
    return this.step === e || (this.step = e, Re(this.eInput, "step", e)), this;
  }
  getDate() {
    if (this.eInput.validity.valid)
      return J(this.getValue()) ?? void 0;
  }
  setDate(e, t) {
    this.setValue(re(e ?? null, !1), t);
  }
} }, Ll = class {
  getTemplate() {
    return '<ag-input-date-field class="ag-cell-editor" data-ref="eInput"></ag-input-date-field>';
  }
  getAgComponents() {
    return [Pr];
  }
  init(e, t) {
    this.eInput = e, this.params = t, t.min != null && e.setMin(t.min), t.max != null && e.setMax(t.max), t.step != null && e.setStep(t.step);
  }
  getValue() {
    const e = this.eInput.getDate();
    return S(e) || S(this.params.value) ? e ?? null : this.params.value;
  }
  getStartValue() {
    const { value: e } = this.params;
    if (e instanceof Date)
      return re(e, !1);
  }
}, Ol = class {
  constructor(e) {
    this.getDataTypeService = e;
  }
  getTemplate() {
    return '<ag-input-date-field class="ag-cell-editor" data-ref="eInput"></ag-input-date-field>';
  }
  getAgComponents() {
    return [Pr];
  }
  init(e, t) {
    this.eInput = e, this.params = t, t.min != null && e.setMin(t.min), t.max != null && e.setMax(t.max), t.step != null && e.setStep(t.step);
  }
  getValue() {
    const e = this.formatDate(this.eInput.getDate());
    return S(e) || S(this.params.value) ? this.params.parseValue(e ?? "") : this.params.value;
  }
  getStartValue() {
    return re(this.parseDate(this.params.value ?? void 0) ?? null, !1);
  }
  parseDate(e) {
    const t = this.getDataTypeService();
    return t ? t.getDateParserFunction(this.params.column)(e) : J(e) ?? void 0;
  }
  formatDate(e) {
    const t = this.getDataTypeService();
    return t ? t.getDateFormatterFunction(this.params.column)(e) : re(e ?? null, !1) ?? void 0;
  }
}, wt = class {
  constructor(e) {
    this.cellValueChanges = e;
  }
}, Ri = class extends wt {
  constructor(e, t, i, o) {
    super(e), this.initialRange = t, this.finalRange = i, this.ranges = o;
  }
}, Wo = class {
  constructor(e) {
    this.actionStack = [], this.maxStackSize = e || 10, this.actionStack = new Array(this.maxStackSize);
  }
  pop() {
    return this.actionStack.pop();
  }
  push(e) {
    e.cellValueChanges && e.cellValueChanges.length > 0 && (this.actionStack.length === this.maxStackSize && this.actionStack.shift(), this.actionStack.push(e));
  }
  clear() {
    this.actionStack = [];
  }
  getCurrentStackSize() {
    return this.actionStack.length;
  }
};
function kr(e, t, i = "auto") {
  e.frameworkOverrides.wrapIncoming(() => e.ctrlsService.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(t, i), "ensureVisible");
}
function Ar(e, t, i) {
  e.frameworkOverrides.wrapIncoming(() => e.ctrlsService.getGridBodyCtrl().getScrollFeature().ensureIndexVisible(t, i), "ensureVisible");
}
var Be = { version: M, moduleName: "@ag-grid-community/edit-core", beans: [class extends f {
  constructor() {
    super(...arguments), this.beanName = "editService";
  }
  wireBeans(e) {
    this.navigationService = e.navigationService, this.userComponentFactory = e.userComponentFactory, this.valueService = e.valueService;
  }
  startEditing(e, t = null, i = !1, o = null) {
    const s = this.createCellEditorParams(e, t, i), r = e.getColumn().getColDef(), n = this.userComponentFactory.getCellEditorDetails(r, s), a = (n == null ? void 0 : n.popupFromSelector) != null ? n.popupFromSelector : !!r.cellEditorPopup, l = (n == null ? void 0 : n.popupPositionFromSelector) != null ? n.popupPositionFromSelector : r.cellEditorPopupPosition;
    e.setEditing(!0, n), e.getComp().setEditDetails(n, a, l, this.gos.get("reactiveCustomComponents"));
    const d = e.createEvent(o, "cellEditingStarted");
    this.eventService.dispatchEvent(d);
  }
  stopEditing(e, t) {
    const i = e.getComp(), { newValue: o, newValueExists: s } = this.takeValueFromCellEditor(t, i), r = e.getRowNode(), n = e.getColumn(), a = r.getValueFromValueService(n);
    let l = !1;
    s && (l = this.saveNewValue(e, a, o, r, n)), e.setEditing(!1, void 0), i.setEditDetails(), e.updateAndFormatValue(!1), e.refreshCell({ forceRefresh: !0, suppressFlash: !0 });
    const d = { ...e.createEvent(null, "cellEditingStopped"), oldValue: a, newValue: o, valueChanged: l };
    return this.eventService.dispatchEvent(d), l;
  }
  handleColDefChanged(e) {
    const t = e.getCellEditor();
    if (t != null && t.refresh) {
      const { eventKey: i, cellStartedEdit: o } = e.getEditCompDetails().params, s = this.createCellEditorParams(e, i, o), r = e.getColumn().getColDef(), n = this.userComponentFactory.getCellEditorDetails(r, s);
      t.refresh(n.params);
    }
  }
  setFocusOutOnEditor(e) {
    const t = e.getComp().getCellEditor();
    t && t.focusOut && t.focusOut();
  }
  setFocusInOnEditor(e) {
    const t = e.getComp().getCellEditor();
    t && t.focusIn ? t.focusIn() : e.focusCell(!0);
  }
  stopEditingAndFocus(e, t = !1, i = !1) {
    e.stopRowOrCellEdit(), e.focusCell(!0), t || this.navigateAfterEdit(i, e.getCellPosition());
  }
  createPopupEditorWrapper(e) {
    return new Al(e);
  }
  takeValueFromCellEditor(e, t) {
    const i = { newValueExists: !1 };
    if (e)
      return i;
    const o = t.getCellEditor();
    return o ? o.isCancelAfterEnd && o.isCancelAfterEnd() ? i : { newValue: o.getValue(), newValueExists: !0 } : i;
  }
  saveNewValue(e, t, i, o, s) {
    if (i === t)
      return !1;
    e.setSuppressRefreshCell(!0);
    const r = o.setDataValue(s, i, "edit");
    return e.setSuppressRefreshCell(!1), r;
  }
  createCellEditorParams(e, t, i) {
    const o = e.getColumn(), s = e.getRowNode();
    return this.gos.addGridCommonParams({ value: s.getValueFromValueService(o), eventKey: t, column: o, colDef: o.getColDef(), rowIndex: e.getCellPosition().rowIndex, node: s, data: s.data, cellStartedEdit: i, onKeyDown: e.onKeyDown.bind(e), stopEditing: e.stopEditingAndFocus.bind(e), eGridCell: e.getGui(), parseValue: (r) => this.valueService.parseValue(o, s, r, e.getValue()), formatValue: e.formatValue.bind(e) });
  }
  navigateAfterEdit(e, t) {
    if (this.gos.get("enterNavigatesVerticallyAfterEdit")) {
      const i = e ? v.UP : v.DOWN;
      this.navigationService.navigateToNextCell(null, i, t, !1);
    }
  }
}] }, Nl = { version: M, moduleName: "@ag-grid-community/edit-api", apiFunctions: { undoCellEditing: function(e) {
  var t;
  (t = e.undoRedoService) == null || t.undo("api");
}, redoCellEditing: function(e) {
  var t;
  (t = e.undoRedoService) == null || t.redo("api");
}, getCellEditorInstances: function(e, t = {}) {
  return e.rowRenderer.getCellEditorInstances(t).map(St);
}, getEditingCells: function(e) {
  return e.rowRenderer.getEditingCells();
}, stopEditing: function(e, t = !1) {
  e.rowRenderer.stopEditing(t);
}, startEditingCell: function(e, t) {
  const i = e.columnModel.getCol(t.colKey);
  if (!i)
    return void b(`no column found for ${t.colKey}`);
  const o = { rowIndex: t.rowIndex, rowPinned: t.rowPinned || null, column: i };
  t.rowPinned == null && Ar(e, t.rowIndex), kr(e, t.colKey);
  const s = e.navigationService.getCellByPosition(o);
  s && (e.focusService.isCellFocused(o) || e.focusService.setFocusedCell(o), s.startRowOrCellEdit(t.key));
}, getCurrentUndoSize: function(e) {
  var t;
  return ((t = e.undoRedoService) == null ? void 0 : t.getCurrentUndoStackSize()) ?? 0;
}, getCurrentRedoSize: function(e) {
  var t;
  return ((t = e.undoRedoService) == null ? void 0 : t.getCurrentRedoStackSize()) ?? 0;
} }, dependantModules: [Be] }, Gl = { version: M, moduleName: "@ag-grid-community/undo-redo-edit", beans: [class extends f {
  constructor() {
    super(...arguments), this.beanName = "undoRedoService", this.cellValueChanges = [], this.activeCellEdit = null, this.activeRowEdit = null, this.isPasting = !1, this.isRangeInAction = !1, this.onCellValueChanged = (e) => {
      const t = { column: e.column, rowIndex: e.rowIndex, rowPinned: e.rowPinned }, i = this.activeCellEdit !== null && this.cellPositionUtils.equals(this.activeCellEdit, t), o = this.activeRowEdit !== null && this.rowPositionUtils.sameRow(this.activeRowEdit, t);
      if (!(i || o || this.isPasting || this.isRangeInAction))
        return;
      const { rowPinned: s, rowIndex: r, column: n, oldValue: a, value: l } = e, d = { rowPinned: s, rowIndex: r, columnId: n.getColId(), newValue: l, oldValue: a };
      this.cellValueChanges.push(d);
    }, this.clearStacks = () => {
      this.undoStack.clear(), this.redoStack.clear();
    };
  }
  wireBeans(e) {
    this.focusService = e.focusService, this.ctrlsService = e.ctrlsService, this.cellPositionUtils = e.cellPositionUtils, this.rowPositionUtils = e.rowPositionUtils, this.columnModel = e.columnModel, this.rangeService = e.rangeService;
  }
  postConstruct() {
    if (!this.gos.get("undoRedoCellEditing"))
      return;
    const e = this.gos.get("undoRedoCellEditingLimit");
    if (e <= 0)
      return;
    this.undoStack = new Wo(e), this.redoStack = new Wo(e), this.addListeners();
    const t = this.clearStacks.bind(this);
    this.addManagedEventListeners({ cellValueChanged: this.onCellValueChanged.bind(this), modelUpdated: (i) => {
      i.keepUndoRedoStack || this.clearStacks();
    }, columnPivotModeChanged: t, newColumnsLoaded: t, columnGroupOpened: t, columnRowGroupChanged: t, columnMoved: t, columnPinned: t, columnVisible: t, rowDragEnd: t }), this.ctrlsService.whenReady((i) => {
      this.gridBodyCtrl = i.gridBodyCtrl;
    });
  }
  getCurrentUndoStackSize() {
    return this.undoStack ? this.undoStack.getCurrentStackSize() : 0;
  }
  getCurrentRedoStackSize() {
    return this.redoStack ? this.redoStack.getCurrentStackSize() : 0;
  }
  undo(e) {
    const t = { type: "undoStarted", source: e };
    this.eventService.dispatchEvent(t);
    const i = { type: "undoEnded", source: e, operationPerformed: this.undoRedo(this.undoStack, this.redoStack, "initialRange", "oldValue", "undo") };
    this.eventService.dispatchEvent(i);
  }
  redo(e) {
    const t = { type: "redoStarted", source: e };
    this.eventService.dispatchEvent(t);
    const i = { type: "redoEnded", source: e, operationPerformed: this.undoRedo(this.redoStack, this.undoStack, "finalRange", "newValue", "redo") };
    this.eventService.dispatchEvent(i);
  }
  undoRedo(e, t, i, o, s) {
    if (!e)
      return !1;
    const r = e.pop();
    return !(!r || !r.cellValueChanges || (this.processAction(r, (n) => n[o], s), r instanceof Ri ? this.processRange(this.rangeService, r.ranges || [r[i]]) : this.processCell(r.cellValueChanges), t.push(r), 0));
  }
  processAction(e, t, i) {
    e.cellValueChanges.forEach((o) => {
      const { rowIndex: s, rowPinned: r, columnId: n } = o, a = { rowIndex: s, rowPinned: r }, l = this.rowPositionUtils.getRowNode(a);
      l.displayed && l.setDataValue(n, t(o), i);
    });
  }
  processRange(e, t) {
    let i;
    e.removeAllCellRanges(!0), t.forEach((o, s) => {
      if (!o)
        return;
      const r = o.startRow, n = o.endRow;
      s === t.length - 1 && (i = { rowPinned: r.rowPinned, rowIndex: r.rowIndex, columnId: o.startColumn.getColId() }, this.setLastFocusedCell(i));
      const a = { rowStartIndex: r.rowIndex, rowStartPinned: r.rowPinned, rowEndIndex: n.rowIndex, rowEndPinned: n.rowPinned, columnStart: o.startColumn, columns: o.columns };
      e.addCellRange(a);
    });
  }
  processCell(e) {
    const t = e[0], { rowIndex: i, rowPinned: o } = t, s = { rowIndex: i, rowPinned: o }, r = this.rowPositionUtils.getRowNode(s), n = { rowPinned: t.rowPinned, rowIndex: r.rowIndex, columnId: t.columnId };
    this.setLastFocusedCell(n, this.rangeService);
  }
  setLastFocusedCell(e, t) {
    const { rowIndex: i, columnId: o, rowPinned: s } = e, r = this.gridBodyCtrl.getScrollFeature(), n = this.columnModel.getCol(o);
    if (!n)
      return;
    r.ensureIndexVisible(i), r.ensureColumnVisible(n);
    const a = { rowIndex: i, column: n, rowPinned: s };
    this.focusService.setFocusedCell({ ...a, forceBrowserFocus: !0 }), t == null || t.setRangeToCell(a);
  }
  addListeners() {
    this.addManagedEventListeners({ rowEditingStarted: (e) => {
      this.activeRowEdit = { rowIndex: e.rowIndex, rowPinned: e.rowPinned };
    }, rowEditingStopped: () => {
      const e = new wt(this.cellValueChanges);
      this.pushActionsToUndoStack(e), this.activeRowEdit = null;
    }, cellEditingStarted: (e) => {
      this.activeCellEdit = { column: e.column, rowIndex: e.rowIndex, rowPinned: e.rowPinned };
    }, cellEditingStopped: (e) => {
      if (this.activeCellEdit = null, e.valueChanged && !this.activeRowEdit && !this.isPasting && !this.isRangeInAction) {
        const t = new wt(this.cellValueChanges);
        this.pushActionsToUndoStack(t);
      }
    }, pasteStart: () => {
      this.isPasting = !0;
    }, pasteEnd: () => {
      const e = new wt(this.cellValueChanges);
      this.pushActionsToUndoStack(e), this.isPasting = !1;
    }, fillStart: () => {
      this.isRangeInAction = !0;
    }, fillEnd: (e) => {
      const t = new Ri(this.cellValueChanges, e.initialRange, e.finalRange);
      this.pushActionsToUndoStack(t), this.isRangeInAction = !1;
    }, keyShortcutChangedCellStart: () => {
      this.isRangeInAction = !0;
    }, keyShortcutChangedCellEnd: () => {
      let e;
      e = this.rangeService && this.gos.get("enableRangeSelection") ? new Ri(this.cellValueChanges, void 0, void 0, [...this.rangeService.getCellRanges()]) : new wt(this.cellValueChanges), this.pushActionsToUndoStack(e), this.isRangeInAction = !1;
    } });
  }
  pushActionsToUndoStack(e) {
    this.undoStack.push(e), this.cellValueChanges = [], this.redoStack.clear();
  }
}], dependantModules: [Be] }, Uo = { version: M, moduleName: "@ag-grid-community/default-editor", userComponents: [{ name: "agCellEditor", classImp: Er }], dependantModules: [Be] }, zl = { version: M, moduleName: "@ag-grid-community/editing", dependantModules: [Be, Gl, { version: M, moduleName: "@ag-grid-community/full-row-edit", beans: [class extends f {
  constructor() {
    super(...arguments), this.beanName = "rowEditService";
  }
  startEditing(e, t = null, i = null, o = null) {
    e.getAllCellCtrls().reduce((s, r) => {
      const n = r === i;
      return n ? r.startEditing(t, n, o) : r.startEditing(null, n, o), !!s || r.isEditing();
    }, !1) && this.setEditing(e, !0);
  }
  stopEditing(e, t = !1) {
    const i = e.getAllCellCtrls(), o = e.isEditing();
    e.setStoppingRowEdit(!0);
    let s = !1;
    for (const r of i) {
      const n = r.stopEditing(t);
      o && !t && !s && n && (s = !0);
    }
    if (s) {
      const r = e.createRowEvent("rowValueChanged");
      this.eventService.dispatchEvent(r);
    }
    o && this.setEditing(e, !1), e.setStoppingRowEdit(!1);
  }
  setEditing(e, t) {
    e.setEditingRow(t), e.forEachGui(void 0, (o) => o.rowComp.addOrRemoveCssClass("ag-row-editing", t));
    const i = t ? e.createRowEvent("rowEditingStarted") : e.createRowEvent("rowEditingStopped");
    this.eventService.dispatchEvent(i);
  }
}], dependantModules: [Be] }, { version: M, moduleName: "@ag-grid-community/all-editors", dependantModules: [Uo, { version: M, moduleName: "@ag-grid-community/data-type-editors", userComponents: [{ name: "agTextCellEditor", classImp: Er }, { name: "agNumberCellEditor", classImp: class extends qt {
  constructor() {
    super(new Il());
  }
} }, { name: "agDateCellEditor", classImp: class extends qt {
  constructor() {
    super(new Ll());
  }
} }, { name: "agDateStringCellEditor", classImp: class extends qt {
  wireBeans(e) {
    this.dataTypeService = e.dataTypeService;
  }
  constructor() {
    super(new Ol(() => this.dataTypeService));
  }
} }, { name: "agCheckboxCellEditor", classImp: class extends nt {
  constructor() {
    super(`
            <div class="ag-cell-wrapper ag-cell-edit-wrapper ag-checkbox-edit">
                <ag-checkbox role="presentation" data-ref="eCheckbox"></ag-checkbox>
            </div>`, [lo]), this.eCheckbox = R;
  }
  init(e) {
    this.params = e;
    const t = e.value ?? void 0;
    this.eCheckbox.setValue(t), this.eCheckbox.getInputElement().setAttribute("tabindex", "-1"), this.setAriaLabel(t), this.addManagedListeners(this.eCheckbox, { fieldValueChanged: (i) => this.setAriaLabel(i.selected) });
  }
  getValue() {
    return this.eCheckbox.getValue();
  }
  focusIn() {
    this.eCheckbox.getFocusableElement().focus();
  }
  afterGuiAttached() {
    this.params.cellStartedEdit && this.focusIn();
  }
  isPopup() {
    return !1;
  }
  setAriaLabel(e) {
    const t = this.localeService.getLocaleTextFunc(), i = eo(t, e), o = t("ariaToggleCellValue", "Press SPACE to toggle cell value");
    this.eCheckbox.setInputAriaLabel(`${o} (${i})`);
  }
} }], dependantModules: [Uo] }, { version: M, moduleName: "@ag-grid-community/select-editor", userComponents: [{ name: "agSelectCellEditor", classImp: class extends nt {
  constructor() {
    super(`<div class="ag-cell-edit-wrapper">
                <ag-select class="ag-cell-editor" data-ref="eSelect"></ag-select>
            </div>`, [pa]), this.eSelect = R, this.startedByEnter = !1;
  }
  wireBeans(e) {
    this.valueService = e.valueService;
  }
  init(e) {
    this.focusAfterAttached = e.cellStartedEdit;
    const { eSelect: t, valueService: i, gos: o } = this, { values: s, value: r, eventKey: n } = e;
    if (A(s))
      return void b("no values found for select cellEditor");
    this.startedByEnter = n != null && n === v.ENTER;
    let a = !1;
    s.forEach((h) => {
      const g = { value: h }, u = i.formatValue(e.column, null, h), p = u != null;
      g.text = p ? u : h, t.addOption(g), a = a || r === h;
    }), a ? t.setValue(e.value, !0) : e.values.length && t.setValue(e.values[0], !0);
    const { valueListGap: l, valueListMaxWidth: d, valueListMaxHeight: c } = e;
    l != null && t.setPickerGap(l), c != null && t.setPickerMaxHeight(c), d != null && t.setPickerMaxWidth(d), o.get("editType") !== "fullRow" && this.addManagedListeners(this.eSelect, { selectedItem: () => e.stopEditing() });
  }
  afterGuiAttached() {
    this.focusAfterAttached && this.eSelect.getFocusableElement().focus(), this.startedByEnter && setTimeout(() => {
      this.isAlive() && this.eSelect.showPicker();
    });
  }
  focusIn() {
    this.eSelect.getFocusableElement().focus();
  }
  getValue() {
    return this.eSelect.getValue();
  }
  isPopup() {
    return !1;
  }
} }], dependantModules: [Be] }, { version: M, moduleName: "@ag-grid-community/large-text-editor", userComponents: [{ name: "agLargeTextCellEditor", classImp: class extends nt {
  constructor() {
    super(`<div class="ag-large-text">
        <ag-input-text-area data-ref="eTextArea" class="ag-large-text-input"></ag-input-text-area>
        </div>`, [kl]), this.eTextArea = R;
  }
  init(e) {
    this.params = e, this.focusAfterAttached = e.cellStartedEdit, this.eTextArea.setMaxLength(e.maxLength || 200).setCols(e.cols || 60).setRows(e.rows || 10), S(e.value, !0) && this.eTextArea.setValue(e.value.toString(), !0), this.addGuiEventListener("keydown", this.onKeyDown.bind(this)), this.activateTabIndex();
  }
  onKeyDown(e) {
    const t = e.key;
    (t === v.LEFT || t === v.UP || t === v.RIGHT || t === v.DOWN || e.shiftKey && t === v.ENTER) && e.stopPropagation();
  }
  afterGuiAttached() {
    const e = this.localeService.getLocaleTextFunc();
    this.eTextArea.setInputAriaLabel(e("ariaInputEditor", "Input Editor")), this.focusAfterAttached && this.eTextArea.getFocusableElement().focus();
  }
  getValue() {
    const e = this.eTextArea.getValue();
    return S(e) || S(this.params.value) ? this.params.parseValue(e) : this.params.value;
  }
} }], dependantModules: [Be] }] }, Nl] }, Bl = class extends f {
  constructor() {
    super(...arguments), this.beanName = "autoWidthCalculator";
  }
  wireBeans(e) {
    this.rowRenderer = e.rowRenderer, this.ctrlsService = e.ctrlsService;
  }
  postConstruct() {
    this.ctrlsService.whenReady((e) => {
      this.centerRowContainerCtrl = e.center;
    });
  }
  getPreferredWidthForColumn(e, t) {
    const i = this.getHeaderCellForColumn(e);
    if (!i)
      return -1;
    const o = this.rowRenderer.getAllCellsForColumn(e);
    return t || o.push(i), this.addElementsToContainerAndGetWidth(o);
  }
  getPreferredWidthForColumnGroup(e) {
    const t = this.getHeaderCellForColumn(e);
    return t ? this.addElementsToContainerAndGetWidth([t]) : -1;
  }
  addElementsToContainerAndGetWidth(e) {
    const t = document.createElement("form");
    t.style.position = "fixed";
    const i = this.centerRowContainerCtrl.getContainerElement();
    e.forEach((s) => this.cloneItemIntoDummy(s, t)), i.appendChild(t);
    const o = t.offsetWidth;
    return i.removeChild(t), o + this.getAutoSizePadding();
  }
  getAutoSizePadding() {
    return this.gos.get("autoSizePadding");
  }
  getHeaderCellForColumn(e) {
    let t = null;
    return this.ctrlsService.getHeaderRowContainerCtrls().forEach((i) => {
      const o = i.getHtmlElementForColumnHeader(e);
      o != null && (t = o);
    }), t;
  }
  cloneItemIntoDummy(e, t) {
    const i = e.cloneNode(!0);
    i.style.width = "", i.style.position = "static", i.style.left = "";
    const o = document.createElement("div"), s = o.classList;
    ["ag-header-cell", "ag-header-group-cell"].some((n) => i.classList.contains(n)) ? (s.add("ag-header", "ag-header-row"), o.style.position = "static") : s.add("ag-row");
    let r = e.parentElement;
    for (; r; ) {
      if (["ag-header-row", "ag-row"].some((n) => r.classList.contains(n))) {
        for (let n = 0; n < r.classList.length; n++) {
          const a = r.classList[n];
          a != "ag-row-position-absolute" && s.add(a);
        }
        break;
      }
      r = r.parentElement;
    }
    o.appendChild(i), t.appendChild(o);
  }
}, Hl = class extends f {
  constructor(e, t) {
    super(), this.createRowCon = e, this.destroyRowCtrls = t, this.stickyTopRowCtrls = [], this.stickyBottomRowCtrls = [], this.topContainerHeight = 0, this.bottomContainerHeight = 0, this.extraTopHeight = 0, this.extraBottomHeight = 0;
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.rowRenderer = e.rowRenderer, this.ctrlsService = e.ctrlsService, this.pageBoundsService = e.pageBoundsService;
  }
  postConstruct() {
    this.isClientSide = this.rowModel.getType() === "clientSide", this.ctrlsService.whenReady((e) => {
      this.gridBodyCtrl = e.gridBodyCtrl;
    });
  }
  getStickyTopRowCtrls() {
    return this.stickyTopRowCtrls;
  }
  getStickyBottomRowCtrls() {
    return this.stickyBottomRowCtrls;
  }
  setOffsetTop(e) {
    if (this.extraTopHeight === e)
      return;
    this.extraTopHeight = e;
    const t = { type: "stickyTopOffsetChanged", offset: e };
    this.eventService.dispatchEvent(t);
  }
  setOffsetBottom(e) {
    this.extraBottomHeight !== e && (this.extraBottomHeight = e);
  }
  resetOffsets() {
    this.setOffsetBottom(0), this.setOffsetTop(0);
  }
  getExtraTopHeight() {
    return this.extraTopHeight;
  }
  getExtraBottomHeight() {
    return this.extraBottomHeight;
  }
  getLastPixelOfGroup(e) {
    return this.isClientSide ? this.getClientSideLastPixelOfGroup(e) : this.getServerSideLastPixelOfGroup(e);
  }
  getFirstPixelOfGroup(e) {
    return e.footer ? e.sibling.rowTop + e.sibling.rowHeight - 1 : e.hasChildren() ? e.rowTop - 1 : 0;
  }
  getServerSideLastPixelOfGroup(e) {
    var t, i;
    if (this.isClientSide)
      throw new Error("This func should only be called in server side row model.");
    if (e.isExpandable() || e.footer) {
      if (e.master)
        return e.detailNode.rowTop + e.detailNode.rowHeight;
      if (!e.sibling || Math.abs(e.sibling.rowIndex - e.rowIndex) === 1) {
        let o = (t = e.childStore) == null ? void 0 : t.getStoreBounds();
        return e.footer && (o = (i = e.sibling.childStore) == null ? void 0 : i.getStoreBounds()), ((o == null ? void 0 : o.heightPx) ?? 0) + ((o == null ? void 0 : o.topPx) ?? 0);
      }
      return e.footer ? e.rowTop + e.rowHeight : e.sibling.rowTop + e.sibling.rowHeight;
    }
    return Number.MAX_SAFE_INTEGER;
  }
  getClientSideLastPixelOfGroup(e) {
    if (!this.isClientSide)
      throw new Error("This func should only be called in client side row model.");
    if (e.isExpandable() || e.footer) {
      if (e.footer && e.rowIndex === 0)
        return Number.MAX_SAFE_INTEGER;
      if (!e.sibling || Math.abs(e.sibling.rowIndex - e.rowIndex) === 1) {
        let t = e.footer ? e.sibling : e;
        for (; t.isExpandable() && t.expanded; )
          if (t.master)
            t = t.detailNode;
          else if (t.childrenAfterSort) {
            if (t.childrenAfterSort.length === 0)
              break;
            t = T(t.childrenAfterSort);
          }
        return t.rowTop + t.rowHeight;
      }
      return e.footer ? e.rowTop + e.rowHeight : e.sibling.rowTop + e.sibling.rowHeight;
    }
    return Number.MAX_SAFE_INTEGER;
  }
  updateStickyRows(e) {
    const t = e === "top";
    let i = 0;
    if (!this.canRowsBeSticky())
      return this.refreshNodesAndContainerHeight(e, /* @__PURE__ */ new Set(), i);
    const o = t ? this.rowRenderer.getFirstVisibleVerticalPixel() - this.extraTopHeight : this.rowRenderer.getLastVisibleVerticalPixel() - this.extraTopHeight, s = /* @__PURE__ */ new Set(), r = (d) => {
      if (s.add(d), t) {
        const c = this.getLastPixelOfGroup(d), h = o + i + d.rowHeight;
        d.stickyRowTop = c < h ? i + (c - h) : i;
      } else {
        const c = this.getFirstPixelOfGroup(d), h = o - (i + d.rowHeight);
        d.stickyRowTop = c > h ? i - (c - h) : i;
      }
      i = 0, s.forEach((c) => {
        const h = c.stickyRowTop + c.rowHeight;
        i < h && (i = h);
      });
    }, n = this.areFooterRowsStickySuppressed(), a = this.gos.get("suppressGroupRowsSticky"), l = (d) => !!d.displayed && (d.footer ? n !== !0 && (n !== "grand" || d.level !== -1) && !(n === "group" && d.level > -1) && !s.has(d) : !!d.isExpandable() && a !== !0 && !s.has(d) && d.expanded);
    for (let d = 0; d < 100; d++) {
      let c = o + i;
      t || (c = o - i);
      const h = this.rowModel.getRowIndexAtPixel(c), g = this.rowModel.getRow(h);
      if (g == null)
        break;
      const u = this.getStickyAncestors(g).find((p) => (t ? p.rowIndex < h : p.rowIndex > h) && l(p));
      if (u)
        r(u);
      else {
        if (!(t ? g.rowTop < c : g.rowTop + g.rowHeight > c) || !l(g))
          break;
        r(g);
      }
    }
    return t || s.forEach((d) => {
      d.stickyRowTop = i - (d.stickyRowTop + d.rowHeight);
    }), this.refreshNodesAndContainerHeight(e, s, i);
  }
  areFooterRowsStickySuppressed() {
    const e = this.gos.get("suppressStickyTotalRow");
    if (e === !0)
      return !0;
    const t = !!this.gos.get("groupIncludeFooter") || e === "group", i = !!this.gos.get("groupIncludeTotalFooter") || e === "grand";
    return !(!t || !i) || (i ? "grand" : !!t && "group");
  }
  canRowsBeSticky() {
    const e = this.gos.isGroupRowsSticky(), t = this.areFooterRowsStickySuppressed(), i = this.gos.get("suppressGroupRowsSticky");
    return e && (!t || !i);
  }
  getStickyAncestors(e) {
    const t = [];
    let i = e.footer ? e.sibling : e.parent;
    for (; i; )
      i.sibling && t.push(i.sibling), t.push(i), i = i.parent;
    return t.reverse();
  }
  checkStickyRows() {
    const e = this.updateStickyRows("top"), t = this.updateStickyRows("bottom");
    return e || t;
  }
  destroyStickyCtrls() {
    this.refreshNodesAndContainerHeight("top", /* @__PURE__ */ new Set(), 0), this.refreshNodesAndContainerHeight("bottom", /* @__PURE__ */ new Set(), 0);
  }
  refreshStickyNode(e) {
    const t = /* @__PURE__ */ new Set();
    if (this.stickyTopRowCtrls.some((i) => i.getRowNode() === e)) {
      for (let i = 0; i < this.stickyTopRowCtrls.length; i++) {
        const o = this.stickyTopRowCtrls[i].getRowNode();
        o !== e && t.add(o);
      }
      this.refreshNodesAndContainerHeight("top", t, this.topContainerHeight) && this.checkStickyRows();
    } else {
      for (let i = 0; i < this.stickyBottomRowCtrls.length; i++) {
        const o = this.stickyBottomRowCtrls[i].getRowNode();
        o !== e && t.add(o);
      }
      this.refreshNodesAndContainerHeight("bottom", t, this.bottomContainerHeight) && this.checkStickyRows();
    }
  }
  refreshNodesAndContainerHeight(e, t, i) {
    const o = e === "top", s = o ? this.stickyTopRowCtrls : this.stickyBottomRowCtrls, r = {}, n = [];
    for (let g = 0; g < s.length; g++) {
      const u = s[g].getRowNode();
      t.has(u) ? n.push(s[g]) : (r[u.id] = s[g], u.sticky = !1);
    }
    const a = /* @__PURE__ */ new Set();
    for (let g = 0; g < n.length; g++)
      a.add(n[g].getRowNode());
    const l = [];
    t.forEach((g) => {
      a.has(g) || (g.sticky = !0, l.push(this.createRowCon(g, !1, !1)));
    });
    let d = !!l.length || n.length !== s.length;
    o ? this.topContainerHeight !== i && (this.topContainerHeight = i, this.gridBodyCtrl.setStickyTopHeight(i), d = !0) : this.bottomContainerHeight !== i && (this.bottomContainerHeight = i, this.gridBodyCtrl.setStickyBottomHeight(i), d = !0), this.destroyRowCtrls(r, !1);
    const c = [...n, ...l];
    c.sort((g, u) => u.getRowNode().rowIndex - g.getRowNode().rowIndex), o || c.reverse(), c.forEach((g) => g.setRowTop(g.getRowNode().stickyRowTop));
    let h = 0;
    return o ? (t.forEach((g) => {
      g.rowIndex < this.pageBoundsService.getFirstRow() && (h += g.rowHeight);
    }), h > this.topContainerHeight && (h = this.topContainerHeight), this.setOffsetTop(h)) : (t.forEach((g) => {
      g.rowIndex > this.pageBoundsService.getLastRow() && (h += g.rowHeight);
    }), h > this.bottomContainerHeight && (h = this.bottomContainerHeight), this.setOffsetBottom(h)), !!d && (o ? this.stickyTopRowCtrls = c : this.stickyBottomRowCtrls = c, !0);
  }
  ensureRowHeightsValid() {
    let e = !1;
    const t = (i) => {
      const o = i.getRowNode();
      if (o.rowHeightEstimated) {
        const s = this.gos.getRowHeightForNode(o);
        o.setRowHeight(s.height), e = !0;
      }
    };
    return this.stickyTopRowCtrls.forEach(t), this.stickyBottomRowCtrls.forEach(t), e;
  }
}, Vl = class extends f {
  constructor() {
    super(...arguments), this.beanName = "rowRenderer", this.destroyFuncsForColumnListeners = [], this.rowCtrlsByRowIndex = {}, this.zombieRowCtrls = {}, this.allRowCtrls = [], this.topRowCtrls = [], this.bottomRowCtrls = [], this.refreshInProgress = !1, this.dataFirstRenderedFired = !1, this.setupRangeSelectionListeners = () => {
      const e = () => {
        this.getAllCellCtrls().forEach((s) => s.onRangeSelectionChanged());
      }, t = () => {
        this.getAllCellCtrls().forEach((s) => s.updateRangeBordersIfRangeCount());
      }, i = () => {
        this.eventService.addEventListener("rangeSelectionChanged", e), this.eventService.addEventListener("columnMoved", t), this.eventService.addEventListener("columnPinned", t), this.eventService.addEventListener("columnVisible", t);
      }, o = () => {
        this.eventService.removeEventListener("rangeSelectionChanged", e), this.eventService.removeEventListener("columnMoved", t), this.eventService.removeEventListener("columnPinned", t), this.eventService.removeEventListener("columnVisible", t);
      };
      this.addDestroyFunc(() => o()), this.addManagedPropertyListener("enableRangeSelection", (s) => {
        s.currentValue ? i() : o();
      }), this.gos.get("enableRangeSelection") && i();
    };
  }
  wireBeans(e) {
    this.animationFrameService = e.animationFrameService, this.paginationService = e.paginationService, this.pageBoundsService = e.pageBoundsService, this.columnModel = e.columnModel, this.visibleColsService = e.visibleColsService, this.pinnedRowModel = e.pinnedRowModel, this.rowModel = e.rowModel, this.focusService = e.focusService, this.beans = e, this.rowContainerHeightService = e.rowContainerHeightService, this.ctrlsService = e.ctrlsService, this.environment = e.environment;
  }
  postConstruct() {
    this.ctrlsService.whenReady((e) => {
      this.gridBodyCtrl = e.gridBodyCtrl, this.initialise();
    });
  }
  initialise() {
    if (this.addManagedEventListeners({ paginationChanged: this.onPageLoaded.bind(this), pinnedRowDataChanged: this.onPinnedRowDataChanged.bind(this), displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this), bodyScroll: this.onBodyScroll.bind(this), bodyHeightChanged: this.redraw.bind(this) }), this.addManagedPropertyListeners(["domLayout", "embedFullWidthRows"], () => this.onDomLayoutChanged()), this.addManagedPropertyListeners(["suppressMaxRenderedRowRestriction", "rowBuffer"], () => this.redraw()), this.addManagedPropertyListeners(["suppressCellFocus", "getBusinessKeyForNode", "fullWidthCellRenderer", "fullWidthCellRendererParams", "rowStyle", "getRowStyle", "rowClass", "getRowClass", "rowClassRules", "suppressStickyTotalRow", "groupRowRenderer", "groupRowRendererParams", "loadingCellRenderer", "loadingCellRendererParams", "detailCellRenderer", "detailCellRendererParams", "enableRangeSelection", "enableCellTextSelection"], () => this.redrawRows()), this.gos.isGroupRowsSticky()) {
      const e = this.rowModel.getType();
      e !== "clientSide" && e !== "serverSide" || (this.stickyRowFeature = this.createManagedBean(new Hl(this.createRowCon.bind(this), this.destroyRowCtrls.bind(this))));
    }
    this.registerCellEventListeners(), this.initialiseCache(), this.printLayout = this.gos.isDomLayout("print"), this.embedFullWidthRows = this.printLayout || this.gos.get("embedFullWidthRows"), this.redrawAfterModelUpdate();
  }
  initialiseCache() {
    if (this.gos.get("keepDetailRows")) {
      const e = this.getKeepDetailRowsCount(), t = e ?? 3;
      this.cachedRowCtrls = new Wl(t);
    }
  }
  getKeepDetailRowsCount() {
    return this.gos.get("keepDetailRowsCount");
  }
  getStickyTopRowCtrls() {
    return this.stickyRowFeature ? this.stickyRowFeature.getStickyTopRowCtrls() : [];
  }
  getStickyBottomRowCtrls() {
    return this.stickyRowFeature ? this.stickyRowFeature.getStickyBottomRowCtrls() : [];
  }
  updateAllRowCtrls() {
    const e = Ie(this.rowCtrlsByRowIndex), t = Ie(this.zombieRowCtrls), i = this.cachedRowCtrls ? this.cachedRowCtrls.getEntries() : [];
    t.length > 0 || i.length > 0 ? this.allRowCtrls = [...e, ...t, ...i] : this.allRowCtrls = e;
  }
  onCellFocusChanged(e) {
    this.getAllCellCtrls().forEach((t) => t.onCellFocused(e)), this.getFullWidthRowCtrls().forEach((t) => t.onFullWidthRowFocused(e));
  }
  registerCellEventListeners() {
    this.addManagedEventListeners({ cellFocused: (e) => {
      this.onCellFocusChanged(e);
    }, cellFocusCleared: () => this.onCellFocusChanged(), flashCells: (e) => {
      this.getAllCellCtrls().forEach((t) => t.onFlashCells(e));
    }, columnHoverChanged: () => {
      this.getAllCellCtrls().forEach((e) => e.onColumnHover());
    }, displayedColumnsChanged: () => {
      this.getAllCellCtrls().forEach((e) => e.onDisplayedColumnsChanged());
    }, displayedColumnsWidthChanged: () => {
      this.printLayout && this.getAllCellCtrls().forEach((e) => e.onLeftChanged());
    } }), this.setupRangeSelectionListeners(), this.refreshListenersToColumnsForCellComps(), this.addManagedEventListeners({ gridColumnsChanged: this.refreshListenersToColumnsForCellComps.bind(this) }), this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
  }
  removeGridColumnListeners() {
    this.destroyFuncsForColumnListeners.forEach((e) => e()), this.destroyFuncsForColumnListeners.length = 0;
  }
  refreshListenersToColumnsForCellComps() {
    this.removeGridColumnListeners(), this.columnModel.getCols().forEach((e) => {
      const t = (a) => {
        this.getAllCellCtrls().forEach((l) => {
          l.getColumn() === e && a(l);
        });
      }, i = () => {
        t((a) => a.onLeftChanged());
      }, o = () => {
        t((a) => a.onWidthChanged());
      }, s = () => {
        t((a) => a.onFirstRightPinnedChanged());
      }, r = () => {
        t((a) => a.onLastLeftPinnedChanged());
      }, n = () => {
        t((a) => a.onColDefChanged());
      };
      e.addEventListener("leftChanged", i), e.addEventListener("widthChanged", o), e.addEventListener("firstRightPinnedChanged", s), e.addEventListener("lastLeftPinnedChanged", r), e.addEventListener("colDefChanged", n), this.destroyFuncsForColumnListeners.push(() => {
        e.removeEventListener("leftChanged", i), e.removeEventListener("widthChanged", o), e.removeEventListener("firstRightPinnedChanged", s), e.removeEventListener("lastLeftPinnedChanged", r), e.removeEventListener("colDefChanged", n);
      });
    });
  }
  onDomLayoutChanged() {
    const e = this.gos.isDomLayout("print"), t = e || this.gos.get("embedFullWidthRows"), i = t !== this.embedFullWidthRows || this.printLayout !== e;
    this.printLayout = e, this.embedFullWidthRows = t, i && this.redrawAfterModelUpdate({ domLayoutChanged: !0 });
  }
  datasourceChanged() {
    this.firstRenderedRow = 0, this.lastRenderedRow = -1;
    const e = Object.keys(this.rowCtrlsByRowIndex);
    this.removeRowCtrls(e);
  }
  onPageLoaded(e) {
    const t = { recycleRows: e.keepRenderedRows, animate: e.animate, newData: e.newData, newPage: e.newPage, onlyBody: !0 };
    this.redrawAfterModelUpdate(t);
  }
  getAllCellsForColumn(e) {
    const t = [];
    return this.getAllRowCtrls().forEach((i) => {
      const o = i.getCellElement(e);
      o && t.push(o);
    }), t;
  }
  refreshFloatingRowComps() {
    this.refreshFloatingRows(this.topRowCtrls, this.pinnedRowModel.getPinnedTopRowNodes()), this.refreshFloatingRows(this.bottomRowCtrls, this.pinnedRowModel.getPinnedBottomRowNodes());
  }
  getTopRowCtrls() {
    return this.topRowCtrls;
  }
  getCentreRowCtrls() {
    return this.allRowCtrls;
  }
  getBottomRowCtrls() {
    return this.bottomRowCtrls;
  }
  refreshFloatingRows(e, t) {
    const i = Object.fromEntries(t.map((s) => [s.id, s])), o = Object.fromEntries(e.map((s) => [s.getRowNode().id, s]));
    for (let s = 0; s < t.length; s++) {
      const r = t[s], n = e[s];
      n && i[n.getRowNode().id] === void 0 && (n.destroyFirstPass(), n.destroySecondPass()), r.id in o ? (e[s] = o[r.id], delete o[r.id]) : e[s] = new je(r, this.beans, !1, !1, this.printLayout);
    }
    e.length = t.length;
  }
  onPinnedRowDataChanged() {
    this.redrawAfterModelUpdate({ recycleRows: !0 });
  }
  redrawRow(e, t = !1) {
    var i;
    if (e.sticky)
      this.stickyRowFeature.refreshStickyNode(e);
    else {
      if ((i = this.cachedRowCtrls) != null && i.has(e))
        return void this.cachedRowCtrls.removeRow(e);
      {
        const o = (s) => {
          const r = s[e.rowIndex];
          r && r.getRowNode() === e && (r.destroyFirstPass(), r.destroySecondPass(), s[e.rowIndex] = this.createRowCon(e, !1, !1));
        };
        switch (e.rowPinned) {
          case "top":
            o(this.topRowCtrls);
            break;
          case "bottom":
            o(this.bottomRowCtrls);
            break;
          default:
            o(this.rowCtrlsByRowIndex), this.updateAllRowCtrls();
        }
      }
    }
    t || this.dispatchDisplayedRowsChanged(!1);
  }
  redrawRows(e) {
    if (e != null)
      return e == null || e.forEach((t) => this.redrawRow(t, !0)), void this.dispatchDisplayedRowsChanged(!1);
    this.redrawAfterModelUpdate();
  }
  getCellToRestoreFocusToAfterRefresh(e) {
    const t = e != null && e.suppressKeepFocus ? null : this.focusService.getFocusCellToUseAfterRefresh();
    if (t == null)
      return null;
    const i = this.gos.getActiveDomElement(), o = this.gos.getDomData(i, Ue.DOM_DATA_KEY_CELL_CTRL), s = this.gos.getDomData(i, je.DOM_DATA_KEY_ROW_CTRL);
    return o || s ? t : null;
  }
  redrawAfterModelUpdate(e = {}) {
    this.getLockOnRefresh();
    const t = this.getCellToRestoreFocusToAfterRefresh(e);
    this.updateContainerHeights(), this.scrollToTopIfNewData(e);
    const i = !e.domLayoutChanged && !!e.recycleRows, o = e.animate && this.gos.isAnimateRows(), s = i ? this.getRowsToRecycle() : null;
    if (i || this.removeAllRowComps(), this.workOutFirstAndLastRowsToRender(), this.stickyRowFeature) {
      this.stickyRowFeature.checkStickyRows();
      const r = this.stickyRowFeature.getExtraTopHeight() + this.stickyRowFeature.getExtraBottomHeight();
      r && this.updateContainerHeights(r);
    }
    this.recycleRows(s, o), this.gridBodyCtrl.updateRowCount(), e.onlyBody || this.refreshFloatingRowComps(), this.dispatchDisplayedRowsChanged(), t != null && this.restoreFocusedCell(t), this.releaseLockOnRefresh();
  }
  scrollToTopIfNewData(e) {
    var o;
    const t = e.newData || e.newPage, i = this.gos.get("suppressScrollOnNewData");
    t && !i && (this.gridBodyCtrl.getScrollFeature().scrollToTop(), (o = this.stickyRowFeature) == null || o.resetOffsets());
  }
  updateContainerHeights(e = 0) {
    if (this.printLayout)
      return void this.rowContainerHeightService.setModelHeight(null);
    let t = this.pageBoundsService.getCurrentPageHeight();
    t === 0 && (t = 1), this.rowContainerHeightService.setModelHeight(t + e);
  }
  getLockOnRefresh() {
    var e, t, i, o;
    if (this.refreshInProgress) {
      const s = ((t = (e = this.frameworkOverrides).getLockOnRefreshError) == null ? void 0 : t.call(e)) ?? "";
      throw new Error("AG Grid: cannot get grid to draw rows when it is in the middle of drawing rows. Your code probably called a grid API method while the grid was in the render stage. To overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). To see what part of your code that caused the refresh check this stacktrace." + s);
    }
    this.refreshInProgress = !0, (o = (i = this.frameworkOverrides).getLockOnRefresh) == null || o.call(i);
  }
  releaseLockOnRefresh() {
    var e, t;
    this.refreshInProgress = !1, (t = (e = this.frameworkOverrides).releaseLockOnRefresh) == null || t.call(e);
  }
  isRefreshInProgress() {
    return this.refreshInProgress;
  }
  restoreFocusedCell(e) {
    e && setTimeout(() => {
      this.focusService.setRestoreFocusedCell(e), this.onCellFocusChanged(this.gos.addGridCommonParams({ rowIndex: e.rowIndex, column: e.column, rowPinned: e.rowPinned, forceBrowserFocus: !0, preventScrollOnBrowserFocus: !0, type: "cellFocused" }));
    });
  }
  stopEditing(e = !1) {
    this.getAllRowCtrls().forEach((t) => {
      t.stopEditing(e);
    });
  }
  getAllCellCtrls() {
    const e = [], t = this.getAllRowCtrls(), i = t.length;
    for (let o = 0; o < i; o++) {
      const s = t[o].getAllCellCtrls(), r = s.length;
      for (let n = 0; n < r; n++)
        e.push(s[n]);
    }
    return e;
  }
  getAllRowCtrls() {
    const e = this.stickyRowFeature && this.stickyRowFeature.getStickyTopRowCtrls() || [], t = this.stickyRowFeature && this.stickyRowFeature.getStickyBottomRowCtrls() || [], i = [...this.topRowCtrls, ...this.bottomRowCtrls, ...e, ...t];
    for (const o in this.rowCtrlsByRowIndex)
      i.push(this.rowCtrlsByRowIndex[o]);
    return i;
  }
  addRenderedRowListener(e, t, i) {
    const o = this.rowCtrlsByRowIndex[t];
    o && o.addEventListener(e, i);
  }
  flashCells(e = {}) {
    this.getCellCtrls(e.rowNodes, e.columns).forEach((t) => t.flashCell(e));
  }
  refreshCells(e = {}) {
    const t = { forceRefresh: e.force, newData: !1, suppressFlash: e.suppressFlash };
    for (const i of this.getCellCtrls(e.rowNodes, e.columns))
      i.refreshOrDestroyCell(t);
    this.refreshFullWidth(e.rowNodes);
  }
  refreshFullWidth(e) {
    if (!e)
      return;
    let t = null;
    this.stickyRowFeature && Li() && (t = this.getCellToRestoreFocusToAfterRefresh() || null);
    for (const i of this.getRowCtrls(e))
      i.isFullWidth() && (i.refreshFullWidth() || this.redrawRow(i.getRowNode(), !0));
    this.dispatchDisplayedRowsChanged(!1), t && this.restoreFocusedCell(t);
  }
  getCellRendererInstances(e) {
    var s;
    const t = this.getCellCtrls(e.rowNodes, e.columns).map((r) => r.getCellRenderer()).filter((r) => r != null);
    if ((s = e.columns) != null && s.length)
      return t;
    const i = [], o = this.mapRowNodes(e.rowNodes);
    return this.getAllRowCtrls().forEach((r) => {
      if (o && !this.isRowInMap(r.getRowNode(), o) || !r.isFullWidth())
        return;
      const n = r.getFullWidthCellRenderers();
      for (let a = 0; a < n.length; a++) {
        const l = n[a];
        l != null && i.push(l);
      }
    }), [...i, ...t];
  }
  getCellEditorInstances(e) {
    const t = [];
    return this.getCellCtrls(e.rowNodes, e.columns).forEach((i) => {
      const o = i.getCellEditor();
      o && t.push(o);
    }), t;
  }
  getEditingCells() {
    const e = [];
    return this.getAllCellCtrls().forEach((t) => {
      if (t.isEditing()) {
        const i = t.getCellPosition();
        e.push(i);
      }
    }), e;
  }
  mapRowNodes(e) {
    if (!e)
      return;
    const t = { top: {}, bottom: {}, normal: {} };
    return e.forEach((i) => {
      const o = i.id;
      switch (i.rowPinned) {
        case "top":
          t.top[o] = i;
          break;
        case "bottom":
          t.bottom[o] = i;
          break;
        default:
          t.normal[o] = i;
      }
    }), t;
  }
  isRowInMap(e, t) {
    const i = e.id;
    switch (e.rowPinned) {
      case "top":
        return t.top[i] != null;
      case "bottom":
        return t.bottom[i] != null;
      default:
        return t.normal[i] != null;
    }
  }
  getRowCtrls(e) {
    const t = this.mapRowNodes(e), i = this.getAllRowCtrls();
    return e && t ? i.filter((o) => {
      const s = o.getRowNode();
      return this.isRowInMap(s, t);
    }) : i;
  }
  getCellCtrls(e, t) {
    let i;
    S(t) && (i = {}, t.forEach((s) => {
      const r = this.columnModel.getCol(s);
      S(r) && (i[r.getId()] = !0);
    }));
    const o = [];
    return this.getRowCtrls(e).forEach((s) => {
      s.getAllCellCtrls().forEach((r) => {
        const n = r.getColumn().getId();
        i && !i[n] || o.push(r);
      });
    }), o;
  }
  destroy() {
    this.removeAllRowComps(), super.destroy();
  }
  removeAllRowComps() {
    const e = Object.keys(this.rowCtrlsByRowIndex);
    this.removeRowCtrls(e), this.stickyRowFeature && this.stickyRowFeature.destroyStickyCtrls();
  }
  getRowsToRecycle() {
    const e = [];
    le(this.rowCtrlsByRowIndex, (i, o) => {
      o.getRowNode().id == null && e.push(i);
    }), this.removeRowCtrls(e);
    const t = {};
    return le(this.rowCtrlsByRowIndex, (i, o) => {
      const s = o.getRowNode();
      t[s.id] = o;
    }), this.rowCtrlsByRowIndex = {}, t;
  }
  removeRowCtrls(e, t = !1) {
    e.forEach((i) => {
      const o = this.rowCtrlsByRowIndex[i];
      o && (o.destroyFirstPass(t), o.destroySecondPass()), delete this.rowCtrlsByRowIndex[i];
    });
  }
  onBodyScroll(e) {
    e.direction === "vertical" && this.redraw({ afterScroll: !0 });
  }
  redraw(e = {}) {
    const { afterScroll: t } = e;
    let i;
    this.stickyRowFeature && Li() && (i = this.getCellToRestoreFocusToAfterRefresh() || void 0);
    const o = this.firstRenderedRow, s = this.lastRenderedRow;
    this.workOutFirstAndLastRowsToRender();
    let r = !1;
    if (this.stickyRowFeature) {
      r = this.stickyRowFeature.checkStickyRows();
      const a = this.stickyRowFeature.getExtraTopHeight() + this.stickyRowFeature.getExtraBottomHeight();
      a && this.updateContainerHeights(a);
    }
    const n = this.firstRenderedRow !== o || this.lastRenderedRow !== s;
    if ((!t || r || n) && (this.getLockOnRefresh(), this.recycleRows(null, !1, t), this.releaseLockOnRefresh(), this.dispatchDisplayedRowsChanged(t && !r), i != null)) {
      const a = this.getCellToRestoreFocusToAfterRefresh();
      i != null && a == null && (this.animationFrameService.flushAllFrames(), this.restoreFocusedCell(i));
    }
  }
  removeRowCompsNotToDraw(e, t) {
    const i = {};
    e.forEach((s) => i[s] = !0);
    const o = Object.keys(this.rowCtrlsByRowIndex).filter((s) => !i[s]);
    this.removeRowCtrls(o, t);
  }
  calculateIndexesToDraw(e) {
    const t = function(s, r) {
      const n = [];
      for (let a = s; a <= r; a++)
        n.push(a);
      return n;
    }(this.firstRenderedRow, this.lastRenderedRow), i = (s, r) => {
      const n = r.getRowNode().rowIndex;
      n != null && (n < this.firstRenderedRow || n > this.lastRenderedRow) && this.doNotUnVirtualiseRow(r) && t.push(n);
    };
    le(this.rowCtrlsByRowIndex, i), le(e, i), t.sort((s, r) => s - r);
    const o = [];
    for (let s = 0; s < t.length; s++) {
      const r = t[s], n = this.rowModel.getRow(r);
      n && !n.sticky && o.push(r);
    }
    return o;
  }
  recycleRows(e, t = !1, i = !1) {
    const o = this.calculateIndexesToDraw(e);
    (this.printLayout || i) && (t = !1), this.removeRowCompsNotToDraw(o, !t), o.forEach((s) => {
      this.createOrUpdateRowCtrl(s, e, t, i);
    }), e && (!i || this.gos.get("suppressAnimationFrame") || this.printLayout ? this.destroyRowCtrls(e, t) : this.beans.animationFrameService.addDestroyTask(() => {
      this.destroyRowCtrls(e, t), this.updateAllRowCtrls(), this.dispatchDisplayedRowsChanged();
    })), this.updateAllRowCtrls();
  }
  dispatchDisplayedRowsChanged(e = !1) {
    const t = { type: "displayedRowsChanged", afterScroll: e };
    this.eventService.dispatchEvent(t);
  }
  onDisplayedColumnsChanged() {
    const e = this.visibleColsService.isPinningLeft(), t = this.visibleColsService.isPinningRight();
    (this.pinningLeft !== e || t !== this.pinningRight) && (this.pinningLeft = e, this.pinningRight = t, this.embedFullWidthRows && this.redrawFullWidthEmbeddedRows());
  }
  redrawFullWidthEmbeddedRows() {
    const e = [];
    this.getFullWidthRowCtrls().forEach((t) => {
      const i = t.getRowNode().rowIndex;
      e.push(i.toString());
    }), this.refreshFloatingRowComps(), this.removeRowCtrls(e), this.redraw({ afterScroll: !0 });
  }
  getFullWidthRowCtrls(e) {
    const t = this.mapRowNodes(e);
    return this.getAllRowCtrls().filter((i) => {
      if (!i.isFullWidth())
        return !1;
      const o = i.getRowNode();
      return !(t != null && !this.isRowInMap(o, t));
    });
  }
  createOrUpdateRowCtrl(e, t, i, o) {
    let s, r = this.rowCtrlsByRowIndex[e];
    if (r || (s = this.rowModel.getRow(e), S(s) && S(t) && t[s.id] && s.alreadyRendered && (r = t[s.id], t[s.id] = null)), !r) {
      if (s || (s = this.rowModel.getRow(e)), !S(s))
        return;
      r = this.createRowCon(s, i, o);
    }
    return s && (s.alreadyRendered = !0), this.rowCtrlsByRowIndex[e] = r, r;
  }
  destroyRowCtrls(e, t) {
    const i = [];
    le(e, (o, s) => {
      s && (this.cachedRowCtrls && s.isCacheable() ? this.cachedRowCtrls.addRow(s) : (s.destroyFirstPass(!t), t ? (this.zombieRowCtrls[s.getInstanceId()] = s, i.push(() => {
        s.destroySecondPass(), delete this.zombieRowCtrls[s.getInstanceId()];
      })) : s.destroySecondPass()));
    }), t && (i.push(() => {
      this.updateAllRowCtrls(), this.dispatchDisplayedRowsChanged();
    }), function(o, s = 0) {
      o.length > 0 && window.setTimeout(() => o.forEach((r) => r()), s);
    }(i, 400));
  }
  getRowBuffer() {
    return this.gos.get("rowBuffer");
  }
  getRowBufferInPixels() {
    return this.getRowBuffer() * this.gos.getRowHeightAsNumber();
  }
  workOutFirstAndLastRowsToRender() {
    let e, t;
    if (this.rowContainerHeightService.updateOffset(), this.rowModel.isRowsToRender())
      if (this.printLayout)
        this.environment.refreshRowHeightVariable(), e = this.pageBoundsService.getFirstRow(), t = this.pageBoundsService.getLastRow();
      else {
        const a = this.getRowBufferInPixels(), l = this.ctrlsService.getGridBodyCtrl(), d = this.gos.get("suppressRowVirtualisation");
        let c, h, g = !1;
        do {
          const w = this.pageBoundsService.getPixelOffset(), { pageFirstPixel: x, pageLastPixel: E } = this.pageBoundsService.getCurrentPagePixelRange(), k = this.rowContainerHeightService.getDivStretchOffset(), P = l.getScrollFeature().getVScrollPosition(), D = P.top, F = P.bottom;
          d ? (c = x + k, h = E + k) : (c = Math.max(D + w - a, x) + k, h = Math.min(F + w + a, E) + k), this.firstVisibleVPixel = Math.max(D + w, x) + k, this.lastVisibleVPixel = Math.min(F + w, E) + k, g = this.ensureAllRowsInRangeHaveHeightsCalculated(c, h);
        } while (g);
        let u = this.rowModel.getRowIndexAtPixel(c), p = this.rowModel.getRowIndexAtPixel(h);
        const C = this.pageBoundsService.getFirstRow(), y = this.pageBoundsService.getLastRow();
        u < C && (u = C), p > y && (p = y), e = u, t = p;
      }
    else
      e = 0, t = -1;
    const i = this.gos.isDomLayout("normal"), o = this.gos.get("suppressMaxRenderedRowRestriction"), s = Math.max(this.getRowBuffer(), 500);
    i && !o && t - e > s && (t = e + s);
    const r = e !== this.firstRenderedRow, n = t !== this.lastRenderedRow;
    if (r || n) {
      this.firstRenderedRow = e, this.lastRenderedRow = t;
      const a = { type: "viewportChanged", firstRow: e, lastRow: t };
      this.eventService.dispatchEvent(a);
    }
  }
  dispatchFirstDataRenderedEvent() {
    if (this.dataFirstRenderedFired)
      return;
    this.dataFirstRenderedFired = !0;
    const e = { type: "firstDataRendered", firstRow: this.firstRenderedRow, lastRow: this.lastRenderedRow };
    window.requestAnimationFrame(() => {
      this.beans.eventService.dispatchEvent(e);
    });
  }
  ensureAllRowsInRangeHaveHeightsCalculated(e, t) {
    var r, n;
    const i = (r = this.pinnedRowModel) == null ? void 0 : r.ensureRowHeightsValid(), o = (n = this.stickyRowFeature) == null ? void 0 : n.ensureRowHeightsValid(), s = this.rowModel.ensureRowHeightsValid(e, t, this.pageBoundsService.getFirstRow(), this.pageBoundsService.getLastRow());
    return (s || o) && this.eventService.dispatchEvent({ type: "recalculateRowBounds" }), !!(o || s || i) && (this.updateContainerHeights(), !0);
  }
  getFirstVisibleVerticalPixel() {
    return this.firstVisibleVPixel;
  }
  getLastVisibleVerticalPixel() {
    return this.lastVisibleVPixel;
  }
  getFirstVirtualRenderedRow() {
    return this.firstRenderedRow;
  }
  getLastVirtualRenderedRow() {
    return this.lastRenderedRow;
  }
  doNotUnVirtualiseRow(e) {
    const t = e.getRowNode(), i = this.focusService.isRowNodeFocused(t), o = e.isEditing(), s = t.detail;
    return !!(i || o || s) && !!this.isRowPresent(t);
  }
  isRowPresent(e) {
    return !!this.rowModel.isRowPresent(e) && (!this.paginationService || this.paginationService.isRowPresent(e));
  }
  createRowCon(e, t, i) {
    const o = this.cachedRowCtrls ? this.cachedRowCtrls.getRow(e) : null;
    if (o)
      return o;
    const s = this.gos.get("suppressAnimationFrame"), r = i && !s && !this.printLayout;
    return new je(e, this.beans, t, r, this.printLayout);
  }
  getRenderedNodes() {
    const e = this.rowCtrlsByRowIndex;
    return Object.values(e).map((t) => t.getRowNode());
  }
  getRowByPosition(e) {
    let t;
    const { rowIndex: i } = e;
    switch (e.rowPinned) {
      case "top":
        t = this.topRowCtrls[i];
        break;
      case "bottom":
        t = this.bottomRowCtrls[i];
        break;
      default:
        t = this.rowCtrlsByRowIndex[i], t || (t = this.getStickyTopRowCtrls().find((o) => o.getRowNode().rowIndex === i) || null, t || (t = this.getStickyBottomRowCtrls().find((o) => o.getRowNode().rowIndex === i) || null));
    }
    return t;
  }
  isRangeInRenderedViewport(e, t) {
    if (e == null || t == null)
      return !1;
    const i = e > this.lastRenderedRow;
    return !(t < this.firstRenderedRow || i);
  }
}, Wl = class {
  constructor(e) {
    this.entriesMap = {}, this.entriesList = [], this.maxCount = e;
  }
  addRow(e) {
    if (this.entriesMap[e.getRowNode().id] = e, this.entriesList.push(e), e.setCached(!0), this.entriesList.length > this.maxCount) {
      const t = this.entriesList[0];
      t.destroyFirstPass(), t.destroySecondPass(), this.removeFromCache(t);
    }
  }
  getRow(e) {
    if (e == null || e.id == null)
      return null;
    const t = this.entriesMap[e.id];
    return t ? (this.removeFromCache(t), t.setCached(!1), t.getRowNode() != e ? null : t) : null;
  }
  has(e) {
    return this.entriesMap[e.id] != null;
  }
  removeRow(e) {
    const t = e.id, i = this.entriesMap[t];
    delete this.entriesMap[t], Y(this.entriesList, i);
  }
  removeFromCache(e) {
    const t = e.getRowNode().id;
    delete this.entriesMap[t], Y(this.entriesList, e);
  }
  getEntries() {
    return this.entriesList;
  }
}, Ul = class extends f {
  constructor() {
    super(...arguments), this.beanName = "pinnedRowModel", this.nextId = 0;
  }
  wireBeans(e) {
    this.beans = e;
  }
  postConstruct() {
    this.setPinnedTopRowData(), this.setPinnedBottomRowData(), this.addManagedPropertyListener("pinnedTopRowData", () => this.setPinnedTopRowData()), this.addManagedPropertyListener("pinnedBottomRowData", () => this.setPinnedBottomRowData()), this.addManagedEventListeners({ gridStylesChanged: this.onGridStylesChanges.bind(this) });
  }
  isEmpty(e) {
    return W(e === "top" ? this.pinnedTopRows : this.pinnedBottomRows);
  }
  isRowsToRender(e) {
    return !this.isEmpty(e);
  }
  getRowAtPixel(e, t) {
    const i = t === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
    if (W(i))
      return 0;
    for (let o = 0; o < i.length; o++) {
      const s = i[o];
      if (s.rowTop + s.rowHeight - 1 >= e)
        return o;
    }
    return i.length - 1;
  }
  onGridStylesChanges(e) {
    if (e.rowHeightChanged) {
      const t = (i) => {
        i.setRowHeight(i.rowHeight, !0);
      };
      this.pinnedBottomRows.forEach(t), this.pinnedTopRows.forEach(t);
    }
  }
  ensureRowHeightsValid() {
    var o, s;
    let e = !1, t = 0;
    const i = (r) => {
      if (r.rowHeightEstimated) {
        const n = this.gos.getRowHeightForNode(r);
        r.setRowTop(t), r.setRowHeight(n.height), t += n.height, e = !0;
      }
    };
    return (o = this.pinnedBottomRows) == null || o.forEach(i), t = 0, (s = this.pinnedTopRows) == null || s.forEach(i), this.eventService.dispatchEvent({ type: "pinnedHeightChanged" }), e;
  }
  setPinnedTopRowData() {
    const e = this.gos.get("pinnedTopRowData");
    this.pinnedTopRows = this.createNodesFromData(e, !0), this.eventService.dispatchEvent({ type: "pinnedRowDataChanged" });
  }
  setPinnedBottomRowData() {
    const e = this.gos.get("pinnedBottomRowData");
    this.pinnedBottomRows = this.createNodesFromData(e, !1), this.eventService.dispatchEvent({ type: "pinnedRowDataChanged" });
  }
  createNodesFromData(e, t) {
    const i = [];
    if (e) {
      const o = this.gos.getRowIdCallback(), s = t ? xe.ID_PREFIX_TOP_PINNED : xe.ID_PREFIX_BOTTOM_PINNED;
      let r = 0;
      const n = t ? "top" : "bottom";
      e.forEach((a, l) => {
        const d = new xe(this.beans);
        d.data = a, d.id = (o == null ? void 0 : o({ data: a, level: 0, rowPinned: n })) ?? s + this.nextId++, d.rowPinned = n, d.setRowTop(r), d.setRowHeight(this.gos.getRowHeightForNode(d).height), d.setRowIndex(l), r += d.rowHeight, i.push(d);
      });
    }
    return i;
  }
  getPinnedTopRowNodes() {
    return this.pinnedTopRows;
  }
  getPinnedBottomRowNodes() {
    return this.pinnedBottomRows;
  }
  getPinnedTopTotalHeight() {
    return this.getTotalHeight(this.pinnedTopRows);
  }
  getPinnedTopRowCount() {
    return this.pinnedTopRows ? this.pinnedTopRows.length : 0;
  }
  getPinnedBottomRowCount() {
    return this.pinnedBottomRows ? this.pinnedBottomRows.length : 0;
  }
  getPinnedTopRow(e) {
    return this.pinnedTopRows[e];
  }
  getPinnedBottomRow(e) {
    return this.pinnedBottomRows[e];
  }
  forEachPinnedTopRow(e) {
    W(this.pinnedTopRows) || this.pinnedTopRows.forEach(e);
  }
  forEachPinnedBottomRow(e) {
    W(this.pinnedBottomRows) || this.pinnedBottomRows.forEach(e);
  }
  getPinnedBottomTotalHeight() {
    return this.getTotalHeight(this.pinnedBottomRows);
  }
  getTotalHeight(e) {
    if (!e || e.length === 0)
      return 0;
    const t = T(e);
    return t.rowTop + t.rowHeight;
  }
}, jl = class extends f {
  constructor(e) {
    super(), this.state = "needsLoading", this.version = 0, this.id = e;
  }
  getId() {
    return this.id;
  }
  load() {
    this.state = "loading", this.loadFromDatasource();
  }
  getVersion() {
    return this.version;
  }
  setStateWaitingToLoad() {
    this.version++, this.state = "needsLoading";
  }
  getState() {
    return this.state;
  }
  pageLoadFailed(e) {
    this.isRequestMostRecentAndLive(e) && (this.state = "failed", this.processServerFail()), this.dispatchLoadCompleted(!1);
  }
  success(e, t) {
    this.successCommon(e, t);
  }
  pageLoaded(e, t, i) {
    this.successCommon(e, { rowData: t, rowCount: i });
  }
  isRequestMostRecentAndLive(e) {
    const t = e === this.version, i = this.isAlive();
    return t && i;
  }
  successCommon(e, t) {
    this.dispatchLoadCompleted(), this.isRequestMostRecentAndLive(e) && (this.state = "loaded", this.processServerResult(t));
  }
  dispatchLoadCompleted(e = !0) {
    const t = { type: "loadComplete", success: e, block: this };
    this.dispatchLocalEvent(t);
  }
}, Kl = { version: M, moduleName: "@ag-grid-community/row-node-block", beans: [class extends f {
  constructor() {
    super(...arguments), this.beanName = "rowNodeBlockLoader", this.activeBlockLoadsCount = 0, this.blocks = [], this.active = !0;
  }
  wireBeans(e) {
    this.rowModel = e.rowModel;
  }
  postConstruct() {
    this.maxConcurrentRequests = this.getMaxConcurrentDatasourceRequests();
    const e = this.gos.get("blockLoadDebounceMillis");
    e && e > 0 && (this.checkBlockToLoadDebounce = q(this.performCheckBlocksToLoad.bind(this), e));
  }
  getMaxConcurrentDatasourceRequests() {
    const e = this.gos.get("maxConcurrentDatasourceRequests");
    return e == null ? 2 : e <= 0 ? void 0 : e;
  }
  addBlock(e) {
    this.blocks.push(e), e.addEventListener("loadComplete", this.loadComplete.bind(this)), this.checkBlockToLoad();
  }
  removeBlock(e) {
    Y(this.blocks, e);
  }
  destroy() {
    super.destroy(), this.active = !1;
  }
  loadComplete() {
    this.activeBlockLoadsCount--, this.checkBlockToLoad(), this.dispatchLocalEvent({ type: "blockLoaded" }), this.activeBlockLoadsCount == 0 && this.dispatchLocalEvent({ type: "blockLoaderFinished" });
  }
  checkBlockToLoad() {
    this.checkBlockToLoadDebounce ? this.checkBlockToLoadDebounce() : this.performCheckBlocksToLoad();
  }
  performCheckBlocksToLoad() {
    if (!this.active)
      return;
    if (this.printCacheStatus(), this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests)
      return void (this.gos.get("debug") && se("RowNodeBlockLoader - checkBlockToLoad: max loads exceeded"));
    const e = this.getAvailableLoadingCount(), t = this.blocks.filter((i) => i.getState() === "needsLoading").slice(0, e);
    this.registerLoads(t.length), t.forEach((i) => i.load()), this.printCacheStatus();
  }
  getBlockState() {
    if (this.gos.isRowModelType("serverSide"))
      return this.rowModel.getBlockStates();
    const e = {};
    return this.blocks.forEach((t) => {
      const { id: i, state: o } = t.getBlockStateJson();
      e[i] = o;
    }), e;
  }
  printCacheStatus() {
    this.gos.get("debug") && se(`RowNodeBlockLoader - printCacheStatus: activePageLoadsCount = ${this.activeBlockLoadsCount}, blocks = ${JSON.stringify(this.getBlockState())}`);
  }
  isLoading() {
    return this.activeBlockLoadsCount > 0;
  }
  registerLoads(e) {
    this.activeBlockLoadsCount += e;
  }
  getAvailableLoadingCount() {
    return this.maxConcurrentRequests !== void 0 ? this.maxConcurrentRequests - this.activeBlockLoadsCount : void 0;
  }
}] }, Ql = class {
  constructor() {
    this.root = null, this.end = null, this.cachedRange = [];
  }
  init(e) {
    this.rowModel = e;
  }
  reset() {
    this.root = null, this.end = null, this.cachedRange.length = 0;
  }
  setRoot(e) {
    this.root = e, this.end = null, this.cachedRange.length = 0;
  }
  setEndRange(e) {
    this.end = e, this.cachedRange.length = 0;
  }
  getRange() {
    if (this.cachedRange.length === 0) {
      const e = this.getRoot(), t = this.getEnd();
      if (e == null || t == null)
        return this.cachedRange;
      this.cachedRange = this.rowModel.getNodesInRangeForSelection(e, t);
    }
    return this.cachedRange;
  }
  isInRange(e) {
    return this.root !== null && this.getRange().some((t) => t.id === e.id);
  }
  getRoot() {
    var e;
    return this.root && ((e = this.root) == null ? void 0 : e.key) === null && (this.root = this.rowModel.getRowNode(this.root.id) ?? null), this.root;
  }
  getEnd() {
    var e;
    return this.end && ((e = this.end) == null ? void 0 : e.key) === null && (this.end = this.rowModel.getRowNode(this.end.id) ?? null), this.end;
  }
  truncate(e) {
    const t = this.getRange();
    if (t.length === 0)
      return { keep: [], discard: [] };
    const i = t[0].id === this.root.id, o = t.findIndex((s) => s.id === e.id);
    if (o > -1) {
      const s = t.slice(0, o), r = t.slice(o + 1);
      return this.setEndRange(e), i ? { keep: s, discard: r } : { keep: r, discard: s };
    }
    return { keep: t, discard: [] };
  }
  extend(e, t = !1) {
    const i = this.getRoot();
    if (i == null) {
      const o = this.getRange().slice();
      return t && e.depthFirstSearch((s) => !s.group && o.push(s)), o.push(e), this.setRoot(e), { keep: o, discard: [] };
    }
    if (this.rowModel.getNodesInRangeForSelection(i, e).find((o) => {
      var s;
      return o.id === ((s = this.end) == null ? void 0 : s.id);
    }))
      return this.setEndRange(e), { keep: this.getRange(), discard: [] };
    {
      const o = this.getRange().slice();
      return this.setEndRange(e), { keep: this.getRange(), discard: o };
    }
  }
}, Yl = class extends f {
  constructor() {
    super(...arguments), this.beanName = "stylingService";
  }
  wireBeans(e) {
    this.expressionService = e.expressionService;
  }
  processAllCellClasses(e, t, i, o) {
    this.processClassRules(void 0, e.cellClassRules, t, i, o), this.processStaticCellClasses(e, t, i);
  }
  processClassRules(e, t, i, o, s) {
    if (t == null && e == null)
      return;
    const r = {}, n = {}, a = (l, d) => {
      l.split(" ").forEach((c) => {
        c.trim() != "" && d(c);
      });
    };
    if (t) {
      const l = Object.keys(t);
      for (let d = 0; d < l.length; d++) {
        const c = l[d], h = t[c];
        let g;
        typeof h == "string" ? g = this.expressionService.evaluate(h, i) : typeof h == "function" && (g = h(i)), a(c, (u) => {
          g ? r[u] = !0 : n[u] = !0;
        });
      }
    }
    e && s && Object.keys(e).forEach((l) => a(l, (d) => {
      r[d] || (n[d] = !0);
    })), s && Object.keys(n).forEach(s), Object.keys(r).forEach(o);
  }
  getStaticCellClasses(e, t) {
    const { cellClass: i } = e;
    if (!i)
      return [];
    let o;
    return o = typeof i == "function" ? i(t) : i, typeof o == "string" && (o = [o]), o || [];
  }
  processStaticCellClasses(e, t, i) {
    this.getStaticCellClasses(e, t).forEach((o) => {
      i(o);
    });
  }
}, ql = class extends f {
  constructor(e) {
    super(), this.skipTabGuardFocus = !1, this.forcingFocusOut = !1, this.allowFocus = !1;
    const { comp: t, eTopGuard: i, eBottomGuard: o, focusTrapActive: s, forceFocusOutWhenTabGuardsAreEmpty: r, isFocusableContainer: n, focusInnerElement: a, onFocusIn: l, onFocusOut: d, shouldStopEventPropagation: c, onTabKeyDown: h, handleKeyDown: g, eFocusableElement: u } = e;
    this.comp = t, this.eTopGuard = i, this.eBottomGuard = o, this.providedFocusInnerElement = a, this.eFocusableElement = u, this.focusTrapActive = !!s, this.forceFocusOutWhenTabGuardsAreEmpty = !!r, this.isFocusableContainer = !!n, this.providedFocusIn = l, this.providedFocusOut = d, this.providedShouldStopEventPropagation = c, this.providedOnTabKeyDown = h, this.providedHandleKeyDown = g;
  }
  wireBeans(e) {
    this.focusService = e.focusService;
  }
  postConstruct() {
    this.createManagedBean(new qe(this.eFocusableElement, { shouldStopEventPropagation: () => this.shouldStopEventPropagation(), onTabKeyDown: (e) => this.onTabKeyDown(e), handleKeyDown: (e) => this.handleKeyDown(e), onFocusIn: (e) => this.onFocusIn(e), onFocusOut: (e) => this.onFocusOut(e) })), this.activateTabGuards(), [this.eTopGuard, this.eBottomGuard].forEach((e) => this.addManagedElementListeners(e, { focus: this.onFocus.bind(this) }));
  }
  handleKeyDown(e) {
    this.providedHandleKeyDown && this.providedHandleKeyDown(e);
  }
  tabGuardsAreActive() {
    return !!this.eTopGuard && this.eTopGuard.hasAttribute("tabIndex");
  }
  shouldStopEventPropagation() {
    return !!this.providedShouldStopEventPropagation && this.providedShouldStopEventPropagation();
  }
  activateTabGuards() {
    if (this.forcingFocusOut)
      return;
    const e = this.gos.get("tabIndex");
    this.comp.setTabIndex(e.toString());
  }
  deactivateTabGuards() {
    this.comp.setTabIndex();
  }
  onFocus(e) {
    if (this.isFocusableContainer && !this.eFocusableElement.contains(e.relatedTarget) && !this.allowFocus)
      return void this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
    if (this.skipTabGuardFocus)
      return void (this.skipTabGuardFocus = !1);
    if (this.forceFocusOutWhenTabGuardsAreEmpty && this.focusService.findFocusableElements(this.eFocusableElement, ".ag-tab-guard").length === 0)
      return void this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
    if (this.isFocusableContainer && this.eFocusableElement.contains(e.relatedTarget))
      return;
    const t = e.target === this.eBottomGuard;
    this.providedFocusInnerElement ? this.providedFocusInnerElement(t) : this.focusInnerElement(t);
  }
  findNextElementOutsideAndFocus(e) {
    const t = this.gos.getDocument(), i = this.focusService.findFocusableElements(t.body, null, !0), o = i.indexOf(e ? this.eTopGuard : this.eBottomGuard);
    if (o === -1)
      return;
    let s, r;
    e ? (s = 0, r = o) : (s = o + 1, r = i.length);
    const n = i.slice(s, r), a = this.gos.get("tabIndex");
    n.sort((l, d) => {
      const c = parseInt(l.getAttribute("tabindex") || "0"), h = parseInt(d.getAttribute("tabindex") || "0");
      return h === a ? 1 : c === a ? -1 : c === 0 ? 1 : h === 0 ? -1 : c - h;
    }), n[e ? n.length - 1 : 0].focus();
  }
  onFocusIn(e) {
    this.focusTrapActive || this.forcingFocusOut || (this.providedFocusIn && this.providedFocusIn(e), this.isFocusableContainer || this.deactivateTabGuards());
  }
  onFocusOut(e) {
    this.focusTrapActive || (this.providedFocusOut && this.providedFocusOut(e), this.eFocusableElement.contains(e.relatedTarget) || this.activateTabGuards());
  }
  onTabKeyDown(e) {
    if (this.providedOnTabKeyDown)
      return void this.providedOnTabKeyDown(e);
    if (this.focusTrapActive || e.defaultPrevented)
      return;
    const t = this.tabGuardsAreActive();
    t && this.deactivateTabGuards();
    const i = this.getNextFocusableElement(e.shiftKey);
    t && setTimeout(() => this.activateTabGuards(), 0), i && (i.focus(), e.preventDefault());
  }
  focusInnerElement(e = !1) {
    const t = this.focusService.findFocusableElements(this.eFocusableElement);
    this.tabGuardsAreActive() && (t.splice(0, 1), t.splice(t.length - 1, 1)), t.length && t[e ? t.length - 1 : 0].focus({ preventScroll: !0 });
  }
  getNextFocusableElement(e) {
    return this.focusService.findNextFocusableElement(this.eFocusableElement, !1, e);
  }
  forceFocusOutOfContainer(e = !1) {
    if (this.forcingFocusOut)
      return;
    const t = e ? this.eTopGuard : this.eBottomGuard;
    this.activateTabGuards(), this.skipTabGuardFocus = !0, this.forcingFocusOut = !0, t.focus(), window.setTimeout(() => {
      this.forcingFocusOut = !1, this.activateTabGuards();
    });
  }
  isTabGuard(e, t) {
    return e === this.eTopGuard && !t || e === this.eBottomGuard && (t ?? !0);
  }
  setAllowFocus(e) {
    this.allowFocus = e;
  }
}, $l = class extends f {
  constructor(e) {
    super(), this.comp = e;
  }
  initialiseTabGuard(e) {
    this.eTopGuard = this.createTabGuard("top"), this.eBottomGuard = this.createTabGuard("bottom"), this.eFocusableElement = this.comp.getFocusableElement();
    const { eTopGuard: t, eBottomGuard: i, eFocusableElement: o } = this, s = [t, i], r = { setTabIndex: (C) => {
      s.forEach((y) => C != null ? y.setAttribute("tabindex", C) : y.removeAttribute("tabindex"));
    } };
    this.addTabGuards(t, i);
    const { focusTrapActive: n = !1, onFocusIn: a, onFocusOut: l, focusInnerElement: d, handleKeyDown: c, onTabKeyDown: h, shouldStopEventPropagation: g, forceFocusOutWhenTabGuardsAreEmpty: u, isFocusableContainer: p } = e;
    this.tabGuardCtrl = this.createManagedBean(new ql({ comp: r, focusTrapActive: n, eTopGuard: t, eBottomGuard: i, eFocusableElement: o, onFocusIn: a, onFocusOut: l, focusInnerElement: d, handleKeyDown: c, onTabKeyDown: h, shouldStopEventPropagation: g, forceFocusOutWhenTabGuardsAreEmpty: u, isFocusableContainer: p }));
  }
  getTabGuardCtrl() {
    return this.tabGuardCtrl;
  }
  createTabGuard(e) {
    const t = this.gos.getDocument().createElement("div"), i = e === "top" ? "ag-tab-guard-top" : "ag-tab-guard-bottom";
    return t.classList.add("ag-tab-guard", i), X(t, "presentation"), t;
  }
  addTabGuards(e, t) {
    this.eFocusableElement.insertAdjacentElement("afterbegin", e), this.eFocusableElement.insertAdjacentElement("beforeend", t);
  }
  removeAllChildrenExceptTabGuards() {
    const e = [this.eTopGuard, this.eBottomGuard];
    j(this.comp.getFocusableElement()), this.addTabGuards(...e);
  }
  forceFocusOutOfContainer(e = !1) {
    this.tabGuardCtrl.forceFocusOutOfContainer(e);
  }
  appendChild(e, t, i) {
    ro(t) || (t = t.getGui());
    const { eBottomGuard: o } = this;
    o ? o.insertAdjacentElement("beforebegin", t) : e(t, i);
  }
}, Tr = class extends O {
  initialiseTabGuard(e) {
    this.tabGuardFeature = this.createManagedBean(new $l(this)), this.tabGuardFeature.initialiseTabGuard(e);
  }
  forceFocusOutOfContainer(e = !1) {
    this.tabGuardFeature.forceFocusOutOfContainer(e);
  }
  appendChild(e, t) {
    this.tabGuardFeature.appendChild(super.appendChild.bind(this), e, t);
  }
}, Jl = 0, Xl = class extends f {
  constructor() {
    super(...arguments), this.beanName = "popupService", this.popupList = [];
  }
  wireBeans(e) {
    this.ctrlsService = e.ctrlsService, this.resizeObserverService = e.resizeObserverService, this.environment = e.environment;
  }
  postConstruct() {
    this.ctrlsService.whenReady((e) => {
      this.gridCtrl = e.gridCtrl;
    }), this.addManagedEventListeners({ gridStylesChanged: this.handleThemeChange.bind(this) });
  }
  getPopupParent() {
    return this.gos.get("popupParent") || this.gridCtrl.getGui();
  }
  positionPopupForMenu(e) {
    const { eventSource: t, ePopup: i } = e, o = this.getPopupIndex(i);
    o !== -1 && (this.popupList[o].alignedToElement = t);
    const s = t.getBoundingClientRect(), r = this.getParentRect(), n = this.keepXYWithinBounds(i, s.top - r.top, 0), a = i.clientWidth > 0 ? i.clientWidth : 200;
    i.style.minWidth = `${a}px`;
    const l = r.right - r.left - a;
    let d;
    function c() {
      return s.right - r.left - 2;
    }
    function h() {
      return s.left - r.left - a;
    }
    this.gos.get("enableRtl") ? (d = h(), d < 0 && (d = c(), this.setAlignedStyles(i, "left")), d > l && (d = 0, this.setAlignedStyles(i, "right"))) : (d = c(), d > l && (d = h(), this.setAlignedStyles(i, "right")), d < 0 && (d = 0, this.setAlignedStyles(i, "left"))), i.style.left = `${d}px`, i.style.top = `${n}px`;
  }
  positionPopupUnderMouseEvent(e) {
    const { ePopup: t, nudgeX: i, nudgeY: o, skipObserver: s } = e;
    this.positionPopup({ ePopup: t, nudgeX: i, nudgeY: o, keepWithinBounds: !0, skipObserver: s, updatePosition: () => this.calculatePointerAlign(e.mouseEvent), postProcessCallback: () => this.callPostProcessPopup(e.type, e.ePopup, null, e.mouseEvent, e.column, e.rowNode) });
  }
  calculatePointerAlign(e) {
    const t = this.getParentRect();
    return { x: e.clientX - t.left, y: e.clientY - t.top };
  }
  positionPopupByComponent(e) {
    const { ePopup: t, nudgeX: i, nudgeY: o, keepWithinBounds: s, eventSource: r, alignSide: n = "left", position: a = "over", column: l, rowNode: d, type: c } = e, h = r.getBoundingClientRect(), g = this.getParentRect(), u = this.getPopupIndex(t);
    u !== -1 && (this.popupList[u].alignedToElement = r), this.positionPopup({ ePopup: t, nudgeX: i, nudgeY: o, keepWithinBounds: s, updatePosition: () => {
      let p, C = h.left - g.left;
      return n === "right" && (C -= t.offsetWidth - h.width), a === "over" ? (p = h.top - g.top, this.setAlignedStyles(t, "over")) : (this.setAlignedStyles(t, "under"), p = this.shouldRenderUnderOrAbove(t, h, g, e.nudgeY || 0) === "under" ? h.top - g.top + h.height : h.top - t.offsetHeight - 2 * (o || 0) - g.top), { x: C, y: p };
    }, postProcessCallback: () => this.callPostProcessPopup(c, t, r, null, l, d) });
  }
  shouldRenderUnderOrAbove(e, t, i, o) {
    const s = i.bottom - t.bottom, r = t.top - i.top, n = e.offsetHeight + o;
    return s > n ? "under" : r > n || r > s ? "above" : "under";
  }
  setAlignedStyles(e, t) {
    const i = this.getPopupIndex(e);
    if (i === -1)
      return;
    const o = this.popupList[i], { alignedToElement: s } = o;
    s && (["right", "left", "over", "above", "under"].forEach((r) => {
      s.classList.remove(`ag-has-popup-positioned-${r}`), e.classList.remove(`ag-popup-positioned-${r}`);
    }), t && (s.classList.add(`ag-has-popup-positioned-${t}`), e.classList.add(`ag-popup-positioned-${t}`)));
  }
  callPostProcessPopup(e, t, i, o, s, r) {
    const n = this.gos.getCallback("postProcessPopup");
    n && n({ column: s, rowNode: r, ePopup: t, type: e, eventSource: i, mouseEvent: o });
  }
  positionPopup(e) {
    const { ePopup: t, keepWithinBounds: i, nudgeX: o, nudgeY: s, skipObserver: r, updatePosition: n } = e, a = { width: 0, height: 0 }, l = (d = !1) => {
      let { x: c, y: h } = n();
      d && t.clientWidth === a.width && t.clientHeight === a.height || (a.width = t.clientWidth, a.height = t.clientHeight, o && (c += o), s && (h += s), i && (c = this.keepXYWithinBounds(t, c, 1), h = this.keepXYWithinBounds(t, h, 0)), t.style.left = `${c}px`, t.style.top = `${h}px`, e.postProcessCallback && e.postProcessCallback());
    };
    if (l(), !r) {
      const d = this.resizeObserverService.observeResize(t, () => l(!0));
      setTimeout(() => d(), 200);
    }
  }
  getActivePopups() {
    return this.popupList.map((e) => e.element);
  }
  getPopupList() {
    return this.popupList;
  }
  getParentRect() {
    const e = this.gos.getDocument();
    let t = this.getPopupParent();
    return t === e.body ? t = e.documentElement : getComputedStyle(t).position === "static" && (t = t.offsetParent), Ts(t);
  }
  keepXYWithinBounds(e, t, i) {
    const o = i === 0, s = o ? "clientHeight" : "clientWidth", r = o ? "top" : "left", n = o ? "height" : "width", a = o ? "scrollTop" : "scrollLeft", l = this.gos.getDocument(), d = l.documentElement, c = this.getPopupParent(), h = e.getBoundingClientRect(), g = c.getBoundingClientRect(), u = l.documentElement.getBoundingClientRect(), p = c === l.body, C = Math.ceil(h[n]);
    let y = p ? (o ? As : ei)(d) + d[a] : c[s];
    p && (y -= Math.abs(u[r] - g[r]));
    const w = y - C;
    return Math.min(Math.max(t, 0), Math.abs(w));
  }
  addPopup(e) {
    const t = this.gos.getDocument(), { eChild: i, ariaLabel: o, alwaysOnTop: s, positionCallback: r, anchorToElement: n } = e;
    if (!t)
      return b("could not find the document, document is empty"), { hideFunc: () => {
      } };
    const a = this.getPopupIndex(i);
    if (a !== -1)
      return { hideFunc: this.popupList[a].hideFunc };
    this.initialisePopupPosition(i);
    const l = this.createPopupWrapper(i, o, !!s), d = this.addEventListenersToPopup({ ...e, wrapperEl: l });
    return r && r(), this.addPopupToPopupList(i, l, d, n), { hideFunc: d };
  }
  initialisePopupPosition(e) {
    const t = this.getPopupParent().getBoundingClientRect();
    S(e.style.top) || (e.style.top = -1 * t.top + "px"), S(e.style.left) || (e.style.left = -1 * t.left + "px");
  }
  createPopupWrapper(e, t, i) {
    const o = this.getPopupParent(), s = document.createElement("div");
    return this.environment.applyThemeClasses(s), s.classList.add("ag-popup"), e.classList.add(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr", "ag-popup-child"), e.hasAttribute("role") || X(e, "dialog"), lt(e, t), s.appendChild(e), o.appendChild(s), i ? this.setAlwaysOnTop(e, !0) : this.bringPopupToFront(e), s;
  }
  handleThemeChange(e) {
    if (e.themeChanged)
      for (const t of this.popupList)
        this.environment.applyThemeClasses(t.wrapper);
  }
  addEventListenersToPopup(e) {
    const t = this.gos.getDocument(), i = this.getPopupParent(), { wrapperEl: o, eChild: s, closedCallback: r, afterGuiAttached: n, closeOnEsc: a, modal: l } = e;
    let d = !1;
    const c = (p) => {
      o.contains(this.gos.getActiveDomElement()) && (p.key !== v.ESCAPE || Ae(p) || u({ keyboardEvent: p }));
    }, h = (p) => u({ mouseEvent: p }), g = (p) => u({ touchEvent: p }), u = (p = {}) => {
      const { mouseEvent: C, touchEvent: y, keyboardEvent: w, forceHide: x } = p;
      (x || !this.isEventFromCurrentPopup({ mouseEvent: C, touchEvent: y }, s) && !d) && (d = !0, i.removeChild(o), t.removeEventListener("keydown", c), t.removeEventListener("mousedown", h), t.removeEventListener("touchstart", g), t.removeEventListener("contextmenu", h), this.eventService.removeEventListener("dragStarted", h), r && r(C || y || w), this.removePopupFromPopupList(s));
    };
    return n && n({ hidePopup: u }), window.setTimeout(() => {
      a && t.addEventListener("keydown", c), l && (t.addEventListener("mousedown", h), this.eventService.addEventListener("dragStarted", h), t.addEventListener("touchstart", g), t.addEventListener("contextmenu", h));
    }, 0), u;
  }
  addPopupToPopupList(e, t, i, o) {
    this.popupList.push({ element: e, wrapper: t, hideFunc: i, instanceId: Jl++, isAnchored: !!o }), o && this.setPopupPositionRelatedToElement(e, o);
  }
  getPopupIndex(e) {
    return this.popupList.findIndex((t) => t.element === e);
  }
  setPopupPositionRelatedToElement(e, t) {
    const i = this.getPopupIndex(e);
    if (i === -1)
      return;
    const o = this.popupList[i];
    if (o.stopAnchoringPromise && o.stopAnchoringPromise.then((r) => r && r()), o.stopAnchoringPromise = void 0, o.isAnchored = !1, !t)
      return;
    const s = this.keepPopupPositionedRelativeTo({ element: t, ePopup: e, hidePopup: o.hideFunc });
    return o.stopAnchoringPromise = s, o.isAnchored = !0, s;
  }
  removePopupFromPopupList(e) {
    this.setAlignedStyles(e, null), this.setPopupPositionRelatedToElement(e, null), this.popupList = this.popupList.filter((t) => t.element !== e);
  }
  keepPopupPositionedRelativeTo(e) {
    const t = this.getPopupParent(), i = t.getBoundingClientRect(), { element: o, ePopup: s } = e, r = o.getBoundingClientRect(), n = i.top - r.top, a = i.left - r.left;
    let l = n, d = a;
    const c = s.style.top, h = parseInt(c.substring(0, c.length - 1), 10), g = s.style.left, u = parseInt(g.substring(0, g.length - 1), 10), p = this.getFrameworkOverrides();
    return new ee((C) => {
      p.wrapIncoming(() => {
        p.setInterval(() => {
          const y = t.getBoundingClientRect(), w = o.getBoundingClientRect();
          if (w.top == 0 && w.left == 0 && w.height == 0 && w.width == 0)
            return void e.hidePopup();
          const x = y.top - w.top;
          if (x != l) {
            const k = this.keepXYWithinBounds(s, h + n - x, 0);
            s.style.top = `${k}px`;
          }
          l = x;
          const E = y.left - w.left;
          if (E != d) {
            const k = this.keepXYWithinBounds(s, u + a - E, 1);
            s.style.left = `${k}px`;
          }
          d = E;
        }, 200).then((y) => {
          C(() => {
            y != null && window.clearInterval(y);
          });
        });
      }, "popupPositioning");
    });
  }
  hasAnchoredPopup() {
    return this.popupList.some((e) => e.isAnchored);
  }
  isEventFromCurrentPopup(e, t) {
    const { mouseEvent: i, touchEvent: o } = e, s = i || o;
    if (!s)
      return !1;
    const r = this.getPopupIndex(t);
    if (r === -1)
      return !1;
    for (let n = r; n < this.popupList.length; n++)
      if (Zr(this.popupList[n].element, s))
        return !0;
    return this.isElementWithinCustomPopup(s.target);
  }
  isElementWithinCustomPopup(e) {
    const t = this.gos.getDocument();
    for (; e && e !== t.body; ) {
      if (e.classList.contains("ag-custom-component-popup") || e.parentElement === null)
        return !0;
      e = e.parentElement;
    }
    return !1;
  }
  getWrapper(e) {
    for (; !e.classList.contains("ag-popup") && e.parentElement; )
      e = e.parentElement;
    return e.classList.contains("ag-popup") ? e : null;
  }
  setAlwaysOnTop(e, t) {
    const i = this.getWrapper(e);
    i && (i.classList.toggle("ag-always-on-top", !!t), t && this.bringPopupToFront(i));
  }
  bringPopupToFront(e) {
    const t = this.getPopupParent(), i = Array.prototype.slice.call(t.querySelectorAll(".ag-popup")), o = i.length, s = Array.prototype.slice.call(t.querySelectorAll(".ag-popup.ag-always-on-top")), r = s.length, n = this.getWrapper(e);
    if (!n || o <= 1 || !t.contains(e))
      return !1;
    const a = i.indexOf(n), l = n.querySelectorAll("div"), d = [];
    l.forEach((h) => {
      h.scrollTop !== 0 && d.push([h, h.scrollTop]);
    });
    let c = !1;
    for (r ? n.classList.contains("ag-always-on-top") ? a !== o - 1 && (T(s).insertAdjacentElement("afterend", n), c = !0) : a !== o - r - 1 && (s[0].insertAdjacentElement("beforebegin", n), c = !0) : a !== o - 1 && (T(i).insertAdjacentElement("afterend", n), c = !0); d.length; ) {
      const h = d.pop();
      h[0].scrollTop = h[1];
    }
    return c;
  }
}, Zl = ["touchstart", "touchend", "touchmove", "touchcancel"], _l = class {
  constructor(e = "javascript") {
    this.frameworkName = e, this.renderingEngine = "vanilla", this.wrapIncoming = (t) => t(), this.wrapOutgoing = (t) => t();
  }
  setInterval(e, t) {
    return new ee((i) => {
      i(window.setInterval(e, t));
    });
  }
  addEventListener(e, t, i, o) {
    const s = He(Zl, t);
    e.addEventListener(t, i, { capture: !!o, passive: s });
  }
  get shouldWrapOutgoing() {
    return !1;
  }
  frameworkComponent(e) {
    return null;
  }
  isFrameworkComponent(e) {
    return !1;
  }
  getDocLink(e) {
    return `https://www.ag-grid.com/${this.frameworkName === "solid" ? "react" : this.frameworkName}-data-grid${e ? `/${e}` : ""}`;
  }
}, ed = class extends f {
  constructor() {
    super(...arguments), this.beanName = "cellNavigationService";
  }
  wireBeans(e) {
    this.visibleColsService = e.visibleColsService, this.rowModel = e.rowModel, this.rowRenderer = e.rowRenderer, this.pinnedRowModel = e.pinnedRowModel, this.paginationService = e.paginationService, this.pageBoundsService = e.pageBoundsService;
  }
  getNextCellToFocus(e, t, i = !1) {
    return i ? this.getNextCellToFocusWithCtrlPressed(e, t) : this.getNextCellToFocusWithoutCtrlPressed(e, t);
  }
  getNextCellToFocusWithCtrlPressed(e, t) {
    const i = e === v.UP, o = e === v.DOWN, s = e === v.LEFT;
    let r, n;
    if (i || o)
      n = i ? this.pageBoundsService.getFirstRow() : this.pageBoundsService.getLastRow(), r = t.column;
    else {
      const a = this.visibleColsService.getAllCols(), l = this.gos.get("enableRtl");
      n = t.rowIndex, r = s !== l ? a[0] : T(a);
    }
    return { rowIndex: n, rowPinned: null, column: r };
  }
  getNextCellToFocusWithoutCtrlPressed(e, t) {
    let i = t, o = !1;
    for (; !o; ) {
      switch (e) {
        case v.UP:
          i = this.getCellAbove(i);
          break;
        case v.DOWN:
          i = this.getCellBelow(i);
          break;
        case v.RIGHT:
          i = this.gos.get("enableRtl") ? this.getCellToLeft(i) : this.getCellToRight(i);
          break;
        case v.LEFT:
          i = this.gos.get("enableRtl") ? this.getCellToRight(i) : this.getCellToLeft(i);
          break;
        default:
          i = null, b("unknown key for navigation ", e);
      }
      o = !i || this.isCellGoodToFocusOn(i);
    }
    return i;
  }
  isCellGoodToFocusOn(e) {
    const t = e.column;
    let i;
    switch (e.rowPinned) {
      case "top":
        i = this.pinnedRowModel.getPinnedTopRow(e.rowIndex);
        break;
      case "bottom":
        i = this.pinnedRowModel.getPinnedBottomRow(e.rowIndex);
        break;
      default:
        i = this.rowModel.getRow(e.rowIndex);
    }
    return !!i && !t.isSuppressNavigable(i);
  }
  getCellToLeft(e) {
    if (!e)
      return null;
    const t = this.visibleColsService.getColBefore(e.column);
    return t ? { rowIndex: e.rowIndex, column: t, rowPinned: e.rowPinned } : null;
  }
  getCellToRight(e) {
    if (!e)
      return null;
    const t = this.visibleColsService.getColAfter(e.column);
    return t ? { rowIndex: e.rowIndex, column: t, rowPinned: e.rowPinned } : null;
  }
  getRowBelow(e) {
    const t = e.rowIndex, i = e.rowPinned;
    if (this.isLastRowInContainer(e))
      switch (i) {
        case "bottom":
          return null;
        case "top":
          return this.rowModel.isRowsToRender() ? { rowIndex: this.pageBoundsService.getFirstRow(), rowPinned: null } : this.pinnedRowModel.isRowsToRender("bottom") ? { rowIndex: 0, rowPinned: "bottom" } : null;
        default:
          return this.pinnedRowModel.isRowsToRender("bottom") ? { rowIndex: 0, rowPinned: "bottom" } : null;
      }
    const o = this.rowModel.getRow(e.rowIndex);
    return this.getNextStickyPosition(o) || { rowIndex: t + 1, rowPinned: i };
  }
  getNextStickyPosition(e, t) {
    if (!this.gos.isGroupRowsSticky() || !e || !e.sticky)
      return;
    let i = [];
    i = this.rowRenderer.getStickyTopRowCtrls().some((n) => n.getRowNode().rowIndex === e.rowIndex) ? [...this.rowRenderer.getStickyTopRowCtrls()].sort((n, a) => n.getRowNode().rowIndex - a.getRowNode().rowIndex) : [...this.rowRenderer.getStickyBottomRowCtrls()].sort((n, a) => a.getRowNode().rowIndex - n.getRowNode().rowIndex);
    const o = t ? -1 : 1, s = i.findIndex((n) => n.getRowNode().rowIndex === e.rowIndex), r = i[s + o];
    return r ? { rowIndex: r.getRowNode().rowIndex, rowPinned: null } : void 0;
  }
  getCellBelow(e) {
    if (!e)
      return null;
    const t = this.getRowBelow(e);
    return t ? { rowIndex: t.rowIndex, column: e.column, rowPinned: t.rowPinned } : null;
  }
  isLastRowInContainer(e) {
    const t = e.rowPinned, i = e.rowIndex;
    return t === "top" ? this.pinnedRowModel.getPinnedTopRowNodes().length - 1 <= i : t === "bottom" ? this.pinnedRowModel.getPinnedBottomRowNodes().length - 1 <= i : this.pageBoundsService.getLastRow() <= i;
  }
  getRowAbove(e) {
    const t = e.rowIndex, i = e.rowPinned;
    if (i ? t === 0 : t === this.pageBoundsService.getFirstRow())
      return i === "top" ? null : i && this.rowModel.isRowsToRender() ? this.getLastBodyCell() : this.pinnedRowModel.isRowsToRender("top") ? this.getLastFloatingTopRow() : null;
    const o = this.rowModel.getRow(e.rowIndex);
    return this.getNextStickyPosition(o, !0) || { rowIndex: t - 1, rowPinned: i };
  }
  getCellAbove(e) {
    if (!e)
      return null;
    const t = this.getRowAbove({ rowIndex: e.rowIndex, rowPinned: e.rowPinned });
    return t ? { rowIndex: t.rowIndex, column: e.column, rowPinned: t.rowPinned } : null;
  }
  getLastBodyCell() {
    return { rowIndex: this.pageBoundsService.getLastRow(), rowPinned: null };
  }
  getLastFloatingTopRow() {
    return { rowIndex: this.pinnedRowModel.getPinnedTopRowNodes().length - 1, rowPinned: "top" };
  }
  getNextTabbedCell(e, t) {
    return t ? this.getNextTabbedCellBackwards(e) : this.getNextTabbedCellForwards(e);
  }
  getNextTabbedCellForwards(e) {
    var r;
    const t = this.visibleColsService.getAllCols();
    let i = e.rowIndex, o = e.rowPinned, s = this.visibleColsService.getColAfter(e.column);
    if (!s) {
      s = t[0];
      const n = this.getRowBelow(e);
      if (A(n) || !n.rowPinned && !(((r = this.paginationService) == null ? void 0 : r.isRowInPage(n)) ?? 1))
        return null;
      i = n ? n.rowIndex : null, o = n ? n.rowPinned : null;
    }
    return { rowIndex: i, column: s, rowPinned: o };
  }
  getNextTabbedCellBackwards(e) {
    var r;
    const t = this.visibleColsService.getAllCols();
    let i = e.rowIndex, o = e.rowPinned, s = this.visibleColsService.getColBefore(e.column);
    if (!s) {
      s = T(t);
      const n = this.getRowAbove({ rowIndex: e.rowIndex, rowPinned: e.rowPinned });
      if (A(n) || !n.rowPinned && !(((r = this.paginationService) == null ? void 0 : r.isRowInPage(n)) ?? 1))
        return null;
      i = n ? n.rowIndex : null, o = n ? n.rowPinned : null;
    }
    return { rowIndex: i, column: s, rowPinned: o };
  }
};
function td(e, t) {
  e.eventService.dispatchEvent(t);
}
var id = class extends f {
  constructor() {
    super(...arguments), this.beanName = "apiFunctionService", this.functions = { dispatchEvent: td }, this.isDestroyed = !1;
  }
  wireBeans(e) {
    this.beans = e;
  }
  postConstruct() {
    this.preDestroyLink = this.frameworkOverrides.getDocLink("grid-lifecycle/#grid-pre-destroyed");
  }
  callFunction(e, t) {
    var o;
    const i = this.functions[e];
    return i ? i.apply(i, [this.beans, ...t]) : this.isDestroyed ? this.destroyedHandler(e) : void (this.isFrameworkMethod(e) || ((o = this.beans.validationService) == null ? void 0 : o.warnMissingApiFunction(e)));
  }
  addFunction(e, t) {
    const { validationService: i } = this.beans;
    i && (t = i.validateApiFunction(e, t)), this.functions[e] = t;
  }
  destroy() {
    this.functions = {}, this.isDestroyed = !0, super.destroy();
  }
  destroyedHandler(e) {
    if (e === "isDestroyed")
      return !0;
    e !== "destroy" && b(`Grid API function ${e}() cannot be called as the grid has been destroyed.
Either clear local references to the grid api, when it is destroyed, or check gridApi.isDestroyed() to avoid calling methods against a destroyed grid.
To run logic when the grid is about to be destroyed use the gridPreDestroy event. See: ${this.preDestroyLink}`);
  }
  isFrameworkMethod(e) {
    return ["preWireBeans", "wireBeans", "preConstruct", "postConstruct"].includes(e);
  }
};
function od(e) {
  const t = e.getBean("apiFunctionService");
  return new Proxy(t, { get(i, o) {
    if (o !== "then")
      return (...s) => i.callFunction(o, s);
  } });
}
function sd(e) {
  return { beanName: "gridApi", bean: od(e) };
}
var rd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "columnDefFactory";
  }
  buildColumnDefs(e, t, i) {
    const o = [], s = {};
    return e.forEach((r) => {
      let n = !0, a = this.createDefFromColumn(r, t, i), l = r.getOriginalParent(), d = null;
      for (; l; ) {
        let c = null;
        if (l.isPadding()) {
          l = l.getOriginalParent();
          continue;
        }
        const h = s[l.getGroupId()];
        if (h) {
          h.children.push(a), n = !1;
          break;
        }
        if (c = this.createDefFromGroup(l), c && (c.children = [a], s[c.groupId] = c, a = c, l = l.getOriginalParent()), l != null && d === l) {
          n = !1;
          break;
        }
        d = l;
      }
      n && o.push(a);
    }), o;
  }
  createDefFromGroup(e) {
    const t = ki(e.getColGroupDef(), ["children"]);
    return t && (t.groupId = e.getGroupId()), t;
  }
  createDefFromColumn(e, t, i) {
    const o = ki(e.getColDef());
    return o.colId = e.getColId(), o.width = e.getActualWidth(), o.rowGroup = e.isRowGroupActive(), o.rowGroupIndex = e.isRowGroupActive() ? t.indexOf(e) : null, o.pivot = e.isPivotActive(), o.pivotIndex = e.isPivotActive() ? i.indexOf(e) : null, o.aggFunc = e.isValueActive() ? e.getAggFunc() : null, o.hide = !e.isVisible() || void 0, o.pinned = e.isPinned() ? e.getPinned() : null, o.sort = e.getSort() ? e.getSort() : null, o.sortIndex = e.getSortIndex() != null ? e.getSortIndex() : null, o;
  }
}, nd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "columnEventDispatcher";
  }
  visibleCols() {
    this.eventService.dispatchEvent({ type: "displayedColumnsChanged" });
  }
  gridColumns() {
    this.eventService.dispatchEvent({ type: "gridColumnsChanged" });
  }
  headerHeight(e) {
    const t = { type: "columnHeaderHeightChanged", column: e, columns: [e], source: "autosizeColumnHeaderHeight" };
    this.eventService.dispatchEvent(t);
  }
  groupOpened(e) {
    const t = { type: "columnGroupOpened", columnGroup: e.length === 1 ? e[0] : void 0, columnGroups: e };
    this.eventService.dispatchEvent(t);
  }
  rowGroupChanged(e, t) {
    const i = { type: "columnRowGroupChanged", columns: e, column: e.length === 1 ? e[0] : null, source: t };
    this.eventService.dispatchEvent(i);
  }
  genericColumnEvent(e, t, i) {
    const o = { type: e, columns: t, column: t.length === 1 ? t[0] : null, source: i };
    this.eventService.dispatchEvent(o);
  }
  pivotModeChanged() {
    this.eventService.dispatchEvent({ type: "columnPivotModeChanged" });
  }
  virtualColumnsChanged(e) {
    const t = { type: "virtualColumnsChanged", afterScroll: e };
    this.eventService.dispatchEvent(t);
  }
  newColumnsLoaded(e) {
    const t = { type: "newColumnsLoaded", source: e };
    this.eventService.dispatchEvent(t);
  }
  everythingChanged(e) {
    const t = { type: "columnEverythingChanged", source: e };
    this.eventService.dispatchEvent(t);
  }
  columnMoved(e) {
    const { movedColumns: t, source: i, toIndex: o, finished: s } = e, r = { type: "columnMoved", columns: t, column: t && t.length === 1 ? t[0] : null, toIndex: o, finished: s, source: i };
    this.eventService.dispatchEvent(r);
  }
  columnPinned(e, t) {
    if (!e.length)
      return;
    const i = e.length === 1 ? e[0] : null, o = this.getCommonValue(e, (r) => r.getPinned()), s = { type: "columnPinned", pinned: o ?? null, columns: e, column: i, source: t };
    this.eventService.dispatchEvent(s);
  }
  columnVisible(e, t) {
    if (!e.length)
      return;
    const i = e.length === 1 ? e[0] : null, o = { type: "columnVisible", visible: this.getCommonValue(e, (s) => s.isVisible()), columns: e, column: i, source: t };
    this.eventService.dispatchEvent(o);
  }
  getCommonValue(e, t) {
    if (!e || e.length == 0)
      return;
    const i = t(e[0]);
    for (let o = 1; o < e.length; o++)
      if (i !== t(e[o]))
        return;
    return i;
  }
  columnChanged(e, t, i) {
    const o = { type: e, columns: t, column: t && t.length == 1 ? t[0] : null, source: i };
    this.eventService.dispatchEvent(o);
  }
  columnResized(e, t, i, o = null) {
    if (e && e.length) {
      const s = { type: "columnResized", columns: e, column: e.length === 1 ? e[0] : null, flexColumns: o, finished: t, source: i };
      this.eventService.dispatchEvent(s);
    }
  }
}, ad = class extends f {
  constructor() {
    super(...arguments), this.beanName = "columnGetStateService";
  }
  wireBeans(e) {
    this.columnModel = e.columnModel, this.funcColsService = e.funcColsService;
  }
  getColumnState() {
    if (A(this.columnModel.getColDefCols()) || !this.columnModel.isAlive())
      return [];
    const e = this.columnModel.getAllCols().map(this.createStateItemFromColumn.bind(this));
    return this.orderColumnStateList(e), e;
  }
  createStateItemFromColumn(e) {
    const t = this.funcColsService.getRowGroupColumns(), i = this.funcColsService.getPivotColumns(), o = e.isRowGroupActive() ? t.indexOf(e) : null, s = e.isPivotActive() ? i.indexOf(e) : null, r = e.isValueActive() ? e.getAggFunc() : null, n = e.getSort() != null ? e.getSort() : null, a = e.getSortIndex() != null ? e.getSortIndex() : null, l = e.getFlex() != null && e.getFlex() > 0 ? e.getFlex() : null;
    return { colId: e.getColId(), width: e.getActualWidth(), hide: !e.isVisible(), pinned: e.getPinned(), sort: n, sortIndex: a, aggFunc: r, rowGroup: e.isRowGroupActive(), rowGroupIndex: o, pivot: e.isPivotActive(), pivotIndex: s, flex: l };
  }
  orderColumnStateList(e) {
    const t = this.columnModel.getCols(), i = new Map(t.map((o, s) => [o.getColId(), s]));
    e.sort((o, s) => (i.has(o.colId) ? i.get(o.colId) : -1) - (i.has(s.colId) ? i.get(s.colId) : -1));
  }
}, ld = class extends f {
  constructor() {
    super(...arguments), this.beanName = "columnGroupStateService";
  }
  wireBeans(e) {
    this.columnModel = e.columnModel, this.columnAnimationService = e.columnAnimationService, this.eventDispatcher = e.columnEventDispatcher, this.visibleColsService = e.visibleColsService;
  }
  getColumnGroupState() {
    const e = [];
    return Fe(null, this.columnModel.getColTree(), (t) => {
      K(t) && e.push({ groupId: t.getGroupId(), open: t.isExpanded() });
    }), e;
  }
  resetColumnGroupState(e) {
    const t = this.columnModel.getColDefColTree();
    if (!t)
      return;
    const i = [];
    Fe(null, t, (o) => {
      if (K(o)) {
        const s = o.getColGroupDef(), r = { groupId: o.getGroupId(), open: s ? s.openByDefault : void 0 };
        i.push(r);
      }
    }), this.setColumnGroupState(i, e);
  }
  setColumnGroupState(e, t) {
    if (!this.columnModel.getColTree())
      return;
    this.columnAnimationService.start();
    const i = [];
    e.forEach((o) => {
      const s = o.groupId, r = o.open, n = this.columnModel.getProvidedColGroup(s);
      n && n.isExpanded() !== r && (n.setExpanded(r), i.push(n));
    }), this.visibleColsService.refresh(t, !0), i.length && this.eventDispatcher.groupOpened(i), this.columnAnimationService.finish();
  }
}, dd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "columnViewportService", this.colsWithinViewport = [], this.headerColsWithinViewport = [], this.colsWithinViewportHash = "", this.rowsOfHeadersToRenderLeft = {}, this.rowsOfHeadersToRenderRight = {}, this.rowsOfHeadersToRenderCenter = {};
  }
  wireBeans(e) {
    this.visibleColsService = e.visibleColsService, this.columnModel = e.columnModel, this.eventDispatcher = e.columnEventDispatcher;
  }
  postConstruct() {
    this.suppressColumnVirtualisation = this.gos.get("suppressColumnVirtualisation");
  }
  setScrollPosition(e, t, i = !1) {
    const o = this.visibleColsService.isBodyWidthDirty();
    if (e !== this.scrollWidth || t !== this.scrollPosition || o) {
      if (this.scrollWidth = e, this.scrollPosition = t, this.visibleColsService.setBodyWidthDirty(), this.gos.get("enableRtl")) {
        const s = this.visibleColsService.getBodyContainerWidth();
        this.viewportLeft = s - this.scrollPosition - this.scrollWidth, this.viewportRight = s - this.scrollPosition;
      } else
        this.viewportLeft = this.scrollPosition, this.viewportRight = this.scrollWidth + this.scrollPosition;
      this.columnModel.isReady() && this.checkViewportColumns(i);
    }
  }
  getHeadersToRender(e, t) {
    let i;
    switch (e) {
      case "left":
        i = this.rowsOfHeadersToRenderLeft[t];
        break;
      case "right":
        i = this.rowsOfHeadersToRenderRight[t];
        break;
      default:
        i = this.rowsOfHeadersToRenderCenter[t];
    }
    return i || [];
  }
  extractViewportColumns() {
    const e = this.visibleColsService.getCenterCols();
    this.isColumnVirtualisationSuppressed() ? (this.colsWithinViewport = e, this.headerColsWithinViewport = e) : (this.colsWithinViewport = e.filter(this.isColumnInRowViewport.bind(this)), this.headerColsWithinViewport = e.filter(this.isColumnInHeaderViewport.bind(this)));
  }
  isColumnVirtualisationSuppressed() {
    return this.suppressColumnVirtualisation || this.viewportRight === 0;
  }
  clear() {
    this.rowsOfHeadersToRenderLeft = {}, this.rowsOfHeadersToRenderRight = {}, this.rowsOfHeadersToRenderCenter = {}, this.colsWithinViewportHash = "";
  }
  isColumnInHeaderViewport(e) {
    return !!e.isAutoHeaderHeight() || this.isColumnInRowViewport(e);
  }
  isColumnInRowViewport(e) {
    if (e.isAutoHeight())
      return !0;
    const t = e.getLeft() || 0, i = t + e.getActualWidth(), o = this.viewportLeft - 200, s = this.viewportRight + 200;
    return !(t < o && i < o || t > s && i > s);
  }
  getViewportColumns() {
    const e = this.visibleColsService.getLeftCols(), t = this.visibleColsService.getRightCols();
    return this.colsWithinViewport.concat(e).concat(t);
  }
  getColsWithinViewport(e) {
    if (!this.columnModel.isColSpanActive())
      return this.colsWithinViewport;
    const t = this.isColumnVirtualisationSuppressed() ? null : this.isColumnInRowViewport.bind(this), i = this.visibleColsService.getColsCenter();
    return this.visibleColsService.getColsForRow(e, i, t, (o) => {
      const s = o.getLeft();
      return S(s) && s > this.viewportLeft;
    });
  }
  checkViewportColumns(e = !1) {
    this.extractViewport() && this.eventDispatcher.virtualColumnsChanged(e);
  }
  calculateHeaderRows() {
    this.rowsOfHeadersToRenderLeft = {}, this.rowsOfHeadersToRenderRight = {}, this.rowsOfHeadersToRenderCenter = {};
    const e = {}, t = this.visibleColsService.getLeftCols(), i = this.visibleColsService.getRightCols();
    this.headerColsWithinViewport.concat(t).concat(i).forEach((s) => e[s.getId()] = !0);
    const o = (s, r, n) => {
      let a = !1;
      for (let l = 0; l < s.length; l++) {
        const d = s[l];
        let c = !1;
        if (Le(d))
          c = e[d.getId()] === !0;
        else {
          const h = d.getDisplayedChildren();
          h && (c = o(h, r, n + 1));
        }
        c && (a = !0, r[n] || (r[n] = []), r[n].push(d));
      }
      return a;
    };
    o(this.visibleColsService.getTreeLeft(), this.rowsOfHeadersToRenderLeft, 0), o(this.visibleColsService.getTreeRight(), this.rowsOfHeadersToRenderRight, 0), o(this.visibleColsService.getTreeCenter(), this.rowsOfHeadersToRenderCenter, 0);
  }
  extractViewport() {
    this.extractViewportColumns();
    const e = this.getViewportColumns().map((i) => `${i.getId()}-${i.getPinned() || "normal"}`).join("#"), t = this.colsWithinViewportHash !== e;
    return t && (this.colsWithinViewportHash = e, this.calculateHeaderRows()), t;
  }
}, cd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "agComponentUtils";
  }
  wireBeans(e) {
    this.componentMetadataProvider = e.componentMetadataProvider;
  }
  adaptFunction(e, t) {
    const i = this.componentMetadataProvider.retrieve(e);
    return i && i.functionAdapter ? i.functionAdapter(t) : null;
  }
  adaptCellRendererFunction(e) {
    return class {
      refresh() {
        return !1;
      }
      getGui() {
        return this.eGui;
      }
      init(t) {
        const i = e(t), o = typeof i;
        this.eGui = o !== "string" && o !== "number" && o !== "boolean" ? i ?? dt("<span></span>") : dt("<span>" + i + "</span>");
      }
    };
  }
  doesImplementIComponent(e) {
    return !!e && e.prototype && "getGui" in e.prototype;
  }
}, hd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "componentMetadataProvider";
  }
  wireBeans(e) {
    this.agComponentUtils = e.agComponentUtils;
  }
  postConstruct() {
    this.componentMetaData = { dateComponent: { mandatoryMethodList: ["getDate", "setDate"], optionalMethodList: ["afterGuiAttached", "setInputPlaceholder", "setInputAriaLabel", "setDisabled", "onParamsUpdated", "refresh"] }, detailCellRenderer: { mandatoryMethodList: [], optionalMethodList: ["refresh"], functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils) }, headerComponent: { mandatoryMethodList: [], optionalMethodList: ["refresh"] }, headerGroupComponent: { mandatoryMethodList: [], optionalMethodList: [] }, loadingCellRenderer: { mandatoryMethodList: [], optionalMethodList: [], functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils) }, loadingOverlayComponent: { mandatoryMethodList: [], optionalMethodList: ["refresh"] }, noRowsOverlayComponent: { mandatoryMethodList: [], optionalMethodList: ["refresh"] }, floatingFilterComponent: { mandatoryMethodList: ["onParentModelChanged"], optionalMethodList: ["afterGuiAttached", "onParamsUpdated", "refresh"] }, cellRenderer: { mandatoryMethodList: [], optionalMethodList: ["refresh", "afterGuiAttached"], functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils) }, cellEditor: { mandatoryMethodList: ["getValue"], optionalMethodList: ["isPopup", "isCancelBeforeStart", "isCancelAfterEnd", "getPopupPosition", "focusIn", "focusOut", "afterGuiAttached", "refresh"] }, innerRenderer: { mandatoryMethodList: [], optionalMethodList: ["afterGuiAttached"], functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils) }, fullWidthCellRenderer: { mandatoryMethodList: [], optionalMethodList: ["refresh", "afterGuiAttached"], functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils) }, groupRowRenderer: { mandatoryMethodList: [], optionalMethodList: ["afterGuiAttached"], functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils) }, filter: { mandatoryMethodList: ["isFilterActive", "doesFilterPass", "getModel", "setModel"], optionalMethodList: ["afterGuiAttached", "afterGuiDetached", "onNewRowsLoaded", "getModelAsString", "onFloatingFilterChanged", "onAnyFilterChanged", "refresh"] }, statusPanel: { mandatoryMethodList: [], optionalMethodList: ["refresh"] }, toolPanel: { mandatoryMethodList: [], optionalMethodList: ["refresh", "getState"] }, tooltipComponent: { mandatoryMethodList: [], optionalMethodList: [] }, menuItem: { mandatoryMethodList: [], optionalMethodList: ["setActive", "select", "setExpanded", "configureDefaults"] } };
  }
  retrieve(e) {
    return this.componentMetaData[e];
  }
}, jo = Object.fromEntries(["rowPositionUtils", "cellPositionUtils", "headerPositionUtils", "paginationAutoPageSizeService", "apiFunctionService", "gridApi", "userComponentRegistry", "agComponentUtils", "componentMetadataProvider", "resizeObserverService", "userComponentFactory", "rowContainerHeightService", "horizontalResizeService", "localeService", "validationService", "pinnedRowModel", "dragService", "visibleColsService", "eventService", "gos", "popupService", "selectionService", "columnFilterService", "quickFilterService", "filterManager", "columnModel", "headerNavigationService", "pageBoundsService", "paginationService", "pageBoundsListener", "rowRenderer", "expressionService", "columnFactory", "alignedGridsService", "navigationService", "valueCache", "valueService", "loggerFactory", "autoWidthCalculator", "filterMenuFactory", "dragAndDropService", "focusService", "mouseEventService", "environment", "cellNavigationService", "stylingService", "scrollVisibleService", "sortController", "columnHoverService", "columnAnimationService", "selectableService", "autoColService", "changeDetectionService", "animationFrameService", "undoRedoService", "columnDefFactory", "rowCssClassCalculator", "rowNodeBlockLoader", "rowNodeSorter", "ctrlsService", "pinnedWidthService", "rowNodeEventThrottle", "ctrlsFactory", "dataTypeService", "syncService", "overlayService", "stateService", "expansionService", "apiEventService", "ariaAnnouncementService", "menuService", "columnApplyStateService", "columnEventDispatcher", "columnMoveService", "columnAutosizeService", "columnGetStateService", "columnGroupStateService", "columnSizeService", "funcColsService", "columnNameService", "columnViewportService", "pivotResultColsService", "showRowGroupColsService"].map((e, t) => [e, t]));
function gd(e, t) {
  return ((e.beanName ? jo[e.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER) - ((t.beanName ? jo[t.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER);
}
function ud(e, t) {
  return (e == null ? void 0 : e.beanName) === "gridDestroyService" ? -1 : 0;
}
var pd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "ctrlsFactory", this.registry = {};
  }
  register(e) {
    this.registry[e.name] = e.classImp;
  }
  getInstance(e, ...t) {
    const i = this.registry[e];
    if (i != null)
      return new i(...t);
  }
}, md = class extends f {
  constructor() {
    super(...arguments), this.beanName = "ctrlsService", this.params = {}, this.ready = !1, this.readyCallbacks = [];
  }
  checkReady() {
    const e = this.params;
    this.ready = e.gridCtrl != null && e.gridBodyCtrl != null && e.center != null && e.left != null && e.right != null && e.bottomCenter != null && e.bottomLeft != null && e.bottomRight != null && e.topCenter != null && e.topLeft != null && e.topRight != null && e.stickyTopCenter != null && e.stickyTopLeft != null && e.stickyTopRight != null && e.stickyBottomCenter != null && e.stickyBottomLeft != null && e.stickyBottomRight != null && e.centerHeader != null && e.leftHeader != null && e.rightHeader != null && e.fakeHScrollComp != null && e.fakeVScrollComp != null && e.gridHeaderCtrl != null, this.ready && (this.readyCallbacks.forEach((t) => t(e)), this.readyCallbacks.length = 0);
  }
  whenReady(e) {
    this.ready ? e(this.params) : this.readyCallbacks.push(e);
  }
  register(e, t) {
    this.params[e] = t, this.checkReady();
  }
  registerHeaderContainer(e, t) {
    const i = this.params;
    switch (t) {
      case "left":
        i.leftHeader = e;
        break;
      case "right":
        i.rightHeader = e;
        break;
      default:
        i.centerHeader = e;
    }
    this.checkReady();
  }
  get(e) {
    return this.params[e];
  }
  getParams() {
    return this.params;
  }
  getGridBodyCtrl() {
    return this.params.gridBodyCtrl;
  }
  getHeaderRowContainerCtrls() {
    const { leftHeader: e, centerHeader: t, rightHeader: i } = this.params;
    return [e, i, t];
  }
  getHeaderRowContainerCtrl(e) {
    const t = this.params;
    switch (e) {
      case "left":
        return t.leftHeader;
      case "right":
        return t.rightHeader;
      default:
        return t.centerHeader;
    }
  }
}, vd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "cellPositionUtils";
  }
  createId(e) {
    const { rowIndex: t, rowPinned: i, column: o } = e;
    return this.createIdFromValues({ rowIndex: t, column: o, rowPinned: i });
  }
  createIdFromValues(e) {
    const { rowIndex: t, rowPinned: i, column: o } = e;
    return `${t}.${i ?? "null"}.${o.getId()}`;
  }
  equals(e, t) {
    const i = e.column === t.column, o = e.rowPinned === t.rowPinned, s = e.rowIndex === t.rowIndex;
    return i && o && s;
  }
}, fd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "rowNodeEventThrottle", this.events = [];
  }
  wireBeans(e) {
    this.animationFrameService = e.animationFrameService, this.rowModel = e.rowModel;
  }
  postConstruct() {
    this.rowModel.getType() == "clientSide" && (this.clientSideRowModel = this.rowModel);
  }
  dispatchExpanded(e, t) {
    if (this.clientSideRowModel == null)
      return void this.eventService.dispatchEvent(e);
    this.events.push(e);
    const i = () => {
      this.clientSideRowModel && this.clientSideRowModel.onRowGroupOpened(), this.events.forEach((o) => this.eventService.dispatchEvent(o)), this.events = [];
    };
    t ? i() : (this.dispatchExpandedDebounced == null && (this.dispatchExpandedDebounced = this.animationFrameService.debounce(i)), this.dispatchExpandedDebounced());
  }
}, Cd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "rowPositionUtils";
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.pinnedRowModel = e.pinnedRowModel, this.pageBoundsService = e.pageBoundsService;
  }
  getFirstRow() {
    let e, t = 0;
    return this.pinnedRowModel.getPinnedTopRowCount() ? e = "top" : this.rowModel.getRowCount() ? (e = null, t = this.pageBoundsService.getFirstRow()) : this.pinnedRowModel.getPinnedBottomRowCount() && (e = "bottom"), e === void 0 ? null : { rowIndex: t, rowPinned: e };
  }
  getLastRow() {
    let e, t = null;
    const i = this.pinnedRowModel.getPinnedBottomRowCount(), o = this.pinnedRowModel.getPinnedTopRowCount();
    return i ? (t = "bottom", e = i - 1) : this.rowModel.getRowCount() ? (t = null, e = this.pageBoundsService.getLastRow()) : o && (t = "top", e = o - 1), e === void 0 ? null : { rowIndex: e, rowPinned: t };
  }
  getRowNode(e) {
    switch (e.rowPinned) {
      case "top":
        return this.pinnedRowModel.getPinnedTopRowNodes()[e.rowIndex];
      case "bottom":
        return this.pinnedRowModel.getPinnedBottomRowNodes()[e.rowIndex];
      default:
        return this.rowModel.getRow(e.rowIndex);
    }
  }
  sameRow(e, t) {
    return !e && !t || !(e && !t || !e && t) && e.rowIndex === t.rowIndex && e.rowPinned == t.rowPinned;
  }
  before(e, t) {
    switch (e.rowPinned) {
      case "top":
        if (t.rowPinned !== "top")
          return !0;
        break;
      case "bottom":
        if (t.rowPinned !== "bottom")
          return !1;
        break;
      default:
        if (S(t.rowPinned))
          return t.rowPinned !== "top";
    }
    return e.rowIndex < t.rowIndex;
  }
}, Ko = { cssName: "--ag-row-height", changeKey: "rowHeightChanged", defaultValue: 42 }, Qo = { cssName: "--ag-header-height", changeKey: "headerHeightChanged", defaultValue: 48 }, Yo = { cssName: "--ag-list-item-height", changeKey: "listItemHeightChanged", defaultValue: 24 }, wd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "environment", this.sizeEls = /* @__PURE__ */ new Map(), this.lastKnownValues = /* @__PURE__ */ new Map(), this.themeClasses = [], this.eThemeAncestor = null, this.eMeasurementContainer = null, this.sizesMeasured = !1;
  }
  wireBeans(e) {
    this.resizeObserverService = e.resizeObserverService, this.eGridDiv = e.eGridDiv;
  }
  postConstruct() {
    this.addManagedPropertyListener("rowHeight", () => this.refreshRowHeightVariable()), this.themeClasses = this.getAncestorThemeClasses(), this.setUpThemeClassObservers(), this.getSizeEl(Ko), this.getSizeEl(Qo), this.getSizeEl(Yo);
  }
  getDefaultRowHeight() {
    return this.getCSSVariablePixelValue(Ko);
  }
  getDefaultHeaderHeight() {
    return this.getCSSVariablePixelValue(Qo);
  }
  getDefaultListItemHeight() {
    return this.getCSSVariablePixelValue(Yo);
  }
  hasMeasuredSizes() {
    return this.sizesMeasured;
  }
  getThemeClasses() {
    return this.themeClasses;
  }
  applyThemeClasses(e) {
    for (const t of Array.from(e.classList))
      t.startsWith("ag-theme-") && !this.themeClasses.includes(t) && e.classList.remove(t);
    for (const t of this.themeClasses)
      e.classList.contains(t) || e.classList.add(t);
  }
  getThemeAncestorElement() {
    return this.eThemeAncestor;
  }
  refreshRowHeightVariable() {
    const e = this.eGridDiv.style.getPropertyValue("--ag-line-height").trim(), t = this.gos.get("rowHeight");
    if (t == null || isNaN(t) || !isFinite(t))
      return e !== null && this.eGridDiv.style.setProperty("--ag-line-height", null), -1;
    const i = `${t}px`;
    return e != i ? (this.eGridDiv.style.setProperty("--ag-line-height", i), t) : e != "" ? parseFloat(e) : -1;
  }
  getCSSVariablePixelValue(e) {
    const t = this.lastKnownValues.get(e);
    if (t != null)
      return t;
    const i = this.measureSizeEl(e);
    return i === "detached" || i === "no-styles" ? e.defaultValue : (this.lastKnownValues.set(e, i), i);
  }
  measureSizeEl(e) {
    const t = this.getSizeEl(e);
    if (t.offsetParent == null)
      return "detached";
    const i = t.offsetWidth;
    return i === qo ? "no-styles" : (this.sizesMeasured = !0, i);
  }
  getSizeEl(e) {
    let t = this.sizeEls.get(e);
    if (t)
      return t;
    let i = this.eMeasurementContainer;
    i || (i = this.eMeasurementContainer = document.createElement("div"), i.className = "ag-measurement-container", this.eGridDiv.appendChild(i)), t = document.createElement("div"), t.style.width = `var(${e.cssName}, ${qo}px)`, i.appendChild(t), this.sizeEls.set(e, t);
    let o = this.measureSizeEl(e);
    o === "no-styles" && b(`no value for ${e.cssName}. This usually means that the grid has been initialised before styles have been loaded. The default value of ${e.defaultValue} will be used and updated when styles load.`);
    const s = this.resizeObserverService.observeResize(t, () => {
      const r = this.measureSizeEl(e);
      r !== "detached" && r !== "no-styles" && (this.lastKnownValues.set(e, r), r !== o && (o = r, this.fireGridStylesChangedEvent(e.changeKey)));
    });
    return this.addDestroyFunc(() => s()), t;
  }
  fireGridStylesChangedEvent(e) {
    const t = { type: "gridStylesChanged", [e]: !0 };
    this.eventService.dispatchEvent(t);
  }
  setUpThemeClassObservers() {
    const e = new MutationObserver(() => {
      const i = this.getAncestorThemeClasses();
      bd(i, this.themeClasses) || (this.themeClasses = i, this.fireGridStylesChangedEvent("themeChanged"));
    });
    let t = this.eGridDiv;
    for (; t; )
      e.observe(t || this.eGridDiv, { attributes: !0, attributeFilter: ["class"] }), t = t.parentElement;
  }
  getAncestorThemeClasses() {
    let e = this.eGridDiv;
    const t = [];
    for (this.eThemeAncestor = null; e; ) {
      const i = Array.from(e.classList).filter((o) => o.startsWith("ag-theme-"));
      for (const o of i)
        this.eThemeAncestor = e, t.includes(o) || t.unshift(o);
      e = e.parentElement;
    }
    return Object.freeze(t);
  }
}, bd = (e, t) => e.length === t.length && e.findIndex((i, o) => e[o] !== t[o]) === -1, qo = 15538, yd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "eventService", this.globalEventService = new ht();
  }
  wireBeans(e) {
    this.globalEventListener = e.globalEventListener, this.globalSyncEventListener = e.globalSyncEventListener;
  }
  postConstruct() {
    if (this.globalEventListener) {
      const e = this.gos.useAsyncEvents();
      this.addGlobalListener(this.globalEventListener, e);
    }
    this.globalSyncEventListener && this.addGlobalListener(this.globalSyncEventListener, !1);
  }
  addEventListener(e, t, i) {
    this.globalEventService.addEventListener(e, t, i);
  }
  removeEventListener(e, t, i) {
    this.globalEventService.removeEventListener(e, t, i);
  }
  addGlobalListener(e, t = !1) {
    this.globalEventService.addGlobalListener(e, t);
  }
  removeGlobalListener(e, t = !1) {
    this.globalEventService.removeGlobalListener(e, t);
  }
  dispatchLocalEvent() {
  }
  dispatchEvent(e) {
    this.globalEventService.dispatchEvent(this.gos.addGridCommonParams(e));
  }
  dispatchEventOnce(e) {
    this.globalEventService.dispatchEventOnce(this.gos.addGridCommonParams(e));
  }
}, Ui = class _ extends f {
  constructor() {
    super(...arguments), this.beanName = "focusService";
  }
  wireBeans(t) {
    this.eGridDiv = t.eGridDiv, this.columnModel = t.columnModel, this.visibleColsService = t.visibleColsService, this.headerNavigationService = t.headerNavigationService, this.headerPositionUtils = t.headerPositionUtils, this.rowRenderer = t.rowRenderer, this.rowPositionUtils = t.rowPositionUtils, this.cellPositionUtils = t.cellPositionUtils, this.navigationService = t.navigationService, this.ctrlsService = t.ctrlsService, this.filterManager = t.filterManager, this.rangeService = t.rangeService, this.advancedFilterService = t.advancedFilterService;
  }
  static addKeyboardModeEvents(t) {
    this.instanceCount > 0 || (t.addEventListener("keydown", _.toggleKeyboardMode), t.addEventListener("mousedown", _.toggleKeyboardMode));
  }
  static removeKeyboardModeEvents(t) {
    this.instanceCount > 0 || (t.addEventListener("keydown", _.toggleKeyboardMode), t.addEventListener("mousedown", _.toggleKeyboardMode));
  }
  static toggleKeyboardMode(t) {
    const i = _.keyboardModeActive, o = t.type === "keydown";
    o && (t.ctrlKey || t.metaKey || t.altKey) || i !== o && (_.keyboardModeActive = o);
  }
  static unregisterGridCompController(t) {
    _.removeKeyboardModeEvents(t);
  }
  postConstruct() {
    const t = this.clearFocusedCell.bind(this);
    this.addManagedEventListeners({ columnPivotModeChanged: t, newColumnsLoaded: this.onColumnEverythingChanged.bind(this), columnGroupOpened: t, columnRowGroupChanged: t }), this.registerKeyboardFocusEvents(), this.ctrlsService.whenReady((i) => {
      this.gridCtrl = i.gridCtrl;
    });
  }
  registerKeyboardFocusEvents() {
    const t = this.gos.getDocument();
    _.addKeyboardModeEvents(t), _.instanceCount++, this.addDestroyFunc(() => {
      _.instanceCount--, _.unregisterGridCompController(t);
    });
  }
  onColumnEverythingChanged() {
    if (!this.focusedCellPosition)
      return;
    const t = this.focusedCellPosition.column, i = this.columnModel.getCol(t.getId());
    t !== i && this.clearFocusedCell();
  }
  isKeyboardMode() {
    return _.keyboardModeActive;
  }
  getFocusCellToUseAfterRefresh() {
    return this.gos.get("suppressFocusAfterRefresh") || !this.focusedCellPosition || this.isDomDataMissingInHierarchy(this.gos.getActiveDomElement(), je.DOM_DATA_KEY_ROW_CTRL) ? null : this.focusedCellPosition;
  }
  getFocusHeaderToUseAfterRefresh() {
    return this.gos.get("suppressFocusAfterRefresh") || !this.focusedHeaderPosition || this.isDomDataMissingInHierarchy(this.gos.getActiveDomElement(), ai.DOM_DATA_KEY_HEADER_CTRL) ? null : this.focusedHeaderPosition;
  }
  isDomDataMissingInHierarchy(t, i) {
    let o = t;
    for (; o; ) {
      if (this.gos.getDomData(o, i))
        return !1;
      o = o.parentNode;
    }
    return !0;
  }
  getFocusedCell() {
    return this.focusedCellPosition;
  }
  shouldRestoreFocus(t) {
    return !!this.isCellRestoreFocused(t) && (setTimeout(() => {
      this.restoredFocusedCellPosition = null;
    }, 0), !0);
  }
  isCellRestoreFocused(t) {
    return this.restoredFocusedCellPosition != null && this.cellPositionUtils.equals(t, this.restoredFocusedCellPosition);
  }
  setRestoreFocusedCell(t) {
    this.getFrameworkOverrides().renderingEngine === "react" && (this.restoredFocusedCellPosition = t);
  }
  getFocusEventParams() {
    const { rowIndex: t, rowPinned: i, column: o } = this.focusedCellPosition, s = { rowIndex: t, rowPinned: i, column: o, isFullWidthCell: !1 }, r = this.rowRenderer.getRowByPosition({ rowIndex: t, rowPinned: i });
    return r && (s.isFullWidthCell = r.isFullWidth()), s;
  }
  clearFocusedCell() {
    if (this.restoredFocusedCellPosition = null, this.focusedCellPosition == null)
      return;
    const t = { type: "cellFocusCleared", ...this.getFocusEventParams() };
    this.focusedCellPosition = null, this.eventService.dispatchEvent(t);
  }
  setFocusedCell(t) {
    const { column: i, rowIndex: o, rowPinned: s, forceBrowserFocus: r = !1, preventScrollOnBrowserFocus: n = !1 } = t, a = this.columnModel.getCol(i);
    if (!a)
      return void (this.focusedCellPosition = null);
    this.focusedCellPosition = a ? { rowIndex: o, rowPinned: Ve(s), column: a } : null;
    const l = { type: "cellFocused", ...this.getFocusEventParams(), forceBrowserFocus: r, preventScrollOnBrowserFocus: n };
    this.eventService.dispatchEvent(l);
  }
  isCellFocused(t) {
    return this.focusedCellPosition != null && this.cellPositionUtils.equals(t, this.focusedCellPosition);
  }
  isRowNodeFocused(t) {
    return this.isRowFocused(t.rowIndex, t.rowPinned);
  }
  isHeaderWrapperFocused(t) {
    if (this.focusedHeaderPosition == null)
      return !1;
    const i = t.getColumnGroupChild(), o = t.getRowIndex(), s = t.getPinned(), { column: r, headerRowIndex: n } = this.focusedHeaderPosition;
    return i === r && o === n && s == r.getPinned();
  }
  clearFocusedHeader() {
    this.focusedHeaderPosition = null;
  }
  getFocusedHeader() {
    return this.focusedHeaderPosition;
  }
  setFocusedHeader(t, i) {
    this.focusedHeaderPosition = { headerRowIndex: t, column: i };
  }
  focusHeaderPosition(t) {
    var d;
    if (this.gos.get("suppressHeaderFocus"))
      return !1;
    const { direction: i, fromTab: o, allowUserOverride: s, event: r, fromCell: n, rowWithoutSpanValue: a } = t;
    let { headerPosition: l } = t;
    if (n && ((d = this.filterManager) != null && d.isAdvancedFilterHeaderActive()))
      return this.focusAdvancedFilter(l);
    if (s) {
      const c = this.getFocusedHeader(), h = this.headerNavigationService.getHeaderRowCount();
      if (o) {
        const g = this.gos.getCallback("tabToNextHeader");
        g && (l = this.getHeaderPositionFromUserFunc({ userFunc: g, direction: i, currentPosition: c, headerPosition: l, headerRowCount: h }));
      } else {
        const g = this.gos.getCallback("navigateToNextHeader");
        g && r && (l = g({ key: r.key, previousHeaderPosition: c, nextHeaderPosition: l, headerRowCount: h, event: r }));
      }
    }
    return !!l && this.focusProvidedHeaderPosition({ headerPosition: l, direction: i, event: r, fromCell: n, rowWithoutSpanValue: a });
  }
  focusHeaderPositionFromUserFunc(t) {
    if (this.gos.get("suppressHeaderFocus"))
      return !1;
    const { userFunc: i, headerPosition: o, direction: s, event: r } = t, n = this.getFocusedHeader(), a = this.headerNavigationService.getHeaderRowCount(), l = this.getHeaderPositionFromUserFunc({ userFunc: i, direction: s, currentPosition: n, headerPosition: o, headerRowCount: a });
    return !!l && this.focusProvidedHeaderPosition({ headerPosition: l, direction: s, event: r });
  }
  getHeaderPositionFromUserFunc(t) {
    const { userFunc: i, direction: o, currentPosition: s, headerPosition: r, headerRowCount: n } = t, a = i({ backwards: o === "Before", previousHeaderPosition: s, nextHeaderPosition: r, headerRowCount: n });
    return a === !0 || a === null ? (a === null && b("Since v31.3 Returning `null` from tabToNextHeader is deprecated. Return `true` to stay on the current header, or `false` to let the browser handle the tab behaviour."), s) : a === !1 ? null : a;
  }
  focusProvidedHeaderPosition(t) {
    var c;
    const { headerPosition: i, direction: o, fromCell: s, rowWithoutSpanValue: r, event: n } = t, { column: a, headerRowIndex: l } = i;
    if (l === -1)
      return (c = this.filterManager) != null && c.isAdvancedFilterHeaderActive() ? this.focusAdvancedFilter(i) : this.focusGridView(a);
    this.headerNavigationService.scrollToColumn(a, o);
    const d = this.ctrlsService.getHeaderRowContainerCtrl(a.getPinned()).focusHeader(i.headerRowIndex, a, n);
    return d && (r != null || s) && this.headerNavigationService.setCurrentHeaderRowWithoutSpan(r ?? -1), d;
  }
  focusFirstHeader() {
    let t = this.visibleColsService.getAllCols()[0];
    if (!t)
      return !1;
    t.getParent() && (t = this.visibleColsService.getColGroupAtLevel(t, 0));
    const i = this.headerPositionUtils.getHeaderIndexToFocus(t, 0);
    return this.focusHeaderPosition({ headerPosition: i, rowWithoutSpanValue: 0 });
  }
  focusLastHeader(t) {
    const i = this.headerNavigationService.getHeaderRowCount() - 1, o = T(this.visibleColsService.getAllCols());
    return this.focusHeaderPosition({ headerPosition: { headerRowIndex: i, column: o }, rowWithoutSpanValue: -1, event: t });
  }
  focusPreviousFromFirstCell(t) {
    var i;
    return (i = this.filterManager) != null && i.isAdvancedFilterHeaderActive() ? this.focusAdvancedFilter(null) : this.focusLastHeader(t);
  }
  isAnyCellFocused() {
    return !!this.focusedCellPosition;
  }
  isRowFocused(t, i) {
    return this.focusedCellPosition != null && this.focusedCellPosition.rowIndex === t && this.focusedCellPosition.rowPinned === Ve(i);
  }
  findFocusableElements(t, i, o = !1) {
    let s = ks;
    i && (s += ", " + i), o && (s += ', [tabindex="-1"]');
    const r = Array.prototype.slice.apply(t.querySelectorAll("[tabindex], input, select, button, textarea, [href]")).filter((l) => he(l)), n = Array.prototype.slice.apply(t.querySelectorAll(s));
    return n.length ? (a = n, r.filter((l) => a.indexOf(l) === -1)) : r;
    var a;
  }
  focusInto(t, i = !1, o = !1) {
    const s = this.findFocusableElements(t, null, o), r = i ? T(s) : s[0];
    return !!r && (r.focus({ preventScroll: !0 }), !0);
  }
  findFocusableElementBeforeTabGuard(t, i) {
    if (!i)
      return null;
    const o = this.findFocusableElements(t), s = o.indexOf(i);
    if (s === -1)
      return null;
    let r = -1;
    for (let n = s - 1; n >= 0; n--)
      if (o[n].classList.contains("ag-tab-guard-top")) {
        r = n;
        break;
      }
    return r <= 0 ? null : o[r - 1];
  }
  findNextFocusableElement(t = this.eGridDiv, i, o) {
    const s = this.findFocusableElements(t, i ? ':not([tabindex="-1"])' : null), r = this.gos.getActiveDomElement();
    let n;
    n = i ? s.findIndex((l) => l.contains(r)) : s.indexOf(r);
    const a = n + (o ? -1 : 1);
    return a < 0 || a >= s.length ? null : s[a];
  }
  isTargetUnderManagedComponent(t, i) {
    if (!i)
      return !1;
    const o = t.querySelectorAll(`.${qe.FOCUS_MANAGED_CLASS}`);
    if (!o.length)
      return !1;
    for (let s = 0; s < o.length; s++)
      if (o[s].contains(i))
        return !0;
    return !1;
  }
  findTabbableParent(t, i = 5) {
    let o = 0;
    for (; t && Oi(t) === null && ++o <= i; )
      t = t.parentElement;
    return Oi(t) === null ? null : t;
  }
  focusGridView(t, i) {
    var a;
    if (this.gos.get("suppressCellFocus"))
      return i ? this.gos.get("suppressHeaderFocus") ? this.focusNextGridCoreContainer(!0, !0) : this.focusLastHeader() : this.focusNextGridCoreContainer(!1);
    const o = i ? this.rowPositionUtils.getLastRow() : this.rowPositionUtils.getFirstRow();
    if (!o)
      return !1;
    const { rowIndex: s, rowPinned: r } = o, n = this.getFocusedHeader();
    return !t && n && (t = n.column), !(s == null || !t || (this.navigationService.ensureCellVisible({ rowIndex: s, column: t, rowPinned: r }), this.setFocusedCell({ rowIndex: s, column: t, rowPinned: Ve(r), forceBrowserFocus: !0 }), (a = this.rangeService) == null || a.setRangeToCell({ rowIndex: s, rowPinned: r, column: t }), 0));
  }
  focusNextGridCoreContainer(t, i = !1) {
    return !(i || !this.gridCtrl.focusNextInnerContainer(t)) || ((i || !t && !this.gridCtrl.isDetailGrid()) && this.gridCtrl.forceFocusOutOfContainer(t), !1);
  }
  focusAdvancedFilter(t) {
    var i;
    return this.advancedFilterFocusColumn = t == null ? void 0 : t.column, ((i = this.advancedFilterService) == null ? void 0 : i.getCtrl().focusHeaderComp()) ?? !1;
  }
  focusNextFromAdvancedFilter(t, i) {
    var s;
    const o = (i ? void 0 : this.advancedFilterFocusColumn) ?? ((s = this.visibleColsService.getAllCols()) == null ? void 0 : s[0]);
    return t ? this.focusHeaderPosition({ headerPosition: { column: o, headerRowIndex: this.headerNavigationService.getHeaderRowCount() - 1 } }) : this.focusGridView(o);
  }
  clearAdvancedFilterColumn() {
    this.advancedFilterFocusColumn = void 0;
  }
  addFocusableContainer(t) {
    this.gridCtrl.addFocusableContainer(t);
  }
  removeFocusableContainer(t) {
    this.gridCtrl.removeFocusableContainer(t);
  }
  focusGridInnerElement(t) {
    return this.gridCtrl.focusInnerElement(t);
  }
};
Ui.keyboardModeActive = !1, Ui.instanceCount = 0;
var Sd = Ui, Rd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "pinnedWidthService";
  }
  wireBeans(e) {
    this.visibleColsService = e.visibleColsService;
  }
  postConstruct() {
    const e = this.checkContainerWidths.bind(this);
    this.addManagedEventListeners({ displayedColumnsChanged: e, displayedColumnsWidthChanged: e }), this.addManagedPropertyListener("domLayout", e);
  }
  checkContainerWidths() {
    const e = this.gos.isDomLayout("print"), t = e ? 0 : this.visibleColsService.getColsLeftWidth(), i = e ? 0 : this.visibleColsService.getDisplayedColumnsRightWidth();
    t != this.leftWidth && (this.leftWidth = t, this.eventService.dispatchEvent({ type: "leftPinnedWidthChanged" })), i != this.rightWidth && (this.rightWidth = i, this.eventService.dispatchEvent({ type: "rightPinnedWidthChanged" }));
  }
  getPinnedRightWidth() {
    return this.rightWidth;
  }
  getPinnedLeftWidth() {
    return this.leftWidth;
  }
}, xd = class extends f {
  constructor() {
    super(...arguments), this.additionalFocusableContainers = /* @__PURE__ */ new Set();
  }
  wireBeans(e) {
    this.beans = e, this.focusService = e.focusService, this.visibleColsService = e.visibleColsService;
  }
  setComp(e, t, i) {
    this.view = e, this.eGridHostDiv = t, this.eGui = i, this.eGui.setAttribute("grid-id", this.gridId);
    const { dragAndDropService: o, mouseEventService: s, ctrlsService: r, resizeObserverService: n } = this.beans;
    o.addDropTarget({ getContainer: () => this.eGui, isInterestedIn: (l) => l === 1 || l === 0, getIconName: () => "notAllowed" }), s.stampTopLevelGridCompWithGridInstance(t), this.createManagedBean(new So(this.view)), this.addRtlSupport();
    const a = n.observeResize(this.eGridHostDiv, this.onGridSizeChanged.bind(this));
    this.addDestroyFunc(() => a()), r.register("gridCtrl", this);
  }
  isDetailGrid() {
    var t;
    const e = this.focusService.findTabbableParent(this.getGui());
    return ((t = e == null ? void 0 : e.getAttribute("row-id")) == null ? void 0 : t.startsWith("detail")) || !1;
  }
  getOptionalSelectors() {
    var t, i, o, s, r;
    const e = this.beans;
    return { paginationSelector: (t = e.paginationService) == null ? void 0 : t.getPaginationSelector(), gridHeaderDropZonesSelector: (i = e.columnDropZonesService) == null ? void 0 : i.getDropZoneSelector(), sideBarSelector: (o = e.sideBarService) == null ? void 0 : o.getSideBarSelector(), statusBarSelector: (s = e.statusBarService) == null ? void 0 : s.getStatusPanelSelector(), watermarkSelector: (r = e.licenseManager) == null ? void 0 : r.getWatermarkSelector() };
  }
  onGridSizeChanged() {
    const e = { type: "gridSizeChanged", clientWidth: this.eGridHostDiv.clientWidth, clientHeight: this.eGridHostDiv.clientHeight };
    this.eventService.dispatchEvent(e);
  }
  addRtlSupport() {
    const e = this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr";
    this.view.setRtlClass(e);
  }
  destroyGridUi() {
    this.view.destroyGridUi();
  }
  getGui() {
    return this.eGui;
  }
  setResizeCursor(e) {
    this.view.setCursor(e ? "ew-resize" : null);
  }
  disableUserSelect(e) {
    this.view.setUserSelect(e ? "none" : null);
  }
  focusNextInnerContainer(e) {
    const t = this.getFocusableContainers(), i = this.gos.getActiveDomElement(), o = t.findIndex((r) => r.getGui().contains(i)), s = o + (e ? -1 : 1);
    if (s < 0 || s >= t.length)
      return !1;
    if (s === 0) {
      if (o > 0) {
        const r = T(this.visibleColsService.getAllCols());
        if (this.focusService.focusGridView(r, !0))
          return !0;
      }
      return !1;
    }
    return this.focusContainer(t[s], e);
  }
  focusInnerElement(e) {
    const t = this.getFocusableContainers(), i = this.visibleColsService.getAllCols(), o = this.gos.getCallback("focusGridInnerElement");
    if (o && o({ fromBottom: !!e }))
      return !0;
    if (e) {
      if (t.length > 1)
        return this.focusContainer(T(t), !0);
      const s = T(i);
      if (this.focusService.focusGridView(s, !0))
        return !0;
    }
    if (this.gos.get("headerHeight") === 0 || this.gos.get("suppressHeaderFocus")) {
      if (this.focusService.focusGridView(i[0]))
        return !0;
      for (let s = 1; s < t.length; s++)
        if (this.focusService.focusInto(t[s].getGui()))
          return !0;
      return !1;
    }
    return this.focusService.focusFirstHeader();
  }
  forceFocusOutOfContainer(e = !1) {
    this.view.forceFocusOutOfContainer(e);
  }
  addFocusableContainer(e) {
    this.additionalFocusableContainers.add(e);
  }
  removeFocusableContainer(e) {
    this.additionalFocusableContainers.delete(e);
  }
  focusContainer(e, t) {
    var o, s;
    (o = e == null ? void 0 : e.setAllowFocus) == null || o.call(e, !0);
    const i = this.focusService.focusInto(e.getGui(), t);
    return (s = e == null ? void 0 : e.setAllowFocus) == null || s.call(e, !1), i;
  }
  getFocusableContainers() {
    return [...this.view.getFocusableContainers(), ...this.additionalFocusableContainers.values()];
  }
  destroy() {
    this.additionalFocusableContainers.clear(), super.destroy();
  }
}, Fd = class extends Tr {
  constructor(e) {
    super(), this.gridBody = R, this.sideBar = R, this.pagination = R, this.rootWrapperBody = R, this.eGridDiv = e;
  }
  postConstruct() {
    const e = { destroyGridUi: () => this.destroyBean(this), setRtlClass: (r) => this.addCssClass(r), forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this), updateLayoutClasses: this.updateLayoutClasses.bind(this), getFocusableContainers: this.getFocusableContainers.bind(this), setUserSelect: (r) => {
      this.getGui().style.userSelect = r ?? "", this.getGui().style.webkitUserSelect = r ?? "";
    }, setCursor: (r) => {
      this.getGui().style.cursor = r ?? "";
    } }, t = this.createManagedBean(new xd()), i = t.getOptionalSelectors(), o = this.createTemplate(i), s = [bl, ...Object.values(i).filter((r) => !!r)];
    this.setTemplate(o, s), t.setComp(e, this.eGridDiv, this.getGui()), this.insertGridIntoDom(), this.initialiseTabGuard({ onTabKeyDown: () => {
    }, focusInnerElement: (r) => t.focusInnerElement(r), forceFocusOutWhenTabGuardsAreEmpty: !0 });
  }
  insertGridIntoDom() {
    const e = this.getGui();
    this.eGridDiv.appendChild(e), this.addDestroyFunc(() => {
      this.eGridDiv.removeChild(e), this.gos.get("debug") && se("Grid removed from DOM");
    });
  }
  updateLayoutClasses(e, t) {
    const i = this.rootWrapperBody.classList;
    i.toggle("ag-layout-auto-height", t.autoHeight), i.toggle("ag-layout-normal", t.normal), i.toggle("ag-layout-print", t.print), this.addOrRemoveCssClass("ag-layout-auto-height", t.autoHeight), this.addOrRemoveCssClass("ag-layout-normal", t.normal), this.addOrRemoveCssClass("ag-layout-print", t.print);
  }
  createTemplate(e) {
    const t = e.gridHeaderDropZonesSelector ? "<ag-grid-header-drop-zones></ag-grid-header-drop-zones>" : "", i = e.sideBarSelector ? '<ag-side-bar data-ref="sideBar"></ag-side-bar>' : "", o = e.statusBarSelector ? "<ag-status-bar></ag-status-bar>" : "", s = e.watermarkSelector ? "<ag-watermark></ag-watermark>" : "";
    return `<div class="ag-root-wrapper" role="presentation">
                ${t}
                <div class="ag-root-wrapper-body" data-ref="rootWrapperBody" role="presentation">
                    <ag-grid-body data-ref="gridBody"></ag-grid-body>
                    ${i}
                </div>
                ${o}
                ${e.paginationSelector ? '<ag-pagination data-ref="pagination"></ag-pagination>' : ""}
                ${s}
            </div>`;
  }
  getFocusableElement() {
    return this.rootWrapperBody;
  }
  forceFocusOutOfContainer(e = !1) {
    var t;
    e || !((t = this.pagination) != null && t.isDisplayed()) ? super.forceFocusOutOfContainer(e) : this.pagination.forceFocusOutOfContainer(e);
  }
  getFocusableContainers() {
    const e = [this.gridBody];
    return [this.sideBar, this.pagination].forEach((t) => {
      t && e.push(t);
    }), e.filter((t) => he(t.getGui()));
  }
}, Dd = { version: M, moduleName: "@ag-grid-community/aligned-grid", beans: [class extends f {
  constructor() {
    super(...arguments), this.beanName = "alignedGridsService", this.consuming = !1;
  }
  wireBeans(e) {
    this.columnModel = e.columnModel, this.columnSizeService = e.columnSizeService, this.ctrlsService = e.ctrlsService, this.columnApplyStateService = e.columnApplyStateService;
  }
  getAlignedGridApis() {
    let e = this.gos.get("alignedGrids") ?? [];
    const t = typeof e == "function";
    typeof e == "function" && (e = e());
    const i = () => `See ${this.getFrameworkOverrides().getDocLink("aligned-grids")}`;
    return e.map((o) => {
      var r;
      if (!o)
        return L("alignedGrids contains an undefined option."), t || L(`You may want to configure via a callback to avoid setup race conditions:
                     "alignedGrids: () => [linkedGrid]"`), void L(i());
      if (this.isGridApi(o))
        return o;
      const s = o;
      return "current" in s ? (r = s.current) == null ? void 0 : r.api : (s.api || L(`alignedGrids - No api found on the linked grid. If you are passing gridOptions to alignedGrids since v31 this is no longer valid. ${i()}`), s.api);
    }).filter((o) => !!o && !o.isDestroyed());
  }
  isGridApi(e) {
    return !!e && !!e.dispatchEvent;
  }
  postConstruct() {
    const e = this.fireColumnEvent.bind(this);
    this.addManagedEventListeners({ columnMoved: e, columnVisible: e, columnPinned: e, columnGroupOpened: e, columnResized: e, bodyScroll: this.fireScrollEvent.bind(this), alignedGridColumn: ({ event: t }) => this.onColumnEvent(t), alignedGridScroll: ({ event: t }) => this.onScrollEvent(t) });
  }
  fireEvent(e) {
    this.consuming || this.getAlignedGridApis().forEach((t) => {
      t.isDestroyed() || t.dispatchEvent(e);
    });
  }
  onEvent(e) {
    this.consuming = !0, e(), this.consuming = !1;
  }
  fireColumnEvent(e) {
    const t = { type: "alignedGridColumn", event: e };
    this.fireEvent(t);
  }
  fireScrollEvent(e) {
    if (e.direction !== "horizontal")
      return;
    const t = { type: "alignedGridScroll", event: e };
    this.fireEvent(t);
  }
  onScrollEvent(e) {
    this.onEvent(() => {
      this.ctrlsService.getGridBodyCtrl().getScrollFeature().setHorizontalScrollPosition(e.left, !0);
    });
  }
  getMasterColumns(e) {
    const t = [];
    return e.columns ? e.columns.forEach((i) => {
      t.push(i);
    }) : e.column && t.push(e.column), t;
  }
  getColumnIds(e) {
    const t = [];
    return e.columns ? e.columns.forEach((i) => {
      t.push(i.getColId());
    }) : e.column && t.push(e.column.getColId()), t;
  }
  onColumnEvent(e) {
    this.onEvent(() => {
      switch (e.type) {
        case "columnMoved":
        case "columnVisible":
        case "columnPinned":
        case "columnResized": {
          const t = e;
          this.processColumnEvent(t);
          break;
        }
        case "columnGroupOpened": {
          const t = e;
          this.processGroupOpenedEvent(t);
          break;
        }
        case "columnPivotChanged":
          b("pivoting is not supported with aligned grids. You can only use one of these features at a time in a grid.");
      }
    });
  }
  processGroupOpenedEvent(e) {
    e.columnGroups.forEach((t) => {
      let i = null;
      if (t) {
        const o = t.getGroupId();
        i = this.columnModel.getProvidedColGroup(o);
      }
      t && !i || this.columnModel.setColumnGroupOpened(i, t.isExpanded(), "alignedGridChanged");
    });
  }
  processColumnEvent(e) {
    var r;
    const t = e.column;
    let i = null;
    if (t && (i = this.columnModel.getColDefCol(t.getColId())), t && !i)
      return;
    const o = this.getMasterColumns(e);
    switch (e.type) {
      case "columnMoved":
        {
          const n = e.api.getColumnState().map((a) => ({ colId: a.colId }));
          this.columnApplyStateService.applyColumnState({ state: n, applyOrder: !0 }, "alignedGridChanged");
        }
        break;
      case "columnVisible":
        {
          const n = e.api.getColumnState().map((a) => ({ colId: a.colId, hide: a.hide }));
          this.columnApplyStateService.applyColumnState({ state: n }, "alignedGridChanged");
        }
        break;
      case "columnPinned":
        {
          const n = e.api.getColumnState().map((a) => ({ colId: a.colId, pinned: a.pinned }));
          this.columnApplyStateService.applyColumnState({ state: n }, "alignedGridChanged");
        }
        break;
      case "columnResized": {
        const n = e, a = {};
        o.forEach((l) => {
          a[l.getId()] = { key: l.getColId(), newWidth: l.getActualWidth() };
        }), (r = n.flexColumns) == null || r.forEach((l) => {
          a[l.getId()] && delete a[l.getId()];
        }), this.columnSizeService.setColumnWidths(Object.values(a), !1, n.finished, "alignedGridChanged");
        break;
      }
    }
    const s = this.ctrlsService.getGridBodyCtrl().isVerticalScrollShowing();
    this.getAlignedGridApis().forEach((n) => {
      n.setGridOption("alwaysShowVerticalScroll", s);
    });
  }
}] }, $o = { january: "January", february: "February", march: "March", april: "April", may: "May", june: "June", july: "July", august: "August", september: "September", october: "October", november: "November", december: "December" }, Jo = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"], Md = { version: M, moduleName: "@ag-grid-community/data-type", beans: [class extends f {
  constructor() {
    super(...arguments), this.beanName = "dataTypeService", this.dataTypeDefinitions = {}, this.isWaitingForRowData = !1, this.isColumnTypeOverrideInDataTypeDefinitions = !1, this.columnStateUpdatesPendingInference = {}, this.columnStateUpdateListenerDestroyFuncs = [];
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.columnModel = e.columnModel, this.funcColsService = e.funcColsService, this.valueService = e.valueService, this.columnApplyStateService = e.columnApplyStateService;
  }
  postConstruct() {
    this.groupHideOpenParents = this.gos.get("groupHideOpenParents"), this.addManagedPropertyListener("groupHideOpenParents", () => {
      this.groupHideOpenParents = this.gos.get("groupHideOpenParents");
    }), this.processDataTypeDefinitions(), this.addManagedPropertyListener("dataTypeDefinitions", (e) => {
      this.processDataTypeDefinitions(), this.columnModel.recreateColumnDefs(st(e.source));
    });
  }
  processDataTypeDefinitions() {
    const e = this.getDefaultDataTypes();
    this.dataTypeDefinitions = {}, this.formatValueFuncs = {};
    const t = (o) => (s) => {
      const { column: r, node: n, value: a } = s;
      let l = r.getColDef().valueFormatter;
      return l === o.groupSafeValueFormatter && (l = o.valueFormatter), this.valueService.formatValue(r, n, a, l);
    };
    Object.entries(e).forEach(([o, s]) => {
      const r = { ...s, groupSafeValueFormatter: this.createGroupSafeValueFormatter(s) };
      this.dataTypeDefinitions[o] = r, this.formatValueFuncs[o] = t(r);
    });
    const i = this.gos.get("dataTypeDefinitions") ?? {};
    this.dataTypeMatchers = {}, Object.entries(i).forEach(([o, s]) => {
      const r = this.processDataTypeDefinition(s, i, [o], e);
      r && (this.dataTypeDefinitions[o] = r, s.dataTypeMatcher && (this.dataTypeMatchers[o] = s.dataTypeMatcher), this.formatValueFuncs[o] = t(r));
    }), this.checkObjectValueHandlers(e), ["dateString", "text", "number", "boolean", "date"].forEach((o) => {
      const s = this.dataTypeMatchers[o];
      s && delete this.dataTypeMatchers[o], this.dataTypeMatchers[o] = s ?? e[o].dataTypeMatcher;
    });
  }
  mergeDataTypeDefinitions(e, t) {
    const i = { ...e, ...t };
    return e.columnTypes && t.columnTypes && t.appendColumnTypes && (i.columnTypes = [...Qt(e.columnTypes), ...Qt(t.columnTypes)]), i;
  }
  processDataTypeDefinition(e, t, i, o) {
    let s;
    const r = e.extendsDataType;
    if (e.columnTypes && (this.isColumnTypeOverrideInDataTypeDefinitions = !0), e.extendsDataType === e.baseDataType) {
      let n = o[r];
      const a = t[r];
      if (n && a && (n = a), !this.validateDataTypeDefinition(e, n, r))
        return;
      s = this.mergeDataTypeDefinitions(n, e);
    } else {
      if (i.includes(r))
        return void b('Data type definition hierarchies (via the "extendsDataType" property) cannot contain circular references.');
      const n = t[r];
      if (!this.validateDataTypeDefinition(e, n, r))
        return;
      const a = this.processDataTypeDefinition(n, t, [...i, r], o);
      if (!a)
        return;
      s = this.mergeDataTypeDefinitions(a, e);
    }
    return { ...s, groupSafeValueFormatter: this.createGroupSafeValueFormatter(s) };
  }
  validateDataTypeDefinition(e, t, i) {
    return t ? t.baseDataType === e.baseDataType || (b('The "baseDataType" property of a data type definition must match that of its parent.'), !1) : (b(`The data type definition ${i} does not exist.`), !1);
  }
  createGroupSafeValueFormatter(e) {
    if (e.valueFormatter)
      return (t) => {
        var i, o;
        if ((i = t.node) != null && i.group) {
          const s = t.column.getAggFunc();
          if (s) {
            if (s === "first" || s === "last")
              return e.valueFormatter(t);
            if (e.baseDataType === "number" && s !== "count") {
              if (typeof t.value == "number")
                return e.valueFormatter(t);
              if (typeof t.value == "object") {
                if (!t.value)
                  return;
                if ("toNumber" in t.value)
                  return e.valueFormatter({ ...t, value: t.value.toNumber() });
                if ("value" in t.value)
                  return e.valueFormatter({ ...t, value: t.value.value });
              }
            }
          }
          if (!this.gos.get("suppressGroupMaintainValueType"))
            return;
        } else if (this.groupHideOpenParents && t.column.isRowGroupActive()) {
          if (typeof t.value != "string" || (o = e.dataTypeMatcher) != null && o.call(e, t.value))
            return e.valueFormatter(t);
          if (!this.gos.get("suppressGroupMaintainValueType"))
            return;
        }
        return e.valueFormatter(t);
      };
  }
  updateColDefAndGetColumnType(e, t, i) {
    let { cellDataType: o } = t;
    const { field: s } = t;
    if (o === void 0 && (o = e.cellDataType), o != null && o !== !0 || (o = !!this.canInferCellDataType(e, t) && this.inferCellDataType(s, i)), !o)
      return void (e.cellDataType = !1);
    const r = this.dataTypeDefinitions[o];
    if (r)
      return e.cellDataType = o, r.groupSafeValueFormatter && (e.valueFormatter = r.groupSafeValueFormatter), r.valueParser && (e.valueParser = r.valueParser), r.suppressDefaultProperties || this.setColDefPropertiesForBaseDataType(e, o, r, i), r.columnTypes;
    b(`Missing data type definition - "${o}"`);
  }
  addColumnListeners(e) {
    if (!this.isWaitingForRowData)
      return;
    const t = this.columnStateUpdatesPendingInference[e.getColId()];
    if (!t)
      return;
    const i = (o) => {
      t.add(o.key);
    };
    e.addEventListener("columnStateUpdated", i), this.columnStateUpdateListenerDestroyFuncs.push(() => e.removeEventListener("columnStateUpdated", i));
  }
  canInferCellDataType(e, t) {
    if (this.rowModel.getType() !== "clientSide")
      return !1;
    const i = { cellRenderer: !0, valueGetter: !0, valueParser: !0, refData: !0 };
    if (this.doColDefPropsPreventInference(t, i))
      return !1;
    const o = t.type === null ? e.type : t.type;
    if (o) {
      const s = this.gos.get("columnTypes") ?? {};
      if (Qt(o).some((r) => {
        const n = s[r.trim()];
        return n && this.doColDefPropsPreventInference(n, i);
      }))
        return !1;
    }
    return !this.doColDefPropsPreventInference(e, i);
  }
  doColDefPropsPreventInference(e, t) {
    return [["cellRenderer", "agSparklineCellRenderer"], ["valueGetter", void 0], ["valueParser", void 0], ["refData", void 0]].some(([i, o]) => this.doesColDefPropPreventInference(e, t, i, o));
  }
  doesColDefPropPreventInference(e, t, i, o) {
    if (!t[i])
      return !1;
    const s = e[i];
    return s === null ? (t[i] = !1, !1) : o === void 0 ? !!s : s === o;
  }
  inferCellDataType(e, t) {
    if (!e)
      return;
    let i;
    const o = this.getInitialData();
    if (o) {
      const r = e.indexOf(".") >= 0 && !this.gos.get("suppressFieldDotNotation");
      i = bt(o, e, r);
    } else
      this.initWaitForRowData(t);
    if (i == null)
      return;
    const [s] = Object.entries(this.dataTypeMatchers).find(([r, n]) => n(i)) ?? ["object"];
    return s;
  }
  getInitialData() {
    const e = this.gos.get("rowData");
    if (e != null && e.length)
      return e[0];
    if (this.initialData)
      return this.initialData;
    {
      const t = this.rowModel.getRootNode().allLeafChildren;
      if (t != null && t.length)
        return t[0].data;
    }
    return null;
  }
  initWaitForRowData(e) {
    if (this.columnStateUpdatesPendingInference[e] = /* @__PURE__ */ new Set(), this.isWaitingForRowData)
      return;
    this.isWaitingForRowData = !0;
    const t = this.isColumnTypeOverrideInDataTypeDefinitions;
    t && this.columnModel.queueResizeOperations();
    const [i] = this.addManagedEventListeners({ rowDataUpdateStarted: (o) => {
      const { firstRowData: s } = o;
      s && (i == null || i(), this.isWaitingForRowData = !1, this.processColumnsPendingInference(s, t), this.columnStateUpdatesPendingInference = {}, t && this.columnModel.processResizeOperations(), this.eventService.dispatchEvent({ type: "dataTypesInferred" }));
    } });
  }
  isPendingInference() {
    return this.isWaitingForRowData;
  }
  processColumnsPendingInference(e, t) {
    this.initialData = e;
    const i = [];
    this.destroyColumnStateUpdateListeners();
    const o = {}, s = {};
    Object.entries(this.columnStateUpdatesPendingInference).forEach(([r, n]) => {
      const a = this.columnModel.getCol(r);
      if (!a)
        return;
      const l = a.getColDef();
      if (!this.columnModel.resetColDefIntoCol(a, "cellDataTypeInferred"))
        return;
      const d = a.getColDef();
      if (t && d.type && d.type !== l.type) {
        const c = this.getUpdatedColumnState(a, n);
        c.rowGroup && c.rowGroupIndex == null && (o[r] = c), c.pivot && c.pivotIndex == null && (s[r] = c), i.push(c);
      }
    }), t && i.push(...this.funcColsService.generateColumnStateForRowGroupAndPivotIndexes(o, s)), i.length && this.columnApplyStateService.applyColumnState({ state: i }, "cellDataTypeInferred"), this.initialData = null;
  }
  getUpdatedColumnState(e, t) {
    const i = this.columnApplyStateService.getColumnStateFromColDef(e);
    return t.forEach((o) => {
      delete i[o], o === "rowGroup" ? delete i.rowGroupIndex : o === "pivot" && delete i.pivotIndex;
    }), i;
  }
  checkObjectValueHandlers(e) {
    const t = this.dataTypeDefinitions.object, i = e.object;
    this.hasObjectValueParser = t.valueParser !== i.valueParser, this.hasObjectValueFormatter = t.valueFormatter !== i.valueFormatter;
  }
  getDateStringTypeDefinition(e) {
    return e ? this.getDataTypeDefinition(e) ?? this.dataTypeDefinitions.dateString : this.dataTypeDefinitions.dateString;
  }
  getDateParserFunction(e) {
    return this.getDateStringTypeDefinition(e).dateParser;
  }
  getDateFormatterFunction(e) {
    return this.getDateStringTypeDefinition(e).dateFormatter;
  }
  getDataTypeDefinition(e) {
    const t = e.getColDef();
    if (t.cellDataType)
      return this.dataTypeDefinitions[t.cellDataType];
  }
  getBaseDataType(e) {
    var t;
    return (t = this.getDataTypeDefinition(e)) == null ? void 0 : t.baseDataType;
  }
  checkType(e, t) {
    var o;
    if (t == null)
      return !0;
    const i = (o = this.getDataTypeDefinition(e)) == null ? void 0 : o.dataTypeMatcher;
    return !i || i(t);
  }
  validateColDef(e) {
    e.cellDataType === "object" && (e.valueFormatter !== this.dataTypeDefinitions.object.groupSafeValueFormatter || this.hasObjectValueFormatter || b('Cell data type is "object" but no value formatter has been provided. Please either provide an object data type definition with a value formatter, or set "colDef.valueFormatter"'), e.editable && e.valueParser === this.dataTypeDefinitions.object.valueParser && !this.hasObjectValueParser && b('Cell data type is "object" but no value parser has been provided. Please either provide an object data type definition with a value parser, or set "colDef.valueParser"'));
  }
  getFormatValue(e) {
    return this.formatValueFuncs[e];
  }
  setColDefPropertiesForBaseDataType(e, t, i, o) {
    const s = this.formatValueFuncs[t], r = Q.__isRegistered("@ag-grid-enterprise/set-filter", this.gridId), n = this.localeService.getLocaleTextFunc(), a = (l) => {
      const { filterParams: d } = e;
      e.filterParams = typeof d == "object" ? { ...d, ...l } : l;
    };
    switch (i.baseDataType) {
      case "number":
        e.cellEditor = "agNumberCellEditor", r && a({ comparator: (l, d) => {
          const c = l == null ? 0 : parseInt(l), h = d == null ? 0 : parseInt(d);
          return c === h ? 0 : c > h ? 1 : -1;
        } });
        break;
      case "boolean":
        e.cellEditor = "agCheckboxCellEditor", e.cellRenderer = "agCheckboxCellRenderer", e.suppressKeyboardEvent = (l) => !!l.colDef.editable && l.event.key === v.SPACE, a(r ? { valueFormatter: (l) => S(l.value) ? n(String(l.value), l.value ? "True" : "False") : n("blanks", "(Blanks)") } : { maxNumConditions: 1, debounceMs: 0, filterOptions: ["empty", { displayKey: "true", displayName: "True", predicate: (l, d) => d, numberOfInputs: 0 }, { displayKey: "false", displayName: "False", predicate: (l, d) => d === !1, numberOfInputs: 0 }] });
        break;
      case "date":
        e.cellEditor = "agDateCellEditor", e.keyCreator = s, r && a({ valueFormatter: (l) => {
          const d = s(l);
          return S(d) ? d : n("blanks", "(Blanks)");
        }, treeList: !0, treeListFormatter: (l, d) => {
          if (d === 1 && l != null) {
            const c = Jo[Number(l) - 1];
            return n(c, $o[c]);
          }
          return l ?? n("blanks", "(Blanks)");
        } });
        break;
      case "dateString": {
        e.cellEditor = "agDateStringCellEditor", e.keyCreator = s;
        const l = i.dateParser;
        a(r ? { valueFormatter: (d) => {
          const c = s(d);
          return S(c) ? c : n("blanks", "(Blanks)");
        }, treeList: !0, treeListPathGetter: (d) => {
          const c = l(d ?? void 0);
          return c ? [String(c.getFullYear()), String(c.getMonth() + 1), String(c.getDate())] : null;
        }, treeListFormatter: (d, c) => {
          if (c === 1 && d != null) {
            const h = Jo[Number(d) - 1];
            return n(h, $o[h]);
          }
          return d ?? n("blanks", "(Blanks)");
        } } : { comparator: (d, c) => {
          const h = l(c);
          return c == null || h < d ? -1 : h > d ? 1 : 0;
        } });
        break;
      }
      case "object":
        e.cellEditorParams = { useFormatter: !0 }, e.comparator = (l, d) => {
          const c = this.columnModel.getColDefCol(o), h = c == null ? void 0 : c.getColDef();
          if (!c || !h)
            return 0;
          const g = l == null ? "" : s({ column: c, node: null, value: l }), u = d == null ? "" : s({ column: c, node: null, value: d });
          return g === u ? 0 : g > u ? 1 : -1;
        }, e.keyCreator = s, r ? a({ valueFormatter: (l) => {
          const d = s(l);
          return S(d) ? d : n("blanks", "(Blanks)");
        } }) : e.filterValueGetter = (l) => s({ column: l.column, node: l.node, value: this.valueService.getValue(l.column, l.node) });
    }
  }
  getDefaultDataTypes() {
    const e = (i) => !!i.match("^\\d{4}-\\d{2}-\\d{2}$"), t = this.localeService.getLocaleTextFunc();
    return { number: { baseDataType: "number", valueParser: (i) => {
      var o, s;
      return ((s = (o = i.newValue) == null ? void 0 : o.trim) == null ? void 0 : s.call(o)) === "" ? null : Number(i.newValue);
    }, valueFormatter: (i) => i.value == null ? "" : typeof i.value != "number" || isNaN(i.value) ? t("invalidNumber", "Invalid Number") : String(i.value), dataTypeMatcher: (i) => typeof i == "number" }, text: { baseDataType: "text", valueParser: (i) => i.newValue === "" ? null : Mi(i.newValue), dataTypeMatcher: (i) => typeof i == "string" }, boolean: { baseDataType: "boolean", valueParser: (i) => {
      var o, s;
      return i.newValue == null ? i.newValue : ((s = (o = i.newValue) == null ? void 0 : o.trim) == null ? void 0 : s.call(o)) === "" ? null : String(i.newValue).toLowerCase() === "true";
    }, valueFormatter: (i) => i.value == null ? "" : String(i.value), dataTypeMatcher: (i) => typeof i == "boolean" }, date: { baseDataType: "date", valueParser: (i) => J(i.newValue == null ? null : String(i.newValue)), valueFormatter: (i) => i.value == null ? "" : i.value instanceof Date && !isNaN(i.value.getTime()) ? re(i.value, !1) ?? "" : t("invalidDate", "Invalid Date"), dataTypeMatcher: (i) => i instanceof Date }, dateString: { baseDataType: "dateString", dateParser: (i) => J(i) ?? void 0, dateFormatter: (i) => re(i ?? null, !1) ?? void 0, valueParser: (i) => e(String(i.newValue)) ? i.newValue : null, valueFormatter: (i) => e(String(i.value)) ? i.value : "", dataTypeMatcher: (i) => typeof i == "string" && e(i) }, object: { baseDataType: "object", valueParser: () => null, valueFormatter: (i) => Mi(i.value) ?? "" } };
  }
  destroyColumnStateUpdateListeners() {
    this.columnStateUpdateListenerDestroyFuncs.forEach((e) => e()), this.columnStateUpdateListenerDestroyFuncs = [];
  }
  destroy() {
    this.dataTypeDefinitions = {}, this.dataTypeMatchers = {}, this.formatValueFuncs = {}, this.columnStateUpdatesPendingInference = {}, this.destroyColumnStateUpdateListeners(), super.destroy();
  }
}] };
function Xo(e, t) {
  const { colKey: i, rowNode: o, useFormatter: s } = t, r = e.columnModel.getColDefCol(i) ?? e.columnModel.getCol(i);
  if (A(r))
    return null;
  const n = e.valueService.getValue(r, o);
  return s ? e.valueService.formatValue(r, o, n) ?? fe(n, !0) : n;
}
function Zo(e, t) {
  e.gos.updateGridOptions({ options: t });
}
function _o(e) {
  return e.rowRenderer.getFirstVirtualRenderedRow();
}
function es(e) {
  return e.rowRenderer.getLastVirtualRenderedRow();
}
var Ed = { version: M, moduleName: "@ag-grid-community/api", dependantModules: [{ version: M, moduleName: "@ag-grid-community/core-api", apiFunctions: { getGridId: function(e) {
  return e.context.getGridId();
}, destroy: function(e) {
  e.gridDestroyService.destroy();
}, isDestroyed: function(e) {
  return e.gridDestroyService.isDestroyCalled();
}, getGridOption: function(e, t) {
  return e.gos.get(t);
}, setGridOption: function(e, t, i) {
  Zo(e, { [t]: i });
}, updateGridOptions: Zo } }, { version: M, moduleName: "@ag-grid-community/pinned-row-api", apiFunctions: { getPinnedTopRowCount: function(e) {
  return e.pinnedRowModel.getPinnedTopRowCount();
}, getPinnedBottomRowCount: function(e) {
  return e.pinnedRowModel.getPinnedBottomRowCount();
}, getPinnedTopRow: function(e, t) {
  return e.pinnedRowModel.getPinnedTopRow(t);
}, getPinnedBottomRow: function(e, t) {
  return e.pinnedRowModel.getPinnedBottomRow(t);
} } }, { version: M, moduleName: "@ag-grid-community/row-selection-api", apiFunctions: { setNodesSelected: function(e, t) {
  if (!t.nodes.every((n) => n.rowPinned ? (b("cannot select pinned rows"), !1) : n.id !== void 0 || (b("cannot select node until id for node is known"), !1)))
    return;
  const { nodes: i, source: o, newValue: s } = t, r = i;
  e.selectionService.setNodesSelected({ nodes: r, source: o ?? "api", newValue: s });
}, selectAll: function(e, t = "apiSelectAll") {
  e.selectionService.selectAllRowNodes({ source: t });
}, deselectAll: function(e, t = "apiSelectAll") {
  e.selectionService.deselectAllRowNodes({ source: t });
}, selectAllFiltered: function(e, t = "apiSelectAllFiltered") {
  e.selectionService.selectAllRowNodes({ source: t, justFiltered: !0 });
}, deselectAllFiltered: function(e, t = "apiSelectAllFiltered") {
  e.selectionService.deselectAllRowNodes({ source: t, justFiltered: !0 });
}, selectAllOnCurrentPage: function(e, t = "apiSelectAllCurrentPage") {
  e.selectionService.selectAllRowNodes({ source: t, justCurrentPage: !0 });
}, deselectAllOnCurrentPage: function(e, t = "apiSelectAllCurrentPage") {
  e.selectionService.deselectAllRowNodes({ source: t, justCurrentPage: !0 });
}, getSelectedNodes: function(e) {
  return e.selectionService.getSelectedNodes();
}, getSelectedRows: function(e) {
  return e.selectionService.getSelectedRows();
} } }, { version: M, moduleName: "@ag-grid-community/column-api", apiFunctions: { getColumnDef: function(e, t) {
  const i = e.columnModel.getColDefCol(t);
  return i ? i.getColDef() : null;
}, getColumnDefs: function(e) {
  return e.columnModel.getColumnDefs();
}, sizeColumnsToFit: function(e, t) {
  typeof t == "number" ? e.columnSizeService.sizeColumnsToFit(t, "api") : e.ctrlsService.getGridBodyCtrl().sizeColumnsToFit(t);
}, setColumnGroupOpened: function(e, t, i) {
  e.columnModel.setColumnGroupOpened(t, i, "api");
}, getColumnGroup: function(e, t, i) {
  return e.visibleColsService.getColumnGroup(t, i);
}, getProvidedColumnGroup: function(e, t) {
  return e.columnModel.getProvidedColGroup(t);
}, getDisplayNameForColumn: function(e, t, i) {
  return e.columnNameService.getDisplayNameForColumn(t, i) || "";
}, getDisplayNameForColumnGroup: function(e, t, i) {
  return e.columnNameService.getDisplayNameForColumnGroup(t, i) || "";
}, getColumn: function(e, t) {
  return e.columnModel.getColDefCol(t);
}, getColumns: function(e) {
  return e.columnModel.getColDefCols();
}, applyColumnState: function(e, t) {
  return e.columnApplyStateService.applyColumnState(t, "api");
}, getColumnState: function(e) {
  return e.columnGetStateService.getColumnState();
}, resetColumnState: function(e) {
  e.columnApplyStateService.resetColumnState("api");
}, getColumnGroupState: function(e) {
  return e.columnGroupStateService.getColumnGroupState();
}, setColumnGroupState: function(e, t) {
  e.columnGroupStateService.setColumnGroupState(t, "api");
}, resetColumnGroupState: function(e) {
  e.columnGroupStateService.resetColumnGroupState("api");
}, isPinning: function(e) {
  return e.visibleColsService.isPinningLeft() || e.visibleColsService.isPinningRight();
}, isPinningLeft: function(e) {
  return e.visibleColsService.isPinningLeft();
}, isPinningRight: function(e) {
  return e.visibleColsService.isPinningRight();
}, getDisplayedColAfter: function(e, t) {
  return e.visibleColsService.getColAfter(t);
}, getDisplayedColBefore: function(e, t) {
  return e.visibleColsService.getColBefore(t);
}, setColumnVisible: function(e, t, i) {
  e.columnModel.setColsVisible([t], i, "api");
}, setColumnsVisible: function(e, t, i) {
  e.columnModel.setColsVisible(t, i, "api");
}, setColumnPinned: function(e, t, i) {
  e.columnModel.setColsPinned([t], i, "api");
}, setColumnsPinned: function(e, t, i) {
  e.columnModel.setColsPinned(t, i, "api");
}, getAllGridColumns: function(e) {
  return e.columnModel.getCols();
}, getDisplayedLeftColumns: function(e) {
  return e.visibleColsService.getLeftCols();
}, getDisplayedCenterColumns: function(e) {
  return e.visibleColsService.getCenterCols();
}, getDisplayedRightColumns: function(e) {
  return e.visibleColsService.getRightCols();
}, getAllDisplayedColumns: function(e) {
  return e.visibleColsService.getAllCols();
}, getAllDisplayedVirtualColumns: function(e) {
  return e.columnViewportService.getViewportColumns();
}, moveColumn: function(e, t, i) {
  e.columnMoveService.moveColumns([t], i, "api");
}, moveColumnByIndex: function(e, t, i) {
  e.columnMoveService.moveColumnByIndex(t, i, "api");
}, moveColumns: function(e, t, i) {
  e.columnMoveService.moveColumns(t, i, "api");
}, setColumnWidth: function(e, t, i, o = !0, s = "api") {
  e.columnSizeService.setColumnWidths([{ key: t, newWidth: i }], !1, o, s);
}, setColumnWidths: function(e, t, i = !0, o = "api") {
  e.columnSizeService.setColumnWidths(t, !1, i, o);
}, getLeftDisplayedColumnGroups: function(e) {
  return e.visibleColsService.getTreeLeft();
}, getCenterDisplayedColumnGroups: function(e) {
  return e.visibleColsService.getTreeCenter();
}, getRightDisplayedColumnGroups: function(e) {
  return e.visibleColsService.getTreeRight();
}, getAllDisplayedColumnGroups: function(e) {
  return e.visibleColsService.getAllTrees();
}, autoSizeColumn: function(e, t, i) {
  return e.columnAutosizeService.autoSizeCols({ colKeys: [t], skipHeader: i, source: "api" });
}, autoSizeColumns: function(e, t, i) {
  e.columnAutosizeService.autoSizeCols({ colKeys: t, skipHeader: i, source: "api" });
}, autoSizeAllColumns: function(e, t) {
  e.columnAutosizeService.autoSizeAllColumns("api", t);
} } }, { version: M, moduleName: "@ag-grid-community/row-api", apiFunctions: { redrawRows: function(e, t = {}) {
  const i = t ? t.rowNodes : void 0;
  e.frameworkOverrides.wrapIncoming(() => e.rowRenderer.redrawRows(i));
}, setRowNodeExpanded: function(e, t, i, o, s) {
  e.expansionService.setRowNodeExpanded(t, i, o, s);
}, getRowNode: function(e, t) {
  return e.rowModel.getRowNode(t);
}, addRenderedRowListener: function(e, t, i, o) {
  e.rowRenderer.addRenderedRowListener(t, i, o);
}, getRenderedNodes: function(e) {
  return e.rowRenderer.getRenderedNodes();
}, forEachNode: function(e, t, i) {
  e.rowModel.forEachNode(t, i);
}, getFirstDisplayedRow: function(e) {
  return _o(e);
}, getFirstDisplayedRowIndex: _o, getLastDisplayedRow: function(e) {
  return es(e);
}, getLastDisplayedRowIndex: es, getDisplayedRowAtIndex: function(e, t) {
  return e.rowModel.getRow(t);
}, getDisplayedRowCount: function(e) {
  return e.rowModel.getRowCount();
}, getModel: function(e) {
  return e.rowModel;
} } }, { version: M, moduleName: "@ag-grid-community/drag-api", apiFunctions: { addRowDropZone: function(e, t) {
  e.ctrlsService.getGridBodyCtrl().getRowDragFeature().addRowDropZone(t);
}, removeRowDropZone: function(e, t) {
  const i = e.dragAndDropService.findExternalZone(t);
  i && e.dragAndDropService.removeDropTarget(i);
}, getRowDropZoneParams: function(e, t) {
  return e.ctrlsService.getGridBodyCtrl().getRowDragFeature().getRowDropZone(t);
} } }, { version: M, moduleName: "@ag-grid-community/scroll-api", apiFunctions: { getVerticalPixelRange: function(e) {
  return e.ctrlsService.getGridBodyCtrl().getScrollFeature().getVScrollPosition();
}, getHorizontalPixelRange: function(e) {
  return e.ctrlsService.getGridBodyCtrl().getScrollFeature().getHScrollPosition();
}, ensureColumnVisible: kr, ensureIndexVisible: Ar, ensureNodeVisible: function(e, t, i = null) {
  e.frameworkOverrides.wrapIncoming(() => e.ctrlsService.getGridBodyCtrl().getScrollFeature().ensureNodeVisible(t, i), "ensureVisible");
} } }, { version: M, moduleName: "@ag-grid-community/overlay-api", apiFunctions: { showLoadingOverlay: function(e) {
  e.overlayService.showLoadingOverlay();
}, showNoRowsOverlay: function(e) {
  e.overlayService.showNoRowsOverlay();
}, hideOverlay: function(e) {
  e.overlayService.hideOverlay();
} } }, { version: M, moduleName: "@ag-grid-community/keyboard-navigation-api", apiFunctions: { getFocusedCell: function(e) {
  return e.focusService.getFocusedCell();
}, clearFocusedCell: function(e) {
  return e.focusService.clearFocusedCell();
}, setFocusedCell: function(e, t, i, o) {
  e.focusService.setFocusedCell({ rowIndex: t, column: i, rowPinned: o, forceBrowserFocus: !0 });
}, setFocusedHeader: function(e, t, i = !1) {
  const o = e.headerNavigationService.getHeaderPositionForColumn(t, i);
  o && e.focusService.focusHeaderPosition({ headerPosition: o });
}, tabToNextCell: function(e, t) {
  return e.navigationService.tabToNextCell(!1, t);
}, tabToPreviousCell: function(e, t) {
  return e.navigationService.tabToNextCell(!0, t);
} } }, { version: M, moduleName: "@ag-grid-community/event-api", apiFunctions: { addEventListener: function(e, t, i) {
  e.apiEventService.addEventListener(t, i);
}, addGlobalListener: function(e, t) {
  e.apiEventService.addGlobalListener(t);
}, removeEventListener: function(e, t, i) {
  e.apiEventService.removeEventListener(t, i);
}, removeGlobalListener: function(e, t) {
  e.apiEventService.removeGlobalListener(t);
} } }, { version: M, moduleName: "@ag-grid-community/render-api", apiFunctions: { setGridAriaProperty: function(e, t, i) {
  if (!t)
    return;
  const o = e.ctrlsService.getGridBodyCtrl().getGui(), s = `aria-${t}`;
  i === null ? o.removeAttribute(s) : o.setAttribute(s, i);
}, refreshCells: function(e, t = {}) {
  e.frameworkOverrides.wrapIncoming(() => e.rowRenderer.refreshCells(t));
}, flashCells: function(e, t = {}) {
  const i = (o) => b(`Since v31.1 api.flashCells parameter '${o}Delay' is deprecated. Please use '${o}Duration' instead.`);
  S(t.fadeDelay) && i("fade"), S(t.flashDelay) && i("flash"), e.frameworkOverrides.wrapIncoming(() => e.rowRenderer.flashCells(t));
}, refreshHeader: function(e) {
  e.frameworkOverrides.wrapIncoming(() => e.ctrlsService.getHeaderRowContainerCtrls().forEach((t) => t.refresh()));
}, isAnimationFrameQueueEmpty: function(e) {
  return e.animationFrameService.isQueueEmpty();
}, flushAllAnimationFrames: function(e) {
  e.animationFrameService.flushAllFrames();
}, getSizesForCurrentTheme: function(e) {
  return { rowHeight: e.gos.getRowHeightAsNumber(), headerHeight: e.columnModel.getHeaderHeight() };
}, getCellRendererInstances: function(e, t = {}) {
  return e.rowRenderer.getCellRendererInstances(t).map(St);
} } }, { version: M, moduleName: "@ag-grid-community/cell-api", apiFunctions: { expireValueCache: function(e) {
  e.valueCache.expire();
}, getValue: function(e, t, i) {
  return Xo(e, { colKey: t, rowNode: i });
}, getCellValue: Xo } }, { version: M, moduleName: "@ag-grid-community/menu-api", apiFunctions: { showColumnMenuAfterButtonClick: function(e, t, i) {
  const o = e.columnModel.getCol(t);
  e.menuService.showColumnMenu({ column: o, buttonElement: i, positionBy: "button" });
}, showColumnMenuAfterMouseClick: function(e, t, i) {
  let o = e.columnModel.getCol(t);
  o || (o = e.columnModel.getColDefCol(t)), o ? e.menuService.showColumnMenu({ column: o, mouseEvent: i, positionBy: "mouse" }) : L(`column '${t}' not found`);
}, showColumnMenu: function(e, t) {
  const i = e.columnModel.getCol(t);
  i ? e.menuService.showColumnMenu({ column: i, positionBy: "auto" }) : L(`column '${t}' not found`);
}, hidePopupMenu: function(e) {
  e.menuService.hidePopupMenu();
} } }, { version: M, moduleName: "@ag-grid-community/sort-api", apiFunctions: { onSortChanged: function(e) {
  e.sortController.onSortChanged("api");
} } }] }, ts = { version: M, moduleName: "@ag-grid-community/state-core", beans: [class extends f {
  constructor() {
    super(...arguments), this.beanName = "stateService", this.suppressEvents = !0, this.queuedUpdateSources = /* @__PURE__ */ new Set(), this.dispatchStateUpdateEventDebounced = q(() => this.dispatchQueuedStateUpdateEvents(), 0), this.onRowGroupOpenedDebounced = q(() => this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState()), 0), this.onRowSelectedDebounced = q(() => {
      this.staleStateKeys.delete("rowSelection"), this.updateCachedState("rowSelection", this.getRowSelectionState());
    }, 0), this.staleStateKeys = /* @__PURE__ */ new Set();
  }
  wireBeans(e) {
    this.filterManager = e.filterManager, this.ctrlsService = e.ctrlsService, this.pivotResultColsService = e.pivotResultColsService, this.focusService = e.focusService, this.columnModel = e.columnModel, this.visibleColsService = e.visibleColsService, this.columnGroupStateService = e.columnGroupStateService, this.columnGetStateService = e.columnGetStateService, this.paginationService = e.paginationService, this.rowModel = e.rowModel, this.selectionService = e.selectionService, this.expansionService = e.expansionService, this.columnAnimationService = e.columnAnimationService, this.columnApplyStateService = e.columnApplyStateService, this.sideBarService = e.sideBarService, this.rangeService = e.rangeService;
  }
  postConstruct() {
    this.isClientSideRowModel = this.rowModel.getType() === "clientSide", this.cachedState = this.gos.get("initialState") ?? {}, this.ctrlsService.whenReady(() => this.suppressEventsAndDispatchInitEvent(() => this.setupStateOnGridReady()));
    const [e, t, i] = this.addManagedEventListeners({ newColumnsLoaded: ({ source: o }) => {
      o === "gridInitializing" && (e(), this.suppressEventsAndDispatchInitEvent(() => this.setupStateOnColumnsInitialised()));
    }, rowCountReady: () => {
      t == null || t(), this.suppressEventsAndDispatchInitEvent(() => this.setupStateOnRowCountReady());
    }, firstDataRendered: () => {
      i == null || i(), this.suppressEventsAndDispatchInitEvent(() => this.setupStateOnFirstDataRendered());
    } });
  }
  getState() {
    return this.staleStateKeys.size && this.refreshStaleState(), this.cachedState;
  }
  setupStateOnGridReady() {
    this.updateCachedState("sideBar", this.getSideBarState());
    const e = () => this.updateCachedState("sideBar", this.getSideBarState());
    this.addManagedEventListeners({ toolPanelVisibleChanged: e, sideBarUpdated: e });
  }
  setupStateOnColumnsInitialised() {
    const e = this.gos.get("initialState") ?? {};
    this.setColumnState(e), this.setColumnGroupState(e), this.updateColumnState(["aggregation", "columnOrder", "columnPinning", "columnSizing", "columnVisibility", "pivot", "pivot", "rowGroup", "sort"]), this.updateCachedState("columnGroup", this.getColumnGroupState()), this.addManagedEventListeners({ columnValueChanged: () => this.updateColumnState(["aggregation"]), columnMoved: () => this.updateColumnState(["columnOrder"]), columnPinned: () => this.updateColumnState(["columnPinning"]), columnResized: () => this.updateColumnState(["columnSizing"]), columnVisible: () => this.updateColumnState(["columnVisibility"]), columnPivotChanged: () => this.updateColumnState(["pivot"]), columnPivotModeChanged: () => this.updateColumnState(["pivot"]), columnRowGroupChanged: () => this.updateColumnState(["rowGroup"]), sortChanged: () => this.updateColumnState(["sort"]), newColumnsLoaded: () => this.updateColumnState(["aggregation", "columnOrder", "columnPinning", "columnSizing", "columnVisibility", "pivot", "rowGroup", "sort"]), columnGroupOpened: () => this.updateCachedState("columnGroup", this.getColumnGroupState()) });
  }
  setupStateOnRowCountReady() {
    const { filter: e, rowGroupExpansion: t, rowSelection: i, pagination: o } = this.gos.get("initialState") ?? {}, s = this.gos.get("advancedFilterModel");
    (e || s) && this.setFilterState(e, s), t && this.setRowGroupExpansionState(t), i && this.setRowSelectionState(i), o && this.setPaginationState(o), this.updateCachedState("filter", this.getFilterState()), this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState()), this.updateCachedState("rowSelection", this.getRowSelectionState()), this.updateCachedState("pagination", this.getPaginationState()), this.addManagedEventListeners({ filterChanged: () => this.updateCachedState("filter", this.getFilterState()), rowGroupOpened: () => this.onRowGroupOpenedDebounced(), expandOrCollapseAll: () => this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState()), selectionChanged: () => {
      this.staleStateKeys.add("rowSelection"), this.onRowSelectedDebounced();
    }, paginationChanged: (r) => {
      (r.newPage || r.newPageSize) && this.updateCachedState("pagination", this.getPaginationState());
    } });
  }
  setupStateOnFirstDataRendered() {
    const { scroll: e, rangeSelection: t, focusedCell: i, columnOrder: o } = this.gos.get("initialState") ?? {};
    i && this.setFocusedCellState(i), t && this.setRangeSelectionState(t), e && this.setScrollState(e), this.setColumnPivotState(!!(o != null && o.orderedColIds)), this.updateCachedState("sideBar", this.getSideBarState()), this.updateCachedState("focusedCell", this.getFocusedCellState()), this.updateCachedState("rangeSelection", this.getRangeSelectionState()), this.updateCachedState("scroll", this.getScrollState()), this.addManagedEventListeners({ cellFocused: () => this.updateCachedState("focusedCell", this.getFocusedCellState()), rangeSelectionChanged: (s) => {
      s.finished && this.updateCachedState("rangeSelection", this.getRangeSelectionState());
    }, bodyScrollEnd: () => this.updateCachedState("scroll", this.getScrollState()) });
  }
  getColumnState() {
    const e = this.columnModel.isPivotMode(), t = [], i = [], o = [], s = [], r = [], n = [], a = [], l = [], d = [], c = this.columnGetStateService.getColumnState();
    for (let h = 0; h < c.length; h++) {
      const { colId: g, sort: u, sortIndex: p, rowGroup: C, rowGroupIndex: y, aggFunc: w, pivot: x, pivotIndex: E, pinned: k, hide: P, width: D, flex: F } = c[h];
      d.push(g), u && (t[p ?? 0] = { colId: g, sort: u }), C && (i[y ?? 0] = g), typeof w == "string" && o.push({ colId: g, aggFunc: w }), x && (s[E ?? 0] = g), k && (k === "right" ? n : r).push(g), P && a.push(g), (F || D) && l.push({ colId: g, flex: F ?? void 0, width: D });
    }
    return { sort: t.length ? { sortModel: t } : void 0, rowGroup: i.length ? { groupColIds: i } : void 0, aggregation: o.length ? { aggregationModel: o } : void 0, pivot: s.length || e ? { pivotMode: e, pivotColIds: s } : void 0, columnPinning: r.length || n.length ? { leftColIds: r, rightColIds: n } : void 0, columnVisibility: a.length ? { hiddenColIds: a } : void 0, columnSizing: l.length ? { columnSizingModel: l } : void 0, columnOrder: d.length ? { orderedColIds: d } : void 0 };
  }
  setColumnState(e) {
    const { sort: t, rowGroup: i, aggregation: o, pivot: s, columnPinning: r, columnVisibility: n, columnSizing: a, columnOrder: l } = e, d = {}, c = (p) => {
      let C = d[p];
      return C || (C = { colId: p }, d[p] = C, C);
    };
    t && t.sortModel.forEach(({ colId: p, sort: C }, y) => {
      const w = c(p);
      w.sort = C, w.sortIndex = y;
    }), i && i.groupColIds.forEach((p, C) => {
      const y = c(p);
      y.rowGroup = !0, y.rowGroupIndex = C;
    }), o && o.aggregationModel.forEach(({ colId: p, aggFunc: C }) => {
      c(p).aggFunc = C;
    }), s && (s.pivotColIds.forEach((p, C) => {
      const y = c(p);
      y.pivot = !0, y.pivotIndex = C;
    }), this.gos.updateGridOptions({ options: { pivotMode: s.pivotMode }, source: "gridInitializing" })), r && (r.leftColIds.forEach((p) => {
      c(p).pinned = "left";
    }), r.rightColIds.forEach((p) => {
      c(p).pinned = "right";
    })), n && n.hiddenColIds.forEach((p) => {
      c(p).hide = !0;
    }), a && a.columnSizingModel.forEach(({ colId: p, flex: C, width: y }) => {
      const w = c(p);
      w.flex = C ?? null, w.width = y;
    });
    const h = l == null ? void 0 : l.orderedColIds, g = !!(h != null && h.length), u = g ? h.map((p) => c(p)) : Object.values(d);
    if (u.length) {
      this.columnStates = u;
      const p = { sort: null, sortIndex: null, rowGroup: null, rowGroupIndex: null, aggFunc: null, pivot: null, pivotIndex: null, pinned: null, hide: null, flex: null };
      this.columnApplyStateService.applyColumnState({ state: u, applyOrder: g, defaultState: p }, "gridInitializing");
    }
  }
  setColumnPivotState(e) {
    const t = this.columnStates;
    this.columnStates = void 0;
    const i = this.columnGroupStates;
    if (this.columnGroupStates = void 0, this.pivotResultColsService.isPivotResultColsPresent()) {
      if (t) {
        const o = [];
        for (const s of t)
          this.pivotResultColsService.getPivotResultCol(s.colId) && o.push(s);
        this.columnApplyStateService.applyColumnState({ state: o, applyOrder: e }, "gridInitializing");
      }
      i && this.columnGroupStateService.setColumnGroupState(i, "gridInitializing");
    }
  }
  getColumnGroupState() {
    const e = this.columnGroupStateService.getColumnGroupState(), t = [];
    return e.forEach(({ groupId: i, open: o }) => {
      o && t.push(i);
    }), t.length ? { openColumnGroupIds: t } : void 0;
  }
  setColumnGroupState(e) {
    var o;
    if (!Object.prototype.hasOwnProperty.call(e, "columnGroup"))
      return;
    const t = new Set((o = e.columnGroup) == null ? void 0 : o.openColumnGroupIds), i = this.columnGroupStateService.getColumnGroupState().map(({ groupId: s }) => {
      const r = t.has(s);
      return r && t.delete(s), { groupId: s, open: r };
    });
    t.forEach((s) => {
      i.push({ groupId: s, open: !0 });
    }), i.length && (this.columnGroupStates = i), this.columnGroupStateService.setColumnGroupState(i, "gridInitializing");
  }
  getFilterState() {
    var i, o;
    let e = (i = this.filterManager) == null ? void 0 : i.getFilterModel();
    e && Object.keys(e).length === 0 && (e = void 0);
    const t = ((o = this.filterManager) == null ? void 0 : o.getAdvancedFilterModel()) ?? void 0;
    return e || t ? { filterModel: e, advancedFilterModel: t } : void 0;
  }
  setFilterState(e, t) {
    var s, r;
    const { filterModel: i, advancedFilterModel: o } = e ?? { advancedFilterModel: t };
    i && ((s = this.filterManager) == null || s.setFilterModel(i, "columnFilter")), o && ((r = this.filterManager) == null || r.setAdvancedFilterModel(o));
  }
  getRangeSelectionState() {
    var t;
    const e = (t = this.rangeService) == null ? void 0 : t.getCellRanges().map((i) => {
      const { id: o, type: s, startRow: r, endRow: n, columns: a, startColumn: l } = i;
      return { id: o, type: s, startRow: r, endRow: n, colIds: a.map((d) => d.getColId()), startColId: l.getColId() };
    });
    return e != null && e.length ? { cellRanges: e } : void 0;
  }
  setRangeSelectionState(e) {
    if (!this.gos.get("enableRangeSelection") || !this.rangeService)
      return;
    const t = [];
    e.cellRanges.forEach((i) => {
      const o = [];
      if (i.colIds.forEach((r) => {
        const n = this.columnModel.getCol(r);
        n && o.push(n);
      }), !o.length)
        return;
      let s = this.columnModel.getCol(i.startColId);
      if (!s) {
        const r = this.visibleColsService.getAllCols(), n = new Set(o);
        s = r.find((a) => n.has(a));
      }
      t.push({ ...i, columns: o, startColumn: s });
    }), this.rangeService.setCellRanges(t);
  }
  getScrollState() {
    var o;
    if (!this.isClientSideRowModel)
      return;
    const e = (o = this.ctrlsService.getGridBodyCtrl()) == null ? void 0 : o.getScrollFeature(), { left: t } = (e == null ? void 0 : e.getHScrollPosition()) ?? { left: 0 }, { top: i } = (e == null ? void 0 : e.getVScrollPosition()) ?? { top: 0 };
    return i || t ? { top: i, left: t } : void 0;
  }
  setScrollState(e) {
    var o;
    if (!this.isClientSideRowModel)
      return;
    const { top: t, left: i } = e;
    (o = this.ctrlsService.getGridBodyCtrl()) == null || o.getScrollFeature().setScrollPosition(t, i);
  }
  getSideBarState() {
    var e, t;
    return (t = (e = this.sideBarService) == null ? void 0 : e.getSideBarComp()) == null ? void 0 : t.getState();
  }
  getFocusedCellState() {
    if (!this.isClientSideRowModel)
      return;
    const e = this.focusService.getFocusedCell();
    if (e) {
      const { column: t, rowIndex: i, rowPinned: o } = e;
      return { colId: t.getColId(), rowIndex: i, rowPinned: o };
    }
  }
  setFocusedCellState(e) {
    if (!this.isClientSideRowModel)
      return;
    const { colId: t, rowIndex: i, rowPinned: o } = e;
    this.focusService.setFocusedCell({ column: this.columnModel.getCol(t), rowIndex: i, rowPinned: o, forceBrowserFocus: !0, preventScrollOnBrowserFocus: !0 });
  }
  getPaginationState() {
    if (!this.paginationService)
      return;
    const e = this.paginationService.getCurrentPage(), t = this.gos.get("paginationAutoPageSize") ? void 0 : this.paginationService.getPageSize();
    return e || t ? { page: e, pageSize: t } : void 0;
  }
  setPaginationState(e) {
    this.paginationService && (e.pageSize && !this.gos.get("paginationAutoPageSize") && this.paginationService.setPageSize(e.pageSize, "initialState"), typeof e.page == "number" && this.paginationService.setPage(e.page));
  }
  getRowSelectionState() {
    var t;
    const e = this.selectionService.getSelectionState();
    return e && (Array.isArray(e) || e.selectAll !== !1 && e.selectAllChildren !== !1 || (t = e == null ? void 0 : e.toggledNodes) != null && t.length) ? e : void 0;
  }
  setRowSelectionState(e) {
    this.selectionService.setSelectionState(e, "gridInitializing");
  }
  getRowGroupExpansionState() {
    const e = this.expansionService.getExpandedRows();
    return e.length ? { expandedRowGroupIds: e } : void 0;
  }
  setRowGroupExpansionState(e) {
    this.expansionService.expandRows(e.expandedRowGroupIds);
  }
  updateColumnState(e) {
    const t = this.getColumnState();
    let i = !1;
    Object.entries(t).forEach(([o, s]) => {
      Xt(s, this.cachedState[o]) || (i = !0);
    }), this.cachedState = { ...this.cachedState, ...t }, i && this.dispatchStateUpdateEvent(e);
  }
  updateCachedState(e, t) {
    const i = this.cachedState[e];
    this.setCachedStateValue(e, t), Xt(t, i) || this.dispatchStateUpdateEvent([e]);
  }
  setCachedStateValue(e, t) {
    this.cachedState = { ...this.cachedState, [e]: t };
  }
  refreshStaleState() {
    this.staleStateKeys.forEach((e) => {
      e === "rowSelection" && this.setCachedStateValue(e, this.getRowSelectionState());
    }), this.staleStateKeys.clear();
  }
  dispatchStateUpdateEvent(e) {
    this.suppressEvents || (e.forEach((t) => this.queuedUpdateSources.add(t)), this.dispatchStateUpdateEventDebounced());
  }
  dispatchQueuedStateUpdateEvents() {
    const e = Array.from(this.queuedUpdateSources);
    this.queuedUpdateSources.clear();
    const t = { type: "stateUpdated", sources: e, state: this.cachedState };
    this.eventService.dispatchEvent(t);
  }
  suppressEventsAndDispatchInitEvent(e) {
    this.suppressEvents = !0, this.columnAnimationService.setSuppressAnimation(!0), e(), setTimeout(() => {
      this.suppressEvents = !1, this.queuedUpdateSources.clear(), this.isAlive() && (this.columnAnimationService.setSuppressAnimation(!1), this.dispatchStateUpdateEvent(["gridInitializing"]));
    });
  }
}] }, Pd = { version: M, moduleName: "@ag-grid-community/state", dependantModules: [ts, { version: M, moduleName: "@ag-grid-community/state-api", apiFunctions: { getState: function(e) {
  var t;
  return ((t = e.stateService) == null ? void 0 : t.getState()) ?? {};
} }, dependantModules: [ts] }] }, kd = { selector: "AG-PAGE-SIZE-SELECTOR", component: class extends O {
  constructor() {
    super('<span class="ag-paging-page-size"></span>'), this.hasEmptyOption = !1, this.handlePageSizeItemSelected = () => {
      if (!this.selectPageSizeComp)
        return;
      const e = this.selectPageSizeComp.getValue();
      if (!e)
        return;
      const t = Number(e);
      isNaN(t) || t < 1 || t === this.paginationService.getPageSize() || (this.paginationService.setPageSize(t, "pageSizeSelector"), this.hasEmptyOption && this.toggleSelectDisplay(!0), this.selectPageSizeComp.getFocusableElement().focus());
    };
  }
  wireBeans(e) {
    this.paginationService = e.paginationService;
  }
  postConstruct() {
    this.addManagedPropertyListener("paginationPageSizeSelector", () => {
      this.onPageSizeSelectorValuesChange();
    }), this.addManagedEventListeners({ paginationChanged: (e) => this.handlePaginationChanged(e) });
  }
  handlePaginationChanged(e) {
    if (!this.selectPageSizeComp || !(e != null && e.newPageSize))
      return;
    const t = this.paginationService.getPageSize();
    this.getPageSizeSelectorValues().includes(t) ? this.selectPageSizeComp.setValue(t.toString()) : this.hasEmptyOption ? this.selectPageSizeComp.setValue("") : this.toggleSelectDisplay(!0);
  }
  toggleSelectDisplay(e) {
    this.selectPageSizeComp && this.reset(), e && (this.reloadPageSizesSelector(), this.selectPageSizeComp && this.appendChild(this.selectPageSizeComp));
  }
  reset() {
    j(this.getGui()), this.selectPageSizeComp && (this.selectPageSizeComp = this.destroyBean(this.selectPageSizeComp));
  }
  onPageSizeSelectorValuesChange() {
    this.selectPageSizeComp && this.shouldShowPageSizeSelector() && this.reloadPageSizesSelector();
  }
  shouldShowPageSizeSelector() {
    return this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel") && !this.gos.get("paginationAutoPageSize") && this.gos.get("paginationPageSizeSelector") !== !1;
  }
  reloadPageSizesSelector() {
    const e = this.getPageSizeSelectorValues(), t = this.paginationService.getPageSize(), i = !t || !e.includes(t);
    i && (e.unshift(""), b(`The paginationPageSize grid option is set to a value that is not in the list of page size options.
                Please make sure that the paginationPageSize grid option is set to one of the values in the 
                paginationPageSizeSelector array, or set the paginationPageSizeSelector to false to hide the page size selector.`)), this.selectPageSizeComp && (this.selectPageSizeComp = this.destroyBean(this.selectPageSizeComp));
    const o = this.localeService.getLocaleTextFunc(), s = o("pageSizeSelectorLabel", "Page Size:"), r = e.map((a) => ({ value: String(a), text: String(a) })), n = o("ariaPageSizeSelectorLabel", "Page Size");
    this.selectPageSizeComp = this.createManagedBean(new ho()).addOptions(r).setValue(String(i ? "" : t)).setAriaLabel(n).setLabel(s).onValueChange(() => this.handlePageSizeItemSelected()), this.hasEmptyOption = i;
  }
  getPageSizeSelectorValues() {
    const e = this.gos.get("paginationPageSizeSelector");
    return Array.isArray(e) && this.validateValues(e) ? [...e].sort((t, i) => t - i) : [20, 50, 100];
  }
  validateValues(e) {
    if (!e.length)
      return b(`The paginationPageSizeSelector grid option is an empty array. This is most likely a mistake.
                If you want to hide the page size selector, please set the paginationPageSizeSelector to false.`), !1;
    for (let t = 0; t < e.length; t++) {
      const i = e[t], o = i > 0;
      if (typeof i != "number")
        return b(`The paginationPageSizeSelector grid option contains a non-numeric value.
                    Please make sure that all values in the paginationPageSizeSelector array are numbers.`), !1;
      if (!o)
        return b(`The paginationPageSizeSelector grid option contains a negative number or zero.
                    Please make sure that all values in the paginationPageSizeSelector array are positive.`), !1;
    }
    return !0;
  }
  destroy() {
    this.toggleSelectDisplay(!1), super.destroy();
  }
} }, Ad = { selector: "AG-PAGINATION", component: class extends Tr {
  constructor() {
    super(), this.btFirst = R, this.btPrevious = R, this.btNext = R, this.btLast = R, this.lbRecordCount = R, this.lbFirstRowOnPage = R, this.lbLastRowOnPage = R, this.lbCurrent = R, this.lbTotal = R, this.pageSizeComp = R, this.previousAndFirstButtonsDisabled = !1, this.nextButtonDisabled = !1, this.lastButtonDisabled = !1, this.areListenersSetup = !1, this.allowFocusInnerElement = !1;
  }
  wireBeans(e) {
    this.rowNodeBlockLoader = e.rowNodeBlockLoader, this.rowModel = e.rowModel, this.paginationService = e.paginationService, this.focusService = e.focusService;
  }
  postConstruct() {
    const e = this.gos.get("enableRtl");
    this.setTemplate(this.getTemplate(), [kd]);
    const { btFirst: t, btPrevious: i, btNext: o, btLast: s } = this;
    this.activateTabIndex([t, i, o, s]), t.insertAdjacentElement("afterbegin", te(e ? "last" : "first", this.gos)), i.insertAdjacentElement("afterbegin", te(e ? "next" : "previous", this.gos)), o.insertAdjacentElement("afterbegin", te(e ? "previous" : "next", this.gos)), s.insertAdjacentElement("afterbegin", te(e ? "first" : "last", this.gos)), this.addManagedPropertyListener("pagination", this.onPaginationChanged.bind(this)), this.addManagedPropertyListener("suppressPaginationPanel", this.onPaginationChanged.bind(this)), this.addManagedPropertyListeners(["paginationPageSizeSelector", "paginationAutoPageSize", "suppressPaginationPanel"], () => this.onPageSizeRelatedOptionsChange()), this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector()), this.initialiseTabGuard({ onTabKeyDown: () => {
    }, focusInnerElement: (r) => {
      this.allowFocusInnerElement ? this.tabGuardFeature.getTabGuardCtrl().focusInnerElement(r) : this.focusService.focusGridInnerElement(r);
    }, forceFocusOutWhenTabGuardsAreEmpty: !0 }), this.onPaginationChanged();
  }
  setAllowFocus(e) {
    this.allowFocusInnerElement = e;
  }
  onPaginationChanged() {
    const e = this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel");
    this.setDisplayed(e), e && (this.setupListeners(), this.enableOrDisableButtons(), this.updateRowLabels(), this.setCurrentPageLabel(), this.setTotalLabels(), this.onPageSizeRelatedOptionsChange());
  }
  onPageSizeRelatedOptionsChange() {
    this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
  }
  setupListeners() {
    var e, t;
    this.areListenersSetup || (this.addManagedEventListeners({ paginationChanged: this.onPaginationChanged.bind(this) }), [{ el: this.btFirst, fn: this.onBtFirst.bind(this) }, { el: this.btPrevious, fn: this.onBtPrevious.bind(this) }, { el: this.btNext, fn: this.onBtNext.bind(this) }, { el: this.btLast, fn: this.onBtLast.bind(this) }].forEach((i) => {
      const { el: o, fn: s } = i;
      this.addManagedListeners(o, { click: s, keydown: (r) => {
        r.key !== v.ENTER && r.key !== v.SPACE || (r.preventDefault(), s());
      } });
    }), e = this.getGui(), t = this.focusService, this.addManagedElementListeners(e, { keydown: (i) => {
      if (!i.defaultPrevented && i.key === v.TAB) {
        const o = i.shiftKey;
        t.findNextFocusableElement(e, !1, o) || t.focusNextGridCoreContainer(o) && i.preventDefault();
      }
    } }), this.areListenersSetup = !0);
  }
  onBtFirst() {
    this.previousAndFirstButtonsDisabled || this.paginationService.goToFirstPage();
  }
  setCurrentPageLabel() {
    const e = this.paginationService.getTotalPages() > 0, t = this.paginationService.getCurrentPage(), i = e ? t + 1 : 0;
    this.lbCurrent.textContent = this.formatNumber(i);
  }
  formatNumber(e) {
    const t = this.gos.getCallback("paginationNumberFormatter");
    if (t)
      return t({ value: e });
    const i = this.localeService.getLocaleTextFunc();
    return function(o, s, r) {
      return typeof o != "number" ? "" : o.toString().replace(".", r).replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${s}`);
    }(e, i("thousandSeparator", ","), i("decimalSeparator", "."));
  }
  getTemplate() {
    const e = this.localeService.getLocaleTextFunc(), t = e("page", "Page"), i = e("to", "to"), o = e("of", "of"), s = e("firstPage", "First Page"), r = e("previousPage", "Previous Page"), n = e("nextPage", "Next Page"), a = e("lastPage", "Last Page"), l = this.getCompId();
    return `<div class="ag-paging-panel ag-unselectable" id="ag-${l}">
                <ag-page-size-selector data-ref="pageSizeComp"></ag-page-size-selector>
                <span class="ag-paging-row-summary-panel" role="status">
                    <span id="ag-${l}-first-row" data-ref="lbFirstRowOnPage" class="ag-paging-row-summary-panel-number"></span>
                    <span id="ag-${l}-to">${i}</span>
                    <span id="ag-${l}-last-row" data-ref="lbLastRowOnPage" class="ag-paging-row-summary-panel-number"></span>
                    <span id="ag-${l}-of">${o}</span>
                    <span id="ag-${l}-row-count" data-ref="lbRecordCount" class="ag-paging-row-summary-panel-number"></span>
                </span>
                <span class="ag-paging-page-summary-panel" role="presentation">
                    <div data-ref="btFirst" class="ag-button ag-paging-button" role="button" aria-label="${s}"></div>
                    <div data-ref="btPrevious" class="ag-button ag-paging-button" role="button" aria-label="${r}"></div>
                    <span class="ag-paging-description" role="status">
                        <span id="ag-${l}-start-page">${t}</span>
                        <span id="ag-${l}-start-page-number" data-ref="lbCurrent" class="ag-paging-number"></span>
                        <span id="ag-${l}-of-page">${o}</span>
                        <span id="ag-${l}-of-page-number" data-ref="lbTotal" class="ag-paging-number"></span>
                    </span>
                    <div data-ref="btNext" class="ag-button ag-paging-button" role="button" aria-label="${n}"></div>
                    <div data-ref="btLast" class="ag-button ag-paging-button" role="button" aria-label="${a}"></div>
                </span>
            </div>`;
  }
  onBtNext() {
    this.nextButtonDisabled || this.paginationService.goToNextPage();
  }
  onBtPrevious() {
    this.previousAndFirstButtonsDisabled || this.paginationService.goToPreviousPage();
  }
  onBtLast() {
    this.lastButtonDisabled || this.paginationService.goToLastPage();
  }
  enableOrDisableButtons() {
    const e = this.paginationService.getCurrentPage(), t = this.rowModel.isLastRowIndexKnown(), i = this.paginationService.getTotalPages();
    this.previousAndFirstButtonsDisabled = e === 0, this.toggleButtonDisabled(this.btFirst, this.previousAndFirstButtonsDisabled), this.toggleButtonDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
    const o = this.isZeroPagesToDisplay(), s = e === i - 1;
    this.nextButtonDisabled = s || o, this.lastButtonDisabled = !t || o || e === i - 1, this.toggleButtonDisabled(this.btNext, this.nextButtonDisabled), this.toggleButtonDisabled(this.btLast, this.lastButtonDisabled);
  }
  toggleButtonDisabled(e, t) {
    (function(i, o) {
      De(i, "disabled", o);
    })(e, t), e.classList.toggle("ag-disabled", t);
  }
  updateRowLabels() {
    var n;
    const e = this.paginationService.getCurrentPage(), t = this.paginationService.getPageSize(), i = this.rowModel.isLastRowIndexKnown(), o = this.rowModel.isLastRowIndexKnown() ? this.paginationService.getMasterRowCount() : null;
    let s, r;
    if (this.isZeroPagesToDisplay() ? s = r = 0 : (s = t * e + 1, r = s + t - 1, i && r > o && (r = o)), this.lbFirstRowOnPage.textContent = this.formatNumber(s), (n = this.rowNodeBlockLoader) == null ? void 0 : n.isLoading()) {
      const a = this.localeService.getLocaleTextFunc();
      this.lbLastRowOnPage.innerHTML = a("pageLastRowUnknown", "?");
    } else
      this.lbLastRowOnPage.textContent = this.formatNumber(r);
  }
  isZeroPagesToDisplay() {
    const e = this.rowModel.isLastRowIndexKnown(), t = this.paginationService.getTotalPages();
    return e && t === 0;
  }
  setTotalLabels() {
    const e = this.rowModel.isLastRowIndexKnown(), t = this.paginationService.getTotalPages(), i = e ? this.paginationService.getMasterRowCount() : null;
    if (i === 1) {
      const o = this.rowModel.getRow(0);
      if (o && o.group && !o.groupData && !o.aggData)
        return void this.setTotalLabelsToZero();
    }
    if (e)
      this.lbTotal.textContent = this.formatNumber(t), this.lbRecordCount.textContent = this.formatNumber(i);
    else {
      const o = this.localeService.getLocaleTextFunc()("more", "more");
      this.lbTotal.innerHTML = o, this.lbRecordCount.innerHTML = o;
    }
  }
  setTotalLabelsToZero() {
    this.lbFirstRowOnPage.textContent = this.formatNumber(0), this.lbCurrent.textContent = this.formatNumber(0), this.lbLastRowOnPage.textContent = this.formatNumber(0), this.lbTotal.textContent = this.formatNumber(0), this.lbRecordCount.textContent = this.formatNumber(0);
  }
} }, is = { version: M, moduleName: "@ag-grid-community/pagination-core", beans: [class extends f {
  constructor() {
    super(...arguments), this.beanName = "paginationService", this.currentPage = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = 0, this.masterRowCount = 0;
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.pageBoundsService = e.pageBoundsService;
  }
  postConstruct() {
    this.active = this.gos.get("pagination"), this.pageSizeFromGridOptions = this.gos.get("paginationPageSize"), this.paginateChildRows = this.isPaginateChildRows(), this.addManagedPropertyListener("pagination", this.onPaginationGridOptionChanged.bind(this)), this.addManagedPropertyListener("paginationPageSize", this.onPageSizeGridOptionChanged.bind(this));
  }
  getPaginationSelector() {
    return Ad;
  }
  isPaginateChildRows() {
    return !(!this.gos.get("groupRemoveSingleChildren") && !this.gos.get("groupRemoveLowestSingleChildren")) || this.gos.get("paginateChildRows");
  }
  onPaginationGridOptionChanged() {
    this.active = this.gos.get("pagination"), this.calculatePages(), this.dispatchPaginationChangedEvent({ keepRenderedRows: !0 });
  }
  onPageSizeGridOptionChanged() {
    this.setPageSize(this.gos.get("paginationPageSize"), "gridOptions");
  }
  goToPage(e) {
    this.active && this.currentPage !== e && typeof this.currentPage == "number" && (this.currentPage = e, this.calculatePages(), this.dispatchPaginationChangedEvent({ newPage: !0 }));
  }
  isRowPresent(e) {
    return e.rowIndex >= this.topDisplayedRowIndex && e.rowIndex <= this.bottomDisplayedRowIndex;
  }
  getPageForIndex(e) {
    return Math.floor(e / this.pageSize);
  }
  goToPageWithIndex(e) {
    if (!this.active)
      return;
    const t = this.getPageForIndex(e);
    this.goToPage(t);
  }
  isRowInPage(e) {
    return !this.active || this.getPageForIndex(e.rowIndex) === this.currentPage;
  }
  getCurrentPage() {
    return this.currentPage;
  }
  goToNextPage() {
    this.goToPage(this.currentPage + 1);
  }
  goToPreviousPage() {
    this.goToPage(this.currentPage - 1);
  }
  goToFirstPage() {
    this.goToPage(0);
  }
  goToLastPage() {
    const e = this.rowModel.getRowCount(), t = Math.floor(e / this.pageSize);
    this.goToPage(t);
  }
  getPageSize() {
    return this.pageSize;
  }
  getTotalPages() {
    return this.totalPages;
  }
  setPage(e) {
    this.currentPage = e;
  }
  get pageSize() {
    return S(this.pageSizeAutoCalculated) ? this.pageSizeAutoCalculated : S(this.pageSizeFromPageSizeSelector) ? this.pageSizeFromPageSizeSelector : S(this.pageSizeFromInitialState) ? this.pageSizeFromInitialState : S(this.pageSizeFromGridOptions) ? this.pageSizeFromGridOptions : this.defaultPageSize;
  }
  calculatePages() {
    this.active ? this.paginateChildRows ? this.calculatePagesAllRows() : this.calculatePagesMasterRowsOnly() : this.calculatedPagesNotActive(), this.pageBoundsService.calculateBounds(this.topDisplayedRowIndex, this.bottomDisplayedRowIndex);
  }
  unsetAutoCalculatedPageSize() {
    if (this.pageSizeAutoCalculated === void 0)
      return;
    const e = this.pageSizeAutoCalculated;
    this.pageSizeAutoCalculated = void 0, this.pageSize !== e && (this.calculatePages(), this.dispatchPaginationChangedEvent({ newPageSize: !0 }));
  }
  setPageSize(e, t) {
    const i = this.pageSize;
    switch (t) {
      case "autoCalculated":
        this.pageSizeAutoCalculated = e;
        break;
      case "pageSizeSelector":
        this.pageSizeFromPageSizeSelector = e, this.currentPage !== 0 && this.goToFirstPage();
        break;
      case "initialState":
        this.pageSizeFromInitialState = e;
        break;
      case "gridOptions":
        this.pageSizeFromGridOptions = e, this.pageSizeFromInitialState = void 0, this.pageSizeFromPageSizeSelector = void 0, this.currentPage !== 0 && this.goToFirstPage();
    }
    i !== this.pageSize && (this.calculatePages(), this.dispatchPaginationChangedEvent({ newPageSize: !0, keepRenderedRows: !0 }));
  }
  setZeroRows() {
    this.masterRowCount = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = -1, this.currentPage = 0, this.totalPages = 0;
  }
  adjustCurrentPageIfInvalid() {
    this.currentPage >= this.totalPages && (this.currentPage = this.totalPages - 1), (!isFinite(this.currentPage) || isNaN(this.currentPage) || this.currentPage < 0) && (this.currentPage = 0);
  }
  calculatePagesMasterRowsOnly() {
    if (this.masterRowCount = this.rowModel.getTopLevelRowCount(), this.masterRowCount <= 0)
      return void this.setZeroRows();
    const e = this.masterRowCount - 1;
    this.totalPages = Math.floor(e / this.pageSize) + 1, this.adjustCurrentPageIfInvalid();
    const t = this.pageSize * this.currentPage;
    let i = this.pageSize * (this.currentPage + 1) - 1;
    if (i > e && (i = e), this.topDisplayedRowIndex = this.rowModel.getTopLevelRowDisplayedIndex(t), i === e)
      this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
    else {
      const o = this.rowModel.getTopLevelRowDisplayedIndex(i + 1);
      this.bottomDisplayedRowIndex = o - 1;
    }
  }
  getMasterRowCount() {
    return this.masterRowCount;
  }
  calculatePagesAllRows() {
    if (this.masterRowCount = this.rowModel.getRowCount(), this.masterRowCount === 0)
      return void this.setZeroRows();
    const e = this.masterRowCount - 1;
    this.totalPages = Math.floor(e / this.pageSize) + 1, this.adjustCurrentPageIfInvalid(), this.topDisplayedRowIndex = this.pageSize * this.currentPage, this.bottomDisplayedRowIndex = this.pageSize * (this.currentPage + 1) - 1, this.bottomDisplayedRowIndex > e && (this.bottomDisplayedRowIndex = e);
  }
  calculatedPagesNotActive() {
    this.setPageSize(void 0, "autoCalculated"), this.totalPages = 1, this.currentPage = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
  }
  dispatchPaginationChangedEvent(e) {
    const { keepRenderedRows: t = !1, newPage: i = !1, newPageSize: o = !1 } = e, s = { type: "paginationChanged", animate: !1, newData: !1, newPage: i, newPageSize: o, keepRenderedRows: t };
    this.eventService.dispatchEvent(s);
  }
}, class extends f {
  constructor() {
    super(...arguments), this.beanName = "paginationAutoPageSizeService";
  }
  wireBeans(e) {
    this.ctrlsService = e.ctrlsService, this.paginationService = e.paginationService;
  }
  postConstruct() {
    this.ctrlsService.whenReady((e) => {
      this.centerRowsCtrl = e.center;
      const t = this.checkPageSize.bind(this);
      this.addManagedEventListeners({ bodyHeightChanged: t, scrollVisibilityChanged: t }), this.addManagedPropertyListener("paginationAutoPageSize", this.onPaginationAutoSizeChanged.bind(this)), this.checkPageSize();
    });
  }
  notActive() {
    return !this.gos.get("paginationAutoPageSize") || this.centerRowsCtrl == null;
  }
  onPaginationAutoSizeChanged() {
    this.notActive() ? this.paginationService.unsetAutoCalculatedPageSize() : this.checkPageSize();
  }
  checkPageSize() {
    if (this.notActive())
      return;
    const e = this.centerRowsCtrl.getViewportSizeFeature().getBodyHeight();
    if (e > 0) {
      const t = () => {
        const i = Math.max(this.gos.getRowHeightAsNumber(), 1), o = Math.floor(e / i);
        this.paginationService.setPageSize(o, "autoCalculated");
      };
      this.isBodyRendered ? q(() => t(), 50)() : (t(), this.isBodyRendered = !0);
    } else
      this.isBodyRendered = !1;
  }
}] }, Td = { version: M, moduleName: "@ag-grid-community/pagination", dependantModules: [is, { version: M, moduleName: "@ag-grid-community/pagination-api", dependantModules: [is], apiFunctions: { paginationIsLastPageFound: function(e) {
  return e.rowModel.isLastRowIndexKnown();
}, paginationGetPageSize: function(e) {
  var t;
  return ((t = e.paginationService) == null ? void 0 : t.getPageSize()) ?? 100;
}, paginationGetCurrentPage: function(e) {
  var t;
  return ((t = e.paginationService) == null ? void 0 : t.getCurrentPage()) ?? 0;
}, paginationGetTotalPages: function(e) {
  var t;
  return ((t = e.paginationService) == null ? void 0 : t.getTotalPages()) ?? 1;
}, paginationGetRowCount: function(e) {
  return e.paginationService ? e.paginationService.getMasterRowCount() : e.rowModel.getRowCount();
}, paginationGoToNextPage: function(e) {
  var t;
  (t = e.paginationService) == null || t.goToNextPage();
}, paginationGoToPreviousPage: function(e) {
  var t;
  (t = e.paginationService) == null || t.goToPreviousPage();
}, paginationGoToFirstPage: function(e) {
  var t;
  (t = e.paginationService) == null || t.goToFirstPage();
}, paginationGoToLastPage: function(e) {
  var t;
  (t = e.paginationService) == null || t.goToLastPage();
}, paginationGoToPage: function(e, t) {
  var i;
  (i = e.paginationService) == null || i.goToPage(t);
} } }] }, m = "@ag-grid-community/core", pe = "@ag-grid-community/client-side-row-model", os = "@ag-grid-community/csv-export", Vt = "@ag-grid-community/infinite-row-model", Wt = "@ag-grid-enterprise/advanced-filter", ne = "@ag-grid-enterprise/charts", Xe = "@ag-grid-enterprise/clipboard", vt = "@ag-grid-enterprise/excel-export", Ut = "@ag-grid-enterprise/master-detail", xi = "@ag-grid-enterprise/menu", Fi = "@ag-grid-enterprise/range-selection", B = "@ag-grid-enterprise/row-grouping", ye = "@ag-grid-enterprise/server-side-row-model", me = "@ag-grid-enterprise/side-bar", Id = { dispatchEvent: m, getState: m, getGridId: m, destroy: m, isDestroyed: m, getGridOption: m, setGridOption: m, updateGridOptions: m, setNodesSelected: m, selectAll: m, deselectAll: m, selectAllFiltered: m, deselectAllFiltered: m, selectAllOnCurrentPage: m, deselectAllOnCurrentPage: m, getSelectedNodes: m, getSelectedRows: m, redrawRows: m, setRowNodeExpanded: m, getRowNode: m, addRenderedRowListener: m, getRenderedNodes: m, forEachNode: m, getFirstDisplayedRow: m, getFirstDisplayedRowIndex: m, getLastDisplayedRow: m, getLastDisplayedRowIndex: m, getDisplayedRowAtIndex: m, getDisplayedRowCount: m, getModel: m, getVerticalPixelRange: m, getHorizontalPixelRange: m, ensureColumnVisible: m, ensureIndexVisible: m, ensureNodeVisible: m, getFocusedCell: m, clearFocusedCell: m, setFocusedCell: m, tabToNextCell: m, tabToPreviousCell: m, setFocusedHeader: m, addEventListener: m, addGlobalListener: m, removeEventListener: m, removeGlobalListener: m, expireValueCache: m, getValue: m, getCellValue: m, showColumnMenuAfterButtonClick: m, showColumnMenuAfterMouseClick: m, showColumnMenu: m, hidePopupMenu: m, onSortChanged: m, getPinnedTopRowCount: m, getPinnedBottomRowCount: m, getPinnedTopRow: m, getPinnedBottomRow: m, showLoadingOverlay: m, showNoRowsOverlay: m, hideOverlay: m, setGridAriaProperty: m, refreshCells: m, flashCells: m, refreshHeader: m, isAnimationFrameQueueEmpty: m, flushAllAnimationFrames: m, getSizesForCurrentTheme: m, getCellRendererInstances: m, addRowDropZone: m, removeRowDropZone: m, getRowDropZoneParams: m, getColumnDef: m, getColumnDefs: m, sizeColumnsToFit: m, setColumnGroupOpened: m, getColumnGroup: m, getProvidedColumnGroup: m, getDisplayNameForColumn: m, getDisplayNameForColumnGroup: m, getColumn: m, getColumns: m, applyColumnState: m, getColumnState: m, resetColumnState: m, getColumnGroupState: m, setColumnGroupState: m, resetColumnGroupState: m, isPinning: m, isPinningLeft: m, isPinningRight: m, getDisplayedColAfter: m, getDisplayedColBefore: m, setColumnVisible: m, setColumnsVisible: m, setColumnPinned: m, setColumnsPinned: m, getAllGridColumns: m, getDisplayedLeftColumns: m, getDisplayedCenterColumns: m, getDisplayedRightColumns: m, getAllDisplayedColumns: m, getAllDisplayedVirtualColumns: m, moveColumn: m, moveColumnByIndex: m, moveColumns: m, setColumnWidth: m, setColumnWidths: m, getLeftDisplayedColumnGroups: m, getCenterDisplayedColumnGroups: m, getRightDisplayedColumnGroups: m, getAllDisplayedColumnGroups: m, autoSizeColumn: m, autoSizeColumns: m, autoSizeAllColumns: m, undoCellEditing: m, redoCellEditing: m, getCellEditorInstances: m, getEditingCells: m, stopEditing: m, startEditingCell: m, getCurrentUndoSize: m, getCurrentRedoSize: m, isAnyFilterPresent: m, onFilterChanged: m, isColumnFilterPresent: m, getFilterInstance: m, getColumnFilterInstance: m, destroyFilter: m, setFilterModel: m, getFilterModel: m, getColumnFilterModel: m, setColumnFilterModel: m, showColumnFilter: m, isQuickFilterPresent: m, getQuickFilter: m, resetQuickFilter: m, paginationIsLastPageFound: m, paginationGetPageSize: m, paginationGetCurrentPage: m, paginationGetTotalPages: m, paginationGetRowCount: m, paginationGoToNextPage: m, paginationGoToPreviousPage: m, paginationGoToFirstPage: m, paginationGoToLastPage: m, paginationGoToPage: m, expandAll: m, collapseAll: m, onRowHeightChanged: m, setRowCount: m, getCacheBlockState: m, onGroupExpandedOrCollapsed: pe, refreshClientSideRowModel: pe, forEachLeafNode: pe, forEachNodeAfterFilter: pe, forEachNodeAfterFilterAndSort: pe, resetRowHeights: pe, applyTransaction: pe, applyTransactionAsync: pe, flushAsyncTransactions: pe, getBestCostNodeSelection: pe, getDataAsCsv: os, exportDataAsCsv: os, refreshInfiniteCache: Vt, purgeInfiniteCache: Vt, getInfiniteRowCount: Vt, isLastRowIndexKnown: Vt, getAdvancedFilterModel: Wt, setAdvancedFilterModel: Wt, showAdvancedFilterBuilder: Wt, hideAdvancedFilterBuilder: Wt, getChartModels: ne, getChartRef: ne, getChartImageDataURL: ne, downloadChart: ne, openChartToolPanel: ne, closeChartToolPanel: ne, createRangeChart: ne, createPivotChart: ne, createCrossFilterChart: ne, updateChart: ne, restoreChart: ne, copyToClipboard: Xe, cutToClipboard: Xe, copySelectedRowsToClipboard: Xe, copySelectedRangeToClipboard: Xe, copySelectedRangeDown: Xe, pasteFromClipboard: Xe, getDataAsExcel: vt, exportDataAsExcel: vt, getSheetDataForExcel: vt, getMultipleSheetsAsExcel: vt, exportMultipleSheetsAsExcel: vt, addDetailGridInfo: Ut, removeDetailGridInfo: Ut, getDetailGridInfo: Ut, forEachDetailGridInfo: Ut, showContextMenu: xi, showColumnChooser: xi, hideColumnChooser: xi, getCellRanges: Fi, addCellRange: Fi, clearRangeSelection: Fi, addAggFunc: B, addAggFuncs: B, clearAggFuncs: B, setColumnAggFunc: B, isPivotMode: B, getPivotResultColumn: B, setValueColumns: B, getValueColumns: B, removeValueColumn: B, removeValueColumns: B, addValueColumn: B, addValueColumns: B, setRowGroupColumns: B, removeRowGroupColumn: B, removeRowGroupColumns: B, addRowGroupColumn: B, addRowGroupColumns: B, getRowGroupColumns: B, moveRowGroupColumn: B, setPivotColumns: B, removePivotColumn: B, removePivotColumns: B, addPivotColumn: B, addPivotColumns: B, getPivotColumns: B, setPivotResultColumns: B, getPivotResultColumns: B, getServerSideSelectionState: ye, setServerSideSelectionState: ye, applyServerSideTransaction: ye, applyServerSideTransactionAsync: ye, applyServerSideRowData: ye, retryServerSideLoads: ye, flushServerSideAsyncTransactions: ye, refreshServerSide: ye, getServerSideGroupLevelState: ye, isSideBarVisible: me, setSideBarVisible: me, setSideBarPosition: me, openToolPanel: me, closeToolPanel: me, getOpenedToolPanel: me, refreshToolPanel: me, isToolPanelShowing: me, getToolPanelInstance: me, getSideBar: me, getStatusPanel: "@ag-grid-enterprise/status-bar" }, Z = "clientSide", $ = "serverSide", Ze = "infinite", Ld = { onGroupExpandedOrCollapsed: [Z], refreshClientSideRowModel: [Z], forEachLeafNode: [Z], forEachNodeAfterFilter: [Z], forEachNodeAfterFilterAndSort: [Z], resetRowHeights: [Z], applyTransaction: [Z], applyTransactionAsync: [Z], flushAsyncTransactions: [Z], getBestCostNodeSelection: [Z], getServerSideSelectionState: [$], setServerSideSelectionState: [$], applyServerSideTransaction: [$], applyServerSideTransactionAsync: [$], applyServerSideRowData: [$], retryServerSideLoads: [$], flushServerSideAsyncTransactions: [$], refreshServerSide: [$], getServerSideGroupLevelState: [$], refreshInfiniteCache: [Ze], purgeInfiniteCache: [Ze], getInfiniteRowCount: [Ze], isLastRowIndexKnown: [Ze], expandAll: [Z, $], collapseAll: [Z, $], onRowHeightChanged: [Z, $], setRowCount: [Ze, $], getCacheBlockState: [Ze, $] }, Od = { getValue: { version: "v31.3", new: "getCellValue" }, getFirstDisplayedRow: { version: "v31.1", new: "getFirstDisplayedRowIndex" }, getLastDisplayedRow: { version: "v31.1", new: "getLastDisplayedRowIndex" }, getModel: { version: "v31.1", message: "Please use the appropriate grid API methods instead." }, setColumnVisible: { version: "v31.1", old: "setColumnVisible(key,visible)", new: "setColumnsVisible([key],visible)" }, setColumnPinned: { version: "v31.1", old: "setColumnPinned(key,pinned)", new: "setColumnsPinned([key],pinned)" }, moveColumn: { version: "v31.1", old: "moveColumn(key, toIndex)", new: "moveColumns([key], toIndex)" }, setColumnWidth: { version: "v31.1", old: "setColumnWidth(col, width)", new: "setColumnWidths([{key: col, newWidth: width}])" }, autoSizeColumn: { version: "v31.1", old: "autoSizeColumn(key, skipHeader)", new: "autoSizeColumns([key], skipHeader)" }, addAggFunc: { version: "v31.1", old: "addAggFunc(key, func)", new: "addAggFuncs({ key: func })" }, removeValueColumn: { version: "v31.1", old: "removeValueColumn(colKey)", new: "removeValueColumns([colKey])" }, addValueColumn: { version: "v31.1", old: "addValueColumn(colKey)", new: "addValueColumns([colKey])" }, removeRowGroupColumn: { version: "v31.1", old: "removeRowGroupColumn(colKey)", new: "removeRowGroupColumns([colKey])" }, addRowGroupColumn: { version: "v31.1", old: "addRowGroupColumn(colKey)", new: "addRowGroupColumns([colKey])" }, removePivotColumn: { version: "v31.1", old: "removePivotColumn(colKey)", new: "removePivotColumns([colKey])" }, addPivotColumn: { version: "v31.1", old: "addPivotColumn(colKey)", new: "addPivotColumns([colKey])" }, showColumnMenuAfterButtonClick: { version: "v31.1", message: "Use 'IHeaderParams.showColumnMenu' within a header component, or 'api.showColumnMenu' elsewhere." }, showColumnMenuAfterMouseClick: { version: "v31.1", message: "Use 'IHeaderParams.showColumnMenuAfterMouseClick' within a header component, or 'api.showColumnMenu' elsewhere." }, getFilterInstance: { version: "v31.1", message: "'getFilterInstance' is deprecated. To get/set individual filter models, use 'getColumnFilterModel' or 'setColumnFilterModel' instead. To get hold of the filter instance, use 'getColumnFilterInstance' which returns the instance asynchronously." }, showLoadingOverlay: { version: "v32", message: '`showLoadingOverlay` is deprecated. Use the grid option "loading"=true instead or setGridOption("loading", true).' } }, Pe = (e, t) => (t.rowModelType ?? "clientSide") === "clientSide" ? { module: "@ag-grid-enterprise/row-grouping" } : null, Nd = { enableRowGroup: Pe, rowGroup: Pe, rowGroupIndex: Pe, enablePivot: Pe, enableValue: Pe, pivot: Pe, pivotIndex: Pe, aggFunc: Pe, cellEditor: (e) => e.cellEditor === "agRichSelect" || e.cellEditor === "agRichSelectCellEditor" ? { module: "@ag-grid-enterprise/rich-select" } : null, menuTabs: (e) => {
  var i;
  const t = ["columnsMenuTab", "generalMenuTab"];
  return (i = e.menuTabs) != null && i.some((o) => t.includes(o)) ? { module: "@ag-grid-enterprise/menu" } : null;
}, columnsMenuParams: { module: ["@ag-grid-enterprise/menu", "@ag-grid-enterprise/column-tool-panel"] }, columnChooserParams: { module: ["@ag-grid-enterprise/menu", "@ag-grid-enterprise/column-tool-panel"] }, headerCheckboxSelection: { supportedRowModels: ["clientSide", "serverSide"], dependencies: (e, { rowSelection: t }) => t === "multiple" ? null : "headerCheckboxSelection is only supported with rowSelection=multiple" }, headerCheckboxSelectionFilteredOnly: { supportedRowModels: ["clientSide"], dependencies: (e, { rowSelection: t }) => t === "multiple" ? null : "headerCheckboxSelectionFilteredOnly is only supported with rowSelection=multiple" }, headerCheckboxSelectionCurrentPageOnly: { supportedRowModels: ["clientSide"], dependencies: (e, { rowSelection: t }) => t === "multiple" ? null : "headerCheckboxSelectionCurrentPageOnly is only supported with rowSelection=multiple" }, children: () => it }, it = { objectName: "colDef", allProperties: Object.keys({ headerName: void 0, columnGroupShow: void 0, headerClass: void 0, toolPanelClass: void 0, headerValueGetter: void 0, pivotKeys: void 0, groupId: void 0, colId: void 0, sort: void 0, initialSort: void 0, field: void 0, type: void 0, cellDataType: void 0, tooltipComponent: void 0, tooltipField: void 0, headerTooltip: void 0, cellClass: void 0, showRowGroup: void 0, filter: void 0, initialAggFunc: void 0, defaultAggFunc: void 0, aggFunc: void 0, pinned: void 0, initialPinned: void 0, chartDataType: void 0, cellAriaRole: void 0, cellEditorPopupPosition: void 0, headerGroupComponent: void 0, headerGroupComponentParams: void 0, cellStyle: void 0, cellRenderer: void 0, cellRendererParams: void 0, cellEditor: void 0, cellEditorParams: void 0, filterParams: void 0, pivotValueColumn: void 0, headerComponent: void 0, headerComponentParams: void 0, floatingFilterComponent: void 0, floatingFilterComponentParams: void 0, tooltipComponentParams: void 0, refData: void 0, columnsMenuParams: void 0, columnChooserParams: void 0, children: void 0, sortingOrder: void 0, allowedAggFuncs: void 0, menuTabs: void 0, pivotTotalColumnIds: void 0, cellClassRules: void 0, icons: void 0, sortIndex: void 0, initialSortIndex: void 0, flex: void 0, initialFlex: void 0, width: void 0, initialWidth: void 0, minWidth: void 0, maxWidth: void 0, rowGroupIndex: void 0, initialRowGroupIndex: void 0, pivotIndex: void 0, initialPivotIndex: void 0, suppressCellFlash: void 0, suppressColumnsToolPanel: void 0, suppressFiltersToolPanel: void 0, openByDefault: void 0, marryChildren: void 0, suppressStickyLabel: void 0, hide: void 0, initialHide: void 0, rowGroup: void 0, initialRowGroup: void 0, pivot: void 0, initialPivot: void 0, checkboxSelection: void 0, showDisabledCheckboxes: void 0, headerCheckboxSelection: void 0, headerCheckboxSelectionFilteredOnly: void 0, headerCheckboxSelectionCurrentPageOnly: void 0, suppressMenu: void 0, suppressHeaderMenuButton: void 0, suppressMovable: void 0, lockPosition: void 0, lockVisible: void 0, lockPinned: void 0, unSortIcon: void 0, suppressSizeToFit: void 0, suppressAutoSize: void 0, enableRowGroup: void 0, enablePivot: void 0, enableValue: void 0, editable: void 0, suppressPaste: void 0, suppressNavigable: void 0, enableCellChangeFlash: void 0, rowDrag: void 0, dndSource: void 0, autoHeight: void 0, wrapText: void 0, sortable: void 0, resizable: void 0, singleClickEdit: void 0, floatingFilter: void 0, cellEditorPopup: void 0, suppressFillHandle: void 0, wrapHeaderText: void 0, autoHeaderHeight: void 0, dndSourceOnRowDrag: void 0, valueGetter: void 0, valueSetter: void 0, filterValueGetter: void 0, keyCreator: void 0, valueFormatter: void 0, valueParser: void 0, comparator: void 0, equals: void 0, pivotComparator: void 0, suppressKeyboardEvent: void 0, suppressHeaderKeyboardEvent: void 0, colSpan: void 0, rowSpan: void 0, getQuickFilterText: void 0, onCellValueChanged: void 0, onCellClicked: void 0, onCellDoubleClicked: void 0, onCellContextMenu: void 0, rowDragText: void 0, tooltipValueGetter: void 0, cellRendererSelector: void 0, cellEditorSelector: void 0, suppressSpanHeaderHeight: void 0, useValueFormatterForExport: void 0, useValueParserForImport: void 0, mainMenuItems: void 0, contextMenuItems: void 0, suppressFloatingFilterButton: void 0, suppressHeaderFilterButton: void 0, suppressHeaderContextMenu: void 0, loadingCellRenderer: void 0, loadingCellRendererParams: void 0, loadingCellRendererSelector: void 0, context: void 0 }), docsUrl: "column-properties/", deprecations: { columnsMenuParams: { version: "31.1", message: "Use `columnChooserParams` instead." }, suppressMenu: { version: "31.1", message: "Use `suppressHeaderMenuButton` instead." }, suppressCellFlash: { version: "31.2", message: "Use `enableCellChangeFlash={false}` in the ColDef" } }, validations: Nd }, Gd = { suppressContextMenu: !1, preventDefaultOnContextMenu: !1, allowContextMenuWithControlKey: !1, suppressMenuHide: !0, enableBrowserTooltips: !1, tooltipTrigger: "hover", tooltipShowDelay: 2e3, tooltipHideDelay: 1e4, tooltipMouseTrack: !1, tooltipShowMode: "standard", tooltipInteraction: !1, copyHeadersToClipboard: !1, copyGroupHeadersToClipboard: !1, clipboardDelimiter: "	", suppressCopyRowsToClipboard: !1, suppressCopySingleCellRanges: !1, suppressLastEmptyLineOnPaste: !1, suppressClipboardPaste: !1, suppressClipboardApi: !1, suppressCutToClipboard: !1, maintainColumnOrder: !1, suppressFieldDotNotation: !1, allowDragFromColumnsToolPanel: !1, suppressMovableColumns: !1, suppressColumnMoveAnimation: !1, suppressDragLeaveHidesColumns: !1, suppressRowGroupHidesColumns: !1, suppressAutoSize: !1, autoSizePadding: 20, skipHeaderOnAutoSize: !1, singleClickEdit: !1, suppressClickEdit: !1, readOnlyEdit: !1, stopEditingWhenCellsLoseFocus: !1, enterNavigatesVertically: !1, enterNavigatesVerticallyAfterEdit: !1, enableCellEditingOnBackspace: !1, undoRedoCellEditing: !1, undoRedoCellEditingLimit: 10, suppressCsvExport: !1, suppressExcelExport: !1, cacheQuickFilter: !1, includeHiddenColumnsInQuickFilter: !1, excludeChildrenWhenTreeDataFiltering: !1, enableAdvancedFilter: !1, includeHiddenColumnsInAdvancedFilter: !1, enableCharts: !1, masterDetail: !1, keepDetailRows: !1, keepDetailRowsCount: 10, detailRowAutoHeight: !1, tabIndex: 0, rowBuffer: 10, valueCache: !1, valueCacheNeverExpires: !1, enableCellExpressions: !1, suppressTouch: !1, suppressFocusAfterRefresh: !1, suppressAsyncEvents: !1, suppressBrowserResizeObserver: !1, suppressPropertyNamesCheck: !1, suppressChangeDetection: !1, debug: !1, suppressLoadingOverlay: !1, suppressNoRowsOverlay: !1, pagination: !1, paginationPageSize: 100, paginationPageSizeSelector: !0, paginationAutoPageSize: !1, paginateChildRows: !1, suppressPaginationPanel: !1, pivotMode: !1, pivotPanelShow: "never", pivotDefaultExpanded: 0, pivotSuppressAutoColumn: !1, suppressExpandablePivotGroups: !1, functionsReadOnly: !1, suppressAggFuncInHeader: !1, alwaysAggregateAtRootLevel: !1, aggregateOnlyChangedColumns: !1, suppressAggFilteredOnly: !1, removePivotHeaderRowWhenSingleValueColumn: !1, animateRows: !0, enableCellChangeFlash: !1, cellFlashDelay: 500, cellFlashDuration: 500, cellFadeDelay: 1e3, cellFadeDuration: 1e3, allowShowChangeAfterFilter: !1, domLayout: "normal", ensureDomOrder: !1, enableRtl: !1, suppressColumnVirtualisation: !1, suppressMaxRenderedRowRestriction: !1, suppressRowVirtualisation: !1, rowDragManaged: !1, suppressRowDrag: !1, suppressMoveWhenRowDragging: !1, rowDragEntireRow: !1, rowDragMultiRow: !1, embedFullWidthRows: !1, groupDisplayType: "singleColumn", groupDefaultExpanded: 0, groupMaintainOrder: !1, groupSelectsChildren: !1, groupIncludeTotalFooter: !1, groupSuppressBlankHeader: !1, groupSelectsFiltered: !1, showOpenedGroup: !1, groupRemoveSingleChildren: !1, groupRemoveLowestSingleChildren: !1, groupHideOpenParents: !1, groupAllowUnbalanced: !1, rowGroupPanelShow: "never", suppressMakeColumnVisibleAfterUnGroup: !1, treeData: !1, rowGroupPanelSuppressSort: !1, suppressGroupRowsSticky: !1, rowModelType: "clientSide", asyncTransactionWaitMillis: 50, suppressModelUpdateAfterUpdateTransaction: !1, cacheOverflowSize: 1, infiniteInitialRowCount: 1, serverSideInitialRowCount: 1, suppressServerSideInfiniteScroll: !1, cacheBlockSize: 100, maxBlocksInCache: -1, maxConcurrentDatasourceRequests: 2, blockLoadDebounceMillis: 0, purgeClosedRowNodes: !1, serverSideSortAllLevels: !1, serverSideOnlyRefreshFilteredGroups: !1, serverSideSortOnServer: !1, serverSideFilterOnServer: !1, serverSidePivotResultFieldSeparator: "_", viewportRowModelPageSize: 5, viewportRowModelBufferSize: 5, alwaysShowHorizontalScroll: !1, alwaysShowVerticalScroll: !1, debounceVerticalScrollbar: !1, suppressHorizontalScroll: !1, suppressScrollOnNewData: !1, suppressScrollWhenPopupsAreOpen: !1, suppressAnimationFrame: !1, suppressMiddleClickScrolls: !1, suppressPreventDefaultOnMouseWheel: !1, rowMultiSelectWithClick: !1, suppressRowDeselection: !1, suppressRowClickSelection: !1, suppressCellFocus: !1, suppressHeaderFocus: !1, suppressMultiRangeSelection: !1, enableCellTextSelection: !1, enableRangeSelection: !1, enableRangeHandle: !1, enableFillHandle: !1, fillHandleDirection: "xy", suppressClearOnFillReduction: !1, accentedSort: !1, unSortIcon: !1, suppressMultiSort: !1, alwaysMultiSort: !1, suppressMaintainUnsortedOrder: !1, suppressRowHoverHighlight: !1, suppressRowTransform: !1, columnHoverHighlight: !1, deltaSort: !1, enableGroupEdit: !1, suppressGroupMaintainValueType: !1, groupLockGroupColumns: 0, serverSideEnableClientSideSort: !1, suppressServerSideFullWidthLoadingRow: !1, pivotMaxGeneratedColumns: -1, columnMenu: "new", reactiveCustomComponents: !0 }, Ir = { version: M, moduleName: "@ag-grid-community/core-community-features", dependantModules: [{ version: M, moduleName: "@ag-grid-community/core" }, { version: M, moduleName: "@ag-grid-community/core-validations", beans: [class extends f {
  constructor() {
    super(...arguments), this.beanName = "validationService";
  }
  wireBeans(e) {
    this.beans = e, this.gridOptions = e.gridOptions;
  }
  postConstruct() {
    this.processGridOptions(this.gridOptions);
  }
  processGridOptions(e) {
    this.processOptions(e, { objectName: "gridOptions", allProperties: [...Ft.ALL_PROPERTIES, ...ws.EVENT_CALLBACKS], propertyExceptions: ["api"], docsUrl: "grid-options/", deprecations: { advancedFilterModel: { version: "31", message: "Use `initialState.filter.advancedFilterModel` instead." }, suppressAsyncEvents: { version: "31", message: "Events should be handled asynchronously." }, cellFadeDelay: { version: "31.1", renamed: "cellFadeDuration" }, cellFlashDelay: { version: "31.1", renamed: "cellFlashDuration" }, suppressServerSideInfiniteScroll: { version: "31.1" }, serverSideSortOnServer: { version: "31.1" }, serverSideFilterOnServer: { version: "31.1" }, enableCellChangeFlash: { version: "31.2", message: "Use `enableCellChangeFlash` in the `ColDef` or `defaultColDef` for all columns." }, groupIncludeFooter: { version: "31.3", message: "Use `groupTotalRow` instead." }, groupIncludeTotalFooter: { version: "31.3", message: "Use `grandTotalRow` instead." }, suppressLoadingOverlay: { version: "32", message: "Use `loading`=false instead." } }, validations: { sideBar: { module: "@ag-grid-enterprise/side-bar" }, statusBar: { module: "@ag-grid-enterprise/status-bar" }, enableCharts: { module: "@ag-grid-enterprise/charts" }, getMainMenuItems: { module: "@ag-grid-enterprise/menu" }, getContextMenuItems: { module: "@ag-grid-enterprise/menu" }, allowContextMenuWithControlKey: { module: "@ag-grid-enterprise/menu" }, enableAdvancedFilter: { module: "@ag-grid-enterprise/advanced-filter" }, treeData: { supportedRowModels: ["clientSide", "serverSide"], module: "@ag-grid-enterprise/row-grouping", dependencies: (t) => {
      const i = t.rowModelType ?? "clientSide";
      switch (i) {
        case "clientSide": {
          const o = `treeData requires 'getDataPath' in the ${i} row model.`;
          return t.getDataPath ? null : o;
        }
        case "serverSide": {
          const o = `treeData requires 'isServerSideGroup' and 'getServerSideGroupKey' in the ${i} row model.`;
          return t.isServerSideGroup && t.getServerSideGroupKey ? null : o;
        }
      }
      return null;
    } }, masterDetail: { module: "@ag-grid-enterprise/master-detail" }, enableRangeSelection: { module: "@ag-grid-enterprise/range-selection" }, enableRangeHandle: { dependencies: { enableRangeSelection: [!0] } }, enableFillHandle: { dependencies: { enableRangeSelection: [!0] } }, groupDefaultExpanded: { supportedRowModels: ["clientSide"] }, groupIncludeFooter: { supportedRowModels: ["clientSide", "serverSide"], dependencies: (t) => {
      switch (t.rowModelType ?? "clientSide") {
        case "clientSide":
          return null;
        case "serverSide": {
          const i = "groupIncludeFooter is not supported alongside suppressServerSideInfiniteScroll";
          return t.suppressServerSideInfiniteScroll ? i : null;
        }
      }
      return null;
    } }, groupHideOpenParents: { supportedRowModels: ["clientSide"], dependencies: { groupTotalRow: [void 0, "bottom"] } }, groupIncludeTotalFooter: { supportedRowModels: ["clientSide"] }, groupRemoveSingleChildren: { dependencies: { groupHideOpenParents: [void 0, !1], groupRemoveLowestSingleChildren: [void 0, !1] } }, groupRemoveLowestSingleChildren: { dependencies: { groupHideOpenParents: [void 0, !1], groupRemoveSingleChildren: [void 0, !1] } }, groupSelectsChildren: { dependencies: { rowSelection: ["multiple"] } }, viewportDatasource: { supportedRowModels: ["viewport"], module: "@ag-grid-enterprise/viewport-row-model" }, serverSideDatasource: { supportedRowModels: ["serverSide"], module: "@ag-grid-enterprise/server-side-row-model" }, cacheBlockSize: { supportedRowModels: ["serverSide", "infinite"] }, datasource: { supportedRowModels: ["infinite"], module: "@ag-grid-community/infinite-row-model" }, rowData: { supportedRowModels: ["clientSide"], module: "@ag-grid-community/client-side-row-model" }, columnDefs: () => it, defaultColDef: () => it, defaultColGroupDef: () => it, autoGroupColumnDef: () => it } });
  }
  processColumnDefs(e) {
    this.processOptions(e, it);
  }
  warnMissingApiFunction(e) {
    (function(t, i) {
      const o = Id[t];
      o ? Q.__assertRegistered(o, `api.${t}`, i) && b(`API function '${t}' not registered to module '${o}'`) : L(`Unknown API function: '${t}' on GridApi.`);
    })(e, this.gridId);
  }
  validateApiFunction(e, t) {
    return function(i, o, s) {
      const r = Od[i];
      if (r) {
        const { version: a, new: l, old: d, message: c } = r, h = d ?? i;
        return (...g) => (b(`Since ${a} api.${h} is deprecated. ${l ? `Please use ${l} instead. ` : ""}${c ?? ""}`), o.apply(o, g));
      }
      const n = Ld[i];
      return n ? (...a) => {
        const l = s.rowModel.getType();
        if (n.includes(l))
          return o.apply(o, a);
        L(`api.${i} can only be called when gridOptions.rowModelType is ${n.join(" or ")}`);
      } : o;
    }(e, t, this.beans);
  }
  processOptions(e, t) {
    const { validations: i, deprecations: o, allProperties: s, propertyExceptions: r, objectName: n, docsUrl: a } = t;
    s && this.gridOptions.suppressPropertyNamesCheck !== !0 && this.checkProperties(e, [...r ?? [], ...Object.keys(o)], s, n, a);
    const l = /* @__PURE__ */ new Set();
    Object.keys(e).forEach((d) => {
      const c = o[d];
      if (c)
        if ("renamed" in c) {
          const { renamed: w, version: x } = c;
          l.add(`As of v${x}, ${String(d)} is deprecated. Please use ${String(w)} instead.`), e[w] = e[d];
        } else {
          const { message: w, version: x } = c;
          l.add(`As of v${x}, ${String(d)} is deprecated. ${w ?? ""}`);
        }
      const h = e[d];
      if (h == null || h === !1)
        return;
      const g = i[d];
      let u;
      if (!g)
        return;
      if (typeof g == "function") {
        const w = g(e, this.gridOptions);
        if (!w)
          return;
        if ("objectName" in w) {
          const x = e[d];
          return Array.isArray(x) ? void x.forEach((E) => {
            this.processOptions(E, w);
          }) : void this.processOptions(e[d], w);
        }
        u = w;
      } else
        u = g;
      const { module: p, dependencies: C, supportedRowModels: y } = u;
      if (y) {
        const w = this.gridOptions.rowModelType ?? "clientSide";
        if (!y.includes(w))
          return void l.add(`${String(d)} is not supported with the '${w}' row model.`);
      }
      if (p) {
        const w = Array.isArray(p) ? p : [p];
        let x = !0;
        if (w.forEach((E) => {
          Q.__assertRegistered(E, String(d), this.gridId) || (x = !1, l.add(`${String(d)} is only available when ${E} is loaded.`));
        }), !x)
          return;
      }
      if (C) {
        const w = this.checkForWarning(d, C, e);
        if (w)
          return void l.add(w);
      }
    }), l.size > 0 && l.forEach((d) => {
      b(d);
    });
  }
  checkForWarning(e, t, i) {
    if (typeof t == "function")
      return t(i, this.gridOptions);
    const o = Object.entries(t).find(([n, a]) => {
      const l = i[n];
      return !a.includes(l);
    });
    if (!o)
      return null;
    const [s, r] = o;
    return r.length > 1 ? `'${String(e)}' requires '${s}' to be one of [${r.join(", ")}].` : `'${String(e)}' requires '${s}' to be ${r[0]}.`;
  }
  checkProperties(e, t, i, o, s) {
    const r = function(n, a, l) {
      const d = {}, c = n.filter((h) => !a.some((g) => g === h));
      return c.length > 0 && c.forEach((h) => d[h] = js(h, l).values), d;
    }(Object.getOwnPropertyNames(e), ["__ob__", "__v_skip", "__metadata__", ...t, ...i], i);
    if (le(r, (n, a) => {
      let l = `invalid ${o} property '${n}' did you mean any of these: ${a.slice(0, 8).join(", ")}.`;
      i.includes("context") && (l += `
If you are trying to annotate ${o} with application data, use the '${o}.context' property instead.`), b(l);
    }), Object.keys(r).length > 0 && s) {
      const n = this.getFrameworkOverrides().getDocLink(s);
      b(`to see all the valid ${o} properties please check: ${n}`);
    }
  }
}] }, zl, Ra, Pd, Md, Dd, Td, Ed] }, zd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "gridDestroyService", this.destroyCalled = !1;
  }
  wireBeans(e) {
    this.beans = e;
  }
  destroy() {
    var t, i;
    if (this.destroyCalled)
      return;
    const e = { type: "gridPreDestroyed", state: ((t = this.beans.stateService) == null ? void 0 : t.getState()) ?? {} };
    this.eventService.dispatchEvent(e), this.destroyCalled = !0, (i = this.beans.ctrlsService.get("gridCtrl")) == null || i.destroyGridUi(), this.beans.context.destroy(), super.destroy();
  }
  isDestroyCalled() {
    return this.destroyCalled;
  }
}, $t = /* @__PURE__ */ new Set(["gridPreDestroyed", "fillStart", "pasteStart"]), Bd = new Map([...Ft.BOOLEAN_PROPERTIES.map((e) => [e, Pi]), ...Ft.NUMBER_PROPERTIES.map((e) => [e, ar]), ["groupAggFiltering", (e) => typeof e == "function" ? e : Pi(e)], ["pageSize", ue(1)], ["autoSizePadding", ue(0)], ["keepDetailRowsCount", ue(1)], ["rowBuffer", ue(0)], ["infiniteInitialRowCount", ue(1)], ["cacheOverflowSize", ue(1)], ["cacheBlockSize", ue(1)], ["serverSideInitialRowCount", ue(1)], ["viewportRowModelPageSize", ue(1)], ["viewportRowModelBufferSize", ue(0)]]);
function Lr(e, t) {
  const i = Bd.get(e);
  return i ? i(t) : t;
}
var Or = class Nr extends f {
  constructor() {
    super(...arguments), this.beanName = "gos", this.domDataKey = "__AG_" + Math.random().toString(), this.propertyEventService = new ht(), this.globalEventHandlerFactory = (t) => (i, o) => {
      if (!this.isAlive())
        return;
      const s = $t.has(i);
      if (s && !t || !s && t)
        return;
      const r = ws.getCallbackForEvent(i), n = this.gridOptions[r];
      typeof n == "function" && this.frameworkOverrides.wrapOutgoing(() => {
        n(o);
      });
    };
  }
  wireBeans(t) {
    this.gridOptions = t.gridOptions, this.eGridDiv = t.eGridDiv, this.validationService = t.validationService, this.environment = t.environment, this.api = t.gridApi;
  }
  get gridOptionsContext() {
    return this.gridOptions.context;
  }
  postConstruct() {
    const t = !this.get("suppressAsyncEvents");
    this.eventService.addGlobalListener(this.globalEventHandlerFactory().bind(this), t), this.eventService.addGlobalListener(this.globalEventHandlerFactory(!0).bind(this), !1), this.propertyEventService.setFrameworkOverrides(this.frameworkOverrides), this.getScrollbarWidth(), this.addManagedEventListeners({ gridOptionsChanged: ({ options: i }) => {
      this.updateGridOptions({ options: i, force: !0, source: "gridOptionsUpdated" });
    } });
  }
  get(t) {
    return this.gridOptions[t] ?? Gd[t];
  }
  getCallback(t) {
    return this.mergeGridCommonParams(this.gridOptions[t]);
  }
  exists(t) {
    return S(this.gridOptions[t]);
  }
  mergeGridCommonParams(t) {
    return t && ((i) => {
      const o = i;
      return o.api = this.api, o.context = this.gridOptionsContext, t(o);
    });
  }
  updateGridOptions({ options: t, force: i, source: o = "api" }) {
    var n;
    const s = { id: Nr.changeSetId++, properties: [] }, r = [];
    Object.entries(t).forEach(([a, l]) => {
      o === "api" && Cn[a] && b(`${a} is an initial property and cannot be updated.`);
      const d = Lr(a, l), c = i || typeof d == "object" && o === "api", h = this.gridOptions[a];
      if (c || h !== d) {
        this.gridOptions[a] = d;
        const g = { type: a, currentValue: d, previousValue: h, changeSet: s, source: o };
        r.push(g);
      }
    }), (n = this.validationService) == null || n.processGridOptions(this.gridOptions), s.properties = r.map((a) => a.type), r.forEach((a) => {
      this.gridOptions.debug && se(`Updated property ${a.type} from`, a.previousValue, " to ", a.currentValue), this.propertyEventService.dispatchEvent(a);
    });
  }
  addPropertyEventListener(t, i) {
    this.propertyEventService.addEventListener(t, i);
  }
  removePropertyEventListener(t, i) {
    this.propertyEventService.removeEventListener(t, i);
  }
  getScrollbarWidth() {
    if (this.scrollbarWidth == null) {
      const t = typeof this.gridOptions.scrollbarWidth == "number" && this.gridOptions.scrollbarWidth >= 0 ? this.gridOptions.scrollbarWidth : (Ii == null && Es(), Ii);
      t != null && (this.scrollbarWidth = t, this.eventService.dispatchEvent({ type: "scrollbarWidthChanged" }));
    }
    return this.scrollbarWidth;
  }
  isRowModelType(t) {
    return this.gridOptions.rowModelType === t || t === "clientSide" && A(this.gridOptions.rowModelType);
  }
  isDomLayout(t) {
    return (this.gridOptions.domLayout ?? "normal") === t;
  }
  isRowSelection() {
    return this.gridOptions.rowSelection === "single" || this.gridOptions.rowSelection === "multiple";
  }
  useAsyncEvents() {
    return !this.get("suppressAsyncEvents");
  }
  isGetRowHeightFunction() {
    return typeof this.gridOptions.getRowHeight == "function";
  }
  getRowHeightForNode(t, i = !1, o) {
    if (o == null && (o = this.environment.getDefaultRowHeight()), this.isGetRowHeightFunction()) {
      if (i)
        return { height: o, estimated: !0 };
      const s = { node: t, data: t.data }, r = this.getCallback("getRowHeight")(s);
      if (this.isNumeric(r))
        return r === 0 && b("The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead."), { height: Math.max(1, r), estimated: !1 };
    }
    return t.detail && this.get("masterDetail") ? this.getMasterDetailRowHeight() : { height: this.gridOptions.rowHeight && this.isNumeric(this.gridOptions.rowHeight) ? this.gridOptions.rowHeight : o, estimated: !1 };
  }
  getMasterDetailRowHeight() {
    return this.get("detailRowAutoHeight") ? { height: 1, estimated: !1 } : this.isNumeric(this.gridOptions.detailRowHeight) ? { height: this.gridOptions.detailRowHeight, estimated: !1 } : { height: 300, estimated: !1 };
  }
  getRowHeightAsNumber() {
    if (!this.gridOptions.rowHeight || A(this.gridOptions.rowHeight))
      return this.environment.getDefaultRowHeight();
    const t = this.environment.refreshRowHeightVariable();
    return t !== -1 ? t : (b("row height must be a number if not using standard row model"), this.environment.getDefaultRowHeight());
  }
  isNumeric(t) {
    return !isNaN(t) && typeof t == "number" && isFinite(t);
  }
  getDomDataKey() {
    return this.domDataKey;
  }
  getDomData(t, i) {
    const o = t[this.getDomDataKey()];
    return o ? o[i] : void 0;
  }
  setDomData(t, i, o) {
    const s = this.getDomDataKey();
    let r = t[s];
    A(r) && (r = {}, t[s] = r), r[i] = o;
  }
  getDocument() {
    let t = null;
    return this.gridOptions.getDocument && S(this.gridOptions.getDocument) ? t = this.gridOptions.getDocument() : this.eGridDiv && (t = this.eGridDiv.ownerDocument), t && S(t) ? t : document;
  }
  getWindow() {
    return this.getDocument().defaultView || window;
  }
  getRootNode() {
    return this.eGridDiv.getRootNode();
  }
  getActiveDomElement() {
    return this.getRootNode().activeElement;
  }
  getAsyncTransactionWaitMillis() {
    return S(this.gridOptions.asyncTransactionWaitMillis) ? this.gridOptions.asyncTransactionWaitMillis : 50;
  }
  isAnimateRows() {
    return !this.get("ensureDomOrder") && this.get("animateRows");
  }
  isGroupRowsSticky() {
    return !(this.get("paginateChildRows") || this.get("groupHideOpenParents") || this.isDomLayout("print"));
  }
  isColumnsSortingCoupledToGroup() {
    const t = this.gridOptions.autoGroupColumnDef;
    return !(t != null && t.comparator) && !this.get("treeData");
  }
  getGroupAggFiltering() {
    const t = this.gridOptions.groupAggFiltering;
    return typeof t == "function" ? this.getCallback("groupAggFiltering") : t === !0 ? () => !0 : void 0;
  }
  getGrandTotalRow() {
    return this.gridOptions.grandTotalRow || (this.gridOptions.groupIncludeTotalFooter ? "bottom" : void 0);
  }
  getGroupTotalRowCallback() {
    const t = this.get("groupTotalRow");
    if (typeof t == "function")
      return this.getCallback("groupTotalRow");
    if (t)
      return () => t;
    const i = this.get("groupIncludeFooter");
    if (typeof i == "function") {
      const o = this.getCallback("groupIncludeFooter");
      return (s) => o(s) ? "bottom" : void 0;
    }
    return () => i ? "bottom" : void 0;
  }
  isGroupMultiAutoColumn() {
    return this.gridOptions.groupDisplayType ? this.gridOptions.groupDisplayType === "multipleColumns" : this.get("groupHideOpenParents");
  }
  isGroupUseEntireRow(t) {
    return !t && this.gridOptions.groupDisplayType === "groupRows";
  }
  getGridCommonParams() {
    return { api: this.api, context: this.gridOptionsContext };
  }
  addGridCommonParams(t) {
    const i = t;
    return i.api = this.api, i.context = this.gridOptionsContext, i;
  }
  getRowIdCallback() {
    const t = this.getCallback("getRowId");
    return t === void 0 ? t : (i) => {
      let o = t(i);
      return typeof o != "string" && (b("The getRowId callback must return a string. The ID ", o, " is being cast to a string."), o = String(o)), o;
    };
  }
};
Or.changeSetId = 0;
var Hd = Or, Vd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "headerPositionUtils";
  }
  wireBeans(e) {
    this.visibleColsService = e.visibleColsService, this.ctrlsService = e.ctrlsService;
  }
  findHeader(e, t) {
    let i, o;
    if (V(e.column) ? i = this.visibleColsService.getGroupAtDirection(e.column, t) : (o = `getCol${t}`, i = this.visibleColsService[o](e.column)), !i)
      return;
    const { headerRowIndex: s } = e;
    if (this.getHeaderRowType(s) !== "filter") {
      const a = [i];
      for (; i.getParent(); )
        i = i.getParent(), a.push(i);
      i = a[a.length - 1 - s];
    }
    const { column: r, headerRowIndex: n } = this.getHeaderIndexToFocus(i, s);
    return { column: r, headerRowIndex: n };
  }
  getHeaderIndexToFocus(e, t) {
    let i;
    if (V(e) && this.isAnyChildSpanningHeaderHeight(e) && e.isPadding()) {
      const o = e;
      i = o.getLeafColumns()[0];
      let s = i;
      for (; s !== o; )
        t++, s = s.getParent();
    }
    return { column: i || e, headerRowIndex: t };
  }
  isAnyChildSpanningHeaderHeight(e) {
    return !!e && e.getLeafColumns().some((t) => t.isSpanHeaderHeight());
  }
  getColumnVisibleParent(e, t) {
    const i = this.getHeaderRowType(t), o = i === "column";
    let s = i === "filter" ? e : e.getParent(), r = t - 1, n = r;
    if (o && this.isAnyChildSpanningHeaderHeight(e.getParent())) {
      for (; s && s.isPadding(); )
        s = s.getParent(), r--;
      n = r, r < 0 && (s = e, r = t, n = void 0);
    }
    return { column: s, headerRowIndex: r, headerRowIndexWithoutSpan: n };
  }
  getColumnVisibleChild(e, t, i = "After") {
    let o = e, s = t + 1;
    const r = s;
    if (this.getHeaderRowType(t) === "group") {
      const n = e.getDisplayedLeafColumns(), a = i === "After" ? n[0] : T(n), l = [];
      let d = a;
      for (; d.getParent() !== e; )
        d = d.getParent(), l.push(d);
      if (o = a, a.isSpanHeaderHeight())
        for (let c = l.length - 1; c >= 0; c--) {
          const h = l[c];
          if (!h.isPadding()) {
            o = h;
            break;
          }
          s++;
        }
      else
        o = T(l), o || (o = a);
    }
    return { column: o, headerRowIndex: s, headerRowIndexWithoutSpan: r };
  }
  getHeaderRowType(e) {
    const t = this.ctrlsService.getHeaderRowContainerCtrl();
    if (t)
      return t.getRowType(e);
  }
  findColAtEdgeForHeaderRow(e, t) {
    const i = this.visibleColsService.getAllCols(), o = i[t === "start" ? 0 : i.length - 1];
    if (!o)
      return;
    const s = this.ctrlsService.getHeaderRowContainerCtrl(o.getPinned()).getRowType(e);
    return s == "group" ? { headerRowIndex: e, column: this.visibleColsService.getColGroupAtLevel(o, e) } : { headerRowIndex: s == null ? -1 : e, column: o };
  }
}, Wd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "localeService";
  }
  getLocaleTextFunc() {
    const e = this.gos.getCallback("getLocaleText");
    if (e)
      return (i, o, s) => e({ key: i, defaultValue: o, variableValues: s });
    const t = this.gos.get("localeText");
    return (i, o, s) => {
      let r = t && t[i];
      if (r && s && s.length) {
        let n = 0;
        for (; !(n >= s.length) && r.indexOf("${variable}") !== -1; )
          r = r.replace("${variable}", s[n++]);
      }
      return r ?? o;
    };
  }
}, Ud = class extends f {
  constructor() {
    super(...arguments), this.beanName = "apiEventService", this.syncEventListeners = /* @__PURE__ */ new Map(), this.asyncEventListeners = /* @__PURE__ */ new Map(), this.syncGlobalEventListeners = /* @__PURE__ */ new Set(), this.globalEventListenerPairs = /* @__PURE__ */ new Map();
  }
  postConstruct() {
    this.frameworkEventWrappingService = new qi(this.getFrameworkOverrides());
  }
  addEventListener(e, t) {
    const i = this.frameworkEventWrappingService.wrap(t), o = this.gos.useAsyncEvents() && !$t.has(e), s = o ? this.asyncEventListeners : this.syncEventListeners;
    s.has(e) || s.set(e, /* @__PURE__ */ new Set()), s.get(e).add(i), this.eventService.addEventListener(e, i, o);
  }
  removeEventListener(e, t) {
    var r;
    const i = this.frameworkEventWrappingService.unwrap(t), o = this.asyncEventListeners.get(e), s = !!(o != null && o.delete(i));
    s || ((r = this.syncEventListeners.get(e)) == null || r.delete(i)), this.eventService.removeEventListener(e, i, s);
  }
  addGlobalListener(e) {
    const t = this.frameworkEventWrappingService.wrapGlobal(e);
    if (this.gos.useAsyncEvents()) {
      const i = (s, r) => {
        $t.has(s) && t(s, r);
      }, o = (s, r) => {
        $t.has(s) || t(s, r);
      };
      this.globalEventListenerPairs.set(e, { syncListener: i, asyncListener: o }), this.eventService.addGlobalListener(i, !1), this.eventService.addGlobalListener(o, !0);
    } else
      this.syncGlobalEventListeners.add(t), this.eventService.addGlobalListener(t, !1);
  }
  removeGlobalListener(e) {
    const t = this.frameworkEventWrappingService.unwrapGlobal(e);
    if (this.globalEventListenerPairs.has(t)) {
      const { syncListener: i, asyncListener: o } = this.globalEventListenerPairs.get(t);
      this.eventService.removeGlobalListener(i, !1), this.eventService.removeGlobalListener(o, !0), this.globalEventListenerPairs.delete(e);
    } else
      this.syncGlobalEventListeners.delete(t), this.eventService.removeGlobalListener(t, !1);
  }
  destroyEventListeners(e, t) {
    e.forEach((i, o) => {
      i.forEach((s) => this.eventService.removeEventListener(o, s, t)), i.clear();
    }), e.clear();
  }
  destroyGlobalListeners(e, t) {
    e.forEach((i) => this.eventService.removeGlobalListener(i, t)), e.clear();
  }
  destroy() {
    super.destroy(), this.destroyEventListeners(this.syncEventListeners, !1), this.destroyEventListeners(this.asyncEventListeners, !0), this.destroyGlobalListeners(this.syncGlobalEventListeners, !1), this.globalEventListenerPairs.forEach(({ syncListener: e, asyncListener: t }) => {
      this.eventService.removeGlobalListener(e, !1), this.eventService.removeGlobalListener(t, !0);
    }), this.globalEventListenerPairs.clear();
  }
}, jd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "pageBoundsListener";
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.paginationService = e.paginationService, this.pageBoundsService = e.pageBoundsService;
  }
  postConstruct() {
    this.addManagedEventListeners({ modelUpdated: this.onModelUpdated.bind(this), recalculateRowBounds: this.calculatePages.bind(this) }), this.onModelUpdated();
  }
  onModelUpdated(e) {
    this.calculatePages();
    const t = { type: "paginationChanged", animate: !!e && e.animate, newData: !!e && e.newData, newPage: !!e && e.newPage, newPageSize: !!e && e.newPageSize, keepRenderedRows: !!e && e.keepRenderedRows };
    this.eventService.dispatchEvent(t);
  }
  calculatePages() {
    this.paginationService ? this.paginationService.calculatePages() : this.pageBoundsService.calculateBounds(0, this.rowModel.getRowCount() - 1);
  }
}, Kd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "pageBoundsService", this.pixelOffset = 0;
  }
  wireBeans(e) {
    this.rowModel = e.rowModel;
  }
  getFirstRow() {
    return this.topRowBounds ? this.topRowBounds.rowIndex : -1;
  }
  getLastRow() {
    return this.bottomRowBounds ? this.bottomRowBounds.rowIndex : -1;
  }
  getCurrentPageHeight() {
    return A(this.topRowBounds) || A(this.bottomRowBounds) ? 0 : Math.max(this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight - this.topRowBounds.rowTop, 0);
  }
  getCurrentPagePixelRange() {
    return { pageFirstPixel: this.topRowBounds ? this.topRowBounds.rowTop : 0, pageLastPixel: this.bottomRowBounds ? this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight : 0 };
  }
  calculateBounds(e, t) {
    this.topRowBounds = this.rowModel.getRowBounds(e), this.topRowBounds && (this.topRowBounds.rowIndex = e), this.bottomRowBounds = this.rowModel.getRowBounds(t), this.bottomRowBounds && (this.bottomRowBounds.rowIndex = t), this.calculatePixelOffset();
  }
  getPixelOffset() {
    return this.pixelOffset;
  }
  calculatePixelOffset() {
    const e = S(this.topRowBounds) ? this.topRowBounds.rowTop : 0;
    this.pixelOffset !== e && (this.pixelOffset = e, this.eventService.dispatchEvent({ type: "paginationPixelOffsetChanged" }));
  }
}, Qd = class extends f {
  constructor() {
    super(), this.beanName = "ariaAnnouncementService", this.descriptionContainer = null, this.announceValue = q(this.announceValue.bind(this), 200);
  }
  wireBeans(e) {
    this.eGridDiv = e.eGridDiv;
  }
  postConstruct() {
    const e = this.gos.getDocument(), t = this.descriptionContainer = e.createElement("div");
    t.classList.add("ag-aria-description-container"), Ss(t, "polite"), De(t, "relevant", "additions text"), De(t, "atomic", !0), this.eGridDiv.appendChild(t);
  }
  announceValue(e) {
    this.descriptionContainer && (this.descriptionContainer.textContent = "", setTimeout(() => {
      this.isAlive() && this.descriptionContainer && (this.descriptionContainer.textContent = e);
    }, 50));
  }
  destroy() {
    super.destroy();
    const { descriptionContainer: e } = this;
    e && (j(e), e.parentElement && e.parentElement.removeChild(e)), this.descriptionContainer = null, this.eGridDiv = null;
  }
}, Yd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "columnAnimationService", this.executeNextFuncs = [], this.executeLaterFuncs = [], this.active = !1, this.suppressAnimation = !1, this.animationThreadCount = 0;
  }
  wireBeans(e) {
    this.ctrlsService = e.ctrlsService;
  }
  postConstruct() {
    this.ctrlsService.whenReady((e) => this.gridBodyCtrl = e.gridBodyCtrl);
  }
  isActive() {
    return this.active && !this.suppressAnimation;
  }
  setSuppressAnimation(e) {
    this.suppressAnimation = e;
  }
  start() {
    this.active || this.gos.get("suppressColumnMoveAnimation") || this.gos.get("enableRtl") || (this.ensureAnimationCssClassPresent(), this.active = !0);
  }
  finish() {
    this.active && this.flush(() => {
      this.active = !1;
    });
  }
  executeNextVMTurn(e) {
    this.active ? this.executeNextFuncs.push(e) : e();
  }
  executeLaterVMTurn(e) {
    this.active ? this.executeLaterFuncs.push(e) : e();
  }
  ensureAnimationCssClassPresent() {
    this.animationThreadCount++;
    const e = this.animationThreadCount;
    this.gridBodyCtrl.setColumnMovingCss(!0), this.executeLaterFuncs.push(() => {
      this.animationThreadCount === e && this.gridBodyCtrl.setColumnMovingCss(!1);
    });
  }
  flush(e) {
    if (this.executeNextFuncs.length === 0 && this.executeLaterFuncs.length === 0)
      return void e();
    const t = (i) => {
      for (; i.length; ) {
        const o = i.pop();
        o && o();
      }
    };
    this.getFrameworkOverrides().wrapIncoming(() => {
      window.setTimeout(() => t(this.executeNextFuncs), 0), window.setTimeout(() => {
        e(), t(this.executeLaterFuncs);
      }, 200);
    });
  }
}, qd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "columnHoverService";
  }
  setMouseOver(e) {
    this.selectedColumns = e, this.eventService.dispatchEvent({ type: "columnHoverChanged" });
  }
  clearMouseOver() {
    this.selectedColumns = null, this.eventService.dispatchEvent({ type: "columnHoverChanged" });
  }
  isHovered(e) {
    return !!this.selectedColumns && this.selectedColumns.indexOf(e) >= 0;
  }
}, $d = class extends f {
  constructor() {
    super(...arguments), this.beanName = "overlayService", this.state = 0, this.showInitialOverlay = !0;
  }
  wireBeans(e) {
    this.userComponentFactory = e.userComponentFactory, this.rowModel = e.rowModel, this.columnModel = e.columnModel;
  }
  postConstruct() {
    const e = () => this.updateOverlayVisibility();
    this.addManagedEventListeners({ newColumnsLoaded: e, rowDataUpdated: e }), this.addManagedPropertyListener("loading", e);
  }
  registerOverlayWrapperComp(e) {
    this.overlayWrapperComp = e, this.updateOverlayVisibility();
  }
  showLoadingOverlay() {
    this.showInitialOverlay = !1;
    const e = this.gos.get("loading");
    (e || e === void 0 && !this.gos.get("suppressLoadingOverlay")) && this.doShowLoadingOverlay();
  }
  showNoRowsOverlay() {
    this.showInitialOverlay = !1, this.gos.get("loading") || this.gos.get("suppressNoRowsOverlay") || this.doShowNoRowsOverlay();
  }
  hideOverlay() {
    this.showInitialOverlay = !1, this.gos.get("loading") || this.doHideOverlay();
  }
  updateOverlayVisibility() {
    let e = this.gos.get("loading");
    this.showInitialOverlay && e === void 0 && !this.gos.get("suppressLoadingOverlay") && (e = !this.gos.get("columnDefs") || !this.columnModel.isReady() || !this.gos.get("rowData") && this.gos.isRowModelType("clientSide")), e ? this.state !== 1 && this.doShowLoadingOverlay() : (this.showInitialOverlay = !1, this.rowModel.isEmpty() && !this.gos.get("suppressNoRowsOverlay") && this.gos.isRowModelType("clientSide") ? this.state !== 2 && this.doShowNoRowsOverlay() : this.state !== 0 && this.doHideOverlay());
  }
  doShowLoadingOverlay() {
    this.state = 1, this.showOverlay(this.userComponentFactory.getLoadingOverlayCompDetails({}), "ag-overlay-loading-wrapper", "loadingOverlayComponentParams");
  }
  doShowNoRowsOverlay() {
    this.state = 2, this.showOverlay(this.userComponentFactory.getNoRowsOverlayCompDetails({}), "ag-overlay-no-rows-wrapper", "noRowsOverlayComponentParams");
  }
  doHideOverlay() {
    this.state = 0, this.overlayWrapperComp.hideOverlay();
  }
  showOverlay(e, t, i) {
    const o = e.newAgStackInstance();
    this.overlayWrapperComp.showOverlay(o, t, i);
  }
}, Jd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "rowCssClassCalculator";
  }
  wireBeans(e) {
    this.stylingService = e.stylingService;
  }
  getInitialRowClasses(e) {
    const t = [];
    return S(e.extraCssClass) && t.push(e.extraCssClass), t.push("ag-row"), t.push(e.rowFocused ? "ag-row-focus" : "ag-row-no-focus"), e.fadeRowIn && t.push("ag-opacity-zero"), t.push(e.rowIsEven ? "ag-row-even" : "ag-row-odd"), e.rowNode.isRowPinned() && t.push("ag-row-pinned"), e.rowNode.isSelected() && t.push("ag-row-selected"), e.rowNode.footer && t.push("ag-row-footer"), t.push("ag-row-level-" + e.rowLevel), e.rowNode.stub && t.push("ag-row-loading"), e.fullWidthRow && t.push("ag-full-width-row"), e.expandable && (t.push("ag-row-group"), t.push(e.rowNode.expanded ? "ag-row-group-expanded" : "ag-row-group-contracted")), e.rowNode.dragging && t.push("ag-row-dragging"), Mo(t, this.processClassesFromGridOptions(e.rowNode)), Mo(t, this.preProcessRowClassRules(e.rowNode)), t.push(e.printLayout ? "ag-row-position-relative" : "ag-row-position-absolute"), e.firstRowOnPage && t.push("ag-row-first"), e.lastRowOnPage && t.push("ag-row-last"), e.fullWidthRow && (e.pinned === "left" && t.push("ag-cell-last-left-pinned"), e.pinned === "right" && t.push("ag-cell-first-right-pinned")), t;
  }
  processClassesFromGridOptions(e) {
    const t = [], i = (r) => {
      typeof r == "string" ? t.push(r) : Array.isArray(r) && r.forEach((n) => t.push(n));
    }, o = this.gos.get("rowClass");
    if (o) {
      if (typeof o == "function")
        return b("rowClass should not be a function, please use getRowClass instead"), [];
      i(o);
    }
    const s = this.gos.getCallback("getRowClass");
    return s && i(s({ data: e.data, node: e, rowIndex: e.rowIndex })), t;
  }
  preProcessRowClassRules(e) {
    const t = [];
    return this.processRowClassRules(e, (i) => {
      t.push(i);
    }, () => {
    }), t;
  }
  processRowClassRules(e, t, i) {
    const o = this.gos.addGridCommonParams({ data: e.data, node: e, rowIndex: e.rowIndex });
    this.stylingService.processClassRules(void 0, this.gos.get("rowClassRules"), o, t, i);
  }
  calculateRowLevel(e) {
    return e.group ? e.level : e.parent ? e.parent.level + 1 : 0;
  }
}, Xd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "rowContainerHeightService", this.scrollY = 0, this.uiBodyHeight = 0;
  }
  wireBeans(e) {
    this.ctrlsService = e.ctrlsService;
  }
  postConstruct() {
    this.addManagedEventListeners({ bodyHeightChanged: this.updateOffset.bind(this) }), this.maxDivHeight = function() {
      if (!document.body)
        return -1;
      let e = 1e6;
      const t = navigator.userAgent.toLowerCase().match(/firefox/) ? 6e6 : 1e9, i = document.createElement("div");
      for (document.body.appendChild(i); ; ) {
        const o = 2 * e;
        if (i.style.height = o + "px", o > t || i.clientHeight !== o)
          break;
        e = o;
      }
      return document.body.removeChild(i), e;
    }(), this.gos.get("debug") && se("RowContainerHeightService - maxDivHeight = " + this.maxDivHeight);
  }
  isStretching() {
    return this.stretching;
  }
  getDivStretchOffset() {
    return this.divStretchOffset;
  }
  updateOffset() {
    if (!this.stretching)
      return;
    const e = this.ctrlsService.getGridBodyCtrl().getScrollFeature().getVScrollPosition().top, t = this.getUiBodyHeight();
    (e !== this.scrollY || t !== this.uiBodyHeight) && (this.scrollY = e, this.uiBodyHeight = t, this.calculateOffset());
  }
  calculateOffset() {
    this.setUiContainerHeight(this.maxDivHeight), this.pixelsToShave = this.modelHeight - this.uiContainerHeight, this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
    const e = this.scrollY / this.maxScrollY, t = e * this.pixelsToShave;
    this.gos.get("debug") && se(`RowContainerHeightService - Div Stretch Offset = ${t} (${this.pixelsToShave} * ${e})`), this.setDivStretchOffset(t);
  }
  setUiContainerHeight(e) {
    e !== this.uiContainerHeight && (this.uiContainerHeight = e, this.eventService.dispatchEvent({ type: "rowContainerHeightChanged" }));
  }
  clearOffset() {
    this.setUiContainerHeight(this.modelHeight), this.pixelsToShave = 0, this.setDivStretchOffset(0);
  }
  setDivStretchOffset(e) {
    const t = typeof e == "number" ? Math.floor(e) : null;
    this.divStretchOffset !== t && (this.divStretchOffset = t, this.eventService.dispatchEvent({ type: "heightScaleChanged" }));
  }
  setModelHeight(e) {
    this.modelHeight = e, this.stretching = e != null && this.maxDivHeight > 0 && e > this.maxDivHeight, this.stretching ? this.calculateOffset() : this.clearOffset();
  }
  getUiContainerHeight() {
    return this.uiContainerHeight;
  }
  getRealPixelPosition(e) {
    return e - this.divStretchOffset;
  }
  getUiBodyHeight() {
    const e = this.ctrlsService.getGridBodyCtrl().getScrollFeature().getVScrollPosition();
    return e.bottom - e.top;
  }
  getScrollPositionForPixel(e) {
    if (this.pixelsToShave <= 0)
      return e;
    const t = e / (this.modelHeight - this.getUiBodyHeight());
    return this.maxScrollY * t;
  }
}, Zd = class extends f {
  constructor() {
    super(...arguments), this.beanName = "rowNodeSorter";
  }
  wireBeans(e) {
    this.valueService = e.valueService, this.columnModel = e.columnModel, this.showRowGroupColsService = e.showRowGroupColsService;
  }
  postConstruct() {
    this.isAccentedSort = this.gos.get("accentedSort"), this.primaryColumnsSortGroups = this.gos.isColumnsSortingCoupledToGroup(), this.addManagedPropertyListener("accentedSort", (e) => this.isAccentedSort = e.currentValue), this.addManagedPropertyListener("autoGroupColumnDef", () => this.primaryColumnsSortGroups = this.gos.isColumnsSortingCoupledToGroup());
  }
  doFullSort(e, t) {
    const i = e.map((o, s) => ({ currentPos: s, rowNode: o }));
    return i.sort(this.compareRowNodes.bind(this, t)), i.map((o) => o.rowNode);
  }
  compareRowNodes(e, t, i) {
    const o = t.rowNode, s = i.rowNode;
    for (let r = 0, n = e.length; r < n; r++) {
      const a = e[r], l = a.sort === "desc", d = this.getValue(o, a.column), c = this.getValue(s, a.column);
      let h;
      const g = this.getComparator(a, o);
      if (h = g ? g(d, c, o, s, l) : _r(d, c, this.isAccentedSort), !isNaN(h) && h !== 0)
        return a.sort === "asc" ? h : -1 * h;
    }
    return t.currentPos - i.currentPos;
  }
  getComparator(e, t) {
    const i = e.column, o = i.getColDef().comparator;
    if (o != null)
      return o;
    if (!i.getColDef().showRowGroup)
      return;
    const s = !t.group && i.getColDef().field;
    if (!s)
      return;
    const r = this.columnModel.getColDefCol(s);
    return r ? r.getColDef().comparator : void 0;
  }
  getValue(e, t) {
    var i, o, s;
    if (!this.primaryColumnsSortGroups)
      return this.valueService.getValue(t, e, !1, !1);
    if (e.rowGroupColumn === t) {
      if (this.gos.isGroupUseEntireRow(this.columnModel.isPivotActive())) {
        const n = (i = e.allLeafChildren) == null ? void 0 : i[0];
        return n ? this.valueService.getValue(t, n, !1, !1) : void 0;
      }
      const r = (o = this.showRowGroupColsService) == null ? void 0 : o.getShowRowGroupCol(t.getId());
      return r ? (s = e.groupData) == null ? void 0 : s[r.getId()] : void 0;
    }
    return e.group && t.getColDef().showRowGroup ? void 0 : this.valueService.getValue(t, e, !1, !1);
  }
}, li = class {
  constructor(e, t) {
    this.active = !0, this.nodeIdsToColumns = {}, this.mapToItems = {}, this.keepingColumns = e, this.pathRoot = { rowNode: t, children: null }, this.mapToItems[t.id] = this.pathRoot;
  }
  setInactive() {
    this.active = !1;
  }
  isActive() {
    return this.active;
  }
  depthFirstSearchChangedPath(e, t) {
    if (e.children)
      for (let i = 0; i < e.children.length; i++)
        this.depthFirstSearchChangedPath(e.children[i], t);
    t(e.rowNode);
  }
  depthFirstSearchEverything(e, t, i) {
    if (e.childrenAfterGroup)
      for (let o = 0; o < e.childrenAfterGroup.length; o++) {
        const s = e.childrenAfterGroup[o];
        s.childrenAfterGroup ? this.depthFirstSearchEverything(e.childrenAfterGroup[o], t, i) : i && t(s);
      }
    t(e);
  }
  forEachChangedNodeDepthFirst(e, t = !1, i = !1) {
    this.active && !i ? this.depthFirstSearchChangedPath(this.pathRoot, e) : this.depthFirstSearchEverything(this.pathRoot.rowNode, e, t);
  }
  executeFromRootNode(e) {
    e(this.pathRoot.rowNode);
  }
  createPathItems(e) {
    let t = e, i = 0;
    for (; !this.mapToItems[t.id]; ) {
      const o = { rowNode: t, children: null };
      this.mapToItems[t.id] = o, i++, t = t.parent;
    }
    return i;
  }
  populateColumnsMap(e, t) {
    if (!this.keepingColumns || !t)
      return;
    let i = e;
    for (; i; )
      this.nodeIdsToColumns[i.id] || (this.nodeIdsToColumns[i.id] = {}), t.forEach((o) => this.nodeIdsToColumns[i.id][o.getId()] = !0), i = i.parent;
  }
  linkPathItems(e, t) {
    let i = e;
    for (let o = 0; o < t; o++) {
      const s = this.mapToItems[i.id], r = this.mapToItems[i.parent.id];
      r.children || (r.children = []), r.children.push(s), i = i.parent;
    }
  }
  addParentNode(e, t) {
    if (!e || e.isRowPinned())
      return;
    const i = this.createPathItems(e);
    this.linkPathItems(e, i), this.populateColumnsMap(e, t);
  }
  canSkip(e) {
    return this.active && !this.mapToItems[e.id];
  }
  getValueColumnsForNode(e, t) {
    if (!this.keepingColumns)
      return t;
    const i = this.nodeIdsToColumns[e.id];
    return t.filter((o) => i[o.getId()]);
  }
  getNotValueColumnsForNode(e, t) {
    if (!this.keepingColumns)
      return null;
    const i = this.nodeIdsToColumns[e.id];
    return t.filter((o) => !i[o.getId()]);
  }
}, Gr = class extends f {
  constructor() {
    super(...arguments), this.beanName = "selectionService", this.selectedNodes = /* @__PURE__ */ new Map(), this.selectionCtx = new Ql();
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.pageBoundsService = e.pageBoundsService;
  }
  postConstruct() {
    this.selectionCtx.init(this.rowModel), this.rowSelection = this.gos.get("rowSelection"), this.groupSelectsChildren = this.gos.get("groupSelectsChildren"), this.addManagedPropertyListeners(["groupSelectsChildren", "rowSelection"], () => {
      this.groupSelectsChildren = this.gos.get("groupSelectsChildren"), this.rowSelection = this.gos.get("rowSelection"), this.deselectAllRowNodes({ source: "api" });
    }), this.addManagedEventListeners({ rowSelected: this.onRowSelected.bind(this) });
  }
  destroy() {
    super.destroy(), this.resetNodes(), this.selectionCtx.reset();
  }
  isMultiselect() {
    return this.rowSelection === "multiple";
  }
  overrideSelectionValue(e, t) {
    if (!((o) => o === "checkboxSelected" || o === "rowClicked" || o === "spaceKey" || o === "uiSelectAll" || o === "uiSelectAllCurrentPage" || o === "uiSelectAllFiltered")(t))
      return e;
    const i = this.selectionCtx.getRoot();
    return !i || (i.isSelected() ?? !1);
  }
  setNodesSelected(e) {
    var h;
    const { newValue: t, clearSelection: i, suppressFinishActions: o, rangeSelect: s, nodes: r, event: n, source: a } = e;
    if (r.length === 0)
      return 0;
    if (r.length > 1 && !this.isMultiselect())
      return b("cannot multi select while rowSelection='single'"), 0;
    const l = this.groupSelectsChildren && e.groupSelectsFiltered === !0, d = r.map((g) => g.footer ? g.sibling : g);
    if (s) {
      if (d.length > 1)
        return b("cannot range select while selecting multiple rows"), 0;
      const g = d[0], u = this.overrideSelectionValue(t, a);
      if (this.isMultiselect()) {
        if (this.selectionCtx.isInRange(g)) {
          const p = this.selectionCtx.truncate(g);
          return u && this.selectRange(p.discard, !1, a), this.selectRange(p.keep, u, a);
        }
        if (this.selectionCtx.getRoot() !== g) {
          const p = this.selectionCtx.extend(g, this.groupSelectsChildren);
          return u && this.selectRange(p.discard, !1, a), this.selectRange(p.keep, u, a);
        }
      }
    }
    o || this.selectionCtx.setRoot(d[0]);
    let c = 0;
    for (let g = 0; g < d.length; g++) {
      const u = d[g];
      l && u.group || u.selectThisNode(t, n, a) && c++, this.groupSelectsChildren && ((h = u.childrenAfterGroup) != null && h.length) && (c += this.selectChildren(u, t, l, a));
    }
    return o || (t && (i || !this.isMultiselect()) && (c += this.clearOtherNodes(d[0], a)), c > 0 && (this.updateGroupsFromChildrenSelections(a), this.dispatchSelectionChanged(a))), c;
  }
  selectRange(e, t, i) {
    let o = 0;
    return e.forEach((s) => {
      s.group && this.groupSelectsChildren || s.selectThisNode(t, void 0, i) && o++;
    }), o > 0 && (this.updateGroupsFromChildrenSelections(i), this.dispatchSelectionChanged(i)), o;
  }
  selectChildren(e, t, i, o) {
    const s = i ? e.childrenAfterAggFilter : e.childrenAfterGroup;
    return A(s) ? 0 : this.setNodesSelected({ newValue: t, clearSelection: !1, suppressFinishActions: !0, groupSelectsFiltered: i, source: o, nodes: s });
  }
  getSelectedNodes() {
    const e = [];
    return this.selectedNodes.forEach((t) => {
      t && e.push(t);
    }), e;
  }
  getSelectedRows() {
    const e = [];
    return this.selectedNodes.forEach((t) => {
      t && t.data && e.push(t.data);
    }), e;
  }
  getSelectionCount() {
    return this.selectedNodes.size;
  }
  filterFromSelection(e) {
    const t = /* @__PURE__ */ new Map();
    this.selectedNodes.forEach((i, o) => {
      i && e(i) && t.set(o, i);
    }), this.selectedNodes = t;
  }
  updateGroupsFromChildrenSelections(e, t) {
    if (!this.groupSelectsChildren || this.rowModel.getType() !== "clientSide")
      return !1;
    const i = this.rowModel.getRootNode();
    t || (t = new li(!0, i)).setInactive();
    let o = !1;
    return t.forEachChangedNodeDepthFirst((s) => {
      if (s !== i) {
        const r = s.calculateSelectedFromChildren();
        o = s.selectThisNode(r !== null && r, void 0, e) || o;
      }
    }), o;
  }
  clearOtherNodes(e, t) {
    const i = /* @__PURE__ */ new Map();
    let o = 0;
    return this.selectedNodes.forEach((s) => {
      if (s && s.id !== e.id) {
        const r = this.selectedNodes.get(s.id);
        o += r.setSelectedParams({ newValue: !1, clearSelection: !1, suppressFinishActions: !0, source: t }), this.groupSelectsChildren && s.parent && i.set(s.parent.id, s.parent);
      }
    }), i.forEach((s) => {
      const r = s.calculateSelectedFromChildren();
      s.selectThisNode(r !== null && r, void 0, t);
    }), o;
  }
  onRowSelected(e) {
    const t = e.node;
    this.groupSelectsChildren && t.group || (t.isSelected() ? this.selectedNodes.set(t.id, t) : this.selectedNodes.delete(t.id));
  }
  syncInRowNode(e, t) {
    this.syncInOldRowNode(e, t), this.syncInNewRowNode(e);
  }
  syncInOldRowNode(e, t) {
    if (S(t) && e.id !== t.id && t) {
      const i = t.id;
      this.selectedNodes.get(i) == e && this.selectedNodes.set(t.id, t);
    }
  }
  syncInNewRowNode(e) {
    this.selectedNodes.has(e.id) ? (e.setSelectedInitialValue(!0), this.selectedNodes.set(e.id, e)) : e.setSelectedInitialValue(!1);
  }
  reset(e) {
    const t = this.getSelectionCount();
    this.resetNodes(), t && this.dispatchSelectionChanged(e);
  }
  resetNodes() {
    var e;
    (e = this.selectedNodes) == null || e.clear();
  }
  getBestCostNodeSelection() {
    if (this.rowModel.getType() !== "clientSide")
      return;
    const e = this.rowModel.getTopLevelNodes();
    if (e === null)
      return;
    const t = [];
    return function i(o) {
      for (let s = 0, r = o.length; s < r; s++) {
        const n = o[s];
        if (n.isSelected())
          t.push(n);
        else {
          const a = n;
          a.group && a.children && i(a.children);
        }
      }
    }(e), t;
  }
  isEmpty() {
    let e = 0;
    return this.selectedNodes.forEach((t) => {
      t && e++;
    }), e === 0;
  }
  deselectAllRowNodes(e) {
    const t = (n) => n.selectThisNode(!1, void 0, o), i = this.rowModel.getType() === "clientSide", { source: o, justFiltered: s, justCurrentPage: r } = e;
    if (r || s) {
      if (!i)
        return void L("selecting just filtered only works when gridOptions.rowModelType='clientSide'");
      this.getNodesToSelect(s, r).forEach(t);
    } else
      this.selectedNodes.forEach((n) => {
        n && t(n);
      }), this.reset(o);
    this.selectionCtx.reset(), i && this.groupSelectsChildren && this.updateGroupsFromChildrenSelections(o), this.dispatchSelectionChanged(o);
  }
  getSelectedCounts(e, t) {
    let i = 0, o = 0;
    return this.getNodesToSelect(e, t).forEach((s) => {
      this.groupSelectsChildren && s.group || (s.isSelected() ? i++ : s.selectable && o++);
    }), { selectedCount: i, notSelectedCount: o };
  }
  getSelectAllState(e, t) {
    const { selectedCount: i, notSelectedCount: o } = this.getSelectedCounts(e, t);
    return (i !== 0 || o !== 0) && (i > 0 && o > 0 ? null : i > 0);
  }
  hasNodesToSelect(e = !1, t = !1) {
    return this.getNodesToSelect(e, t).filter((i) => i.selectable).length > 0;
  }
  getNodesToSelect(e = !1, t = !1) {
    if (this.rowModel.getType() !== "clientSide")
      throw new Error(`selectAll only available when rowModelType='clientSide', ie not ${this.rowModel.getType()}`);
    const i = [];
    if (t)
      return this.forEachNodeOnPage((s) => {
        if (s.group)
          if (s.expanded)
            this.groupSelectsChildren || i.push(s);
          else {
            const r = (n) => {
              var a;
              i.push(n), (a = n.childrenAfterFilter) != null && a.length && n.childrenAfterFilter.forEach(r);
            };
            r(s);
          }
        else
          i.push(s);
      }), i;
    const o = this.rowModel;
    return e ? (o.forEachNodeAfterFilter((s) => {
      i.push(s);
    }), i) : (o.forEachNode((s) => {
      i.push(s);
    }), i);
  }
  forEachNodeOnPage(e) {
    const t = this.pageBoundsService.getFirstRow(), i = this.pageBoundsService.getLastRow();
    for (let o = t; o <= i; o++) {
      const s = this.rowModel.getRow(o);
      s && e(s);
    }
  }
  selectAllRowNodes(e) {
    if (this.rowModel.getType() !== "clientSide")
      throw new Error(`selectAll only available when rowModelType='clientSide', ie not ${this.rowModel.getType()}`);
    const { source: t, justFiltered: i, justCurrentPage: o } = e, s = this.getNodesToSelect(i, o);
    s.forEach((r) => r.selectThisNode(!0, void 0, t)), this.selectionCtx.setRoot(s[0] ?? null), this.selectionCtx.setEndRange(T(s) ?? null), this.rowModel.getType() === "clientSide" && this.groupSelectsChildren && this.updateGroupsFromChildrenSelections(t), this.dispatchSelectionChanged(t);
  }
  getSelectionState() {
    const e = [];
    return this.selectedNodes.forEach((t) => {
      t != null && t.id && e.push(t.id);
    }), e.length ? e : null;
  }
  setSelectionState(e, t) {
    if (!Array.isArray(e))
      return;
    const i = new Set(e), o = [];
    this.rowModel.forEachNode((s) => {
      i.has(s.id) && o.push(s);
    }), this.setNodesSelected({ newValue: !0, nodes: o, source: t });
  }
  dispatchSelectionChanged(e) {
    const t = { type: "selectionChanged", source: e };
    this.eventService.dispatchEvent(t);
  }
}, _d = class extends f {
  constructor() {
    super(...arguments), this.beanName = "selectableService";
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.selectionService = e.selectionService;
  }
  postConstruct() {
    this.addManagedPropertyListener("isRowSelectable", () => this.updateSelectable());
  }
  updateSelectableAfterGrouping() {
    this.updateSelectable(!0);
  }
  updateSelectable(e = !1) {
    const t = !!this.gos.get("rowSelection"), i = this.gos.get("isRowSelectable");
    if (!t || !i)
      return;
    const o = this.gos.get("groupSelectsChildren"), s = this.rowModel.getType() === "clientSide" && o, r = [], n = (a) => {
      if (e && !a.group)
        return;
      if (s && a.group) {
        const d = a.childrenAfterGroup.some((c) => c.selectable === !0);
        return void a.setRowSelectable(d, !0);
      }
      const l = !i || i(a);
      a.setRowSelectable(l, !0), !l && a.isSelected() && r.push(a);
    };
    if (s) {
      const a = this.rowModel;
      new li(!1, a.getRootNode()).forEachChangedNodeDepthFirst(n, !0, !0);
    } else
      this.rowModel.forEachNode(n);
    r.length && this.selectionService.setNodesSelected({ nodes: r, newValue: !1, source: "selectableChanged" }), s && this.selectionService instanceof Gr && this.selectionService.updateGroupsFromChildrenSelections("selectableChanged");
  }
}, ss = ["asc", "desc", null], ec = class extends f {
  constructor() {
    super(...arguments), this.beanName = "sortController";
  }
  wireBeans(e) {
    this.columnModel = e.columnModel, this.funcColsService = e.funcColsService, this.showRowGroupColsService = e.showRowGroupColsService;
  }
  progressSort(e, t, i) {
    const o = this.getNextSortDirection(e);
    this.setSortForColumn(e, o, t, i);
  }
  setSortForColumn(e, t, i, o) {
    t !== "asc" && t !== "desc" && (t = null);
    let s = [e];
    if (this.gos.isColumnsSortingCoupledToGroup() && e.getColDef().showRowGroup) {
      const n = this.funcColsService.getSourceColumnsForGroupColumn(e), a = n == null ? void 0 : n.filter((l) => l.isSortable());
      a && (s = [e, ...a]);
    }
    s.forEach((n) => n.setSort(t, o));
    const r = [];
    if (!i && !this.gos.get("alwaysMultiSort") || this.gos.get("suppressMultiSort")) {
      const n = this.clearSortBarTheseColumns(s, o);
      r.push(...n);
    }
    this.updateSortIndex(e), r.push(...s), this.dispatchSortChangedEvents(o, r);
  }
  updateSortIndex(e) {
    var n;
    const t = this.gos.isColumnsSortingCoupledToGroup(), i = (n = this.showRowGroupColsService) == null ? void 0 : n.getShowRowGroupCol(e.getId()), o = t && i || e, s = this.getColumnsWithSortingOrdered();
    this.columnModel.getAllCols().forEach((a) => a.setSortIndex(null));
    const r = s.filter((a) => !(t && a.getColDef().showRowGroup || a === o));
    (o.getSort() ? [...r, o] : r).forEach((a, l) => {
      a.setSortIndex(l);
    });
  }
  onSortChanged(e, t) {
    this.dispatchSortChangedEvents(e, t);
  }
  isSortActive() {
    const e = this.columnModel.getAllCols().filter((t) => !!t.getSort());
    return e && e.length > 0;
  }
  dispatchSortChangedEvents(e, t) {
    const i = { type: "sortChanged", source: e };
    t && (i.columns = t), this.eventService.dispatchEvent(i);
  }
  clearSortBarTheseColumns(e, t) {
    const i = [];
    return this.columnModel.getAllCols().forEach((o) => {
      e.includes(o) || (o.getSort() && i.push(o), o.setSort(void 0, t));
    }), i;
  }
  getNextSortDirection(e) {
    let t;
    if (t = e.getColDef().sortingOrder ? e.getColDef().sortingOrder : this.gos.get("sortingOrder") ? this.gos.get("sortingOrder") : ss, !Array.isArray(t) || t.length <= 0)
      return b(`sortingOrder must be an array with at least one element, currently it's ${t}`), null;
    const i = t.indexOf(e.getSort()), o = i < 0, s = i == t.length - 1;
    let r;
    return r = o || s ? t[0] : t[i + 1], ss.indexOf(r) < 0 ? (b("invalid sort type ", r), null) : r;
  }
  getIndexedSortMap() {
    let e = this.columnModel.getAllCols().filter((r) => !!r.getSort());
    if (this.columnModel.isPivotMode()) {
      const r = this.gos.isColumnsSortingCoupledToGroup();
      e = e.filter((n) => {
        var c;
        const a = !!n.getAggFunc(), l = !n.isPrimary(), d = r ? (c = this.showRowGroupColsService) == null ? void 0 : c.getShowRowGroupCol(n.getId()) : n.getColDef().showRowGroup;
        return a || l || d;
      });
    }
    const t = this.funcColsService.getRowGroupColumns().filter((r) => !!r.getSort()), i = {};
    e.forEach((r, n) => i[r.getId()] = n), e.sort((r, n) => {
      const a = r.getSortIndex(), l = n.getSortIndex();
      return a != null && l != null ? a - l : a == null && l == null ? i[r.getId()] > i[n.getId()] ? 1 : -1 : l == null ? -1 : 1;
    });
    const o = this.gos.isColumnsSortingCoupledToGroup() && !!t.length;
    o && (e = [...new Set(e.map((r) => {
      var n;
      return ((n = this.showRowGroupColsService) == null ? void 0 : n.getShowRowGroupCol(r.getId())) ?? r;
    }))]);
    const s = /* @__PURE__ */ new Map();
    return e.forEach((r, n) => s.set(r, n)), o && t.forEach((r) => {
      const n = this.showRowGroupColsService.getShowRowGroupCol(r.getId());
      s.set(r, s.get(n));
    }), s;
  }
  getColumnsWithSortingOrdered() {
    return [...this.getIndexedSortMap().entries()].sort(([e, t], [i, o]) => t - o).map(([e]) => e);
  }
  getSortModel() {
    return this.getColumnsWithSortingOrdered().filter((e) => e.getSort()).map((e) => ({ sort: e.getSort(), colId: e.getId() }));
  }
  getSortOptions() {
    return this.getColumnsWithSortingOrdered().filter((e) => e.getSort()).map((e) => ({ sort: e.getSort(), column: e }));
  }
  canColumnDisplayMixedSort(e) {
    const t = this.gos.isColumnsSortingCoupledToGroup(), i = !!e.getColDef().showRowGroup;
    return t && i;
  }
  getDisplaySortForColumn(e) {
    const t = this.funcColsService.getSourceColumnsForGroupColumn(e);
    if (!this.canColumnDisplayMixedSort(e) || !(t != null && t.length))
      return e.getSort();
    const i = e.getColDef().field != null || e.getColDef().valueGetter ? [e, ...t] : t, o = i[0].getSort();
    return i.every((s) => s.getSort() == o) ? o : "mixed";
  }
  getDisplaySortIndexForColumn(e) {
    return this.getIndexedSortMap().get(e);
  }
}, tc = class extends f {
  constructor() {
    super(...arguments), this.beanName = "syncService", this.waitingForColumns = !1;
  }
  wireBeans(e) {
    this.ctrlsService = e.ctrlsService, this.columnModel = e.columnModel, this.rowModel = e.rowModel;
  }
  postConstruct() {
    this.addManagedPropertyListener("columnDefs", (e) => this.setColumnDefs(e));
  }
  start() {
    this.ctrlsService.whenReady(() => {
      const e = this.gos.get("columnDefs");
      e ? this.setColumnsAndData(e) : this.waitingForColumns = !0, this.gridReady();
    });
  }
  setColumnsAndData(e) {
    this.columnModel.setColumnDefs(e ?? [], "gridInitializing"), this.rowModel.start();
  }
  gridReady() {
    this.dispatchGridReadyEvent();
    const e = Q.__isRegistered("@ag-grid-enterprise/core", this.gridId);
    this.gos.get("debug") && se(`initialised successfully, enterprise = ${e}`);
  }
  dispatchGridReadyEvent() {
    this.eventService.dispatchEvent({ type: "gridReady" });
  }
  setColumnDefs(e) {
    const t = this.gos.get("columnDefs");
    if (t)
      return this.waitingForColumns ? (this.waitingForColumns = !1, void this.setColumnsAndData(t)) : void this.columnModel.setColumnDefs(t, st(e.source));
  }
}, ic = class extends f {
  constructor() {
    super(...arguments), this.beanName = "changeDetectionService";
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.rowRenderer = e.rowRenderer;
  }
  postConstruct() {
    this.rowModel.getType() === "clientSide" && (this.clientSideRowModel = this.rowModel), this.addManagedEventListeners({ cellValueChanged: this.onCellValueChanged.bind(this) });
  }
  onCellValueChanged(e) {
    e.source !== "paste" && this.doChangeDetection(e.node, e.column);
  }
  doChangeDetection(e, t) {
    if (this.gos.get("suppressChangeDetection"))
      return;
    const i = [e];
    if (this.clientSideRowModel && !e.isRowPinned()) {
      const o = this.gos.get("aggregateOnlyChangedColumns"), s = new li(o, this.clientSideRowModel.getRootNode());
      s.addParentNode(e.parent, [t]), this.clientSideRowModel.doAggregate(s), s.forEachChangedNodeDepthFirst((r) => {
        i.push(r);
      });
    }
    this.rowRenderer.refreshCells({ rowNodes: i });
  }
}, oc = class extends f {
  constructor() {
    super(...arguments), this.beanName = "expressionService", this.expressionToFunctionCache = {};
  }
  evaluate(e, t) {
    if (typeof e == "string")
      return this.evaluateExpression(e, t);
    L("value should be either a string or a function", e);
  }
  evaluateExpression(e, t) {
    try {
      return this.createExpressionFunction(e)(t.value, t.context, t.oldValue, t.newValue, t.value, t.node, t.data, t.colDef, t.rowIndex, t.api, t.getValue, t.column, t.columnGroup);
    } catch (i) {
      return se("Processing of the expression failed"), se("Expression = ", e), se("Params = ", t), se("Exception = ", i), null;
    }
  }
  createExpressionFunction(e) {
    if (this.expressionToFunctionCache[e])
      return this.expressionToFunctionCache[e];
    const t = this.createFunctionBody(e), i = new Function("x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, getValue, column, columnGroup", t);
    return this.expressionToFunctionCache[e] = i, i;
  }
  createFunctionBody(e) {
    return e.indexOf("return") >= 0 ? e : "return " + e + ";";
  }
}, sc = class extends f {
  constructor() {
    super(...arguments), this.beanName = "valueCache", this.cacheVersion = 0;
  }
  postConstruct() {
    this.active = this.gos.get("valueCache"), this.neverExpires = this.gos.get("valueCacheNeverExpires");
  }
  onDataChanged() {
    this.neverExpires || this.expire();
  }
  expire() {
    this.cacheVersion++;
  }
  setValue(e, t, i) {
    this.active && (e.__cacheVersion !== this.cacheVersion && (e.__cacheVersion = this.cacheVersion, e.__cacheData = {}), e.__cacheData[t] = i);
  }
  getValue(e, t) {
    if (this.active && e.__cacheVersion === this.cacheVersion)
      return e.__cacheData[t];
  }
}, rc = class extends f {
  constructor() {
    super(...arguments), this.beanName = "valueService", this.initialised = !1, this.isSsrm = !1;
  }
  wireBeans(e) {
    this.expressionService = e.expressionService, this.columnModel = e.columnModel, this.valueCache = e.valueCache, this.dataTypeService = e.dataTypeService;
  }
  postConstruct() {
    this.initialised || this.init();
  }
  init() {
    this.isSsrm = this.gos.isRowModelType("serverSide"), this.cellExpressions = this.gos.get("enableCellExpressions"), this.isTreeData = this.gos.get("treeData"), this.initialised = !0;
    const e = (i) => this.callColumnCellValueChangedHandler(i), t = this.gos.useAsyncEvents();
    this.eventService.addEventListener("cellValueChanged", e, t), this.addDestroyFunc(() => this.eventService.removeEventListener("cellValueChanged", e, t)), this.addManagedPropertyListener("treeData", (i) => this.isTreeData = i.currentValue);
  }
  getValue(e, t, i = !1, o = !1) {
    if (this.initialised || this.init(), !t)
      return;
    const s = e.getColDef(), r = s.field, n = e.getColId(), a = t.data;
    let l;
    const d = t.groupData && t.groupData[n] !== void 0, c = !o && t.aggData && t.aggData[n] !== void 0, h = this.isSsrm && o && !!e.getColDef().aggFunc, g = this.isSsrm && t.footer && t.field && (e.getColDef().showRowGroup === !0 || e.getColDef().showRowGroup === t.field);
    if (i && s.filterValueGetter ? l = this.executeFilterValueGetter(s.filterValueGetter, a, e, t) : this.isTreeData && c ? l = t.aggData[n] : this.isTreeData && s.valueGetter ? l = this.executeValueGetter(s.valueGetter, a, e, t) : this.isTreeData && r && a ? l = bt(a, r, e.isFieldContainsDots()) : d ? l = t.groupData[n] : c ? l = t.aggData[n] : s.valueGetter ? l = this.executeValueGetter(s.valueGetter, a, e, t) : g ? l = bt(a, t.field, e.isFieldContainsDots()) : r && a && !h && (l = bt(a, r, e.isFieldContainsDots())), this.cellExpressions && typeof l == "string" && l.indexOf("=") === 0) {
      const u = l.substring(1);
      l = this.executeValueGetter(u, a, e, t);
    }
    if (l == null) {
      const u = this.getOpenedGroup(t, e);
      if (u != null)
        return u;
    }
    return l;
  }
  parseValue(e, t, i, o) {
    const s = e.getColDef(), r = this.gos.addGridCommonParams({ node: t, data: t == null ? void 0 : t.data, oldValue: o, newValue: i, colDef: s, column: e }), n = s.valueParser;
    return S(n) ? typeof n == "function" ? n(r) : this.expressionService.evaluate(n, r) : i;
  }
  formatValue(e, t, i, o, s = !0) {
    let r, n = null;
    const a = e.getColDef();
    if (o ? r = o : s && (r = a.valueFormatter), r) {
      const l = this.gos.addGridCommonParams({ value: i, node: t, data: t ? t.data : null, colDef: a, column: e });
      n = typeof r == "function" ? r(l) : this.expressionService.evaluate(r, l);
    } else if (a.refData)
      return a.refData[i] || "";
    return n == null && Array.isArray(i) && (n = i.join(", ")), n;
  }
  getOpenedGroup(e, t) {
    if (!this.gos.get("showOpenedGroup") || !t.getColDef().showRowGroup)
      return;
    const i = t.getColDef().showRowGroup;
    let o = e.parent;
    for (; o != null; ) {
      if (o.rowGroupColumn && (i === !0 || i === o.rowGroupColumn.getColId()))
        return o.key;
      o = o.parent;
    }
  }
  setValue(e, t, i, o) {
    const s = this.columnModel.getColDefCol(t);
    if (!e || !s)
      return !1;
    A(e.data) && (e.data = {});
    const { field: r, valueSetter: n } = s.getColDef();
    if (A(r) && A(n))
      return b("you need either field or valueSetter set on colDef for editing to work"), !1;
    if (this.dataTypeService && !this.dataTypeService.checkType(s, i))
      return b("Data type of the new value does not match the cell data type of the column"), !1;
    const a = this.gos.addGridCommonParams({ node: e, data: e.data, oldValue: this.getValue(s, e), newValue: i, colDef: s.getColDef(), column: s });
    let l;
    if (a.newValue = i, l = S(n) ? typeof n == "function" ? n(a) : this.expressionService.evaluate(n, a) : this.setValueUsingField(e.data, r, i, s.isFieldContainsDots()), l === void 0 && (l = !0), !l)
      return !1;
    e.resetQuickFilterAggregateText(), this.valueCache.onDataChanged(), a.newValue = this.getValue(s, e);
    const d = { type: "cellValueChanged", event: null, rowIndex: e.rowIndex, rowPinned: e.rowPinned, column: a.column, api: a.api, colDef: a.colDef, context: a.context, data: e.data, node: e, oldValue: a.oldValue, newValue: a.newValue, value: a.newValue, source: o };
    return this.eventService.dispatchEvent(d), !0;
  }
  callColumnCellValueChangedHandler(e) {
    const t = e.colDef.onCellValueChanged;
    typeof t == "function" && this.getFrameworkOverrides().wrapOutgoing(() => {
      t({ node: e.node, data: e.data, oldValue: e.oldValue, newValue: e.newValue, colDef: e.colDef, column: e.column, api: e.api, context: e.context });
    });
  }
  setValueUsingField(e, t, i, o) {
    if (!t)
      return !1;
    let s = !1;
    if (o) {
      const r = t.split(".");
      let n = e;
      for (; r.length > 0 && n; ) {
        const a = r.shift();
        r.length === 0 ? (s = n[a] === i, s || (n[a] = i)) : n = n[a];
      }
    } else
      s = e[t] === i, s || (e[t] = i);
    return !s;
  }
  executeFilterValueGetter(e, t, i, o) {
    const s = this.gos.addGridCommonParams({ data: t, node: o, column: i, colDef: i.getColDef(), getValue: this.getValueCallback.bind(this, o) });
    return typeof e == "function" ? e(s) : this.expressionService.evaluate(e, s);
  }
  executeValueGetter(e, t, i, o) {
    const s = i.getColId(), r = this.valueCache.getValue(o, s);
    if (r !== void 0)
      return r;
    const n = this.gos.addGridCommonParams({ data: t, node: o, column: i, colDef: i.getColDef(), getValue: this.getValueCallback.bind(this, o) });
    let a;
    return a = typeof e == "function" ? e(n) : this.expressionService.evaluate(e, n), this.valueCache.setValue(o, s, a), a;
  }
  getValueCallback(e, t) {
    const i = this.columnModel.getColDefCol(t);
    return i ? this.getValue(i, e) : null;
  }
  getKeyForNode(e, t) {
    const i = this.getValue(e, t), o = e.getColDef().keyCreator;
    let s = i;
    return o && (s = o(this.gos.addGridCommonParams({ value: i, colDef: e.getColDef(), column: e, node: t, data: t.data }))), typeof s == "string" || s == null || (s = String(s), s === "[object Object]" && b("a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (se AG Grid docs) or b) to toString() on the object to return a key")), s;
  }
}, ji = class {
};
ji.gridOptions = void 0;
var nc = 1, ac = class {
  create(e, t, i, o, s) {
    let r = {};
    ji.gridOptions ? (oe(r, ji.gridOptions, !0, !0), r = { ...r, ...t }) : r = t;
    const n = function(g) {
      const u = {};
      return Object.entries(g).forEach(([p, C]) => {
        const y = Lr(p, C);
        u[p] = y;
      }), u;
    }(r), a = n.gridId ?? String(nc++), l = this.getRegisteredModules(s, a), d = this.createBeansList(n.rowModelType, l, a), c = this.createProvidedBeans(e, n, s);
    if (!d)
      return void L("Failed to create grid.");
    const h = new ea({ providedBeanInstances: c, beanClasses: d, gridId: a, beanInitComparator: gd, beanDestroyComparator: ud, derivedBeans: [sd] });
    return this.registerModuleUserComponents(h, l), this.registerControllers(h, l), this.registerModuleApiFunctions(h, l), i(h), h.getBean("syncService").start(), o && o(h), h.getBean("gridApi");
  }
  registerControllers(e, t) {
    const i = e.getBean("ctrlsFactory");
    t.forEach((o) => {
      o.controllers && o.controllers.forEach((s) => i.register(s));
    });
  }
  getRegisteredModules(e, t) {
    const i = e ? e.modules : null, o = Q.__getRegisteredModules(t), s = [], r = {}, n = (a, l, d) => {
      var c;
      r[(c = l).moduleName] || (r[c.moduleName] = !0, s.push(c), Q.__register(c, a, d)), l.dependantModules && l.dependantModules.forEach((h) => n(a, h, d));
    };
    return n(!!(i != null && i.length) || !Q.__isPackageBased(), Ir, void 0), i && i.forEach((a) => n(!0, a, t)), o && o.forEach((a) => n(!Q.__isPackageBased(), a, void 0)), s;
  }
  registerModuleUserComponents(e, t) {
    const i = this.extractModuleEntity(t, (s) => s.userComponents ? s.userComponents : []), o = e.getBean("userComponentRegistry");
    i.forEach((s) => {
      o.registerDefaultComponent(s.name, s.classImp);
    });
  }
  registerModuleApiFunctions(e, t) {
    const i = e.getBean("apiFunctionService");
    t.forEach((o) => {
      const s = o.apiFunctions ?? {};
      Object.keys(s).forEach((r) => {
        i == null || i.addFunction(r, s[r]);
      });
    });
  }
  createProvidedBeans(e, t, i) {
    let o = i ? i.frameworkOverrides : null;
    A(o) && (o = new _l());
    const s = { gridOptions: t, eGridDiv: e, globalEventListener: i ? i.globalEventListener : null, globalSyncEventListener: i ? i.globalSyncEventListener : null, frameworkOverrides: o };
    return i && i.providedBeanInstances && Object.assign(s, i.providedBeanInstances), s;
  }
  createBeansList(e = "clientSide", t, i) {
    const o = t.filter((l) => !l.rowModel || l.rowModel === e), s = { clientSide: "@ag-grid-community/client-side-row-model", infinite: "@ag-grid-community/infinite-row-model", serverSide: "@ag-grid-enterprise/server-side-row-model", viewport: "@ag-grid-enterprise/viewport-row-model" };
    if (!s[e])
      return void L("Could not find row model for rowModelType = ", e);
    if (!Q.__assertRegistered(s[e], `rowModelType = '${e}'`, i))
      return;
    const r = [Cd, vd, Vd, zd, id, On, cd, hd, Dl, Ks, Xd, xl, Wd, Ul, sa, vn, yd, Hd, Xl, Gr, nn, Ea, Kd, jd, Vl, oc, rn, Rl, sc, rc, Bl, Fl, ta, Sd, Sl, wd, ed, Yl, yl, ec, qd, Yd, _d, ic, Ml, rd, Jd, Zd, md, Rd, fd, pd, tc, $d, El, Ud, Qd, Pl, dn, nd, cn, an, ad, ld, mn, ln, un, dd, pn], n = this.extractModuleEntity(o, (l) => l.beans ? l.beans : []);
    r.push(...n);
    const a = [];
    return r.forEach((l) => {
      a.indexOf(l) < 0 && a.push(l);
    }), a;
  }
  extractModuleEntity(e, t) {
    return [].concat(...e.map(t));
  }
}, zr = class extends f {
  constructor() {
    super(...arguments), this.beanName = "rowModelHelperService";
  }
  wireBeans(e) {
    this.rowModel = e.rowModel;
  }
  postConstruct() {
    const e = this.rowModel;
    switch (e.getType()) {
      case "clientSide":
        this.clientSideRowModel = e;
        break;
      case "infinite":
        this.infiniteRowModel = e;
        break;
      case "serverSide":
        this.serverSideRowModel = e;
    }
  }
  getClientSideRowModel() {
    return this.clientSideRowModel;
  }
  getInfiniteRowModel() {
    return this.infiniteRowModel;
  }
  getServerSideRowModel() {
    return this.serverSideRowModel;
  }
}, lc = { version: M, moduleName: "@ag-grid-community/csrm-ssrm-shared-api", apiFunctions: { expandAll: function(e) {
  e.expansionService.expandAll(!0);
}, collapseAll: function(e) {
  e.expansionService.expandAll(!1);
}, onRowHeightChanged: function(e) {
  var o, s;
  const t = (o = e.rowModelHelperService) == null ? void 0 : o.getClientSideRowModel(), i = (s = e.rowModelHelperService) == null ? void 0 : s.getServerSideRowModel();
  t ? t.onRowHeightChanged() : i && i.onRowHeightChanged();
} } }, dc = { version: M, moduleName: "@ag-grid-community/ssrm-infinite-shared-api", apiFunctions: { setRowCount: function(e, t, i) {
  var r, n;
  const o = (r = e.rowModelHelperService) == null ? void 0 : r.getServerSideRowModel();
  if (o)
    return e.funcColsService.isRowGroupEmpty() ? void o.setRowCount(t, i) : void L("setRowCount cannot be used while using row grouping.");
  const s = (n = e.rowModelHelperService) == null ? void 0 : n.getInfiniteRowModel();
  s && s.setRowCount(t, i);
}, getCacheBlockState: function(e) {
  var t;
  return ((t = e.rowNodeBlockLoader) == null ? void 0 : t.getBlockState()) ?? {};
} } }, _e = typeof global > "u" ? {} : global;
_e.HTMLElement = typeof HTMLElement > "u" ? {} : HTMLElement, _e.HTMLButtonElement = typeof HTMLButtonElement > "u" ? {} : HTMLButtonElement, _e.HTMLSelectElement = typeof HTMLSelectElement > "u" ? {} : HTMLSelectElement, _e.HTMLInputElement = typeof HTMLInputElement > "u" ? {} : HTMLInputElement, _e.Node = typeof Node > "u" ? {} : Node, _e.MouseEvent = typeof MouseEvent > "u" ? {} : MouseEvent;
var cc = class {
  constructor(e, t, i, o, s, r) {
    this.nextId = 0, this.rowCountReady = !1, this.allNodesMap = {}, this.rootNode = e, this.gos = t, this.eventService = i, this.funcColsService = o, this.beans = r, this.selectionService = s, this.rootNode.group = !0, this.rootNode.level = -1, this.rootNode.id = "ROOT_NODE_ID", this.rootNode.allLeafChildren = [], this.rootNode.childrenAfterGroup = [], this.rootNode.childrenAfterSort = [], this.rootNode.childrenAfterAggFilter = [], this.rootNode.childrenAfterFilter = [];
  }
  getCopyOfNodesMap() {
    return gs(this.allNodesMap);
  }
  getRowNode(e) {
    return this.allNodesMap[e];
  }
  setRowData(e) {
    if (typeof e == "string")
      return void b("rowData must be an array.");
    this.rowCountReady = !0, this.dispatchRowDataUpdateStartedEvent(e);
    const t = this.rootNode, i = this.rootNode.sibling;
    t.childrenAfterFilter = null, t.childrenAfterGroup = null, t.childrenAfterAggFilter = null, t.childrenAfterSort = null, t.childrenMapped = null, t.updateHasChildren(), this.nextId = 0, this.allNodesMap = {}, e ? t.allLeafChildren = e.map((o) => this.createNode(o, this.rootNode, 0)) : (t.allLeafChildren = [], t.childrenAfterGroup = []), i && (i.childrenAfterFilter = t.childrenAfterFilter, i.childrenAfterGroup = t.childrenAfterGroup, i.childrenAfterAggFilter = t.childrenAfterAggFilter, i.childrenAfterSort = t.childrenAfterSort, i.childrenMapped = t.childrenMapped, i.allLeafChildren = t.allLeafChildren);
  }
  updateRowData(e, t) {
    this.rowCountReady = !0, this.dispatchRowDataUpdateStartedEvent(e.add);
    const i = { remove: [], update: [], add: [] }, o = [];
    return this.executeRemove(e, i, o), this.executeUpdate(e, i, o), this.executeAdd(e, i), this.updateSelection(o, "rowDataChanged"), t && function(s, r) {
      if (!s)
        return !1;
      const n = (c, h) => {
        const g = r[c.id], u = r[h.id], p = g !== void 0, C = u !== void 0;
        return p && C ? g - u : p || C ? p ? 1 : -1 : c.__objectId - h.__objectId;
      };
      let a, l, d = !1;
      for (let c = 0; c < s.length - 1; c++)
        if (a = s[c], l = s[c + 1], n(a, l) > 0) {
          d = !0;
          break;
        }
      d && s.sort(n);
    }(this.rootNode.allLeafChildren, t), i;
  }
  isRowCountReady() {
    return this.rowCountReady;
  }
  dispatchRowDataUpdateStartedEvent(e) {
    const t = { type: "rowDataUpdateStarted", firstRowData: e != null && e.length ? e[0] : null };
    this.eventService.dispatchEvent(t);
  }
  updateSelection(e, t) {
    const i = e.length > 0;
    if (i && this.selectionService.setNodesSelected({ newValue: !1, nodes: e, suppressFinishActions: !0, source: t }), this.selectionService.updateGroupsFromChildrenSelections(t), i) {
      const o = { type: "selectionChanged", source: t };
      this.eventService.dispatchEvent(o);
    }
  }
  executeAdd(e, t) {
    var n;
    const { add: i, addIndex: o } = e;
    if (W(i))
      return;
    const s = i.map((a) => this.createNode(a, this.rootNode, 0)), r = this.rootNode.allLeafChildren;
    if (typeof o == "number" && o >= 0) {
      const a = r.length;
      let l = o;
      if (this.gos.get("treeData") && o > 0 && a > 0) {
        for (let h = 0; h < a; h++)
          if (((n = r[h]) == null ? void 0 : n.rowIndex) == o - 1) {
            l = h + 1;
            break;
          }
      }
      const d = r.slice(0, l), c = r.slice(l, r.length);
      this.rootNode.allLeafChildren = [...d, ...s, ...c];
    } else
      this.rootNode.allLeafChildren = [...r, ...s];
    this.rootNode.sibling && (this.rootNode.sibling.allLeafChildren = r), t.add = s;
  }
  executeRemove(e, t, i) {
    var r;
    const { remove: o } = e;
    if (W(o))
      return;
    const s = {};
    o.forEach((n) => {
      const a = this.lookupRowNode(n);
      a && (a.isSelected() && i.push(a), a.clearRowTopAndRowIndex(), s[a.id] = !0, delete this.allNodesMap[a.id], t.remove.push(a));
    }), this.rootNode.allLeafChildren = ((r = this.rootNode.allLeafChildren) == null ? void 0 : r.filter((n) => !s[n.id])) ?? null, this.rootNode.sibling && (this.rootNode.sibling.allLeafChildren = this.rootNode.allLeafChildren);
  }
  executeUpdate(e, t, i) {
    const { update: o } = e;
    W(o) || o.forEach((s) => {
      const r = this.lookupRowNode(s);
      r && (r.updateData(s), !r.selectable && r.isSelected() && i.push(r), this.setMasterForRow(r, s, 0, !1), t.update.push(r));
    });
  }
  lookupRowNode(e) {
    var o;
    const t = this.gos.getRowIdCallback();
    let i;
    if (t) {
      const s = t({ data: e, level: 0 });
      if (i = this.allNodesMap[s], !i)
        return L(`could not find row id=${s}, data item was not found for this id`), null;
    } else if (i = (o = this.rootNode.allLeafChildren) == null ? void 0 : o.find((s) => s.data === e), !i)
      return L("could not find data item as object was not found", e), L("Consider using getRowId to help the Grid find matching row data"), null;
    return i || null;
  }
  createNode(e, t, i) {
    const o = new xe(this.beans);
    return o.group = !1, this.setMasterForRow(o, e, i, !0), t && (o.parent = t), o.level = i, o.setDataAndId(e, this.nextId.toString()), this.allNodesMap[o.id] && b(`duplicate node id '${o.id}' detected from getRowId callback, this could cause issues in your grid.`), this.allNodesMap[o.id] = o, this.nextId++, o;
  }
  setMasterForRow(e, t, i, o) {
    if (this.gos.get("treeData"))
      e.setMaster(!1), o && (e.expanded = !1);
    else {
      if (this.gos.get("masterDetail")) {
        const s = this.gos.get("isRowMaster");
        s ? e.setMaster(s(t)) : e.setMaster(!0);
      } else
        e.setMaster(!1);
      if (o) {
        const s = this.funcColsService.getRowGroupColumns(), r = i + (s ? s.length : 0);
        e.expanded = !!e.master && this.isExpanded(r);
      }
    }
  }
  isExpanded(e) {
    const t = this.gos.get("groupDefaultExpanded");
    return t === -1 || e < t;
  }
}, Ki = "32.0.2", rs = { version: Ki, moduleName: "@ag-grid-community/client-side-row-model-core", rowModel: "clientSide", beans: [class extends f {
  constructor() {
    super(...arguments), this.beanName = "rowModel", this.onRowHeightChanged_debounced = q(this.onRowHeightChanged.bind(this), 100), this.rowsToDisplay = [], this.hasStarted = !1, this.shouldSkipSettingDataOnStart = !1, this.isRefreshingModel = !1, this.rowCountReady = !1;
  }
  wireBeans(e) {
    this.beans = e, this.columnModel = e.columnModel, this.funcColsService = e.funcColsService, this.selectionService = e.selectionService, this.valueCache = e.valueCache, this.environment = e.environment, this.filterStage = e.filterStage, this.sortStage = e.sortStage, this.flattenStage = e.flattenStage, this.groupStage = e.groupStage, this.aggregationStage = e.aggregationStage, this.pivotStage = e.pivotStage, this.filterAggregatesStage = e.filterAggregatesStage;
  }
  postConstruct() {
    const e = this.refreshModel.bind(this, { step: "group" }), t = !this.gos.get("suppressAnimationFrame"), i = this.refreshModel.bind(this, { step: "group", afterColumnsChanged: !0, keepRenderedRows: !0, animate: t });
    this.addManagedEventListeners({ newColumnsLoaded: i, columnRowGroupChanged: e, columnValueChanged: this.onValueChanged.bind(this), columnPivotChanged: this.refreshModel.bind(this, { step: "pivot" }), filterChanged: this.onFilterChanged.bind(this), sortChanged: this.onSortChanged.bind(this), columnPivotModeChanged: e, gridStylesChanged: this.onGridStylesChanges.bind(this), gridReady: this.onGridReady.bind(this) }), this.addPropertyListeners(), this.rootNode = new xe(this.beans), this.nodeManager = new cc(this.rootNode, this.gos, this.eventService, this.funcColsService, this.selectionService, this.beans);
  }
  addPropertyListeners() {
    const e = /* @__PURE__ */ new Set(["treeData", "masterDetail"]), t = /* @__PURE__ */ new Set(["groupDefaultExpanded", "groupAllowUnbalanced", "initialGroupOrderComparator", "groupHideOpenParents", "groupDisplayType"]), i = /* @__PURE__ */ new Set(["excludeChildrenWhenTreeDataFiltering"]), o = /* @__PURE__ */ new Set(["removePivotHeaderRowWhenSingleValueColumn", "pivotRowTotals", "pivotColumnGroupTotals", "suppressExpandablePivotGroups"]), s = /* @__PURE__ */ new Set(["getGroupRowAgg", "alwaysAggregateAtRootLevel", "groupIncludeTotalFooter", "suppressAggFilteredOnly", "grandTotalRow"]), r = /* @__PURE__ */ new Set(["postSortRows", "groupDisplayType", "accentedSort"]), n = /* @__PURE__ */ new Set([]), a = /* @__PURE__ */ new Set(["groupRemoveSingleChildren", "groupRemoveLowestSingleChildren", "groupIncludeFooter", "groupTotalRow"]), l = [...e, ...t, ...i, ...o, ...o, ...s, ...r, ...n, ...a];
    this.addManagedPropertyListeners(l, (d) => {
      var g;
      const c = (g = d.changeSet) == null ? void 0 : g.properties;
      if (!c)
        return;
      const h = (u) => c.some((p) => u.has(p));
      h(e) ? this.setRowData(this.rootNode.allLeafChildren.map((u) => u.data)) : h(t) ? this.refreshModel({ step: "group" }) : h(i) ? this.refreshModel({ step: "filter" }) : h(o) ? this.refreshModel({ step: "pivot" }) : h(s) ? this.refreshModel({ step: "aggregate" }) : h(r) ? this.refreshModel({ step: "sort" }) : h(n) ? this.refreshModel({ step: "filter_aggregates" }) : h(a) && this.refreshModel({ step: "map" });
    }), this.addManagedPropertyListener("rowHeight", () => this.resetRowHeights());
  }
  start() {
    this.hasStarted = !0, this.shouldSkipSettingDataOnStart ? this.dispatchUpdateEventsAndRefresh() : this.setInitialData();
  }
  setInitialData() {
    const e = this.gos.get("rowData");
    e && (this.shouldSkipSettingDataOnStart = !0, this.setRowData(e));
  }
  ensureRowHeightsValid(e, t, i, o) {
    let s, r = !1;
    do {
      s = !1;
      const n = this.getRowIndexAtPixel(e), a = this.getRowIndexAtPixel(t), l = Math.max(n, i), d = Math.min(a, o);
      for (let c = l; c <= d; c++) {
        const h = this.getRow(c);
        if (h.rowHeightEstimated) {
          const g = this.gos.getRowHeightForNode(h);
          h.setRowHeight(g.height), s = !0, r = !0;
        }
      }
      s && this.setRowTopAndRowIndex();
    } while (s);
    return r;
  }
  setRowTopAndRowIndex() {
    const e = this.environment.getDefaultRowHeight();
    let t = 0;
    const i = /* @__PURE__ */ new Set(), o = this.gos.isDomLayout("normal");
    for (let s = 0; s < this.rowsToDisplay.length; s++) {
      const r = this.rowsToDisplay[s];
      if (r.id != null && i.add(r.id), r.rowHeight == null) {
        const n = this.gos.getRowHeightForNode(r, o, e);
        r.setRowHeight(n.height, n.estimated);
      }
      r.setRowTop(t), r.setRowIndex(s), t += r.rowHeight;
    }
    return i;
  }
  clearRowTopAndRowIndex(e, t) {
    const i = e.isActive(), o = (r) => {
      r && r.id != null && !t.has(r.id) && r.clearRowTopAndRowIndex();
    }, s = (r) => {
      if (o(r), o(r.detailNode), o(r.sibling), r.hasChildren() && r.childrenAfterGroup) {
        const n = r.level == -1;
        i && !n && !r.expanded || r.childrenAfterGroup.forEach(s);
      }
    };
    s(this.rootNode);
  }
  ensureRowsAtPixel(e, t, i = 0) {
    const o = this.getRowIndexAtPixel(t), s = this.getRow(o), r = !this.gos.get("suppressAnimationFrame");
    return s !== e[0] && (e.forEach((n) => {
      Y(this.rootNode.allLeafChildren, n);
    }), e.forEach((n, a) => {
      Jt(this.rootNode.allLeafChildren, n, Math.max(o + i, 0) + a);
    }), this.refreshModel({ step: "group", keepRenderedRows: !0, keepEditingRows: !0, animate: r }), !0);
  }
  highlightRowAtPixel(e, t) {
    const i = t != null ? this.getRowIndexAtPixel(t) : null, o = i != null ? this.getRow(i) : null;
    if (!o || !e || o === e || t == null)
      return void (this.lastHighlightedRow && (this.lastHighlightedRow.setHighlighted(null), this.lastHighlightedRow = null));
    const s = this.getHighlightPosition(t, o);
    this.lastHighlightedRow && this.lastHighlightedRow !== o && (this.lastHighlightedRow.setHighlighted(null), this.lastHighlightedRow = null), o.setHighlighted(s), this.lastHighlightedRow = o;
  }
  getHighlightPosition(e, t) {
    if (!t) {
      const s = this.getRowIndexAtPixel(e);
      if (!(t = this.getRow(s || 0)))
        return 1;
    }
    const { rowTop: i, rowHeight: o } = t;
    return e - i < o / 2 ? 0 : 1;
  }
  getLastHighlightedRowNode() {
    return this.lastHighlightedRow;
  }
  isLastRowIndexKnown() {
    return !0;
  }
  getRowCount() {
    return this.rowsToDisplay ? this.rowsToDisplay.length : 0;
  }
  getTopLevelRowCount() {
    if (this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode)
      return 1;
    const e = this.rootNode.sibling ? 1 : 0, t = this.rootNode.childrenAfterAggFilter;
    return (t ? t.length : 0) + e;
  }
  getTopLevelRowDisplayedIndex(e) {
    if (this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode)
      return e;
    let t = e;
    if (this.rowsToDisplay[0].footer) {
      if (e === 0)
        return 0;
      t -= 1;
    }
    let i = this.rootNode.childrenAfterSort[t];
    if (this.gos.get("groupHideOpenParents"))
      for (; i.expanded && i.childrenAfterSort && i.childrenAfterSort.length > 0; )
        i = i.childrenAfterSort[0];
    return i.rowIndex;
  }
  getRowBounds(e) {
    if (A(this.rowsToDisplay))
      return null;
    const t = this.rowsToDisplay[e];
    return t ? { rowTop: t.rowTop, rowHeight: t.rowHeight } : null;
  }
  onRowGroupOpened() {
    const e = this.gos.isAnimateRows();
    this.refreshModel({ step: "map", keepRenderedRows: !0, animate: e });
  }
  onFilterChanged(e) {
    if (e.afterDataChange)
      return;
    const t = this.gos.isAnimateRows(), i = e.columns.length === 0 || e.columns.some((o) => o.isPrimary()) ? "filter" : "filter_aggregates";
    this.refreshModel({ step: i, keepRenderedRows: !0, animate: t });
  }
  onSortChanged() {
    const e = this.gos.isAnimateRows();
    this.refreshModel({ step: "sort", keepRenderedRows: !0, animate: e, keepEditingRows: !0 });
  }
  getType() {
    return "clientSide";
  }
  onValueChanged() {
    this.columnModel.isPivotActive() ? this.refreshModel({ step: "pivot" }) : this.refreshModel({ step: "aggregate" });
  }
  createChangePath(e) {
    const t = W(e), i = new li(!1, this.rootNode);
    return (t || this.gos.get("treeData")) && i.setInactive(), i;
  }
  isSuppressModelUpdateAfterUpdateTransaction(e) {
    if (!this.gos.get("suppressModelUpdateAfterUpdateTransaction") || e.rowNodeTransactions == null)
      return !1;
    const t = e.rowNodeTransactions.filter((i) => i.add != null && i.add.length > 0 || i.remove != null && i.remove.length > 0);
    return t == null || t.length == 0;
  }
  buildRefreshModelParams(e) {
    let t = "group";
    const i = { everything: "group", group: "group", filter: "filter", map: "map", aggregate: "aggregate", sort: "sort", pivot: "pivot" };
    if (S(e) && (t = i[e]), !A(t))
      return { step: t, keepRenderedRows: !0, keepEditingRows: !0, animate: !this.gos.get("suppressAnimationFrame") };
    L(`invalid step ${e}, available steps are ${Object.keys(i).join(", ")}`);
  }
  refreshModel(e) {
    if (!this.hasStarted || this.isRefreshingModel || this.columnModel.isChangeEventsDispatching())
      return;
    const t = typeof e == "object" && "step" in e ? e : this.buildRefreshModelParams(e);
    if (!t || this.isSuppressModelUpdateAfterUpdateTransaction(t))
      return;
    const i = this.createChangePath(t.rowNodeTransactions);
    switch (this.isRefreshingModel = !0, t.step) {
      case "group":
        this.doRowGrouping(t.rowNodeTransactions, t.rowNodeOrder, i, !!t.afterColumnsChanged);
      case "filter":
        this.doFilter(i);
      case "pivot":
        this.doPivot(i);
      case "aggregate":
        this.doAggregate(i);
      case "filter_aggregates":
        this.doFilterAggregates(i);
      case "sort":
        this.doSort(t.rowNodeTransactions, i);
      case "map":
        this.doRowsToDisplay();
    }
    const o = this.setRowTopAndRowIndex();
    this.clearRowTopAndRowIndex(i, o), this.isRefreshingModel = !1;
    const s = { type: "modelUpdated", animate: t.animate, keepRenderedRows: t.keepRenderedRows, newData: t.newData, newPage: !1, keepUndoRedoStack: t.keepUndoRedoStack };
    this.eventService.dispatchEvent(s);
  }
  isEmpty() {
    const e = A(this.rootNode.allLeafChildren) || this.rootNode.allLeafChildren.length === 0;
    return A(this.rootNode) || e || !this.columnModel.isReady();
  }
  isRowsToRender() {
    return S(this.rowsToDisplay) && this.rowsToDisplay.length > 0;
  }
  getNodesInRangeForSelection(e, t) {
    let i = !1, o = !1;
    const s = [], r = this.gos.get("groupSelectsChildren");
    return this.forEachNodeAfterFilterAndSort((n) => {
      if (!o)
        if (i && (n === t || n === e) && (o = !0, n.group && r))
          s.push(...n.allLeafChildren);
        else {
          if (!i) {
            if (n !== t && n !== e)
              return;
            i = !0;
          }
          (!n.group || !r) && s.push(n);
        }
    }), s;
  }
  setDatasource(e) {
    L("should never call setDatasource on clientSideRowController");
  }
  getTopLevelNodes() {
    return this.rootNode ? this.rootNode.childrenAfterGroup : null;
  }
  getRootNode() {
    return this.rootNode;
  }
  getRow(e) {
    return this.rowsToDisplay[e];
  }
  isRowPresent(e) {
    return this.rowsToDisplay.indexOf(e) >= 0;
  }
  getRowIndexAtPixel(e) {
    if (this.isEmpty() || this.rowsToDisplay.length === 0)
      return -1;
    let t = 0, i = this.rowsToDisplay.length - 1;
    if (e <= 0)
      return 0;
    if (T(this.rowsToDisplay).rowTop <= e)
      return this.rowsToDisplay.length - 1;
    let o = -1, s = -1;
    for (; ; ) {
      const r = Math.floor((t + i) / 2), n = this.rowsToDisplay[r];
      if (this.isRowInPixel(n, e) || (n.rowTop < e ? t = r + 1 : n.rowTop > e && (i = r - 1), o === t && s === i))
        return r;
      o = t, s = i;
    }
  }
  isRowInPixel(e, t) {
    const i = e.rowTop, o = e.rowTop + e.rowHeight;
    return i <= t && o > t;
  }
  forEachLeafNode(e) {
    this.rootNode.allLeafChildren && this.rootNode.allLeafChildren.forEach((t, i) => e(t, i));
  }
  forEachNode(e, t = !1) {
    this.recursivelyWalkNodesAndCallback({ nodes: [...this.rootNode.childrenAfterGroup || []], callback: e, recursionType: 0, index: 0, includeFooterNodes: t });
  }
  forEachNodeAfterFilter(e, t = !1) {
    this.recursivelyWalkNodesAndCallback({ nodes: [...this.rootNode.childrenAfterAggFilter || []], callback: e, recursionType: 1, index: 0, includeFooterNodes: t });
  }
  forEachNodeAfterFilterAndSort(e, t = !1) {
    this.recursivelyWalkNodesAndCallback({ nodes: [...this.rootNode.childrenAfterSort || []], callback: e, recursionType: 2, index: 0, includeFooterNodes: t });
  }
  forEachPivotNode(e, t = !1) {
    this.recursivelyWalkNodesAndCallback({ nodes: [this.rootNode], callback: e, recursionType: 3, index: 0, includeFooterNodes: t });
  }
  recursivelyWalkNodesAndCallback(e) {
    const { nodes: t, callback: i, recursionType: o, includeFooterNodes: s } = e;
    let { index: r } = e;
    const n = (a) => {
      var g;
      const l = (g = t[0]) == null ? void 0 : g.parent;
      if (!l)
        return;
      const d = s && this.gos.getGrandTotalRow(), c = this.gos.getGroupTotalRowCallback(), h = s && c({ node: l });
      l === this.rootNode ? d === a && (l.createFooter(), i(l.sibling, r++)) : h === a && (l.createFooter(), i(l.sibling, r++));
    };
    n("top");
    for (let a = 0; a < t.length; a++) {
      const l = t[a];
      if (i(l, r++), l.hasChildren() && !l.footer) {
        let d = null;
        switch (o) {
          case 0:
            d = l.childrenAfterGroup;
            break;
          case 1:
            d = l.childrenAfterAggFilter;
            break;
          case 2:
            d = l.childrenAfterSort;
            break;
          case 3:
            d = l.leafGroup ? null : l.childrenAfterSort;
        }
        d && (r = this.recursivelyWalkNodesAndCallback({ nodes: [...d], callback: i, recursionType: o, index: r, includeFooterNodes: s }));
      }
    }
    return n("bottom"), r;
  }
  doAggregate(e) {
    var t;
    (t = this.aggregationStage) == null || t.execute({ rowNode: this.rootNode, changedPath: e });
  }
  doFilterAggregates(e) {
    this.filterAggregatesStage ? this.filterAggregatesStage.execute({ rowNode: this.rootNode, changedPath: e }) : this.rootNode.childrenAfterAggFilter = this.rootNode.childrenAfterFilter;
  }
  expandOrCollapseAll(e) {
    const t = this.gos.get("treeData"), i = this.columnModel.isPivotActive(), o = (r) => {
      r && r.forEach((n) => {
        const a = () => {
          n.expanded = e, o(n.childrenAfterGroup);
        };
        t ? S(n.childrenAfterGroup) && a() : i ? !n.leafGroup && a() : n.group && a();
      });
    };
    this.rootNode && o(this.rootNode.childrenAfterGroup), this.refreshModel({ step: "map" });
    const s = { type: "expandOrCollapseAll", source: e ? "expandAll" : "collapseAll" };
    this.eventService.dispatchEvent(s);
  }
  doSort(e, t) {
    this.sortStage.execute({ rowNode: this.rootNode, rowNodeTransactions: e, changedPath: t });
  }
  doRowGrouping(e, t, i, o) {
    if (this.groupStage) {
      if (e ? this.groupStage.execute({ rowNode: this.rootNode, rowNodeTransactions: e, rowNodeOrder: t, changedPath: i }) : this.groupStage.execute({ rowNode: this.rootNode, changedPath: i, afterColumnsChanged: o }), this.gos.get("groupSelectsChildren") && this.selectionService.updateGroupsFromChildrenSelections("rowGroupChanged", i)) {
        const s = { type: "selectionChanged", source: "rowGroupChanged" };
        this.eventService.dispatchEvent(s);
      }
    } else
      this.rootNode.childrenAfterGroup = this.rootNode.allLeafChildren, this.rootNode.sibling && (this.rootNode.sibling.childrenAfterGroup = this.rootNode.childrenAfterGroup), this.rootNode.updateHasChildren();
    this.nodeManager.isRowCountReady() && (this.rowCountReady = !0, this.eventService.dispatchEventOnce({ type: "rowCountReady" }));
  }
  doFilter(e) {
    this.filterStage.execute({ rowNode: this.rootNode, changedPath: e });
  }
  doPivot(e) {
    var t;
    (t = this.pivotStage) == null || t.execute({ rowNode: this.rootNode, changedPath: e });
  }
  getCopyOfNodesMap() {
    return this.nodeManager.getCopyOfNodesMap();
  }
  getRowNode(e) {
    if (typeof e == "string" && e.indexOf(xe.ID_PREFIX_ROW_GROUP) == 0) {
      let t;
      return this.forEachNode((i) => {
        i.id === e && (t = i);
      }), t;
    }
    return this.nodeManager.getRowNode(e);
  }
  setRowData(e) {
    this.selectionService.reset("rowDataChanged"), this.nodeManager.setRowData(e), this.hasStarted && this.dispatchUpdateEventsAndRefresh();
  }
  dispatchUpdateEventsAndRefresh() {
    this.eventService.dispatchEvent({ type: "rowDataUpdated" }), this.refreshModel({ step: "group", newData: !0 });
  }
  batchUpdateRowData(e, t) {
    if (this.applyAsyncTransactionsTimeout == null) {
      this.rowDataTransactionBatch = [];
      const i = this.gos.getAsyncTransactionWaitMillis();
      this.applyAsyncTransactionsTimeout = window.setTimeout(() => {
        this.executeBatchUpdateRowData();
      }, i);
    }
    this.rowDataTransactionBatch.push({ rowDataTransaction: e, callback: t });
  }
  flushAsyncTransactions() {
    this.applyAsyncTransactionsTimeout != null && (clearTimeout(this.applyAsyncTransactionsTimeout), this.executeBatchUpdateRowData());
  }
  executeBatchUpdateRowData() {
    this.valueCache.onDataChanged();
    const e = [], t = [];
    let i = !1;
    if (this.rowDataTransactionBatch && this.rowDataTransactionBatch.forEach((o) => {
      const s = this.nodeManager.updateRowData(o.rowDataTransaction, void 0);
      t.push(s), o.callback && e.push(o.callback.bind(null, s)), typeof o.rowDataTransaction.addIndex == "number" && (i = !0);
    }), this.commonUpdateRowData(t, void 0, i), e.length > 0 && window.setTimeout(() => {
      e.forEach((o) => o());
    }, 0), t.length > 0) {
      const o = { type: "asyncTransactionsFlushed", results: t };
      this.eventService.dispatchEvent(o);
    }
    this.rowDataTransactionBatch = null, this.applyAsyncTransactionsTimeout = void 0;
  }
  updateRowData(e, t) {
    this.valueCache.onDataChanged();
    const i = this.nodeManager.updateRowData(e, t), o = typeof e.addIndex == "number";
    return this.commonUpdateRowData([i], t, o), i;
  }
  createRowNodeOrder() {
    if (this.gos.get("suppressMaintainUnsortedOrder"))
      return;
    const e = {};
    if (this.rootNode && this.rootNode.allLeafChildren)
      for (let t = 0; t < this.rootNode.allLeafChildren.length; t++)
        e[this.rootNode.allLeafChildren[t].id] = t;
    return e;
  }
  commonUpdateRowData(e, t, i) {
    if (!this.hasStarted)
      return;
    const o = !this.gos.get("suppressAnimationFrame");
    i && (t = this.createRowNodeOrder()), this.eventService.dispatchEvent({ type: "rowDataUpdated" }), this.refreshModel({ step: "group", rowNodeTransactions: e, rowNodeOrder: t, keepRenderedRows: !0, keepEditingRows: !0, animate: o });
  }
  doRowsToDisplay() {
    this.rowsToDisplay = this.flattenStage.execute({ rowNode: this.rootNode });
  }
  onRowHeightChanged() {
    this.refreshModel({ step: "map", keepRenderedRows: !0, keepEditingRows: !0, keepUndoRedoStack: !0 });
  }
  onRowHeightChangedDebounced() {
    this.onRowHeightChanged_debounced();
  }
  resetRowHeights() {
    const e = this.resetRowHeightsForAllRowNodes();
    this.rootNode.setRowHeight(this.rootNode.rowHeight, !0), this.rootNode.sibling && this.rootNode.sibling.setRowHeight(this.rootNode.sibling.rowHeight, !0), e && this.onRowHeightChanged();
  }
  resetRowHeightsForAllRowNodes() {
    let e = !1;
    return this.forEachNode((t) => {
      t.setRowHeight(t.rowHeight, !0);
      const i = t.detailNode;
      i && i.setRowHeight(i.rowHeight, !0), t.sibling && t.sibling.setRowHeight(t.sibling.rowHeight, !0), e = !0;
    }), e;
  }
  onGridStylesChanges(e) {
    if (e.rowHeightChanged) {
      if (this.columnModel.isAutoRowHeightActive())
        return;
      this.resetRowHeights();
    }
  }
  onGridReady() {
    this.hasStarted || this.setInitialData();
  }
  isRowDataLoaded() {
    return this.rowCountReady;
  }
}, class extends f {
  constructor() {
    super(...arguments), this.beanName = "filterStage";
  }
  wireBeans(e) {
    this.filterManager = e.filterManager;
  }
  execute(e) {
    const { changedPath: t } = e;
    this.filter(t);
  }
  filter(e) {
    var i;
    const t = !!((i = this.filterManager) != null && i.isChildFilterPresent());
    this.filterNodes(t, e);
  }
  filterNodes(e, t) {
    const i = (o, s) => {
      o.hasChildren() ? o.childrenAfterFilter = e && !s ? o.childrenAfterGroup.filter((r) => {
        const n = r.childrenAfterFilter && r.childrenAfterFilter.length > 0, a = r.data && this.filterManager.doesRowPassFilter({ rowNode: r });
        return n || a;
      }) : o.childrenAfterGroup : o.childrenAfterFilter = o.childrenAfterGroup, o.sibling && (o.sibling.childrenAfterFilter = o.childrenAfterFilter);
    };
    if (this.doingTreeDataFiltering()) {
      const o = (r, n) => {
        if (r.childrenAfterGroup)
          for (let a = 0; a < r.childrenAfterGroup.length; a++) {
            const l = r.childrenAfterGroup[a], d = n || this.filterManager.doesRowPassFilter({ rowNode: l });
            l.childrenAfterGroup ? o(r.childrenAfterGroup[a], d) : i(l, d);
          }
        i(r, n);
      }, s = (r) => o(r, !1);
      t.executeFromRootNode(s);
    } else {
      const o = (s) => i(s, !1);
      t.forEachChangedNodeDepthFirst(o, !0);
    }
  }
  doingTreeDataFiltering() {
    return this.gos.get("treeData") && !this.gos.get("excludeChildrenWhenTreeDataFiltering");
  }
}, class extends f {
  constructor() {
    super(...arguments), this.beanName = "sortStage";
  }
  wireBeans(e) {
    this.sortService = e.sortService, this.sortController = e.sortController;
  }
  execute(e) {
    const t = this.sortController.getSortOptions(), i = S(t) && t.length > 0, o = i && S(e.rowNodeTransactions) && this.gos.get("deltaSort"), s = t.some((r) => this.gos.isColumnsSortingCoupledToGroup() ? r.column.isPrimary() && r.column.isRowGroupActive() : !!r.column.getColDef().showRowGroup);
    this.sortService.sort(t, i, o, e.rowNodeTransactions, e.changedPath, s);
  }
}, class extends f {
  constructor() {
    super(...arguments), this.beanName = "flattenStage";
  }
  wireBeans(e) {
    this.beans = e, this.columnModel = e.columnModel;
  }
  execute(e) {
    const t = e.rowNode, i = [], o = this.columnModel.isPivotMode(), s = o && t.leafGroup, r = s ? [t] : t.childrenAfterSort, n = this.getFlattenDetails();
    if (this.recursivelyAddToRowsToDisplay(n, r, i, o, 0), !s && i.length > 0 && n.grandTotalRow) {
      t.createFooter();
      const a = n.grandTotalRow === "top";
      this.addRowNodeToRowsToDisplay(n, t.sibling, i, 0, a);
    }
    return i;
  }
  getFlattenDetails() {
    const e = this.gos.get("groupRemoveSingleChildren");
    return { groupRemoveLowestSingleChildren: !e && this.gos.get("groupRemoveLowestSingleChildren"), groupRemoveSingleChildren: e, isGroupMultiAutoColumn: this.gos.isGroupMultiAutoColumn(), hideOpenParents: this.gos.get("groupHideOpenParents"), grandTotalRow: this.gos.getGrandTotalRow(), groupTotalRow: this.gos.getGroupTotalRowCallback() };
  }
  recursivelyAddToRowsToDisplay(e, t, i, o, s) {
    if (!W(t))
      for (let r = 0; r < t.length; r++) {
        const n = t[r], a = n.hasChildren(), l = o && !a, d = e.groupRemoveSingleChildren && a && n.childrenAfterGroup.length === 1, c = e.groupRemoveLowestSingleChildren && a && n.leafGroup && n.childrenAfterGroup.length === 1, h = o && n.leafGroup, g = e.hideOpenParents && n.expanded && !n.master && !h;
        if (!(l || g || d || c) && this.addRowNodeToRowsToDisplay(e, n, i, s), !o || !n.leafGroup) {
          if (a) {
            const u = d || c;
            if (n.expanded || u) {
              const p = e.groupTotalRow({ node: n });
              p || n.destroyFooter();
              const C = u ? s : s + 1;
              p === "top" && (n.createFooter(), this.addRowNodeToRowsToDisplay(e, n.sibling, i, C)), this.recursivelyAddToRowsToDisplay(e, n.childrenAfterSort, i, o, C), p === "bottom" && (n.createFooter(), this.addRowNodeToRowsToDisplay(e, n.sibling, i, C));
            }
          } else if (n.master && n.expanded) {
            const u = this.createDetailNode(n);
            this.addRowNodeToRowsToDisplay(e, u, i, s);
          }
        }
      }
  }
  addRowNodeToRowsToDisplay(e, t, i, o, s) {
    s ? i.unshift(t) : i.push(t), t.setUiLevel(e.isGroupMultiAutoColumn ? 0 : o);
  }
  createDetailNode(e) {
    if (S(e.detailNode))
      return e.detailNode;
    const t = new xe(this.beans);
    return t.detail = !0, t.selectable = !1, t.parent = e, S(e.id) && (t.id = "detail_" + e.id), t.data = e.data, t.level = e.level + 1, e.detailNode = t, t;
  }
}, class extends f {
  constructor() {
    super(...arguments), this.beanName = "sortService";
  }
  wireBeans(e) {
    this.columnModel = e.columnModel, this.funcColsService = e.funcColsService, this.rowNodeSorter = e.rowNodeSorter, this.showRowGroupColsService = e.showRowGroupColsService;
  }
  sort(e, t, i, o, s, r) {
    const n = this.gos.get("groupMaintainOrder"), a = this.columnModel.getCols().some((h) => h.isRowGroupActive());
    let l = {};
    i && o && (l = this.calculateDirtyNodes(o));
    const d = this.columnModel.isPivotMode(), c = this.gos.getCallback("postSortRows");
    s && s.forEachChangedNodeDepthFirst((h) => {
      var u;
      this.pullDownGroupDataForHideOpenParents(h.childrenAfterAggFilter, !0);
      const g = d && h.leafGroup;
      if (n && a && !h.leafGroup && !r) {
        const p = (u = this.funcColsService.getRowGroupColumns()) == null ? void 0 : u[h.level + 1], C = (p == null ? void 0 : p.getSort()) === null, y = h.childrenAfterAggFilter.slice(0);
        if (h.childrenAfterSort && !C) {
          const w = {};
          h.childrenAfterSort.forEach((x, E) => {
            w[x.id] = E;
          }), y.sort((x, E) => (w[x.id] ?? 0) - (w[E.id] ?? 0));
        }
        h.childrenAfterSort = y;
      } else
        h.childrenAfterSort = !t || g ? h.childrenAfterAggFilter.slice(0) : i ? this.doDeltaSort(h, l, s, e) : this.rowNodeSorter.doFullSort(h.childrenAfterAggFilter, e);
      if (h.sibling && (h.sibling.childrenAfterSort = h.childrenAfterSort), this.updateChildIndexes(h), c) {
        const p = { nodes: h.childrenAfterSort };
        c(p);
      }
    }), this.updateGroupDataForHideOpenParents(s);
  }
  calculateDirtyNodes(e) {
    const t = {}, i = (o) => {
      o && o.forEach((s) => t[s.id] = !0);
    };
    return e && e.forEach((o) => {
      i(o.add), i(o.update), i(o.remove);
    }), t;
  }
  doDeltaSort(e, t, i, o) {
    const s = e.childrenAfterAggFilter, r = e.childrenAfterSort;
    if (!r)
      return this.rowNodeSorter.doFullSort(s, o);
    const n = {}, a = [];
    s.forEach((h) => {
      t[h.id] || !i.canSkip(h) ? a.push(h) : n[h.id] = !0;
    });
    const l = r.filter((h) => n[h.id]), d = (h, g) => ({ currentPos: g, rowNode: h }), c = a.map(d).sort((h, g) => this.rowNodeSorter.compareRowNodes(o, h, g));
    return this.mergeSortedArrays(o, c, l.map(d)).map(({ rowNode: h }) => h);
  }
  mergeSortedArrays(e, t, i) {
    const o = [];
    let s = 0, r = 0;
    for (; s < t.length && r < i.length; )
      this.rowNodeSorter.compareRowNodes(e, t[s], i[r]) < 0 ? o.push(t[s++]) : o.push(i[r++]);
    for (; s < t.length; )
      o.push(t[s++]);
    for (; r < i.length; )
      o.push(i[r++]);
    return o;
  }
  updateChildIndexes(e) {
    if (A(e.childrenAfterSort))
      return;
    const t = e.childrenAfterSort;
    for (let i = 0; i < t.length; i++) {
      const o = t[i], s = i === 0, r = i === e.childrenAfterSort.length - 1;
      o.setFirstChild(s), o.setLastChild(r), o.setChildIndex(i);
    }
  }
  updateGroupDataForHideOpenParents(e) {
    if (!this.gos.get("groupHideOpenParents"))
      return;
    if (this.gos.get("treeData"))
      return b("The property hideOpenParents dose not work with Tree Data. This is because Tree Data has values at the group level, it doesn't make sense to hide them."), !1;
    const t = (i) => {
      this.pullDownGroupDataForHideOpenParents(i.childrenAfterSort, !1), i.childrenAfterSort.forEach((o) => {
        o.hasChildren() && t(o);
      });
    };
    e && e.executeFromRootNode((i) => t(i));
  }
  pullDownGroupDataForHideOpenParents(e, t) {
    this.gos.get("groupHideOpenParents") && !A(e) && e.forEach((i) => {
      var o;
      (((o = this.showRowGroupColsService) == null ? void 0 : o.getShowRowGroupCols()) ?? []).forEach((s) => {
        const r = s.getColDef().showRowGroup;
        if (typeof r != "string")
          return void L("groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup");
        const n = r, a = this.columnModel.getColDefCol(n);
        if (a !== i.rowGroupColumn)
          if (t)
            i.setGroupValue(s.getId(), void 0);
          else {
            const l = i.getFirstChildOfFirstChild(a);
            l && i.setGroupValue(s.getId(), l.key);
          }
      });
    });
  }
}, class extends f {
  constructor() {
    super(...arguments), this.beanName = "immutableService";
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.selectionService = e.selectionService;
  }
  postConstruct() {
    this.rowModel.getType() === "clientSide" && (this.clientSideRowModel = this.rowModel, this.addManagedPropertyListener("rowData", () => this.onRowDataUpdated()));
  }
  isActive() {
    const e = this.gos.exists("getRowId");
    return !this.gos.get("resetRowDataOnUpdate") && e;
  }
  setRowData(e) {
    const t = this.createTransactionForRowData(e);
    if (!t)
      return;
    const [i, o] = t;
    this.clientSideRowModel.updateRowData(i, o);
  }
  createTransactionForRowData(e) {
    if (A(this.clientSideRowModel))
      return void L("ImmutableService only works with ClientSideRowModel");
    const t = this.gos.getRowIdCallback();
    if (t == null)
      return void L("ImmutableService requires getRowId() callback to be implemented, your row data needs IDs!");
    const i = { remove: [], update: [], add: [] }, o = this.clientSideRowModel.getCopyOfNodesMap(), s = this.gos.get("suppressMaintainUnsortedOrder") ? void 0 : {};
    return S(e) && e.forEach((r, n) => {
      const a = t({ data: r, level: 0 }), l = o[a];
      s && (s[a] = n), l ? (l.data !== r && i.update.push(r), o[a] = void 0) : i.add.push(r);
    }), le(o, (r, n) => {
      n && i.remove.push(n.data);
    }), [i, s];
  }
  onRowDataUpdated() {
    const e = this.gos.get("rowData");
    e && (this.isActive() ? this.setRowData(e) : (this.selectionService.reset("rowDataChanged"), this.clientSideRowModel.setRowData(e)));
  }
}] }, hc = { version: Ki, moduleName: "@ag-grid-community/client-side-row-model", dependantModules: [rs, { version: Ki, moduleName: "@ag-grid-community/client-side-row-model-api", beans: [zr], apiFunctions: { onGroupExpandedOrCollapsed: function(e) {
  e.expansionService.onGroupExpandedOrCollapsed();
}, refreshClientSideRowModel: function(e, t) {
  var i, o;
  (o = (i = e.rowModelHelperService) == null ? void 0 : i.getClientSideRowModel()) == null || o.refreshModel(t);
}, forEachLeafNode: function(e, t) {
  var i, o;
  (o = (i = e.rowModelHelperService) == null ? void 0 : i.getClientSideRowModel()) == null || o.forEachLeafNode(t);
}, forEachNodeAfterFilter: function(e, t) {
  var i, o;
  (o = (i = e.rowModelHelperService) == null ? void 0 : i.getClientSideRowModel()) == null || o.forEachNodeAfterFilter(t);
}, forEachNodeAfterFilterAndSort: function(e, t) {
  var i, o;
  (o = (i = e.rowModelHelperService) == null ? void 0 : i.getClientSideRowModel()) == null || o.forEachNodeAfterFilterAndSort(t);
}, resetRowHeights: function(e) {
  var t, i;
  e.columnModel.isAutoRowHeightActive() ? b("calling gridApi.resetRowHeights() makes no sense when using Auto Row Height.") : (i = (t = e.rowModelHelperService) == null ? void 0 : t.getClientSideRowModel()) == null || i.resetRowHeights();
}, applyTransaction: function(e, t) {
  return e.frameworkOverrides.wrapIncoming(() => {
    var i, o;
    return (o = (i = e.rowModelHelperService) == null ? void 0 : i.getClientSideRowModel()) == null ? void 0 : o.updateRowData(t);
  });
}, applyTransactionAsync: function(e, t, i) {
  e.frameworkOverrides.wrapIncoming(() => {
    var o, s;
    return (s = (o = e.rowModelHelperService) == null ? void 0 : o.getClientSideRowModel()) == null ? void 0 : s.batchUpdateRowData(t, i);
  });
}, flushAsyncTransactions: function(e) {
  e.frameworkOverrides.wrapIncoming(() => {
    var t, i;
    return (i = (t = e.rowModelHelperService) == null ? void 0 : t.getClientSideRowModel()) == null ? void 0 : i.flushAsyncTransactions();
  });
}, getBestCostNodeSelection: function(e) {
  return e.selectionService.getBestCostNodeSelection();
} }, dependantModules: [rs, lc] }] }, gc = class extends f {
  setBeans(e) {
    this.beans = e;
  }
  getFileName(e) {
    const t = this.getDefaultFileExtension();
    return e != null && e.length || (e = this.getDefaultFileName()), e.indexOf(".") === -1 ? `${e}.${t}` : e;
  }
  getData(e) {
    const t = this.createSerializingSession(e);
    return this.beans.gridSerializer.serialize(t, e);
  }
  getDefaultFileName() {
    return `export.${this.getDefaultFileExtension()}`;
  }
}, uc = class {
  constructor(e) {
    this.groupColumns = [];
    const { columnModel: t, funcColsService: i, columnNameService: o, valueService: s, gos: r, processCellCallback: n, processHeaderCallback: a, processGroupHeaderCallback: l, processRowGroupCallback: d } = e;
    this.columnModel = t, this.funcColsService = i, this.columnNameService = o, this.valueService = s, this.gos = r, this.processCellCallback = n, this.processHeaderCallback = a, this.processGroupHeaderCallback = l, this.processRowGroupCallback = d;
  }
  prepare(e) {
    this.groupColumns = e.filter((t) => !!t.getColDef().showRowGroup);
  }
  extractHeaderValue(e) {
    return this.getHeaderName(this.processHeaderCallback, e) ?? "";
  }
  extractRowCellValue(e, t, i, o, s) {
    const r = this.gos.get("groupHideOpenParents") && !s.footer || !this.shouldRenderGroupSummaryCell(s, e, t) ? this.valueService.getValue(e, s) : this.createValueForGroupNode(e, s);
    return this.processCell({ accumulatedRowIndex: i, rowNode: s, column: e, value: r, processCellCallback: this.processCellCallback, type: o });
  }
  shouldRenderGroupSummaryCell(e, t, i) {
    var s;
    if (!e || !e.group)
      return !1;
    if (this.groupColumns.indexOf(t) !== -1) {
      if (((s = e.groupData) == null ? void 0 : s[t.getId()]) != null || this.gos.isRowModelType("serverSide") && e.group)
        return !0;
      if (e.footer && e.level === -1) {
        const r = t.getColDef();
        return r == null || r.showRowGroup === !0 || r.showRowGroup === this.funcColsService.getRowGroupColumns()[0].getId();
      }
    }
    const o = this.gos.isGroupUseEntireRow(this.columnModel.isPivotMode());
    return i === 0 && o;
  }
  getHeaderName(e, t) {
    return e ? e(this.gos.addGridCommonParams({ column: t })) : this.columnNameService.getDisplayNameForColumn(t, "csv", !0);
  }
  createValueForGroupNode(e, t) {
    if (this.processRowGroupCallback)
      return this.processRowGroupCallback(this.gos.addGridCommonParams({ column: e, node: t }));
    const i = this.gos.get("treeData"), o = this.gos.get("suppressGroupMaintainValueType"), s = (l) => {
      var c;
      if (i || o)
        return l.key;
      const d = (c = l.groupData) == null ? void 0 : c[e.getId()];
      return d && l.rowGroupColumn && l.rowGroupColumn.getColDef().useValueFormatterForExport !== !1 ? this.valueService.formatValue(l.rowGroupColumn, l, d) ?? d : d;
    }, r = t.footer, n = [s(t)];
    if (!this.gos.isGroupMultiAutoColumn())
      for (; t.parent; )
        t = t.parent, n.push(s(t));
    const a = n.reverse().join(" -> ");
    return r ? `Total ${a}` : a;
  }
  processCell(e) {
    const { accumulatedRowIndex: t, rowNode: i, column: o, value: s, processCellCallback: r, type: n } = e;
    return r ? { value: r(this.gos.addGridCommonParams({ accumulatedRowIndex: t, column: o, node: i, value: s, type: n, parseValue: (a) => this.valueService.parseValue(o, i, a, this.valueService.getValue(o, i)), formatValue: (a) => this.valueService.formatValue(o, i, a) ?? a })) ?? "" } : o.getColDef().useValueFormatterForExport !== !1 ? { value: s ?? "", valueFormatted: this.valueService.formatValue(o, i, s) } : { value: s ?? "" };
  }
}, pc = class {
  static download(e, t) {
    const i = document.defaultView || window;
    if (!i)
      return void b("There is no `window` associated with the current `document`");
    const o = document.createElement("a"), s = i.URL.createObjectURL(t);
    o.setAttribute("href", s), o.setAttribute("download", e), o.style.display = "none", document.body.appendChild(o), o.dispatchEvent(new MouseEvent("click", { bubbles: !1, cancelable: !0, view: i })), document.body.removeChild(o), i.setTimeout(() => {
      i.URL.revokeObjectURL(s);
    }, 0);
  }
}, mc = class extends uc {
  constructor(e) {
    super(e), this.isFirstLine = !0, this.result = "";
    const { suppressQuotes: t, columnSeparator: i } = e;
    this.suppressQuotes = t, this.columnSeparator = i;
  }
  addCustomContent(e) {
    e && (typeof e == "string" ? (/^\s*\n/.test(e) || this.beginNewLine(), e = e.replace(/\r?\n/g, `\r
`), this.result += e) : e.forEach((t) => {
      this.beginNewLine(), t.forEach((i, o) => {
        o !== 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(i.data.value || ""), i.mergeAcross && this.appendEmptyCells(i.mergeAcross);
      });
    }));
  }
  onNewHeaderGroupingRow() {
    return this.beginNewLine(), { onColumn: this.onNewHeaderGroupingRowColumn.bind(this) };
  }
  onNewHeaderGroupingRowColumn(e, t, i, o) {
    i != 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(t), this.appendEmptyCells(o);
  }
  appendEmptyCells(e) {
    for (let t = 1; t <= e; t++)
      this.result += this.columnSeparator + this.putInQuotes("");
  }
  onNewHeaderRow() {
    return this.beginNewLine(), { onColumn: this.onNewHeaderRowColumn.bind(this) };
  }
  onNewHeaderRowColumn(e, t) {
    t != 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(this.extractHeaderValue(e));
  }
  onNewBodyRow() {
    return this.beginNewLine(), { onColumn: this.onNewBodyRowColumn.bind(this) };
  }
  onNewBodyRowColumn(e, t, i) {
    t != 0 && (this.result += this.columnSeparator);
    const o = this.extractRowCellValue(e, t, t, "csv", i);
    this.result += this.putInQuotes(o.valueFormatted ?? o.value);
  }
  putInQuotes(e) {
    if (this.suppressQuotes)
      return e;
    if (e == null)
      return '""';
    let t;
    return typeof e == "string" ? t = e : typeof e.toString == "function" ? t = e.toString() : (b("unknown value type during csv conversion"), t = ""), '"' + t.replace(/"/g, '""') + '"';
  }
  parse() {
    return this.result;
  }
  beginNewLine() {
    this.isFirstLine || (this.result += `\r
`), this.isFirstLine = !1;
  }
}, Qi = "32.0.2", ns = { version: Qi, moduleName: "@ag-grid-community/csv-export-core", beans: [class extends gc {
  constructor() {
    super(...arguments), this.beanName = "csvCreator";
  }
  wireBeans(e) {
    this.columnModel = e.columnModel, this.columnNameService = e.columnNameService, this.funcColsService = e.funcColsService, this.valueService = e.valueService, this.gridSerializer = e.gridSerializer;
  }
  postConstruct() {
    this.setBeans({ gridSerializer: this.gridSerializer, gos: this.gos });
  }
  getMergedParams(e) {
    const t = this.gos.get("defaultCsvExportParams");
    return Object.assign({}, t, e);
  }
  export(e) {
    if (this.isExportSuppressed())
      return void b("Export cancelled. Export is not allowed as per your configuration.");
    const t = this.getMergedParams(e), i = this.getData(t), o = new Blob(["\uFEFF", i], { type: "text/plain" }), s = typeof t.fileName == "function" ? t.fileName(this.gos.getGridCommonParams()) : t.fileName;
    pc.download(this.getFileName(s), o);
  }
  exportDataAsCsv(e) {
    this.export(e);
  }
  getDataAsCsv(e, t = !1) {
    const i = t ? Object.assign({}, e) : this.getMergedParams(e);
    return this.getData(i);
  }
  getDefaultFileExtension() {
    return "csv";
  }
  createSerializingSession(e) {
    const { columnModel: t, columnNameService: i, funcColsService: o, valueService: s, gos: r } = this, { processCellCallback: n, processHeaderCallback: a, processGroupHeaderCallback: l, processRowGroupCallback: d, suppressQuotes: c, columnSeparator: h } = e;
    return new mc({ columnModel: t, columnNameService: i, funcColsService: o, valueService: s, gos: r, processCellCallback: n || void 0, processHeaderCallback: a || void 0, processGroupHeaderCallback: l || void 0, processRowGroupCallback: d || void 0, suppressQuotes: c || !1, columnSeparator: h || "," });
  }
  isExportSuppressed() {
    return this.gos.get("suppressCsvExport");
  }
}, class extends f {
  constructor() {
    super(...arguments), this.beanName = "gridSerializer";
  }
  wireBeans(e) {
    this.visibleColsService = e.visibleColsService, this.columnModel = e.columnModel, this.columnNameService = e.columnNameService, this.rowModel = e.rowModel, this.pinnedRowModel = e.pinnedRowModel, this.selectionService = e.selectionService, this.rowNodeSorter = e.rowNodeSorter, this.sortController = e.sortController;
  }
  serialize(e, t = {}) {
    const { allColumns: i, columnKeys: o, skipRowGroups: s } = t, r = this.getColumnsToExport(i, s, o);
    return function(...n) {
      return (a) => n.reduce((l, d) => d(l), a);
    }(this.prepareSession(r), this.prependContent(t), this.exportColumnGroups(t, r), this.exportHeaders(t, r), this.processPinnedTopRows(t, r), this.processRows(t, r), this.processPinnedBottomRows(t, r), this.appendContent(t))(e).parse();
  }
  processRow(e, t, i, o) {
    var p;
    const s = t.shouldRowBeSkipped || (() => !1), r = this.gos.get("groupRemoveSingleChildren"), n = this.gos.get("groupRemoveLowestSingleChildren"), a = t.rowPositions != null || !!t.onlySelected, l = this.gos.get("groupHideOpenParents") && !a, d = this.columnModel.isPivotMode() ? o.leafGroup : !o.group, c = !!o.footer, h = n && o.leafGroup, g = o.allChildrenCount === 1 && ((p = o.childrenAfterGroup) == null ? void 0 : p.length) === 1 && (r || h);
    if (!d && !c && (t.skipRowGroups || g || l) || t.onlySelected && !o.isSelected() || t.skipPinnedTop && o.rowPinned === "top" || t.skipPinnedBottom && o.rowPinned === "bottom" || o.level === -1 && !d && !c || s(this.gos.addGridCommonParams({ node: o })))
      return;
    const u = e.onNewBodyRow(o);
    if (i.forEach((C, y) => {
      u.onColumn(C, y, o);
    }), t.getCustomContentBelowRow) {
      const C = t.getCustomContentBelowRow(this.gos.addGridCommonParams({ node: o }));
      C && e.addCustomContent(C);
    }
  }
  appendContent(e) {
    return (t) => {
      const i = e.appendContent;
      return i && t.addCustomContent(i), t;
    };
  }
  prependContent(e) {
    return (t) => {
      const i = e.prependContent;
      return i && t.addCustomContent(i), t;
    };
  }
  prepareSession(e) {
    return (t) => (t.prepare(e), t);
  }
  exportColumnGroups(e, t) {
    return (i) => {
      if (!e.skipColumnGroupHeaders) {
        const o = new fs(), s = this.visibleColsService.createGroups({ columns: t, idCreator: o, pinned: null, isStandaloneStructure: !0 });
        this.recursivelyAddHeaderGroups(s, i, e.processGroupHeaderCallback);
      }
      return i;
    };
  }
  exportHeaders(e, t) {
    return (i) => {
      if (!e.skipColumnHeaders) {
        const o = i.onNewHeaderRow();
        t.forEach((s, r) => {
          o.onColumn(s, r, void 0);
        });
      }
      return i;
    };
  }
  processPinnedTopRows(e, t) {
    return (i) => {
      const o = this.processRow.bind(this, i, e, t);
      return e.rowPositions ? e.rowPositions.filter((s) => s.rowPinned === "top").sort((s, r) => s.rowIndex - r.rowIndex).map((s) => this.pinnedRowModel.getPinnedTopRow(s.rowIndex)).forEach(o) : this.pinnedRowModel.forEachPinnedTopRow(o), i;
    };
  }
  processRows(e, t) {
    return (i) => {
      const o = this.rowModel, s = o.getType(), r = s === "clientSide", n = s === "serverSide", a = !r && e.onlySelected, l = this.processRow.bind(this, i, e, t), { exportedRows: d = "filteredAndSorted" } = e;
      if (e.rowPositions)
        e.rowPositions.filter((c) => c.rowPinned == null).sort((c, h) => c.rowIndex - h.rowIndex).map((c) => o.getRow(c.rowIndex)).forEach(l);
      else if (this.columnModel.isPivotMode())
        r ? o.forEachPivotNode(l, !0) : n ? o.forEachNodeAfterFilterAndSort(l, !0) : o.forEachNode(l);
      else if (e.onlySelectedAllPages || a) {
        const c = this.selectionService.getSelectedNodes();
        this.replicateSortedOrder(c), c.forEach(l);
      } else
        d === "all" ? o.forEachNode(l) : r || n ? o.forEachNodeAfterFilterAndSort(l, !0) : o.forEachNode(l);
      return i;
    };
  }
  replicateSortedOrder(e) {
    const t = this.sortController.getSortOptions(), i = (o, s) => {
      var r, n;
      return o.rowIndex != null && s.rowIndex != null ? o.rowIndex - s.rowIndex : o.level === s.level ? ((r = o.parent) == null ? void 0 : r.id) === ((n = s.parent) == null ? void 0 : n.id) ? this.rowNodeSorter.compareRowNodes(t, { rowNode: o, currentPos: o.rowIndex ?? -1 }, { rowNode: s, currentPos: s.rowIndex ?? -1 }) : i(o.parent, s.parent) : o.level > s.level ? i(o.parent, s) : i(o, s.parent);
    };
    e.sort(i);
  }
  processPinnedBottomRows(e, t) {
    return (i) => {
      const o = this.processRow.bind(this, i, e, t);
      return e.rowPositions ? e.rowPositions.filter((s) => s.rowPinned === "bottom").sort((s, r) => s.rowIndex - r.rowIndex).map((s) => this.pinnedRowModel.getPinnedBottomRow(s.rowIndex)).forEach(o) : this.pinnedRowModel.forEachPinnedBottomRow(o), i;
    };
  }
  getColumnsToExport(e = !1, t = !1, i) {
    const o = this.columnModel.isPivotMode();
    if (i && i.length)
      return this.columnModel.getColsForKeys(i);
    const s = this.gos.get("treeData");
    let r = [];
    return r = e && !o ? this.columnModel.getCols() : this.visibleColsService.getAllCols(), t && !s && (r = r.filter((n) => n.getColId() !== Et)), r;
  }
  recursivelyAddHeaderGroups(e, t, i) {
    const o = [];
    e.forEach((s) => {
      const r = s;
      r.getChildren && r.getChildren().forEach((n) => o.push(n));
    }), e.length > 0 && V(e[0]) && this.doAddHeaderHeader(t, e, i), o && o.length > 0 && this.recursivelyAddHeaderGroups(o, t, i);
  }
  doAddHeaderHeader(e, t, i) {
    const o = e.onNewHeaderGroupingRow();
    let s = 0;
    t.forEach((r) => {
      const n = r;
      let a;
      a = i ? i(this.gos.addGridCommonParams({ columnGroup: n })) : this.columnNameService.getDisplayNameForColumnGroup(n, "header");
      const l = n.getLeafColumns().reduce((d, c, h, g) => {
        let u = T(d);
        return c.getColumnGroupShow() === "open" ? u && u[1] == null || (u = [h], d.push(u)) : u && u[1] == null && (u[1] = h - 1), h === g.length - 1 && u && u[1] == null && (u[1] = h), d;
      }, []);
      o.onColumn(n, a || "", s++, n.getLeafColumns().length - 1, l);
    });
  }
}] }, vc = { version: Qi, moduleName: "@ag-grid-community/csv-export", dependantModules: [ns, { version: Qi, moduleName: "@ag-grid-community/csv-export-api", apiFunctions: { getDataAsCsv: function(e, t) {
  var i;
  return (i = e.csvCreator) == null ? void 0 : i.getDataAsCsv(t);
}, exportDataAsCsv: function(e, t) {
  var i;
  (i = e.csvCreator) == null || i.exportDataAsCsv(t);
} }, dependantModules: [ns] }] }, fc = class extends jl {
  wireBeans(e) {
    this.beans = e;
  }
  constructor(e, t, i) {
    super(e), this.parentCache = t, this.params = i, this.startRow = e * i.blockSize, this.endRow = this.startRow + i.blockSize;
  }
  postConstruct() {
    this.createRowNodes();
  }
  getBlockStateJson() {
    return { id: "" + this.getId(), state: { blockNumber: this.getId(), startRow: this.getStartRow(), endRow: this.getEndRow(), pageStatus: this.getState() } };
  }
  setDataAndId(e, t, i) {
    S(t) ? e.setDataAndId(t, i.toString()) : e.setDataAndId(void 0, void 0);
  }
  loadFromDatasource() {
    const e = this.createLoadParams();
    A(this.params.datasource.getRows) ? b("datasource is missing getRows method") : window.setTimeout(() => {
      this.params.datasource.getRows(e);
    }, 0);
  }
  processServerFail() {
  }
  createLoadParams() {
    return { startRow: this.getStartRow(), endRow: this.getEndRow(), successCallback: this.pageLoaded.bind(this, this.getVersion()), failCallback: this.pageLoadFailed.bind(this, this.getVersion()), sortModel: this.params.sortModel, filterModel: this.params.filterModel, context: this.gos.getGridCommonParams().context };
  }
  forEachNode(e, t, i) {
    this.rowNodes.forEach((o, s) => {
      this.startRow + s < i && e(o, t.next());
    });
  }
  getLastAccessed() {
    return this.lastAccessed;
  }
  getRow(e, t = !1) {
    t || (this.lastAccessed = this.params.lastAccessedSequence.next());
    const i = e - this.startRow;
    return this.rowNodes[i];
  }
  getStartRow() {
    return this.startRow;
  }
  getEndRow() {
    return this.endRow;
  }
  createRowNodes() {
    this.rowNodes = [];
    for (let e = 0; e < this.params.blockSize; e++) {
      const t = this.startRow + e, i = new xe(this.beans);
      i.setRowHeight(this.params.rowHeight), i.uiLevel = 0, i.setRowIndex(t), i.setRowTop(this.params.rowHeight * t), this.rowNodes.push(i);
    }
  }
  processServerResult(e) {
    this.rowNodes.forEach((i, o) => {
      const s = e.rowData ? e.rowData[o] : void 0;
      !i.id && i.alreadyRendered && s && (this.rowNodes[o] = new xe(this.beans), this.rowNodes[o].setRowIndex(i.rowIndex), this.rowNodes[o].setRowTop(i.rowTop), this.rowNodes[o].setRowHeight(i.rowHeight), i.clearRowTopAndRowIndex()), this.setDataAndId(this.rowNodes[o], s, this.startRow + o);
    });
    const t = e.rowCount != null && e.rowCount >= 0 ? e.rowCount : void 0;
    this.parentCache.pageLoaded(this, t);
  }
  destroy() {
    this.rowNodes.forEach((e) => {
      e.clearRowTopAndRowIndex();
    }), super.destroy();
  }
}, Cc = class extends f {
  constructor(e) {
    super(), this.lastRowIndexKnown = !1, this.blocks = {}, this.blockCount = 0, this.rowCount = e.initialRowCount, this.params = e;
  }
  wireBeans(e) {
    this.rowRenderer = e.rowRenderer, this.focusService = e.focusService;
  }
  getRow(e, t = !1) {
    const i = Math.floor(e / this.params.blockSize);
    let o = this.blocks[i];
    if (!o) {
      if (t)
        return;
      o = this.createBlock(i);
    }
    return o.getRow(e);
  }
  createBlock(e) {
    const t = this.createBean(new fc(e, this, this.params));
    return this.blocks[t.getId()] = t, this.blockCount++, this.purgeBlocksIfNeeded(t), this.params.rowNodeBlockLoader.addBlock(t), t;
  }
  refreshCache() {
    this.blockCount == 0 ? this.purgeCache() : (this.getBlocksInOrder().forEach((e) => e.setStateWaitingToLoad()), this.params.rowNodeBlockLoader.checkBlockToLoad());
  }
  destroy() {
    this.getBlocksInOrder().forEach((e) => this.destroyBlock(e)), super.destroy();
  }
  getRowCount() {
    return this.rowCount;
  }
  isLastRowIndexKnown() {
    return this.lastRowIndexKnown;
  }
  pageLoaded(e, t) {
    this.isAlive() && (this.gos.get("debug") && se(`InfiniteCache - onPageLoaded: page = ${e.getId()}, lastRow = ${t}`), this.checkRowCount(e, t), this.onCacheUpdated());
  }
  purgeBlocksIfNeeded(e) {
    const t = this.getBlocksInOrder().filter((s) => s != e);
    t.sort((s, r) => r.getLastAccessed() - s.getLastAccessed());
    const i = this.params.maxBlocksInCache > 0, o = i ? this.params.maxBlocksInCache - 1 : null;
    t.forEach((s, r) => {
      if (s.getState() === "needsLoading" && r >= 1 || i && r >= o) {
        if (this.isBlockCurrentlyDisplayed(s) || this.isBlockFocused(s))
          return;
        this.removeBlockFromCache(s);
      }
    });
  }
  isBlockFocused(e) {
    const t = this.focusService.getFocusCellToUseAfterRefresh();
    if (!t || t.rowPinned != null)
      return !1;
    const i = e.getStartRow(), o = e.getEndRow();
    return t.rowIndex >= i && t.rowIndex < o;
  }
  isBlockCurrentlyDisplayed(e) {
    const t = e.getStartRow(), i = e.getEndRow() - 1;
    return this.rowRenderer.isRangeInRenderedViewport(t, i);
  }
  removeBlockFromCache(e) {
    e && this.destroyBlock(e);
  }
  checkRowCount(e, t) {
    if (typeof t == "number" && t >= 0)
      this.rowCount = t, this.lastRowIndexKnown = !0;
    else if (!this.lastRowIndexKnown) {
      const i = (e.getId() + 1) * this.params.blockSize + this.params.overflowSize;
      this.rowCount < i && (this.rowCount = i);
    }
  }
  setRowCount(e, t) {
    this.rowCount = e, S(t) && (this.lastRowIndexKnown = t), this.lastRowIndexKnown || this.rowCount % this.params.blockSize == 0 && this.rowCount++, this.onCacheUpdated();
  }
  forEachNodeDeep(e) {
    const t = new ct();
    this.getBlocksInOrder().forEach((i) => i.forEachNode(e, t, this.rowCount));
  }
  getBlocksInOrder() {
    return Ie(this.blocks).sort((e, t) => e.getId() - t.getId());
  }
  destroyBlock(e) {
    delete this.blocks[e.getId()], this.destroyBean(e), this.blockCount--, this.params.rowNodeBlockLoader.removeBlock(e);
  }
  onCacheUpdated() {
    if (this.isAlive()) {
      this.destroyAllBlocksPastVirtualRowCount();
      const e = { type: "storeUpdated" };
      this.eventService.dispatchEvent(e);
    }
  }
  destroyAllBlocksPastVirtualRowCount() {
    const e = [];
    this.getBlocksInOrder().forEach((t) => {
      t.getId() * this.params.blockSize >= this.rowCount && e.push(t);
    }), e.length > 0 && e.forEach((t) => this.destroyBlock(t));
  }
  purgeCache() {
    this.getBlocksInOrder().forEach((e) => this.removeBlockFromCache(e)), this.lastRowIndexKnown = !1, this.rowCount === 0 && (this.rowCount = this.params.initialRowCount), this.onCacheUpdated();
  }
  getRowNodesInRange(e, t) {
    const i = [];
    let o = -1, s = !1;
    const r = new ct();
    let n = !1;
    return this.getBlocksInOrder().forEach((a) => {
      n || (s && o + 1 !== a.getId() ? n = !0 : (o = a.getId(), a.forEachNode((l) => {
        const d = l === e || l === t;
        (s || d) && i.push(l), d && (s = !s);
      }, r, this.rowCount)));
    }), n || s ? [] : i;
  }
}, Yi = "32.0.2", as = { version: Yi, moduleName: "@ag-grid-community/infinite-row-model-core", rowModel: "infinite", beans: [class extends f {
  constructor() {
    super(...arguments), this.beanName = "rowModel";
  }
  wireBeans(e) {
    this.filterManager = e.filterManager, this.sortController = e.sortController, this.selectionService = e.selectionService, this.rowRenderer = e.rowRenderer, this.rowNodeBlockLoader = e.rowNodeBlockLoader;
  }
  getRowBounds(e) {
    return { rowHeight: this.rowHeight, rowTop: this.rowHeight * e };
  }
  ensureRowHeightsValid() {
    return !1;
  }
  postConstruct() {
    this.gos.isRowModelType("infinite") && (this.rowHeight = this.gos.getRowHeightAsNumber(), this.addEventListeners(), this.addDestroyFunc(() => this.destroyCache()), this.verifyProps());
  }
  verifyProps() {
    this.gos.exists("initialGroupOrderComparator") && b("initialGroupOrderComparator cannot be used with Infinite Row Model as sorting is done on the server side");
  }
  start() {
    this.setDatasource(this.gos.get("datasource"));
  }
  destroy() {
    this.destroyDatasource(), super.destroy();
  }
  destroyDatasource() {
    this.datasource && (this.destroyBean(this.datasource), this.rowRenderer.datasourceChanged(), this.datasource = null);
  }
  addEventListeners() {
    this.addManagedEventListeners({ filterChanged: this.onFilterChanged.bind(this), sortChanged: this.onSortChanged.bind(this), newColumnsLoaded: this.onColumnEverything.bind(this), storeUpdated: this.onCacheUpdated.bind(this) }), this.addManagedPropertyListener("datasource", () => this.setDatasource(this.gos.get("datasource"))), this.addManagedPropertyListener("cacheBlockSize", () => this.resetCache()), this.addManagedPropertyListener("rowHeight", () => {
      this.rowHeight = this.gos.getRowHeightAsNumber(), this.cacheParams.rowHeight = this.rowHeight, this.updateRowHeights();
    });
  }
  onFilterChanged() {
    this.reset();
  }
  onSortChanged() {
    this.reset();
  }
  onColumnEverything() {
    let e;
    e = !this.cacheParams || this.isSortModelDifferent(), e && this.reset();
  }
  isSortModelDifferent() {
    return !Xt(this.cacheParams.sortModel, this.sortController.getSortModel());
  }
  getType() {
    return "infinite";
  }
  setDatasource(e) {
    this.destroyDatasource(), this.datasource = e, e && this.reset();
  }
  isEmpty() {
    return !this.infiniteCache;
  }
  isRowsToRender() {
    return !!this.infiniteCache;
  }
  getNodesInRangeForSelection(e, t) {
    return this.infiniteCache ? this.infiniteCache.getRowNodesInRange(e, t) : [];
  }
  reset() {
    this.datasource && (this.gos.getRowIdCallback() != null || this.selectionService.reset("rowDataChanged"), this.resetCache());
  }
  createModelUpdatedEvent() {
    return { type: "modelUpdated", newPage: !1, newPageSize: !1, newData: !1, keepRenderedRows: !0, animate: !1 };
  }
  resetCache() {
    var t;
    this.destroyCache(), this.cacheParams = { datasource: this.datasource, filterModel: ((t = this.filterManager) == null ? void 0 : t.getFilterModel()) ?? {}, sortModel: this.sortController.getSortModel(), rowNodeBlockLoader: this.rowNodeBlockLoader, initialRowCount: this.gos.get("infiniteInitialRowCount"), maxBlocksInCache: this.gos.get("maxBlocksInCache"), rowHeight: this.gos.getRowHeightAsNumber(), overflowSize: this.gos.get("cacheOverflowSize"), blockSize: this.gos.get("cacheBlockSize"), lastAccessedSequence: new ct() }, this.infiniteCache = this.createBean(new Cc(this.cacheParams)), this.eventService.dispatchEventOnce({ type: "rowCountReady" });
    const e = this.createModelUpdatedEvent();
    this.eventService.dispatchEvent(e);
  }
  updateRowHeights() {
    this.forEachNode((t) => {
      t.setRowHeight(this.rowHeight), t.setRowTop(this.rowHeight * t.rowIndex);
    });
    const e = this.createModelUpdatedEvent();
    this.eventService.dispatchEvent(e);
  }
  destroyCache() {
    this.infiniteCache && (this.infiniteCache = this.destroyBean(this.infiniteCache));
  }
  onCacheUpdated() {
    const e = this.createModelUpdatedEvent();
    this.eventService.dispatchEvent(e);
  }
  getRow(e) {
    if (this.infiniteCache && !(e >= this.infiniteCache.getRowCount()))
      return this.infiniteCache.getRow(e);
  }
  getRowNode(e) {
    let t;
    return this.forEachNode((i) => {
      i.id === e && (t = i);
    }), t;
  }
  forEachNode(e) {
    this.infiniteCache && this.infiniteCache.forEachNodeDeep(e);
  }
  getTopLevelRowCount() {
    return this.getRowCount();
  }
  getTopLevelRowDisplayedIndex(e) {
    return e;
  }
  getRowIndexAtPixel(e) {
    if (this.rowHeight !== 0) {
      const t = Math.floor(e / this.rowHeight), i = this.getRowCount() - 1;
      return t > i ? i : t;
    }
    return 0;
  }
  getRowCount() {
    return this.infiniteCache ? this.infiniteCache.getRowCount() : 0;
  }
  isRowPresent(e) {
    return !!this.getRowNode(e.id);
  }
  refreshCache() {
    this.infiniteCache && this.infiniteCache.refreshCache();
  }
  purgeCache() {
    this.infiniteCache && this.infiniteCache.purgeCache();
  }
  isLastRowIndexKnown() {
    return !!this.infiniteCache && this.infiniteCache.isLastRowIndexKnown();
  }
  setRowCount(e, t) {
    this.infiniteCache && this.infiniteCache.setRowCount(e, t);
  }
}], dependantModules: [Kl] }, wc = { version: Yi, moduleName: "@ag-grid-community/infinite-row-model", dependantModules: [as, { version: Yi, moduleName: "@ag-grid-community/infinite-row-model-api", beans: [zr], apiFunctions: { refreshInfiniteCache: function(e) {
  var t, i;
  (i = (t = e.rowModelHelperService) == null ? void 0 : t.getInfiniteRowModel()) == null || i.refreshCache();
}, purgeInfiniteCache: function(e) {
  var t, i;
  (i = (t = e.rowModelHelperService) == null ? void 0 : t.getInfiniteRowModel()) == null || i.purgeCache();
}, getInfiniteRowCount: function(e) {
  var t, i;
  return (i = (t = e.rowModelHelperService) == null ? void 0 : t.getInfiniteRowModel()) == null ? void 0 : i.getRowCount();
}, isLastRowIndexKnown: function(e) {
  var t, i;
  return (i = (t = e.rowModelHelperService) == null ? void 0 : t.getInfiniteRowModel()) == null ? void 0 : i.isLastRowIndexKnown();
} }, dependantModules: [as, dc] }] };
Q.__registerModules([Ir, hc, wc, vc], !1, void 0);
const bc = Ur`
  :host {
    display: block;
  }
`;
var yc = Object.defineProperty, Sc = Object.getOwnPropertyDescriptor, ke = (e, t, i, o) => {
  for (var s, r = o > 1 ? void 0 : o ? Sc(t, i) : t, n = e.length - 1; n >= 0; n--)
    (s = e[n]) && (r = (o ? s(t, i, r) : s(r)) || r);
  return o && r && yc(t, i, r), r;
};
const et = (e, t) => `<div class="table-grid__icon-size">
            <ex-icon size="XS" icon="${e}" label="${t}" variant="icon"></ex-icon>
          </div>`;
class ae extends jr {
  constructor() {
    super(...arguments), this.isTableGrid = !1, this.gridOptions = {}, this.editableContent = !1, this.overflowVisible = !1, this.hideSortOrder = !1, this.stickyHeader = !1, this.domLayoutNormal = !1;
  }
  initializeGrid(t) {
    try {
      (function(i, o, s) {
        if (!o)
          return L("No gridOptions provided to createGrid"), {};
        if (new ac().create(i, o, (r) => {
          const n = new Fd(i);
          r.createBean(n);
        }, void 0, s), !Object.isFrozen(o)) {
          const r = "https://ag-grid.com/javascript-data-grid/grid-interface/#grid-api";
          Object.defineProperty(o, "api", { get: () => {
            L(`gridOptions.api is no longer supported. See ${r}.`);
          }, configurable: !0 });
        }
      })(t, this.gridOptions);
    } catch (i) {
      console.error("Failed to initialize the Grid Table", i);
    }
  }
  async firstUpdated() {
    var t;
    if (this.isTableGrid = (t = this.gridOptions) && Object.keys(t).length > 1 || !1, this.isTableGrid) {
      const i = await this.tableEle, o = { sortAscending: et("Up arrow", "Ascending"), sortDescending: et("Down arrow", "Descending"), smallDown: et("direction-arrowhead-down", "Select"), sortUnSort: et("Sort", "Sort"), filter: et("Filter simple", "Filter"), rowDrag: et("Reorder", "drag row") };
      this.gridOptions.icons = o, this.initializeGrid(i);
    } else
      console.warn("Deprecation Warning!!! Table without the gridOptions property will be moved to the Structured Lists Component.");
  }
  render() {
    return this.isTableGrid ? Do`
        <div
          id="table-grid"
          tabindex="0"
          class=${$r({ "ag-theme-alpine": !0, "ag-theme-alpine--editable-content": this.editableContent, "ag-theme-alpine--overflow-visible": this.overflowVisible, "ag-theme-alpine--hide-sort-order": this.hideSortOrder, "sticky--header": this.stickyHeader, "dom-layout--normal": this.domLayoutNormal })}
        ></div>
      ` : Do`
      <div class="table">
        <slot></slot>
      </div>
    `;
  }
}
ae.styles = [It(`.ag-icon{font-family:var(--ag-icon-font-family);font-weight:var(--ag-icon-font-weight);color:var(--ag-icon-font-color);font-size:var(--ag-icon-size);line-height:var(--ag-icon-size);font-style:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:var(--ag-icon-size);height:var(--ag-icon-size);position:relative}.ag-icon:before{content:"";font-family:inherit}.ag-icon:after{background:transparent var(--ag-icon-image, none) center/contain no-repeat;display:var(--ag-icon-image-display);opacity:var(--ag-icon-image-opacity, .9);position:absolute;top:0;right:0;bottom:0;left:0;content:""}.ag-icon-aggregation{font-family:var(--ag-icon-font-family-aggregation, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-aggregation, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-aggregation, var(--ag-icon-font-color))}.ag-icon-aggregation:before{content:var(--ag-icon-font-code-aggregation, "");display:var(--ag-icon-font-display-aggregation, var(--ag-icon-font-display))}.ag-icon-aggregation:after{background-image:var(--ag-icon-image-aggregation, var(--ag-icon-image));display:var(--ag-icon-image-display-aggregation, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-aggregation, var(--ag-icon-image-opacity, .9))}.ag-icon-arrows{font-family:var(--ag-icon-font-family-arrows, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-arrows, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-arrows, var(--ag-icon-font-color))}.ag-icon-arrows:before{content:var(--ag-icon-font-code-arrows, "");display:var(--ag-icon-font-display-arrows, var(--ag-icon-font-display))}.ag-icon-arrows:after{background-image:var(--ag-icon-image-arrows, var(--ag-icon-image));display:var(--ag-icon-image-display-arrows, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-arrows, var(--ag-icon-image-opacity, .9))}.ag-icon-asc{font-family:var(--ag-icon-font-family-asc, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-asc, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-asc, var(--ag-icon-font-color))}.ag-icon-asc:before{content:var(--ag-icon-font-code-asc, "");display:var(--ag-icon-font-display-asc, var(--ag-icon-font-display))}.ag-icon-asc:after{background-image:var(--ag-icon-image-asc, var(--ag-icon-image));display:var(--ag-icon-image-display-asc, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-asc, var(--ag-icon-image-opacity, .9))}.ag-icon-cancel{font-family:var(--ag-icon-font-family-cancel, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-cancel, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-cancel, var(--ag-icon-font-color))}.ag-icon-cancel:before{content:var(--ag-icon-font-code-cancel, "");display:var(--ag-icon-font-display-cancel, var(--ag-icon-font-display))}.ag-icon-cancel:after{background-image:var(--ag-icon-image-cancel, var(--ag-icon-image));display:var(--ag-icon-image-display-cancel, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-cancel, var(--ag-icon-image-opacity, .9))}.ag-icon-chart{font-family:var(--ag-icon-font-family-chart, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-chart, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-chart, var(--ag-icon-font-color))}.ag-icon-chart:before{content:var(--ag-icon-font-code-chart, "");display:var(--ag-icon-font-display-chart, var(--ag-icon-font-display))}.ag-icon-chart:after{background-image:var(--ag-icon-image-chart, var(--ag-icon-image));display:var(--ag-icon-image-display-chart, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-chart, var(--ag-icon-image-opacity, .9))}.ag-icon-checkbox-checked{font-family:var(--ag-icon-font-family-checkbox-checked, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-checkbox-checked, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-checkbox-checked, var(--ag-icon-font-color))}.ag-icon-checkbox-checked:before{content:var(--ag-icon-font-code-checkbox-checked, "");display:var(--ag-icon-font-display-checkbox-checked, var(--ag-icon-font-display))}.ag-icon-checkbox-checked:after{background-image:var(--ag-icon-image-checkbox-checked, var(--ag-icon-image));display:var(--ag-icon-image-display-checkbox-checked, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-checkbox-checked, var(--ag-icon-image-opacity, .9))}.ag-icon-checkbox-indeterminate{font-family:var(--ag-icon-font-family-checkbox-indeterminate, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-checkbox-indeterminate, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-checkbox-indeterminate, var(--ag-icon-font-color))}.ag-icon-checkbox-indeterminate:before{content:var(--ag-icon-font-code-checkbox-indeterminate, "");display:var(--ag-icon-font-display-checkbox-indeterminate, var(--ag-icon-font-display))}.ag-icon-checkbox-indeterminate:after{background-image:var(--ag-icon-image-checkbox-indeterminate, var(--ag-icon-image));display:var(--ag-icon-image-display-checkbox-indeterminate, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-checkbox-indeterminate, var(--ag-icon-image-opacity, .9))}.ag-icon-checkbox-unchecked{font-family:var(--ag-icon-font-family-checkbox-unchecked, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-checkbox-unchecked, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-checkbox-unchecked, var(--ag-icon-font-color))}.ag-icon-checkbox-unchecked:before{content:var(--ag-icon-font-code-checkbox-unchecked, "");display:var(--ag-icon-font-display-checkbox-unchecked, var(--ag-icon-font-display))}.ag-icon-checkbox-unchecked:after{background-image:var(--ag-icon-image-checkbox-unchecked, var(--ag-icon-image));display:var(--ag-icon-image-display-checkbox-unchecked, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-checkbox-unchecked, var(--ag-icon-image-opacity, .9))}.ag-icon-color-picker{font-family:var(--ag-icon-font-family-color-picker, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-color-picker, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-color-picker, var(--ag-icon-font-color))}.ag-icon-color-picker:before{content:var(--ag-icon-font-code-color-picker, "");display:var(--ag-icon-font-display-color-picker, var(--ag-icon-font-display))}.ag-icon-color-picker:after{background-image:var(--ag-icon-image-color-picker, var(--ag-icon-image));display:var(--ag-icon-image-display-color-picker, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-color-picker, var(--ag-icon-image-opacity, .9))}.ag-icon-columns{font-family:var(--ag-icon-font-family-columns, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-columns, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-columns, var(--ag-icon-font-color))}.ag-icon-columns:before{content:var(--ag-icon-font-code-columns, "");display:var(--ag-icon-font-display-columns, var(--ag-icon-font-display))}.ag-icon-columns:after{background-image:var(--ag-icon-image-columns, var(--ag-icon-image));display:var(--ag-icon-image-display-columns, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-columns, var(--ag-icon-image-opacity, .9))}.ag-icon-contracted{font-family:var(--ag-icon-font-family-contracted, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-contracted, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-contracted, var(--ag-icon-font-color))}.ag-icon-contracted:before{content:var(--ag-icon-font-code-contracted, "");display:var(--ag-icon-font-display-contracted, var(--ag-icon-font-display))}.ag-icon-contracted:after{background-image:var(--ag-icon-image-contracted, var(--ag-icon-image));display:var(--ag-icon-image-display-contracted, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-contracted, var(--ag-icon-image-opacity, .9))}.ag-icon-copy{font-family:var(--ag-icon-font-family-copy, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-copy, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-copy, var(--ag-icon-font-color))}.ag-icon-copy:before{content:var(--ag-icon-font-code-copy, "");display:var(--ag-icon-font-display-copy, var(--ag-icon-font-display))}.ag-icon-copy:after{background-image:var(--ag-icon-image-copy, var(--ag-icon-image));display:var(--ag-icon-image-display-copy, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-copy, var(--ag-icon-image-opacity, .9))}.ag-icon-cross{font-family:var(--ag-icon-font-family-cross, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-cross, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-cross, var(--ag-icon-font-color))}.ag-icon-cross:before{content:var(--ag-icon-font-code-cross, "");display:var(--ag-icon-font-display-cross, var(--ag-icon-font-display))}.ag-icon-cross:after{background-image:var(--ag-icon-image-cross, var(--ag-icon-image));display:var(--ag-icon-image-display-cross, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-cross, var(--ag-icon-image-opacity, .9))}.ag-icon-csv{font-family:var(--ag-icon-font-family-csv, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-csv, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-csv, var(--ag-icon-font-color))}.ag-icon-csv:before{content:var(--ag-icon-font-code-csv, "");display:var(--ag-icon-font-display-csv, var(--ag-icon-font-display))}.ag-icon-csv:after{background-image:var(--ag-icon-image-csv, var(--ag-icon-image));display:var(--ag-icon-image-display-csv, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-csv, var(--ag-icon-image-opacity, .9))}.ag-icon-cut{font-family:var(--ag-icon-font-family-cut, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-cut, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-cut, var(--ag-icon-font-color))}.ag-icon-cut:before{content:var(--ag-icon-font-code-cut, "");display:var(--ag-icon-font-display-cut, var(--ag-icon-font-display))}.ag-icon-cut:after{background-image:var(--ag-icon-image-cut, var(--ag-icon-image));display:var(--ag-icon-image-display-cut, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-cut, var(--ag-icon-image-opacity, .9))}.ag-icon-desc{font-family:var(--ag-icon-font-family-desc, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-desc, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-desc, var(--ag-icon-font-color))}.ag-icon-desc:before{content:var(--ag-icon-font-code-desc, "");display:var(--ag-icon-font-display-desc, var(--ag-icon-font-display))}.ag-icon-desc:after{background-image:var(--ag-icon-image-desc, var(--ag-icon-image));display:var(--ag-icon-image-display-desc, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-desc, var(--ag-icon-image-opacity, .9))}.ag-icon-excel{font-family:var(--ag-icon-font-family-excel, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-excel, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-excel, var(--ag-icon-font-color))}.ag-icon-excel:before{content:var(--ag-icon-font-code-excel, "");display:var(--ag-icon-font-display-excel, var(--ag-icon-font-display))}.ag-icon-excel:after{background-image:var(--ag-icon-image-excel, var(--ag-icon-image));display:var(--ag-icon-image-display-excel, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-excel, var(--ag-icon-image-opacity, .9))}.ag-icon-expanded{font-family:var(--ag-icon-font-family-expanded, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-expanded, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-expanded, var(--ag-icon-font-color))}.ag-icon-expanded:before{content:var(--ag-icon-font-code-expanded, "");display:var(--ag-icon-font-display-expanded, var(--ag-icon-font-display))}.ag-icon-expanded:after{background-image:var(--ag-icon-image-expanded, var(--ag-icon-image));display:var(--ag-icon-image-display-expanded, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-expanded, var(--ag-icon-image-opacity, .9))}.ag-icon-eye-slash{font-family:var(--ag-icon-font-family-eye-slash, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-eye-slash, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-eye-slash, var(--ag-icon-font-color))}.ag-icon-eye-slash:before{content:var(--ag-icon-font-code-eye-slash, "");display:var(--ag-icon-font-display-eye-slash, var(--ag-icon-font-display))}.ag-icon-eye-slash:after{background-image:var(--ag-icon-image-eye-slash, var(--ag-icon-image));display:var(--ag-icon-image-display-eye-slash, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-eye-slash, var(--ag-icon-image-opacity, .9))}.ag-icon-eye{font-family:var(--ag-icon-font-family-eye, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-eye, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-eye, var(--ag-icon-font-color))}.ag-icon-eye:before{content:var(--ag-icon-font-code-eye, "");display:var(--ag-icon-font-display-eye, var(--ag-icon-font-display))}.ag-icon-eye:after{background-image:var(--ag-icon-image-eye, var(--ag-icon-image));display:var(--ag-icon-image-display-eye, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-eye, var(--ag-icon-image-opacity, .9))}.ag-icon-filter{font-family:var(--ag-icon-font-family-filter, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-filter, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-filter, var(--ag-icon-font-color))}.ag-icon-filter:before{content:var(--ag-icon-font-code-filter, "");display:var(--ag-icon-font-display-filter, var(--ag-icon-font-display))}.ag-icon-filter:after{background-image:var(--ag-icon-image-filter, var(--ag-icon-image));display:var(--ag-icon-image-display-filter, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-filter, var(--ag-icon-image-opacity, .9))}.ag-icon-first{font-family:var(--ag-icon-font-family-first, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-first, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-first, var(--ag-icon-font-color))}.ag-icon-first:before{content:var(--ag-icon-font-code-first, "");display:var(--ag-icon-font-display-first, var(--ag-icon-font-display))}.ag-icon-first:after{background-image:var(--ag-icon-image-first, var(--ag-icon-image));display:var(--ag-icon-image-display-first, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-first, var(--ag-icon-image-opacity, .9))}.ag-icon-grip{font-family:var(--ag-icon-font-family-grip, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-grip, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-grip, var(--ag-icon-font-color))}.ag-icon-grip:before{content:var(--ag-icon-font-code-grip, "");display:var(--ag-icon-font-display-grip, var(--ag-icon-font-display))}.ag-icon-grip:after{background-image:var(--ag-icon-image-grip, var(--ag-icon-image));display:var(--ag-icon-image-display-grip, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-grip, var(--ag-icon-image-opacity, .9))}.ag-icon-group{font-family:var(--ag-icon-font-family-group, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-group, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-group, var(--ag-icon-font-color))}.ag-icon-group:before{content:var(--ag-icon-font-code-group, "");display:var(--ag-icon-font-display-group, var(--ag-icon-font-display))}.ag-icon-group:after{background-image:var(--ag-icon-image-group, var(--ag-icon-image));display:var(--ag-icon-image-display-group, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-group, var(--ag-icon-image-opacity, .9))}.ag-icon-last{font-family:var(--ag-icon-font-family-last, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-last, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-last, var(--ag-icon-font-color))}.ag-icon-last:before{content:var(--ag-icon-font-code-last, "");display:var(--ag-icon-font-display-last, var(--ag-icon-font-display))}.ag-icon-last:after{background-image:var(--ag-icon-image-last, var(--ag-icon-image));display:var(--ag-icon-image-display-last, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-last, var(--ag-icon-image-opacity, .9))}.ag-icon-left{font-family:var(--ag-icon-font-family-left, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-left, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-left, var(--ag-icon-font-color))}.ag-icon-left:before{content:var(--ag-icon-font-code-left, "");display:var(--ag-icon-font-display-left, var(--ag-icon-font-display))}.ag-icon-left:after{background-image:var(--ag-icon-image-left, var(--ag-icon-image));display:var(--ag-icon-image-display-left, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-left, var(--ag-icon-image-opacity, .9))}.ag-icon-linked{font-family:var(--ag-icon-font-family-linked, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-linked, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-linked, var(--ag-icon-font-color))}.ag-icon-linked:before{content:var(--ag-icon-font-code-linked, "");display:var(--ag-icon-font-display-linked, var(--ag-icon-font-display))}.ag-icon-linked:after{background-image:var(--ag-icon-image-linked, var(--ag-icon-image));display:var(--ag-icon-image-display-linked, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-linked, var(--ag-icon-image-opacity, .9))}.ag-icon-loading{font-family:var(--ag-icon-font-family-loading, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-loading, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-loading, var(--ag-icon-font-color))}.ag-icon-loading:before{content:var(--ag-icon-font-code-loading, "");display:var(--ag-icon-font-display-loading, var(--ag-icon-font-display))}.ag-icon-loading:after{background-image:var(--ag-icon-image-loading, var(--ag-icon-image));display:var(--ag-icon-image-display-loading, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-loading, var(--ag-icon-image-opacity, .9))}.ag-icon-maximize{font-family:var(--ag-icon-font-family-maximize, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-maximize, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-maximize, var(--ag-icon-font-color))}.ag-icon-maximize:before{content:var(--ag-icon-font-code-maximize, "");display:var(--ag-icon-font-display-maximize, var(--ag-icon-font-display))}.ag-icon-maximize:after{background-image:var(--ag-icon-image-maximize, var(--ag-icon-image));display:var(--ag-icon-image-display-maximize, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-maximize, var(--ag-icon-image-opacity, .9))}.ag-icon-menu{font-family:var(--ag-icon-font-family-menu, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-menu, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-menu, var(--ag-icon-font-color))}.ag-icon-menu:before{content:var(--ag-icon-font-code-menu, "");display:var(--ag-icon-font-display-menu, var(--ag-icon-font-display))}.ag-icon-menu:after{background-image:var(--ag-icon-image-menu, var(--ag-icon-image));display:var(--ag-icon-image-display-menu, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-menu, var(--ag-icon-image-opacity, .9))}.ag-icon-minimize{font-family:var(--ag-icon-font-family-minimize, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-minimize, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-minimize, var(--ag-icon-font-color))}.ag-icon-minimize:before{content:var(--ag-icon-font-code-minimize, "");display:var(--ag-icon-font-display-minimize, var(--ag-icon-font-display))}.ag-icon-minimize:after{background-image:var(--ag-icon-image-minimize, var(--ag-icon-image));display:var(--ag-icon-image-display-minimize, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-minimize, var(--ag-icon-image-opacity, .9))}.ag-icon-next{font-family:var(--ag-icon-font-family-next, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-next, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-next, var(--ag-icon-font-color))}.ag-icon-next:before{content:var(--ag-icon-font-code-next, "");display:var(--ag-icon-font-display-next, var(--ag-icon-font-display))}.ag-icon-next:after{background-image:var(--ag-icon-image-next, var(--ag-icon-image));display:var(--ag-icon-image-display-next, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-next, var(--ag-icon-image-opacity, .9))}.ag-icon-none{font-family:var(--ag-icon-font-family-none, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-none, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-none, var(--ag-icon-font-color))}.ag-icon-none:before{content:var(--ag-icon-font-code-none, "");display:var(--ag-icon-font-display-none, var(--ag-icon-font-display))}.ag-icon-none:after{background-image:var(--ag-icon-image-none, var(--ag-icon-image));display:var(--ag-icon-image-display-none, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-none, var(--ag-icon-image-opacity, .9))}.ag-icon-not-allowed{font-family:var(--ag-icon-font-family-not-allowed, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-not-allowed, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-not-allowed, var(--ag-icon-font-color))}.ag-icon-not-allowed:before{content:var(--ag-icon-font-code-not-allowed, "");display:var(--ag-icon-font-display-not-allowed, var(--ag-icon-font-display))}.ag-icon-not-allowed:after{background-image:var(--ag-icon-image-not-allowed, var(--ag-icon-image));display:var(--ag-icon-image-display-not-allowed, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-not-allowed, var(--ag-icon-image-opacity, .9))}.ag-icon-paste{font-family:var(--ag-icon-font-family-paste, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-paste, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-paste, var(--ag-icon-font-color))}.ag-icon-paste:before{content:var(--ag-icon-font-code-paste, "");display:var(--ag-icon-font-display-paste, var(--ag-icon-font-display))}.ag-icon-paste:after{background-image:var(--ag-icon-image-paste, var(--ag-icon-image));display:var(--ag-icon-image-display-paste, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-paste, var(--ag-icon-image-opacity, .9))}.ag-icon-pin{font-family:var(--ag-icon-font-family-pin, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-pin, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-pin, var(--ag-icon-font-color))}.ag-icon-pin:before{content:var(--ag-icon-font-code-pin, "");display:var(--ag-icon-font-display-pin, var(--ag-icon-font-display))}.ag-icon-pin:after{background-image:var(--ag-icon-image-pin, var(--ag-icon-image));display:var(--ag-icon-image-display-pin, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-pin, var(--ag-icon-image-opacity, .9))}.ag-icon-pivot{font-family:var(--ag-icon-font-family-pivot, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-pivot, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-pivot, var(--ag-icon-font-color))}.ag-icon-pivot:before{content:var(--ag-icon-font-code-pivot, "");display:var(--ag-icon-font-display-pivot, var(--ag-icon-font-display))}.ag-icon-pivot:after{background-image:var(--ag-icon-image-pivot, var(--ag-icon-image));display:var(--ag-icon-image-display-pivot, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-pivot, var(--ag-icon-image-opacity, .9))}.ag-icon-previous{font-family:var(--ag-icon-font-family-previous, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-previous, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-previous, var(--ag-icon-font-color))}.ag-icon-previous:before{content:var(--ag-icon-font-code-previous, "");display:var(--ag-icon-font-display-previous, var(--ag-icon-font-display))}.ag-icon-previous:after{background-image:var(--ag-icon-image-previous, var(--ag-icon-image));display:var(--ag-icon-image-display-previous, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-previous, var(--ag-icon-image-opacity, .9))}.ag-icon-radio-button-off{font-family:var(--ag-icon-font-family-radio-button-off, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-radio-button-off, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-radio-button-off, var(--ag-icon-font-color))}.ag-icon-radio-button-off:before{content:var(--ag-icon-font-code-radio-button-off, "");display:var(--ag-icon-font-display-radio-button-off, var(--ag-icon-font-display))}.ag-icon-radio-button-off:after{background-image:var(--ag-icon-image-radio-button-off, var(--ag-icon-image));display:var(--ag-icon-image-display-radio-button-off, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-radio-button-off, var(--ag-icon-image-opacity, .9))}.ag-icon-radio-button-on{font-family:var(--ag-icon-font-family-radio-button-on, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-radio-button-on, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-radio-button-on, var(--ag-icon-font-color))}.ag-icon-radio-button-on:before{content:var(--ag-icon-font-code-radio-button-on, "");display:var(--ag-icon-font-display-radio-button-on, var(--ag-icon-font-display))}.ag-icon-radio-button-on:after{background-image:var(--ag-icon-image-radio-button-on, var(--ag-icon-image));display:var(--ag-icon-image-display-radio-button-on, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-radio-button-on, var(--ag-icon-image-opacity, .9))}.ag-icon-right{font-family:var(--ag-icon-font-family-right, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-right, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-right, var(--ag-icon-font-color))}.ag-icon-right:before{content:var(--ag-icon-font-code-right, "");display:var(--ag-icon-font-display-right, var(--ag-icon-font-display))}.ag-icon-right:after{background-image:var(--ag-icon-image-right, var(--ag-icon-image));display:var(--ag-icon-image-display-right, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-right, var(--ag-icon-image-opacity, .9))}.ag-icon-save{font-family:var(--ag-icon-font-family-save, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-save, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-save, var(--ag-icon-font-color))}.ag-icon-save:before{content:var(--ag-icon-font-code-save, "");display:var(--ag-icon-font-display-save, var(--ag-icon-font-display))}.ag-icon-save:after{background-image:var(--ag-icon-image-save, var(--ag-icon-image));display:var(--ag-icon-image-display-save, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-save, var(--ag-icon-image-opacity, .9))}.ag-icon-small-down{font-family:var(--ag-icon-font-family-small-down, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-small-down, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-small-down, var(--ag-icon-font-color))}.ag-icon-small-down:before{content:var(--ag-icon-font-code-small-down, "");display:var(--ag-icon-font-display-small-down, var(--ag-icon-font-display))}.ag-icon-small-down:after{background-image:var(--ag-icon-image-small-down, var(--ag-icon-image));display:var(--ag-icon-image-display-small-down, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-small-down, var(--ag-icon-image-opacity, .9))}.ag-icon-small-left{font-family:var(--ag-icon-font-family-small-left, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-small-left, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-small-left, var(--ag-icon-font-color))}.ag-icon-small-left:before{content:var(--ag-icon-font-code-small-left, "");display:var(--ag-icon-font-display-small-left, var(--ag-icon-font-display))}.ag-icon-small-left:after{background-image:var(--ag-icon-image-small-left, var(--ag-icon-image));display:var(--ag-icon-image-display-small-left, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-small-left, var(--ag-icon-image-opacity, .9))}.ag-icon-small-right{font-family:var(--ag-icon-font-family-small-right, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-small-right, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-small-right, var(--ag-icon-font-color))}.ag-icon-small-right:before{content:var(--ag-icon-font-code-small-right, "");display:var(--ag-icon-font-display-small-right, var(--ag-icon-font-display))}.ag-icon-small-right:after{background-image:var(--ag-icon-image-small-right, var(--ag-icon-image));display:var(--ag-icon-image-display-small-right, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-small-right, var(--ag-icon-image-opacity, .9))}.ag-icon-small-up{font-family:var(--ag-icon-font-family-small-up, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-small-up, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-small-up, var(--ag-icon-font-color))}.ag-icon-small-up:before{content:var(--ag-icon-font-code-small-up, "");display:var(--ag-icon-font-display-small-up, var(--ag-icon-font-display))}.ag-icon-small-up:after{background-image:var(--ag-icon-image-small-up, var(--ag-icon-image));display:var(--ag-icon-image-display-small-up, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-small-up, var(--ag-icon-image-opacity, .9))}.ag-icon-tick{font-family:var(--ag-icon-font-family-tick, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-tick, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-tick, var(--ag-icon-font-color))}.ag-icon-tick:before{content:var(--ag-icon-font-code-tick, "");display:var(--ag-icon-font-display-tick, var(--ag-icon-font-display))}.ag-icon-tick:after{background-image:var(--ag-icon-image-tick, var(--ag-icon-image));display:var(--ag-icon-image-display-tick, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-tick, var(--ag-icon-image-opacity, .9))}.ag-icon-tree-closed{font-family:var(--ag-icon-font-family-tree-closed, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-tree-closed, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-tree-closed, var(--ag-icon-font-color))}.ag-icon-tree-closed:before{content:var(--ag-icon-font-code-tree-closed, "");display:var(--ag-icon-font-display-tree-closed, var(--ag-icon-font-display))}.ag-icon-tree-closed:after{background-image:var(--ag-icon-image-tree-closed, var(--ag-icon-image));display:var(--ag-icon-image-display-tree-closed, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-tree-closed, var(--ag-icon-image-opacity, .9))}.ag-icon-tree-indeterminate{font-family:var(--ag-icon-font-family-tree-indeterminate, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-tree-indeterminate, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-tree-indeterminate, var(--ag-icon-font-color))}.ag-icon-tree-indeterminate:before{content:var(--ag-icon-font-code-tree-indeterminate, "");display:var(--ag-icon-font-display-tree-indeterminate, var(--ag-icon-font-display))}.ag-icon-tree-indeterminate:after{background-image:var(--ag-icon-image-tree-indeterminate, var(--ag-icon-image));display:var(--ag-icon-image-display-tree-indeterminate, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-tree-indeterminate, var(--ag-icon-image-opacity, .9))}.ag-icon-tree-open{font-family:var(--ag-icon-font-family-tree-open, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-tree-open, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-tree-open, var(--ag-icon-font-color))}.ag-icon-tree-open:before{content:var(--ag-icon-font-code-tree-open, "");display:var(--ag-icon-font-display-tree-open, var(--ag-icon-font-display))}.ag-icon-tree-open:after{background-image:var(--ag-icon-image-tree-open, var(--ag-icon-image));display:var(--ag-icon-image-display-tree-open, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-tree-open, var(--ag-icon-image-opacity, .9))}.ag-icon-unlinked{font-family:var(--ag-icon-font-family-unlinked, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-unlinked, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-unlinked, var(--ag-icon-font-color))}.ag-icon-unlinked:before{content:var(--ag-icon-font-code-unlinked, "");display:var(--ag-icon-font-display-unlinked, var(--ag-icon-font-display))}.ag-icon-unlinked:after{background-image:var(--ag-icon-image-unlinked, var(--ag-icon-image));display:var(--ag-icon-image-display-unlinked, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-unlinked, var(--ag-icon-image-opacity, .9))}.ag-icon-up{font-family:var(--ag-icon-font-family-up, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-up, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-up, var(--ag-icon-font-color))}.ag-icon-up:before{content:var(--ag-icon-font-code-up, "");display:var(--ag-icon-font-display-up, var(--ag-icon-font-display))}.ag-icon-up:after{background-image:var(--ag-icon-image-up, var(--ag-icon-image));display:var(--ag-icon-image-display-up, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-up, var(--ag-icon-image-opacity, .9))}.ag-icon-down{font-family:var(--ag-icon-font-family-down, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-down, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-down, var(--ag-icon-font-color))}.ag-icon-down:before{content:var(--ag-icon-font-code-down, "");display:var(--ag-icon-font-display-down, var(--ag-icon-font-display))}.ag-icon-down:after{background-image:var(--ag-icon-image-down, var(--ag-icon-image));display:var(--ag-icon-image-display-down, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-down, var(--ag-icon-image-opacity, .9))}.ag-icon-plus{font-family:var(--ag-icon-font-family-plus, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-plus, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-plus, var(--ag-icon-font-color))}.ag-icon-plus:before{content:var(--ag-icon-font-code-plus, "");display:var(--ag-icon-font-display-plus, var(--ag-icon-font-display))}.ag-icon-plus:after{background-image:var(--ag-icon-image-plus, var(--ag-icon-image));display:var(--ag-icon-image-display-plus, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-plus, var(--ag-icon-image-opacity, .9))}.ag-icon-minus{font-family:var(--ag-icon-font-family-minus, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-minus, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-minus, var(--ag-icon-font-color))}.ag-icon-minus:before{content:var(--ag-icon-font-code-minus, "");display:var(--ag-icon-font-display-minus, var(--ag-icon-font-display))}.ag-icon-minus:after{background-image:var(--ag-icon-image-minus, var(--ag-icon-image));display:var(--ag-icon-image-display-minus, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-minus, var(--ag-icon-image-opacity, .9))}.ag-icon-menu-alt{font-family:var(--ag-icon-font-family-menu-alt, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-menu-alt, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-menu-alt, var(--ag-icon-font-color))}.ag-icon-menu-alt:before{content:var(--ag-icon-font-code-menu-alt, "");display:var(--ag-icon-font-display-menu-alt, var(--ag-icon-font-display))}.ag-icon-menu-alt:after{background-image:var(--ag-icon-image-menu-alt, var(--ag-icon-image));display:var(--ag-icon-image-display-menu-alt, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-menu-alt, var(--ag-icon-image-opacity, .9))}.ag-icon-settings{font-family:var(--ag-icon-font-family-settings, var(--ag-icon-font-family));font-weight:var(--ag-icon-font-weight-settings, var(--ag-icon-font-weight));color:var(--ag-icon-font-color-settings, var(--ag-icon-font-color))}.ag-icon-settings:before{content:var(--ag-icon-font-code-settings, "");display:var(--ag-icon-font-display-settings, var(--ag-icon-font-display))}.ag-icon-settings:after{background-image:var(--ag-icon-image-settings, var(--ag-icon-image));display:var(--ag-icon-image-display-settings, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-settings, var(--ag-icon-image-opacity, .9))}.ag-icon-row-drag:before{content:var(--ag-icon-font-code-grip)}.ag-left-arrow:before{content:var(--ag-icon-font-code-left)}.ag-right-arrow:before{content:var(--ag-icon-font-code-right)}[class*=ag-theme-]{--ag-foreground-color: #000;--ag-data-color: var(--ag-foreground-color);--ag-secondary-foreground-color: var(--ag-foreground-color);--ag-header-foreground-color: var(--ag-secondary-foreground-color);--ag-disabled-foreground-color: rgba(0, 0, 0, .5);--ag-background-color: #fff;--ag-header-background-color: transparent;--ag-tooltip-background-color: transparent;--ag-subheader-background-color: transparent;--ag-subheader-toolbar-background-color: transparent;--ag-control-panel-background-color: transparent;--ag-side-button-selected-background-color: var(--ag-control-panel-background-color);--ag-selected-row-background-color: #bbb;--ag-odd-row-background-color: var(--ag-background-color);--ag-modal-overlay-background-color: rgba(255, 255, 255, .66);--ag-menu-background-color: var(--ag-background-color);--ag-menu-border-color: var(--ag-border-color);--ag-panel-background-color: var(--ag-background-color);--ag-panel-border-color: var(--ag-border-color);--ag-row-hover-color: transparent;--ag-column-hover-color: transparent;--ag-range-selection-border-color: var(--ag-foreground-color);--ag-range-selection-border-style: solid;--ag-range-selection-background-color: rgba(0, 0, 0, .2);--ag-range-selection-background-color-2: var(--ag-range-selection-background-color);--ag-range-selection-background-color-3: var(--ag-range-selection-background-color);--ag-range-selection-background-color-4: var(--ag-range-selection-background-color);--ag-range-selection-highlight-color: var(--ag-range-selection-border-color);--ag-selected-tab-underline-color: var(--ag-range-selection-border-color);--ag-selected-tab-underline-width: 0;--ag-selected-tab-underline-transition-speed: 0s;--ag-range-selection-chart-category-background-color: rgba(0, 255, 132, .1);--ag-range-selection-chart-background-color: rgba(0, 88, 255, .1);--ag-header-cell-hover-background-color: transparent;--ag-header-cell-moving-background-color: var(--ag-background-color);--ag-value-change-value-highlight-background-color: rgba(22, 160, 133, .5);--ag-value-change-delta-up-color: #43a047;--ag-value-change-delta-down-color: #e53935;--ag-row-loading-skeleton-effect-color: rgba(66, 66, 66, .2);--ag-chip-background-color: transparent;--ag-chip-border-color: var(--ag-chip-background-color);--ag-borders: solid 1px;--ag-border-color: rgba(0, 0, 0, .25);--ag-borders-critical: var(--ag-borders);--ag-borders-secondary: var(--ag-borders);--ag-secondary-border-color: var(--ag-border-color);--ag-row-border-style: solid;--ag-row-border-width: 1px;--ag-cell-horizontal-border: solid transparent;--ag-borders-input: var(--ag-borders-secondary);--ag-input-border-color: var(--ag-secondary-border-color);--ag-borders-input-invalid: solid 2px;--ag-input-border-color-invalid: var(--ag-invalid-color);--ag-borders-side-button: var(--ag-borders);--ag-border-radius: 0px;--ag-wrapper-border-radius: var(--ag-border-radius);--ag-row-border-color: var(--ag-secondary-border-color);--ag-header-column-separator-display: none;--ag-header-column-separator-height: 100%;--ag-header-column-separator-width: 1px;--ag-header-column-separator-color: var(--ag-secondary-border-color);--ag-header-column-resize-handle-display: none;--ag-header-column-resize-handle-height: 50%;--ag-header-column-resize-handle-width: 1px;--ag-header-column-resize-handle-color: var(--ag-secondary-border-color);--ag-invalid-color: red;--ag-input-disabled-border-color: var(--ag-input-border-color);--ag-input-disabled-background-color: transparent;--ag-checkbox-background-color: transparent;--ag-checkbox-border-radius: var(--ag-border-radius);--ag-checkbox-checked-color: var(--ag-foreground-color);--ag-checkbox-unchecked-color: var(--ag-foreground-color);--ag-checkbox-indeterminate-color: var(--ag-checkbox-unchecked-color);--ag-toggle-button-off-border-color: var(--ag-checkbox-unchecked-color);--ag-toggle-button-off-background-color: var(--ag-checkbox-unchecked-color);--ag-toggle-button-on-border-color: var(--ag-checkbox-checked-color);--ag-toggle-button-on-background-color: var(--ag-checkbox-checked-color);--ag-toggle-button-switch-background-color: var(--ag-background-color);--ag-toggle-button-switch-border-color: var(--ag-toggle-button-off-border-color);--ag-toggle-button-border-width: 1px;--ag-toggle-button-height: var(--ag-icon-size);--ag-toggle-button-width: calc(var(--ag-toggle-button-height) * 2);--ag-input-focus-box-shadow: none;--ag-input-focus-border-color: none;--ag-minichart-selected-chart-color: var(--ag-checkbox-checked-color);--ag-minichart-selected-page-color: var(--ag-checkbox-checked-color);--ag-grid-size: 4px;--ag-icon-size: 12px;--ag-icon-font-weight: normal;--ag-icon-font-color: var(--ag-foreground-color);--ag-icon-image-display: block;--ag-widget-container-horizontal-padding: calc(var(--ag-grid-size) * 1.5);--ag-widget-container-vertical-padding: calc(var(--ag-grid-size) * 1.5);--ag-widget-horizontal-spacing: calc(var(--ag-grid-size) * 2);--ag-widget-vertical-spacing: var(--ag-grid-size);--ag-cell-horizontal-padding: calc(var(--ag-grid-size) * 3);--ag-cell-widget-spacing: var(--ag-cell-horizontal-padding);--ag-row-height: calc(var(--ag-grid-size) * 6 + 1px);--ag-header-height: var(--ag-row-height);--ag-list-item-height: calc(var(--ag-grid-size) * 5);--ag-column-select-indent-size: calc(var(--ag-grid-size) + var(--ag-icon-size));--ag-set-filter-indent-size: calc(var(--ag-grid-size) + var(--ag-icon-size));--ag-advanced-filter-builder-indent-size: calc(var(--ag-grid-size) * 2 + var(--ag-icon-size));--ag-row-group-indent-size: calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size));--ag-filter-tool-panel-group-indent: 16px;--ag-tab-min-width: 220px;--ag-chart-menu-panel-width: var(--ag-tab-min-width);--ag-menu-min-width: 181px;--ag-side-bar-panel-width: 200px;--ag-font-family: "Helvetica Neue", sans-serif;--ag-font-size: 14px;--ag-card-radius: var(--ag-border-radius);--ag-card-shadow: none;--ag-popup-shadow: 5px 5px 10px rgba(0, 0, 0, .3);--ag-advanced-filter-join-pill-color: #f08e8d;--ag-advanced-filter-column-pill-color: #a6e194;--ag-advanced-filter-option-pill-color: #f3c08b;--ag-advanced-filter-value-pill-color: #85c0e4}.ag-root-wrapper,.ag-sticky-top,.ag-sticky-bottom,.ag-dnd-ghost{background-color:var(--ag-background-color)}.ag-root-wrapper,.ag-popup{--ag-indentation-level: 0}[class*=ag-theme-]{-webkit-font-smoothing:antialiased;font-family:var(--ag-font-family);font-size:var(--ag-font-size);line-height:normal;color:var(--ag-foreground-color)}ag-grid,ag-grid-angular,ag-grid-ng2,ag-grid-polymer,ag-grid-aurelia{display:block}.ag-aria-description-container{z-index:9999;border:0px;clip:rect(1px,1px,1px,1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap}.ag-hidden{display:none!important}.ag-invisible{visibility:hidden!important}.ag-drag-handle{cursor:grab}.ag-column-drop-wrapper{display:flex}.ag-column-drop-horizontal-half-width{display:inline-block;width:50%!important}.ag-unselectable{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ag-selectable{-moz-user-select:text;-webkit-user-select:text;-ms-user-select:text;user-select:text}.ag-tab{position:relative}.ag-tab-guard{position:absolute;width:0;height:0;display:block}.ag-virtual-list-viewport .ag-tab-guard{position:sticky}.ag-tab-guard-top{top:1px}.ag-tab-guard-bottom{bottom:1px}.ag-select-agg-func-popup{position:absolute}.ag-input-wrapper,.ag-picker-field-wrapper{display:flex;flex:1 1 auto;align-items:center;line-height:normal;position:relative}.ag-shake-left-to-right{animation-direction:alternate;animation-duration:.2s;animation-iteration-count:infinite;animation-name:ag-shake-left-to-right}@keyframes ag-shake-left-to-right{0%{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}.ag-root-wrapper{cursor:default;position:relative;display:flex;flex-direction:column;overflow:hidden;white-space:normal}.ag-root-wrapper.ag-layout-normal{height:100%}.ag-watermark{position:absolute;bottom:20px;right:25px;opacity:.7;transition:opacity 1s ease-out 3s;color:#9b9b9b}.ag-watermark:before{content:"";background-image:url(data:image/svg+xml;base64,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);background-repeat:no-repeat;background-size:170px 40px;display:block;height:40px;width:170px}.ag-watermark-text{opacity:.5;font-weight:700;font-family:Impact,sans-serif;font-size:19px;padding-left:.7rem}.ag-root-wrapper-body{display:flex;flex-direction:row}.ag-root-wrapper-body.ag-layout-normal{flex:1 1 auto;height:0;min-height:0}.ag-root{position:relative;display:flex;flex-direction:column}.ag-root.ag-layout-normal,.ag-root.ag-layout-auto-height{overflow:hidden;flex:1 1 auto;width:0}.ag-root.ag-layout-normal{height:100%}.ag-header-viewport,.ag-floating-top-viewport,.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-body-horizontal-scroll-viewport,.ag-body-vertical-scroll-viewport,.ag-virtual-list-viewport,.ag-sticky-top-viewport,.ag-sticky-bottom-viewport{position:relative;height:100%;min-width:0px;overflow:hidden;flex:1 1 auto}.ag-body-viewport,.ag-center-cols-viewport{-ms-overflow-style:none!important;scrollbar-width:none!important}.ag-body-viewport::-webkit-scrollbar,.ag-center-cols-viewport::-webkit-scrollbar{display:none!important}.ag-body-viewport{display:flex}.ag-body-viewport.ag-layout-normal{overflow-y:auto;-webkit-overflow-scrolling:touch}.ag-center-cols-viewport{min-height:100%;width:100%;overflow-x:auto}.ag-body-horizontal-scroll-viewport{overflow-x:scroll}.ag-body-vertical-scroll-viewport{overflow-y:scroll}.ag-virtual-list-viewport{overflow:auto;width:100%}.ag-header-container,.ag-floating-top-container,.ag-body-container,.ag-pinned-right-cols-container,.ag-center-cols-container,.ag-pinned-left-cols-container,.ag-floating-bottom-container,.ag-body-horizontal-scroll-container,.ag-body-vertical-scroll-container,.ag-full-width-container,.ag-floating-bottom-full-width-container,.ag-virtual-list-container,.ag-sticky-top-container,.ag-sticky-bottom-container{position:relative}.ag-header-container,.ag-floating-top-container,.ag-floating-bottom-container,.ag-sticky-top-container,.ag-sticky-bottom-container{height:100%;white-space:nowrap}.ag-center-cols-container,.ag-pinned-right-cols-container{display:block}.ag-body-horizontal-scroll-container{height:100%}.ag-body-vertical-scroll-container{width:100%}.ag-full-width-container,.ag-floating-top-full-width-container,.ag-floating-bottom-full-width-container,.ag-sticky-top-full-width-container,.ag-sticky-bottom-full-width-container{position:absolute;top:0;pointer-events:none}.ag-ltr .ag-full-width-container,.ag-ltr .ag-floating-top-full-width-container,.ag-ltr .ag-floating-bottom-full-width-container,.ag-ltr .ag-sticky-top-full-width-container,.ag-ltr .ag-sticky-bottom-full-width-container{left:0}.ag-rtl .ag-full-width-container,.ag-rtl .ag-floating-top-full-width-container,.ag-rtl .ag-floating-bottom-full-width-container,.ag-rtl .ag-sticky-top-full-width-container,.ag-rtl .ag-sticky-bottom-full-width-container{right:0}.ag-full-width-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container{display:inline-block;overflow:hidden;height:100%;width:100%}.ag-virtual-list-container{overflow:hidden}.ag-body{position:relative;display:flex;flex:1 1 auto;flex-direction:row!important;min-height:0}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{min-height:0;min-width:0;display:flex;position:relative}.ag-body-horizontal-scroll.ag-scrollbar-invisible,.ag-body-vertical-scroll.ag-scrollbar-invisible{position:absolute;bottom:0}.ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar,.ag-body-vertical-scroll.ag-scrollbar-invisible.ag-apple-scrollbar{opacity:0;transition:opacity .4s;visibility:hidden}.ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-scrolling,.ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-active,.ag-body-vertical-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-scrolling,.ag-body-vertical-scroll.ag-scrollbar-invisible.ag-apple-scrollbar.ag-scrollbar-active{visibility:visible;opacity:1}.ag-body-horizontal-scroll{width:100%}.ag-body-horizontal-scroll.ag-scrollbar-invisible{left:0;right:0}.ag-body-vertical-scroll{height:100%}.ag-body-vertical-scroll.ag-scrollbar-invisible{top:0;z-index:10}.ag-ltr .ag-body-vertical-scroll.ag-scrollbar-invisible{right:0}.ag-rtl .ag-body-vertical-scroll.ag-scrollbar-invisible{left:0}.ag-force-vertical-scroll{overflow-y:scroll!important}.ag-horizontal-left-spacer,.ag-horizontal-right-spacer{height:100%;min-width:0;overflow-x:scroll}.ag-horizontal-left-spacer.ag-scroller-corner,.ag-horizontal-right-spacer.ag-scroller-corner{overflow-x:hidden}.ag-header,.ag-pinned-left-header,.ag-pinned-right-header{display:inline-block;overflow:hidden;position:relative}.ag-header-cell-sortable .ag-header-cell-label{cursor:pointer}.ag-header{display:flex;width:100%;white-space:nowrap}.ag-pinned-left-header,.ag-pinned-right-header{height:100%}.ag-header-row{position:absolute}.ag-header-row:not(.ag-header-row-column-group){overflow:hidden}.ag-header.ag-header-allow-overflow .ag-header-row{overflow:visible}.ag-header-cell{display:inline-flex;align-items:center;position:absolute;height:100%}.ag-header-cell.ag-header-active .ag-header-cell-menu-button,.ag-header-cell-filter-button{opacity:1}.ag-header-cell-menu-button:not(.ag-header-menu-always-show){transition:opacity .2s;opacity:0}.ag-header-group-cell-label,.ag-header-cell-label{display:flex;flex:1 1 auto;align-self:stretch;align-items:center}.ag-header-cell-label{overflow:hidden;text-overflow:ellipsis}.ag-header-group-cell-label.ag-sticky-label{position:sticky;flex:none;max-width:100%}.ag-header-group-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-header-cell-text{overflow:hidden;text-overflow:ellipsis;word-break:break-word}.ag-header-cell:not(.ag-header-cell-auto-height) .ag-header-cell-comp-wrapper{height:100%;display:flex;align-items:center}.ag-header-cell-comp-wrapper{width:100%}.ag-header-cell-wrap-text .ag-header-cell-comp-wrapper{white-space:normal}.ag-right-aligned-header .ag-header-cell-label{flex-direction:row-reverse}.ag-header-cell-resize{position:absolute;z-index:2;height:100%;width:8px;top:0;cursor:ew-resize}.ag-ltr .ag-header-cell-resize{right:-4px}.ag-rtl .ag-header-cell-resize{left:-4px}.ag-pinned-left-header .ag-header-cell-resize{right:-4px}.ag-pinned-right-header .ag-header-cell-resize{left:-4px}.ag-header-select-all{display:flex}.ag-header-cell-menu-button,.ag-header-cell-filter-button,.ag-side-button-button,.ag-panel-title-bar-button,.ag-floating-filter-button-button{cursor:pointer}.ag-column-moving .ag-cell,.ag-column-moving .ag-header-cell{transition:left .2s}.ag-column-moving .ag-header-group-cell{transition:left .2s,width .2s}.ag-column-panel{display:flex;flex-direction:column;overflow:hidden;flex:1 1 auto}.ag-column-select{position:relative;display:flex;flex-direction:column;overflow:hidden;flex:3 1 0px}.ag-column-select-header{position:relative;display:flex;flex:none}.ag-column-select-header-icon{position:relative}.ag-column-select-header-filter-wrapper{flex:1 1 auto}.ag-column-select-header-filter{width:100%}.ag-column-select-list{flex:1 1 0px;overflow:hidden}.ag-column-drop{position:relative;display:inline-flex;align-items:center;overflow:auto;width:100%}.ag-column-drop-list{display:flex;align-items:center}.ag-column-drop-cell{position:relative;display:flex;align-items:center}.ag-column-drop-cell-text{overflow:hidden;flex:1 1 auto;text-overflow:ellipsis;white-space:nowrap}.ag-column-drop-vertical{display:flex;flex-direction:column;overflow:hidden;align-items:stretch;flex:1 1 0px}.ag-column-drop-vertical-title-bar{display:flex;align-items:center;flex:none}.ag-column-drop-vertical-list{position:relative;align-items:stretch;flex-grow:1;flex-direction:column;overflow-x:auto}.ag-column-drop-vertical-list>*{flex:none}.ag-column-drop-empty .ag-column-drop-vertical-list{overflow:hidden}.ag-column-drop-vertical-empty-message{display:block}.ag-column-drop.ag-column-drop-horizontal{white-space:nowrap;overflow:hidden}.ag-column-drop-cell-button{cursor:pointer}.ag-filter-toolpanel{flex:1 1 0px;min-width:0}.ag-filter-toolpanel-header{position:relative}.ag-filter-toolpanel-header,.ag-filter-toolpanel-search{display:flex;align-items:center}.ag-filter-toolpanel-header>*,.ag-filter-toolpanel-search>*{display:flex;align-items:center}.ag-filter-apply-panel{display:flex;justify-content:flex-end;overflow:hidden}.ag-row-animation .ag-row{transition:transform .4s,top .4s,opacity .2s}.ag-row-animation .ag-row.ag-after-created{transition:transform .4s,top .4s,height .4s,opacity .2s}.ag-row-no-animation .ag-row{transition:none}.ag-row{white-space:nowrap;width:100%}.ag-row-loading{display:flex;align-items:center}.ag-row-position-absolute{position:absolute}.ag-row-position-relative{position:relative}.ag-full-width-row{overflow:hidden;pointer-events:all}.ag-row-inline-editing{z-index:1}.ag-row-dragging{z-index:2}.ag-stub-cell{display:flex;align-items:center}.ag-cell{display:inline-block;position:absolute;white-space:nowrap;height:100%}.ag-cell-value{flex:1 1 auto}.ag-cell-value,.ag-group-value{overflow:hidden;text-overflow:ellipsis}.ag-cell-wrap-text{white-space:normal;word-break:break-word}.ag-cell-wrapper{display:flex;align-items:center}.ag-cell-wrapper.ag-row-group{align-items:flex-start}.ag-sparkline-wrapper{position:absolute;height:100%;width:100%;left:0;top:0}.ag-full-width-row .ag-cell-wrapper.ag-row-group{height:100%;align-items:center}.ag-cell-inline-editing{z-index:1}.ag-cell-inline-editing .ag-cell-wrapper,.ag-cell-inline-editing .ag-cell-edit-wrapper,.ag-cell-inline-editing .ag-cell-editor,.ag-cell-inline-editing .ag-cell-editor .ag-wrapper,.ag-cell-inline-editing .ag-cell-editor input{height:100%;width:100%;line-height:normal}.ag-cell .ag-icon{display:inline-block;vertical-align:middle}.ag-set-filter-item{display:flex;align-items:center;height:100%}.ag-set-filter-item-checkbox{display:flex;width:100%;height:100%}.ag-set-filter-group-icons{display:block}.ag-set-filter-group-icons>*{cursor:pointer}.ag-filter-body-wrapper{display:flex;flex-direction:column}.ag-filter-filter{flex:1 1 0px}.ag-filter-condition{display:flex;justify-content:center}.ag-floating-filter-body{position:relative;display:flex;flex:1 1 auto;height:100%}.ag-floating-filter-full-body{display:flex;flex:1 1 auto;height:100%;width:100%;align-items:center;overflow:hidden}.ag-floating-filter-full-body>div{flex:1 1 auto}.ag-floating-filter-input{align-items:center;display:flex;width:100%}.ag-floating-filter-input>*{flex:1 1 auto}.ag-floating-filter-button{display:flex;flex:none}.ag-set-floating-filter-input input[disabled]{pointer-events:none}.ag-dnd-ghost{position:absolute;display:inline-flex;align-items:center;cursor:move;white-space:nowrap;z-index:9999}.ag-overlay{height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%;z-index:2}.ag-overlay-panel{display:flex;height:100%;width:100%}.ag-overlay-wrapper{display:flex;flex:none;width:100%;height:100%;align-items:center;justify-content:center;text-align:center}.ag-overlay-loading-wrapper{pointer-events:all}.ag-popup-child{z-index:5;top:0}.ag-popup-editor{position:absolute;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ag-large-text-input{display:block}.ag-virtual-list-item{position:absolute;width:100%}.ag-floating-top{overflow:hidden;white-space:nowrap;width:100%;position:relative;display:flex}.ag-pinned-left-floating-top,.ag-pinned-right-floating-top{display:inline-block;overflow:hidden;position:relative;min-width:0px}.ag-floating-bottom{overflow:hidden;white-space:nowrap;width:100%;position:relative;display:flex}.ag-pinned-left-floating-bottom,.ag-pinned-right-floating-bottom{display:inline-block;overflow:hidden;position:relative;min-width:0px}.ag-sticky-top,.ag-sticky-bottom{position:absolute;display:flex;width:100%}.ag-pinned-left-sticky-top,.ag-pinned-right-sticky-top{position:relative;height:100%;overflow:hidden}.ag-sticky-top-full-width-container,.ag-sticky-bottom-full-width-container{overflow:hidden;width:100%;height:100%}.ag-dialog,.ag-panel{display:flex;flex-direction:column;position:relative;overflow:hidden}.ag-panel-title-bar{display:flex;flex:none;align-items:center;cursor:default}.ag-panel-title-bar-title{flex:1 1 auto}.ag-panel-title-bar-buttons{display:flex}.ag-panel-title-bar-button{cursor:pointer}.ag-panel-content-wrapper{display:flex;flex:1 1 auto;position:relative;overflow:hidden}.ag-dialog{position:absolute}.ag-resizer{position:absolute;pointer-events:none;z-index:1;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ag-resizer.ag-resizer-topLeft{top:0;left:0;height:5px;width:5px;cursor:nwse-resize}.ag-resizer.ag-resizer-top{top:0;left:5px;right:5px;height:5px;cursor:ns-resize}.ag-resizer.ag-resizer-topRight{top:0;right:0;height:5px;width:5px;cursor:nesw-resize}.ag-resizer.ag-resizer-right{top:5px;right:0;bottom:5px;width:5px;cursor:ew-resize}.ag-resizer.ag-resizer-bottomRight{bottom:0;right:0;height:5px;width:5px;cursor:nwse-resize}.ag-resizer.ag-resizer-bottom{bottom:0;left:5px;right:5px;height:5px;cursor:ns-resize}.ag-resizer.ag-resizer-bottomLeft{bottom:0;left:0;height:5px;width:5px;cursor:nesw-resize}.ag-resizer.ag-resizer-left{left:0;top:5px;bottom:5px;width:5px;cursor:ew-resize}.ag-tooltip,.ag-tooltip-custom{position:absolute;z-index:99999}.ag-tooltip:not(.ag-tooltip-interactive),.ag-tooltip-custom:not(.ag-tooltip-interactive){pointer-events:none}.ag-value-slide-out{margin-right:5px;opacity:1;transition:opacity 3s,margin-right 3s;transition-timing-function:linear}.ag-value-slide-out-end{margin-right:10px;opacity:0}.ag-opacity-zero{opacity:0!important}.ag-menu{max-height:100%;overflow-y:auto;position:absolute;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ag-menu-column-select-wrapper{height:265px;overflow:auto}.ag-menu-column-select-wrapper .ag-column-select{height:100%}.ag-dialog .ag-panel-content-wrapper .ag-column-select{-webkit-user-select:none;user-select:none}.ag-menu-list{display:table;width:100%}.ag-menu-option,.ag-menu-separator{display:table-row}.ag-menu-option-part,.ag-menu-separator-part{display:table-cell;vertical-align:middle}.ag-menu-option-text{white-space:nowrap}.ag-menu-option-custom{display:contents}.ag-compact-menu-option{width:100%;display:flex;flex-wrap:nowrap}.ag-compact-menu-option-text{white-space:nowrap;flex:1 1 auto}.ag-pill-container{display:flex;gap:.25rem;flex-wrap:nowrap}.ag-pill{display:flex;white-space:nowrap;padding:0 .25rem;align-items:center}.ag-pill .ag-pill-button{border:none;padding:0}.ag-rich-select{cursor:default;outline:none;height:100%}.ag-rich-select-value{display:flex;align-items:center;height:100%}.ag-rich-select-value .ag-picker-field-display{overflow:hidden;text-overflow:ellipsis}.ag-rich-select-value .ag-picker-field-display.ag-display-as-placeholder{opacity:.5}.ag-rich-select-list{position:relative}.ag-rich-select-list .ag-loading-text{min-height:2rem}.ag-rich-select-row{display:flex;flex:1 1 auto;align-items:center;white-space:nowrap;overflow:hidden;height:100%}.ag-rich-select-field-input{flex:1 1 auto}.ag-rich-select-field-input .ag-input-field-input{padding:0!important;border:none!important;box-shadow:none!important;text-overflow:ellipsis}.ag-rich-select-field-input .ag-input-field-input::placeholder{opacity:.8}.ag-autocomplete{align-items:center;display:flex}.ag-autocomplete>*{flex:1 1 auto}.ag-autocomplete-list-popup{position:absolute;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ag-autocomplete-list{position:relative}.ag-autocomplete-virtual-list-item{display:flex}.ag-autocomplete-row{display:flex;flex:1 1 auto;align-items:center;overflow:hidden}.ag-autocomplete-row-label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ag-paging-panel{align-items:center;display:flex;justify-content:flex-end}.ag-paging-page-summary-panel{display:flex;align-items:center}.ag-paging-button{position:relative}.ag-disabled .ag-paging-page-summary-panel{pointer-events:none}.ag-tool-panel-wrapper{display:flex;overflow-y:auto;overflow-x:hidden;cursor:default;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ag-column-select-column,.ag-column-select-column-group,.ag-select-agg-func-item{position:relative;align-items:center;display:flex;flex-direction:row;flex-wrap:nowrap;height:100%}.ag-column-select-column>*,.ag-column-select-column-group>*,.ag-select-agg-func-item>*{flex:none}.ag-select-agg-func-item,.ag-column-select-column-label{flex:1 1 auto;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-column-select-checkbox{display:flex}.ag-tool-panel-horizontal-resize{cursor:ew-resize;height:100%;position:absolute;top:0;width:5px;z-index:1}.ag-ltr .ag-side-bar-left .ag-tool-panel-horizontal-resize{right:-3px}.ag-rtl .ag-side-bar-left .ag-tool-panel-horizontal-resize,.ag-ltr .ag-side-bar-right .ag-tool-panel-horizontal-resize{left:-3px}.ag-rtl .ag-side-bar-right .ag-tool-panel-horizontal-resize{right:-3px}.ag-details-row{width:100%}.ag-details-row-fixed-height{height:100%}.ag-details-grid{width:100%}.ag-details-grid-fixed-height{height:100%}.ag-header-group-cell{display:flex;align-items:center;height:100%;position:absolute}.ag-header-group-cell-no-group.ag-header-span-height .ag-header-cell-resize{display:none}.ag-cell-label-container{display:flex;justify-content:space-between;flex-direction:row-reverse;align-items:center;height:100%;width:100%;padding:5px 0}.ag-right-aligned-header .ag-cell-label-container{flex-direction:row}.ag-right-aligned-header .ag-header-cell-text{text-align:end}.ag-side-bar{display:flex;flex-direction:row-reverse}.ag-side-bar-left{order:-1;flex-direction:row}.ag-side-button-button{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;flex-wrap:nowrap;white-space:nowrap;outline:none;cursor:pointer}.ag-side-button-label{writing-mode:vertical-lr}.ag-status-bar{display:flex;justify-content:space-between;overflow:hidden}.ag-status-panel{display:inline-flex}.ag-status-name-value{white-space:nowrap}.ag-status-bar-left,.ag-status-bar-center,.ag-status-bar-right{display:inline-flex}.ag-icon{display:block;speak:none}.ag-group{position:relative;width:100%}.ag-group-title-bar{display:flex;align-items:center}.ag-group-title{display:inline;min-width:0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ag-group-title-bar .ag-group-title{cursor:default}.ag-group-toolbar{display:flex;align-items:center}.ag-group-container{display:flex}.ag-disabled .ag-group-container{pointer-events:none}.ag-group-container-horizontal{flex-direction:row;flex-wrap:wrap}.ag-group-container-vertical{flex-direction:column}.ag-column-group-icons{display:block}.ag-column-group-icons>*{cursor:pointer}.ag-group-item-alignment-stretch .ag-group-item{align-items:stretch}.ag-group-item-alignment-start .ag-group-item{align-items:flex-start}.ag-group-item-alignment-end .ag-group-item{align-items:flex-end}.ag-toggle-button-icon{transition:right .3s;position:absolute;top:-1px}.ag-input-field,.ag-select{display:flex;flex-direction:row;align-items:center}.ag-input-field-input{flex:1 1 auto}.ag-floating-filter-input .ag-input-field-input[type=date]{width:1px}.ag-range-field,.ag-angle-select{display:flex;align-items:center}.ag-angle-select-wrapper{display:flex}.ag-angle-select-parent-circle{display:block;position:relative}.ag-angle-select-child-circle{position:absolute}.ag-slider-wrapper{display:flex}.ag-slider-wrapper .ag-input-field,.ag-picker-field-display{flex:1 1 auto}.ag-picker-field{display:flex;align-items:center}.ag-picker-field-icon{display:flex;border:0;padding:0;margin:0;cursor:pointer}.ag-picker-field-wrapper{overflow:hidden}.ag-label-align-right .ag-label{order:1}.ag-label-align-right>*{flex:none}.ag-label-align-top{flex-direction:column;align-items:flex-start}.ag-label-align-top>*{align-self:stretch}.ag-label-ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1}.ag-color-panel{width:100%;display:flex;flex-direction:column;text-align:center}.ag-spectrum-color{flex:1 1 auto;position:relative;overflow:visible;cursor:default}.ag-spectrum-fill{position:absolute;top:0;left:0;right:0;bottom:0}.ag-spectrum-val{cursor:pointer}.ag-spectrum-dragger{position:absolute;pointer-events:none;cursor:pointer}.ag-spectrum-hue,.ag-spectrum-alpha{cursor:default}.ag-spectrum-hue-background{background:linear-gradient(to left,#ff0000 3%,#ffff00 17%,#00ff00 33%,#00ffff 50%,#0000ff 67%,#ff00ff 83%,#ff0000 100%);width:100%;height:100%}.ag-spectrum-alpha{--ag-spectrum-alpha-background-checked: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="4" height="4"><rect x="0" y="0" width="4" height="4" fill="%23fff"/><path d="M0 0H2V4H4V2H0Z" fill="%23b2b2b2"/></svg>')}.ag-spectrum-alpha-background{background:linear-gradient(to right,var(--ag-internal-spectrum-alpha-color-from),var(--ag-internal-spectrum-alpha-color-to)),var(--ag-spectrum-alpha-background-checked) top left/4px 4px;width:100%;height:100%}.ag-spectrum-tool{cursor:pointer;position:relative}.ag-spectrum-slider{position:absolute;pointer-events:none}.ag-spectrum-alpha .ag-spectrum-slider{background:linear-gradient(to bottom,var(--ag-internal-spectrum-alpha-color),var(--ag-internal-spectrum-alpha-color)) white}.ag-recent-colors{display:flex}.ag-recent-color{cursor:pointer}.ag-pill-select{display:flex;flex-direction:column}.ag-pill-select .ag-column-drop{flex:unset}.ag-ltr{direction:ltr}.ag-ltr .ag-body,.ag-ltr .ag-floating-top,.ag-ltr .ag-floating-bottom,.ag-ltr .ag-header,.ag-ltr .ag-sticky-top,.ag-ltr .ag-sticky-bottom,.ag-ltr .ag-body-viewport,.ag-ltr .ag-body-horizontal-scroll{flex-direction:row}.ag-rtl{direction:rtl}.ag-rtl .ag-body,.ag-rtl .ag-floating-top,.ag-rtl .ag-floating-bottom,.ag-rtl .ag-header,.ag-rtl .ag-sticky-top,.ag-rtl .ag-sticky-bottom,.ag-rtl .ag-body-viewport,.ag-rtl .ag-body-horizontal-scroll{flex-direction:row-reverse}.ag-rtl .ag-icon-contracted,.ag-rtl .ag-icon-expanded,.ag-rtl .ag-icon-tree-closed{display:block;transform:rotate(180deg)}.ag-body .ag-body-viewport{-webkit-overflow-scrolling:touch}.ag-measurement-container{width:0;overflow:hidden;visibility:hidden}.ag-measurement-container div{position:absolute}.ag-layout-print.ag-body{display:block;height:unset}.ag-layout-print.ag-root-wrapper{display:inline-block}.ag-layout-print .ag-body-vertical-scroll,.ag-layout-print .ag-body-horizontal-scroll{display:none}.ag-layout-print.ag-force-vertical-scroll{overflow-y:visible!important}@media print{.ag-root-wrapper.ag-layout-print{display:table}.ag-root-wrapper.ag-layout-print .ag-root-wrapper-body,.ag-root-wrapper.ag-layout-print .ag-root,.ag-root-wrapper.ag-layout-print .ag-body-viewport,.ag-root-wrapper.ag-layout-print .ag-center-cols-container,.ag-root-wrapper.ag-layout-print .ag-center-cols-viewport,.ag-root-wrapper.ag-layout-print .ag-body-horizontal-scroll-viewport,.ag-root-wrapper.ag-layout-print .ag-virtual-list-viewport{height:auto!important;overflow:hidden!important;display:block!important}.ag-root-wrapper.ag-layout-print .ag-row,.ag-root-wrapper.ag-layout-print .ag-cell{break-inside:avoid}}[class^=ag-],[class^=ag-]:focus,[class^=ag-]:after,[class^=ag-]:before{box-sizing:border-box;outline:none}[class^=ag-]::-ms-clear{display:none}.ag-checkbox .ag-input-wrapper,.ag-radio-button .ag-input-wrapper{overflow:visible}.ag-range-field .ag-input-wrapper{height:100%}.ag-toggle-button{flex:none;width:unset;min-width:unset}.ag-button{border-radius:0;color:var(--ag-foreground-color)}.ag-button:hover{background-color:transparent}.ag-ltr .ag-label-align-right .ag-label{margin-left:var(--ag-grid-size)}.ag-rtl .ag-label-align-right .ag-label{margin-right:var(--ag-grid-size)}input[class^=ag-]{margin:0;background-color:var(--ag-background-color)}textarea[class^=ag-],select[class^=ag-]{background-color:var(--ag-background-color)}input[class^=ag-]:not([type]),input[class^=ag-][type=text],input[class^=ag-][type=number],input[class^=ag-][type=tel],input[class^=ag-][type=date],input[class^=ag-][type=datetime-local],textarea[class^=ag-]{font-size:inherit;line-height:inherit;color:inherit;font-family:inherit;border:var(--ag-borders-input) var(--ag-input-border-color)}input[class^=ag-]:not([type]):disabled,input[class^=ag-][type=text]:disabled,input[class^=ag-][type=number]:disabled,input[class^=ag-][type=tel]:disabled,input[class^=ag-][type=date]:disabled,input[class^=ag-][type=datetime-local]:disabled,textarea[class^=ag-]:disabled{color:var(--ag-disabled-foreground-color);background-color:var(--ag-input-disabled-background-color);border-color:var(--ag-input-disabled-border-color)}input[class^=ag-]:not([type]):focus,input[class^=ag-][type=text]:focus,input[class^=ag-][type=number]:focus,input[class^=ag-][type=tel]:focus,input[class^=ag-][type=date]:focus,input[class^=ag-][type=datetime-local]:focus,textarea[class^=ag-]:focus{outline:none;box-shadow:var(--ag-input-focus-box-shadow);border-color:var(--ag-input-focus-border-color)}input[class^=ag-]:not([type]):invalid,input[class^=ag-][type=text]:invalid,input[class^=ag-][type=number]:invalid,input[class^=ag-][type=tel]:invalid,input[class^=ag-][type=date]:invalid,input[class^=ag-][type=datetime-local]:invalid,textarea[class^=ag-]:invalid{border:var(--ag-borders-input-invalid) var(--ag-input-border-color-invalid)}input[class^=ag-][type=number]:not(.ag-number-field-input-stepper){-moz-appearance:textfield}input[class^=ag-][type=number]:not(.ag-number-field-input-stepper)::-webkit-outer-spin-button,input[class^=ag-][type=number]:not(.ag-number-field-input-stepper)::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}input[class^=ag-][type=range]{padding:0}input[class^=ag-][type=button]:focus,button[class^=ag-]:focus{box-shadow:var(--ag-input-focus-box-shadow)}.ag-drag-handle{color:var(--ag-secondary-foreground-color)}.ag-list-item,.ag-virtual-list-item{height:var(--ag-list-item-height)}.ag-virtual-list-item:focus-visible{outline:none}.ag-virtual-list-item:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-select-list{background-color:var(--ag-background-color);overflow-y:auto;overflow-x:hidden;border-radius:var(--ag-border-radius);border:var(--ag-borders) var(--ag-border-color)}.ag-list-item{display:flex;align-items:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ag-list-item.ag-active-item{background-color:var(--ag-row-hover-color)}.ag-select-list-item{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.ag-ltr .ag-select-list-item{padding-left:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-rtl .ag-select-list-item{padding-right:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-select-list-item span{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.ag-row-drag,.ag-selection-checkbox,.ag-group-expanded,.ag-group-contracted{color:var(--ag-secondary-foreground-color)}.ag-ltr .ag-row-drag,.ag-ltr .ag-selection-checkbox,.ag-ltr .ag-group-expanded,.ag-ltr .ag-group-contracted{margin-right:var(--ag-cell-widget-spacing)}.ag-rtl .ag-row-drag,.ag-rtl .ag-selection-checkbox,.ag-rtl .ag-group-expanded,.ag-rtl .ag-group-contracted{margin-left:var(--ag-cell-widget-spacing)}.ag-cell-wrapper>*:not(.ag-cell-value):not(.ag-group-value){--ag-internal-calculated-line-height: var( --ag-line-height, calc(var(--ag-row-height) - var(--ag-row-border-width)) );--ag-internal-padded-row-height: calc(var(--ag-row-height) - var(--ag-row-border-width));height:min(var(--ag-internal-calculated-line-height),var(--ag-internal-padded-row-height));display:flex;align-items:center;flex:none}.ag-group-expanded,.ag-group-contracted{cursor:pointer}.ag-group-title-bar-icon{cursor:pointer;flex:none;color:var(--ag-secondary-foreground-color)}.ag-ltr .ag-group-child-count{margin-left:2px}.ag-rtl .ag-group-child-count{margin-right:2px}.ag-group-title-bar{background-color:var(--ag-subheader-background-color);padding:var(--ag-grid-size)}.ag-group-toolbar{padding:var(--ag-grid-size);background-color:var(--ag-subheader-toolbar-background-color)}.ag-disabled-group-title-bar,.ag-disabled-group-container{opacity:.5}.group-item{margin:calc(var(--ag-grid-size) * .5) 0}.ag-label{white-space:nowrap}.ag-ltr .ag-label{margin-right:var(--ag-grid-size)}.ag-rtl .ag-label{margin-left:var(--ag-grid-size)}.ag-label-align-top .ag-label{margin-bottom:calc(var(--ag-grid-size) * .5)}.ag-angle-select[disabled]{color:var(--ag-disabled-foreground-color);pointer-events:none}.ag-angle-select[disabled] .ag-angle-select-field{opacity:.4}.ag-ltr .ag-slider-field,.ag-ltr .ag-angle-select-field{margin-right:calc(var(--ag-grid-size) * 2)}.ag-rtl .ag-slider-field,.ag-rtl .ag-angle-select-field{margin-left:calc(var(--ag-grid-size) * 2)}.ag-angle-select-parent-circle{width:24px;height:24px;border-radius:12px;border:solid 1px;border-color:var(--ag-border-color);background-color:var(--ag-background-color)}.ag-angle-select-child-circle{top:4px;left:12px;width:6px;height:6px;margin-left:-3px;margin-top:-4px;border-radius:3px;background-color:var(--ag-secondary-foreground-color)}.ag-picker-field-wrapper{border:var(--ag-borders);border-color:var(--ag-border-color);border-radius:5px;background-color:var(--ag-background-color)}.ag-picker-field-wrapper:disabled{color:var(--ag-disabled-foreground-color);background-color:var(--ag-input-disabled-background-color);border-color:var(--ag-input-disabled-border-color)}.ag-picker-field-wrapper.ag-picker-has-focus,.ag-picker-field-wrapper:focus-within{outline:none;box-shadow:var(--ag-input-focus-box-shadow);border-color:var(--ag-input-focus-border-color)}.ag-picker-field-button{background-color:var(--ag-background-color);color:var(--ag-secondary-foreground-color)}.ag-dialog.ag-color-dialog{border-radius:5px}.ag-color-picker .ag-picker-field-wrapper{padding-left:var(--ag-grid-size);padding-right:var(--ag-grid-size)}.ag-color-picker .ag-picker-field-display{display:flex;flex-direction:row;align-items:center;min-height:var(--ag-list-item-height)}.ag-ltr .ag-color-picker-color,.ag-ltr .ag-color-picker-value{margin-right:var(--ag-grid-size)}.ag-rtl .ag-color-picker-color,.ag-rtl .ag-color-picker-value{margin-left:var(--ag-grid-size)}.ag-color-panel{padding:var(--ag-grid-size)}.ag-spectrum-color{background-color:red;border-radius:2px}.ag-spectrum-tools{padding:10px}.ag-spectrum-sat{background-image:linear-gradient(to right,white,rgba(204,154,129,0))}.ag-spectrum-val{background-image:linear-gradient(to top,black,rgba(204,154,129,0))}.ag-spectrum-dragger{border-radius:12px;height:12px;width:12px;border:2px solid white;background:black;box-shadow:0 0 2px #0000003d}.ag-spectrum-hue-background,.ag-spectrum-alpha-background{border-radius:2px}.ag-spectrum-tool{margin-bottom:10px;height:11px;border-radius:2px}.ag-spectrum-slider{margin-top:-12px;width:13px;height:13px;border-radius:13px;border:2px solid white;box-shadow:0 1px 4px #0000005e}.ag-recent-colors{margin-top:10px}.ag-recent-color{margin:0 3px}.ag-recent-color:first-child{margin-left:0}.ag-recent-color:last-child{margin-right:0}.ag-spectrum-color:focus-visible:not(:disabled):not([readonly]),.ag-spectrum-slider:focus-visible:not(:disabled):not([readonly]),.ag-recent-color:focus-visible:not(:disabled):not([readonly]){box-shadow:var(--ag-input-focus-box-shadow)}.ag-ltr .ag-color-input input[class^=ag-][type=text].ag-input-field-input{padding-left:calc(var(--ag-icon-size) + var(--ag-grid-size) * 2)}.ag-rtl .ag-color-input input[class^=ag-][type=text].ag-input-field-input{padding-right:calc(var(--ag-icon-size) + var(--ag-grid-size) * 2)}.ag-color-input .ag-color-input-color{position:absolute}.ag-ltr .ag-color-input .ag-color-input-color{margin-left:var(--ag-grid-size)}.ag-rtl .ag-color-input .ag-color-input-color{margin-right:var(--ag-grid-size)}.ag-color-picker-color,.ag-color-input-color{width:var(--ag-icon-size);height:var(--ag-icon-size);border:var(--ag-borders-secondary) var(--ag-secondary-border-color);border-radius:2px}.ag-dnd-ghost{border:var(--ag-borders) var(--ag-border-color);background:var(--ag-background-color);border-radius:var(--ag-card-radius);box-shadow:var(--ag-card-shadow);padding:var(--ag-grid-size);overflow:hidden;text-overflow:ellipsis;border:var(--ag-borders-secondary) var(--ag-secondary-border-color);color:var(--ag-secondary-foreground-color);height:var(--ag-header-height)!important;line-height:var(--ag-header-height);margin:0;padding:0 calc(var(--ag-grid-size) * 2);transform:translateY(calc(var(--ag-grid-size) * 2))}.ag-dnd-ghost-icon{margin-right:var(--ag-grid-size);color:var(--ag-foreground-color)}.ag-popup-child:not(.ag-tooltip-custom){box-shadow:var(--ag-popup-shadow)}.ag-select .ag-picker-field-wrapper{min-height:var(--ag-list-item-height);cursor:default}.ag-ltr .ag-select .ag-picker-field-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-rtl .ag-select .ag-picker-field-wrapper{padding-right:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-ltr .ag-select .ag-picker-field-wrapper{padding-right:var(--ag-grid-size)}.ag-rtl .ag-select .ag-picker-field-wrapper{padding-left:var(--ag-grid-size)}.ag-select.ag-disabled .ag-picker-field-wrapper:focus{box-shadow:none}.ag-select:not(.ag-cell-editor,.ag-label-align-top){min-height:var(--ag-list-item-height)}.ag-select .ag-picker-field-display{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ag-select .ag-picker-field-icon{display:flex;align-items:center}.ag-select.ag-disabled{opacity:.5}.ag-rich-select-value,.ag-rich-select-list{background-color:var(--ag-background-color)}.ag-rich-select-list{width:100%;height:auto;border-radius:var(--ag-border-radius);border:var(--ag-borders) var(--ag-border-color)}.ag-rich-select-list .ag-loading-text{padding:var(--ag-widget-vertical-spacing) var(--ag-widget-horizontal-spacing)}.ag-rich-select-value{border-bottom:var(--ag-borders-secondary) var(--ag-secondary-border-color);padding-top:0;padding-bottom:0}.ag-ltr .ag-rich-select-value{padding-left:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-rtl .ag-rich-select-value{padding-right:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-ltr .ag-rich-select-value{padding-right:var(--ag-grid-size)}.ag-rtl .ag-rich-select-value{padding-left:var(--ag-grid-size)}.ag-ltr .ag-rich-select-field-input{left:calc(var(--ag-cell-horizontal-padding))}.ag-rtl .ag-rich-select-field-input{right:calc(var(--ag-cell-horizontal-padding))}.ag-popup-editor .ag-rich-select-value{height:var(--ag-row-height);min-width:200px}.ag-rich-select-virtual-list-item{cursor:default;height:var(--ag-list-item-height)}.ag-rich-select-virtual-list-item:focus-visible:after{content:none}.ag-ltr .ag-rich-select-row{padding-left:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-rtl .ag-rich-select-row{padding-right:calc(var(--ag-cell-horizontal-padding) / 2)}.ag-rich-select-row-selected{background-color:var(--ag-selected-row-background-color)}.ag-rich-select-row:hover,.ag-rich-select-row-highlighted{background-image:linear-gradient(var(--ag-row-hover-color),var(--ag-row-hover-color))}.ag-rich-select-row-text-highlight{font-weight:700}.ag-autocomplete{width:100%}.ag-autocomplete-list{width:100%;min-width:200px;height:calc(var(--ag-row-height) * 6.5)}.ag-autocomplete-virtual-list-item{cursor:default;height:var(--ag-list-item-height)}.ag-autocomplete-virtual-list-item:focus-visible:after{content:none}.ag-autocomplete-virtual-list-item:hover{background-color:var(--ag-row-hover-color)}.ag-autocomplete-row-label{margin:0px var(--ag-widget-container-horizontal-padding)}.ag-autocomplete-row-selected{background-color:var(--ag-selected-row-background-color)}.ag-pill{border:1px solid var(--ag-chip-border-color);border-radius:var(--ag-border-radius);background-color:var(--ag-chip-background-color)}.ag-ltr .ag-pill .ag-pill-button{margin-left:var(--ag-grid-size)}.ag-rtl .ag-pill .ag-pill-button{margin-right:var(--ag-grid-size)}.ag-pill:focus-visible{border-color:var(--ag-input-focus-border-color)}.ag-pill .ag-pill-button:hover{color:var(--ag-active-color);cursor:pointer}.ag-dragging-range-handle .ag-dialog,.ag-dragging-fill-handle .ag-dialog{opacity:.7;pointer-events:none}.ag-dialog{border-radius:var(--ag-border-radius);border:var(--ag-borders) var(--ag-border-color);box-shadow:var(--ag-popup-shadow)}.ag-panel{background-color:var(--ag-panel-background-color);border-color:var(--ag-panel-border-color)}.ag-panel-title-bar{color:var(--ag-header-foreground-color);height:var(--ag-header-height);padding:var(--ag-grid-size) var(--ag-cell-horizontal-padding);border-bottom:var(--ag-borders) var(--ag-border-color)}.ag-ltr .ag-panel-title-bar-button{margin-left:var(--ag-grid-size)}.ag-rtl .ag-panel-title-bar-button{margin-right:var(--ag-grid-size)}.ag-tooltip{background-color:var(--ag-tooltip-background-color);color:var(--ag-foreground-color);padding:var(--ag-grid-size);border:var(--ag-borders) var(--ag-border-color);border-radius:var(--ag-card-radius);white-space:normal}.ag-tooltip.ag-tooltip-animate,.ag-tooltip-custom.ag-tooltip-animate{transition:opacity 1s}.ag-tooltip.ag-tooltip-animate.ag-tooltip-hiding,.ag-tooltip-custom.ag-tooltip-animate.ag-tooltip-hiding{opacity:0}.ag-ltr .ag-column-select-column,.ag-ltr .ag-column-select-column-group{padding-left:calc(var(--ag-indentation-level) * var(--ag-column-select-indent-size))}.ag-rtl .ag-column-select-column,.ag-rtl .ag-column-select-column-group{padding-right:calc(var(--ag-indentation-level) * var(--ag-column-select-indent-size))}.ag-column-select-header-icon{cursor:pointer}.ag-column-select-header-icon:focus-visible{outline:none}.ag-column-select-header-icon:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:0;left:0;display:block;width:calc(100% + -0px);height:calc(100% + -0px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-ltr .ag-column-group-icons:not(:last-child),.ag-ltr .ag-column-select-header-icon:not(:last-child),.ag-ltr .ag-column-select-header-checkbox:not(:last-child),.ag-ltr .ag-column-select-header-filter-wrapper:not(:last-child),.ag-ltr .ag-column-select-checkbox:not(:last-child),.ag-ltr .ag-column-select-column-drag-handle:not(:last-child),.ag-ltr .ag-column-select-column-group-drag-handle:not(:last-child),.ag-ltr .ag-column-select-column-label:not(:last-child){margin-right:var(--ag-widget-horizontal-spacing)}.ag-rtl .ag-column-group-icons:not(:last-child),.ag-rtl .ag-column-select-header-icon:not(:last-child),.ag-rtl .ag-column-select-header-checkbox:not(:last-child),.ag-rtl .ag-column-select-header-filter-wrapper:not(:last-child),.ag-rtl .ag-column-select-checkbox:not(:last-child),.ag-rtl .ag-column-select-column-drag-handle:not(:last-child),.ag-rtl .ag-column-select-column-group-drag-handle:not(:last-child),.ag-rtl .ag-column-select-column-label:not(:last-child){margin-left:var(--ag-widget-horizontal-spacing)}.ag-column-select-virtual-list-item:focus-visible{outline:none}.ag-column-select-virtual-list-item:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:1px;left:1px;display:block;width:calc(100% - 2px);height:calc(100% - 2px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-column-select-column-group:not(:last-child),.ag-column-select-column:not(:last-child){margin-bottom:var(--ag-widget-vertical-spacing)}.ag-column-select-column-readonly,.ag-column-select-column-group-readonly{color:var(--ag-disabled-foreground-color);pointer-events:none}.ag-ltr .ag-column-select-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-grid-size) * 2)}.ag-rtl .ag-column-select-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-grid-size) * 2)}.ag-column-select-virtual-list-viewport{padding:calc(var(--ag-widget-container-vertical-padding) * .5) 0px}.ag-column-select-virtual-list-item{padding:0 var(--ag-widget-container-horizontal-padding)}.ag-checkbox-edit{padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding)}.ag-pill-select .ag-column-drop{border-bottom:0;min-height:unset}.ag-pill-select .ag-column-drop-list{padding:0}.ag-pill-select .ag-select{padding-top:var(--ag-grid-size)}.ag-pill-select .ag-picker-field-wrapper{background-color:transparent;border:0}.ag-pill-select .ag-picker-field-display{cursor:pointer}.ag-rtl{text-align:right}.ag-root-wrapper{border-radius:var(--ag-wrapper-border-radius);border:var(--ag-borders) var(--ag-border-color)}.ag-row>.ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size) * var(--ag-indentation-level))}.ag-cell-wrapper.ag-row-group,.ag-cell-wrapper.ag-row-group-leaf-indent,.ag-cell-wrapper.ag-pivot-leaf-group{padding-left:calc(var(--ag-indentation-level) * var(--ag-row-group-indent-size))}.ag-pivot-leaf-group{margin-left:min(var(--ag-row-group-indent-size),var(--ag-row-group-indent-size) * var(--ag-indentation-level))}.ag-ltr .ag-row-group-leaf-indent{margin-left:var(--ag-row-group-indent-size)}.ag-rtl .ag-row-group-leaf-indent{margin-right:var(--ag-row-group-indent-size)}.ag-value-change-delta{padding-right:2px}.ag-value-change-delta-up{color:var(--ag-value-change-delta-up-color)}.ag-value-change-delta-down{color:var(--ag-value-change-delta-down-color)}.ag-value-change-value{background-color:transparent;border-radius:1px;padding-left:1px;padding-right:1px;transition:background-color 1s}.ag-value-change-value-highlight{background-color:var(--ag-value-change-value-highlight-background-color);transition:background-color .1s}.ag-cell-data-changed{background-color:var(--ag-value-change-value-highlight-background-color)!important}.ag-cell-data-changed-animation{background-color:transparent}.ag-cell-highlight{background-color:var(--ag-range-selection-highlight-color)!important}.ag-row{height:var(--ag-row-height);background-color:var(--ag-background-color);color:var(--ag-data-color);border-bottom:var(--ag-row-border-style) var(--ag-row-border-color) var(--ag-row-border-width)}.ag-sticky-bottom:after{content:"";position:absolute;top:0;left:0;width:100%;height:1px;border-top:var(--ag-row-border-style) var(--ag-row-border-color) var(--ag-row-border-width)}.ag-row-highlight-above:after,.ag-row-highlight-below:after{content:"";position:absolute;width:calc(100% - 1px);height:1px;background-color:var(--ag-range-selection-border-color);left:1px}.ag-row-highlight-above:after{top:-1px}.ag-row-highlight-above.ag-row-first:after{top:0}.ag-row-highlight-below:after{bottom:0}.ag-row-odd{background-color:var(--ag-odd-row-background-color)}.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-left-spacer:not(.ag-scroller-corner){border-right:var(--ag-borders-critical) var(--ag-border-color)}.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-right-spacer:not(.ag-scroller-corner){border-left:var(--ag-borders-critical) var(--ag-border-color)}.ag-row-selected:before{content:"";background-color:var(--ag-selected-row-background-color);display:block;position:absolute;top:0;left:0;right:0;bottom:0}.ag-row-hover:not(.ag-full-width-row):before,.ag-row-hover.ag-full-width-row.ag-row-group:before{content:"";background-color:var(--ag-row-hover-color);display:block;position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none}.ag-row-hover.ag-full-width-row.ag-row-group>*{position:relative}.ag-row-hover.ag-row-selected:before{background-color:var(--ag-row-hover-color);background-image:linear-gradient(var(--ag-selected-row-background-color),var(--ag-selected-row-background-color))}.ag-column-hover{background-color:var(--ag-column-hover-color)}.ag-ltr .ag-right-aligned-cell{text-align:right}.ag-rtl .ag-right-aligned-cell{text-align:left}.ag-ltr .ag-right-aligned-cell .ag-cell-value,.ag-ltr .ag-right-aligned-cell .ag-group-value{margin-left:auto}.ag-rtl .ag-right-aligned-cell .ag-cell-value,.ag-rtl .ag-right-aligned-cell .ag-group-value{margin-right:auto}.ag-ltr .ag-right-aligned-cell .ag-skeleton-effect{margin-left:auto}.ag-rtl .ag-right-aligned-cell .ag-skeleton-effect{margin-right:auto}.ag-cell,.ag-full-width-row .ag-cell-wrapper.ag-row-group{--ag-internal-calculated-line-height: var( --ag-line-height, calc(var(--ag-row-height) - var(--ag-row-border-width)) );--ag-internal-padded-row-height: calc(var(--ag-row-height) - var(--ag-row-border-width));border:1px solid transparent;line-height:min(var(--ag-internal-calculated-line-height),var(--ag-internal-padded-row-height));padding-left:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size) * var(--ag-indentation-level));padding-right:calc(var(--ag-cell-horizontal-padding) - 1px);-webkit-font-smoothing:subpixel-antialiased}.ag-row>.ag-cell-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}.ag-row-dragging{cursor:move;opacity:.5}.ag-cell-inline-editing{border:1px solid var(--ag-border-color);border-radius:var(--ag-card-radius);box-shadow:var(--ag-card-shadow);padding:0;background-color:var(--ag-control-panel-background-color)}.ag-popup-editor .ag-large-text,.ag-autocomplete-list-popup{border:var(--ag-borders) var(--ag-border-color);background:var(--ag-background-color);border-radius:var(--ag-card-radius);box-shadow:var(--ag-card-shadow);padding:var(--ag-grid-size);background-color:var(--ag-control-panel-background-color);padding:0}.ag-large-text-input{height:auto;padding:var(--ag-cell-horizontal-padding)}.ag-rtl .ag-large-text-input textarea{resize:none}.ag-details-row{padding:calc(var(--ag-grid-size) * 5);background-color:var(--ag-background-color)}.ag-layout-auto-height .ag-center-cols-viewport,.ag-layout-auto-height .ag-center-cols-container,.ag-layout-print .ag-center-cols-viewport,.ag-layout-print .ag-center-cols-container{min-height:50px}.ag-overlay-loading-wrapper{background-color:var(--ag-modal-overlay-background-color)}.ag-overlay-loading-center{border:var(--ag-borders) var(--ag-border-color);background:var(--ag-background-color);border-radius:var(--ag-card-radius);box-shadow:var(--ag-card-shadow);padding:var(--ag-grid-size)}.ag-overlay-no-rows-wrapper.ag-layout-auto-height{padding-top:30px}.ag-skeleton-container{width:100%;height:100%;align-content:center}.ag-skeleton-effect{background-color:var(--ag-row-loading-skeleton-effect-color);width:100%;height:1em;border-radius:.25rem;animation:ag-skeleton-loading 1.5s ease-in-out .5s infinite}@keyframes ag-skeleton-loading{0%{opacity:1}50%{opacity:.4}to{opacity:1}}.ag-loading{display:flex;height:100%;align-items:center}.ag-ltr .ag-loading{padding-left:var(--ag-cell-horizontal-padding)}.ag-rtl .ag-loading{padding-right:var(--ag-cell-horizontal-padding)}.ag-ltr .ag-loading-icon{padding-right:var(--ag-cell-widget-spacing)}.ag-rtl .ag-loading-icon{padding-left:var(--ag-cell-widget-spacing)}.ag-icon-loading{animation-name:spin;animation-duration:1s;animation-iteration-count:infinite;animation-timing-function:linear}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.ag-floating-top{border-bottom:var(--ag-borders-critical) var(--ag-border-color)}.ag-floating-bottom{border-top:var(--ag-borders-critical) var(--ag-border-color)}.ag-ltr .ag-cell{border-right:var(--ag-cell-horizontal-border)}.ag-rtl .ag-cell{border-left:var(--ag-cell-horizontal-border)}.ag-ltr .ag-cell{border-right-width:1px}.ag-rtl .ag-cell{border-left-width:1px}.ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell){border-left:var(--ag-borders-critical) var(--ag-border-color)}.ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell){border-right:var(--ag-borders-critical) var(--ag-border-color)}.ag-cell-range-selected:not(.ag-cell-focus),.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing){background-color:var(--ag-range-selection-background-color)}.ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart,.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart{background-color:var(--ag-range-selection-chart-background-color)!important}.ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart.ag-cell-range-chart-category,.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart.ag-cell-range-chart-category{background-color:var(--ag-range-selection-chart-category-background-color)!important}.ag-cell-range-selected-1:not(.ag-cell-focus),.ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing){background-color:var(--ag-range-selection-background-color)}.ag-cell-range-selected-2:not(.ag-cell-focus),.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-2{background-color:var(--ag-range-selection-background-color-2)}.ag-cell-range-selected-3:not(.ag-cell-focus),.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-3{background-color:var(--ag-range-selection-background-color-3)}.ag-cell-range-selected-4:not(.ag-cell-focus),.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-4{background-color:var(--ag-range-selection-background-color-4)}.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top{border-top-color:var(--ag-range-selection-border-color);border-top-style:var(--ag-range-selection-border-style)}.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right{border-right-color:var(--ag-range-selection-border-color);border-right-style:var(--ag-range-selection-border-style)}.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom{border-bottom-color:var(--ag-range-selection-border-color);border-bottom-style:var(--ag-range-selection-border-style)}.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left{border-left-color:var(--ag-range-selection-border-color);border-left-style:var(--ag-range-selection-border-style)}.ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within,.ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.ag-ltr .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,.ag-ltr .ag-cell-range-single-cell,.ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle,.ag-rtl .ag-cell-focus:not(.ag-cell-range-selected):focus-within,.ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.ag-rtl .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,.ag-rtl .ag-cell-range-single-cell,.ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle{border:1px solid;border-color:var(--ag-range-selection-border-color);border-style:var(--ag-range-selection-border-style);outline:initial}.ag-cell.ag-selection-fill-top,.ag-cell.ag-selection-fill-top.ag-cell-range-selected{border-top:1px dashed;border-top-color:var(--ag-range-selection-border-color)}.ag-ltr .ag-cell.ag-selection-fill-right,.ag-ltr .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-right:1px dashed var(--ag-range-selection-border-color)!important}.ag-rtl .ag-cell.ag-selection-fill-right,.ag-rtl .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-left:1px dashed var(--ag-range-selection-border-color)!important}.ag-cell.ag-selection-fill-bottom,.ag-cell.ag-selection-fill-bottom.ag-cell-range-selected{border-bottom:1px dashed;border-bottom-color:var(--ag-range-selection-border-color)}.ag-ltr .ag-cell.ag-selection-fill-left,.ag-ltr .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-left:1px dashed var(--ag-range-selection-border-color)!important}.ag-rtl .ag-cell.ag-selection-fill-left,.ag-rtl .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-right:1px dashed var(--ag-range-selection-border-color)!important}.ag-fill-handle,.ag-range-handle{position:absolute;width:6px;height:6px;bottom:-1px;background-color:var(--ag-range-selection-border-color)}.ag-ltr .ag-fill-handle,.ag-ltr .ag-range-handle{right:-1px}.ag-rtl .ag-fill-handle,.ag-rtl .ag-range-handle{left:-1px}.ag-fill-handle{cursor:cell}.ag-range-handle{cursor:nwse-resize}.ag-cell-inline-editing{border-color:var(--ag-input-focus-border-color)!important}.ag-menu{border:var(--ag-borders) var(--ag-border-color);background:var(--ag-background-color);border-radius:var(--ag-card-radius);box-shadow:var(--ag-card-shadow);padding:var(--ag-grid-size);background-color:var(--ag-menu-background-color);border-color:var(--ag-menu-border-color);padding:0}.ag-menu.ag-tabs{min-width:var(--ag-tab-min-width)}.ag-menu-list{cursor:default;padding:var(--ag-grid-size) 0}.ag-menu-separator{height:calc(var(--ag-grid-size) * 2 + 1px)}.ag-menu-separator-part:after{content:"";display:block;border-top:var(--ag-borders-critical) var(--ag-border-color)}.ag-menu-option-active,.ag-compact-menu-option-active{background-color:var(--ag-row-hover-color)}.ag-menu-option-part,.ag-compact-menu-option-part{line-height:var(--ag-icon-size);padding:calc(var(--ag-grid-size) + 2px) 0}.ag-menu-option-disabled,.ag-compact-menu-option-disabled{opacity:.5}.ag-menu-option-icon,.ag-compact-menu-option-icon{width:var(--ag-icon-size)}.ag-ltr .ag-menu-option-icon,.ag-ltr .ag-compact-menu-option-icon{padding-left:calc(var(--ag-grid-size) * 2)}.ag-rtl .ag-menu-option-icon,.ag-rtl .ag-compact-menu-option-icon{padding-right:calc(var(--ag-grid-size) * 2)}.ag-menu-option-text,.ag-compact-menu-option-text{padding-left:calc(var(--ag-grid-size) * 2);padding-right:calc(var(--ag-grid-size) * 2)}.ag-ltr .ag-menu-option-shortcut,.ag-ltr .ag-compact-menu-option-shortcut{padding-right:var(--ag-grid-size)}.ag-rtl .ag-menu-option-shortcut,.ag-rtl .ag-compact-menu-option-shortcut{padding-left:var(--ag-grid-size)}.ag-ltr .ag-menu-option-popup-pointer,.ag-ltr .ag-compact-menu-option-popup-pointer{padding-right:var(--ag-grid-size)}.ag-rtl .ag-menu-option-popup-pointer,.ag-rtl .ag-compact-menu-option-popup-pointer{padding-left:var(--ag-grid-size)}.ag-tabs-header,.ag-tabs-header-wrapper{display:flex}.ag-tabs-header-wrapper .ag-tabs-header{flex:1}.ag-tabs-close-button-wrapper{border:0;border-right:var(--ag-borders) var(--ag-border-color);padding:var(--ag-grid-size)}.ag-tabs-close-button{border:0;background-color:unset;cursor:pointer;padding:0}.ag-tab{border-bottom:var(--ag-selected-tab-underline-width) solid transparent;transition:border-bottom var(--ag-selected-tab-underline-transition-speed);display:flex;flex:none;align-items:center;justify-content:center;cursor:pointer}.ag-tab:focus-visible{outline:none}.ag-tab:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-tab-selected{border-bottom-color:var(--ag-selected-tab-underline-color)}.ag-menu-header{color:var(--ag-secondary-foreground-color)}.ag-filter-separator{border-top:var(--ag-borders-critical) var(--ag-border-color)}.ag-filter-select .ag-picker-field-wrapper{width:0}.ag-filter-condition-operator{height:17px}.ag-ltr .ag-filter-condition-operator-or{margin-left:calc(var(--ag-grid-size) * 2)}.ag-rtl .ag-filter-condition-operator-or{margin-right:calc(var(--ag-grid-size) * 2)}.ag-set-filter-select-all{padding-top:var(--ag-widget-container-vertical-padding)}.ag-set-filter-list,.ag-filter-no-matches{height:calc(var(--ag-list-item-height) * 6)}.ag-set-filter-tree-list{height:calc(var(--ag-list-item-height) * 10)}.ag-set-filter-filter{margin-top:var(--ag-widget-container-vertical-padding);margin-left:var(--ag-widget-container-horizontal-padding);margin-right:var(--ag-widget-container-horizontal-padding)}.ag-filter-to{margin-top:var(--ag-widget-vertical-spacing)}.ag-mini-filter{margin:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}.ag-set-filter{--ag-indentation-level: 0}.ag-ltr .ag-set-filter-item{padding-left:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level) * var(--ag-set-filter-indent-size))}.ag-rtl .ag-set-filter-item{padding-right:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level) * var(--ag-set-filter-indent-size))}.ag-ltr .ag-set-filter-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}.ag-rtl .ag-set-filter-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}.ag-ltr .ag-set-filter-group-icons{margin-right:var(--ag-widget-container-horizontal-padding)}.ag-rtl .ag-set-filter-group-icons{margin-left:var(--ag-widget-container-horizontal-padding)}.ag-filter-menu .ag-set-filter-list{min-width:200px}.ag-filter-virtual-list-item:focus-visible{outline:none}.ag-filter-virtual-list-item:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:1px;left:1px;display:block;width:calc(100% - 2px);height:calc(100% - 2px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-filter-apply-panel{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);border-top:var(--ag-borders-secondary) var(--ag-secondary-border-color)}.ag-filter-apply-panel-button{line-height:1.5}.ag-ltr .ag-filter-apply-panel-button{margin-left:calc(var(--ag-grid-size) * 2)}.ag-rtl .ag-filter-apply-panel-button{margin-right:calc(var(--ag-grid-size) * 2)}.ag-simple-filter-body-wrapper{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);padding-bottom:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));overflow-y:auto;min-height:calc(var(--ag-list-item-height) + var(--ag-widget-container-vertical-padding) + var(--ag-widget-vertical-spacing))}.ag-simple-filter-body-wrapper>*{margin-bottom:var(--ag-widget-vertical-spacing)}.ag-simple-filter-body-wrapper .ag-resizer-wrapper{margin:0}.ag-menu:not(.ag-tabs) .ag-filter .ag-filter-body-wrapper,.ag-menu:not(.ag-tabs) .ag-filter>*:not(.ag-filter-wrapper){min-width:calc(var(--ag-menu-min-width) - 2px)}.ag-filter-no-matches{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}.ag-multi-filter-menu-item{margin:var(--ag-grid-size) 0}.ag-multi-filter-group-title-bar{padding:calc(var(--ag-grid-size) * 2) var(--ag-grid-size);background-color:transparent}.ag-group-filter-field-select-wrapper{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);padding-bottom:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing))}.ag-group-filter-field-select-wrapper>*{margin-bottom:var(--ag-widget-vertical-spacing)}.ag-multi-filter-group-title-bar:focus-visible{outline:none}.ag-multi-filter-group-title-bar:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-side-bar{position:relative}.ag-tool-panel-wrapper{width:var(--ag-side-bar-panel-width);background-color:var(--ag-control-panel-background-color)}.ag-side-buttons{padding-top:calc(var(--ag-grid-size) * 4);width:calc(var(--ag-icon-size) + 4px);position:relative;overflow:hidden}button.ag-side-button-button{color:inherit;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;background:transparent;padding:calc(var(--ag-grid-size) * 2) 0 calc(var(--ag-grid-size) * 2) 0;width:100%;margin:0;min-height:calc(var(--ag-grid-size) * 18);background-position-y:center;background-position-x:center;background-repeat:no-repeat;border:none;border-top:var(--ag-borders-side-button) var(--ag-border-color);border-bottom:var(--ag-borders-side-button) var(--ag-border-color)}button.ag-side-button-button:focus{box-shadow:none}.ag-side-button-button:focus-visible{outline:none}.ag-side-button-button:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-selected button.ag-side-button-button{background-color:var(--ag-side-button-selected-background-color)}.ag-side-button-icon-wrapper{margin-bottom:3px}.ag-ltr .ag-side-bar-left,.ag-rtl .ag-side-bar-right{border-right:var(--ag-borders) var(--ag-border-color)}.ag-ltr .ag-side-bar-left .ag-tool-panel-wrapper,.ag-rtl .ag-side-bar-right .ag-tool-panel-wrapper{border-left:var(--ag-borders) var(--ag-border-color)}.ag-ltr .ag-side-bar-left .ag-side-button-button,.ag-rtl .ag-side-bar-right .ag-side-button-button{border-right:var(--ag-selected-tab-underline-width) solid transparent;transition:border-right var(--ag-selected-tab-underline-transition-speed)}.ag-ltr .ag-side-bar-left .ag-selected .ag-side-button-button,.ag-rtl .ag-side-bar-right .ag-selected .ag-side-button-button{border-right-color:var(--ag-selected-tab-underline-color)}.ag-rtl .ag-side-bar-left,.ag-ltr .ag-side-bar-right{border-left:var(--ag-borders) var(--ag-border-color)}.ag-rtl .ag-side-bar-left .ag-tool-panel-wrapper,.ag-ltr .ag-side-bar-right .ag-tool-panel-wrapper{border-right:var(--ag-borders) var(--ag-border-color)}.ag-rtl .ag-side-bar-left .ag-side-button-button,.ag-ltr .ag-side-bar-right .ag-side-button-button{border-left:var(--ag-selected-tab-underline-width) solid transparent;transition:border-left var(--ag-selected-tab-underline-transition-speed)}.ag-rtl .ag-side-bar-left .ag-selected .ag-side-button-button,.ag-ltr .ag-side-bar-right .ag-selected .ag-side-button-button{border-left-color:var(--ag-selected-tab-underline-color)}.ag-filter-toolpanel-header{height:calc(var(--ag-grid-size) * 6)}.ag-filter-toolpanel-header,.ag-filter-toolpanel-search{padding:0 var(--ag-grid-size)}.ag-filter-toolpanel-header:focus-visible{outline:none}.ag-filter-toolpanel-header:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-filter-toolpanel-group:not(.ag-has-filter)>.ag-group-title-bar .ag-filter-toolpanel-group-instance-header-icon{display:none}.ag-filter-toolpanel-group-level-0-header{height:calc(var(--ag-grid-size) * 8)}.ag-filter-toolpanel-group-item{margin-top:calc(var(--ag-grid-size) * .5);margin-bottom:calc(var(--ag-grid-size) * .5)}.ag-filter-toolpanel-search{height:var(--ag-header-height)}.ag-filter-toolpanel-search-input{flex-grow:1;height:calc(var(--ag-grid-size) * 4)}.ag-ltr .ag-filter-toolpanel-search-input{margin-right:var(--ag-grid-size)}.ag-rtl .ag-filter-toolpanel-search-input{margin-left:var(--ag-grid-size)}.ag-filter-toolpanel-group-level-0{border-top:var(--ag-borders-secondary) var(--ag-secondary-border-color)}.ag-ltr .ag-filter-toolpanel-expand,.ag-ltr .ag-filter-toolpanel-group-title-bar-icon{margin-right:var(--ag-grid-size)}.ag-rtl .ag-filter-toolpanel-expand,.ag-rtl .ag-filter-toolpanel-group-title-bar-icon{margin-left:var(--ag-grid-size)}.ag-filter-toolpanel-group-title-bar{background-color:transparent}.ag-ltr .ag-filter-toolpanel-header{padding-left:calc(var(--ag-filter-tool-panel-group-indent) * var(--ag-indentation-level, 0) + var(--ag-grid-size))}.ag-rtl .ag-filter-toolpanel-header{padding-right:calc(var(--ag-filter-tool-panel-group-indent) * var(--ag-indentation-level, 0) + var(--ag-grid-size))}.ag-filter-toolpanel-instance-filter{border-bottom:var(--ag-borders) var(--ag-border-color);border-top:var(--ag-borders) var(--ag-border-color);margin-top:var(--ag-grid-size)}.ag-ltr .ag-filter-toolpanel-group-instance-header-icon,.ag-ltr .ag-filter-toolpanel-instance-header-icon{margin-left:var(--ag-grid-size)}.ag-rtl .ag-filter-toolpanel-group-instance-header-icon,.ag-rtl .ag-filter-toolpanel-instance-header-icon{margin-right:var(--ag-grid-size)}.ag-set-filter-group-icons{color:var(--ag-secondary-foreground-color)}.ag-pivot-mode-panel{min-height:var(--ag-header-height);height:var(--ag-header-height);display:flex}.ag-pivot-mode-select{display:flex;align-items:center}.ag-ltr .ag-pivot-mode-select{margin-left:var(--ag-widget-container-horizontal-padding)}.ag-rtl .ag-pivot-mode-select{margin-right:var(--ag-widget-container-horizontal-padding)}.ag-column-select-header:focus-visible{outline:none}.ag-column-select-header:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-column-select-header{height:var(--ag-header-height);align-items:center;padding:0 var(--ag-widget-container-horizontal-padding);border-bottom:var(--ag-borders-secondary) var(--ag-secondary-border-color)}.ag-column-panel-column-select{border-bottom:var(--ag-borders-secondary) var(--ag-secondary-border-color);border-top:var(--ag-borders-secondary) var(--ag-secondary-border-color)}.ag-column-group-icons,.ag-column-select-header-icon{color:var(--ag-secondary-foreground-color)}.ag-column-select-list .ag-list-item-hovered:after{content:"";position:absolute;left:0;right:0;height:1px;background-color:var(--ag-range-selection-border-color)}.ag-column-select-list .ag-item-highlight-top:after{top:0}.ag-column-select-list .ag-item-highlight-bottom:after{bottom:0}.ag-header,.ag-advanced-filter-header{background-color:var(--ag-header-background-color);border-bottom:var(--ag-borders-critical) var(--ag-border-color)}.ag-header-row{color:var(--ag-header-foreground-color);height:var(--ag-header-height)}.ag-pinned-right-header{border-left:var(--ag-borders-critical) var(--ag-border-color)}.ag-pinned-left-header{border-right:var(--ag-borders-critical) var(--ag-border-color)}.ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon,.ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-menu-icon{margin-left:var(--ag-grid-size)}.ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon,.ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-menu-icon{margin-right:var(--ag-grid-size)}.ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-label-icon,.ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-menu-icon{margin-right:var(--ag-grid-size)}.ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-label-icon,.ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-menu-icon{margin-left:var(--ag-grid-size)}.ag-header-cell,.ag-header-group-cell{padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding)}.ag-header-cell.ag-header-cell-moving,.ag-header-group-cell.ag-header-cell-moving{background-color:var(--ag-header-cell-moving-background-color)}.ag-ltr .ag-header-group-cell-label.ag-sticky-label{left:var(--ag-cell-horizontal-padding)}.ag-rtl .ag-header-group-cell-label.ag-sticky-label{right:var(--ag-cell-horizontal-padding)}.ag-header-cell:focus-visible{outline:none}.ag-header-cell:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-header-group-cell:focus-visible{outline:none}.ag-header-group-cell:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-advanced-filter-header-cell:focus-visible{outline:none}.ag-advanced-filter-header-cell:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-header-icon{color:var(--ag-secondary-foreground-color)}.ag-header-expand-icon{cursor:pointer}.ag-ltr .ag-header-expand-icon{margin-left:4px}.ag-rtl .ag-header-expand-icon{margin-right:4px}.ag-header-row:not(:first-child) .ag-header-cell:not(.ag-header-span-height.ag-header-span-total),.ag-header-row:not(:first-child) .ag-header-group-cell.ag-header-group-cell-with-group{border-top:var(--ag-borders-critical) var(--ag-border-color)}.ag-header-group-cell:not(.ag-column-resizing)+.ag-header-group-cell:not(.ag-column-hover):not(.ag-header-cell-moving):hover,.ag-header-group-cell:not(.ag-column-resizing)+.ag-header-group-cell:not(.ag-column-hover).ag-column-resizing,.ag-header-cell:not(.ag-column-resizing)+.ag-header-cell:not(.ag-column-hover):not(.ag-header-cell-moving):hover,.ag-header-cell:not(.ag-column-resizing)+.ag-header-cell:not(.ag-column-hover).ag-column-resizing,.ag-header-group-cell:first-of-type:not(.ag-header-cell-moving):hover,.ag-header-group-cell:first-of-type.ag-column-resizing,.ag-header-cell:not(.ag-column-hover):first-of-type:not(.ag-header-cell-moving):hover,.ag-header-cell:not(.ag-column-hover):first-of-type.ag-column-resizing{background-color:var(--ag-header-cell-hover-background-color)}.ag-header-cell:before,.ag-header-group-cell:not(.ag-header-span-height.ag-header-group-cell-no-group):before{content:"";position:absolute;z-index:1;display:var(--ag-header-column-separator-display);width:var(--ag-header-column-separator-width);height:var(--ag-header-column-separator-height);top:calc(50% - var(--ag-header-column-separator-height) * .5);background-color:var(--ag-header-column-separator-color)}.ag-ltr .ag-header-cell:before,.ag-ltr .ag-header-group-cell:not(.ag-header-span-height.ag-header-group-cell-no-group):before{right:0}.ag-rtl .ag-header-cell:before,.ag-rtl .ag-header-group-cell:not(.ag-header-span-height.ag-header-group-cell-no-group):before{left:0}.ag-header-cell-resize{display:flex;align-items:center}.ag-header-cell-resize:after{content:"";position:absolute;z-index:1;display:var(--ag-header-column-resize-handle-display);width:var(--ag-header-column-resize-handle-width);height:var(--ag-header-column-resize-handle-height);top:calc(50% - var(--ag-header-column-resize-handle-height) * .5);background-color:var(--ag-header-column-resize-handle-color)}.ag-header-cell.ag-header-span-height .ag-header-cell-resize:after{height:calc(100% - var(--ag-grid-size) * 4);top:calc(var(--ag-grid-size) * 2)}.ag-ltr .ag-header-viewport .ag-header-cell-resize:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}.ag-rtl .ag-header-viewport .ag-header-cell-resize:after{right:calc(50% - var(--ag-header-column-resize-handle-width))}.ag-pinned-left-header .ag-header-cell-resize:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}.ag-pinned-right-header .ag-header-cell-resize:after{left:50%}.ag-ltr .ag-header-select-all{margin-right:var(--ag-cell-horizontal-padding)}.ag-rtl .ag-header-select-all{margin-left:var(--ag-cell-horizontal-padding)}.ag-ltr .ag-floating-filter-button{margin-left:var(--ag-cell-widget-spacing)}.ag-rtl .ag-floating-filter-button{margin-right:var(--ag-cell-widget-spacing)}.ag-floating-filter-button-button{color:inherit;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent;border:none;height:var(--ag-icon-size);padding:0;width:var(--ag-icon-size)}.ag-filter-loading{background-color:var(--ag-control-panel-background-color);height:100%;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:absolute;width:100%;z-index:1}.ag-paging-panel{border-top:1px solid;border-top-color:var(--ag-border-color);color:var(--ag-secondary-foreground-color);height:var(--ag-header-height)}.ag-paging-panel>*{margin:0 var(--ag-cell-horizontal-padding)}.ag-paging-panel>.ag-paging-page-size .ag-wrapper{min-width:calc(var(--ag-grid-size) * 10)}.ag-paging-button{cursor:pointer}.ag-paging-button.ag-disabled{cursor:default;color:var(--ag-disabled-foreground-color)}.ag-paging-button:focus-visible{outline:none}.ag-paging-button:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:0;left:0;display:block;width:calc(100% + -0px);height:calc(100% + -0px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-paging-button,.ag-paging-description{margin:0 var(--ag-grid-size)}.ag-status-bar{border-top:var(--ag-borders) var(--ag-border-color);color:var(--ag-disabled-foreground-color);padding-right:calc(var(--ag-grid-size) * 4);padding-left:calc(var(--ag-grid-size) * 4);line-height:1.5}.ag-status-name-value-value{color:var(--ag-foreground-color)}.ag-status-bar-center{text-align:center}.ag-status-name-value{margin-left:var(--ag-grid-size);margin-right:var(--ag-grid-size);padding-top:calc(var(--ag-grid-size) * 2);padding-bottom:calc(var(--ag-grid-size) * 2)}.ag-column-drop-cell{background:var(--ag-chip-background-color);border-radius:calc(var(--ag-grid-size) * 4);height:calc(var(--ag-grid-size) * 4);padding:0 calc(var(--ag-grid-size) * .5);border:1px solid var(--ag-chip-border-color)}.ag-column-drop-cell:focus-visible{outline:none}.ag-column-drop-cell:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:2px;left:2px;display:block;width:calc(100% - 4px);height:calc(100% - 4px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-column-drop-cell-text{margin:0 var(--ag-grid-size)}.ag-column-drop-cell-button{min-width:calc(var(--ag-grid-size) * 4);margin:0 calc(var(--ag-grid-size) * .5);color:var(--ag-secondary-foreground-color)}.ag-column-drop-cell-drag-handle{margin-left:calc(var(--ag-grid-size) * 2)}.ag-column-drop-cell-ghost{opacity:.5}.ag-column-drop-horizontal{background-color:var(--ag-header-background-color);color:var(--ag-secondary-foreground-color);height:var(--ag-header-height);border-bottom:var(--ag-borders) var(--ag-border-color)}.ag-ltr .ag-column-drop-horizontal{padding-left:var(--ag-cell-horizontal-padding)}.ag-rtl .ag-column-drop-horizontal{padding-right:var(--ag-cell-horizontal-padding)}.ag-ltr .ag-column-drop-horizontal-half-width:not(:last-child){border-right:var(--ag-borders) var(--ag-border-color)}.ag-rtl .ag-column-drop-horizontal-half-width:not(:last-child){border-left:var(--ag-borders) var(--ag-border-color)}.ag-column-drop-horizontal-cell-separator{margin:0 var(--ag-grid-size);color:var(--ag-secondary-foreground-color)}.ag-column-drop-horizontal-empty-message{color:var(--ag-disabled-foreground-color)}.ag-ltr .ag-column-drop-horizontal-icon{margin-right:var(--ag-cell-horizontal-padding)}.ag-rtl .ag-column-drop-horizontal-icon{margin-left:var(--ag-cell-horizontal-padding)}.ag-column-drop-vertical-list{padding-bottom:var(--ag-grid-size);padding-right:var(--ag-grid-size);padding-left:var(--ag-grid-size)}.ag-column-drop-vertical-cell{margin-top:var(--ag-grid-size)}.ag-column-drop-vertical{min-height:50px;border-bottom:var(--ag-borders-secondary) var(--ag-secondary-border-color)}.ag-column-drop-vertical.ag-last-column-drop{border-bottom:none}.ag-column-drop-vertical-icon{margin-left:var(--ag-grid-size);margin-right:var(--ag-grid-size)}.ag-column-drop-vertical-empty-message{position:absolute;top:0;bottom:0;left:0;right:0;overflow:hidden;color:var(--ag-disabled-foreground-color);margin-top:var(--ag-grid-size)}.ag-select-agg-func-popup{border:var(--ag-borders) var(--ag-border-color);border-radius:var(--ag-card-radius);box-shadow:var(--ag-card-shadow);padding:var(--ag-grid-size);background:var(--ag-background-color);height:calc(var(--ag-grid-size) * 5 * 3.5);padding:0}.ag-select-agg-func-virtual-list-item{cursor:default}.ag-ltr .ag-select-agg-func-virtual-list-item{padding-left:calc(var(--ag-grid-size) * 2)}.ag-rtl .ag-select-agg-func-virtual-list-item{padding-right:calc(var(--ag-grid-size) * 2)}.ag-select-agg-func-virtual-list-item:hover{background-color:var(--ag-selected-row-background-color)}.ag-select-agg-func-virtual-list-item:focus-visible{outline:none}.ag-select-agg-func-virtual-list-item:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:1px;left:1px;display:block;width:calc(100% - 2px);height:calc(100% - 2px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-sort-indicator-container{display:flex}.ag-ltr .ag-sort-indicator-icon{padding-left:var(--ag-grid-size)}.ag-rtl .ag-sort-indicator-icon{padding-right:var(--ag-grid-size)}.ag-chart{position:relative;display:flex;overflow:hidden;width:100%;height:100%}.ag-chart-components-wrapper{position:relative;display:flex;flex:1 1 auto;overflow:hidden}.ag-chart-canvas-wrapper{position:relative;flex:1 1 auto;overflow:hidden}.ag-chart-menu{position:absolute;top:16px;display:flex;flex-direction:column}.ag-ltr .ag-chart-menu{right:20px}.ag-rtl .ag-chart-menu{left:20px}.ag-chart-docked-container{position:relative;min-width:var(--ag-chart-menu-panel-width)}.ag-chart-menu-hidden~.ag-chart-docked-container{display:none}.ag-chart-tabbed-menu{width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden}.ag-chart-tabbed-menu-header{flex:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.ag-chart-tabbed-menu-body{display:flex;flex:1 1 auto;align-items:stretch;overflow:hidden}.ag-chart-tab{width:100%;overflow:hidden;overflow-y:auto}.ag-chart-settings{overflow-x:hidden}.ag-chart-settings-wrapper{position:relative;flex-direction:column;width:100%;height:100%;display:flex;overflow:hidden}.ag-chart-settings-nav-bar{display:flex;align-items:center;width:100%;height:30px;padding:0 10px;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ag-chart-settings-card-selector{display:flex;align-items:center;justify-content:space-around;flex:1 1 auto;height:100%;padding:0 10px}.ag-chart-settings-card-item{cursor:pointer;width:10px;height:10px;background-color:#000;position:relative}.ag-chart-settings-card-item.ag-not-selected{opacity:.2}.ag-chart-settings-card-item:before{content:" ";display:block;position:absolute;background-color:transparent;left:50%;top:50%;margin-left:-10px;margin-top:-10px;width:20px;height:20px}.ag-chart-settings-prev,.ag-chart-settings-next{position:relative;flex:none}.ag-chart-settings-prev:focus-within,.ag-chart-settings-next:focus-within{box-shadow:var(--ag-input-focus-box-shadow);border-radius:1px}.ag-chart-settings-prev-button,.ag-chart-settings-next-button{position:absolute;top:0;left:0;width:100%;height:100%;cursor:pointer;opacity:0}.ag-chart-settings-mini-charts-container{position:relative;flex:1 1 auto;overflow-x:hidden;overflow-y:auto}.ag-chart-settings-mini-wrapper{position:absolute;top:0;left:0;display:flex;flex-direction:column;width:100%;min-height:100%;overflow:hidden}.ag-chart-settings-mini-wrapper.ag-animating{transition:left .3s;transition-timing-function:ease-in-out}.ag-chart-mini-thumbnail{cursor:pointer}.ag-chart-mini-thumbnail-canvas{display:block}.ag-chart-data-wrapper,.ag-chart-format-wrapper,.ag-chart-advanced-settings-wrapper{display:flex;flex-direction:column;position:relative;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;padding-bottom:16px}.ag-chart-data-wrapper,.ag-chart-advanced-settings-wrapper{height:100%;overflow-y:auto}.ag-chart-advanced-settings{background-color:var(--ag-control-panel-background-color)}.ag-chart-advanced-settings-wrapper,.ag-chart-advanced-settings{width:100%}.ag-chart-advanced-settings-wrapper{padding-bottom:0}.ag-chart-data-section,.ag-chart-format-section,.ag-chart-advanced-settings-section{display:flex;margin:0}.ag-chart-advanced-settings-section{padding-top:var(--ag-grid-size);padding-bottom:var(--ag-grid-size)}.ag-chart-advanced-settings-section:not(:last-child){border-bottom:1px solid var(--ag-secondary-border-color)}.ag-chart-empty-text{display:flex;top:0;width:100%;height:100%;align-items:center;justify-content:center;background-color:var(--ag-background-color)}.ag-chart .ag-chart-menu{display:none}.ag-chart-menu-hidden:hover .ag-chart-menu{display:block}.ag-chart .ag-chart-menu-wrapper .ag-chart-menu{display:flex;flex-direction:row;top:8px;gap:20px;width:auto}.ag-ltr .ag-chart .ag-chart-menu-wrapper .ag-chart-menu{right:calc(var(--ag-cell-horizontal-padding) + var(--ag-grid-size) - 4px);justify-content:right}.ag-rtl .ag-chart .ag-chart-menu-wrapper .ag-chart-menu{left:calc(var(--ag-cell-horizontal-padding) + var(--ag-grid-size) - 4px);justify-content:left}.ag-charts-font-size-color{display:flex;align-self:stretch;justify-content:space-between}.ag-charts-data-group-item{position:relative}.ag-charts-data-group-item:not(:last-child){margin-bottom:var(--ag-grid-size)}.ag-chart-menu{border-radius:var(--ag-card-radius);background:var(--ag-background-color)}.ag-chart-menu-icon{opacity:.5;margin:2px 0;cursor:pointer;border-radius:var(--ag-card-radius);color:var(--ag-secondary-foreground-color)}.ag-chart-menu-icon:hover{opacity:1}.ag-chart-menu-toolbar-button{border:0;background-color:unset;padding:0 2px;border-radius:1px}.ag-chart-mini-thumbnail{border:1px solid var(--ag-secondary-border-color);border-radius:5px}.ag-chart-mini-thumbnail.ag-selected{border-color:var(--ag-minichart-selected-chart-color);border-width:2px}.ag-chart-mini-thumbnail:focus-visible{outline:none;border-color:var(--ag-minichart-selected-chart-color);box-shadow:var(--ag-input-focus-box-shadow)}.ag-chart-settings-card-item{background:var(--ag-foreground-color);width:8px;height:8px;border-radius:4px}.ag-chart-settings-card-item.ag-selected{background-color:var(--ag-minichart-selected-page-color)}.ag-chart-data-column-drag-handle{margin-left:var(--ag-grid-size)}.ag-charts-settings-group-title-bar,.ag-charts-data-group-title-bar,.ag-charts-format-top-level-group-title-bar{border-top:var(--ag-borders-secondary) var(--ag-secondary-border-color);position:relative}.ag-charts-advanced-settings-top-level-group-title-bar{position:relative;background-color:unset}.ag-charts-data-group-title-bar:focus-visible{outline:none}.ag-charts-data-group-title-bar:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-charts-format-top-level-group-title-bar:focus-visible{outline:none}.ag-charts-format-top-level-group-title-bar:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:4px;left:4px;display:block;width:calc(100% - 8px);height:calc(100% - 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-charts-data-group-title-bar .ag-charts-data-group-title,.ag-charts-format-top-level-group-title-bar .ag-charts-format-top-level-group-title{cursor:pointer}.ag-charts-data-group-container{padding:calc(var(--ag-widget-container-vertical-padding) * .5) var(--ag-widget-container-horizontal-padding)}.ag-charts-data-group-container .ag-charts-data-group-item:not(.ag-charts-format-sub-level-group):not(.ag-pill-select):not(.ag-select){height:var(--ag-list-item-height)}.ag-charts-data-group-container .ag-charts-data-group-item.ag-picker-field{margin-top:var(--ag-grid-size)}.ag-charts-data-group-container .ag-list-item-hovered:after{content:"";position:absolute;left:0;right:0;height:1px;background-color:var(--ag-range-selection-border-color)}.ag-charts-data-group-container .ag-item-highlight-top:after{top:0}.ag-charts-data-group-container .ag-item-highlight-bottom:after{bottom:0}.ag-charts-format-top-level-group-container,.ag-charts-advanced-settings-top-level-group-container{padding:var(--ag-grid-size)}.ag-ltr .ag-charts-format-top-level-group-container,.ag-ltr .ag-charts-advanced-settings-top-level-group-container{margin-left:calc(var(--ag-grid-size) * 2)}.ag-rtl .ag-charts-format-top-level-group-container,.ag-rtl .ag-charts-advanced-settings-top-level-group-container{margin-right:calc(var(--ag-grid-size) * 2)}.ag-charts-format-top-level-group-item,.ag-charts-advanced-settings-top-level-group-item{margin:var(--ag-grid-size) 0}.ag-charts-format-sub-level-group-container{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);padding-bottom:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing))}.ag-charts-format-sub-level-group-container>*{margin-bottom:var(--ag-widget-vertical-spacing)}.ag-charts-format-sub-level-no-header-group-container>*{margin-bottom:var(--ag-widget-vertical-spacing)}.ag-charts-format-sub-level-group-container .ag-charts-format-sub-level-group-item.ag-font-panel-no-header{margin:0}.ag-charts-settings-group-container{padding:var(--ag-grid-size);row-gap:8px;display:grid;grid-template-columns:60px 1fr 60px 1fr 60px}.ag-charts-settings-group-container .ag-chart-mini-thumbnail:nth-child(3n+1){grid-column:1}.ag-charts-settings-group-container .ag-chart-mini-thumbnail:nth-child(3n+2){grid-column:3}.ag-charts-settings-group-container .ag-chart-mini-thumbnail:nth-child(3n+3){grid-column:5}.ag-chart-menu-panel{background-color:var(--ag-control-panel-background-color)}.ag-ltr .ag-chart-menu-panel{border-left:solid 1px var(--ag-border-color)}.ag-rtl .ag-chart-menu-panel{border-right:solid 1px var(--ag-border-color)}.ag-charts-theme-default{--ag-charts-align: none !important;--ag-charts-justify: none !important}.ag-date-time-list-page-title-bar{display:flex}.ag-date-time-list-page-title{flex-grow:1;text-align:center}.ag-date-time-list-page-column-labels-row,.ag-date-time-list-page-entries-row{display:flex}.ag-date-time-list-page-column-label,.ag-date-time-list-page-entry{flex-basis:0;flex-grow:1}.ag-date-time-list-page-entry{cursor:pointer;text-align:center}.ag-date-time-list-page-column-label{text-align:center}.ag-advanced-filter-header{position:relative;display:flex;align-items:center;padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding)}.ag-advanced-filter{display:flex;align-items:center;width:100%}.ag-advanced-filter-apply-button,.ag-advanced-filter-builder-button{line-height:normal;white-space:nowrap}.ag-ltr .ag-advanced-filter-apply-button,.ag-ltr .ag-advanced-filter-builder-button{margin-left:calc(var(--ag-grid-size) * 2)}.ag-rtl .ag-advanced-filter-apply-button,.ag-rtl .ag-advanced-filter-builder-button{margin-right:calc(var(--ag-grid-size) * 2)}.ag-advanced-filter-builder-button{display:flex;align-items:center;border:0;background-color:unset;color:var(--ag-foreground-color);font-size:var(--ag-font-size);font-weight:600}.ag-advanced-filter-builder-button:hover:not(:disabled){background-color:var(--ag-row-hover-color)}.ag-advanced-filter-builder-button:not(:disabled){cursor:pointer}.ag-advanced-filter-builder-button-label{margin-left:var(--ag-grid-size)}.ag-advanced-filter-builder{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;width:100%;background-color:var(--ag-control-panel-background-color);display:flex;flex-direction:column}.ag-advanced-filter-builder-list{flex:1;overflow:auto}.ag-advanced-filter-builder-list .ag-list-item-hovered:after{content:"";position:absolute;left:0;right:0;height:1px;background-color:var(--ag-range-selection-border-color)}.ag-advanced-filter-builder-list .ag-item-highlight-top:after{top:0}.ag-advanced-filter-builder-list .ag-item-highlight-bottom:after{bottom:0}.ag-advanced-filter-builder-button-panel{display:flex;justify-content:flex-end;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);border-top:var(--ag-borders-secondary) var(--ag-secondary-border-color)}.ag-advanced-filter-builder .ag-advanced-filter-builder-button-panel .ag-advanced-filter-builder-apply-button,.ag-advanced-filter-builder .ag-advanced-filter-builder-button-panel .ag-advanced-filter-builder-cancel-button{margin-left:calc(var(--ag-grid-size) * 2)}.ag-advanced-filter-builder-item-wrapper{display:flex;flex:1 1 auto;align-items:center;justify-content:space-between;overflow:hidden;padding-left:calc(var(--ag-icon-size) / 2);padding-right:var(--ag-icon-size)}.ag-virtual-list-viewport .ag-advanced-filter-builder-item-wrapper .ag-tab-guard{position:absolute}.ag-advanced-filter-builder-item-tree-lines>*{width:var(--ag-advanced-filter-builder-indent-size)}.ag-advanced-filter-builder-item-tree-lines .ag-advanced-filter-builder-item-tree-line-root{width:var(--ag-icon-size)}.ag-advanced-filter-builder-item-tree-lines .ag-advanced-filter-builder-item-tree-line-root:before{top:50%;height:50%}.ag-advanced-filter-builder-item-tree-line-horizontal,.ag-advanced-filter-builder-item-tree-line-vertical,.ag-advanced-filter-builder-item-tree-line-vertical-top,.ag-advanced-filter-builder-item-tree-line-vertical-bottom{position:relative;height:100%;display:flex;align-items:center}.ag-advanced-filter-builder-item-tree-line-horizontal:before,.ag-advanced-filter-builder-item-tree-line-horizontal:after,.ag-advanced-filter-builder-item-tree-line-vertical:before,.ag-advanced-filter-builder-item-tree-line-vertical:after,.ag-advanced-filter-builder-item-tree-line-vertical-top:before,.ag-advanced-filter-builder-item-tree-line-vertical-top:after,.ag-advanced-filter-builder-item-tree-line-vertical-bottom:before,.ag-advanced-filter-builder-item-tree-line-vertical-bottom:after{content:"";position:absolute;height:100%}.ag-advanced-filter-builder-item-tree-line-horizontal:after{height:50%;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size));top:0;left:calc(var(--ag-icon-size) / 2);border-bottom:1px solid;border-color:var(--ag-border-color)}.ag-advanced-filter-builder-item-tree-line-vertical:before{width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size) / 2);top:0;left:calc(var(--ag-icon-size) / 2);border-left:1px solid;border-color:var(--ag-border-color)}.ag-advanced-filter-builder-item-tree-line-vertical-top:before{height:50%;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size) / 2);top:0;left:calc(var(--ag-icon-size) / 2);border-left:1px solid;border-color:var(--ag-border-color)}.ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{height:calc((100% - 1.5 * var(--ag-icon-size)) / 2);width:calc(var(--ag-icon-size) / 2);top:calc((100% + 1.5 * var(--ag-icon-size)) / 2);left:calc(var(--ag-icon-size) / 2);border-left:1px solid;border-color:var(--ag-border-color)}.ag-advanced-filter-builder-item-condition{padding-top:var(--ag-grid-size);padding-bottom:var(--ag-grid-size)}.ag-advanced-filter-builder-item,.ag-advanced-filter-builder-item-condition,.ag-advanced-filter-builder-pill-wrapper,.ag-advanced-filter-builder-pill,.ag-advanced-filter-builder-item-buttons,.ag-advanced-filter-builder-item-tree-lines{display:flex;align-items:center;height:100%}.ag-advanced-filter-builder-pill-wrapper{margin:0px var(--ag-grid-size)}.ag-advanced-filter-builder-pill{position:relative;border-radius:var(--ag-border-radius);padding:var(--ag-grid-size) calc(var(--ag-grid-size) * 2);min-height:calc(100% - var(--ag-grid-size) * 3);min-width:calc(var(--ag-grid-size) * 2)}.ag-advanced-filter-builder-pill .ag-picker-field-display{margin-right:var(--ag-grid-size)}.ag-advanced-filter-builder-pill .ag-advanced-filter-builder-value-number{font-family:monospace;font-weight:700}.ag-advanced-filter-builder-pill .ag-advanced-filter-builder-value-empty{color:var(--ag-disabled-foreground-color)}.ag-advanced-filter-builder-pill:focus-visible{outline:none}.ag-advanced-filter-builder-pill:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:-4px;left:-4px;display:block;width:calc(100% + 8px);height:calc(100% + 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-advanced-filter-builder-item-button:focus-visible{outline:none}.ag-advanced-filter-builder-item-button:focus-visible:after{content:"";position:absolute;background-color:transparent;pointer-events:none;top:-4px;left:-4px;display:block;width:calc(100% + 8px);height:calc(100% + 8px);border:1px solid;border-color:var(--ag-input-focus-border-color)}.ag-advanced-filter-builder-pill-display{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:500}.ag-advanced-filter-builder-join-pill{color:var(--ag-foreground-color);background-color:var(--ag-advanced-filter-join-pill-color);cursor:pointer}.ag-advanced-filter-builder-column-pill{color:var(--ag-foreground-color);background-color:var(--ag-advanced-filter-column-pill-color);cursor:pointer}.ag-advanced-filter-builder-option-pill{color:var(--ag-foreground-color);background-color:var(--ag-advanced-filter-option-pill-color);cursor:pointer}.ag-advanced-filter-builder-value-pill{color:var(--ag-foreground-color);background-color:var(--ag-advanced-filter-value-pill-color);cursor:text;max-width:140px}.ag-advanced-filter-builder-value-pill .ag-advanced-filter-builder-pill-display{display:block}.ag-advanced-filter-builder-item-buttons>*{margin:0 calc(var(--ag-grid-size) * .5)}.ag-advanced-filter-builder-item-button{position:relative;cursor:pointer;color:var(--ag-secondary-foreground-color);opacity:50%}.ag-advanced-filter-builder-item-button-disabled{color:var(--ag-disabled-foreground-color);cursor:default}.ag-advanced-filter-builder-virtual-list-container{top:var(--ag-grid-size)}.ag-advanced-filter-builder-virtual-list-item{display:flex;cursor:default;height:var(--ag-list-item-height)}.ag-advanced-filter-builder-virtual-list-item:hover{background-color:var(--ag-row-hover-color)}.ag-advanced-filter-builder-virtual-list-item:hover .ag-advanced-filter-builder-item-button{opacity:100%}.ag-advanced-filter-builder-virtual-list-item-highlight .ag-advanced-filter-builder-item-button:focus-visible,.ag-advanced-filter-builder-validation .ag-advanced-filter-builder-invalid{opacity:100%}.ag-advanced-filter-builder-invalid{margin:0 var(--ag-grid-size);color:var(--ag-invalid-color);cursor:default}.ag-input-field-input{width:100%;min-width:0}.ag-checkbox-input-wrapper{font-family:var(--ag-icon-font-family);font-weight:var(--ag-icon-font-weight);color:var(--ag-icon-font-color);font-size:var(--ag-icon-size);line-height:var(--ag-icon-size);font-style:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:var(--ag-icon-size);height:var(--ag-icon-size);background-color:var(--ag-checkbox-background-color);border-radius:var(--ag-checkbox-border-radius);display:inline-block;vertical-align:middle;flex:none}.ag-checkbox-input-wrapper input{-webkit-appearance:none;opacity:0;width:100%;height:100%}.ag-checkbox-input-wrapper:focus-within,.ag-checkbox-input-wrapper:active{outline:none;box-shadow:var(--ag-input-focus-box-shadow)}.ag-checkbox-input-wrapper.ag-disabled{opacity:.5}.ag-checkbox-input-wrapper:after{content:var(--ag-icon-font-code-checkbox-unchecked, "");font-family:inherit;color:var(--ag-checkbox-unchecked-color);display:var(--ag-icon-font-display-checkbox-unchecked, var(--ag-icon-font-display));position:absolute;top:0;left:0;pointer-events:none}.ag-checkbox-input-wrapper.ag-checked:after{content:var(--ag-icon-font-code-checkbox-checked, "");color:var(--ag-checkbox-checked-color);display:var(--ag-icon-font-display-checkbox-checked, var(--ag-icon-font-display));position:absolute;top:0;left:0;pointer-events:none}.ag-checkbox-input-wrapper.ag-indeterminate:after{content:var(--ag-icon-font-code-checkbox-indeterminate, "");color:var(--ag-checkbox-indeterminate-color);display:var(--ag-icon-font-display-checkbox-indeterminate, var(--ag-icon-font-display));position:absolute;top:0;left:0;pointer-events:none}.ag-checkbox-input-wrapper:before{content:"";background:transparent center/contain no-repeat;position:absolute;top:0;right:0;bottom:0;left:0;background-image:var(--ag-icon-image-checkbox-unchecked, var(--ag-icon-image));display:var(--ag-icon-image-display-checkbox-unchecked, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-checkbox-unchecked, var(--ag-icon-image-opacity, .9))}.ag-checkbox-input-wrapper.ag-checked:before{background-image:var(--ag-icon-image-checkbox-checked, var(--ag-icon-image));display:var(--ag-icon-image-display-checkbox-checked, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-checkbox-checked, var(--ag-icon-image-opacity, .9))}.ag-checkbox-input-wrapper.ag-indeterminate:before{background-image:var(--ag-icon-image-checkbox-indeterminate, var(--ag-icon-image));display:var(--ag-icon-image-display-checkbox-indeterminate, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-checkbox-indeterminate, var(--ag-icon-image-opacity, .9))}.ag-toggle-button-input-wrapper{box-sizing:border-box;width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);max-width:var(--ag-toggle-button-width);height:var(--ag-toggle-button-height);background-color:var(--ag-toggle-button-off-background-color);border-radius:calc(var(--ag-toggle-button-height) * .5);position:relative;flex:none;border:var(--ag-toggle-button-border-width) solid;border-color:var(--ag-toggle-button-off-border-color)}.ag-toggle-button-input-wrapper input{opacity:0;height:100%;width:100%}.ag-toggle-button-input-wrapper:focus-within{outline:none;box-shadow:var(--ag-input-focus-box-shadow)}.ag-toggle-button-input-wrapper.ag-disabled{opacity:.5}.ag-toggle-button-input-wrapper.ag-checked{background-color:var(--ag-toggle-button-on-background-color);border-color:var(--ag-toggle-button-on-border-color)}.ag-toggle-button-input-wrapper:before{content:" ";position:absolute;top:calc(0px - var(--ag-toggle-button-border-width));left:calc(0px - var(--ag-toggle-button-border-width));display:block;box-sizing:border-box;height:var(--ag-toggle-button-height);width:var(--ag-toggle-button-height);background-color:var(--ag-toggle-button-switch-background-color);border-radius:100%;transition:left .1s;border:var(--ag-toggle-button-border-width) solid;border-color:var(--ag-toggle-button-switch-border-color)}.ag-toggle-button-input-wrapper.ag-checked:before{left:calc(100% - var(--ag-toggle-button-height) + var(--ag-toggle-button-border-width));border-color:var(--ag-toggle-button-on-border-color)}.ag-radio-button-input-wrapper{font-family:var(--ag-icon-font-family);font-weight:var(--ag-icon-font-weight);color:var(--ag-icon-font-color);font-size:var(--ag-icon-size);line-height:var(--ag-icon-size);font-style:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:var(--ag-icon-size);height:var(--ag-icon-size);background-color:var(--ag-checkbox-background-color);border-radius:var(--ag-checkbox-border-radius);display:inline-block;vertical-align:middle;flex:none;border-radius:var(--ag-icon-size)}.ag-radio-button-input-wrapper input{-webkit-appearance:none;opacity:0;width:100%;height:100%}.ag-radio-button-input-wrapper:focus-within,.ag-radio-button-input-wrapper:active{outline:none;box-shadow:var(--ag-input-focus-box-shadow)}.ag-radio-button-input-wrapper.ag-disabled{opacity:.5}.ag-radio-button-input-wrapper:after{content:var(--ag-icon-font-code-radio-button-off, "");color:var(--ag-checkbox-unchecked-color);display:var(--ag-icon-font-display-radio-button-off, var(--ag-icon-font-display));position:absolute;top:0;left:0;pointer-events:none}.ag-radio-button-input-wrapper.ag-checked:after{content:var(--ag-icon-font-code-radio-button-on, "");color:var(--ag-checkbox-checked-color);display:var(--ag-icon-font-display-radio-button-on, var(--ag-icon-font-display));position:absolute;top:0;left:0;pointer-events:none}.ag-radio-button-input-wrapper:before{content:"";background:transparent center/contain no-repeat;position:absolute;top:0;right:0;bottom:0;left:0;background-image:var(--ag-icon-image-radio-button-off, var(--ag-icon-image));display:var(--ag-icon-image-display-radio-button-off, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-radio-button-off, var(--ag-icon-image-opacity, .9))}.ag-radio-button-input-wrapper.ag-checked:before{background-image:var(--ag-icon-image-radio-button-on, var(--ag-icon-image));display:var(--ag-icon-image-display-radio-button-on, var(--ag-icon-image-display));opacity:var(--ag-icon-image-opacity-radio-button-on, var(--ag-icon-image-opacity, .9))}input[class^=ag-][type=range]{-webkit-appearance:none;width:100%;height:100%;background:none;overflow:visible}input[class^=ag-][type=range]::-webkit-slider-runnable-track{margin:0;padding:0;width:100%;height:3px;background-color:var(--ag-border-color);border-radius:var(--ag-border-radius);border-radius:var(--ag-checkbox-border-radius)}input[class^=ag-][type=range]::-moz-range-track{margin:0;padding:0;width:100%;height:3px;background-color:var(--ag-border-color);border-radius:var(--ag-border-radius);border-radius:var(--ag-checkbox-border-radius)}input[class^=ag-][type=range]::-ms-track{margin:0;padding:0;width:100%;height:3px;background-color:var(--ag-border-color);border-radius:var(--ag-border-radius);border-radius:var(--ag-checkbox-border-radius);color:transparent;width:calc(100% - 2px)}input[class^=ag-][type=range]::-webkit-slider-thumb{margin:0;padding:0;-webkit-appearance:none;width:var(--ag-icon-size);height:var(--ag-icon-size);background-color:var(--ag-background-color);border:1px solid;border-color:var(--ag-checkbox-unchecked-color);border-radius:var(--ag-icon-size);transform:translateY(calc(var(--ag-icon-size) * -.5 + 1.5px))}input[class^=ag-][type=range]::-ms-thumb{margin:0;padding:0;-webkit-appearance:none;width:var(--ag-icon-size);height:var(--ag-icon-size);background-color:var(--ag-background-color);border:1px solid;border-color:var(--ag-checkbox-unchecked-color);border-radius:var(--ag-icon-size)}input[class^=ag-][type=range]::-moz-ag-range-thumb{margin:0;padding:0;-webkit-appearance:none;width:var(--ag-icon-size);height:var(--ag-icon-size);background-color:var(--ag-background-color);border:1px solid;border-color:var(--ag-checkbox-unchecked-color);border-radius:var(--ag-icon-size)}input[class^=ag-][type=range]:focus{outline:none}input[class^=ag-][type=range]:focus::-webkit-slider-thumb{box-shadow:var(--ag-input-focus-box-shadow);border-color:var(--ag-checkbox-checked-color)}input[class^=ag-][type=range]:focus::-ms-thumb{box-shadow:var(--ag-input-focus-box-shadow);border-color:var(--ag-checkbox-checked-color)}input[class^=ag-][type=range]:focus::-moz-ag-range-thumb{box-shadow:var(--ag-input-focus-box-shadow);border-color:var(--ag-checkbox-checked-color)}input[class^=ag-][type=range]:active::-webkit-slider-runnable-track{background-color:var(--ag-input-focus-border-color)}input[class^=ag-][type=range]:active::-moz-ag-range-track{background-color:var(--ag-input-focus-border-color)}input[class^=ag-][type=range]:active::-ms-track{background-color:var(--ag-input-focus-border-color)}input[class^=ag-][type=range]:disabled{opacity:.5}
`), It(`@font-face{font-family:agGridAlpine;src:url(data:font/woff2;charset=utf-8;base64,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);font-weight:400;font-style:normal}.ag-theme-alpine,.ag-theme-alpine-dark,.ag-theme-alpine-auto-dark{--ag-alpine-active-color: #2196f3;--ag-selected-row-background-color: rgba(33, 150, 243, .3);--ag-row-hover-color: rgba(33, 150, 243, .1);--ag-column-hover-color: rgba(33, 150, 243, .1);--ag-input-focus-border-color: rgba(33, 150, 243, .4);--ag-range-selection-background-color: rgba(33, 150, 243, .2);--ag-range-selection-background-color-2: rgba(33, 150, 243, .36);--ag-range-selection-background-color-3: rgba(33, 150, 243, .49);--ag-range-selection-background-color-4: rgba(33, 150, 243, .59);--ag-background-color: #fff;--ag-foreground-color: #181d1f;--ag-border-color: #babfc7;--ag-secondary-border-color: #dde2eb;--ag-header-background-color: #f8f8f8;--ag-tooltip-background-color: #f8f8f8;--ag-odd-row-background-color: #fcfcfc;--ag-control-panel-background-color: #f8f8f8;--ag-subheader-background-color: #fff;--ag-invalid-color: #e02525;--ag-checkbox-unchecked-color: #999;--ag-advanced-filter-join-pill-color: #f08e8d;--ag-advanced-filter-column-pill-color: #a6e194;--ag-advanced-filter-option-pill-color: #f3c08b;--ag-advanced-filter-value-pill-color: #85c0e4;--ag-checkbox-background-color: var(--ag-background-color);--ag-checkbox-checked-color: var(--ag-alpine-active-color);--ag-range-selection-border-color: var(--ag-alpine-active-color);--ag-secondary-foreground-color: var(--ag-foreground-color);--ag-input-border-color: var(--ag-border-color);--ag-input-border-color-invalid: var(--ag-invalid-color);--ag-input-focus-box-shadow: 0 0 2px .1rem var(--ag-input-focus-border-color);--ag-panel-background-color: var(--ag-header-background-color);--ag-menu-background-color: var(--ag-header-background-color);--ag-disabled-foreground-color: rgba(24, 29, 31, .5);--ag-chip-background-color: rgba(24, 29, 31, .07);--ag-input-disabled-border-color: rgba(186, 191, 199, .3);--ag-input-disabled-background-color: rgba(186, 191, 199, .15);--ag-borders: solid 1px;--ag-border-radius: 3px;--ag-borders-side-button: none;--ag-side-button-selected-background-color: transparent;--ag-header-column-resize-handle-display: block;--ag-header-column-resize-handle-width: 2px;--ag-header-column-resize-handle-height: 30%;--ag-grid-size: 6px;--ag-icon-size: 16px;--ag-row-height: calc(var(--ag-grid-size) * 7);--ag-header-height: calc(var(--ag-grid-size) * 8);--ag-list-item-height: calc(var(--ag-grid-size) * 4);--ag-column-select-indent-size: var(--ag-icon-size);--ag-set-filter-indent-size: var(--ag-icon-size);--ag-advanced-filter-builder-indent-size: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);--ag-cell-horizontal-padding: calc(var(--ag-grid-size) * 3);--ag-cell-widget-spacing: calc(var(--ag-grid-size) * 2);--ag-widget-container-vertical-padding: calc(var(--ag-grid-size) * 2);--ag-widget-container-horizontal-padding: calc(var(--ag-grid-size) * 2);--ag-widget-vertical-spacing: calc(var(--ag-grid-size) * 1.5);--ag-toggle-button-height: 18px;--ag-toggle-button-width: 28px;--ag-font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;--ag-font-size: 13px;--ag-icon-font-family: agGridAlpine;--ag-selected-tab-underline-color: var(--ag-alpine-active-color);--ag-selected-tab-underline-width: 2px;--ag-selected-tab-underline-transition-speed: .3s;--ag-tab-min-width: 240px;--ag-card-shadow: 0 1px 4px 1px rgba(186, 191, 199, .4);--ag-popup-shadow: var(--ag-card-shadow);--ag-side-bar-panel-width: 250px}.ag-theme-alpine-dark{--ag-background-color: #181d1f;--ag-foreground-color: #fff;--ag-border-color: #68686e;--ag-secondary-border-color: rgba(88, 86, 82, .5);--ag-modal-overlay-background-color: rgba(24, 29, 31, .66);--ag-header-background-color: #222628;--ag-tooltip-background-color: #222628;--ag-odd-row-background-color: #222628;--ag-control-panel-background-color: #222628;--ag-subheader-background-color: #000;--ag-input-disabled-background-color: #282c2f;--ag-input-focus-box-shadow: 0 0 2px .5px rgba(255, 255, 255, .5), 0 0 4px 3px var(--ag-input-focus-border-color);--ag-card-shadow: 0 1px 20px 1px black;--ag-disabled-foreground-color: rgba(255, 255, 255, .5);--ag-chip-background-color: rgba(255, 255, 255, .07);--ag-input-disabled-border-color: rgba(104, 104, 110, .3);--ag-input-disabled-background-color: rgba(104, 104, 110, .07);--ag-advanced-filter-join-pill-color: #7a3a37;--ag-advanced-filter-column-pill-color: #355f2d;--ag-advanced-filter-option-pill-color: #5a3168;--ag-advanced-filter-value-pill-color: #374c86;--ag-row-loading-skeleton-effect-color: rgba(202, 203, 204, .4);color-scheme:dark}@media (prefers-color-scheme: dark){.ag-theme-alpine-auto-dark{--ag-background-color: #181d1f;--ag-foreground-color: #fff;--ag-border-color: #68686e;--ag-secondary-border-color: rgba(88, 86, 82, .5);--ag-modal-overlay-background-color: rgba(24, 29, 31, .66);--ag-header-background-color: #222628;--ag-tooltip-background-color: #222628;--ag-odd-row-background-color: #222628;--ag-control-panel-background-color: #222628;--ag-subheader-background-color: #000;--ag-input-disabled-background-color: #282c2f;--ag-input-focus-box-shadow: 0 0 2px .5px rgba(255, 255, 255, .5), 0 0 4px 3px var(--ag-input-focus-border-color);--ag-card-shadow: 0 1px 20px 1px black;--ag-disabled-foreground-color: rgba(255, 255, 255, .5);--ag-chip-background-color: rgba(255, 255, 255, .07);--ag-input-disabled-border-color: rgba(104, 104, 110, .3);--ag-input-disabled-background-color: rgba(104, 104, 110, .07);--ag-advanced-filter-join-pill-color: #7a3a37;--ag-advanced-filter-column-pill-color: #355f2d;--ag-advanced-filter-option-pill-color: #5a3168;--ag-advanced-filter-value-pill-color: #374c86;--ag-row-loading-skeleton-effect-color: rgba(202, 203, 204, .4);color-scheme:dark}}.ag-theme-alpine .ag-filter-toolpanel-header,.ag-theme-alpine .ag-filter-toolpanel-search,.ag-theme-alpine .ag-status-bar,.ag-theme-alpine .ag-header-row,.ag-theme-alpine .ag-panel-title-bar-title,.ag-theme-alpine .ag-multi-filter-group-title-bar,.ag-theme-alpine-dark .ag-filter-toolpanel-header,.ag-theme-alpine-dark .ag-filter-toolpanel-search,.ag-theme-alpine-dark .ag-status-bar,.ag-theme-alpine-dark .ag-header-row,.ag-theme-alpine-dark .ag-panel-title-bar-title,.ag-theme-alpine-dark .ag-multi-filter-group-title-bar,.ag-theme-alpine-auto-dark .ag-filter-toolpanel-header,.ag-theme-alpine-auto-dark .ag-filter-toolpanel-search,.ag-theme-alpine-auto-dark .ag-status-bar,.ag-theme-alpine-auto-dark .ag-header-row,.ag-theme-alpine-auto-dark .ag-panel-title-bar-title,.ag-theme-alpine-auto-dark .ag-multi-filter-group-title-bar{font-weight:700;color:var(--ag-header-foreground-color)}.ag-theme-alpine .ag-row,.ag-theme-alpine-dark .ag-row,.ag-theme-alpine-auto-dark .ag-row{font-size:calc(var(--ag-font-size) + 1px)}.ag-theme-alpine input[class^=ag-]:not([type]),.ag-theme-alpine input[class^=ag-][type=text],.ag-theme-alpine input[class^=ag-][type=number],.ag-theme-alpine input[class^=ag-][type=tel],.ag-theme-alpine input[class^=ag-][type=date],.ag-theme-alpine input[class^=ag-][type=datetime-local],.ag-theme-alpine textarea[class^=ag-],.ag-theme-alpine-dark input[class^=ag-]:not([type]),.ag-theme-alpine-dark input[class^=ag-][type=text],.ag-theme-alpine-dark input[class^=ag-][type=number],.ag-theme-alpine-dark input[class^=ag-][type=tel],.ag-theme-alpine-dark input[class^=ag-][type=date],.ag-theme-alpine-dark input[class^=ag-][type=datetime-local],.ag-theme-alpine-dark textarea[class^=ag-],.ag-theme-alpine-auto-dark input[class^=ag-]:not([type]),.ag-theme-alpine-auto-dark input[class^=ag-][type=text],.ag-theme-alpine-auto-dark input[class^=ag-][type=number],.ag-theme-alpine-auto-dark input[class^=ag-][type=tel],.ag-theme-alpine-auto-dark input[class^=ag-][type=date],.ag-theme-alpine-auto-dark input[class^=ag-][type=datetime-local],.ag-theme-alpine-auto-dark textarea[class^=ag-]{min-height:calc(var(--ag-grid-size) * 4);border-radius:var(--ag-border-radius)}.ag-theme-alpine .ag-ltr input[class^=ag-]:not([type]),.ag-theme-alpine .ag-ltr input[class^=ag-][type=text],.ag-theme-alpine .ag-ltr input[class^=ag-][type=number],.ag-theme-alpine .ag-ltr input[class^=ag-][type=tel],.ag-theme-alpine .ag-ltr input[class^=ag-][type=date],.ag-theme-alpine .ag-ltr input[class^=ag-][type=datetime-local],.ag-theme-alpine .ag-ltr textarea[class^=ag-],.ag-theme-alpine-dark .ag-ltr input[class^=ag-]:not([type]),.ag-theme-alpine-dark .ag-ltr input[class^=ag-][type=text],.ag-theme-alpine-dark .ag-ltr input[class^=ag-][type=number],.ag-theme-alpine-dark .ag-ltr input[class^=ag-][type=tel],.ag-theme-alpine-dark .ag-ltr input[class^=ag-][type=date],.ag-theme-alpine-dark .ag-ltr input[class^=ag-][type=datetime-local],.ag-theme-alpine-dark .ag-ltr textarea[class^=ag-],.ag-theme-alpine-auto-dark .ag-ltr input[class^=ag-]:not([type]),.ag-theme-alpine-auto-dark .ag-ltr input[class^=ag-][type=text],.ag-theme-alpine-auto-dark .ag-ltr input[class^=ag-][type=number],.ag-theme-alpine-auto-dark .ag-ltr input[class^=ag-][type=tel],.ag-theme-alpine-auto-dark .ag-ltr input[class^=ag-][type=date],.ag-theme-alpine-auto-dark .ag-ltr input[class^=ag-][type=datetime-local],.ag-theme-alpine-auto-dark .ag-ltr textarea[class^=ag-]{padding-left:var(--ag-grid-size)}.ag-theme-alpine .ag-rtl input[class^=ag-]:not([type]),.ag-theme-alpine .ag-rtl input[class^=ag-][type=text],.ag-theme-alpine .ag-rtl input[class^=ag-][type=number],.ag-theme-alpine .ag-rtl input[class^=ag-][type=tel],.ag-theme-alpine .ag-rtl input[class^=ag-][type=date],.ag-theme-alpine .ag-rtl input[class^=ag-][type=datetime-local],.ag-theme-alpine .ag-rtl textarea[class^=ag-],.ag-theme-alpine-dark .ag-rtl input[class^=ag-]:not([type]),.ag-theme-alpine-dark .ag-rtl input[class^=ag-][type=text],.ag-theme-alpine-dark .ag-rtl input[class^=ag-][type=number],.ag-theme-alpine-dark .ag-rtl input[class^=ag-][type=tel],.ag-theme-alpine-dark .ag-rtl input[class^=ag-][type=date],.ag-theme-alpine-dark .ag-rtl input[class^=ag-][type=datetime-local],.ag-theme-alpine-dark .ag-rtl textarea[class^=ag-],.ag-theme-alpine-auto-dark .ag-rtl input[class^=ag-]:not([type]),.ag-theme-alpine-auto-dark .ag-rtl input[class^=ag-][type=text],.ag-theme-alpine-auto-dark .ag-rtl input[class^=ag-][type=number],.ag-theme-alpine-auto-dark .ag-rtl input[class^=ag-][type=tel],.ag-theme-alpine-auto-dark .ag-rtl input[class^=ag-][type=date],.ag-theme-alpine-auto-dark .ag-rtl input[class^=ag-][type=datetime-local],.ag-theme-alpine-auto-dark .ag-rtl textarea[class^=ag-]{padding-right:var(--ag-grid-size)}.ag-theme-alpine .ag-tab,.ag-theme-alpine-dark .ag-tab,.ag-theme-alpine-auto-dark .ag-tab{padding:calc(var(--ag-grid-size) * 1.5);transition:color .4s;flex:1 1 auto}.ag-theme-alpine .ag-tab-selected,.ag-theme-alpine-dark .ag-tab-selected,.ag-theme-alpine-auto-dark .ag-tab-selected{color:var(--ag-alpine-active-color)}.ag-theme-alpine .ag-menu,.ag-theme-alpine-dark .ag-menu,.ag-theme-alpine-auto-dark .ag-menu,.ag-theme-alpine .ag-panel-content-wrapper .ag-column-select,.ag-theme-alpine-dark .ag-panel-content-wrapper .ag-column-select,.ag-theme-alpine-auto-dark .ag-panel-content-wrapper .ag-column-select{background-color:var(--ag-control-panel-background-color)}.ag-theme-alpine .ag-menu-header,.ag-theme-alpine-dark .ag-menu-header,.ag-theme-alpine-auto-dark .ag-menu-header{background-color:var(--ag-control-panel-background-color);padding-top:1px}.ag-theme-alpine .ag-tabs-header,.ag-theme-alpine-dark .ag-tabs-header,.ag-theme-alpine-auto-dark .ag-tabs-header{border-bottom:var(--ag-borders) var(--ag-border-color)}.ag-theme-alpine .ag-charts-settings-group-title-bar,.ag-theme-alpine .ag-charts-data-group-title-bar,.ag-theme-alpine .ag-charts-format-top-level-group-title-bar,.ag-theme-alpine .ag-charts-advanced-settings-top-level-group-title-bar,.ag-theme-alpine-dark .ag-charts-settings-group-title-bar,.ag-theme-alpine-dark .ag-charts-data-group-title-bar,.ag-theme-alpine-dark .ag-charts-format-top-level-group-title-bar,.ag-theme-alpine-dark .ag-charts-advanced-settings-top-level-group-title-bar,.ag-theme-alpine-auto-dark .ag-charts-settings-group-title-bar,.ag-theme-alpine-auto-dark .ag-charts-data-group-title-bar,.ag-theme-alpine-auto-dark .ag-charts-format-top-level-group-title-bar,.ag-theme-alpine-auto-dark .ag-charts-advanced-settings-top-level-group-title-bar{padding:var(--ag-grid-size) calc(var(--ag-grid-size) * 2);line-height:calc(var(--ag-icon-size) + var(--ag-grid-size) - 2px)}.ag-theme-alpine .ag-chart-mini-thumbnail,.ag-theme-alpine-dark .ag-chart-mini-thumbnail,.ag-theme-alpine-auto-dark .ag-chart-mini-thumbnail{background-color:var(--ag-background-color)}.ag-theme-alpine .ag-chart-settings-nav-bar,.ag-theme-alpine-dark .ag-chart-settings-nav-bar,.ag-theme-alpine-auto-dark .ag-chart-settings-nav-bar{border-top:var(--ag-borders-secondary) var(--ag-secondary-border-color)}.ag-theme-alpine .ag-ltr .ag-group-title-bar-icon,.ag-theme-alpine-dark .ag-ltr .ag-group-title-bar-icon,.ag-theme-alpine-auto-dark .ag-ltr .ag-group-title-bar-icon{margin-right:var(--ag-grid-size)}.ag-theme-alpine .ag-rtl .ag-group-title-bar-icon,.ag-theme-alpine-dark .ag-rtl .ag-group-title-bar-icon,.ag-theme-alpine-auto-dark .ag-rtl .ag-group-title-bar-icon{margin-left:var(--ag-grid-size)}.ag-theme-alpine .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine .ag-charts-advanced-settings-top-level-group-toolbar,.ag-theme-alpine-dark .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine-dark .ag-charts-advanced-settings-top-level-group-toolbar,.ag-theme-alpine-auto-dark .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine-auto-dark .ag-charts-advanced-settings-top-level-group-toolbar{margin-top:var(--ag-grid-size)}.ag-theme-alpine .ag-ltr .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine .ag-ltr .ag-charts-advanced-settings-top-level-group-toolbar,.ag-theme-alpine-dark .ag-ltr .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine-dark .ag-ltr .ag-charts-advanced-settings-top-level-group-toolbar,.ag-theme-alpine-auto-dark .ag-ltr .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine-auto-dark .ag-ltr .ag-charts-advanced-settings-top-level-group-toolbar{padding-left:calc(var(--ag-icon-size) * .5 + var(--ag-grid-size) * 2)}.ag-theme-alpine .ag-rtl .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine .ag-rtl .ag-charts-advanced-settings-top-level-group-toolbar,.ag-theme-alpine-dark .ag-rtl .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine-dark .ag-rtl .ag-charts-advanced-settings-top-level-group-toolbar,.ag-theme-alpine-auto-dark .ag-rtl .ag-charts-format-top-level-group-toolbar,.ag-theme-alpine-auto-dark .ag-rtl .ag-charts-advanced-settings-top-level-group-toolbar{padding-right:calc(var(--ag-icon-size) * .5 + var(--ag-grid-size) * 2)}.ag-theme-alpine .ag-charts-format-sub-level-group,.ag-theme-alpine-dark .ag-charts-format-sub-level-group,.ag-theme-alpine-auto-dark .ag-charts-format-sub-level-group{border-left:dashed 1px;border-left-color:var(--ag-border-color);padding-left:var(--ag-grid-size);margin-bottom:calc(var(--ag-grid-size) * 2)}.ag-theme-alpine .ag-charts-format-sub-level-group-title-bar,.ag-theme-alpine-dark .ag-charts-format-sub-level-group-title-bar,.ag-theme-alpine-auto-dark .ag-charts-format-sub-level-group-title-bar{padding-top:0;padding-bottom:0;background:none;font-weight:700}.ag-theme-alpine .ag-charts-format-sub-level-group-container,.ag-theme-alpine-dark .ag-charts-format-sub-level-group-container,.ag-theme-alpine-auto-dark .ag-charts-format-sub-level-group-container{padding-bottom:0}.ag-theme-alpine .ag-charts-format-sub-level-group-item:last-child,.ag-theme-alpine-dark .ag-charts-format-sub-level-group-item:last-child,.ag-theme-alpine-auto-dark .ag-charts-format-sub-level-group-item:last-child{margin-bottom:0}.ag-theme-alpine.ag-dnd-ghost,.ag-theme-alpine-dark.ag-dnd-ghost,.ag-theme-alpine-auto-dark.ag-dnd-ghost{font-size:calc(var(--ag-font-size) - 1px);font-weight:700}.ag-theme-alpine .ag-side-buttons,.ag-theme-alpine-dark .ag-side-buttons,.ag-theme-alpine-auto-dark .ag-side-buttons{width:calc(var(--ag-grid-size) * 5)}.ag-theme-alpine .ag-standard-button,.ag-theme-alpine-dark .ag-standard-button,.ag-theme-alpine-auto-dark .ag-standard-button{font-family:inherit;-moz-appearance:none;appearance:none;-webkit-appearance:none;border-radius:var(--ag-border-radius);border:1px solid;border-color:var(--ag-alpine-active-color);color:var(--ag-alpine-active-color);background-color:var(--ag-background-color);font-weight:600;padding:var(--ag-grid-size) calc(var(--ag-grid-size) * 2)}.ag-theme-alpine .ag-standard-button:hover,.ag-theme-alpine-dark .ag-standard-button:hover,.ag-theme-alpine-auto-dark .ag-standard-button:hover{border-color:var(--ag-alpine-active-color);background-color:var(--ag-row-hover-color)}.ag-theme-alpine .ag-standard-button:active,.ag-theme-alpine-dark .ag-standard-button:active,.ag-theme-alpine-auto-dark .ag-standard-button:active{border-color:var(--ag-alpine-active-color);background-color:var(--ag-alpine-active-color);color:var(--ag-background-color)}.ag-theme-alpine .ag-standard-button:disabled,.ag-theme-alpine-dark .ag-standard-button:disabled,.ag-theme-alpine-auto-dark .ag-standard-button:disabled{color:var(--ag-disabled-foreground-color);background-color:var(--ag-input-disabled-background-color);border-color:var(--ag-input-disabled-border-color)}.ag-theme-alpine .ag-column-drop-vertical,.ag-theme-alpine-dark .ag-column-drop-vertical,.ag-theme-alpine-auto-dark .ag-column-drop-vertical{min-height:75px}.ag-theme-alpine .ag-column-drop-vertical-title-bar,.ag-theme-alpine-dark .ag-column-drop-vertical-title-bar,.ag-theme-alpine-auto-dark .ag-column-drop-vertical-title-bar{padding:calc(var(--ag-grid-size) * 2);padding-bottom:0}.ag-theme-alpine .ag-column-drop-vertical-empty-message,.ag-theme-alpine-dark .ag-column-drop-vertical-empty-message,.ag-theme-alpine-auto-dark .ag-column-drop-vertical-empty-message{display:flex;align-items:center;border:dashed 1px;border-color:var(--ag-border-color);margin:calc(var(--ag-grid-size) * 2);padding:calc(var(--ag-grid-size) * 2)}.ag-theme-alpine .ag-column-drop-empty-message,.ag-theme-alpine-dark .ag-column-drop-empty-message,.ag-theme-alpine-auto-dark .ag-column-drop-empty-message{color:var(--ag-foreground-color);opacity:.75}.ag-theme-alpine .ag-pill-select .ag-column-drop,.ag-theme-alpine-dark .ag-pill-select .ag-column-drop,.ag-theme-alpine-auto-dark .ag-pill-select .ag-column-drop{min-height:unset}.ag-theme-alpine .ag-status-bar,.ag-theme-alpine-dark .ag-status-bar,.ag-theme-alpine-auto-dark .ag-status-bar{font-weight:400}.ag-theme-alpine .ag-status-name-value-value,.ag-theme-alpine-dark .ag-status-name-value-value,.ag-theme-alpine-auto-dark .ag-status-name-value-value,.ag-theme-alpine .ag-paging-number,.ag-theme-alpine .ag-paging-row-summary-panel-number,.ag-theme-alpine-dark .ag-paging-number,.ag-theme-alpine-dark .ag-paging-row-summary-panel-number,.ag-theme-alpine-auto-dark .ag-paging-number,.ag-theme-alpine-auto-dark .ag-paging-row-summary-panel-number{font-weight:700}.ag-theme-alpine .ag-column-drop-cell-button,.ag-theme-alpine-dark .ag-column-drop-cell-button,.ag-theme-alpine-auto-dark .ag-column-drop-cell-button{opacity:.5}.ag-theme-alpine .ag-column-drop-cell-button:hover,.ag-theme-alpine-dark .ag-column-drop-cell-button:hover,.ag-theme-alpine-auto-dark .ag-column-drop-cell-button:hover{opacity:.75}.ag-theme-alpine .ag-column-select-column-readonly.ag-icon-grip,.ag-theme-alpine .ag-column-select-column-readonly .ag-icon-grip,.ag-theme-alpine-dark .ag-column-select-column-readonly.ag-icon-grip,.ag-theme-alpine-dark .ag-column-select-column-readonly .ag-icon-grip,.ag-theme-alpine-auto-dark .ag-column-select-column-readonly.ag-icon-grip,.ag-theme-alpine-auto-dark .ag-column-select-column-readonly .ag-icon-grip{opacity:.35}.ag-theme-alpine .ag-header-cell-menu-button:hover,.ag-theme-alpine .ag-header-cell-filter-button:hover,.ag-theme-alpine .ag-side-button-button:hover,.ag-theme-alpine .ag-tab:hover,.ag-theme-alpine .ag-panel-title-bar-button:hover,.ag-theme-alpine .ag-header-expand-icon:hover,.ag-theme-alpine .ag-column-group-icons:hover,.ag-theme-alpine .ag-set-filter-group-icons:hover,.ag-theme-alpine .ag-group-expanded .ag-icon:hover,.ag-theme-alpine .ag-group-contracted .ag-icon:hover,.ag-theme-alpine .ag-chart-settings-prev:hover,.ag-theme-alpine .ag-chart-settings-next:hover,.ag-theme-alpine .ag-group-title-bar-icon:hover,.ag-theme-alpine .ag-column-select-header-icon:hover,.ag-theme-alpine .ag-floating-filter-button-button:hover,.ag-theme-alpine .ag-filter-toolpanel-expand:hover,.ag-theme-alpine .ag-chart-menu-icon:hover,.ag-theme-alpine-dark .ag-header-cell-menu-button:hover,.ag-theme-alpine-dark .ag-header-cell-filter-button:hover,.ag-theme-alpine-dark .ag-side-button-button:hover,.ag-theme-alpine-dark .ag-tab:hover,.ag-theme-alpine-dark .ag-panel-title-bar-button:hover,.ag-theme-alpine-dark .ag-header-expand-icon:hover,.ag-theme-alpine-dark .ag-column-group-icons:hover,.ag-theme-alpine-dark .ag-set-filter-group-icons:hover,.ag-theme-alpine-dark .ag-group-expanded .ag-icon:hover,.ag-theme-alpine-dark .ag-group-contracted .ag-icon:hover,.ag-theme-alpine-dark .ag-chart-settings-prev:hover,.ag-theme-alpine-dark .ag-chart-settings-next:hover,.ag-theme-alpine-dark .ag-group-title-bar-icon:hover,.ag-theme-alpine-dark .ag-column-select-header-icon:hover,.ag-theme-alpine-dark .ag-floating-filter-button-button:hover,.ag-theme-alpine-dark .ag-filter-toolpanel-expand:hover,.ag-theme-alpine-dark .ag-chart-menu-icon:hover,.ag-theme-alpine-auto-dark .ag-header-cell-menu-button:hover,.ag-theme-alpine-auto-dark .ag-header-cell-filter-button:hover,.ag-theme-alpine-auto-dark .ag-side-button-button:hover,.ag-theme-alpine-auto-dark .ag-tab:hover,.ag-theme-alpine-auto-dark .ag-panel-title-bar-button:hover,.ag-theme-alpine-auto-dark .ag-header-expand-icon:hover,.ag-theme-alpine-auto-dark .ag-column-group-icons:hover,.ag-theme-alpine-auto-dark .ag-set-filter-group-icons:hover,.ag-theme-alpine-auto-dark .ag-group-expanded .ag-icon:hover,.ag-theme-alpine-auto-dark .ag-group-contracted .ag-icon:hover,.ag-theme-alpine-auto-dark .ag-chart-settings-prev:hover,.ag-theme-alpine-auto-dark .ag-chart-settings-next:hover,.ag-theme-alpine-auto-dark .ag-group-title-bar-icon:hover,.ag-theme-alpine-auto-dark .ag-column-select-header-icon:hover,.ag-theme-alpine-auto-dark .ag-floating-filter-button-button:hover,.ag-theme-alpine-auto-dark .ag-filter-toolpanel-expand:hover,.ag-theme-alpine-auto-dark .ag-chart-menu-icon:hover{color:var(--ag-alpine-active-color)}.ag-theme-alpine .ag-header-cell-menu-button:hover .ag-icon,.ag-theme-alpine .ag-header-cell-filter-button:hover .ag-icon,.ag-theme-alpine .ag-side-button-button:hover .ag-icon,.ag-theme-alpine .ag-panel-title-bar-button:hover .ag-icon,.ag-theme-alpine .ag-floating-filter-button-button:hover .ag-icon,.ag-theme-alpine-dark .ag-header-cell-menu-button:hover .ag-icon,.ag-theme-alpine-dark .ag-header-cell-filter-button:hover .ag-icon,.ag-theme-alpine-dark .ag-side-button-button:hover .ag-icon,.ag-theme-alpine-dark .ag-panel-title-bar-button:hover .ag-icon,.ag-theme-alpine-dark .ag-floating-filter-button-button:hover .ag-icon,.ag-theme-alpine-auto-dark .ag-header-cell-menu-button:hover .ag-icon,.ag-theme-alpine-auto-dark .ag-header-cell-filter-button:hover .ag-icon,.ag-theme-alpine-auto-dark .ag-side-button-button:hover .ag-icon,.ag-theme-alpine-auto-dark .ag-panel-title-bar-button:hover .ag-icon,.ag-theme-alpine-auto-dark .ag-floating-filter-button-button:hover .ag-icon{color:inherit}.ag-theme-alpine .ag-filter-active .ag-icon-filter,.ag-theme-alpine-dark .ag-filter-active .ag-icon-filter,.ag-theme-alpine-auto-dark .ag-filter-active .ag-icon-filter{color:var(--ag-alpine-active-color)}.ag-theme-alpine .ag-chart-settings-card-item.ag-not-selected:hover,.ag-theme-alpine-dark .ag-chart-settings-card-item.ag-not-selected:hover,.ag-theme-alpine-auto-dark .ag-chart-settings-card-item.ag-not-selected:hover{opacity:.35}.ag-theme-alpine .ag-ltr .ag-panel-title-bar-button,.ag-theme-alpine-dark .ag-ltr .ag-panel-title-bar-button,.ag-theme-alpine-auto-dark .ag-ltr .ag-panel-title-bar-button{margin-left:calc(var(--ag-grid-size) * 2);margin-right:var(--ag-grid-size)}.ag-theme-alpine .ag-rtl .ag-panel-title-bar-button,.ag-theme-alpine-dark .ag-rtl .ag-panel-title-bar-button,.ag-theme-alpine-auto-dark .ag-rtl .ag-panel-title-bar-button{margin-right:calc(var(--ag-grid-size) * 2);margin-left:var(--ag-grid-size)}.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-group-container,.ag-theme-alpine-dark .ag-ltr .ag-filter-toolpanel-group-container,.ag-theme-alpine-auto-dark .ag-ltr .ag-filter-toolpanel-group-container{padding-left:var(--ag-grid-size)}.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-group-container,.ag-theme-alpine-dark .ag-rtl .ag-filter-toolpanel-group-container,.ag-theme-alpine-auto-dark .ag-rtl .ag-filter-toolpanel-group-container{padding-right:var(--ag-grid-size)}.ag-theme-alpine .ag-filter-toolpanel-instance-filter,.ag-theme-alpine-dark .ag-filter-toolpanel-instance-filter,.ag-theme-alpine-auto-dark .ag-filter-toolpanel-instance-filter{border:none;background-color:var(--ag-control-panel-background-color)}.ag-theme-alpine .ag-ltr .ag-filter-toolpanel-instance-filter,.ag-theme-alpine-dark .ag-ltr .ag-filter-toolpanel-instance-filter,.ag-theme-alpine-auto-dark .ag-ltr .ag-filter-toolpanel-instance-filter{border-left:dashed 1px;border-left-color:var(--ag-border-color);margin-left:calc(var(--ag-icon-size) * .5)}.ag-theme-alpine .ag-rtl .ag-filter-toolpanel-instance-filter,.ag-theme-alpine-dark .ag-rtl .ag-filter-toolpanel-instance-filter,.ag-theme-alpine-auto-dark .ag-rtl .ag-filter-toolpanel-instance-filter{border-right:dashed 1px;border-right-color:var(--ag-border-color);margin-right:calc(var(--ag-icon-size) * .5)}.ag-theme-alpine .ag-set-filter-list,.ag-theme-alpine-dark .ag-set-filter-list,.ag-theme-alpine-auto-dark .ag-set-filter-list{padding-top:calc(var(--ag-grid-size) * .5);padding-bottom:calc(var(--ag-grid-size) * .5)}.ag-theme-alpine .ag-layout-auto-height .ag-center-cols-viewport,.ag-theme-alpine .ag-layout-auto-height .ag-center-cols-container,.ag-theme-alpine .ag-layout-print .ag-center-cols-viewport,.ag-theme-alpine .ag-layout-print .ag-center-cols-container,.ag-theme-alpine-dark .ag-layout-auto-height .ag-center-cols-viewport,.ag-theme-alpine-dark .ag-layout-auto-height .ag-center-cols-container,.ag-theme-alpine-dark .ag-layout-print .ag-center-cols-viewport,.ag-theme-alpine-dark .ag-layout-print .ag-center-cols-container,.ag-theme-alpine-auto-dark .ag-layout-auto-height .ag-center-cols-viewport,.ag-theme-alpine-auto-dark .ag-layout-auto-height .ag-center-cols-container,.ag-theme-alpine-auto-dark .ag-layout-print .ag-center-cols-viewport,.ag-theme-alpine-auto-dark .ag-layout-print .ag-center-cols-container{min-height:150px}.ag-theme-alpine .ag-overlay-no-rows-wrapper.ag-layout-auto-height,.ag-theme-alpine-dark .ag-overlay-no-rows-wrapper.ag-layout-auto-height,.ag-theme-alpine-auto-dark .ag-overlay-no-rows-wrapper.ag-layout-auto-height{padding-top:60px}.ag-theme-alpine .ag-date-time-list-page-entry-is-current,.ag-theme-alpine-dark .ag-date-time-list-page-entry-is-current,.ag-theme-alpine-auto-dark .ag-date-time-list-page-entry-is-current{background-color:var(--ag-alpine-active-color)}.ag-theme-alpine .ag-advanced-filter-builder-button,.ag-theme-alpine-dark .ag-advanced-filter-builder-button,.ag-theme-alpine-auto-dark .ag-advanced-filter-builder-button{padding:var(--ag-grid-size);font-weight:600}
`), It(`
      @font-face {
        font-family: "agGridAlpine";
        src: url(data:font/woff2;charset=utf-8;base64,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);
        font-weight: normal;
        font-style: normal;
      }`), It(`:host{--exo-component-table-body-min-height: 150px;--exo-component-table-body-margin-bottom: var(--exo-spacing-none);--exo-component-table-cell-padding-top: 2px;--exo-component-table-row-default-alt-background: rgba(245, 245, 245, .5);--exo-component-table-select-height: 32px;--exo-component-table-header-left: 0px;--exo-component-table-edit-cell-top: 2px;--exo-component-table-selected-indicator-display: flex;--exo-component-table-body-height: unset}.ag-theme-alpine{width:100%;height:100%;border-radius:var(--exo-radius-large);margin-bottom:var(--exo-spacing-2x-small);--ag-header-height: calc( var(--exo-spacing-x-large) + var(--exo-spacing-2x-small) + calc(var(--exo-spacing-4x-small)) );--ag-header-cell-hover-background-color: var( --exo-color-background-action-hover-weak );--ag-header-background-color: var(--exo-color-background);--ag-header-foreground-color: var(--exo-color-font);--ag-background-color: var(--exo-color-background);--ag-foreground-color: var(--exo-color-font);--ag-odd-row-background-color: var(--exo-color-background);--ag-data-color: var(--exo-color-font);--ag-selected-row-background-color: var(--exo-color-background-selected-weak);--ag-row-hover-color: var(--exo-color-background-secondary);--ag-font-size: var(--exo-font-size-small);--ag-font-family: var(--exo-font-family);--ag-borders: none;--ag-borders-row: solid var(--exo-spacing-4x-small);--ag-row-border-color: var(--exo-color-border);--ag-border-color: var(--exo-color-border);--ag-checkbox-background-color: var(--exo-color-background);--ag-checkbox-checked-color: var(--exo-color-background-selected);--ag-checkbox-indeterminate-color: var(--exo-color-background-selected);--ag-card-radius: var(--exo-radius-large);--ag-card-shadow: var(--exo-box-shadow-moderate);--ag-popup-shadow: var(--exo-box-shadow-moderate);--ag-borders-input: solid var(--exo-spacing-4x-small);--ag-input-border-color: var(--exo-color-border);--ag-checkbox-border-radius: var(--exo-spacing-3x-small);--ag-alpine-active-color: var(--exo-color-outline-strong);--ag-disabled-foreground-color: var(--exo-color-font);--ag-modal-overlay-background-color: var(--exo-color-scrim);--ag-tooltip-background-color: var(--exo-color-background-action-inverse)}.ag-theme-alpine--editable-content{--ag-row-height: calc( var(--exo-font-size-6x-large) + var(--exo-font-size-small) )}.ag-theme-alpine.ag-theme-alpine--overflow-visible .ag-root-wrapper.ag-layout-auto-height,.ag-theme-alpine.ag-theme-alpine--overflow-visible .ag-root.ag-layout-auto-height,.ag-theme-alpine.ag-theme-alpine--overflow-visible .ag-body-viewport,.ag-theme-alpine.ag-theme-alpine--overflow-visible .ag-body-clipper,.ag-theme-alpine.ag-theme-alpine--overflow-visible .ag-center-cols-clipper,.ag-theme-alpine.ag-theme-alpine--overflow-visible .ag-center-cols-viewport{overflow:visible}.ag-theme-alpine.ag-theme-alpine--overflow-visible .ag-center-cols-viewport{overflow:auto visible}.ag-theme-alpine .ag-layout-auto-height .ag-center-cols-viewport{min-height:var(--exo-component-table-body-min-height)}.ag-theme-alpine.ag-theme-alpine--overflow-visible .ag-header-cell-resize,.ag-theme-alpine.ag-theme-alpine--overflow-visible .ag-header-cell-resize:after{z-index:auto}.ag-theme-alpine:focus{position:relative;outline:none;border-radius:0}.ag-theme-alpine .ag-root-wrapper{border-radius:var(--exo-radius-none)}.ag-theme-alpine .ag-header-select-all{margin-right:var(--exo-spacing-small)}.ag-theme-alpine .ag-header{border-bottom:var(--exo-spacing-4x-small) solid var(--exo-color-background-action);font:var(--exo-text-label-standard-semi-bold)}.ag-theme-alpine .ag-header-row{font:var(--exo-text-label-standard-semi-bold)}.ag-theme-alpine .ag-header-cell:focus:after{border:none}.ag-theme-alpine .ag-select-list.ag-popup-child{margin-top:var(--exo-spacing-3x-small);border-radius:var(--exo-spacing-2x-small);z-index:999}.ag-theme-alpine .ag-row{font-size:var(--exo-font-size-small);border-bottom:0px}.ag-theme-alpine.ag-theme-alpine--overflow-visible .ag-row-hover{z-index:1}.ag-theme-alpine .ag-row-selected:before{content:"";height:var(--exo-component-table-select-height);border-radius:2px;background:var(--exo-color-background-selected);width:2px;display:var(--exo-component-table-selected-indicator-display);position:absolute;top:8px}.ag-theme-alpine .ag-row-selected{background:var(--exo-color-background-selected-weak)}.ag-theme-alpine .ag-row-selected:before+.ag-row-selected:before{border-top:0}.ag-theme-alpine .ag-input-field{height:32px}.ag-theme-alpine .ag-select{height:calc(var(--exo-size-1) * .4)}.ag-theme-alpine .ag-select .ag-wrapper{height:100%;padding:var(--exo-spacing-x-small);color:var(--exo-color-font);border:var(--exo-spacing-4x-small) solid var(--exo-color-border);border-radius:var(--exo-spacing-2x-small);gap:var(--exo-spacing-x-small)}.ag-theme-alpine .ag-select .ag-wrapper:focus,.ag-theme-alpine .ag-select .ag-wrapper[aria-expanded=true]{outline:var(--exo-spacing-4x-small) solid var(--exo-color-border-tertiary);border:var(--exo-spacing-4x-small) solid var(--exo-color-border-tertiary);box-shadow:none}.ag-theme-alpine .ag-input-field .ag-text-field-input-wrapper,input[class^=ag-][type=number]{height:32px}.ag-theme-alpine .ag-input-field .ag-text-field-input{height:100%;color:var(--exo-color-font);border:var(--exo-spacing-4x-small) solid var(--exo-color-border);border-radius:var(--exo-radius-large)}.ag-theme-alpine input[class^=ag-][type=number]:focus,.ag-theme-alpine .ag-input-field .ag-text-field-input:focus,.ag-theme-alpine .editable-cell .ag-input-field .ag-text-field-input:focus{border-color:transparent;outline:2px solid var(--exo-color-background-selected);box-shadow:none}.ag-theme-alpine .ag-input-field .ag-text-field-input::placeholder{font-family:var(--exo-font-family)}.ag-theme-alpine .ag-select-list{margin-top:var(--exo-spacing-x-small);background-color:var(--exo-color-background);border:var(--exo-spacing-4x-small) solid var(--exo-color-border);border-radius:var(--exo-radius-large)}.ag-theme-alpine .ag-select-list-item{padding:var(--exo-spacing-large) var(--exo-spacing-standard);color:var(--exo-color-font)}.ag-theme-alpine .ag-filter-apply-panel .ag-standard-button{font-family:var(--exo-font-family);color:var(--exo-color-font-inverse);background-color:var(--exo-color-background-action-inverse);border:var(--exo-spacing-4x-small) solid var(--exo-color-background-action-inverse);font-weight:var(--exo-font-weight-semi-bold);font-size:var(--exo-font-size-small);line-height:var(--exo-line-height-body);border-radius:var(--exo-spacing-2x-small);cursor:pointer;transition:background-color var(--exo-time-standard) ease;padding:var(--exo-spacing-3x-small) var(--exo-spacing-standard);display:flex;justify-content:center;align-items:center;user-select:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;box-sizing:border-box;position:relative}.ag-theme-alpine .ag-filter-apply-panel .ag-standard-button:focus{background-color:var(--exo-color-background-action-inverse-hover);outline-offset:calc(-1 * var(--exo-spacing-2x-small));transition:border-color var(--exo-time-standard) ease,background-color var(--exo-time-standard) ease;box-shadow:none}.ag-theme-alpine .ag-filter-apply-panel .ag-standard-button:first-child{background-color:var(--exo-color-background-action-secondary);border-color:var(--exo-color-background-action-secondary);color:var(--exo-color-background-action);height:32px;width:62px}.ag-theme-alpine .ag-filter-apply-panel .ag-standard-button:hover:first-child{background-color:var(--exo-color-background-action-hover-weak);border:var(--exo-spacing-4x-small) solid var(--exo-color-border);color:var(--exo-color-background-action-hover)}.ag-theme-alpine .ag-filter-apply-panel .ag-standard-button:focus:first-child{background-color:var(--exo-color-background-action-secondary);border:var(--exo-spacing-4x-small) solid var(--exo-color-border);box-shadow:none}.ag-theme-alpine .ag-filter-apply-panel .ag-standard-button:focus-visible:first-child{background-color:var(--exo-color-background-action-hover-weak);color:var(--exo-color-background-action-hover);border:var(--exo-spacing-3x-small) solid var(--exo-color-background-action-hover)}.ag-theme-alpine .ag-filter-apply-panel .ag-standard-button:last-child{background-color:var(--exo-color-background-action-secondary);color:var(--exo-color-background-selected);border:var(--exo-spacing-4x-small) solid var(--exo-color-background-selected);height:32px;width:62px}.ag-theme-alpine .ag-filter-apply-panel .ag-standard-button:hover:last-child{border:var(--exo-spacing-4x-small) solid var(--exo-color-background-selected-hover);color:var(--exo-color-background-selected-hover);background-color:var(--exo-color-background-action-secondary-hover)}.ag-theme-alpine .ag-filter-apply-panel .ag-standard-button:focus:last-child{background-color:var(--exo-color-background-action-secondary);border:var(--exo-spacing-4x-small) solid var(--exo-color-background-selected-hover)}.ag-theme-alpine .ag-filter-apply-panel .ag-standard-button:focus-visible:last-child{background-color:var(--exo-color-background-action-secondary-hover);color:var(--exo-color-background-selected-hover);border:var(--exo-spacing-3x-small) solid var(--exo-color-background-selected);box-shadow:none}.ag-theme-alpine .ag-overlay-loading-wrapper{border-radius:var(--exo-radius-large)}.ag-theme-alpine .ag-checkbox-input-wrapper:focus-within,.ag-theme-alpine .ag-checkbox-input-wrapper:active{box-shadow:var(--exo-spacing-none) var(--exo-spacing-none) var(--exo-spacing-none) calc(var(--exo-spacing-3x-small) + var(--exo-spacing-2x-small)) var(--exo-color-background-action-secondary-hover);border-radius:1px}.ag-theme-alpine+.ag-dnd-ghost.ag-theme-alpine{max-width:20%}.ag-theme-alpine.ag-popup .ag-tooltip{color:var(--exo-color-font-inverse)}.action-cell{border-color:transparent!important;box-shadow:none;background-color:transparent!important;border:transparent!important;border-radius:var(--exo-radius-large)}.ag-ltr .ag-cell-focus{border:1px solid transparent!important;outline:1px!important}.ag-ltr .ag-cell-focus:not(.ag-row-selected,.ag-cell-inline-editing):focus-visible{border-radius:var(--exo-spacing-2x-small);border:var(--exo-spacing-3x-small) solid var(--exo-color-background-selected)!important;background:var(--exo-color-background-secondary)}.editable-cell.ag-cell-inline-editing{border-color:transparent!important;box-shadow:none;background-color:transparent!important}.ag-theme-alpine .editable-cell .ag-select{padding-bottom:var(--exo-spacing-small)!important;padding-top:var(--exo-spacing-standard)!important;padding-right:var(--exo-spacing-standard)!important;min-height:calc(var(--ag-grid-size) * 4)}.ag-theme-alpine .editable-cell .ag-select .ag-wrapper{min-height:calc(var(--ag-grid-size) * 4);height:100%;padding:var(--exo-spacing-standard)!important;color:var(--exo-color-font);box-shadow:none;border:var(--exo-spacing-4x-small) solid var(--exo-color-border)}.ag-theme-alpine .editable-cell .ag-select .ag-wrapper:hover{border:var(--exo-spacing-4x-small) solid var(--exo-color-background-action-hover)}.ag-theme-alpine .editable-cell .ag-input-field{padding-top:var(--exo-spacing-x-small)!important;padding-right:var(--exo-spacing-standard)!important;min-height:calc(var(--ag-grid-size) * 4)}.ag-theme-alpine .editable-cell .ag-select .ag-wrapper:focus,.ag-theme-alpine .editable-cell .ag-select .ag-wrapper[aria-expanded=true]{outline:2px solid var(--exo-color-background-selected);border:none}.ag-theme-alpine .editable-cell .ag-input-field .ag-text-field-input-wrapper,.ag-cell-inline-editing{padding-left:9px;padding-right:var(--exo-spacing-standard)!important}.ag-theme-alpine .editable-cell .ag-input-field .ag-text-field-input:hover,.ag-theme-alpine input[class^=ag-][type=number]:hover{border:var(--exo-spacing-4x-small) solid var(--exo-color-background-action-hover);outline:none}.ag-root-wrapper-body{margin-bottom:var(--exo-component-table-body-margin-bottom)}.ag-ltr .ag-cell{border-radius:4px;padding-top:var(--exo-component-table-cell-padding-top)}.error-cell,.error-cell.ag-cell-focus,.error-cell.ag-cell-focus ::selection{background-color:var(--exo-color-background-danger-weak)!important}.error-cell.ag-cell-focus:focus-within .ag-text-field-input:hover{border:none!important}.error-cell.ag-cell-focus:not(.ag-cell-range-selected,.ag-cell-inline-editing):focus-within{border:2px solid var(--exo-color-background-danger-strong)!important}.error-cell.ag-cell-focus:focus-within .ag-text-field-input{outline:2px solid var(--exo-color-background-danger-strong)!important;border:none}.row-default-alt{background:var(--exo-component-table-row-default-alt-background)}.ag-header-cell:focus-visible{border:var(--exo-spacing-3x-small) solid var(--exo-color-background-action-hover);border-radius:var(--exo-spacing-2x-small)}.ag-header-cell-sortable .ag-header-cell-label{position:relative;left:var(--exo-component-table-header-left)}.ag-header-icon{z-index:1}.ag-theme-alpine .ag-menu{background-color:var(--exo-color-background);border:var(--exo-spacing-4x-small) solid var(--exo-color-border);box-shadow:0 12px 32px #0000001a;border-radius:var(--exo-spacing-x-small)}.ag-checkbox-input-wrapper input{cursor:pointer}.ag-header-icon.ag-header-cell-filter-button{display:none}.ag-header-cell:hover .ag-header-icon.ag-header-cell-filter-button,.ag-header-cell:focus-visible .ag-header-icon.ag-header-cell-filter-button,.ag-header-cell.ag-column-menu-visible .ag-header-icon.ag-header-cell-filter-button{display:block}.ag-paging-row-summary-panel{padding-left:8px;display:flex;gap:4px;height:32px;align-items:center}.ag-paging-page-summary-panel{padding-left:8px;display:flex;height:32px;align-items:center}@media only screen and (max-width: 540px){.ag-paging-button,.ag-paging-description{display:flex;margin:0}.ag-paging-panel>*{margin:0}.ag-paging-panel{display:flex;justify-content:space-evenly}}.dom-layout--normal .ag-root-wrapper-body.ag-layout-normal{height:100%;min-height:var(--exo-component-table-body-min-height)}.ag-pinned-left-cols-container,.ag-pinned-left-header,.ag-pinned-left-header:hover{border-right:1px solid var(--exo-color-background-selected)}.ag-header-cell-resize:after{border-radius:4px;height:40%;background:var(--exo-color-border)}.dom-layout--normal.sticky--header .ag-root.ag-layout-normal,.sticky--header.ag-theme-alpine .ag-layout-auto-height .ag-center-cols-viewport{max-height:var(--exo-component-table-body-height)!important}.dom-layout--normal.sticky--header .ag-root.ag-layout-normal{height:auto}.sticky--header.ag-theme-alpine.ag-theme-alpine--overflow-visible .ag-layout-auto-height,.sticky--header.ag-theme-alpine.ag-theme-alpine--overflow-visible .ag-layout-normal,.sticky--header .ag-body .ag-body-viewport{overflow:visible auto}.sticky--header .ag-root-wrapper-body,.ag-body .ag-body-viewport{max-height:var(--exo-component-table-body-height)}.sticky--header .ag-sticky-bottom{display:none}.sticky--header.ag-theme-alpine:not(.ag-theme-alpine--overflow-visible) .ag-center-cols-viewport{max-height:none!important}.sticky--header.ag-theme-alpine .ag-layout-auto-height .ag-center-cols-container{height:100%!important}.sticky--header .ag-body-viewport.ag-layout-auto-height.ag-row-animation,.sticky--header .ag-body-viewport.ag-layout-normal.ag-row-animation{overflow:auto}.ag-theme-alpine.ag-theme-alpine--overflow-visible .ag-center-cols-viewport{overflow:visible}.ag-layout-print.ag-body{height:var(--exo-component-table-body-height)}:host .ag-theme-alpine--hide-sort-order .ag-sort-order{display:none}
`), bc], ke([Yr()], ae.prototype, "isTableGrid", 2), ke([qr("#table-grid")], ae.prototype, "tableEle", 2), ke([Je({ type: Object })], ae.prototype, "gridOptions", 2), ke([Je({ attribute: "editable-content", type: Boolean })], ae.prototype, "editableContent", 2), ke([Je({ attribute: "overflow-visible", type: Boolean })], ae.prototype, "overflowVisible", 2), ke([Je({ attribute: "hide-sort-order", type: Boolean })], ae.prototype, "hideSortOrder", 2), ke([Je({ attribute: "sticky-header", type: Boolean })], ae.prototype, "stickyHeader", 2), ke([Je({ attribute: "dom-layout-normal", type: Boolean })], ae.prototype, "domLayoutNormal", 2);
const Rc = (e = "") => {
  Kr("ex-table", ae, e), Jr(e);
}, Ac = Qr({ tagName: "ex-table", elementClass: ae, react: Wr, events: {}, displayName: "ExTable", registerWebComponent: Rc });
export {
  Ac as ExTable,
  Rc as register
};
